const AbstractPageModule = validate10;
function validate10(data, {
  instancePath = "",
  parentData,
  parentDataProperty,
  rootData = data
} = {}) {
  let vErrors = null;
  let errors = 0;
  {
    if (data && typeof data == "object" && !Array.isArray(data)) {
      let missing0;
      if (data.moduleType === void 0 && (missing0 = "moduleType")) {
        validate10.errors = [{
          instancePath,
          schemaPath: "#/required",
          keyword: "required",
          params: {
            missingProperty: missing0
          },
          message: "must have required property '" + missing0 + "'"
        }];
        return false;
      } else {
        if (data.moduleType !== void 0) {
          const _errs1 = errors;
          if (typeof data.moduleType !== "string") {
            validate10.errors = [{
              instancePath: instancePath + "/moduleType",
              schemaPath: "#/properties/moduleType/type",
              keyword: "type",
              params: {
                type: "string"
              },
              message: "must be string"
            }];
            return false;
          }
          var valid0 = _errs1 === errors;
        } else {
          var valid0 = true;
        }
        if (valid0) {
          if (data.heading !== void 0) {
            const _errs3 = errors;
            if (typeof data.heading !== "string") {
              validate10.errors = [{
                instancePath: instancePath + "/heading",
                schemaPath: "#/properties/heading/type",
                keyword: "type",
                params: {
                  type: "string"
                },
                message: "must be string"
              }];
              return false;
            }
            var valid0 = _errs3 === errors;
          } else {
            var valid0 = true;
          }
          if (valid0) {
            if (data.subHeading !== void 0) {
              const _errs5 = errors;
              if (typeof data.subHeading !== "string") {
                validate10.errors = [{
                  instancePath: instancePath + "/subHeading",
                  schemaPath: "#/properties/subHeading/type",
                  keyword: "type",
                  params: {
                    type: "string"
                  },
                  message: "must be string"
                }];
                return false;
              }
              var valid0 = _errs5 === errors;
            } else {
              var valid0 = true;
            }
          }
        }
      }
    } else {
      validate10.errors = [{
        instancePath,
        schemaPath: "#/type",
        keyword: "type",
        params: {
          type: "object"
        },
        message: "must be object"
      }];
      return false;
    }
  }
  validate10.errors = vErrors;
  return errors === 0;
}
const AbstractListModule = validate11;
const schema12 = {
  "$id": "AbstractListModule",
  "$schema": "http://json-schema.org/draft-07/schema#",
  "type": "object",
  "properties": {
    "moduleType": {
      "type": "string"
    },
    "heading": {
      "type": "string"
    },
    "subHeading": {
      "type": "string"
    },
    "layoutType": {
      "type": "string",
      "enum": ["CAROUSEL", "GRID"]
    },
    "density": {
      "type": "string",
      "enum": ["NORMAL", "DENSE", "DENSEST"]
    },
    "preferedGridSize": {
      "type": "object",
      "properties": {
        "columns": {
          "type": "number"
        },
        "rows": {
          "type": "number"
        }
      },
      "required": ["columns", "rows"]
    }
  },
  "required": ["density", "layoutType", "moduleType"],
  "description": "Most of what is shown in the app is a list of objects, so this abstract class captures that concept."
};
function validate11(data, {
  instancePath = "",
  parentData,
  parentDataProperty,
  rootData = data
} = {}) {
  let vErrors = null;
  let errors = 0;
  {
    if (data && typeof data == "object" && !Array.isArray(data)) {
      let missing0;
      if (data.density === void 0 && (missing0 = "density") || data.layoutType === void 0 && (missing0 = "layoutType") || data.moduleType === void 0 && (missing0 = "moduleType")) {
        validate11.errors = [{
          instancePath,
          schemaPath: "#/required",
          keyword: "required",
          params: {
            missingProperty: missing0
          },
          message: "must have required property '" + missing0 + "'"
        }];
        return false;
      } else {
        if (data.moduleType !== void 0) {
          const _errs1 = errors;
          if (typeof data.moduleType !== "string") {
            validate11.errors = [{
              instancePath: instancePath + "/moduleType",
              schemaPath: "#/properties/moduleType/type",
              keyword: "type",
              params: {
                type: "string"
              },
              message: "must be string"
            }];
            return false;
          }
          var valid0 = _errs1 === errors;
        } else {
          var valid0 = true;
        }
        if (valid0) {
          if (data.heading !== void 0) {
            const _errs3 = errors;
            if (typeof data.heading !== "string") {
              validate11.errors = [{
                instancePath: instancePath + "/heading",
                schemaPath: "#/properties/heading/type",
                keyword: "type",
                params: {
                  type: "string"
                },
                message: "must be string"
              }];
              return false;
            }
            var valid0 = _errs3 === errors;
          } else {
            var valid0 = true;
          }
          if (valid0) {
            if (data.subHeading !== void 0) {
              const _errs5 = errors;
              if (typeof data.subHeading !== "string") {
                validate11.errors = [{
                  instancePath: instancePath + "/subHeading",
                  schemaPath: "#/properties/subHeading/type",
                  keyword: "type",
                  params: {
                    type: "string"
                  },
                  message: "must be string"
                }];
                return false;
              }
              var valid0 = _errs5 === errors;
            } else {
              var valid0 = true;
            }
            if (valid0) {
              if (data.layoutType !== void 0) {
                let data3 = data.layoutType;
                const _errs7 = errors;
                if (typeof data3 !== "string") {
                  validate11.errors = [{
                    instancePath: instancePath + "/layoutType",
                    schemaPath: "#/properties/layoutType/type",
                    keyword: "type",
                    params: {
                      type: "string"
                    },
                    message: "must be string"
                  }];
                  return false;
                }
                if (!(data3 === "CAROUSEL" || data3 === "GRID")) {
                  validate11.errors = [{
                    instancePath: instancePath + "/layoutType",
                    schemaPath: "#/properties/layoutType/enum",
                    keyword: "enum",
                    params: {
                      allowedValues: schema12.properties.layoutType.enum
                    },
                    message: "must be equal to one of the allowed values"
                  }];
                  return false;
                }
                var valid0 = _errs7 === errors;
              } else {
                var valid0 = true;
              }
              if (valid0) {
                if (data.density !== void 0) {
                  let data4 = data.density;
                  const _errs9 = errors;
                  if (typeof data4 !== "string") {
                    validate11.errors = [{
                      instancePath: instancePath + "/density",
                      schemaPath: "#/properties/density/type",
                      keyword: "type",
                      params: {
                        type: "string"
                      },
                      message: "must be string"
                    }];
                    return false;
                  }
                  if (!(data4 === "NORMAL" || data4 === "DENSE" || data4 === "DENSEST")) {
                    validate11.errors = [{
                      instancePath: instancePath + "/density",
                      schemaPath: "#/properties/density/enum",
                      keyword: "enum",
                      params: {
                        allowedValues: schema12.properties.density.enum
                      },
                      message: "must be equal to one of the allowed values"
                    }];
                    return false;
                  }
                  var valid0 = _errs9 === errors;
                } else {
                  var valid0 = true;
                }
                if (valid0) {
                  if (data.preferedGridSize !== void 0) {
                    let data5 = data.preferedGridSize;
                    const _errs11 = errors;
                    {
                      if (data5 && typeof data5 == "object" && !Array.isArray(data5)) {
                        let missing1;
                        if (data5.columns === void 0 && (missing1 = "columns") || data5.rows === void 0 && (missing1 = "rows")) {
                          validate11.errors = [{
                            instancePath: instancePath + "/preferedGridSize",
                            schemaPath: "#/properties/preferedGridSize/required",
                            keyword: "required",
                            params: {
                              missingProperty: missing1
                            },
                            message: "must have required property '" + missing1 + "'"
                          }];
                          return false;
                        } else {
                          if (data5.columns !== void 0) {
                            let data6 = data5.columns;
                            const _errs13 = errors;
                            if (!(typeof data6 == "number" && isFinite(data6))) {
                              validate11.errors = [{
                                instancePath: instancePath + "/preferedGridSize/columns",
                                schemaPath: "#/properties/preferedGridSize/properties/columns/type",
                                keyword: "type",
                                params: {
                                  type: "number"
                                },
                                message: "must be number"
                              }];
                              return false;
                            }
                            var valid1 = _errs13 === errors;
                          } else {
                            var valid1 = true;
                          }
                          if (valid1) {
                            if (data5.rows !== void 0) {
                              let data7 = data5.rows;
                              const _errs15 = errors;
                              if (!(typeof data7 == "number" && isFinite(data7))) {
                                validate11.errors = [{
                                  instancePath: instancePath + "/preferedGridSize/rows",
                                  schemaPath: "#/properties/preferedGridSize/properties/rows/type",
                                  keyword: "type",
                                  params: {
                                    type: "number"
                                  },
                                  message: "must be number"
                                }];
                                return false;
                              }
                              var valid1 = _errs15 === errors;
                            } else {
                              var valid1 = true;
                            }
                          }
                        }
                      } else {
                        validate11.errors = [{
                          instancePath: instancePath + "/preferedGridSize",
                          schemaPath: "#/properties/preferedGridSize/type",
                          keyword: "type",
                          params: {
                            type: "object"
                          },
                          message: "must be object"
                        }];
                        return false;
                      }
                    }
                    var valid0 = _errs11 === errors;
                  } else {
                    var valid0 = true;
                  }
                }
              }
            }
          }
        }
      }
    } else {
      validate11.errors = [{
        instancePath,
        schemaPath: "#/type",
        keyword: "type",
        params: {
          type: "object"
        },
        message: "must be object"
      }];
      return false;
    }
  }
  validate11.errors = vErrors;
  return errors === 0;
}
const InviteErrors = validate12;
const schema13 = {
  "$id": "InviteErrors",
  "$schema": "http://json-schema.org/draft-07/schema#",
  "type": "string",
  "enum": ["joymo-invites/invite-expired", "joymo-invites/invite-not-found", "joymo-invites/unauthorized", "joymo-invites/invalid-invite"]
};
function validate12(data, {
  instancePath = "",
  parentData,
  parentDataProperty,
  rootData = data
} = {}) {
  let vErrors = null;
  let errors = 0;
  if (typeof data !== "string") {
    validate12.errors = [{
      instancePath,
      schemaPath: "#/type",
      keyword: "type",
      params: {
        type: "string"
      },
      message: "must be string"
    }];
    return false;
  }
  if (!(data === "joymo-invites/invite-expired" || data === "joymo-invites/invite-not-found" || data === "joymo-invites/unauthorized" || data === "joymo-invites/invalid-invite")) {
    validate12.errors = [{
      instancePath,
      schemaPath: "#/enum",
      keyword: "enum",
      params: {
        allowedValues: schema13.enum
      },
      message: "must be equal to one of the allowed values"
    }];
    return false;
  }
  validate12.errors = vErrors;
  return errors === 0;
}
const AcceptUserInviteRequest = validate13;
function validate13(data, {
  instancePath = "",
  parentData,
  parentDataProperty,
  rootData = data
} = {}) {
  let vErrors = null;
  let errors = 0;
  {
    if (data && typeof data == "object" && !Array.isArray(data)) {
      let missing0;
      if (data.inviteId === void 0 && (missing0 = "inviteId") || data.token === void 0 && (missing0 = "token")) {
        validate13.errors = [{
          instancePath,
          schemaPath: "#/required",
          keyword: "required",
          params: {
            missingProperty: missing0
          },
          message: "must have required property '" + missing0 + "'"
        }];
        return false;
      } else {
        if (data.inviteId !== void 0) {
          const _errs1 = errors;
          if (typeof data.inviteId !== "string") {
            validate13.errors = [{
              instancePath: instancePath + "/inviteId",
              schemaPath: "#/properties/inviteId/type",
              keyword: "type",
              params: {
                type: "string"
              },
              message: "must be string"
            }];
            return false;
          }
          var valid0 = _errs1 === errors;
        } else {
          var valid0 = true;
        }
        if (valid0) {
          if (data.token !== void 0) {
            const _errs3 = errors;
            if (typeof data.token !== "string") {
              validate13.errors = [{
                instancePath: instancePath + "/token",
                schemaPath: "#/properties/token/type",
                keyword: "type",
                params: {
                  type: "string"
                },
                message: "must be string"
              }];
              return false;
            }
            var valid0 = _errs3 === errors;
          } else {
            var valid0 = true;
          }
          if (valid0) {
            if (data.paymentMethodId !== void 0) {
              const _errs5 = errors;
              if (typeof data.paymentMethodId !== "string") {
                validate13.errors = [{
                  instancePath: instancePath + "/paymentMethodId",
                  schemaPath: "#/properties/paymentMethodId/type",
                  keyword: "type",
                  params: {
                    type: "string"
                  },
                  message: "must be string"
                }];
                return false;
              }
              var valid0 = _errs5 === errors;
            } else {
              var valid0 = true;
            }
          }
        }
      }
    } else {
      validate13.errors = [{
        instancePath,
        schemaPath: "#/type",
        keyword: "type",
        params: {
          type: "object"
        },
        message: "must be object"
      }];
      return false;
    }
  }
  validate13.errors = vErrors;
  return errors === 0;
}
const AcceptUserInviteResponse = validate14;
function validate14(data, {
  instancePath = "",
  parentData,
  parentDataProperty,
  rootData = data
} = {}) {
  let vErrors = null;
  let errors = 0;
  const _errs0 = errors;
  let valid0 = false;
  const _errs1 = errors;
  if (errors === _errs1) {
    if (data && typeof data == "object" && !Array.isArray(data)) {
      let missing0;
      if (data.success === void 0 && (missing0 = "success")) {
        const err0 = {
          instancePath,
          schemaPath: "#/anyOf/0/required",
          keyword: "required",
          params: {
            missingProperty: missing0
          },
          message: "must have required property '" + missing0 + "'"
        };
        if (vErrors === null) {
          vErrors = [err0];
        } else {
          vErrors.push(err0);
        }
        errors++;
      } else {
        if (data.success !== void 0) {
          let data0 = data.success;
          const _errs3 = errors;
          if (typeof data0 !== "boolean") {
            const err1 = {
              instancePath: instancePath + "/success",
              schemaPath: "#/anyOf/0/properties/success/type",
              keyword: "type",
              params: {
                type: "boolean"
              },
              message: "must be boolean"
            };
            if (vErrors === null) {
              vErrors = [err1];
            } else {
              vErrors.push(err1);
            }
            errors++;
          }
          if (true !== data0) {
            const err2 = {
              instancePath: instancePath + "/success",
              schemaPath: "#/anyOf/0/properties/success/const",
              keyword: "const",
              params: {
                allowedValue: true
              },
              message: "must be equal to constant"
            };
            if (vErrors === null) {
              vErrors = [err2];
            } else {
              vErrors.push(err2);
            }
            errors++;
          }
          var valid1 = _errs3 === errors;
        } else {
          var valid1 = true;
        }
        if (valid1) {
          if (data.message !== void 0) {
            const _errs5 = errors;
            if (typeof data.message !== "string") {
              const err3 = {
                instancePath: instancePath + "/message",
                schemaPath: "#/anyOf/0/properties/message/type",
                keyword: "type",
                params: {
                  type: "string"
                },
                message: "must be string"
              };
              if (vErrors === null) {
                vErrors = [err3];
              } else {
                vErrors.push(err3);
              }
              errors++;
            }
            var valid1 = _errs5 === errors;
          } else {
            var valid1 = true;
          }
          if (valid1) {
            if (data.subscriptionId !== void 0) {
              const _errs7 = errors;
              if (typeof data.subscriptionId !== "string") {
                const err4 = {
                  instancePath: instancePath + "/subscriptionId",
                  schemaPath: "#/anyOf/0/properties/subscriptionId/type",
                  keyword: "type",
                  params: {
                    type: "string"
                  },
                  message: "must be string"
                };
                if (vErrors === null) {
                  vErrors = [err4];
                } else {
                  vErrors.push(err4);
                }
                errors++;
              }
              var valid1 = _errs7 === errors;
            } else {
              var valid1 = true;
            }
          }
        }
      }
    } else {
      const err5 = {
        instancePath,
        schemaPath: "#/anyOf/0/type",
        keyword: "type",
        params: {
          type: "object"
        },
        message: "must be object"
      };
      if (vErrors === null) {
        vErrors = [err5];
      } else {
        vErrors.push(err5);
      }
      errors++;
    }
  }
  var _valid0 = _errs1 === errors;
  valid0 = valid0 || _valid0;
  if (!valid0) {
    const _errs9 = errors;
    if (errors === _errs9) {
      if (data && typeof data == "object" && !Array.isArray(data)) {
        let missing1;
        if (data.success === void 0 && (missing1 = "success") || data.message === void 0 && (missing1 = "message") || data.errorReason === void 0 && (missing1 = "errorReason")) {
          const err6 = {
            instancePath,
            schemaPath: "#/anyOf/1/required",
            keyword: "required",
            params: {
              missingProperty: missing1
            },
            message: "must have required property '" + missing1 + "'"
          };
          if (vErrors === null) {
            vErrors = [err6];
          } else {
            vErrors.push(err6);
          }
          errors++;
        } else {
          if (data.success !== void 0) {
            let data3 = data.success;
            const _errs11 = errors;
            if (typeof data3 !== "boolean") {
              const err7 = {
                instancePath: instancePath + "/success",
                schemaPath: "#/anyOf/1/properties/success/type",
                keyword: "type",
                params: {
                  type: "boolean"
                },
                message: "must be boolean"
              };
              if (vErrors === null) {
                vErrors = [err7];
              } else {
                vErrors.push(err7);
              }
              errors++;
            }
            if (false !== data3) {
              const err8 = {
                instancePath: instancePath + "/success",
                schemaPath: "#/anyOf/1/properties/success/const",
                keyword: "const",
                params: {
                  allowedValue: false
                },
                message: "must be equal to constant"
              };
              if (vErrors === null) {
                vErrors = [err8];
              } else {
                vErrors.push(err8);
              }
              errors++;
            }
            var valid2 = _errs11 === errors;
          } else {
            var valid2 = true;
          }
          if (valid2) {
            if (data.message !== void 0) {
              const _errs13 = errors;
              if (typeof data.message !== "string") {
                const err9 = {
                  instancePath: instancePath + "/message",
                  schemaPath: "#/anyOf/1/properties/message/type",
                  keyword: "type",
                  params: {
                    type: "string"
                  },
                  message: "must be string"
                };
                if (vErrors === null) {
                  vErrors = [err9];
                } else {
                  vErrors.push(err9);
                }
                errors++;
              }
              var valid2 = _errs13 === errors;
            } else {
              var valid2 = true;
            }
            if (valid2) {
              if (data.errorReason !== void 0) {
                let data5 = data.errorReason;
                const _errs15 = errors;
                if (typeof data5 !== "string") {
                  const err10 = {
                    instancePath: instancePath + "/errorReason",
                    schemaPath: "InviteErrors/type",
                    keyword: "type",
                    params: {
                      type: "string"
                    },
                    message: "must be string"
                  };
                  if (vErrors === null) {
                    vErrors = [err10];
                  } else {
                    vErrors.push(err10);
                  }
                  errors++;
                }
                if (!(data5 === "joymo-invites/invite-expired" || data5 === "joymo-invites/invite-not-found" || data5 === "joymo-invites/unauthorized" || data5 === "joymo-invites/invalid-invite")) {
                  const err11 = {
                    instancePath: instancePath + "/errorReason",
                    schemaPath: "InviteErrors/enum",
                    keyword: "enum",
                    params: {
                      allowedValues: schema13.enum
                    },
                    message: "must be equal to one of the allowed values"
                  };
                  if (vErrors === null) {
                    vErrors = [err11];
                  } else {
                    vErrors.push(err11);
                  }
                  errors++;
                }
                var valid2 = _errs15 === errors;
              } else {
                var valid2 = true;
              }
            }
          }
        }
      } else {
        const err12 = {
          instancePath,
          schemaPath: "#/anyOf/1/type",
          keyword: "type",
          params: {
            type: "object"
          },
          message: "must be object"
        };
        if (vErrors === null) {
          vErrors = [err12];
        } else {
          vErrors.push(err12);
        }
        errors++;
      }
    }
    var _valid0 = _errs9 === errors;
    valid0 = valid0 || _valid0;
  }
  if (!valid0) {
    const err13 = {
      instancePath,
      schemaPath: "#/anyOf",
      keyword: "anyOf",
      params: {},
      message: "must match a schema in anyOf"
    };
    if (vErrors === null) {
      vErrors = [err13];
    } else {
      vErrors.push(err13);
    }
    errors++;
    validate14.errors = vErrors;
    return false;
  } else {
    errors = _errs0;
    if (vErrors !== null) {
      if (_errs0) {
        vErrors.length = _errs0;
      } else {
        vErrors = null;
      }
    }
  }
  validate14.errors = vErrors;
  return errors === 0;
}
const StaticSlideSource = validate15;
function validate15(data, {
  instancePath = "",
  parentData,
  parentDataProperty,
  rootData = data
} = {}) {
  let vErrors = null;
  let errors = 0;
  {
    if (data && typeof data == "object" && !Array.isArray(data)) {
      let missing0;
      if (data.type === void 0 && (missing0 = "type") || data.slides === void 0 && (missing0 = "slides")) {
        validate15.errors = [{
          instancePath,
          schemaPath: "#/required",
          keyword: "required",
          params: {
            missingProperty: missing0
          },
          message: "must have required property '" + missing0 + "'"
        }];
        return false;
      } else {
        if (data.type !== void 0) {
          let data0 = data.type;
          const _errs1 = errors;
          if (typeof data0 !== "string") {
            validate15.errors = [{
              instancePath: instancePath + "/type",
              schemaPath: "#/properties/type/type",
              keyword: "type",
              params: {
                type: "string"
              },
              message: "must be string"
            }];
            return false;
          }
          if ("STATIC" !== data0) {
            validate15.errors = [{
              instancePath: instancePath + "/type",
              schemaPath: "#/properties/type/const",
              keyword: "const",
              params: {
                allowedValue: "STATIC"
              },
              message: "must be equal to constant"
            }];
            return false;
          }
          var valid0 = _errs1 === errors;
        } else {
          var valid0 = true;
        }
        if (valid0) {
          if (data.slides !== void 0) {
            let data1 = data.slides;
            const _errs3 = errors;
            {
              if (Array.isArray(data1)) {
                var valid1 = true;
                const len0 = data1.length;
                for (let i0 = 0; i0 < len0; i0++) {
                  let data2 = data1[i0];
                  const _errs5 = errors;
                  {
                    if (data2 && typeof data2 == "object" && !Array.isArray(data2)) {
                      let missing1;
                      if (data2.internal === void 0 && (missing1 = "internal") || data2.image === void 0 && (missing1 = "image")) {
                        validate15.errors = [{
                          instancePath: instancePath + "/slides/" + i0,
                          schemaPath: "#/properties/slides/items/required",
                          keyword: "required",
                          params: {
                            missingProperty: missing1
                          },
                          message: "must have required property '" + missing1 + "'"
                        }];
                        return false;
                      } else {
                        if (data2.link !== void 0) {
                          const _errs7 = errors;
                          if (typeof data2.link !== "string") {
                            validate15.errors = [{
                              instancePath: instancePath + "/slides/" + i0 + "/link",
                              schemaPath: "#/properties/slides/items/properties/link/type",
                              keyword: "type",
                              params: {
                                type: "string"
                              },
                              message: "must be string"
                            }];
                            return false;
                          }
                          var valid2 = _errs7 === errors;
                        } else {
                          var valid2 = true;
                        }
                        if (valid2) {
                          if (data2.internal !== void 0) {
                            const _errs9 = errors;
                            if (typeof data2.internal !== "boolean") {
                              validate15.errors = [{
                                instancePath: instancePath + "/slides/" + i0 + "/internal",
                                schemaPath: "#/properties/slides/items/properties/internal/type",
                                keyword: "type",
                                params: {
                                  type: "boolean"
                                },
                                message: "must be boolean"
                              }];
                              return false;
                            }
                            var valid2 = _errs9 === errors;
                          } else {
                            var valid2 = true;
                          }
                          if (valid2) {
                            if (data2.heading !== void 0) {
                              const _errs11 = errors;
                              if (typeof data2.heading !== "string") {
                                validate15.errors = [{
                                  instancePath: instancePath + "/slides/" + i0 + "/heading",
                                  schemaPath: "#/properties/slides/items/properties/heading/type",
                                  keyword: "type",
                                  params: {
                                    type: "string"
                                  },
                                  message: "must be string"
                                }];
                                return false;
                              }
                              var valid2 = _errs11 === errors;
                            } else {
                              var valid2 = true;
                            }
                            if (valid2) {
                              if (data2.subHeading !== void 0) {
                                const _errs13 = errors;
                                if (typeof data2.subHeading !== "string") {
                                  validate15.errors = [{
                                    instancePath: instancePath + "/slides/" + i0 + "/subHeading",
                                    schemaPath: "#/properties/slides/items/properties/subHeading/type",
                                    keyword: "type",
                                    params: {
                                      type: "string"
                                    },
                                    message: "must be string"
                                  }];
                                  return false;
                                }
                                var valid2 = _errs13 === errors;
                              } else {
                                var valid2 = true;
                              }
                              if (valid2) {
                                if (data2.image !== void 0) {
                                  let data7 = data2.image;
                                  const _errs15 = errors;
                                  {
                                    if (data7 && typeof data7 == "object" && !Array.isArray(data7)) {
                                      let missing2;
                                      if (data7.largeViewport === void 0 && (missing2 = "largeViewport")) {
                                        validate15.errors = [{
                                          instancePath: instancePath + "/slides/" + i0 + "/image",
                                          schemaPath: "#/properties/slides/items/properties/image/required",
                                          keyword: "required",
                                          params: {
                                            missingProperty: missing2
                                          },
                                          message: "must have required property '" + missing2 + "'"
                                        }];
                                        return false;
                                      } else {
                                        if (data7.largeViewport !== void 0) {
                                          const _errs17 = errors;
                                          if (typeof data7.largeViewport !== "string") {
                                            validate15.errors = [{
                                              instancePath: instancePath + "/slides/" + i0 + "/image/largeViewport",
                                              schemaPath: "#/properties/slides/items/properties/image/properties/largeViewport/type",
                                              keyword: "type",
                                              params: {
                                                type: "string"
                                              },
                                              message: "must be string"
                                            }];
                                            return false;
                                          }
                                          var valid3 = _errs17 === errors;
                                        } else {
                                          var valid3 = true;
                                        }
                                        if (valid3) {
                                          if (data7.smallViewport !== void 0) {
                                            const _errs19 = errors;
                                            if (typeof data7.smallViewport !== "string") {
                                              validate15.errors = [{
                                                instancePath: instancePath + "/slides/" + i0 + "/image/smallViewport",
                                                schemaPath: "#/properties/slides/items/properties/image/properties/smallViewport/type",
                                                keyword: "type",
                                                params: {
                                                  type: "string"
                                                },
                                                message: "must be string"
                                              }];
                                              return false;
                                            }
                                            var valid3 = _errs19 === errors;
                                          } else {
                                            var valid3 = true;
                                          }
                                        }
                                      }
                                    } else {
                                      validate15.errors = [{
                                        instancePath: instancePath + "/slides/" + i0 + "/image",
                                        schemaPath: "#/properties/slides/items/properties/image/type",
                                        keyword: "type",
                                        params: {
                                          type: "object"
                                        },
                                        message: "must be object"
                                      }];
                                      return false;
                                    }
                                  }
                                  var valid2 = _errs15 === errors;
                                } else {
                                  var valid2 = true;
                                }
                              }
                            }
                          }
                        }
                      }
                    } else {
                      validate15.errors = [{
                        instancePath: instancePath + "/slides/" + i0,
                        schemaPath: "#/properties/slides/items/type",
                        keyword: "type",
                        params: {
                          type: "object"
                        },
                        message: "must be object"
                      }];
                      return false;
                    }
                  }
                  var valid1 = _errs5 === errors;
                  if (!valid1) {
                    break;
                  }
                }
              } else {
                validate15.errors = [{
                  instancePath: instancePath + "/slides",
                  schemaPath: "#/properties/slides/type",
                  keyword: "type",
                  params: {
                    type: "array"
                  },
                  message: "must be array"
                }];
                return false;
              }
            }
            var valid0 = _errs3 === errors;
          } else {
            var valid0 = true;
          }
        }
      }
    } else {
      validate15.errors = [{
        instancePath,
        schemaPath: "#/type",
        keyword: "type",
        params: {
          type: "object"
        },
        message: "must be object"
      }];
      return false;
    }
  }
  validate15.errors = vErrors;
  return errors === 0;
}
const AdCarouselModule = validate16;
const schema18 = {
  "$id": "AdCarouselModule",
  "$schema": "http://json-schema.org/draft-07/schema#",
  "type": "object",
  "properties": {
    "moduleType": {
      "type": "string",
      "const": "AD_CAROUSEL"
    },
    "heading": {
      "type": "string"
    },
    "subHeading": {
      "type": "string"
    },
    "hideFilter": {
      "anyOf": [{
        "type": "array",
        "items": {
          "type": "string",
          "enum": ["SUBSCRIBED", "REGISTERED"]
        }
      }, {
        "type": "null"
      }]
    },
    "displayStyle": {
      "type": "string",
      "const": "SLIDES"
    },
    "holdSeconds": {
      "type": "number"
    },
    "navigable": {
      "type": "boolean"
    },
    "slidesSource": {
      "$ref": "StaticSlideSource"
    }
  },
  "required": ["displayStyle", "hideFilter", "holdSeconds", "moduleType", "navigable", "slidesSource"],
  "description": 'Generalization of the simpler AD_SPACE module. Specifies a space that can display multiple "slides" and control the behavior and style of those slides. The end result is to promote and entice the user to click on one of the slides and can be used for "internal" linking or for external (ads, shopping).'
};
function validate16(data, {
  instancePath = "",
  parentData,
  parentDataProperty,
  rootData = data
} = {}) {
  let vErrors = null;
  let errors = 0;
  if (errors === 0) {
    if (data && typeof data == "object" && !Array.isArray(data)) {
      let missing0;
      if (data.displayStyle === void 0 && (missing0 = "displayStyle") || data.hideFilter === void 0 && (missing0 = "hideFilter") || data.holdSeconds === void 0 && (missing0 = "holdSeconds") || data.moduleType === void 0 && (missing0 = "moduleType") || data.navigable === void 0 && (missing0 = "navigable") || data.slidesSource === void 0 && (missing0 = "slidesSource")) {
        validate16.errors = [{
          instancePath,
          schemaPath: "#/required",
          keyword: "required",
          params: {
            missingProperty: missing0
          },
          message: "must have required property '" + missing0 + "'"
        }];
        return false;
      } else {
        if (data.moduleType !== void 0) {
          let data0 = data.moduleType;
          const _errs1 = errors;
          if (typeof data0 !== "string") {
            validate16.errors = [{
              instancePath: instancePath + "/moduleType",
              schemaPath: "#/properties/moduleType/type",
              keyword: "type",
              params: {
                type: "string"
              },
              message: "must be string"
            }];
            return false;
          }
          if ("AD_CAROUSEL" !== data0) {
            validate16.errors = [{
              instancePath: instancePath + "/moduleType",
              schemaPath: "#/properties/moduleType/const",
              keyword: "const",
              params: {
                allowedValue: "AD_CAROUSEL"
              },
              message: "must be equal to constant"
            }];
            return false;
          }
          var valid0 = _errs1 === errors;
        } else {
          var valid0 = true;
        }
        if (valid0) {
          if (data.heading !== void 0) {
            const _errs3 = errors;
            if (typeof data.heading !== "string") {
              validate16.errors = [{
                instancePath: instancePath + "/heading",
                schemaPath: "#/properties/heading/type",
                keyword: "type",
                params: {
                  type: "string"
                },
                message: "must be string"
              }];
              return false;
            }
            var valid0 = _errs3 === errors;
          } else {
            var valid0 = true;
          }
          if (valid0) {
            if (data.subHeading !== void 0) {
              const _errs5 = errors;
              if (typeof data.subHeading !== "string") {
                validate16.errors = [{
                  instancePath: instancePath + "/subHeading",
                  schemaPath: "#/properties/subHeading/type",
                  keyword: "type",
                  params: {
                    type: "string"
                  },
                  message: "must be string"
                }];
                return false;
              }
              var valid0 = _errs5 === errors;
            } else {
              var valid0 = true;
            }
            if (valid0) {
              if (data.hideFilter !== void 0) {
                let data3 = data.hideFilter;
                const _errs7 = errors;
                const _errs8 = errors;
                let valid1 = false;
                const _errs9 = errors;
                if (errors === _errs9) {
                  if (Array.isArray(data3)) {
                    var valid2 = true;
                    const len0 = data3.length;
                    for (let i0 = 0; i0 < len0; i0++) {
                      let data4 = data3[i0];
                      const _errs11 = errors;
                      if (typeof data4 !== "string") {
                        const err0 = {
                          instancePath: instancePath + "/hideFilter/" + i0,
                          schemaPath: "#/properties/hideFilter/anyOf/0/items/type",
                          keyword: "type",
                          params: {
                            type: "string"
                          },
                          message: "must be string"
                        };
                        if (vErrors === null) {
                          vErrors = [err0];
                        } else {
                          vErrors.push(err0);
                        }
                        errors++;
                      }
                      if (!(data4 === "SUBSCRIBED" || data4 === "REGISTERED")) {
                        const err1 = {
                          instancePath: instancePath + "/hideFilter/" + i0,
                          schemaPath: "#/properties/hideFilter/anyOf/0/items/enum",
                          keyword: "enum",
                          params: {
                            allowedValues: schema18.properties.hideFilter.anyOf[0].items.enum
                          },
                          message: "must be equal to one of the allowed values"
                        };
                        if (vErrors === null) {
                          vErrors = [err1];
                        } else {
                          vErrors.push(err1);
                        }
                        errors++;
                      }
                      var valid2 = _errs11 === errors;
                      if (!valid2) {
                        break;
                      }
                    }
                  } else {
                    const err2 = {
                      instancePath: instancePath + "/hideFilter",
                      schemaPath: "#/properties/hideFilter/anyOf/0/type",
                      keyword: "type",
                      params: {
                        type: "array"
                      },
                      message: "must be array"
                    };
                    if (vErrors === null) {
                      vErrors = [err2];
                    } else {
                      vErrors.push(err2);
                    }
                    errors++;
                  }
                }
                var _valid0 = _errs9 === errors;
                valid1 = valid1 || _valid0;
                if (!valid1) {
                  const _errs13 = errors;
                  if (data3 !== null) {
                    const err3 = {
                      instancePath: instancePath + "/hideFilter",
                      schemaPath: "#/properties/hideFilter/anyOf/1/type",
                      keyword: "type",
                      params: {
                        type: "null"
                      },
                      message: "must be null"
                    };
                    if (vErrors === null) {
                      vErrors = [err3];
                    } else {
                      vErrors.push(err3);
                    }
                    errors++;
                  }
                  var _valid0 = _errs13 === errors;
                  valid1 = valid1 || _valid0;
                }
                if (!valid1) {
                  const err4 = {
                    instancePath: instancePath + "/hideFilter",
                    schemaPath: "#/properties/hideFilter/anyOf",
                    keyword: "anyOf",
                    params: {},
                    message: "must match a schema in anyOf"
                  };
                  if (vErrors === null) {
                    vErrors = [err4];
                  } else {
                    vErrors.push(err4);
                  }
                  errors++;
                  validate16.errors = vErrors;
                  return false;
                } else {
                  errors = _errs8;
                  if (vErrors !== null) {
                    if (_errs8) {
                      vErrors.length = _errs8;
                    } else {
                      vErrors = null;
                    }
                  }
                }
                var valid0 = _errs7 === errors;
              } else {
                var valid0 = true;
              }
              if (valid0) {
                if (data.displayStyle !== void 0) {
                  let data5 = data.displayStyle;
                  const _errs15 = errors;
                  if (typeof data5 !== "string") {
                    validate16.errors = [{
                      instancePath: instancePath + "/displayStyle",
                      schemaPath: "#/properties/displayStyle/type",
                      keyword: "type",
                      params: {
                        type: "string"
                      },
                      message: "must be string"
                    }];
                    return false;
                  }
                  if ("SLIDES" !== data5) {
                    validate16.errors = [{
                      instancePath: instancePath + "/displayStyle",
                      schemaPath: "#/properties/displayStyle/const",
                      keyword: "const",
                      params: {
                        allowedValue: "SLIDES"
                      },
                      message: "must be equal to constant"
                    }];
                    return false;
                  }
                  var valid0 = _errs15 === errors;
                } else {
                  var valid0 = true;
                }
                if (valid0) {
                  if (data.holdSeconds !== void 0) {
                    let data6 = data.holdSeconds;
                    const _errs17 = errors;
                    if (!(typeof data6 == "number" && isFinite(data6))) {
                      validate16.errors = [{
                        instancePath: instancePath + "/holdSeconds",
                        schemaPath: "#/properties/holdSeconds/type",
                        keyword: "type",
                        params: {
                          type: "number"
                        },
                        message: "must be number"
                      }];
                      return false;
                    }
                    var valid0 = _errs17 === errors;
                  } else {
                    var valid0 = true;
                  }
                  if (valid0) {
                    if (data.navigable !== void 0) {
                      const _errs19 = errors;
                      if (typeof data.navigable !== "boolean") {
                        validate16.errors = [{
                          instancePath: instancePath + "/navigable",
                          schemaPath: "#/properties/navigable/type",
                          keyword: "type",
                          params: {
                            type: "boolean"
                          },
                          message: "must be boolean"
                        }];
                        return false;
                      }
                      var valid0 = _errs19 === errors;
                    } else {
                      var valid0 = true;
                    }
                    if (valid0) {
                      if (data.slidesSource !== void 0) {
                        let data8 = data.slidesSource;
                        const _errs21 = errors;
                        const _errs22 = errors;
                        if (errors === _errs22) {
                          if (data8 && typeof data8 == "object" && !Array.isArray(data8)) {
                            let missing1;
                            if (data8.type === void 0 && (missing1 = "type") || data8.slides === void 0 && (missing1 = "slides")) {
                              validate16.errors = [{
                                instancePath: instancePath + "/slidesSource",
                                schemaPath: "StaticSlideSource/required",
                                keyword: "required",
                                params: {
                                  missingProperty: missing1
                                },
                                message: "must have required property '" + missing1 + "'"
                              }];
                              return false;
                            } else {
                              if (data8.type !== void 0) {
                                let data9 = data8.type;
                                const _errs24 = errors;
                                if (typeof data9 !== "string") {
                                  validate16.errors = [{
                                    instancePath: instancePath + "/slidesSource/type",
                                    schemaPath: "StaticSlideSource/properties/type/type",
                                    keyword: "type",
                                    params: {
                                      type: "string"
                                    },
                                    message: "must be string"
                                  }];
                                  return false;
                                }
                                if ("STATIC" !== data9) {
                                  validate16.errors = [{
                                    instancePath: instancePath + "/slidesSource/type",
                                    schemaPath: "StaticSlideSource/properties/type/const",
                                    keyword: "const",
                                    params: {
                                      allowedValue: "STATIC"
                                    },
                                    message: "must be equal to constant"
                                  }];
                                  return false;
                                }
                                var valid4 = _errs24 === errors;
                              } else {
                                var valid4 = true;
                              }
                              if (valid4) {
                                if (data8.slides !== void 0) {
                                  let data10 = data8.slides;
                                  const _errs26 = errors;
                                  if (errors === _errs26) {
                                    if (Array.isArray(data10)) {
                                      var valid5 = true;
                                      const len1 = data10.length;
                                      for (let i1 = 0; i1 < len1; i1++) {
                                        let data11 = data10[i1];
                                        const _errs28 = errors;
                                        if (errors === _errs28) {
                                          if (data11 && typeof data11 == "object" && !Array.isArray(data11)) {
                                            let missing2;
                                            if (data11.internal === void 0 && (missing2 = "internal") || data11.image === void 0 && (missing2 = "image")) {
                                              validate16.errors = [{
                                                instancePath: instancePath + "/slidesSource/slides/" + i1,
                                                schemaPath: "StaticSlideSource/properties/slides/items/required",
                                                keyword: "required",
                                                params: {
                                                  missingProperty: missing2
                                                },
                                                message: "must have required property '" + missing2 + "'"
                                              }];
                                              return false;
                                            } else {
                                              if (data11.link !== void 0) {
                                                const _errs30 = errors;
                                                if (typeof data11.link !== "string") {
                                                  validate16.errors = [{
                                                    instancePath: instancePath + "/slidesSource/slides/" + i1 + "/link",
                                                    schemaPath: "StaticSlideSource/properties/slides/items/properties/link/type",
                                                    keyword: "type",
                                                    params: {
                                                      type: "string"
                                                    },
                                                    message: "must be string"
                                                  }];
                                                  return false;
                                                }
                                                var valid6 = _errs30 === errors;
                                              } else {
                                                var valid6 = true;
                                              }
                                              if (valid6) {
                                                if (data11.internal !== void 0) {
                                                  const _errs32 = errors;
                                                  if (typeof data11.internal !== "boolean") {
                                                    validate16.errors = [{
                                                      instancePath: instancePath + "/slidesSource/slides/" + i1 + "/internal",
                                                      schemaPath: "StaticSlideSource/properties/slides/items/properties/internal/type",
                                                      keyword: "type",
                                                      params: {
                                                        type: "boolean"
                                                      },
                                                      message: "must be boolean"
                                                    }];
                                                    return false;
                                                  }
                                                  var valid6 = _errs32 === errors;
                                                } else {
                                                  var valid6 = true;
                                                }
                                                if (valid6) {
                                                  if (data11.heading !== void 0) {
                                                    const _errs34 = errors;
                                                    if (typeof data11.heading !== "string") {
                                                      validate16.errors = [{
                                                        instancePath: instancePath + "/slidesSource/slides/" + i1 + "/heading",
                                                        schemaPath: "StaticSlideSource/properties/slides/items/properties/heading/type",
                                                        keyword: "type",
                                                        params: {
                                                          type: "string"
                                                        },
                                                        message: "must be string"
                                                      }];
                                                      return false;
                                                    }
                                                    var valid6 = _errs34 === errors;
                                                  } else {
                                                    var valid6 = true;
                                                  }
                                                  if (valid6) {
                                                    if (data11.subHeading !== void 0) {
                                                      const _errs36 = errors;
                                                      if (typeof data11.subHeading !== "string") {
                                                        validate16.errors = [{
                                                          instancePath: instancePath + "/slidesSource/slides/" + i1 + "/subHeading",
                                                          schemaPath: "StaticSlideSource/properties/slides/items/properties/subHeading/type",
                                                          keyword: "type",
                                                          params: {
                                                            type: "string"
                                                          },
                                                          message: "must be string"
                                                        }];
                                                        return false;
                                                      }
                                                      var valid6 = _errs36 === errors;
                                                    } else {
                                                      var valid6 = true;
                                                    }
                                                    if (valid6) {
                                                      if (data11.image !== void 0) {
                                                        let data16 = data11.image;
                                                        const _errs38 = errors;
                                                        if (errors === _errs38) {
                                                          if (data16 && typeof data16 == "object" && !Array.isArray(data16)) {
                                                            let missing3;
                                                            if (data16.largeViewport === void 0 && (missing3 = "largeViewport")) {
                                                              validate16.errors = [{
                                                                instancePath: instancePath + "/slidesSource/slides/" + i1 + "/image",
                                                                schemaPath: "StaticSlideSource/properties/slides/items/properties/image/required",
                                                                keyword: "required",
                                                                params: {
                                                                  missingProperty: missing3
                                                                },
                                                                message: "must have required property '" + missing3 + "'"
                                                              }];
                                                              return false;
                                                            } else {
                                                              if (data16.largeViewport !== void 0) {
                                                                const _errs40 = errors;
                                                                if (typeof data16.largeViewport !== "string") {
                                                                  validate16.errors = [{
                                                                    instancePath: instancePath + "/slidesSource/slides/" + i1 + "/image/largeViewport",
                                                                    schemaPath: "StaticSlideSource/properties/slides/items/properties/image/properties/largeViewport/type",
                                                                    keyword: "type",
                                                                    params: {
                                                                      type: "string"
                                                                    },
                                                                    message: "must be string"
                                                                  }];
                                                                  return false;
                                                                }
                                                                var valid7 = _errs40 === errors;
                                                              } else {
                                                                var valid7 = true;
                                                              }
                                                              if (valid7) {
                                                                if (data16.smallViewport !== void 0) {
                                                                  const _errs42 = errors;
                                                                  if (typeof data16.smallViewport !== "string") {
                                                                    validate16.errors = [{
                                                                      instancePath: instancePath + "/slidesSource/slides/" + i1 + "/image/smallViewport",
                                                                      schemaPath: "StaticSlideSource/properties/slides/items/properties/image/properties/smallViewport/type",
                                                                      keyword: "type",
                                                                      params: {
                                                                        type: "string"
                                                                      },
                                                                      message: "must be string"
                                                                    }];
                                                                    return false;
                                                                  }
                                                                  var valid7 = _errs42 === errors;
                                                                } else {
                                                                  var valid7 = true;
                                                                }
                                                              }
                                                            }
                                                          } else {
                                                            validate16.errors = [{
                                                              instancePath: instancePath + "/slidesSource/slides/" + i1 + "/image",
                                                              schemaPath: "StaticSlideSource/properties/slides/items/properties/image/type",
                                                              keyword: "type",
                                                              params: {
                                                                type: "object"
                                                              },
                                                              message: "must be object"
                                                            }];
                                                            return false;
                                                          }
                                                        }
                                                        var valid6 = _errs38 === errors;
                                                      } else {
                                                        var valid6 = true;
                                                      }
                                                    }
                                                  }
                                                }
                                              }
                                            }
                                          } else {
                                            validate16.errors = [{
                                              instancePath: instancePath + "/slidesSource/slides/" + i1,
                                              schemaPath: "StaticSlideSource/properties/slides/items/type",
                                              keyword: "type",
                                              params: {
                                                type: "object"
                                              },
                                              message: "must be object"
                                            }];
                                            return false;
                                          }
                                        }
                                        var valid5 = _errs28 === errors;
                                        if (!valid5) {
                                          break;
                                        }
                                      }
                                    } else {
                                      validate16.errors = [{
                                        instancePath: instancePath + "/slidesSource/slides",
                                        schemaPath: "StaticSlideSource/properties/slides/type",
                                        keyword: "type",
                                        params: {
                                          type: "array"
                                        },
                                        message: "must be array"
                                      }];
                                      return false;
                                    }
                                  }
                                  var valid4 = _errs26 === errors;
                                } else {
                                  var valid4 = true;
                                }
                              }
                            }
                          } else {
                            validate16.errors = [{
                              instancePath: instancePath + "/slidesSource",
                              schemaPath: "StaticSlideSource/type",
                              keyword: "type",
                              params: {
                                type: "object"
                              },
                              message: "must be object"
                            }];
                            return false;
                          }
                        }
                        var valid0 = _errs21 === errors;
                      } else {
                        var valid0 = true;
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
    } else {
      validate16.errors = [{
        instancePath,
        schemaPath: "#/type",
        keyword: "type",
        params: {
          type: "object"
        },
        message: "must be object"
      }];
      return false;
    }
  }
  validate16.errors = vErrors;
  return errors === 0;
}
const AdSpaceModule = validate17;
const schema20 = {
  "$id": "AdSpaceModule",
  "$schema": "http://json-schema.org/draft-07/schema#",
  "type": "object",
  "properties": {
    "moduleType": {
      "type": "string",
      "const": "AD_SPACE"
    },
    "heading": {
      "type": "string"
    },
    "subHeading": {
      "type": "string"
    },
    "hideFilter": {
      "anyOf": [{
        "type": "array",
        "items": {
          "type": "string",
          "enum": ["SUBSCRIBED", "REGISTERED"]
        }
      }, {
        "type": "null"
      }]
    },
    "link": {
      "type": "string"
    },
    "internal": {
      "type": "boolean"
    },
    "image": {
      "type": "object",
      "properties": {
        "largeViewport": {
          "type": "string"
        },
        "smallViewport": {
          "type": "string"
        }
      },
      "required": ["largeViewport"]
    }
  },
  "required": ["hideFilter", "image", "moduleType"],
  "description": "Specifies an Ad and the users it can be hidden from."
};
function validate17(data, {
  instancePath = "",
  parentData,
  parentDataProperty,
  rootData = data
} = {}) {
  let vErrors = null;
  let errors = 0;
  if (errors === 0) {
    if (data && typeof data == "object" && !Array.isArray(data)) {
      let missing0;
      if (data.hideFilter === void 0 && (missing0 = "hideFilter") || data.image === void 0 && (missing0 = "image") || data.moduleType === void 0 && (missing0 = "moduleType")) {
        validate17.errors = [{
          instancePath,
          schemaPath: "#/required",
          keyword: "required",
          params: {
            missingProperty: missing0
          },
          message: "must have required property '" + missing0 + "'"
        }];
        return false;
      } else {
        if (data.moduleType !== void 0) {
          let data0 = data.moduleType;
          const _errs1 = errors;
          if (typeof data0 !== "string") {
            validate17.errors = [{
              instancePath: instancePath + "/moduleType",
              schemaPath: "#/properties/moduleType/type",
              keyword: "type",
              params: {
                type: "string"
              },
              message: "must be string"
            }];
            return false;
          }
          if ("AD_SPACE" !== data0) {
            validate17.errors = [{
              instancePath: instancePath + "/moduleType",
              schemaPath: "#/properties/moduleType/const",
              keyword: "const",
              params: {
                allowedValue: "AD_SPACE"
              },
              message: "must be equal to constant"
            }];
            return false;
          }
          var valid0 = _errs1 === errors;
        } else {
          var valid0 = true;
        }
        if (valid0) {
          if (data.heading !== void 0) {
            const _errs3 = errors;
            if (typeof data.heading !== "string") {
              validate17.errors = [{
                instancePath: instancePath + "/heading",
                schemaPath: "#/properties/heading/type",
                keyword: "type",
                params: {
                  type: "string"
                },
                message: "must be string"
              }];
              return false;
            }
            var valid0 = _errs3 === errors;
          } else {
            var valid0 = true;
          }
          if (valid0) {
            if (data.subHeading !== void 0) {
              const _errs5 = errors;
              if (typeof data.subHeading !== "string") {
                validate17.errors = [{
                  instancePath: instancePath + "/subHeading",
                  schemaPath: "#/properties/subHeading/type",
                  keyword: "type",
                  params: {
                    type: "string"
                  },
                  message: "must be string"
                }];
                return false;
              }
              var valid0 = _errs5 === errors;
            } else {
              var valid0 = true;
            }
            if (valid0) {
              if (data.hideFilter !== void 0) {
                let data3 = data.hideFilter;
                const _errs7 = errors;
                const _errs8 = errors;
                let valid1 = false;
                const _errs9 = errors;
                if (errors === _errs9) {
                  if (Array.isArray(data3)) {
                    var valid2 = true;
                    const len0 = data3.length;
                    for (let i0 = 0; i0 < len0; i0++) {
                      let data4 = data3[i0];
                      const _errs11 = errors;
                      if (typeof data4 !== "string") {
                        const err0 = {
                          instancePath: instancePath + "/hideFilter/" + i0,
                          schemaPath: "#/properties/hideFilter/anyOf/0/items/type",
                          keyword: "type",
                          params: {
                            type: "string"
                          },
                          message: "must be string"
                        };
                        if (vErrors === null) {
                          vErrors = [err0];
                        } else {
                          vErrors.push(err0);
                        }
                        errors++;
                      }
                      if (!(data4 === "SUBSCRIBED" || data4 === "REGISTERED")) {
                        const err1 = {
                          instancePath: instancePath + "/hideFilter/" + i0,
                          schemaPath: "#/properties/hideFilter/anyOf/0/items/enum",
                          keyword: "enum",
                          params: {
                            allowedValues: schema20.properties.hideFilter.anyOf[0].items.enum
                          },
                          message: "must be equal to one of the allowed values"
                        };
                        if (vErrors === null) {
                          vErrors = [err1];
                        } else {
                          vErrors.push(err1);
                        }
                        errors++;
                      }
                      var valid2 = _errs11 === errors;
                      if (!valid2) {
                        break;
                      }
                    }
                  } else {
                    const err2 = {
                      instancePath: instancePath + "/hideFilter",
                      schemaPath: "#/properties/hideFilter/anyOf/0/type",
                      keyword: "type",
                      params: {
                        type: "array"
                      },
                      message: "must be array"
                    };
                    if (vErrors === null) {
                      vErrors = [err2];
                    } else {
                      vErrors.push(err2);
                    }
                    errors++;
                  }
                }
                var _valid0 = _errs9 === errors;
                valid1 = valid1 || _valid0;
                if (!valid1) {
                  const _errs13 = errors;
                  if (data3 !== null) {
                    const err3 = {
                      instancePath: instancePath + "/hideFilter",
                      schemaPath: "#/properties/hideFilter/anyOf/1/type",
                      keyword: "type",
                      params: {
                        type: "null"
                      },
                      message: "must be null"
                    };
                    if (vErrors === null) {
                      vErrors = [err3];
                    } else {
                      vErrors.push(err3);
                    }
                    errors++;
                  }
                  var _valid0 = _errs13 === errors;
                  valid1 = valid1 || _valid0;
                }
                if (!valid1) {
                  const err4 = {
                    instancePath: instancePath + "/hideFilter",
                    schemaPath: "#/properties/hideFilter/anyOf",
                    keyword: "anyOf",
                    params: {},
                    message: "must match a schema in anyOf"
                  };
                  if (vErrors === null) {
                    vErrors = [err4];
                  } else {
                    vErrors.push(err4);
                  }
                  errors++;
                  validate17.errors = vErrors;
                  return false;
                } else {
                  errors = _errs8;
                  if (vErrors !== null) {
                    if (_errs8) {
                      vErrors.length = _errs8;
                    } else {
                      vErrors = null;
                    }
                  }
                }
                var valid0 = _errs7 === errors;
              } else {
                var valid0 = true;
              }
              if (valid0) {
                if (data.link !== void 0) {
                  const _errs15 = errors;
                  if (typeof data.link !== "string") {
                    validate17.errors = [{
                      instancePath: instancePath + "/link",
                      schemaPath: "#/properties/link/type",
                      keyword: "type",
                      params: {
                        type: "string"
                      },
                      message: "must be string"
                    }];
                    return false;
                  }
                  var valid0 = _errs15 === errors;
                } else {
                  var valid0 = true;
                }
                if (valid0) {
                  if (data.internal !== void 0) {
                    const _errs17 = errors;
                    if (typeof data.internal !== "boolean") {
                      validate17.errors = [{
                        instancePath: instancePath + "/internal",
                        schemaPath: "#/properties/internal/type",
                        keyword: "type",
                        params: {
                          type: "boolean"
                        },
                        message: "must be boolean"
                      }];
                      return false;
                    }
                    var valid0 = _errs17 === errors;
                  } else {
                    var valid0 = true;
                  }
                  if (valid0) {
                    if (data.image !== void 0) {
                      let data7 = data.image;
                      const _errs19 = errors;
                      if (errors === _errs19) {
                        if (data7 && typeof data7 == "object" && !Array.isArray(data7)) {
                          let missing1;
                          if (data7.largeViewport === void 0 && (missing1 = "largeViewport")) {
                            validate17.errors = [{
                              instancePath: instancePath + "/image",
                              schemaPath: "#/properties/image/required",
                              keyword: "required",
                              params: {
                                missingProperty: missing1
                              },
                              message: "must have required property '" + missing1 + "'"
                            }];
                            return false;
                          } else {
                            if (data7.largeViewport !== void 0) {
                              const _errs21 = errors;
                              if (typeof data7.largeViewport !== "string") {
                                validate17.errors = [{
                                  instancePath: instancePath + "/image/largeViewport",
                                  schemaPath: "#/properties/image/properties/largeViewport/type",
                                  keyword: "type",
                                  params: {
                                    type: "string"
                                  },
                                  message: "must be string"
                                }];
                                return false;
                              }
                              var valid3 = _errs21 === errors;
                            } else {
                              var valid3 = true;
                            }
                            if (valid3) {
                              if (data7.smallViewport !== void 0) {
                                const _errs23 = errors;
                                if (typeof data7.smallViewport !== "string") {
                                  validate17.errors = [{
                                    instancePath: instancePath + "/image/smallViewport",
                                    schemaPath: "#/properties/image/properties/smallViewport/type",
                                    keyword: "type",
                                    params: {
                                      type: "string"
                                    },
                                    message: "must be string"
                                  }];
                                  return false;
                                }
                                var valid3 = _errs23 === errors;
                              } else {
                                var valid3 = true;
                              }
                            }
                          }
                        } else {
                          validate17.errors = [{
                            instancePath: instancePath + "/image",
                            schemaPath: "#/properties/image/type",
                            keyword: "type",
                            params: {
                              type: "object"
                            },
                            message: "must be object"
                          }];
                          return false;
                        }
                      }
                      var valid0 = _errs19 === errors;
                    } else {
                      var valid0 = true;
                    }
                  }
                }
              }
            }
          }
        }
      }
    } else {
      validate17.errors = [{
        instancePath,
        schemaPath: "#/type",
        keyword: "type",
        params: {
          type: "object"
        },
        message: "must be object"
      }];
      return false;
    }
  }
  validate17.errors = vErrors;
  return errors === 0;
}
const BillingPeriodicity = validate18;
const schema21 = {
  "$id": "BillingPeriodicity",
  "$schema": "http://json-schema.org/draft-07/schema#",
  "type": "string",
  "enum": ["MONTHLY", "YEARLY"],
  "description": "Represents the duration of one billing cycle."
};
function validate18(data, {
  instancePath = "",
  parentData,
  parentDataProperty,
  rootData = data
} = {}) {
  let vErrors = null;
  let errors = 0;
  if (typeof data !== "string") {
    validate18.errors = [{
      instancePath,
      schemaPath: "#/type",
      keyword: "type",
      params: {
        type: "string"
      },
      message: "must be string"
    }];
    return false;
  }
  if (!(data === "MONTHLY" || data === "YEARLY")) {
    validate18.errors = [{
      instancePath,
      schemaPath: "#/enum",
      keyword: "enum",
      params: {
        allowedValues: schema21.enum
      },
      message: "must be equal to one of the allowed values"
    }];
    return false;
  }
  validate18.errors = vErrors;
  return errors === 0;
}
const PauseBehaviour = validate19;
const formats0 = require("ajv-formats/dist/formats").fullFormats["date-time"];
function validate19(data, {
  instancePath = "",
  parentData,
  parentDataProperty,
  rootData = data
} = {}) {
  let vErrors = null;
  let errors = 0;
  if (errors === 0) {
    if (data && typeof data == "object" && !Array.isArray(data)) {
      let missing0;
      if (data.periods === void 0 && (missing0 = "periods") || data.onceEvery === void 0 && (missing0 = "onceEvery") || data.canUnpause === void 0 && (missing0 = "canUnpause") || data.texts === void 0 && (missing0 = "texts")) {
        validate19.errors = [{
          instancePath,
          schemaPath: "#/required",
          keyword: "required",
          params: {
            missingProperty: missing0
          },
          message: "must have required property '" + missing0 + "'"
        }];
        return false;
      } else {
        if (data.periods !== void 0) {
          let data0 = data.periods;
          const _errs1 = errors;
          if (errors === _errs1) {
            if (Array.isArray(data0)) {
              var valid1 = true;
              const len0 = data0.length;
              for (let i0 = 0; i0 < len0; i0++) {
                let data1 = data0[i0];
                const _errs3 = errors;
                if (errors === _errs3) {
                  if (data1 && typeof data1 == "object" && !Array.isArray(data1)) {
                    let missing1;
                    if (data1.period === void 0 && (missing1 = "period") || data1.label === void 0 && (missing1 = "label")) {
                      validate19.errors = [{
                        instancePath: instancePath + "/periods/" + i0,
                        schemaPath: "#/properties/periods/items/required",
                        keyword: "required",
                        params: {
                          missingProperty: missing1
                        },
                        message: "must have required property '" + missing1 + "'"
                      }];
                      return false;
                    } else {
                      if (data1.period !== void 0) {
                        let data2 = data1.period;
                        const _errs5 = errors;
                        const _errs6 = errors;
                        let valid3 = false;
                        const _errs7 = errors;
                        if (!(typeof data2 == "number" && isFinite(data2))) {
                          const err0 = {
                            instancePath: instancePath + "/periods/" + i0 + "/period",
                            schemaPath: "#/properties/periods/items/properties/period/anyOf/0/type",
                            keyword: "type",
                            params: {
                              type: "number"
                            },
                            message: "must be number"
                          };
                          if (vErrors === null) {
                            vErrors = [err0];
                          } else {
                            vErrors.push(err0);
                          }
                          errors++;
                        }
                        var _valid0 = _errs7 === errors;
                        valid3 = valid3 || _valid0;
                        if (!valid3) {
                          const _errs9 = errors;
                          if (!(data2 && typeof data2 == "object" && !Array.isArray(data2))) {
                            const err1 = {
                              instancePath: instancePath + "/periods/" + i0 + "/period",
                              schemaPath: "#/properties/periods/items/properties/period/anyOf/1/type",
                              keyword: "type",
                              params: {
                                type: "object"
                              },
                              message: "must be object"
                            };
                            if (vErrors === null) {
                              vErrors = [err1];
                            } else {
                              vErrors.push(err1);
                            }
                            errors++;
                          }
                          if (errors === _errs9) {
                            if (errors === _errs9) {
                              if (typeof data2 === "string") {
                                if (!formats0(data2)) {
                                  const err2 = {
                                    instancePath: instancePath + "/periods/" + i0 + "/period",
                                    schemaPath: "#/properties/periods/items/properties/period/anyOf/1/format",
                                    keyword: "format",
                                    params: {
                                      format: "date-time"
                                    },
                                    message: 'must match format "date-time"'
                                  };
                                  if (vErrors === null) {
                                    vErrors = [err2];
                                  } else {
                                    vErrors.push(err2);
                                  }
                                  errors++;
                                }
                              }
                            }
                          }
                          var _valid0 = _errs9 === errors;
                          valid3 = valid3 || _valid0;
                        }
                        if (!valid3) {
                          const err3 = {
                            instancePath: instancePath + "/periods/" + i0 + "/period",
                            schemaPath: "#/properties/periods/items/properties/period/anyOf",
                            keyword: "anyOf",
                            params: {},
                            message: "must match a schema in anyOf"
                          };
                          if (vErrors === null) {
                            vErrors = [err3];
                          } else {
                            vErrors.push(err3);
                          }
                          errors++;
                          validate19.errors = vErrors;
                          return false;
                        } else {
                          errors = _errs6;
                          if (vErrors !== null) {
                            if (_errs6) {
                              vErrors.length = _errs6;
                            } else {
                              vErrors = null;
                            }
                          }
                        }
                        var valid2 = _errs5 === errors;
                      } else {
                        var valid2 = true;
                      }
                      if (valid2) {
                        if (data1.label !== void 0) {
                          const _errs11 = errors;
                          if (typeof data1.label !== "string") {
                            validate19.errors = [{
                              instancePath: instancePath + "/periods/" + i0 + "/label",
                              schemaPath: "#/properties/periods/items/properties/label/type",
                              keyword: "type",
                              params: {
                                type: "string"
                              },
                              message: "must be string"
                            }];
                            return false;
                          }
                          var valid2 = _errs11 === errors;
                        } else {
                          var valid2 = true;
                        }
                      }
                    }
                  } else {
                    validate19.errors = [{
                      instancePath: instancePath + "/periods/" + i0,
                      schemaPath: "#/properties/periods/items/type",
                      keyword: "type",
                      params: {
                        type: "object"
                      },
                      message: "must be object"
                    }];
                    return false;
                  }
                }
                var valid1 = _errs3 === errors;
                if (!valid1) {
                  break;
                }
              }
            } else {
              validate19.errors = [{
                instancePath: instancePath + "/periods",
                schemaPath: "#/properties/periods/type",
                keyword: "type",
                params: {
                  type: "array"
                },
                message: "must be array"
              }];
              return false;
            }
          }
          var valid0 = _errs1 === errors;
        } else {
          var valid0 = true;
        }
        if (valid0) {
          if (data.onceEvery !== void 0) {
            let data4 = data.onceEvery;
            const _errs13 = errors;
            if (!(typeof data4 == "number" && isFinite(data4))) {
              validate19.errors = [{
                instancePath: instancePath + "/onceEvery",
                schemaPath: "#/properties/onceEvery/type",
                keyword: "type",
                params: {
                  type: "number"
                },
                message: "must be number"
              }];
              return false;
            }
            var valid0 = _errs13 === errors;
          } else {
            var valid0 = true;
          }
          if (valid0) {
            if (data.canUnpause !== void 0) {
              const _errs15 = errors;
              if (typeof data.canUnpause !== "boolean") {
                validate19.errors = [{
                  instancePath: instancePath + "/canUnpause",
                  schemaPath: "#/properties/canUnpause/type",
                  keyword: "type",
                  params: {
                    type: "boolean"
                  },
                  message: "must be boolean"
                }];
                return false;
              }
              var valid0 = _errs15 === errors;
            } else {
              var valid0 = true;
            }
            if (valid0) {
              if (data.texts !== void 0) {
                let data6 = data.texts;
                const _errs17 = errors;
                if (errors === _errs17) {
                  if (data6 && typeof data6 == "object" && !Array.isArray(data6)) {
                    let missing2;
                    if (data6.header === void 0 && (missing2 = "header") || data6.pros === void 0 && (missing2 = "pros")) {
                      validate19.errors = [{
                        instancePath: instancePath + "/texts",
                        schemaPath: "#/properties/texts/required",
                        keyword: "required",
                        params: {
                          missingProperty: missing2
                        },
                        message: "must have required property '" + missing2 + "'"
                      }];
                      return false;
                    } else {
                      if (data6.header !== void 0) {
                        const _errs19 = errors;
                        if (typeof data6.header !== "string") {
                          validate19.errors = [{
                            instancePath: instancePath + "/texts/header",
                            schemaPath: "#/properties/texts/properties/header/type",
                            keyword: "type",
                            params: {
                              type: "string"
                            },
                            message: "must be string"
                          }];
                          return false;
                        }
                        var valid4 = _errs19 === errors;
                      } else {
                        var valid4 = true;
                      }
                      if (valid4) {
                        if (data6.pros !== void 0) {
                          let data8 = data6.pros;
                          const _errs21 = errors;
                          if (errors === _errs21) {
                            if (Array.isArray(data8)) {
                              var valid5 = true;
                              const len1 = data8.length;
                              for (let i1 = 0; i1 < len1; i1++) {
                                const _errs23 = errors;
                                if (typeof data8[i1] !== "string") {
                                  validate19.errors = [{
                                    instancePath: instancePath + "/texts/pros/" + i1,
                                    schemaPath: "#/properties/texts/properties/pros/items/type",
                                    keyword: "type",
                                    params: {
                                      type: "string"
                                    },
                                    message: "must be string"
                                  }];
                                  return false;
                                }
                                var valid5 = _errs23 === errors;
                                if (!valid5) {
                                  break;
                                }
                              }
                            } else {
                              validate19.errors = [{
                                instancePath: instancePath + "/texts/pros",
                                schemaPath: "#/properties/texts/properties/pros/type",
                                keyword: "type",
                                params: {
                                  type: "array"
                                },
                                message: "must be array"
                              }];
                              return false;
                            }
                          }
                          var valid4 = _errs21 === errors;
                        } else {
                          var valid4 = true;
                        }
                        if (valid4) {
                          if (data6.promoBlock !== void 0) {
                            let data10 = data6.promoBlock;
                            const _errs25 = errors;
                            if (errors === _errs25) {
                              if (data10 && typeof data10 == "object" && !Array.isArray(data10)) {
                                let missing3;
                                if (data10.title === void 0 && (missing3 = "title") || data10.description === void 0 && (missing3 = "description")) {
                                  validate19.errors = [{
                                    instancePath: instancePath + "/texts/promoBlock",
                                    schemaPath: "#/properties/texts/properties/promoBlock/required",
                                    keyword: "required",
                                    params: {
                                      missingProperty: missing3
                                    },
                                    message: "must have required property '" + missing3 + "'"
                                  }];
                                  return false;
                                } else {
                                  if (data10.imageUrl !== void 0) {
                                    const _errs27 = errors;
                                    if (typeof data10.imageUrl !== "string") {
                                      validate19.errors = [{
                                        instancePath: instancePath + "/texts/promoBlock/imageUrl",
                                        schemaPath: "#/properties/texts/properties/promoBlock/properties/imageUrl/type",
                                        keyword: "type",
                                        params: {
                                          type: "string"
                                        },
                                        message: "must be string"
                                      }];
                                      return false;
                                    }
                                    var valid6 = _errs27 === errors;
                                  } else {
                                    var valid6 = true;
                                  }
                                  if (valid6) {
                                    if (data10.title !== void 0) {
                                      const _errs29 = errors;
                                      if (typeof data10.title !== "string") {
                                        validate19.errors = [{
                                          instancePath: instancePath + "/texts/promoBlock/title",
                                          schemaPath: "#/properties/texts/properties/promoBlock/properties/title/type",
                                          keyword: "type",
                                          params: {
                                            type: "string"
                                          },
                                          message: "must be string"
                                        }];
                                        return false;
                                      }
                                      var valid6 = _errs29 === errors;
                                    } else {
                                      var valid6 = true;
                                    }
                                    if (valid6) {
                                      if (data10.description !== void 0) {
                                        const _errs31 = errors;
                                        if (typeof data10.description !== "string") {
                                          validate19.errors = [{
                                            instancePath: instancePath + "/texts/promoBlock/description",
                                            schemaPath: "#/properties/texts/properties/promoBlock/properties/description/type",
                                            keyword: "type",
                                            params: {
                                              type: "string"
                                            },
                                            message: "must be string"
                                          }];
                                          return false;
                                        }
                                        var valid6 = _errs31 === errors;
                                      } else {
                                        var valid6 = true;
                                      }
                                    }
                                  }
                                }
                              } else {
                                validate19.errors = [{
                                  instancePath: instancePath + "/texts/promoBlock",
                                  schemaPath: "#/properties/texts/properties/promoBlock/type",
                                  keyword: "type",
                                  params: {
                                    type: "object"
                                  },
                                  message: "must be object"
                                }];
                                return false;
                              }
                            }
                            var valid4 = _errs25 === errors;
                          } else {
                            var valid4 = true;
                          }
                        }
                      }
                    }
                  } else {
                    validate19.errors = [{
                      instancePath: instancePath + "/texts",
                      schemaPath: "#/properties/texts/type",
                      keyword: "type",
                      params: {
                        type: "object"
                      },
                      message: "must be object"
                    }];
                    return false;
                  }
                }
                var valid0 = _errs17 === errors;
              } else {
                var valid0 = true;
              }
            }
          }
        }
      }
    } else {
      validate19.errors = [{
        instancePath,
        schemaPath: "#/type",
        keyword: "type",
        params: {
          type: "object"
        },
        message: "must be object"
      }];
      return false;
    }
  }
  validate19.errors = vErrors;
  return errors === 0;
}
const PlanInstallments = validate20;
function validate20(data, {
  instancePath = "",
  parentData,
  parentDataProperty,
  rootData = data
} = {}) {
  let vErrors = null;
  let errors = 0;
  {
    if (data && typeof data == "object" && !Array.isArray(data)) {
      let missing0;
      if (data.bindingCycles === void 0 && (missing0 = "bindingCycles") || data.price === void 0 && (missing0 = "price") || data.period === void 0 && (missing0 = "period")) {
        validate20.errors = [{
          instancePath,
          schemaPath: "#/required",
          keyword: "required",
          params: {
            missingProperty: missing0
          },
          message: "must have required property '" + missing0 + "'"
        }];
        return false;
      } else {
        if (data.bindingCycles !== void 0) {
          let data0 = data.bindingCycles;
          const _errs1 = errors;
          if (!(typeof data0 == "number" && isFinite(data0))) {
            validate20.errors = [{
              instancePath: instancePath + "/bindingCycles",
              schemaPath: "#/properties/bindingCycles/type",
              keyword: "type",
              params: {
                type: "number"
              },
              message: "must be number"
            }];
            return false;
          }
          var valid0 = _errs1 === errors;
        } else {
          var valid0 = true;
        }
        if (valid0) {
          if (data.price !== void 0) {
            let data1 = data.price;
            const _errs3 = errors;
            if (!(typeof data1 == "number" && isFinite(data1))) {
              validate20.errors = [{
                instancePath: instancePath + "/price",
                schemaPath: "#/properties/price/type",
                keyword: "type",
                params: {
                  type: "number"
                },
                message: "must be number"
              }];
              return false;
            }
            var valid0 = _errs3 === errors;
          } else {
            var valid0 = true;
          }
          if (valid0) {
            if (data.period !== void 0) {
              let data2 = data.period;
              const _errs5 = errors;
              if (typeof data2 !== "string") {
                validate20.errors = [{
                  instancePath: instancePath + "/period",
                  schemaPath: "BillingPeriodicity/type",
                  keyword: "type",
                  params: {
                    type: "string"
                  },
                  message: "must be string"
                }];
                return false;
              }
              if (!(data2 === "MONTHLY" || data2 === "YEARLY")) {
                validate20.errors = [{
                  instancePath: instancePath + "/period",
                  schemaPath: "BillingPeriodicity/enum",
                  keyword: "enum",
                  params: {
                    allowedValues: schema21.enum
                  },
                  message: "must be equal to one of the allowed values"
                }];
                return false;
              }
              var valid0 = _errs5 === errors;
            } else {
              var valid0 = true;
            }
            if (valid0) {
              if (data.label !== void 0) {
                const _errs8 = errors;
                if (typeof data.label !== "string") {
                  validate20.errors = [{
                    instancePath: instancePath + "/label",
                    schemaPath: "#/properties/label/type",
                    keyword: "type",
                    params: {
                      type: "string"
                    },
                    message: "must be string"
                  }];
                  return false;
                }
                var valid0 = _errs8 === errors;
              } else {
                var valid0 = true;
              }
              if (valid0) {
                if (data.details !== void 0) {
                  const _errs10 = errors;
                  if (typeof data.details !== "string") {
                    validate20.errors = [{
                      instancePath: instancePath + "/details",
                      schemaPath: "#/properties/details/type",
                      keyword: "type",
                      params: {
                        type: "string"
                      },
                      message: "must be string"
                    }];
                    return false;
                  }
                  var valid0 = _errs10 === errors;
                } else {
                  var valid0 = true;
                }
                if (valid0) {
                  if (data.icon !== void 0) {
                    const _errs12 = errors;
                    if (typeof data.icon !== "string") {
                      validate20.errors = [{
                        instancePath: instancePath + "/icon",
                        schemaPath: "#/properties/icon/type",
                        keyword: "type",
                        params: {
                          type: "string"
                        },
                        message: "must be string"
                      }];
                      return false;
                    }
                    var valid0 = _errs12 === errors;
                  } else {
                    var valid0 = true;
                  }
                }
              }
            }
          }
        }
      }
    } else {
      validate20.errors = [{
        instancePath,
        schemaPath: "#/type",
        keyword: "type",
        params: {
          type: "object"
        },
        message: "must be object"
      }];
      return false;
    }
  }
  validate20.errors = vErrors;
  return errors === 0;
}
const PriceBlock = validate21;
function validate21(data, {
  instancePath = "",
  parentData,
  parentDataProperty,
  rootData = data
} = {}) {
  let vErrors = null;
  let errors = 0;
  if (errors === 0) {
    if (data && typeof data == "object" && !Array.isArray(data)) {
      if (data.discountTag !== void 0) {
        const _errs1 = errors;
        if (typeof data.discountTag !== "string") {
          validate21.errors = [{
            instancePath: instancePath + "/discountTag",
            schemaPath: "#/properties/discountTag/type",
            keyword: "type",
            params: {
              type: "string"
            },
            message: "must be string"
          }];
          return false;
        }
        var valid0 = _errs1 === errors;
      } else {
        var valid0 = true;
      }
      if (valid0) {
        if (data.label !== void 0) {
          const _errs3 = errors;
          if (typeof data.label !== "string") {
            validate21.errors = [{
              instancePath: instancePath + "/label",
              schemaPath: "#/properties/label/type",
              keyword: "type",
              params: {
                type: "string"
              },
              message: "must be string"
            }];
            return false;
          }
          var valid0 = _errs3 === errors;
        } else {
          var valid0 = true;
        }
        if (valid0) {
          if (data.details !== void 0) {
            const _errs5 = errors;
            if (typeof data.details !== "string") {
              validate21.errors = [{
                instancePath: instancePath + "/details",
                schemaPath: "#/properties/details/type",
                keyword: "type",
                params: {
                  type: "string"
                },
                message: "must be string"
              }];
              return false;
            }
            var valid0 = _errs5 === errors;
          } else {
            var valid0 = true;
          }
          if (valid0) {
            if (data.action !== void 0) {
              let data3 = data.action;
              const _errs7 = errors;
              const _errs8 = errors;
              let valid1 = false;
              const _errs9 = errors;
              if (typeof data3 !== "string") {
                const err0 = {
                  instancePath: instancePath + "/action",
                  schemaPath: "#/properties/action/anyOf/0/type",
                  keyword: "type",
                  params: {
                    type: "string"
                  },
                  message: "must be string"
                };
                if (vErrors === null) {
                  vErrors = [err0];
                } else {
                  vErrors.push(err0);
                }
                errors++;
              }
              var _valid0 = _errs9 === errors;
              valid1 = valid1 || _valid0;
              if (!valid1) {
                const _errs11 = errors;
                if (errors === _errs11) {
                  if (Array.isArray(data3)) {
                    if (data3.length > 2) {
                      const err1 = {
                        instancePath: instancePath + "/action",
                        schemaPath: "#/properties/action/anyOf/1/maxItems",
                        keyword: "maxItems",
                        params: {
                          limit: 2
                        },
                        message: "must NOT have more than 2 items"
                      };
                      if (vErrors === null) {
                        vErrors = [err1];
                      } else {
                        vErrors.push(err1);
                      }
                      errors++;
                    } else {
                      if (data3.length < 2) {
                        const err2 = {
                          instancePath: instancePath + "/action",
                          schemaPath: "#/properties/action/anyOf/1/minItems",
                          keyword: "minItems",
                          params: {
                            limit: 2
                          },
                          message: "must NOT have fewer than 2 items"
                        };
                        if (vErrors === null) {
                          vErrors = [err2];
                        } else {
                          vErrors.push(err2);
                        }
                        errors++;
                      } else {
                        const len0 = data3.length;
                        if (len0 > 0) {
                          const _errs13 = errors;
                          if (typeof data3[0] !== "string") {
                            const err3 = {
                              instancePath: instancePath + "/action/0",
                              schemaPath: "#/properties/action/anyOf/1/items/0/type",
                              keyword: "type",
                              params: {
                                type: "string"
                              },
                              message: "must be string"
                            };
                            if (vErrors === null) {
                              vErrors = [err3];
                            } else {
                              vErrors.push(err3);
                            }
                            errors++;
                          }
                          var valid2 = _errs13 === errors;
                        }
                        if (valid2) {
                          if (len0 > 1) {
                            let data5 = data3[1];
                            const _errs15 = errors;
                            if (!(typeof data5 == "number" && isFinite(data5))) {
                              const err4 = {
                                instancePath: instancePath + "/action/1",
                                schemaPath: "#/properties/action/anyOf/1/items/1/type",
                                keyword: "type",
                                params: {
                                  type: "number"
                                },
                                message: "must be number"
                              };
                              if (vErrors === null) {
                                vErrors = [err4];
                              } else {
                                vErrors.push(err4);
                              }
                              errors++;
                            }
                            var valid2 = _errs15 === errors;
                          }
                        }
                      }
                    }
                  } else {
                    const err5 = {
                      instancePath: instancePath + "/action",
                      schemaPath: "#/properties/action/anyOf/1/type",
                      keyword: "type",
                      params: {
                        type: "array"
                      },
                      message: "must be array"
                    };
                    if (vErrors === null) {
                      vErrors = [err5];
                    } else {
                      vErrors.push(err5);
                    }
                    errors++;
                  }
                }
                var _valid0 = _errs11 === errors;
                valid1 = valid1 || _valid0;
              }
              if (!valid1) {
                const err6 = {
                  instancePath: instancePath + "/action",
                  schemaPath: "#/properties/action/anyOf",
                  keyword: "anyOf",
                  params: {},
                  message: "must match a schema in anyOf"
                };
                if (vErrors === null) {
                  vErrors = [err6];
                } else {
                  vErrors.push(err6);
                }
                errors++;
                validate21.errors = vErrors;
                return false;
              } else {
                errors = _errs8;
                if (vErrors !== null) {
                  if (_errs8) {
                    vErrors.length = _errs8;
                  } else {
                    vErrors = null;
                  }
                }
              }
              var valid0 = _errs7 === errors;
            } else {
              var valid0 = true;
            }
          }
        }
      }
    } else {
      validate21.errors = [{
        instancePath,
        schemaPath: "#/type",
        keyword: "type",
        params: {
          type: "object"
        },
        message: "must be object"
      }];
      return false;
    }
  }
  validate21.errors = vErrors;
  return errors === 0;
}
const BillingPeriodConfiguration = validate22;
const schema26 = {
  "$id": "BillingPeriodConfiguration",
  "$schema": "http://json-schema.org/draft-07/schema#",
  "type": "object",
  "properties": {
    "highlighted": {
      "type": "boolean"
    },
    "period": {
      "$ref": "BillingPeriodicity"
    },
    "basePrice": {
      "type": "number"
    },
    "trialDays": {
      "type": ["null", "number"]
    },
    "discountLabel": {
      "type": ["string", "null"]
    },
    "discountDescription": {
      "type": "string"
    },
    "priceBlock": {
      "$ref": "PriceBlock"
    },
    "initialPhaseDiscount": {
      "anyOf": [{
        "type": "object",
        "properties": {
          "discount": {
            "anyOf": [{
              "type": "object",
              "properties": {
                "percentOff": {
                  "type": "number"
                }
              },
              "required": ["percentOff"]
            }, {
              "type": "object",
              "properties": {
                "amountOff": {
                  "type": "number"
                }
              },
              "required": ["amountOff"]
            }]
          },
          "cycles": {
            "anyOf": [{
              "type": "number"
            }, {
              "type": "object",
              "format": "date-time"
            }]
          },
          "offerEndDate": {
            "anyOf": [{
              "type": "object",
              "format": "date-time"
            }, {
              "type": "null"
            }]
          },
          "title": {
            "type": "string"
          },
          "shortDescription": {
            "type": "string"
          },
          "overrides": {
            "type": "object",
            "properties": {
              "discountLabel": {
                "type": "string"
              },
              "discountDescription": {
                "type": "string"
              },
              "priceBlock": {
                "$ref": "PriceBlock"
              }
            }
          },
          "allowedForInstallments": {
            "type": "boolean",
            "const": false
          }
        },
        "required": ["discount", "cycles", "offerEndDate", "title", "shortDescription"]
      }, {
        "type": "null"
      }]
    },
    "allowPromoCodes": {
      "type": "boolean"
    },
    "pauseBehaviour": {
      "$ref": "PauseBehaviour"
    },
    "installments": {
      "$ref": "PlanInstallments"
    }
  },
  "required": ["highlighted", "period", "basePrice", "trialDays", "discountLabel", "discountDescription", "initialPhaseDiscount", "allowPromoCodes"],
  "description": "Represents the configuration for a given billing period. Currently supported cycles:  - MONTHLY: every month  - YEARLY: every year"
};
function validate22(data, {
  instancePath = "",
  parentData,
  parentDataProperty,
  rootData = data
} = {}) {
  let vErrors = null;
  let errors = 0;
  if (errors === 0) {
    if (data && typeof data == "object" && !Array.isArray(data)) {
      let missing0;
      if (data.highlighted === void 0 && (missing0 = "highlighted") || data.period === void 0 && (missing0 = "period") || data.basePrice === void 0 && (missing0 = "basePrice") || data.trialDays === void 0 && (missing0 = "trialDays") || data.discountLabel === void 0 && (missing0 = "discountLabel") || data.discountDescription === void 0 && (missing0 = "discountDescription") || data.initialPhaseDiscount === void 0 && (missing0 = "initialPhaseDiscount") || data.allowPromoCodes === void 0 && (missing0 = "allowPromoCodes")) {
        validate22.errors = [{
          instancePath,
          schemaPath: "#/required",
          keyword: "required",
          params: {
            missingProperty: missing0
          },
          message: "must have required property '" + missing0 + "'"
        }];
        return false;
      } else {
        if (data.highlighted !== void 0) {
          const _errs1 = errors;
          if (typeof data.highlighted !== "boolean") {
            validate22.errors = [{
              instancePath: instancePath + "/highlighted",
              schemaPath: "#/properties/highlighted/type",
              keyword: "type",
              params: {
                type: "boolean"
              },
              message: "must be boolean"
            }];
            return false;
          }
          var valid0 = _errs1 === errors;
        } else {
          var valid0 = true;
        }
        if (valid0) {
          if (data.period !== void 0) {
            let data1 = data.period;
            const _errs3 = errors;
            if (typeof data1 !== "string") {
              validate22.errors = [{
                instancePath: instancePath + "/period",
                schemaPath: "BillingPeriodicity/type",
                keyword: "type",
                params: {
                  type: "string"
                },
                message: "must be string"
              }];
              return false;
            }
            if (!(data1 === "MONTHLY" || data1 === "YEARLY")) {
              validate22.errors = [{
                instancePath: instancePath + "/period",
                schemaPath: "BillingPeriodicity/enum",
                keyword: "enum",
                params: {
                  allowedValues: schema21.enum
                },
                message: "must be equal to one of the allowed values"
              }];
              return false;
            }
            var valid0 = _errs3 === errors;
          } else {
            var valid0 = true;
          }
          if (valid0) {
            if (data.basePrice !== void 0) {
              let data2 = data.basePrice;
              const _errs6 = errors;
              if (!(typeof data2 == "number" && isFinite(data2))) {
                validate22.errors = [{
                  instancePath: instancePath + "/basePrice",
                  schemaPath: "#/properties/basePrice/type",
                  keyword: "type",
                  params: {
                    type: "number"
                  },
                  message: "must be number"
                }];
                return false;
              }
              var valid0 = _errs6 === errors;
            } else {
              var valid0 = true;
            }
            if (valid0) {
              if (data.trialDays !== void 0) {
                let data3 = data.trialDays;
                const _errs8 = errors;
                if (data3 !== null && !(typeof data3 == "number" && isFinite(data3))) {
                  validate22.errors = [{
                    instancePath: instancePath + "/trialDays",
                    schemaPath: "#/properties/trialDays/type",
                    keyword: "type",
                    params: {
                      type: schema26.properties.trialDays.type
                    },
                    message: "must be null,number"
                  }];
                  return false;
                }
                var valid0 = _errs8 === errors;
              } else {
                var valid0 = true;
              }
              if (valid0) {
                if (data.discountLabel !== void 0) {
                  let data4 = data.discountLabel;
                  const _errs10 = errors;
                  if (typeof data4 !== "string" && data4 !== null) {
                    validate22.errors = [{
                      instancePath: instancePath + "/discountLabel",
                      schemaPath: "#/properties/discountLabel/type",
                      keyword: "type",
                      params: {
                        type: schema26.properties.discountLabel.type
                      },
                      message: "must be string,null"
                    }];
                    return false;
                  }
                  var valid0 = _errs10 === errors;
                } else {
                  var valid0 = true;
                }
                if (valid0) {
                  if (data.discountDescription !== void 0) {
                    const _errs12 = errors;
                    if (typeof data.discountDescription !== "string") {
                      validate22.errors = [{
                        instancePath: instancePath + "/discountDescription",
                        schemaPath: "#/properties/discountDescription/type",
                        keyword: "type",
                        params: {
                          type: "string"
                        },
                        message: "must be string"
                      }];
                      return false;
                    }
                    var valid0 = _errs12 === errors;
                  } else {
                    var valid0 = true;
                  }
                  if (valid0) {
                    if (data.priceBlock !== void 0) {
                      let data6 = data.priceBlock;
                      const _errs14 = errors;
                      const _errs15 = errors;
                      if (errors === _errs15) {
                        if (data6 && typeof data6 == "object" && !Array.isArray(data6)) {
                          if (data6.discountTag !== void 0) {
                            const _errs17 = errors;
                            if (typeof data6.discountTag !== "string") {
                              validate22.errors = [{
                                instancePath: instancePath + "/priceBlock/discountTag",
                                schemaPath: "PriceBlock/properties/discountTag/type",
                                keyword: "type",
                                params: {
                                  type: "string"
                                },
                                message: "must be string"
                              }];
                              return false;
                            }
                            var valid3 = _errs17 === errors;
                          } else {
                            var valid3 = true;
                          }
                          if (valid3) {
                            if (data6.label !== void 0) {
                              const _errs19 = errors;
                              if (typeof data6.label !== "string") {
                                validate22.errors = [{
                                  instancePath: instancePath + "/priceBlock/label",
                                  schemaPath: "PriceBlock/properties/label/type",
                                  keyword: "type",
                                  params: {
                                    type: "string"
                                  },
                                  message: "must be string"
                                }];
                                return false;
                              }
                              var valid3 = _errs19 === errors;
                            } else {
                              var valid3 = true;
                            }
                            if (valid3) {
                              if (data6.details !== void 0) {
                                const _errs21 = errors;
                                if (typeof data6.details !== "string") {
                                  validate22.errors = [{
                                    instancePath: instancePath + "/priceBlock/details",
                                    schemaPath: "PriceBlock/properties/details/type",
                                    keyword: "type",
                                    params: {
                                      type: "string"
                                    },
                                    message: "must be string"
                                  }];
                                  return false;
                                }
                                var valid3 = _errs21 === errors;
                              } else {
                                var valid3 = true;
                              }
                              if (valid3) {
                                if (data6.action !== void 0) {
                                  let data10 = data6.action;
                                  const _errs23 = errors;
                                  const _errs24 = errors;
                                  let valid4 = false;
                                  const _errs25 = errors;
                                  if (typeof data10 !== "string") {
                                    const err0 = {
                                      instancePath: instancePath + "/priceBlock/action",
                                      schemaPath: "PriceBlock/properties/action/anyOf/0/type",
                                      keyword: "type",
                                      params: {
                                        type: "string"
                                      },
                                      message: "must be string"
                                    };
                                    if (vErrors === null) {
                                      vErrors = [err0];
                                    } else {
                                      vErrors.push(err0);
                                    }
                                    errors++;
                                  }
                                  var _valid0 = _errs25 === errors;
                                  valid4 = valid4 || _valid0;
                                  if (!valid4) {
                                    const _errs27 = errors;
                                    if (errors === _errs27) {
                                      if (Array.isArray(data10)) {
                                        if (data10.length > 2) {
                                          const err1 = {
                                            instancePath: instancePath + "/priceBlock/action",
                                            schemaPath: "PriceBlock/properties/action/anyOf/1/maxItems",
                                            keyword: "maxItems",
                                            params: {
                                              limit: 2
                                            },
                                            message: "must NOT have more than 2 items"
                                          };
                                          if (vErrors === null) {
                                            vErrors = [err1];
                                          } else {
                                            vErrors.push(err1);
                                          }
                                          errors++;
                                        } else {
                                          if (data10.length < 2) {
                                            const err2 = {
                                              instancePath: instancePath + "/priceBlock/action",
                                              schemaPath: "PriceBlock/properties/action/anyOf/1/minItems",
                                              keyword: "minItems",
                                              params: {
                                                limit: 2
                                              },
                                              message: "must NOT have fewer than 2 items"
                                            };
                                            if (vErrors === null) {
                                              vErrors = [err2];
                                            } else {
                                              vErrors.push(err2);
                                            }
                                            errors++;
                                          } else {
                                            const len0 = data10.length;
                                            if (len0 > 0) {
                                              const _errs29 = errors;
                                              if (typeof data10[0] !== "string") {
                                                const err3 = {
                                                  instancePath: instancePath + "/priceBlock/action/0",
                                                  schemaPath: "PriceBlock/properties/action/anyOf/1/items/0/type",
                                                  keyword: "type",
                                                  params: {
                                                    type: "string"
                                                  },
                                                  message: "must be string"
                                                };
                                                if (vErrors === null) {
                                                  vErrors = [err3];
                                                } else {
                                                  vErrors.push(err3);
                                                }
                                                errors++;
                                              }
                                              var valid5 = _errs29 === errors;
                                            }
                                            if (valid5) {
                                              if (len0 > 1) {
                                                let data12 = data10[1];
                                                const _errs31 = errors;
                                                if (!(typeof data12 == "number" && isFinite(data12))) {
                                                  const err4 = {
                                                    instancePath: instancePath + "/priceBlock/action/1",
                                                    schemaPath: "PriceBlock/properties/action/anyOf/1/items/1/type",
                                                    keyword: "type",
                                                    params: {
                                                      type: "number"
                                                    },
                                                    message: "must be number"
                                                  };
                                                  if (vErrors === null) {
                                                    vErrors = [err4];
                                                  } else {
                                                    vErrors.push(err4);
                                                  }
                                                  errors++;
                                                }
                                                var valid5 = _errs31 === errors;
                                              }
                                            }
                                          }
                                        }
                                      } else {
                                        const err5 = {
                                          instancePath: instancePath + "/priceBlock/action",
                                          schemaPath: "PriceBlock/properties/action/anyOf/1/type",
                                          keyword: "type",
                                          params: {
                                            type: "array"
                                          },
                                          message: "must be array"
                                        };
                                        if (vErrors === null) {
                                          vErrors = [err5];
                                        } else {
                                          vErrors.push(err5);
                                        }
                                        errors++;
                                      }
                                    }
                                    var _valid0 = _errs27 === errors;
                                    valid4 = valid4 || _valid0;
                                  }
                                  if (!valid4) {
                                    const err6 = {
                                      instancePath: instancePath + "/priceBlock/action",
                                      schemaPath: "PriceBlock/properties/action/anyOf",
                                      keyword: "anyOf",
                                      params: {},
                                      message: "must match a schema in anyOf"
                                    };
                                    if (vErrors === null) {
                                      vErrors = [err6];
                                    } else {
                                      vErrors.push(err6);
                                    }
                                    errors++;
                                    validate22.errors = vErrors;
                                    return false;
                                  } else {
                                    errors = _errs24;
                                    if (vErrors !== null) {
                                      if (_errs24) {
                                        vErrors.length = _errs24;
                                      } else {
                                        vErrors = null;
                                      }
                                    }
                                  }
                                  var valid3 = _errs23 === errors;
                                } else {
                                  var valid3 = true;
                                }
                              }
                            }
                          }
                        } else {
                          validate22.errors = [{
                            instancePath: instancePath + "/priceBlock",
                            schemaPath: "PriceBlock/type",
                            keyword: "type",
                            params: {
                              type: "object"
                            },
                            message: "must be object"
                          }];
                          return false;
                        }
                      }
                      var valid0 = _errs14 === errors;
                    } else {
                      var valid0 = true;
                    }
                    if (valid0) {
                      if (data.initialPhaseDiscount !== void 0) {
                        let data13 = data.initialPhaseDiscount;
                        const _errs33 = errors;
                        const _errs34 = errors;
                        let valid6 = false;
                        const _errs35 = errors;
                        if (errors === _errs35) {
                          if (data13 && typeof data13 == "object" && !Array.isArray(data13)) {
                            let missing1;
                            if (data13.discount === void 0 && (missing1 = "discount") || data13.cycles === void 0 && (missing1 = "cycles") || data13.offerEndDate === void 0 && (missing1 = "offerEndDate") || data13.title === void 0 && (missing1 = "title") || data13.shortDescription === void 0 && (missing1 = "shortDescription")) {
                              const err7 = {
                                instancePath: instancePath + "/initialPhaseDiscount",
                                schemaPath: "#/properties/initialPhaseDiscount/anyOf/0/required",
                                keyword: "required",
                                params: {
                                  missingProperty: missing1
                                },
                                message: "must have required property '" + missing1 + "'"
                              };
                              if (vErrors === null) {
                                vErrors = [err7];
                              } else {
                                vErrors.push(err7);
                              }
                              errors++;
                            } else {
                              if (data13.discount !== void 0) {
                                let data14 = data13.discount;
                                const _errs37 = errors;
                                const _errs38 = errors;
                                let valid8 = false;
                                const _errs39 = errors;
                                if (errors === _errs39) {
                                  if (data14 && typeof data14 == "object" && !Array.isArray(data14)) {
                                    let missing2;
                                    if (data14.percentOff === void 0 && (missing2 = "percentOff")) {
                                      const err8 = {
                                        instancePath: instancePath + "/initialPhaseDiscount/discount",
                                        schemaPath: "#/properties/initialPhaseDiscount/anyOf/0/properties/discount/anyOf/0/required",
                                        keyword: "required",
                                        params: {
                                          missingProperty: missing2
                                        },
                                        message: "must have required property '" + missing2 + "'"
                                      };
                                      if (vErrors === null) {
                                        vErrors = [err8];
                                      } else {
                                        vErrors.push(err8);
                                      }
                                      errors++;
                                    } else {
                                      if (data14.percentOff !== void 0) {
                                        let data15 = data14.percentOff;
                                        if (!(typeof data15 == "number" && isFinite(data15))) {
                                          const err9 = {
                                            instancePath: instancePath + "/initialPhaseDiscount/discount/percentOff",
                                            schemaPath: "#/properties/initialPhaseDiscount/anyOf/0/properties/discount/anyOf/0/properties/percentOff/type",
                                            keyword: "type",
                                            params: {
                                              type: "number"
                                            },
                                            message: "must be number"
                                          };
                                          if (vErrors === null) {
                                            vErrors = [err9];
                                          } else {
                                            vErrors.push(err9);
                                          }
                                          errors++;
                                        }
                                      }
                                    }
                                  } else {
                                    const err10 = {
                                      instancePath: instancePath + "/initialPhaseDiscount/discount",
                                      schemaPath: "#/properties/initialPhaseDiscount/anyOf/0/properties/discount/anyOf/0/type",
                                      keyword: "type",
                                      params: {
                                        type: "object"
                                      },
                                      message: "must be object"
                                    };
                                    if (vErrors === null) {
                                      vErrors = [err10];
                                    } else {
                                      vErrors.push(err10);
                                    }
                                    errors++;
                                  }
                                }
                                var _valid2 = _errs39 === errors;
                                valid8 = valid8 || _valid2;
                                if (!valid8) {
                                  const _errs43 = errors;
                                  if (errors === _errs43) {
                                    if (data14 && typeof data14 == "object" && !Array.isArray(data14)) {
                                      let missing3;
                                      if (data14.amountOff === void 0 && (missing3 = "amountOff")) {
                                        const err11 = {
                                          instancePath: instancePath + "/initialPhaseDiscount/discount",
                                          schemaPath: "#/properties/initialPhaseDiscount/anyOf/0/properties/discount/anyOf/1/required",
                                          keyword: "required",
                                          params: {
                                            missingProperty: missing3
                                          },
                                          message: "must have required property '" + missing3 + "'"
                                        };
                                        if (vErrors === null) {
                                          vErrors = [err11];
                                        } else {
                                          vErrors.push(err11);
                                        }
                                        errors++;
                                      } else {
                                        if (data14.amountOff !== void 0) {
                                          let data16 = data14.amountOff;
                                          if (!(typeof data16 == "number" && isFinite(data16))) {
                                            const err12 = {
                                              instancePath: instancePath + "/initialPhaseDiscount/discount/amountOff",
                                              schemaPath: "#/properties/initialPhaseDiscount/anyOf/0/properties/discount/anyOf/1/properties/amountOff/type",
                                              keyword: "type",
                                              params: {
                                                type: "number"
                                              },
                                              message: "must be number"
                                            };
                                            if (vErrors === null) {
                                              vErrors = [err12];
                                            } else {
                                              vErrors.push(err12);
                                            }
                                            errors++;
                                          }
                                        }
                                      }
                                    } else {
                                      const err13 = {
                                        instancePath: instancePath + "/initialPhaseDiscount/discount",
                                        schemaPath: "#/properties/initialPhaseDiscount/anyOf/0/properties/discount/anyOf/1/type",
                                        keyword: "type",
                                        params: {
                                          type: "object"
                                        },
                                        message: "must be object"
                                      };
                                      if (vErrors === null) {
                                        vErrors = [err13];
                                      } else {
                                        vErrors.push(err13);
                                      }
                                      errors++;
                                    }
                                  }
                                  var _valid2 = _errs43 === errors;
                                  valid8 = valid8 || _valid2;
                                }
                                if (!valid8) {
                                  const err14 = {
                                    instancePath: instancePath + "/initialPhaseDiscount/discount",
                                    schemaPath: "#/properties/initialPhaseDiscount/anyOf/0/properties/discount/anyOf",
                                    keyword: "anyOf",
                                    params: {},
                                    message: "must match a schema in anyOf"
                                  };
                                  if (vErrors === null) {
                                    vErrors = [err14];
                                  } else {
                                    vErrors.push(err14);
                                  }
                                  errors++;
                                } else {
                                  errors = _errs38;
                                  if (vErrors !== null) {
                                    if (_errs38) {
                                      vErrors.length = _errs38;
                                    } else {
                                      vErrors = null;
                                    }
                                  }
                                }
                                var valid7 = _errs37 === errors;
                              } else {
                                var valid7 = true;
                              }
                              if (valid7) {
                                if (data13.cycles !== void 0) {
                                  let data17 = data13.cycles;
                                  const _errs47 = errors;
                                  const _errs48 = errors;
                                  let valid11 = false;
                                  const _errs49 = errors;
                                  if (!(typeof data17 == "number" && isFinite(data17))) {
                                    const err15 = {
                                      instancePath: instancePath + "/initialPhaseDiscount/cycles",
                                      schemaPath: "#/properties/initialPhaseDiscount/anyOf/0/properties/cycles/anyOf/0/type",
                                      keyword: "type",
                                      params: {
                                        type: "number"
                                      },
                                      message: "must be number"
                                    };
                                    if (vErrors === null) {
                                      vErrors = [err15];
                                    } else {
                                      vErrors.push(err15);
                                    }
                                    errors++;
                                  }
                                  var _valid3 = _errs49 === errors;
                                  valid11 = valid11 || _valid3;
                                  if (!valid11) {
                                    const _errs51 = errors;
                                    if (!(data17 && typeof data17 == "object" && !Array.isArray(data17))) {
                                      const err16 = {
                                        instancePath: instancePath + "/initialPhaseDiscount/cycles",
                                        schemaPath: "#/properties/initialPhaseDiscount/anyOf/0/properties/cycles/anyOf/1/type",
                                        keyword: "type",
                                        params: {
                                          type: "object"
                                        },
                                        message: "must be object"
                                      };
                                      if (vErrors === null) {
                                        vErrors = [err16];
                                      } else {
                                        vErrors.push(err16);
                                      }
                                      errors++;
                                    }
                                    if (errors === _errs51) {
                                      if (errors === _errs51) {
                                        if (typeof data17 === "string") {
                                          if (!formats0(data17)) {
                                            const err17 = {
                                              instancePath: instancePath + "/initialPhaseDiscount/cycles",
                                              schemaPath: "#/properties/initialPhaseDiscount/anyOf/0/properties/cycles/anyOf/1/format",
                                              keyword: "format",
                                              params: {
                                                format: "date-time"
                                              },
                                              message: 'must match format "date-time"'
                                            };
                                            if (vErrors === null) {
                                              vErrors = [err17];
                                            } else {
                                              vErrors.push(err17);
                                            }
                                            errors++;
                                          }
                                        }
                                      }
                                    }
                                    var _valid3 = _errs51 === errors;
                                    valid11 = valid11 || _valid3;
                                  }
                                  if (!valid11) {
                                    const err18 = {
                                      instancePath: instancePath + "/initialPhaseDiscount/cycles",
                                      schemaPath: "#/properties/initialPhaseDiscount/anyOf/0/properties/cycles/anyOf",
                                      keyword: "anyOf",
                                      params: {},
                                      message: "must match a schema in anyOf"
                                    };
                                    if (vErrors === null) {
                                      vErrors = [err18];
                                    } else {
                                      vErrors.push(err18);
                                    }
                                    errors++;
                                  } else {
                                    errors = _errs48;
                                    if (vErrors !== null) {
                                      if (_errs48) {
                                        vErrors.length = _errs48;
                                      } else {
                                        vErrors = null;
                                      }
                                    }
                                  }
                                  var valid7 = _errs47 === errors;
                                } else {
                                  var valid7 = true;
                                }
                                if (valid7) {
                                  if (data13.offerEndDate !== void 0) {
                                    let data18 = data13.offerEndDate;
                                    const _errs53 = errors;
                                    const _errs54 = errors;
                                    let valid12 = false;
                                    const _errs55 = errors;
                                    if (!(data18 && typeof data18 == "object" && !Array.isArray(data18))) {
                                      const err19 = {
                                        instancePath: instancePath + "/initialPhaseDiscount/offerEndDate",
                                        schemaPath: "#/properties/initialPhaseDiscount/anyOf/0/properties/offerEndDate/anyOf/0/type",
                                        keyword: "type",
                                        params: {
                                          type: "object"
                                        },
                                        message: "must be object"
                                      };
                                      if (vErrors === null) {
                                        vErrors = [err19];
                                      } else {
                                        vErrors.push(err19);
                                      }
                                      errors++;
                                    }
                                    if (errors === _errs55) {
                                      if (errors === _errs55) {
                                        if (typeof data18 === "string") {
                                          if (!formats0(data18)) {
                                            const err20 = {
                                              instancePath: instancePath + "/initialPhaseDiscount/offerEndDate",
                                              schemaPath: "#/properties/initialPhaseDiscount/anyOf/0/properties/offerEndDate/anyOf/0/format",
                                              keyword: "format",
                                              params: {
                                                format: "date-time"
                                              },
                                              message: 'must match format "date-time"'
                                            };
                                            if (vErrors === null) {
                                              vErrors = [err20];
                                            } else {
                                              vErrors.push(err20);
                                            }
                                            errors++;
                                          }
                                        }
                                      }
                                    }
                                    var _valid4 = _errs55 === errors;
                                    valid12 = valid12 || _valid4;
                                    if (!valid12) {
                                      const _errs57 = errors;
                                      if (data18 !== null) {
                                        const err21 = {
                                          instancePath: instancePath + "/initialPhaseDiscount/offerEndDate",
                                          schemaPath: "#/properties/initialPhaseDiscount/anyOf/0/properties/offerEndDate/anyOf/1/type",
                                          keyword: "type",
                                          params: {
                                            type: "null"
                                          },
                                          message: "must be null"
                                        };
                                        if (vErrors === null) {
                                          vErrors = [err21];
                                        } else {
                                          vErrors.push(err21);
                                        }
                                        errors++;
                                      }
                                      var _valid4 = _errs57 === errors;
                                      valid12 = valid12 || _valid4;
                                    }
                                    if (!valid12) {
                                      const err22 = {
                                        instancePath: instancePath + "/initialPhaseDiscount/offerEndDate",
                                        schemaPath: "#/properties/initialPhaseDiscount/anyOf/0/properties/offerEndDate/anyOf",
                                        keyword: "anyOf",
                                        params: {},
                                        message: "must match a schema in anyOf"
                                      };
                                      if (vErrors === null) {
                                        vErrors = [err22];
                                      } else {
                                        vErrors.push(err22);
                                      }
                                      errors++;
                                    } else {
                                      errors = _errs54;
                                      if (vErrors !== null) {
                                        if (_errs54) {
                                          vErrors.length = _errs54;
                                        } else {
                                          vErrors = null;
                                        }
                                      }
                                    }
                                    var valid7 = _errs53 === errors;
                                  } else {
                                    var valid7 = true;
                                  }
                                  if (valid7) {
                                    if (data13.title !== void 0) {
                                      const _errs59 = errors;
                                      if (typeof data13.title !== "string") {
                                        const err23 = {
                                          instancePath: instancePath + "/initialPhaseDiscount/title",
                                          schemaPath: "#/properties/initialPhaseDiscount/anyOf/0/properties/title/type",
                                          keyword: "type",
                                          params: {
                                            type: "string"
                                          },
                                          message: "must be string"
                                        };
                                        if (vErrors === null) {
                                          vErrors = [err23];
                                        } else {
                                          vErrors.push(err23);
                                        }
                                        errors++;
                                      }
                                      var valid7 = _errs59 === errors;
                                    } else {
                                      var valid7 = true;
                                    }
                                    if (valid7) {
                                      if (data13.shortDescription !== void 0) {
                                        const _errs61 = errors;
                                        if (typeof data13.shortDescription !== "string") {
                                          const err24 = {
                                            instancePath: instancePath + "/initialPhaseDiscount/shortDescription",
                                            schemaPath: "#/properties/initialPhaseDiscount/anyOf/0/properties/shortDescription/type",
                                            keyword: "type",
                                            params: {
                                              type: "string"
                                            },
                                            message: "must be string"
                                          };
                                          if (vErrors === null) {
                                            vErrors = [err24];
                                          } else {
                                            vErrors.push(err24);
                                          }
                                          errors++;
                                        }
                                        var valid7 = _errs61 === errors;
                                      } else {
                                        var valid7 = true;
                                      }
                                      if (valid7) {
                                        if (data13.overrides !== void 0) {
                                          let data21 = data13.overrides;
                                          const _errs63 = errors;
                                          if (errors === _errs63) {
                                            if (data21 && typeof data21 == "object" && !Array.isArray(data21)) {
                                              if (data21.discountLabel !== void 0) {
                                                const _errs65 = errors;
                                                if (typeof data21.discountLabel !== "string") {
                                                  const err25 = {
                                                    instancePath: instancePath + "/initialPhaseDiscount/overrides/discountLabel",
                                                    schemaPath: "#/properties/initialPhaseDiscount/anyOf/0/properties/overrides/properties/discountLabel/type",
                                                    keyword: "type",
                                                    params: {
                                                      type: "string"
                                                    },
                                                    message: "must be string"
                                                  };
                                                  if (vErrors === null) {
                                                    vErrors = [err25];
                                                  } else {
                                                    vErrors.push(err25);
                                                  }
                                                  errors++;
                                                }
                                                var valid13 = _errs65 === errors;
                                              } else {
                                                var valid13 = true;
                                              }
                                              if (valid13) {
                                                if (data21.discountDescription !== void 0) {
                                                  const _errs67 = errors;
                                                  if (typeof data21.discountDescription !== "string") {
                                                    const err26 = {
                                                      instancePath: instancePath + "/initialPhaseDiscount/overrides/discountDescription",
                                                      schemaPath: "#/properties/initialPhaseDiscount/anyOf/0/properties/overrides/properties/discountDescription/type",
                                                      keyword: "type",
                                                      params: {
                                                        type: "string"
                                                      },
                                                      message: "must be string"
                                                    };
                                                    if (vErrors === null) {
                                                      vErrors = [err26];
                                                    } else {
                                                      vErrors.push(err26);
                                                    }
                                                    errors++;
                                                  }
                                                  var valid13 = _errs67 === errors;
                                                } else {
                                                  var valid13 = true;
                                                }
                                                if (valid13) {
                                                  if (data21.priceBlock !== void 0) {
                                                    let data24 = data21.priceBlock;
                                                    const _errs69 = errors;
                                                    const _errs70 = errors;
                                                    if (errors === _errs70) {
                                                      if (data24 && typeof data24 == "object" && !Array.isArray(data24)) {
                                                        if (data24.discountTag !== void 0) {
                                                          const _errs72 = errors;
                                                          if (typeof data24.discountTag !== "string") {
                                                            const err27 = {
                                                              instancePath: instancePath + "/initialPhaseDiscount/overrides/priceBlock/discountTag",
                                                              schemaPath: "PriceBlock/properties/discountTag/type",
                                                              keyword: "type",
                                                              params: {
                                                                type: "string"
                                                              },
                                                              message: "must be string"
                                                            };
                                                            if (vErrors === null) {
                                                              vErrors = [err27];
                                                            } else {
                                                              vErrors.push(err27);
                                                            }
                                                            errors++;
                                                          }
                                                          var valid15 = _errs72 === errors;
                                                        } else {
                                                          var valid15 = true;
                                                        }
                                                        if (valid15) {
                                                          if (data24.label !== void 0) {
                                                            const _errs74 = errors;
                                                            if (typeof data24.label !== "string") {
                                                              const err28 = {
                                                                instancePath: instancePath + "/initialPhaseDiscount/overrides/priceBlock/label",
                                                                schemaPath: "PriceBlock/properties/label/type",
                                                                keyword: "type",
                                                                params: {
                                                                  type: "string"
                                                                },
                                                                message: "must be string"
                                                              };
                                                              if (vErrors === null) {
                                                                vErrors = [err28];
                                                              } else {
                                                                vErrors.push(err28);
                                                              }
                                                              errors++;
                                                            }
                                                            var valid15 = _errs74 === errors;
                                                          } else {
                                                            var valid15 = true;
                                                          }
                                                          if (valid15) {
                                                            if (data24.details !== void 0) {
                                                              const _errs76 = errors;
                                                              if (typeof data24.details !== "string") {
                                                                const err29 = {
                                                                  instancePath: instancePath + "/initialPhaseDiscount/overrides/priceBlock/details",
                                                                  schemaPath: "PriceBlock/properties/details/type",
                                                                  keyword: "type",
                                                                  params: {
                                                                    type: "string"
                                                                  },
                                                                  message: "must be string"
                                                                };
                                                                if (vErrors === null) {
                                                                  vErrors = [err29];
                                                                } else {
                                                                  vErrors.push(err29);
                                                                }
                                                                errors++;
                                                              }
                                                              var valid15 = _errs76 === errors;
                                                            } else {
                                                              var valid15 = true;
                                                            }
                                                            if (valid15) {
                                                              if (data24.action !== void 0) {
                                                                let data28 = data24.action;
                                                                const _errs78 = errors;
                                                                const _errs79 = errors;
                                                                let valid16 = false;
                                                                const _errs80 = errors;
                                                                if (typeof data28 !== "string") {
                                                                  const err30 = {
                                                                    instancePath: instancePath + "/initialPhaseDiscount/overrides/priceBlock/action",
                                                                    schemaPath: "PriceBlock/properties/action/anyOf/0/type",
                                                                    keyword: "type",
                                                                    params: {
                                                                      type: "string"
                                                                    },
                                                                    message: "must be string"
                                                                  };
                                                                  if (vErrors === null) {
                                                                    vErrors = [err30];
                                                                  } else {
                                                                    vErrors.push(err30);
                                                                  }
                                                                  errors++;
                                                                }
                                                                var _valid5 = _errs80 === errors;
                                                                valid16 = valid16 || _valid5;
                                                                if (!valid16) {
                                                                  const _errs82 = errors;
                                                                  if (errors === _errs82) {
                                                                    if (Array.isArray(data28)) {
                                                                      if (data28.length > 2) {
                                                                        const err31 = {
                                                                          instancePath: instancePath + "/initialPhaseDiscount/overrides/priceBlock/action",
                                                                          schemaPath: "PriceBlock/properties/action/anyOf/1/maxItems",
                                                                          keyword: "maxItems",
                                                                          params: {
                                                                            limit: 2
                                                                          },
                                                                          message: "must NOT have more than 2 items"
                                                                        };
                                                                        if (vErrors === null) {
                                                                          vErrors = [err31];
                                                                        } else {
                                                                          vErrors.push(err31);
                                                                        }
                                                                        errors++;
                                                                      } else {
                                                                        if (data28.length < 2) {
                                                                          const err32 = {
                                                                            instancePath: instancePath + "/initialPhaseDiscount/overrides/priceBlock/action",
                                                                            schemaPath: "PriceBlock/properties/action/anyOf/1/minItems",
                                                                            keyword: "minItems",
                                                                            params: {
                                                                              limit: 2
                                                                            },
                                                                            message: "must NOT have fewer than 2 items"
                                                                          };
                                                                          if (vErrors === null) {
                                                                            vErrors = [err32];
                                                                          } else {
                                                                            vErrors.push(err32);
                                                                          }
                                                                          errors++;
                                                                        } else {
                                                                          const len1 = data28.length;
                                                                          if (len1 > 0) {
                                                                            const _errs84 = errors;
                                                                            if (typeof data28[0] !== "string") {
                                                                              const err33 = {
                                                                                instancePath: instancePath + "/initialPhaseDiscount/overrides/priceBlock/action/0",
                                                                                schemaPath: "PriceBlock/properties/action/anyOf/1/items/0/type",
                                                                                keyword: "type",
                                                                                params: {
                                                                                  type: "string"
                                                                                },
                                                                                message: "must be string"
                                                                              };
                                                                              if (vErrors === null) {
                                                                                vErrors = [err33];
                                                                              } else {
                                                                                vErrors.push(err33);
                                                                              }
                                                                              errors++;
                                                                            }
                                                                            var valid17 = _errs84 === errors;
                                                                          }
                                                                          if (valid17) {
                                                                            if (len1 > 1) {
                                                                              let data30 = data28[1];
                                                                              const _errs86 = errors;
                                                                              if (!(typeof data30 == "number" && isFinite(data30))) {
                                                                                const err34 = {
                                                                                  instancePath: instancePath + "/initialPhaseDiscount/overrides/priceBlock/action/1",
                                                                                  schemaPath: "PriceBlock/properties/action/anyOf/1/items/1/type",
                                                                                  keyword: "type",
                                                                                  params: {
                                                                                    type: "number"
                                                                                  },
                                                                                  message: "must be number"
                                                                                };
                                                                                if (vErrors === null) {
                                                                                  vErrors = [err34];
                                                                                } else {
                                                                                  vErrors.push(err34);
                                                                                }
                                                                                errors++;
                                                                              }
                                                                              var valid17 = _errs86 === errors;
                                                                            }
                                                                          }
                                                                        }
                                                                      }
                                                                    } else {
                                                                      const err35 = {
                                                                        instancePath: instancePath + "/initialPhaseDiscount/overrides/priceBlock/action",
                                                                        schemaPath: "PriceBlock/properties/action/anyOf/1/type",
                                                                        keyword: "type",
                                                                        params: {
                                                                          type: "array"
                                                                        },
                                                                        message: "must be array"
                                                                      };
                                                                      if (vErrors === null) {
                                                                        vErrors = [err35];
                                                                      } else {
                                                                        vErrors.push(err35);
                                                                      }
                                                                      errors++;
                                                                    }
                                                                  }
                                                                  var _valid5 = _errs82 === errors;
                                                                  valid16 = valid16 || _valid5;
                                                                }
                                                                if (!valid16) {
                                                                  const err36 = {
                                                                    instancePath: instancePath + "/initialPhaseDiscount/overrides/priceBlock/action",
                                                                    schemaPath: "PriceBlock/properties/action/anyOf",
                                                                    keyword: "anyOf",
                                                                    params: {},
                                                                    message: "must match a schema in anyOf"
                                                                  };
                                                                  if (vErrors === null) {
                                                                    vErrors = [err36];
                                                                  } else {
                                                                    vErrors.push(err36);
                                                                  }
                                                                  errors++;
                                                                } else {
                                                                  errors = _errs79;
                                                                  if (vErrors !== null) {
                                                                    if (_errs79) {
                                                                      vErrors.length = _errs79;
                                                                    } else {
                                                                      vErrors = null;
                                                                    }
                                                                  }
                                                                }
                                                                var valid15 = _errs78 === errors;
                                                              } else {
                                                                var valid15 = true;
                                                              }
                                                            }
                                                          }
                                                        }
                                                      } else {
                                                        const err37 = {
                                                          instancePath: instancePath + "/initialPhaseDiscount/overrides/priceBlock",
                                                          schemaPath: "PriceBlock/type",
                                                          keyword: "type",
                                                          params: {
                                                            type: "object"
                                                          },
                                                          message: "must be object"
                                                        };
                                                        if (vErrors === null) {
                                                          vErrors = [err37];
                                                        } else {
                                                          vErrors.push(err37);
                                                        }
                                                        errors++;
                                                      }
                                                    }
                                                    var valid13 = _errs69 === errors;
                                                  } else {
                                                    var valid13 = true;
                                                  }
                                                }
                                              }
                                            } else {
                                              const err38 = {
                                                instancePath: instancePath + "/initialPhaseDiscount/overrides",
                                                schemaPath: "#/properties/initialPhaseDiscount/anyOf/0/properties/overrides/type",
                                                keyword: "type",
                                                params: {
                                                  type: "object"
                                                },
                                                message: "must be object"
                                              };
                                              if (vErrors === null) {
                                                vErrors = [err38];
                                              } else {
                                                vErrors.push(err38);
                                              }
                                              errors++;
                                            }
                                          }
                                          var valid7 = _errs63 === errors;
                                        } else {
                                          var valid7 = true;
                                        }
                                        if (valid7) {
                                          if (data13.allowedForInstallments !== void 0) {
                                            let data31 = data13.allowedForInstallments;
                                            const _errs88 = errors;
                                            if (typeof data31 !== "boolean") {
                                              const err39 = {
                                                instancePath: instancePath + "/initialPhaseDiscount/allowedForInstallments",
                                                schemaPath: "#/properties/initialPhaseDiscount/anyOf/0/properties/allowedForInstallments/type",
                                                keyword: "type",
                                                params: {
                                                  type: "boolean"
                                                },
                                                message: "must be boolean"
                                              };
                                              if (vErrors === null) {
                                                vErrors = [err39];
                                              } else {
                                                vErrors.push(err39);
                                              }
                                              errors++;
                                            }
                                            if (false !== data31) {
                                              const err40 = {
                                                instancePath: instancePath + "/initialPhaseDiscount/allowedForInstallments",
                                                schemaPath: "#/properties/initialPhaseDiscount/anyOf/0/properties/allowedForInstallments/const",
                                                keyword: "const",
                                                params: {
                                                  allowedValue: false
                                                },
                                                message: "must be equal to constant"
                                              };
                                              if (vErrors === null) {
                                                vErrors = [err40];
                                              } else {
                                                vErrors.push(err40);
                                              }
                                              errors++;
                                            }
                                            var valid7 = _errs88 === errors;
                                          } else {
                                            var valid7 = true;
                                          }
                                        }
                                      }
                                    }
                                  }
                                }
                              }
                            }
                          } else {
                            const err41 = {
                              instancePath: instancePath + "/initialPhaseDiscount",
                              schemaPath: "#/properties/initialPhaseDiscount/anyOf/0/type",
                              keyword: "type",
                              params: {
                                type: "object"
                              },
                              message: "must be object"
                            };
                            if (vErrors === null) {
                              vErrors = [err41];
                            } else {
                              vErrors.push(err41);
                            }
                            errors++;
                          }
                        }
                        var _valid1 = _errs35 === errors;
                        valid6 = valid6 || _valid1;
                        if (!valid6) {
                          const _errs90 = errors;
                          if (data13 !== null) {
                            const err42 = {
                              instancePath: instancePath + "/initialPhaseDiscount",
                              schemaPath: "#/properties/initialPhaseDiscount/anyOf/1/type",
                              keyword: "type",
                              params: {
                                type: "null"
                              },
                              message: "must be null"
                            };
                            if (vErrors === null) {
                              vErrors = [err42];
                            } else {
                              vErrors.push(err42);
                            }
                            errors++;
                          }
                          var _valid1 = _errs90 === errors;
                          valid6 = valid6 || _valid1;
                        }
                        if (!valid6) {
                          const err43 = {
                            instancePath: instancePath + "/initialPhaseDiscount",
                            schemaPath: "#/properties/initialPhaseDiscount/anyOf",
                            keyword: "anyOf",
                            params: {},
                            message: "must match a schema in anyOf"
                          };
                          if (vErrors === null) {
                            vErrors = [err43];
                          } else {
                            vErrors.push(err43);
                          }
                          errors++;
                          validate22.errors = vErrors;
                          return false;
                        } else {
                          errors = _errs34;
                          if (vErrors !== null) {
                            if (_errs34) {
                              vErrors.length = _errs34;
                            } else {
                              vErrors = null;
                            }
                          }
                        }
                        var valid0 = _errs33 === errors;
                      } else {
                        var valid0 = true;
                      }
                      if (valid0) {
                        if (data.allowPromoCodes !== void 0) {
                          const _errs92 = errors;
                          if (typeof data.allowPromoCodes !== "boolean") {
                            validate22.errors = [{
                              instancePath: instancePath + "/allowPromoCodes",
                              schemaPath: "#/properties/allowPromoCodes/type",
                              keyword: "type",
                              params: {
                                type: "boolean"
                              },
                              message: "must be boolean"
                            }];
                            return false;
                          }
                          var valid0 = _errs92 === errors;
                        } else {
                          var valid0 = true;
                        }
                        if (valid0) {
                          if (data.pauseBehaviour !== void 0) {
                            let data33 = data.pauseBehaviour;
                            const _errs94 = errors;
                            const _errs95 = errors;
                            if (errors === _errs95) {
                              if (data33 && typeof data33 == "object" && !Array.isArray(data33)) {
                                let missing4;
                                if (data33.periods === void 0 && (missing4 = "periods") || data33.onceEvery === void 0 && (missing4 = "onceEvery") || data33.canUnpause === void 0 && (missing4 = "canUnpause") || data33.texts === void 0 && (missing4 = "texts")) {
                                  validate22.errors = [{
                                    instancePath: instancePath + "/pauseBehaviour",
                                    schemaPath: "PauseBehaviour/required",
                                    keyword: "required",
                                    params: {
                                      missingProperty: missing4
                                    },
                                    message: "must have required property '" + missing4 + "'"
                                  }];
                                  return false;
                                } else {
                                  if (data33.periods !== void 0) {
                                    let data34 = data33.periods;
                                    const _errs97 = errors;
                                    if (errors === _errs97) {
                                      if (Array.isArray(data34)) {
                                        var valid20 = true;
                                        const len2 = data34.length;
                                        for (let i0 = 0; i0 < len2; i0++) {
                                          let data35 = data34[i0];
                                          const _errs99 = errors;
                                          if (errors === _errs99) {
                                            if (data35 && typeof data35 == "object" && !Array.isArray(data35)) {
                                              let missing5;
                                              if (data35.period === void 0 && (missing5 = "period") || data35.label === void 0 && (missing5 = "label")) {
                                                validate22.errors = [{
                                                  instancePath: instancePath + "/pauseBehaviour/periods/" + i0,
                                                  schemaPath: "PauseBehaviour/properties/periods/items/required",
                                                  keyword: "required",
                                                  params: {
                                                    missingProperty: missing5
                                                  },
                                                  message: "must have required property '" + missing5 + "'"
                                                }];
                                                return false;
                                              } else {
                                                if (data35.period !== void 0) {
                                                  let data36 = data35.period;
                                                  const _errs101 = errors;
                                                  const _errs102 = errors;
                                                  let valid22 = false;
                                                  const _errs103 = errors;
                                                  if (!(typeof data36 == "number" && isFinite(data36))) {
                                                    const err44 = {
                                                      instancePath: instancePath + "/pauseBehaviour/periods/" + i0 + "/period",
                                                      schemaPath: "PauseBehaviour/properties/periods/items/properties/period/anyOf/0/type",
                                                      keyword: "type",
                                                      params: {
                                                        type: "number"
                                                      },
                                                      message: "must be number"
                                                    };
                                                    if (vErrors === null) {
                                                      vErrors = [err44];
                                                    } else {
                                                      vErrors.push(err44);
                                                    }
                                                    errors++;
                                                  }
                                                  var _valid6 = _errs103 === errors;
                                                  valid22 = valid22 || _valid6;
                                                  if (!valid22) {
                                                    const _errs105 = errors;
                                                    if (!(data36 && typeof data36 == "object" && !Array.isArray(data36))) {
                                                      const err45 = {
                                                        instancePath: instancePath + "/pauseBehaviour/periods/" + i0 + "/period",
                                                        schemaPath: "PauseBehaviour/properties/periods/items/properties/period/anyOf/1/type",
                                                        keyword: "type",
                                                        params: {
                                                          type: "object"
                                                        },
                                                        message: "must be object"
                                                      };
                                                      if (vErrors === null) {
                                                        vErrors = [err45];
                                                      } else {
                                                        vErrors.push(err45);
                                                      }
                                                      errors++;
                                                    }
                                                    if (errors === _errs105) {
                                                      if (errors === _errs105) {
                                                        if (typeof data36 === "string") {
                                                          if (!formats0(data36)) {
                                                            const err46 = {
                                                              instancePath: instancePath + "/pauseBehaviour/periods/" + i0 + "/period",
                                                              schemaPath: "PauseBehaviour/properties/periods/items/properties/period/anyOf/1/format",
                                                              keyword: "format",
                                                              params: {
                                                                format: "date-time"
                                                              },
                                                              message: 'must match format "date-time"'
                                                            };
                                                            if (vErrors === null) {
                                                              vErrors = [err46];
                                                            } else {
                                                              vErrors.push(err46);
                                                            }
                                                            errors++;
                                                          }
                                                        }
                                                      }
                                                    }
                                                    var _valid6 = _errs105 === errors;
                                                    valid22 = valid22 || _valid6;
                                                  }
                                                  if (!valid22) {
                                                    const err47 = {
                                                      instancePath: instancePath + "/pauseBehaviour/periods/" + i0 + "/period",
                                                      schemaPath: "PauseBehaviour/properties/periods/items/properties/period/anyOf",
                                                      keyword: "anyOf",
                                                      params: {},
                                                      message: "must match a schema in anyOf"
                                                    };
                                                    if (vErrors === null) {
                                                      vErrors = [err47];
                                                    } else {
                                                      vErrors.push(err47);
                                                    }
                                                    errors++;
                                                    validate22.errors = vErrors;
                                                    return false;
                                                  } else {
                                                    errors = _errs102;
                                                    if (vErrors !== null) {
                                                      if (_errs102) {
                                                        vErrors.length = _errs102;
                                                      } else {
                                                        vErrors = null;
                                                      }
                                                    }
                                                  }
                                                  var valid21 = _errs101 === errors;
                                                } else {
                                                  var valid21 = true;
                                                }
                                                if (valid21) {
                                                  if (data35.label !== void 0) {
                                                    const _errs107 = errors;
                                                    if (typeof data35.label !== "string") {
                                                      validate22.errors = [{
                                                        instancePath: instancePath + "/pauseBehaviour/periods/" + i0 + "/label",
                                                        schemaPath: "PauseBehaviour/properties/periods/items/properties/label/type",
                                                        keyword: "type",
                                                        params: {
                                                          type: "string"
                                                        },
                                                        message: "must be string"
                                                      }];
                                                      return false;
                                                    }
                                                    var valid21 = _errs107 === errors;
                                                  } else {
                                                    var valid21 = true;
                                                  }
                                                }
                                              }
                                            } else {
                                              validate22.errors = [{
                                                instancePath: instancePath + "/pauseBehaviour/periods/" + i0,
                                                schemaPath: "PauseBehaviour/properties/periods/items/type",
                                                keyword: "type",
                                                params: {
                                                  type: "object"
                                                },
                                                message: "must be object"
                                              }];
                                              return false;
                                            }
                                          }
                                          var valid20 = _errs99 === errors;
                                          if (!valid20) {
                                            break;
                                          }
                                        }
                                      } else {
                                        validate22.errors = [{
                                          instancePath: instancePath + "/pauseBehaviour/periods",
                                          schemaPath: "PauseBehaviour/properties/periods/type",
                                          keyword: "type",
                                          params: {
                                            type: "array"
                                          },
                                          message: "must be array"
                                        }];
                                        return false;
                                      }
                                    }
                                    var valid19 = _errs97 === errors;
                                  } else {
                                    var valid19 = true;
                                  }
                                  if (valid19) {
                                    if (data33.onceEvery !== void 0) {
                                      let data38 = data33.onceEvery;
                                      const _errs109 = errors;
                                      if (!(typeof data38 == "number" && isFinite(data38))) {
                                        validate22.errors = [{
                                          instancePath: instancePath + "/pauseBehaviour/onceEvery",
                                          schemaPath: "PauseBehaviour/properties/onceEvery/type",
                                          keyword: "type",
                                          params: {
                                            type: "number"
                                          },
                                          message: "must be number"
                                        }];
                                        return false;
                                      }
                                      var valid19 = _errs109 === errors;
                                    } else {
                                      var valid19 = true;
                                    }
                                    if (valid19) {
                                      if (data33.canUnpause !== void 0) {
                                        const _errs111 = errors;
                                        if (typeof data33.canUnpause !== "boolean") {
                                          validate22.errors = [{
                                            instancePath: instancePath + "/pauseBehaviour/canUnpause",
                                            schemaPath: "PauseBehaviour/properties/canUnpause/type",
                                            keyword: "type",
                                            params: {
                                              type: "boolean"
                                            },
                                            message: "must be boolean"
                                          }];
                                          return false;
                                        }
                                        var valid19 = _errs111 === errors;
                                      } else {
                                        var valid19 = true;
                                      }
                                      if (valid19) {
                                        if (data33.texts !== void 0) {
                                          let data40 = data33.texts;
                                          const _errs113 = errors;
                                          if (errors === _errs113) {
                                            if (data40 && typeof data40 == "object" && !Array.isArray(data40)) {
                                              let missing6;
                                              if (data40.header === void 0 && (missing6 = "header") || data40.pros === void 0 && (missing6 = "pros")) {
                                                validate22.errors = [{
                                                  instancePath: instancePath + "/pauseBehaviour/texts",
                                                  schemaPath: "PauseBehaviour/properties/texts/required",
                                                  keyword: "required",
                                                  params: {
                                                    missingProperty: missing6
                                                  },
                                                  message: "must have required property '" + missing6 + "'"
                                                }];
                                                return false;
                                              } else {
                                                if (data40.header !== void 0) {
                                                  const _errs115 = errors;
                                                  if (typeof data40.header !== "string") {
                                                    validate22.errors = [{
                                                      instancePath: instancePath + "/pauseBehaviour/texts/header",
                                                      schemaPath: "PauseBehaviour/properties/texts/properties/header/type",
                                                      keyword: "type",
                                                      params: {
                                                        type: "string"
                                                      },
                                                      message: "must be string"
                                                    }];
                                                    return false;
                                                  }
                                                  var valid23 = _errs115 === errors;
                                                } else {
                                                  var valid23 = true;
                                                }
                                                if (valid23) {
                                                  if (data40.pros !== void 0) {
                                                    let data42 = data40.pros;
                                                    const _errs117 = errors;
                                                    if (errors === _errs117) {
                                                      if (Array.isArray(data42)) {
                                                        var valid24 = true;
                                                        const len3 = data42.length;
                                                        for (let i1 = 0; i1 < len3; i1++) {
                                                          const _errs119 = errors;
                                                          if (typeof data42[i1] !== "string") {
                                                            validate22.errors = [{
                                                              instancePath: instancePath + "/pauseBehaviour/texts/pros/" + i1,
                                                              schemaPath: "PauseBehaviour/properties/texts/properties/pros/items/type",
                                                              keyword: "type",
                                                              params: {
                                                                type: "string"
                                                              },
                                                              message: "must be string"
                                                            }];
                                                            return false;
                                                          }
                                                          var valid24 = _errs119 === errors;
                                                          if (!valid24) {
                                                            break;
                                                          }
                                                        }
                                                      } else {
                                                        validate22.errors = [{
                                                          instancePath: instancePath + "/pauseBehaviour/texts/pros",
                                                          schemaPath: "PauseBehaviour/properties/texts/properties/pros/type",
                                                          keyword: "type",
                                                          params: {
                                                            type: "array"
                                                          },
                                                          message: "must be array"
                                                        }];
                                                        return false;
                                                      }
                                                    }
                                                    var valid23 = _errs117 === errors;
                                                  } else {
                                                    var valid23 = true;
                                                  }
                                                  if (valid23) {
                                                    if (data40.promoBlock !== void 0) {
                                                      let data44 = data40.promoBlock;
                                                      const _errs121 = errors;
                                                      if (errors === _errs121) {
                                                        if (data44 && typeof data44 == "object" && !Array.isArray(data44)) {
                                                          let missing7;
                                                          if (data44.title === void 0 && (missing7 = "title") || data44.description === void 0 && (missing7 = "description")) {
                                                            validate22.errors = [{
                                                              instancePath: instancePath + "/pauseBehaviour/texts/promoBlock",
                                                              schemaPath: "PauseBehaviour/properties/texts/properties/promoBlock/required",
                                                              keyword: "required",
                                                              params: {
                                                                missingProperty: missing7
                                                              },
                                                              message: "must have required property '" + missing7 + "'"
                                                            }];
                                                            return false;
                                                          } else {
                                                            if (data44.imageUrl !== void 0) {
                                                              const _errs123 = errors;
                                                              if (typeof data44.imageUrl !== "string") {
                                                                validate22.errors = [{
                                                                  instancePath: instancePath + "/pauseBehaviour/texts/promoBlock/imageUrl",
                                                                  schemaPath: "PauseBehaviour/properties/texts/properties/promoBlock/properties/imageUrl/type",
                                                                  keyword: "type",
                                                                  params: {
                                                                    type: "string"
                                                                  },
                                                                  message: "must be string"
                                                                }];
                                                                return false;
                                                              }
                                                              var valid25 = _errs123 === errors;
                                                            } else {
                                                              var valid25 = true;
                                                            }
                                                            if (valid25) {
                                                              if (data44.title !== void 0) {
                                                                const _errs125 = errors;
                                                                if (typeof data44.title !== "string") {
                                                                  validate22.errors = [{
                                                                    instancePath: instancePath + "/pauseBehaviour/texts/promoBlock/title",
                                                                    schemaPath: "PauseBehaviour/properties/texts/properties/promoBlock/properties/title/type",
                                                                    keyword: "type",
                                                                    params: {
                                                                      type: "string"
                                                                    },
                                                                    message: "must be string"
                                                                  }];
                                                                  return false;
                                                                }
                                                                var valid25 = _errs125 === errors;
                                                              } else {
                                                                var valid25 = true;
                                                              }
                                                              if (valid25) {
                                                                if (data44.description !== void 0) {
                                                                  const _errs127 = errors;
                                                                  if (typeof data44.description !== "string") {
                                                                    validate22.errors = [{
                                                                      instancePath: instancePath + "/pauseBehaviour/texts/promoBlock/description",
                                                                      schemaPath: "PauseBehaviour/properties/texts/properties/promoBlock/properties/description/type",
                                                                      keyword: "type",
                                                                      params: {
                                                                        type: "string"
                                                                      },
                                                                      message: "must be string"
                                                                    }];
                                                                    return false;
                                                                  }
                                                                  var valid25 = _errs127 === errors;
                                                                } else {
                                                                  var valid25 = true;
                                                                }
                                                              }
                                                            }
                                                          }
                                                        } else {
                                                          validate22.errors = [{
                                                            instancePath: instancePath + "/pauseBehaviour/texts/promoBlock",
                                                            schemaPath: "PauseBehaviour/properties/texts/properties/promoBlock/type",
                                                            keyword: "type",
                                                            params: {
                                                              type: "object"
                                                            },
                                                            message: "must be object"
                                                          }];
                                                          return false;
                                                        }
                                                      }
                                                      var valid23 = _errs121 === errors;
                                                    } else {
                                                      var valid23 = true;
                                                    }
                                                  }
                                                }
                                              }
                                            } else {
                                              validate22.errors = [{
                                                instancePath: instancePath + "/pauseBehaviour/texts",
                                                schemaPath: "PauseBehaviour/properties/texts/type",
                                                keyword: "type",
                                                params: {
                                                  type: "object"
                                                },
                                                message: "must be object"
                                              }];
                                              return false;
                                            }
                                          }
                                          var valid19 = _errs113 === errors;
                                        } else {
                                          var valid19 = true;
                                        }
                                      }
                                    }
                                  }
                                }
                              } else {
                                validate22.errors = [{
                                  instancePath: instancePath + "/pauseBehaviour",
                                  schemaPath: "PauseBehaviour/type",
                                  keyword: "type",
                                  params: {
                                    type: "object"
                                  },
                                  message: "must be object"
                                }];
                                return false;
                              }
                            }
                            var valid0 = _errs94 === errors;
                          } else {
                            var valid0 = true;
                          }
                          if (valid0) {
                            if (data.installments !== void 0) {
                              const _errs129 = errors;
                              if (!validate20(data.installments, {
                                instancePath: instancePath + "/installments",
                                parentData: data,
                                parentDataProperty: "installments",
                                rootData
                              })) {
                                vErrors = vErrors === null ? validate20.errors : vErrors.concat(validate20.errors);
                                errors = vErrors.length;
                              }
                              var valid0 = _errs129 === errors;
                            } else {
                              var valid0 = true;
                            }
                          }
                        }
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
    } else {
      validate22.errors = [{
        instancePath,
        schemaPath: "#/type",
        keyword: "type",
        params: {
          type: "object"
        },
        message: "must be object"
      }];
      return false;
    }
  }
  validate22.errors = vErrors;
  return errors === 0;
}
const PlanPrice = validate24;
function validate24(data, {
  instancePath = "",
  parentData,
  parentDataProperty,
  rootData = data
} = {}) {
  let vErrors = null;
  let errors = 0;
  if (errors === 0) {
    if (data && typeof data == "object" && !Array.isArray(data)) {
      let missing0;
      if (data.currency === void 0 && (missing0 = "currency") || data.billingPeriods === void 0 && (missing0 = "billingPeriods")) {
        validate24.errors = [{
          instancePath,
          schemaPath: "#/required",
          keyword: "required",
          params: {
            missingProperty: missing0
          },
          message: "must have required property '" + missing0 + "'"
        }];
        return false;
      } else {
        if (data.currency !== void 0) {
          const _errs1 = errors;
          if (typeof data.currency !== "string") {
            validate24.errors = [{
              instancePath: instancePath + "/currency",
              schemaPath: "#/properties/currency/type",
              keyword: "type",
              params: {
                type: "string"
              },
              message: "must be string"
            }];
            return false;
          }
          var valid0 = _errs1 === errors;
        } else {
          var valid0 = true;
        }
        if (valid0) {
          if (data.billingPeriods !== void 0) {
            let data1 = data.billingPeriods;
            const _errs3 = errors;
            if (errors === _errs3) {
              if (Array.isArray(data1)) {
                var valid1 = true;
                const len0 = data1.length;
                for (let i0 = 0; i0 < len0; i0++) {
                  const _errs5 = errors;
                  if (!validate22(data1[i0], {
                    instancePath: instancePath + "/billingPeriods/" + i0,
                    parentData: data1,
                    parentDataProperty: i0,
                    rootData
                  })) {
                    vErrors = vErrors === null ? validate22.errors : vErrors.concat(validate22.errors);
                    errors = vErrors.length;
                  }
                  var valid1 = _errs5 === errors;
                  if (!valid1) {
                    break;
                  }
                }
              } else {
                validate24.errors = [{
                  instancePath: instancePath + "/billingPeriods",
                  schemaPath: "#/properties/billingPeriods/type",
                  keyword: "type",
                  params: {
                    type: "array"
                  },
                  message: "must be array"
                }];
                return false;
              }
            }
            var valid0 = _errs3 === errors;
          } else {
            var valid0 = true;
          }
        }
      }
    } else {
      validate24.errors = [{
        instancePath,
        schemaPath: "#/type",
        keyword: "type",
        params: {
          type: "object"
        },
        message: "must be object"
      }];
      return false;
    }
  }
  validate24.errors = vErrors;
  return errors === 0;
}
const ApplyCouponRequest = validate26;
function validate26(data, {
  instancePath = "",
  parentData,
  parentDataProperty,
  rootData = data
} = {}) {
  let vErrors = null;
  let errors = 0;
  {
    if (data && typeof data == "object" && !Array.isArray(data)) {
      let missing0;
      if (data.code === void 0 && (missing0 = "code") || data.channelId === void 0 && (missing0 = "channelId") || data.planId === void 0 && (missing0 = "planId") || data.selectedPeriodicity === void 0 && (missing0 = "selectedPeriodicity")) {
        validate26.errors = [{
          instancePath,
          schemaPath: "#/required",
          keyword: "required",
          params: {
            missingProperty: missing0
          },
          message: "must have required property '" + missing0 + "'"
        }];
        return false;
      } else {
        if (data.code !== void 0) {
          const _errs1 = errors;
          if (typeof data.code !== "string") {
            validate26.errors = [{
              instancePath: instancePath + "/code",
              schemaPath: "#/properties/code/type",
              keyword: "type",
              params: {
                type: "string"
              },
              message: "must be string"
            }];
            return false;
          }
          var valid0 = _errs1 === errors;
        } else {
          var valid0 = true;
        }
        if (valid0) {
          if (data.channelId !== void 0) {
            const _errs3 = errors;
            if (typeof data.channelId !== "string") {
              validate26.errors = [{
                instancePath: instancePath + "/channelId",
                schemaPath: "#/properties/channelId/type",
                keyword: "type",
                params: {
                  type: "string"
                },
                message: "must be string"
              }];
              return false;
            }
            var valid0 = _errs3 === errors;
          } else {
            var valid0 = true;
          }
          if (valid0) {
            if (data.planId !== void 0) {
              const _errs5 = errors;
              if (typeof data.planId !== "string") {
                validate26.errors = [{
                  instancePath: instancePath + "/planId",
                  schemaPath: "#/properties/planId/type",
                  keyword: "type",
                  params: {
                    type: "string"
                  },
                  message: "must be string"
                }];
                return false;
              }
              var valid0 = _errs5 === errors;
            } else {
              var valid0 = true;
            }
            if (valid0) {
              if (data.selectedCurrency !== void 0) {
                const _errs7 = errors;
                if (typeof data.selectedCurrency !== "string") {
                  validate26.errors = [{
                    instancePath: instancePath + "/selectedCurrency",
                    schemaPath: "#/properties/selectedCurrency/type",
                    keyword: "type",
                    params: {
                      type: "string"
                    },
                    message: "must be string"
                  }];
                  return false;
                }
                var valid0 = _errs7 === errors;
              } else {
                var valid0 = true;
              }
              if (valid0) {
                if (data.selectedPeriodicity !== void 0) {
                  let data4 = data.selectedPeriodicity;
                  const _errs9 = errors;
                  if (typeof data4 !== "string") {
                    validate26.errors = [{
                      instancePath: instancePath + "/selectedPeriodicity",
                      schemaPath: "BillingPeriodicity/type",
                      keyword: "type",
                      params: {
                        type: "string"
                      },
                      message: "must be string"
                    }];
                    return false;
                  }
                  if (!(data4 === "MONTHLY" || data4 === "YEARLY")) {
                    validate26.errors = [{
                      instancePath: instancePath + "/selectedPeriodicity",
                      schemaPath: "BillingPeriodicity/enum",
                      keyword: "enum",
                      params: {
                        allowedValues: schema21.enum
                      },
                      message: "must be equal to one of the allowed values"
                    }];
                    return false;
                  }
                  var valid0 = _errs9 === errors;
                } else {
                  var valid0 = true;
                }
              }
            }
          }
        }
      }
    } else {
      validate26.errors = [{
        instancePath,
        schemaPath: "#/type",
        keyword: "type",
        params: {
          type: "object"
        },
        message: "must be object"
      }];
      return false;
    }
  }
  validate26.errors = vErrors;
  return errors === 0;
}
const ApplyCouponSuccessfulResponse = validate27;
function validate27(data, {
  instancePath = "",
  parentData,
  parentDataProperty,
  rootData = data
} = {}) {
  let vErrors = null;
  let errors = 0;
  {
    if (data && typeof data == "object" && !Array.isArray(data)) {
      let missing0;
      if (data.success === void 0 && (missing0 = "success") || data.totalDue === void 0 && (missing0 = "totalDue") || data.amountOff === void 0 && (missing0 = "amountOff") || data.couponText === void 0 && (missing0 = "couponText")) {
        validate27.errors = [{
          instancePath,
          schemaPath: "#/required",
          keyword: "required",
          params: {
            missingProperty: missing0
          },
          message: "must have required property '" + missing0 + "'"
        }];
        return false;
      } else {
        if (data.success !== void 0) {
          let data0 = data.success;
          const _errs1 = errors;
          if (typeof data0 !== "boolean") {
            validate27.errors = [{
              instancePath: instancePath + "/success",
              schemaPath: "#/properties/success/type",
              keyword: "type",
              params: {
                type: "boolean"
              },
              message: "must be boolean"
            }];
            return false;
          }
          if (true !== data0) {
            validate27.errors = [{
              instancePath: instancePath + "/success",
              schemaPath: "#/properties/success/const",
              keyword: "const",
              params: {
                allowedValue: true
              },
              message: "must be equal to constant"
            }];
            return false;
          }
          var valid0 = _errs1 === errors;
        } else {
          var valid0 = true;
        }
        if (valid0) {
          if (data.totalDue !== void 0) {
            let data1 = data.totalDue;
            const _errs3 = errors;
            if (!(typeof data1 == "number" && isFinite(data1))) {
              validate27.errors = [{
                instancePath: instancePath + "/totalDue",
                schemaPath: "#/properties/totalDue/type",
                keyword: "type",
                params: {
                  type: "number"
                },
                message: "must be number"
              }];
              return false;
            }
            var valid0 = _errs3 === errors;
          } else {
            var valid0 = true;
          }
          if (valid0) {
            if (data.amountOff !== void 0) {
              let data2 = data.amountOff;
              const _errs5 = errors;
              if (!(typeof data2 == "number" && isFinite(data2))) {
                validate27.errors = [{
                  instancePath: instancePath + "/amountOff",
                  schemaPath: "#/properties/amountOff/type",
                  keyword: "type",
                  params: {
                    type: "number"
                  },
                  message: "must be number"
                }];
                return false;
              }
              var valid0 = _errs5 === errors;
            } else {
              var valid0 = true;
            }
            if (valid0) {
              if (data.couponText !== void 0) {
                const _errs7 = errors;
                if (typeof data.couponText !== "string") {
                  validate27.errors = [{
                    instancePath: instancePath + "/couponText",
                    schemaPath: "#/properties/couponText/type",
                    keyword: "type",
                    params: {
                      type: "string"
                    },
                    message: "must be string"
                  }];
                  return false;
                }
                var valid0 = _errs7 === errors;
              } else {
                var valid0 = true;
              }
            }
          }
        }
      }
    } else {
      validate27.errors = [{
        instancePath,
        schemaPath: "#/type",
        keyword: "type",
        params: {
          type: "object"
        },
        message: "must be object"
      }];
      return false;
    }
  }
  validate27.errors = vErrors;
  return errors === 0;
}
const ApplyCouponErrorResponse = validate28;
function validate28(data, {
  instancePath = "",
  parentData,
  parentDataProperty,
  rootData = data
} = {}) {
  let vErrors = null;
  let errors = 0;
  {
    if (data && typeof data == "object" && !Array.isArray(data)) {
      let missing0;
      if (data.success === void 0 && (missing0 = "success") || data.errorReason === void 0 && (missing0 = "errorReason")) {
        validate28.errors = [{
          instancePath,
          schemaPath: "#/required",
          keyword: "required",
          params: {
            missingProperty: missing0
          },
          message: "must have required property '" + missing0 + "'"
        }];
        return false;
      } else {
        if (data.success !== void 0) {
          let data0 = data.success;
          const _errs1 = errors;
          if (typeof data0 !== "boolean") {
            validate28.errors = [{
              instancePath: instancePath + "/success",
              schemaPath: "#/properties/success/type",
              keyword: "type",
              params: {
                type: "boolean"
              },
              message: "must be boolean"
            }];
            return false;
          }
          if (false !== data0) {
            validate28.errors = [{
              instancePath: instancePath + "/success",
              schemaPath: "#/properties/success/const",
              keyword: "const",
              params: {
                allowedValue: false
              },
              message: "must be equal to constant"
            }];
            return false;
          }
          var valid0 = _errs1 === errors;
        } else {
          var valid0 = true;
        }
        if (valid0) {
          if (data.errorReason !== void 0) {
            const _errs3 = errors;
            if (typeof data.errorReason !== "string") {
              validate28.errors = [{
                instancePath: instancePath + "/errorReason",
                schemaPath: "#/properties/errorReason/type",
                keyword: "type",
                params: {
                  type: "string"
                },
                message: "must be string"
              }];
              return false;
            }
            var valid0 = _errs3 === errors;
          } else {
            var valid0 = true;
          }
        }
      }
    } else {
      validate28.errors = [{
        instancePath,
        schemaPath: "#/type",
        keyword: "type",
        params: {
          type: "object"
        },
        message: "must be object"
      }];
      return false;
    }
  }
  validate28.errors = vErrors;
  return errors === 0;
}
const ApplyCouponResponse = validate29;
function validate29(data, {
  instancePath = "",
  parentData,
  parentDataProperty,
  rootData = data
} = {}) {
  let vErrors = null;
  let errors = 0;
  const _errs0 = errors;
  let valid0 = false;
  const _errs1 = errors;
  const _errs2 = errors;
  if (errors === _errs2) {
    if (data && typeof data == "object" && !Array.isArray(data)) {
      let missing0;
      if (data.success === void 0 && (missing0 = "success") || data.totalDue === void 0 && (missing0 = "totalDue") || data.amountOff === void 0 && (missing0 = "amountOff") || data.couponText === void 0 && (missing0 = "couponText")) {
        const err0 = {
          instancePath,
          schemaPath: "ApplyCouponSuccessfulResponse/required",
          keyword: "required",
          params: {
            missingProperty: missing0
          },
          message: "must have required property '" + missing0 + "'"
        };
        if (vErrors === null) {
          vErrors = [err0];
        } else {
          vErrors.push(err0);
        }
        errors++;
      } else {
        if (data.success !== void 0) {
          let data0 = data.success;
          const _errs4 = errors;
          if (typeof data0 !== "boolean") {
            const err1 = {
              instancePath: instancePath + "/success",
              schemaPath: "ApplyCouponSuccessfulResponse/properties/success/type",
              keyword: "type",
              params: {
                type: "boolean"
              },
              message: "must be boolean"
            };
            if (vErrors === null) {
              vErrors = [err1];
            } else {
              vErrors.push(err1);
            }
            errors++;
          }
          if (true !== data0) {
            const err2 = {
              instancePath: instancePath + "/success",
              schemaPath: "ApplyCouponSuccessfulResponse/properties/success/const",
              keyword: "const",
              params: {
                allowedValue: true
              },
              message: "must be equal to constant"
            };
            if (vErrors === null) {
              vErrors = [err2];
            } else {
              vErrors.push(err2);
            }
            errors++;
          }
          var valid2 = _errs4 === errors;
        } else {
          var valid2 = true;
        }
        if (valid2) {
          if (data.totalDue !== void 0) {
            let data1 = data.totalDue;
            const _errs6 = errors;
            if (!(typeof data1 == "number" && isFinite(data1))) {
              const err3 = {
                instancePath: instancePath + "/totalDue",
                schemaPath: "ApplyCouponSuccessfulResponse/properties/totalDue/type",
                keyword: "type",
                params: {
                  type: "number"
                },
                message: "must be number"
              };
              if (vErrors === null) {
                vErrors = [err3];
              } else {
                vErrors.push(err3);
              }
              errors++;
            }
            var valid2 = _errs6 === errors;
          } else {
            var valid2 = true;
          }
          if (valid2) {
            if (data.amountOff !== void 0) {
              let data2 = data.amountOff;
              const _errs8 = errors;
              if (!(typeof data2 == "number" && isFinite(data2))) {
                const err4 = {
                  instancePath: instancePath + "/amountOff",
                  schemaPath: "ApplyCouponSuccessfulResponse/properties/amountOff/type",
                  keyword: "type",
                  params: {
                    type: "number"
                  },
                  message: "must be number"
                };
                if (vErrors === null) {
                  vErrors = [err4];
                } else {
                  vErrors.push(err4);
                }
                errors++;
              }
              var valid2 = _errs8 === errors;
            } else {
              var valid2 = true;
            }
            if (valid2) {
              if (data.couponText !== void 0) {
                const _errs10 = errors;
                if (typeof data.couponText !== "string") {
                  const err5 = {
                    instancePath: instancePath + "/couponText",
                    schemaPath: "ApplyCouponSuccessfulResponse/properties/couponText/type",
                    keyword: "type",
                    params: {
                      type: "string"
                    },
                    message: "must be string"
                  };
                  if (vErrors === null) {
                    vErrors = [err5];
                  } else {
                    vErrors.push(err5);
                  }
                  errors++;
                }
                var valid2 = _errs10 === errors;
              } else {
                var valid2 = true;
              }
            }
          }
        }
      }
    } else {
      const err6 = {
        instancePath,
        schemaPath: "ApplyCouponSuccessfulResponse/type",
        keyword: "type",
        params: {
          type: "object"
        },
        message: "must be object"
      };
      if (vErrors === null) {
        vErrors = [err6];
      } else {
        vErrors.push(err6);
      }
      errors++;
    }
  }
  var _valid0 = _errs1 === errors;
  valid0 = valid0 || _valid0;
  if (!valid0) {
    const _errs12 = errors;
    const _errs13 = errors;
    if (errors === _errs13) {
      if (data && typeof data == "object" && !Array.isArray(data)) {
        let missing1;
        if (data.success === void 0 && (missing1 = "success") || data.errorReason === void 0 && (missing1 = "errorReason")) {
          const err7 = {
            instancePath,
            schemaPath: "ApplyCouponErrorResponse/required",
            keyword: "required",
            params: {
              missingProperty: missing1
            },
            message: "must have required property '" + missing1 + "'"
          };
          if (vErrors === null) {
            vErrors = [err7];
          } else {
            vErrors.push(err7);
          }
          errors++;
        } else {
          if (data.success !== void 0) {
            let data4 = data.success;
            const _errs15 = errors;
            if (typeof data4 !== "boolean") {
              const err8 = {
                instancePath: instancePath + "/success",
                schemaPath: "ApplyCouponErrorResponse/properties/success/type",
                keyword: "type",
                params: {
                  type: "boolean"
                },
                message: "must be boolean"
              };
              if (vErrors === null) {
                vErrors = [err8];
              } else {
                vErrors.push(err8);
              }
              errors++;
            }
            if (false !== data4) {
              const err9 = {
                instancePath: instancePath + "/success",
                schemaPath: "ApplyCouponErrorResponse/properties/success/const",
                keyword: "const",
                params: {
                  allowedValue: false
                },
                message: "must be equal to constant"
              };
              if (vErrors === null) {
                vErrors = [err9];
              } else {
                vErrors.push(err9);
              }
              errors++;
            }
            var valid4 = _errs15 === errors;
          } else {
            var valid4 = true;
          }
          if (valid4) {
            if (data.errorReason !== void 0) {
              const _errs17 = errors;
              if (typeof data.errorReason !== "string") {
                const err10 = {
                  instancePath: instancePath + "/errorReason",
                  schemaPath: "ApplyCouponErrorResponse/properties/errorReason/type",
                  keyword: "type",
                  params: {
                    type: "string"
                  },
                  message: "must be string"
                };
                if (vErrors === null) {
                  vErrors = [err10];
                } else {
                  vErrors.push(err10);
                }
                errors++;
              }
              var valid4 = _errs17 === errors;
            } else {
              var valid4 = true;
            }
          }
        }
      } else {
        const err11 = {
          instancePath,
          schemaPath: "ApplyCouponErrorResponse/type",
          keyword: "type",
          params: {
            type: "object"
          },
          message: "must be object"
        };
        if (vErrors === null) {
          vErrors = [err11];
        } else {
          vErrors.push(err11);
        }
        errors++;
      }
    }
    var _valid0 = _errs12 === errors;
    valid0 = valid0 || _valid0;
  }
  if (!valid0) {
    const err12 = {
      instancePath,
      schemaPath: "#/anyOf",
      keyword: "anyOf",
      params: {},
      message: "must match a schema in anyOf"
    };
    if (vErrors === null) {
      vErrors = [err12];
    } else {
      vErrors.push(err12);
    }
    errors++;
    validate29.errors = vErrors;
    return false;
  } else {
    errors = _errs0;
    if (vErrors !== null) {
      if (_errs0) {
        vErrors.length = _errs0;
      } else {
        vErrors = null;
      }
    }
  }
  validate29.errors = vErrors;
  return errors === 0;
}
const Branding = validate30;
const schema39 = {
  "$id": "Branding",
  "$schema": "http://json-schema.org/draft-07/schema#",
  "type": "object",
  "properties": {
    "accentColor": {
      "type": "string"
    },
    "backgroundColor": {
      "type": "string"
    },
    "themeStyle": {
      "type": "string",
      "enum": ["rounded", "hard"]
    },
    "bannerImages": {
      "type": "object",
      "properties": {
        "3/1": {
          "type": "string"
        },
        "3/4": {
          "type": "string"
        },
        "16/9": {
          "type": "string"
        }
      },
      "required": ["3/1", "3/4", "16/9"]
    },
    "logoImage": {
      "type": "string"
    },
    "contactInformation": {
      "type": "object",
      "properties": {
        "socialMediaLinks": {
          "anyOf": [{
            "type": "array",
            "items": {
              "type": "object",
              "properties": {
                "type": {
                  "type": "string"
                },
                "url": {
                  "type": "string"
                }
              },
              "required": ["type", "url"]
            }
          }, {
            "type": "null"
          }]
        },
        "contactAddressLines": {
          "anyOf": [{
            "type": "array",
            "items": {
              "type": "string"
            }
          }, {
            "type": "null"
          }]
        },
        "contactPhone": {
          "type": ["string", "null"]
        },
        "contactEmail": {
          "type": ["string", "null"]
        },
        "streamHelpText": {
          "type": ["string", "null"]
        },
        "supportEmail": {
          "type": ["string", "null"]
        },
        "faqLink": {
          "type": ["string", "null"]
        },
        "copyrightNotice": {
          "type": ["string", "null"]
        },
        "privacyPolicy": {
          "anyOf": [{
            "type": "array",
            "items": {
              "type": "string"
            }
          }, {
            "type": "null"
          }]
        },
        "logoImage": {
          "type": ["string", "null"]
        }
      },
      "required": ["socialMediaLinks", "contactAddressLines", "contactPhone", "contactEmail", "supportEmail", "copyrightNotice"]
    }
  },
  "required": ["accentColor", "backgroundColor", "themeStyle", "bannerImages", "logoImage"],
  "description": "Holds the information about the branding of a given entity (channel) and will affect the rendering of the elements on pages associated with it."
};
function validate30(data, {
  instancePath = "",
  parentData,
  parentDataProperty,
  rootData = data
} = {}) {
  let vErrors = null;
  let errors = 0;
  if (errors === 0) {
    if (data && typeof data == "object" && !Array.isArray(data)) {
      let missing0;
      if (data.accentColor === void 0 && (missing0 = "accentColor") || data.backgroundColor === void 0 && (missing0 = "backgroundColor") || data.themeStyle === void 0 && (missing0 = "themeStyle") || data.bannerImages === void 0 && (missing0 = "bannerImages") || data.logoImage === void 0 && (missing0 = "logoImage")) {
        validate30.errors = [{
          instancePath,
          schemaPath: "#/required",
          keyword: "required",
          params: {
            missingProperty: missing0
          },
          message: "must have required property '" + missing0 + "'"
        }];
        return false;
      } else {
        if (data.accentColor !== void 0) {
          const _errs1 = errors;
          if (typeof data.accentColor !== "string") {
            validate30.errors = [{
              instancePath: instancePath + "/accentColor",
              schemaPath: "#/properties/accentColor/type",
              keyword: "type",
              params: {
                type: "string"
              },
              message: "must be string"
            }];
            return false;
          }
          var valid0 = _errs1 === errors;
        } else {
          var valid0 = true;
        }
        if (valid0) {
          if (data.backgroundColor !== void 0) {
            const _errs3 = errors;
            if (typeof data.backgroundColor !== "string") {
              validate30.errors = [{
                instancePath: instancePath + "/backgroundColor",
                schemaPath: "#/properties/backgroundColor/type",
                keyword: "type",
                params: {
                  type: "string"
                },
                message: "must be string"
              }];
              return false;
            }
            var valid0 = _errs3 === errors;
          } else {
            var valid0 = true;
          }
          if (valid0) {
            if (data.themeStyle !== void 0) {
              let data2 = data.themeStyle;
              const _errs5 = errors;
              if (typeof data2 !== "string") {
                validate30.errors = [{
                  instancePath: instancePath + "/themeStyle",
                  schemaPath: "#/properties/themeStyle/type",
                  keyword: "type",
                  params: {
                    type: "string"
                  },
                  message: "must be string"
                }];
                return false;
              }
              if (!(data2 === "rounded" || data2 === "hard")) {
                validate30.errors = [{
                  instancePath: instancePath + "/themeStyle",
                  schemaPath: "#/properties/themeStyle/enum",
                  keyword: "enum",
                  params: {
                    allowedValues: schema39.properties.themeStyle.enum
                  },
                  message: "must be equal to one of the allowed values"
                }];
                return false;
              }
              var valid0 = _errs5 === errors;
            } else {
              var valid0 = true;
            }
            if (valid0) {
              if (data.bannerImages !== void 0) {
                let data3 = data.bannerImages;
                const _errs7 = errors;
                if (errors === _errs7) {
                  if (data3 && typeof data3 == "object" && !Array.isArray(data3)) {
                    let missing1;
                    if (data3["3/1"] === void 0 && (missing1 = "3/1") || data3["3/4"] === void 0 && (missing1 = "3/4") || data3["16/9"] === void 0 && (missing1 = "16/9")) {
                      validate30.errors = [{
                        instancePath: instancePath + "/bannerImages",
                        schemaPath: "#/properties/bannerImages/required",
                        keyword: "required",
                        params: {
                          missingProperty: missing1
                        },
                        message: "must have required property '" + missing1 + "'"
                      }];
                      return false;
                    } else {
                      if (data3["3/1"] !== void 0) {
                        const _errs9 = errors;
                        if (typeof data3["3/1"] !== "string") {
                          validate30.errors = [{
                            instancePath: instancePath + "/bannerImages/3~11",
                            schemaPath: "#/properties/bannerImages/properties/3~11/type",
                            keyword: "type",
                            params: {
                              type: "string"
                            },
                            message: "must be string"
                          }];
                          return false;
                        }
                        var valid1 = _errs9 === errors;
                      } else {
                        var valid1 = true;
                      }
                      if (valid1) {
                        if (data3["3/4"] !== void 0) {
                          const _errs11 = errors;
                          if (typeof data3["3/4"] !== "string") {
                            validate30.errors = [{
                              instancePath: instancePath + "/bannerImages/3~14",
                              schemaPath: "#/properties/bannerImages/properties/3~14/type",
                              keyword: "type",
                              params: {
                                type: "string"
                              },
                              message: "must be string"
                            }];
                            return false;
                          }
                          var valid1 = _errs11 === errors;
                        } else {
                          var valid1 = true;
                        }
                        if (valid1) {
                          if (data3["16/9"] !== void 0) {
                            const _errs13 = errors;
                            if (typeof data3["16/9"] !== "string") {
                              validate30.errors = [{
                                instancePath: instancePath + "/bannerImages/16~19",
                                schemaPath: "#/properties/bannerImages/properties/16~19/type",
                                keyword: "type",
                                params: {
                                  type: "string"
                                },
                                message: "must be string"
                              }];
                              return false;
                            }
                            var valid1 = _errs13 === errors;
                          } else {
                            var valid1 = true;
                          }
                        }
                      }
                    }
                  } else {
                    validate30.errors = [{
                      instancePath: instancePath + "/bannerImages",
                      schemaPath: "#/properties/bannerImages/type",
                      keyword: "type",
                      params: {
                        type: "object"
                      },
                      message: "must be object"
                    }];
                    return false;
                  }
                }
                var valid0 = _errs7 === errors;
              } else {
                var valid0 = true;
              }
              if (valid0) {
                if (data.logoImage !== void 0) {
                  const _errs15 = errors;
                  if (typeof data.logoImage !== "string") {
                    validate30.errors = [{
                      instancePath: instancePath + "/logoImage",
                      schemaPath: "#/properties/logoImage/type",
                      keyword: "type",
                      params: {
                        type: "string"
                      },
                      message: "must be string"
                    }];
                    return false;
                  }
                  var valid0 = _errs15 === errors;
                } else {
                  var valid0 = true;
                }
                if (valid0) {
                  if (data.contactInformation !== void 0) {
                    let data8 = data.contactInformation;
                    const _errs17 = errors;
                    if (errors === _errs17) {
                      if (data8 && typeof data8 == "object" && !Array.isArray(data8)) {
                        let missing2;
                        if (data8.socialMediaLinks === void 0 && (missing2 = "socialMediaLinks") || data8.contactAddressLines === void 0 && (missing2 = "contactAddressLines") || data8.contactPhone === void 0 && (missing2 = "contactPhone") || data8.contactEmail === void 0 && (missing2 = "contactEmail") || data8.supportEmail === void 0 && (missing2 = "supportEmail") || data8.copyrightNotice === void 0 && (missing2 = "copyrightNotice")) {
                          validate30.errors = [{
                            instancePath: instancePath + "/contactInformation",
                            schemaPath: "#/properties/contactInformation/required",
                            keyword: "required",
                            params: {
                              missingProperty: missing2
                            },
                            message: "must have required property '" + missing2 + "'"
                          }];
                          return false;
                        } else {
                          if (data8.socialMediaLinks !== void 0) {
                            let data9 = data8.socialMediaLinks;
                            const _errs19 = errors;
                            const _errs20 = errors;
                            let valid3 = false;
                            const _errs21 = errors;
                            if (errors === _errs21) {
                              if (Array.isArray(data9)) {
                                var valid4 = true;
                                const len0 = data9.length;
                                for (let i0 = 0; i0 < len0; i0++) {
                                  let data10 = data9[i0];
                                  const _errs23 = errors;
                                  if (errors === _errs23) {
                                    if (data10 && typeof data10 == "object" && !Array.isArray(data10)) {
                                      let missing3;
                                      if (data10.type === void 0 && (missing3 = "type") || data10.url === void 0 && (missing3 = "url")) {
                                        const err0 = {
                                          instancePath: instancePath + "/contactInformation/socialMediaLinks/" + i0,
                                          schemaPath: "#/properties/contactInformation/properties/socialMediaLinks/anyOf/0/items/required",
                                          keyword: "required",
                                          params: {
                                            missingProperty: missing3
                                          },
                                          message: "must have required property '" + missing3 + "'"
                                        };
                                        if (vErrors === null) {
                                          vErrors = [err0];
                                        } else {
                                          vErrors.push(err0);
                                        }
                                        errors++;
                                      } else {
                                        if (data10.type !== void 0) {
                                          const _errs25 = errors;
                                          if (typeof data10.type !== "string") {
                                            const err1 = {
                                              instancePath: instancePath + "/contactInformation/socialMediaLinks/" + i0 + "/type",
                                              schemaPath: "#/properties/contactInformation/properties/socialMediaLinks/anyOf/0/items/properties/type/type",
                                              keyword: "type",
                                              params: {
                                                type: "string"
                                              },
                                              message: "must be string"
                                            };
                                            if (vErrors === null) {
                                              vErrors = [err1];
                                            } else {
                                              vErrors.push(err1);
                                            }
                                            errors++;
                                          }
                                          var valid5 = _errs25 === errors;
                                        } else {
                                          var valid5 = true;
                                        }
                                        if (valid5) {
                                          if (data10.url !== void 0) {
                                            const _errs27 = errors;
                                            if (typeof data10.url !== "string") {
                                              const err2 = {
                                                instancePath: instancePath + "/contactInformation/socialMediaLinks/" + i0 + "/url",
                                                schemaPath: "#/properties/contactInformation/properties/socialMediaLinks/anyOf/0/items/properties/url/type",
                                                keyword: "type",
                                                params: {
                                                  type: "string"
                                                },
                                                message: "must be string"
                                              };
                                              if (vErrors === null) {
                                                vErrors = [err2];
                                              } else {
                                                vErrors.push(err2);
                                              }
                                              errors++;
                                            }
                                            var valid5 = _errs27 === errors;
                                          } else {
                                            var valid5 = true;
                                          }
                                        }
                                      }
                                    } else {
                                      const err3 = {
                                        instancePath: instancePath + "/contactInformation/socialMediaLinks/" + i0,
                                        schemaPath: "#/properties/contactInformation/properties/socialMediaLinks/anyOf/0/items/type",
                                        keyword: "type",
                                        params: {
                                          type: "object"
                                        },
                                        message: "must be object"
                                      };
                                      if (vErrors === null) {
                                        vErrors = [err3];
                                      } else {
                                        vErrors.push(err3);
                                      }
                                      errors++;
                                    }
                                  }
                                  var valid4 = _errs23 === errors;
                                  if (!valid4) {
                                    break;
                                  }
                                }
                              } else {
                                const err4 = {
                                  instancePath: instancePath + "/contactInformation/socialMediaLinks",
                                  schemaPath: "#/properties/contactInformation/properties/socialMediaLinks/anyOf/0/type",
                                  keyword: "type",
                                  params: {
                                    type: "array"
                                  },
                                  message: "must be array"
                                };
                                if (vErrors === null) {
                                  vErrors = [err4];
                                } else {
                                  vErrors.push(err4);
                                }
                                errors++;
                              }
                            }
                            var _valid0 = _errs21 === errors;
                            valid3 = valid3 || _valid0;
                            if (!valid3) {
                              const _errs29 = errors;
                              if (data9 !== null) {
                                const err5 = {
                                  instancePath: instancePath + "/contactInformation/socialMediaLinks",
                                  schemaPath: "#/properties/contactInformation/properties/socialMediaLinks/anyOf/1/type",
                                  keyword: "type",
                                  params: {
                                    type: "null"
                                  },
                                  message: "must be null"
                                };
                                if (vErrors === null) {
                                  vErrors = [err5];
                                } else {
                                  vErrors.push(err5);
                                }
                                errors++;
                              }
                              var _valid0 = _errs29 === errors;
                              valid3 = valid3 || _valid0;
                            }
                            if (!valid3) {
                              const err6 = {
                                instancePath: instancePath + "/contactInformation/socialMediaLinks",
                                schemaPath: "#/properties/contactInformation/properties/socialMediaLinks/anyOf",
                                keyword: "anyOf",
                                params: {},
                                message: "must match a schema in anyOf"
                              };
                              if (vErrors === null) {
                                vErrors = [err6];
                              } else {
                                vErrors.push(err6);
                              }
                              errors++;
                              validate30.errors = vErrors;
                              return false;
                            } else {
                              errors = _errs20;
                              if (vErrors !== null) {
                                if (_errs20) {
                                  vErrors.length = _errs20;
                                } else {
                                  vErrors = null;
                                }
                              }
                            }
                            var valid2 = _errs19 === errors;
                          } else {
                            var valid2 = true;
                          }
                          if (valid2) {
                            if (data8.contactAddressLines !== void 0) {
                              let data13 = data8.contactAddressLines;
                              const _errs31 = errors;
                              const _errs32 = errors;
                              let valid6 = false;
                              const _errs33 = errors;
                              if (errors === _errs33) {
                                if (Array.isArray(data13)) {
                                  var valid7 = true;
                                  const len1 = data13.length;
                                  for (let i1 = 0; i1 < len1; i1++) {
                                    const _errs35 = errors;
                                    if (typeof data13[i1] !== "string") {
                                      const err7 = {
                                        instancePath: instancePath + "/contactInformation/contactAddressLines/" + i1,
                                        schemaPath: "#/properties/contactInformation/properties/contactAddressLines/anyOf/0/items/type",
                                        keyword: "type",
                                        params: {
                                          type: "string"
                                        },
                                        message: "must be string"
                                      };
                                      if (vErrors === null) {
                                        vErrors = [err7];
                                      } else {
                                        vErrors.push(err7);
                                      }
                                      errors++;
                                    }
                                    var valid7 = _errs35 === errors;
                                    if (!valid7) {
                                      break;
                                    }
                                  }
                                } else {
                                  const err8 = {
                                    instancePath: instancePath + "/contactInformation/contactAddressLines",
                                    schemaPath: "#/properties/contactInformation/properties/contactAddressLines/anyOf/0/type",
                                    keyword: "type",
                                    params: {
                                      type: "array"
                                    },
                                    message: "must be array"
                                  };
                                  if (vErrors === null) {
                                    vErrors = [err8];
                                  } else {
                                    vErrors.push(err8);
                                  }
                                  errors++;
                                }
                              }
                              var _valid1 = _errs33 === errors;
                              valid6 = valid6 || _valid1;
                              if (!valid6) {
                                const _errs37 = errors;
                                if (data13 !== null) {
                                  const err9 = {
                                    instancePath: instancePath + "/contactInformation/contactAddressLines",
                                    schemaPath: "#/properties/contactInformation/properties/contactAddressLines/anyOf/1/type",
                                    keyword: "type",
                                    params: {
                                      type: "null"
                                    },
                                    message: "must be null"
                                  };
                                  if (vErrors === null) {
                                    vErrors = [err9];
                                  } else {
                                    vErrors.push(err9);
                                  }
                                  errors++;
                                }
                                var _valid1 = _errs37 === errors;
                                valid6 = valid6 || _valid1;
                              }
                              if (!valid6) {
                                const err10 = {
                                  instancePath: instancePath + "/contactInformation/contactAddressLines",
                                  schemaPath: "#/properties/contactInformation/properties/contactAddressLines/anyOf",
                                  keyword: "anyOf",
                                  params: {},
                                  message: "must match a schema in anyOf"
                                };
                                if (vErrors === null) {
                                  vErrors = [err10];
                                } else {
                                  vErrors.push(err10);
                                }
                                errors++;
                                validate30.errors = vErrors;
                                return false;
                              } else {
                                errors = _errs32;
                                if (vErrors !== null) {
                                  if (_errs32) {
                                    vErrors.length = _errs32;
                                  } else {
                                    vErrors = null;
                                  }
                                }
                              }
                              var valid2 = _errs31 === errors;
                            } else {
                              var valid2 = true;
                            }
                            if (valid2) {
                              if (data8.contactPhone !== void 0) {
                                let data15 = data8.contactPhone;
                                const _errs39 = errors;
                                if (typeof data15 !== "string" && data15 !== null) {
                                  validate30.errors = [{
                                    instancePath: instancePath + "/contactInformation/contactPhone",
                                    schemaPath: "#/properties/contactInformation/properties/contactPhone/type",
                                    keyword: "type",
                                    params: {
                                      type: schema39.properties.contactInformation.properties.contactPhone.type
                                    },
                                    message: "must be string,null"
                                  }];
                                  return false;
                                }
                                var valid2 = _errs39 === errors;
                              } else {
                                var valid2 = true;
                              }
                              if (valid2) {
                                if (data8.contactEmail !== void 0) {
                                  let data16 = data8.contactEmail;
                                  const _errs41 = errors;
                                  if (typeof data16 !== "string" && data16 !== null) {
                                    validate30.errors = [{
                                      instancePath: instancePath + "/contactInformation/contactEmail",
                                      schemaPath: "#/properties/contactInformation/properties/contactEmail/type",
                                      keyword: "type",
                                      params: {
                                        type: schema39.properties.contactInformation.properties.contactEmail.type
                                      },
                                      message: "must be string,null"
                                    }];
                                    return false;
                                  }
                                  var valid2 = _errs41 === errors;
                                } else {
                                  var valid2 = true;
                                }
                                if (valid2) {
                                  if (data8.streamHelpText !== void 0) {
                                    let data17 = data8.streamHelpText;
                                    const _errs43 = errors;
                                    if (typeof data17 !== "string" && data17 !== null) {
                                      validate30.errors = [{
                                        instancePath: instancePath + "/contactInformation/streamHelpText",
                                        schemaPath: "#/properties/contactInformation/properties/streamHelpText/type",
                                        keyword: "type",
                                        params: {
                                          type: schema39.properties.contactInformation.properties.streamHelpText.type
                                        },
                                        message: "must be string,null"
                                      }];
                                      return false;
                                    }
                                    var valid2 = _errs43 === errors;
                                  } else {
                                    var valid2 = true;
                                  }
                                  if (valid2) {
                                    if (data8.supportEmail !== void 0) {
                                      let data18 = data8.supportEmail;
                                      const _errs45 = errors;
                                      if (typeof data18 !== "string" && data18 !== null) {
                                        validate30.errors = [{
                                          instancePath: instancePath + "/contactInformation/supportEmail",
                                          schemaPath: "#/properties/contactInformation/properties/supportEmail/type",
                                          keyword: "type",
                                          params: {
                                            type: schema39.properties.contactInformation.properties.supportEmail.type
                                          },
                                          message: "must be string,null"
                                        }];
                                        return false;
                                      }
                                      var valid2 = _errs45 === errors;
                                    } else {
                                      var valid2 = true;
                                    }
                                    if (valid2) {
                                      if (data8.faqLink !== void 0) {
                                        let data19 = data8.faqLink;
                                        const _errs47 = errors;
                                        if (typeof data19 !== "string" && data19 !== null) {
                                          validate30.errors = [{
                                            instancePath: instancePath + "/contactInformation/faqLink",
                                            schemaPath: "#/properties/contactInformation/properties/faqLink/type",
                                            keyword: "type",
                                            params: {
                                              type: schema39.properties.contactInformation.properties.faqLink.type
                                            },
                                            message: "must be string,null"
                                          }];
                                          return false;
                                        }
                                        var valid2 = _errs47 === errors;
                                      } else {
                                        var valid2 = true;
                                      }
                                      if (valid2) {
                                        if (data8.copyrightNotice !== void 0) {
                                          let data20 = data8.copyrightNotice;
                                          const _errs49 = errors;
                                          if (typeof data20 !== "string" && data20 !== null) {
                                            validate30.errors = [{
                                              instancePath: instancePath + "/contactInformation/copyrightNotice",
                                              schemaPath: "#/properties/contactInformation/properties/copyrightNotice/type",
                                              keyword: "type",
                                              params: {
                                                type: schema39.properties.contactInformation.properties.copyrightNotice.type
                                              },
                                              message: "must be string,null"
                                            }];
                                            return false;
                                          }
                                          var valid2 = _errs49 === errors;
                                        } else {
                                          var valid2 = true;
                                        }
                                        if (valid2) {
                                          if (data8.privacyPolicy !== void 0) {
                                            let data21 = data8.privacyPolicy;
                                            const _errs51 = errors;
                                            const _errs52 = errors;
                                            let valid8 = false;
                                            const _errs53 = errors;
                                            if (errors === _errs53) {
                                              if (Array.isArray(data21)) {
                                                var valid9 = true;
                                                const len2 = data21.length;
                                                for (let i2 = 0; i2 < len2; i2++) {
                                                  const _errs55 = errors;
                                                  if (typeof data21[i2] !== "string") {
                                                    const err11 = {
                                                      instancePath: instancePath + "/contactInformation/privacyPolicy/" + i2,
                                                      schemaPath: "#/properties/contactInformation/properties/privacyPolicy/anyOf/0/items/type",
                                                      keyword: "type",
                                                      params: {
                                                        type: "string"
                                                      },
                                                      message: "must be string"
                                                    };
                                                    if (vErrors === null) {
                                                      vErrors = [err11];
                                                    } else {
                                                      vErrors.push(err11);
                                                    }
                                                    errors++;
                                                  }
                                                  var valid9 = _errs55 === errors;
                                                  if (!valid9) {
                                                    break;
                                                  }
                                                }
                                              } else {
                                                const err12 = {
                                                  instancePath: instancePath + "/contactInformation/privacyPolicy",
                                                  schemaPath: "#/properties/contactInformation/properties/privacyPolicy/anyOf/0/type",
                                                  keyword: "type",
                                                  params: {
                                                    type: "array"
                                                  },
                                                  message: "must be array"
                                                };
                                                if (vErrors === null) {
                                                  vErrors = [err12];
                                                } else {
                                                  vErrors.push(err12);
                                                }
                                                errors++;
                                              }
                                            }
                                            var _valid2 = _errs53 === errors;
                                            valid8 = valid8 || _valid2;
                                            if (!valid8) {
                                              const _errs57 = errors;
                                              if (data21 !== null) {
                                                const err13 = {
                                                  instancePath: instancePath + "/contactInformation/privacyPolicy",
                                                  schemaPath: "#/properties/contactInformation/properties/privacyPolicy/anyOf/1/type",
                                                  keyword: "type",
                                                  params: {
                                                    type: "null"
                                                  },
                                                  message: "must be null"
                                                };
                                                if (vErrors === null) {
                                                  vErrors = [err13];
                                                } else {
                                                  vErrors.push(err13);
                                                }
                                                errors++;
                                              }
                                              var _valid2 = _errs57 === errors;
                                              valid8 = valid8 || _valid2;
                                            }
                                            if (!valid8) {
                                              const err14 = {
                                                instancePath: instancePath + "/contactInformation/privacyPolicy",
                                                schemaPath: "#/properties/contactInformation/properties/privacyPolicy/anyOf",
                                                keyword: "anyOf",
                                                params: {},
                                                message: "must match a schema in anyOf"
                                              };
                                              if (vErrors === null) {
                                                vErrors = [err14];
                                              } else {
                                                vErrors.push(err14);
                                              }
                                              errors++;
                                              validate30.errors = vErrors;
                                              return false;
                                            } else {
                                              errors = _errs52;
                                              if (vErrors !== null) {
                                                if (_errs52) {
                                                  vErrors.length = _errs52;
                                                } else {
                                                  vErrors = null;
                                                }
                                              }
                                            }
                                            var valid2 = _errs51 === errors;
                                          } else {
                                            var valid2 = true;
                                          }
                                          if (valid2) {
                                            if (data8.logoImage !== void 0) {
                                              let data23 = data8.logoImage;
                                              const _errs59 = errors;
                                              if (typeof data23 !== "string" && data23 !== null) {
                                                validate30.errors = [{
                                                  instancePath: instancePath + "/contactInformation/logoImage",
                                                  schemaPath: "#/properties/contactInformation/properties/logoImage/type",
                                                  keyword: "type",
                                                  params: {
                                                    type: schema39.properties.contactInformation.properties.logoImage.type
                                                  },
                                                  message: "must be string,null"
                                                }];
                                                return false;
                                              }
                                              var valid2 = _errs59 === errors;
                                            } else {
                                              var valid2 = true;
                                            }
                                          }
                                        }
                                      }
                                    }
                                  }
                                }
                              }
                            }
                          }
                        }
                      } else {
                        validate30.errors = [{
                          instancePath: instancePath + "/contactInformation",
                          schemaPath: "#/properties/contactInformation/type",
                          keyword: "type",
                          params: {
                            type: "object"
                          },
                          message: "must be object"
                        }];
                        return false;
                      }
                    }
                    var valid0 = _errs17 === errors;
                  } else {
                    var valid0 = true;
                  }
                }
              }
            }
          }
        }
      }
    } else {
      validate30.errors = [{
        instancePath,
        schemaPath: "#/type",
        keyword: "type",
        params: {
          type: "object"
        },
        message: "must be object"
      }];
      return false;
    }
  }
  validate30.errors = vErrors;
  return errors === 0;
}
const BuySubscriptionRequest = validate31;
const schema40 = {
  "$id": "BuySubscriptionRequest",
  "$schema": "http://json-schema.org/draft-07/schema#",
  "type": "object",
  "properties": {
    "channelId": {
      "type": "string"
    },
    "planId": {
      "type": "string"
    },
    "selectedCurrency": {
      "type": "string"
    },
    "periodicity": {
      "$ref": "BillingPeriodicity"
    },
    "installments": {
      "type": ["boolean", "null"]
    },
    "paymentMethodId": {
      "type": "string"
    },
    "coupon": {
      "type": "string"
    }
  },
  "required": ["channelId", "planId", "selectedCurrency", "periodicity", "paymentMethodId"]
};
function validate31(data, {
  instancePath = "",
  parentData,
  parentDataProperty,
  rootData = data
} = {}) {
  let vErrors = null;
  let errors = 0;
  {
    if (data && typeof data == "object" && !Array.isArray(data)) {
      let missing0;
      if (data.channelId === void 0 && (missing0 = "channelId") || data.planId === void 0 && (missing0 = "planId") || data.selectedCurrency === void 0 && (missing0 = "selectedCurrency") || data.periodicity === void 0 && (missing0 = "periodicity") || data.paymentMethodId === void 0 && (missing0 = "paymentMethodId")) {
        validate31.errors = [{
          instancePath,
          schemaPath: "#/required",
          keyword: "required",
          params: {
            missingProperty: missing0
          },
          message: "must have required property '" + missing0 + "'"
        }];
        return false;
      } else {
        if (data.channelId !== void 0) {
          const _errs1 = errors;
          if (typeof data.channelId !== "string") {
            validate31.errors = [{
              instancePath: instancePath + "/channelId",
              schemaPath: "#/properties/channelId/type",
              keyword: "type",
              params: {
                type: "string"
              },
              message: "must be string"
            }];
            return false;
          }
          var valid0 = _errs1 === errors;
        } else {
          var valid0 = true;
        }
        if (valid0) {
          if (data.planId !== void 0) {
            const _errs3 = errors;
            if (typeof data.planId !== "string") {
              validate31.errors = [{
                instancePath: instancePath + "/planId",
                schemaPath: "#/properties/planId/type",
                keyword: "type",
                params: {
                  type: "string"
                },
                message: "must be string"
              }];
              return false;
            }
            var valid0 = _errs3 === errors;
          } else {
            var valid0 = true;
          }
          if (valid0) {
            if (data.selectedCurrency !== void 0) {
              const _errs5 = errors;
              if (typeof data.selectedCurrency !== "string") {
                validate31.errors = [{
                  instancePath: instancePath + "/selectedCurrency",
                  schemaPath: "#/properties/selectedCurrency/type",
                  keyword: "type",
                  params: {
                    type: "string"
                  },
                  message: "must be string"
                }];
                return false;
              }
              var valid0 = _errs5 === errors;
            } else {
              var valid0 = true;
            }
            if (valid0) {
              if (data.periodicity !== void 0) {
                let data3 = data.periodicity;
                const _errs7 = errors;
                if (typeof data3 !== "string") {
                  validate31.errors = [{
                    instancePath: instancePath + "/periodicity",
                    schemaPath: "BillingPeriodicity/type",
                    keyword: "type",
                    params: {
                      type: "string"
                    },
                    message: "must be string"
                  }];
                  return false;
                }
                if (!(data3 === "MONTHLY" || data3 === "YEARLY")) {
                  validate31.errors = [{
                    instancePath: instancePath + "/periodicity",
                    schemaPath: "BillingPeriodicity/enum",
                    keyword: "enum",
                    params: {
                      allowedValues: schema21.enum
                    },
                    message: "must be equal to one of the allowed values"
                  }];
                  return false;
                }
                var valid0 = _errs7 === errors;
              } else {
                var valid0 = true;
              }
              if (valid0) {
                if (data.installments !== void 0) {
                  let data4 = data.installments;
                  const _errs10 = errors;
                  if (typeof data4 !== "boolean" && data4 !== null) {
                    validate31.errors = [{
                      instancePath: instancePath + "/installments",
                      schemaPath: "#/properties/installments/type",
                      keyword: "type",
                      params: {
                        type: schema40.properties.installments.type
                      },
                      message: "must be boolean,null"
                    }];
                    return false;
                  }
                  var valid0 = _errs10 === errors;
                } else {
                  var valid0 = true;
                }
                if (valid0) {
                  if (data.paymentMethodId !== void 0) {
                    const _errs12 = errors;
                    if (typeof data.paymentMethodId !== "string") {
                      validate31.errors = [{
                        instancePath: instancePath + "/paymentMethodId",
                        schemaPath: "#/properties/paymentMethodId/type",
                        keyword: "type",
                        params: {
                          type: "string"
                        },
                        message: "must be string"
                      }];
                      return false;
                    }
                    var valid0 = _errs12 === errors;
                  } else {
                    var valid0 = true;
                  }
                  if (valid0) {
                    if (data.coupon !== void 0) {
                      const _errs14 = errors;
                      if (typeof data.coupon !== "string") {
                        validate31.errors = [{
                          instancePath: instancePath + "/coupon",
                          schemaPath: "#/properties/coupon/type",
                          keyword: "type",
                          params: {
                            type: "string"
                          },
                          message: "must be string"
                        }];
                        return false;
                      }
                      var valid0 = _errs14 === errors;
                    } else {
                      var valid0 = true;
                    }
                  }
                }
              }
            }
          }
        }
      }
    } else {
      validate31.errors = [{
        instancePath,
        schemaPath: "#/type",
        keyword: "type",
        params: {
          type: "object"
        },
        message: "must be object"
      }];
      return false;
    }
  }
  validate31.errors = vErrors;
  return errors === 0;
}
const BuySubscriptionSuccessfulResponse = validate32;
function validate32(data, {
  instancePath = "",
  parentData,
  parentDataProperty,
  rootData = data
} = {}) {
  let vErrors = null;
  let errors = 0;
  {
    if (data && typeof data == "object" && !Array.isArray(data)) {
      let missing0;
      if (data.success === void 0 && (missing0 = "success") || data.subscriptionId === void 0 && (missing0 = "subscriptionId")) {
        validate32.errors = [{
          instancePath,
          schemaPath: "#/required",
          keyword: "required",
          params: {
            missingProperty: missing0
          },
          message: "must have required property '" + missing0 + "'"
        }];
        return false;
      } else {
        if (data.success !== void 0) {
          let data0 = data.success;
          const _errs1 = errors;
          if (typeof data0 !== "boolean") {
            validate32.errors = [{
              instancePath: instancePath + "/success",
              schemaPath: "#/properties/success/type",
              keyword: "type",
              params: {
                type: "boolean"
              },
              message: "must be boolean"
            }];
            return false;
          }
          if (true !== data0) {
            validate32.errors = [{
              instancePath: instancePath + "/success",
              schemaPath: "#/properties/success/const",
              keyword: "const",
              params: {
                allowedValue: true
              },
              message: "must be equal to constant"
            }];
            return false;
          }
          var valid0 = _errs1 === errors;
        } else {
          var valid0 = true;
        }
        if (valid0) {
          if (data.subscriptionId !== void 0) {
            const _errs3 = errors;
            if (typeof data.subscriptionId !== "string") {
              validate32.errors = [{
                instancePath: instancePath + "/subscriptionId",
                schemaPath: "#/properties/subscriptionId/type",
                keyword: "type",
                params: {
                  type: "string"
                },
                message: "must be string"
              }];
              return false;
            }
            var valid0 = _errs3 === errors;
          } else {
            var valid0 = true;
          }
        }
      }
    } else {
      validate32.errors = [{
        instancePath,
        schemaPath: "#/type",
        keyword: "type",
        params: {
          type: "object"
        },
        message: "must be object"
      }];
      return false;
    }
  }
  validate32.errors = vErrors;
  return errors === 0;
}
const BuySubscriptionErrorResponse = validate33;
function validate33(data, {
  instancePath = "",
  parentData,
  parentDataProperty,
  rootData = data
} = {}) {
  let vErrors = null;
  let errors = 0;
  {
    if (data && typeof data == "object" && !Array.isArray(data)) {
      let missing0;
      if (data.success === void 0 && (missing0 = "success") || data.error === void 0 && (missing0 = "error")) {
        validate33.errors = [{
          instancePath,
          schemaPath: "#/required",
          keyword: "required",
          params: {
            missingProperty: missing0
          },
          message: "must have required property '" + missing0 + "'"
        }];
        return false;
      } else {
        if (data.success !== void 0) {
          let data0 = data.success;
          const _errs1 = errors;
          if (typeof data0 !== "boolean") {
            validate33.errors = [{
              instancePath: instancePath + "/success",
              schemaPath: "#/properties/success/type",
              keyword: "type",
              params: {
                type: "boolean"
              },
              message: "must be boolean"
            }];
            return false;
          }
          if (false !== data0) {
            validate33.errors = [{
              instancePath: instancePath + "/success",
              schemaPath: "#/properties/success/const",
              keyword: "const",
              params: {
                allowedValue: false
              },
              message: "must be equal to constant"
            }];
            return false;
          }
          var valid0 = _errs1 === errors;
        } else {
          var valid0 = true;
        }
        if (valid0) {
          if (data.error !== void 0) {
            const _errs3 = errors;
            if (typeof data.error !== "string") {
              validate33.errors = [{
                instancePath: instancePath + "/error",
                schemaPath: "#/properties/error/type",
                keyword: "type",
                params: {
                  type: "string"
                },
                message: "must be string"
              }];
              return false;
            }
            var valid0 = _errs3 === errors;
          } else {
            var valid0 = true;
          }
        }
      }
    } else {
      validate33.errors = [{
        instancePath,
        schemaPath: "#/type",
        keyword: "type",
        params: {
          type: "object"
        },
        message: "must be object"
      }];
      return false;
    }
  }
  validate33.errors = vErrors;
  return errors === 0;
}
const BuySubscriptionResponse = validate34;
function validate34(data, {
  instancePath = "",
  parentData,
  parentDataProperty,
  rootData = data
} = {}) {
  let vErrors = null;
  let errors = 0;
  const _errs0 = errors;
  let valid0 = false;
  const _errs1 = errors;
  const _errs2 = errors;
  if (errors === _errs2) {
    if (data && typeof data == "object" && !Array.isArray(data)) {
      let missing0;
      if (data.success === void 0 && (missing0 = "success") || data.subscriptionId === void 0 && (missing0 = "subscriptionId")) {
        const err0 = {
          instancePath,
          schemaPath: "BuySubscriptionSuccessfulResponse/required",
          keyword: "required",
          params: {
            missingProperty: missing0
          },
          message: "must have required property '" + missing0 + "'"
        };
        if (vErrors === null) {
          vErrors = [err0];
        } else {
          vErrors.push(err0);
        }
        errors++;
      } else {
        if (data.success !== void 0) {
          let data0 = data.success;
          const _errs4 = errors;
          if (typeof data0 !== "boolean") {
            const err1 = {
              instancePath: instancePath + "/success",
              schemaPath: "BuySubscriptionSuccessfulResponse/properties/success/type",
              keyword: "type",
              params: {
                type: "boolean"
              },
              message: "must be boolean"
            };
            if (vErrors === null) {
              vErrors = [err1];
            } else {
              vErrors.push(err1);
            }
            errors++;
          }
          if (true !== data0) {
            const err2 = {
              instancePath: instancePath + "/success",
              schemaPath: "BuySubscriptionSuccessfulResponse/properties/success/const",
              keyword: "const",
              params: {
                allowedValue: true
              },
              message: "must be equal to constant"
            };
            if (vErrors === null) {
              vErrors = [err2];
            } else {
              vErrors.push(err2);
            }
            errors++;
          }
          var valid2 = _errs4 === errors;
        } else {
          var valid2 = true;
        }
        if (valid2) {
          if (data.subscriptionId !== void 0) {
            const _errs6 = errors;
            if (typeof data.subscriptionId !== "string") {
              const err3 = {
                instancePath: instancePath + "/subscriptionId",
                schemaPath: "BuySubscriptionSuccessfulResponse/properties/subscriptionId/type",
                keyword: "type",
                params: {
                  type: "string"
                },
                message: "must be string"
              };
              if (vErrors === null) {
                vErrors = [err3];
              } else {
                vErrors.push(err3);
              }
              errors++;
            }
            var valid2 = _errs6 === errors;
          } else {
            var valid2 = true;
          }
        }
      }
    } else {
      const err4 = {
        instancePath,
        schemaPath: "BuySubscriptionSuccessfulResponse/type",
        keyword: "type",
        params: {
          type: "object"
        },
        message: "must be object"
      };
      if (vErrors === null) {
        vErrors = [err4];
      } else {
        vErrors.push(err4);
      }
      errors++;
    }
  }
  var _valid0 = _errs1 === errors;
  valid0 = valid0 || _valid0;
  if (!valid0) {
    const _errs8 = errors;
    const _errs9 = errors;
    if (errors === _errs9) {
      if (data && typeof data == "object" && !Array.isArray(data)) {
        let missing1;
        if (data.success === void 0 && (missing1 = "success") || data.error === void 0 && (missing1 = "error")) {
          const err5 = {
            instancePath,
            schemaPath: "BuySubscriptionErrorResponse/required",
            keyword: "required",
            params: {
              missingProperty: missing1
            },
            message: "must have required property '" + missing1 + "'"
          };
          if (vErrors === null) {
            vErrors = [err5];
          } else {
            vErrors.push(err5);
          }
          errors++;
        } else {
          if (data.success !== void 0) {
            let data2 = data.success;
            const _errs11 = errors;
            if (typeof data2 !== "boolean") {
              const err6 = {
                instancePath: instancePath + "/success",
                schemaPath: "BuySubscriptionErrorResponse/properties/success/type",
                keyword: "type",
                params: {
                  type: "boolean"
                },
                message: "must be boolean"
              };
              if (vErrors === null) {
                vErrors = [err6];
              } else {
                vErrors.push(err6);
              }
              errors++;
            }
            if (false !== data2) {
              const err7 = {
                instancePath: instancePath + "/success",
                schemaPath: "BuySubscriptionErrorResponse/properties/success/const",
                keyword: "const",
                params: {
                  allowedValue: false
                },
                message: "must be equal to constant"
              };
              if (vErrors === null) {
                vErrors = [err7];
              } else {
                vErrors.push(err7);
              }
              errors++;
            }
            var valid4 = _errs11 === errors;
          } else {
            var valid4 = true;
          }
          if (valid4) {
            if (data.error !== void 0) {
              const _errs13 = errors;
              if (typeof data.error !== "string") {
                const err8 = {
                  instancePath: instancePath + "/error",
                  schemaPath: "BuySubscriptionErrorResponse/properties/error/type",
                  keyword: "type",
                  params: {
                    type: "string"
                  },
                  message: "must be string"
                };
                if (vErrors === null) {
                  vErrors = [err8];
                } else {
                  vErrors.push(err8);
                }
                errors++;
              }
              var valid4 = _errs13 === errors;
            } else {
              var valid4 = true;
            }
          }
        }
      } else {
        const err9 = {
          instancePath,
          schemaPath: "BuySubscriptionErrorResponse/type",
          keyword: "type",
          params: {
            type: "object"
          },
          message: "must be object"
        };
        if (vErrors === null) {
          vErrors = [err9];
        } else {
          vErrors.push(err9);
        }
        errors++;
      }
    }
    var _valid0 = _errs8 === errors;
    valid0 = valid0 || _valid0;
  }
  if (!valid0) {
    const err10 = {
      instancePath,
      schemaPath: "#/anyOf",
      keyword: "anyOf",
      params: {},
      message: "must match a schema in anyOf"
    };
    if (vErrors === null) {
      vErrors = [err10];
    } else {
      vErrors.push(err10);
    }
    errors++;
    validate34.errors = vErrors;
    return false;
  } else {
    errors = _errs0;
    if (vErrors !== null) {
      if (_errs0) {
        vErrors.length = _errs0;
      } else {
        vErrors = null;
      }
    }
  }
  validate34.errors = vErrors;
  return errors === 0;
}
const UserLocation = validate35;
const schema47 = {
  "$id": "UserLocation",
  "$schema": "http://json-schema.org/draft-07/schema#",
  "type": "object",
  "properties": {
    "IP": {
      "type": ["string", "null"]
    },
    "latlng": {
      "type": ["string", "null"]
    },
    "city": {
      "type": ["string", "null"]
    },
    "country": {
      "type": ["string", "null"]
    },
    "region": {
      "type": ["string", "null"]
    }
  },
  "required": ["IP", "latlng", "city", "country", "region"],
  "description": "Stores information about the user location. Usually extracted from a call to a firebase function."
};
function validate35(data, {
  instancePath = "",
  parentData,
  parentDataProperty,
  rootData = data
} = {}) {
  let vErrors = null;
  let errors = 0;
  {
    if (data && typeof data == "object" && !Array.isArray(data)) {
      let missing0;
      if (data.IP === void 0 && (missing0 = "IP") || data.latlng === void 0 && (missing0 = "latlng") || data.city === void 0 && (missing0 = "city") || data.country === void 0 && (missing0 = "country") || data.region === void 0 && (missing0 = "region")) {
        validate35.errors = [{
          instancePath,
          schemaPath: "#/required",
          keyword: "required",
          params: {
            missingProperty: missing0
          },
          message: "must have required property '" + missing0 + "'"
        }];
        return false;
      } else {
        if (data.IP !== void 0) {
          let data0 = data.IP;
          const _errs1 = errors;
          if (typeof data0 !== "string" && data0 !== null) {
            validate35.errors = [{
              instancePath: instancePath + "/IP",
              schemaPath: "#/properties/IP/type",
              keyword: "type",
              params: {
                type: schema47.properties.IP.type
              },
              message: "must be string,null"
            }];
            return false;
          }
          var valid0 = _errs1 === errors;
        } else {
          var valid0 = true;
        }
        if (valid0) {
          if (data.latlng !== void 0) {
            let data1 = data.latlng;
            const _errs3 = errors;
            if (typeof data1 !== "string" && data1 !== null) {
              validate35.errors = [{
                instancePath: instancePath + "/latlng",
                schemaPath: "#/properties/latlng/type",
                keyword: "type",
                params: {
                  type: schema47.properties.latlng.type
                },
                message: "must be string,null"
              }];
              return false;
            }
            var valid0 = _errs3 === errors;
          } else {
            var valid0 = true;
          }
          if (valid0) {
            if (data.city !== void 0) {
              let data2 = data.city;
              const _errs5 = errors;
              if (typeof data2 !== "string" && data2 !== null) {
                validate35.errors = [{
                  instancePath: instancePath + "/city",
                  schemaPath: "#/properties/city/type",
                  keyword: "type",
                  params: {
                    type: schema47.properties.city.type
                  },
                  message: "must be string,null"
                }];
                return false;
              }
              var valid0 = _errs5 === errors;
            } else {
              var valid0 = true;
            }
            if (valid0) {
              if (data.country !== void 0) {
                let data3 = data.country;
                const _errs7 = errors;
                if (typeof data3 !== "string" && data3 !== null) {
                  validate35.errors = [{
                    instancePath: instancePath + "/country",
                    schemaPath: "#/properties/country/type",
                    keyword: "type",
                    params: {
                      type: schema47.properties.country.type
                    },
                    message: "must be string,null"
                  }];
                  return false;
                }
                var valid0 = _errs7 === errors;
              } else {
                var valid0 = true;
              }
              if (valid0) {
                if (data.region !== void 0) {
                  let data4 = data.region;
                  const _errs9 = errors;
                  if (typeof data4 !== "string" && data4 !== null) {
                    validate35.errors = [{
                      instancePath: instancePath + "/region",
                      schemaPath: "#/properties/region/type",
                      keyword: "type",
                      params: {
                        type: schema47.properties.region.type
                      },
                      message: "must be string,null"
                    }];
                    return false;
                  }
                  var valid0 = _errs9 === errors;
                } else {
                  var valid0 = true;
                }
              }
            }
          }
        }
      }
    } else {
      validate35.errors = [{
        instancePath,
        schemaPath: "#/type",
        keyword: "type",
        params: {
          type: "object"
        },
        message: "must be object"
      }];
      return false;
    }
  }
  validate35.errors = vErrors;
  return errors === 0;
}
const SoldTicket = validate36;
const schema48 = {
  "$id": "SoldTicket",
  "$schema": "http://json-schema.org/draft-07/schema#",
  "type": "object",
  "properties": {
    "status": {
      "type": "string",
      "enum": ["PENDING", "ACTIVE", "REFUNDED"]
    },
    "paymentId": {
      "type": "string"
    },
    "userId": {
      "type": "string"
    },
    "eventId": {
      "type": "string"
    },
    "channelId": {
      "type": "string"
    },
    "organizationId": {
      "type": ["string", "null"]
    },
    "selectedConfig": {
      "type": "object",
      "properties": {
        "price": {
          "type": "number"
        },
        "currency": {
          "type": "string"
        }
      },
      "required": ["price", "currency"]
    },
    "ticketId": {
      "type": "string"
    },
    "eventTicketId": {
      "type": "string"
    },
    "transactionTime": {
      "type": "object",
      "format": "date-time"
    },
    "redemptionTime": {
      "anyOf": [{
        "type": "object",
        "format": "date-time"
      }, {
        "type": "null"
      }]
    },
    "videoIdsAccessed": {
      "type": "array",
      "items": {
        "type": "string"
      }
    },
    "location": {
      "anyOf": [{
        "$ref": "UserLocation"
      }, {
        "type": "null"
      }]
    }
  },
  "required": ["status", "paymentId", "userId", "eventId", "channelId", "organizationId", "selectedConfig", "ticketId", "eventTicketId", "transactionTime", "redemptionTime", "videoIdsAccessed", "location"],
  "description": "An instance of this object is saved when a user completes a payment for a given ticket (for an event). It also stores the list of videos that have been accessed using this ticket."
};
function validate36(data, {
  instancePath = "",
  parentData,
  parentDataProperty,
  rootData = data
} = {}) {
  let vErrors = null;
  let errors = 0;
  if (errors === 0) {
    if (data && typeof data == "object" && !Array.isArray(data)) {
      let missing0;
      if (data.status === void 0 && (missing0 = "status") || data.paymentId === void 0 && (missing0 = "paymentId") || data.userId === void 0 && (missing0 = "userId") || data.eventId === void 0 && (missing0 = "eventId") || data.channelId === void 0 && (missing0 = "channelId") || data.organizationId === void 0 && (missing0 = "organizationId") || data.selectedConfig === void 0 && (missing0 = "selectedConfig") || data.ticketId === void 0 && (missing0 = "ticketId") || data.eventTicketId === void 0 && (missing0 = "eventTicketId") || data.transactionTime === void 0 && (missing0 = "transactionTime") || data.redemptionTime === void 0 && (missing0 = "redemptionTime") || data.videoIdsAccessed === void 0 && (missing0 = "videoIdsAccessed") || data.location === void 0 && (missing0 = "location")) {
        validate36.errors = [{
          instancePath,
          schemaPath: "#/required",
          keyword: "required",
          params: {
            missingProperty: missing0
          },
          message: "must have required property '" + missing0 + "'"
        }];
        return false;
      } else {
        if (data.status !== void 0) {
          let data0 = data.status;
          const _errs1 = errors;
          if (typeof data0 !== "string") {
            validate36.errors = [{
              instancePath: instancePath + "/status",
              schemaPath: "#/properties/status/type",
              keyword: "type",
              params: {
                type: "string"
              },
              message: "must be string"
            }];
            return false;
          }
          if (!(data0 === "PENDING" || data0 === "ACTIVE" || data0 === "REFUNDED")) {
            validate36.errors = [{
              instancePath: instancePath + "/status",
              schemaPath: "#/properties/status/enum",
              keyword: "enum",
              params: {
                allowedValues: schema48.properties.status.enum
              },
              message: "must be equal to one of the allowed values"
            }];
            return false;
          }
          var valid0 = _errs1 === errors;
        } else {
          var valid0 = true;
        }
        if (valid0) {
          if (data.paymentId !== void 0) {
            const _errs3 = errors;
            if (typeof data.paymentId !== "string") {
              validate36.errors = [{
                instancePath: instancePath + "/paymentId",
                schemaPath: "#/properties/paymentId/type",
                keyword: "type",
                params: {
                  type: "string"
                },
                message: "must be string"
              }];
              return false;
            }
            var valid0 = _errs3 === errors;
          } else {
            var valid0 = true;
          }
          if (valid0) {
            if (data.userId !== void 0) {
              const _errs5 = errors;
              if (typeof data.userId !== "string") {
                validate36.errors = [{
                  instancePath: instancePath + "/userId",
                  schemaPath: "#/properties/userId/type",
                  keyword: "type",
                  params: {
                    type: "string"
                  },
                  message: "must be string"
                }];
                return false;
              }
              var valid0 = _errs5 === errors;
            } else {
              var valid0 = true;
            }
            if (valid0) {
              if (data.eventId !== void 0) {
                const _errs7 = errors;
                if (typeof data.eventId !== "string") {
                  validate36.errors = [{
                    instancePath: instancePath + "/eventId",
                    schemaPath: "#/properties/eventId/type",
                    keyword: "type",
                    params: {
                      type: "string"
                    },
                    message: "must be string"
                  }];
                  return false;
                }
                var valid0 = _errs7 === errors;
              } else {
                var valid0 = true;
              }
              if (valid0) {
                if (data.channelId !== void 0) {
                  const _errs9 = errors;
                  if (typeof data.channelId !== "string") {
                    validate36.errors = [{
                      instancePath: instancePath + "/channelId",
                      schemaPath: "#/properties/channelId/type",
                      keyword: "type",
                      params: {
                        type: "string"
                      },
                      message: "must be string"
                    }];
                    return false;
                  }
                  var valid0 = _errs9 === errors;
                } else {
                  var valid0 = true;
                }
                if (valid0) {
                  if (data.organizationId !== void 0) {
                    let data5 = data.organizationId;
                    const _errs11 = errors;
                    if (typeof data5 !== "string" && data5 !== null) {
                      validate36.errors = [{
                        instancePath: instancePath + "/organizationId",
                        schemaPath: "#/properties/organizationId/type",
                        keyword: "type",
                        params: {
                          type: schema48.properties.organizationId.type
                        },
                        message: "must be string,null"
                      }];
                      return false;
                    }
                    var valid0 = _errs11 === errors;
                  } else {
                    var valid0 = true;
                  }
                  if (valid0) {
                    if (data.selectedConfig !== void 0) {
                      let data6 = data.selectedConfig;
                      const _errs13 = errors;
                      if (errors === _errs13) {
                        if (data6 && typeof data6 == "object" && !Array.isArray(data6)) {
                          let missing1;
                          if (data6.price === void 0 && (missing1 = "price") || data6.currency === void 0 && (missing1 = "currency")) {
                            validate36.errors = [{
                              instancePath: instancePath + "/selectedConfig",
                              schemaPath: "#/properties/selectedConfig/required",
                              keyword: "required",
                              params: {
                                missingProperty: missing1
                              },
                              message: "must have required property '" + missing1 + "'"
                            }];
                            return false;
                          } else {
                            if (data6.price !== void 0) {
                              let data7 = data6.price;
                              const _errs15 = errors;
                              if (!(typeof data7 == "number" && isFinite(data7))) {
                                validate36.errors = [{
                                  instancePath: instancePath + "/selectedConfig/price",
                                  schemaPath: "#/properties/selectedConfig/properties/price/type",
                                  keyword: "type",
                                  params: {
                                    type: "number"
                                  },
                                  message: "must be number"
                                }];
                                return false;
                              }
                              var valid1 = _errs15 === errors;
                            } else {
                              var valid1 = true;
                            }
                            if (valid1) {
                              if (data6.currency !== void 0) {
                                const _errs17 = errors;
                                if (typeof data6.currency !== "string") {
                                  validate36.errors = [{
                                    instancePath: instancePath + "/selectedConfig/currency",
                                    schemaPath: "#/properties/selectedConfig/properties/currency/type",
                                    keyword: "type",
                                    params: {
                                      type: "string"
                                    },
                                    message: "must be string"
                                  }];
                                  return false;
                                }
                                var valid1 = _errs17 === errors;
                              } else {
                                var valid1 = true;
                              }
                            }
                          }
                        } else {
                          validate36.errors = [{
                            instancePath: instancePath + "/selectedConfig",
                            schemaPath: "#/properties/selectedConfig/type",
                            keyword: "type",
                            params: {
                              type: "object"
                            },
                            message: "must be object"
                          }];
                          return false;
                        }
                      }
                      var valid0 = _errs13 === errors;
                    } else {
                      var valid0 = true;
                    }
                    if (valid0) {
                      if (data.ticketId !== void 0) {
                        const _errs19 = errors;
                        if (typeof data.ticketId !== "string") {
                          validate36.errors = [{
                            instancePath: instancePath + "/ticketId",
                            schemaPath: "#/properties/ticketId/type",
                            keyword: "type",
                            params: {
                              type: "string"
                            },
                            message: "must be string"
                          }];
                          return false;
                        }
                        var valid0 = _errs19 === errors;
                      } else {
                        var valid0 = true;
                      }
                      if (valid0) {
                        if (data.eventTicketId !== void 0) {
                          const _errs21 = errors;
                          if (typeof data.eventTicketId !== "string") {
                            validate36.errors = [{
                              instancePath: instancePath + "/eventTicketId",
                              schemaPath: "#/properties/eventTicketId/type",
                              keyword: "type",
                              params: {
                                type: "string"
                              },
                              message: "must be string"
                            }];
                            return false;
                          }
                          var valid0 = _errs21 === errors;
                        } else {
                          var valid0 = true;
                        }
                        if (valid0) {
                          if (data.transactionTime !== void 0) {
                            let data11 = data.transactionTime;
                            const _errs23 = errors;
                            if (!(data11 && typeof data11 == "object" && !Array.isArray(data11))) {
                              validate36.errors = [{
                                instancePath: instancePath + "/transactionTime",
                                schemaPath: "#/properties/transactionTime/type",
                                keyword: "type",
                                params: {
                                  type: "object"
                                },
                                message: "must be object"
                              }];
                              return false;
                            }
                            if (errors === _errs23) {
                              if (errors === _errs23) {
                                if (typeof data11 === "string") {
                                  if (!formats0(data11)) {
                                    validate36.errors = [{
                                      instancePath: instancePath + "/transactionTime",
                                      schemaPath: "#/properties/transactionTime/format",
                                      keyword: "format",
                                      params: {
                                        format: "date-time"
                                      },
                                      message: 'must match format "date-time"'
                                    }];
                                    return false;
                                  }
                                }
                              }
                            }
                            var valid0 = _errs23 === errors;
                          } else {
                            var valid0 = true;
                          }
                          if (valid0) {
                            if (data.redemptionTime !== void 0) {
                              let data12 = data.redemptionTime;
                              const _errs25 = errors;
                              const _errs26 = errors;
                              let valid2 = false;
                              const _errs27 = errors;
                              if (!(data12 && typeof data12 == "object" && !Array.isArray(data12))) {
                                const err0 = {
                                  instancePath: instancePath + "/redemptionTime",
                                  schemaPath: "#/properties/redemptionTime/anyOf/0/type",
                                  keyword: "type",
                                  params: {
                                    type: "object"
                                  },
                                  message: "must be object"
                                };
                                if (vErrors === null) {
                                  vErrors = [err0];
                                } else {
                                  vErrors.push(err0);
                                }
                                errors++;
                              }
                              if (errors === _errs27) {
                                if (errors === _errs27) {
                                  if (typeof data12 === "string") {
                                    if (!formats0(data12)) {
                                      const err1 = {
                                        instancePath: instancePath + "/redemptionTime",
                                        schemaPath: "#/properties/redemptionTime/anyOf/0/format",
                                        keyword: "format",
                                        params: {
                                          format: "date-time"
                                        },
                                        message: 'must match format "date-time"'
                                      };
                                      if (vErrors === null) {
                                        vErrors = [err1];
                                      } else {
                                        vErrors.push(err1);
                                      }
                                      errors++;
                                    }
                                  }
                                }
                              }
                              var _valid0 = _errs27 === errors;
                              valid2 = valid2 || _valid0;
                              if (!valid2) {
                                const _errs29 = errors;
                                if (data12 !== null) {
                                  const err2 = {
                                    instancePath: instancePath + "/redemptionTime",
                                    schemaPath: "#/properties/redemptionTime/anyOf/1/type",
                                    keyword: "type",
                                    params: {
                                      type: "null"
                                    },
                                    message: "must be null"
                                  };
                                  if (vErrors === null) {
                                    vErrors = [err2];
                                  } else {
                                    vErrors.push(err2);
                                  }
                                  errors++;
                                }
                                var _valid0 = _errs29 === errors;
                                valid2 = valid2 || _valid0;
                              }
                              if (!valid2) {
                                const err3 = {
                                  instancePath: instancePath + "/redemptionTime",
                                  schemaPath: "#/properties/redemptionTime/anyOf",
                                  keyword: "anyOf",
                                  params: {},
                                  message: "must match a schema in anyOf"
                                };
                                if (vErrors === null) {
                                  vErrors = [err3];
                                } else {
                                  vErrors.push(err3);
                                }
                                errors++;
                                validate36.errors = vErrors;
                                return false;
                              } else {
                                errors = _errs26;
                                if (vErrors !== null) {
                                  if (_errs26) {
                                    vErrors.length = _errs26;
                                  } else {
                                    vErrors = null;
                                  }
                                }
                              }
                              var valid0 = _errs25 === errors;
                            } else {
                              var valid0 = true;
                            }
                            if (valid0) {
                              if (data.videoIdsAccessed !== void 0) {
                                let data13 = data.videoIdsAccessed;
                                const _errs31 = errors;
                                if (errors === _errs31) {
                                  if (Array.isArray(data13)) {
                                    var valid3 = true;
                                    const len0 = data13.length;
                                    for (let i0 = 0; i0 < len0; i0++) {
                                      const _errs33 = errors;
                                      if (typeof data13[i0] !== "string") {
                                        validate36.errors = [{
                                          instancePath: instancePath + "/videoIdsAccessed/" + i0,
                                          schemaPath: "#/properties/videoIdsAccessed/items/type",
                                          keyword: "type",
                                          params: {
                                            type: "string"
                                          },
                                          message: "must be string"
                                        }];
                                        return false;
                                      }
                                      var valid3 = _errs33 === errors;
                                      if (!valid3) {
                                        break;
                                      }
                                    }
                                  } else {
                                    validate36.errors = [{
                                      instancePath: instancePath + "/videoIdsAccessed",
                                      schemaPath: "#/properties/videoIdsAccessed/type",
                                      keyword: "type",
                                      params: {
                                        type: "array"
                                      },
                                      message: "must be array"
                                    }];
                                    return false;
                                  }
                                }
                                var valid0 = _errs31 === errors;
                              } else {
                                var valid0 = true;
                              }
                              if (valid0) {
                                if (data.location !== void 0) {
                                  let data15 = data.location;
                                  const _errs35 = errors;
                                  const _errs36 = errors;
                                  let valid4 = false;
                                  const _errs37 = errors;
                                  const _errs38 = errors;
                                  if (errors === _errs38) {
                                    if (data15 && typeof data15 == "object" && !Array.isArray(data15)) {
                                      let missing2;
                                      if (data15.IP === void 0 && (missing2 = "IP") || data15.latlng === void 0 && (missing2 = "latlng") || data15.city === void 0 && (missing2 = "city") || data15.country === void 0 && (missing2 = "country") || data15.region === void 0 && (missing2 = "region")) {
                                        const err4 = {
                                          instancePath: instancePath + "/location",
                                          schemaPath: "UserLocation/required",
                                          keyword: "required",
                                          params: {
                                            missingProperty: missing2
                                          },
                                          message: "must have required property '" + missing2 + "'"
                                        };
                                        if (vErrors === null) {
                                          vErrors = [err4];
                                        } else {
                                          vErrors.push(err4);
                                        }
                                        errors++;
                                      } else {
                                        if (data15.IP !== void 0) {
                                          let data16 = data15.IP;
                                          const _errs40 = errors;
                                          if (typeof data16 !== "string" && data16 !== null) {
                                            const err5 = {
                                              instancePath: instancePath + "/location/IP",
                                              schemaPath: "UserLocation/properties/IP/type",
                                              keyword: "type",
                                              params: {
                                                type: schema47.properties.IP.type
                                              },
                                              message: "must be string,null"
                                            };
                                            if (vErrors === null) {
                                              vErrors = [err5];
                                            } else {
                                              vErrors.push(err5);
                                            }
                                            errors++;
                                          }
                                          var valid6 = _errs40 === errors;
                                        } else {
                                          var valid6 = true;
                                        }
                                        if (valid6) {
                                          if (data15.latlng !== void 0) {
                                            let data17 = data15.latlng;
                                            const _errs42 = errors;
                                            if (typeof data17 !== "string" && data17 !== null) {
                                              const err6 = {
                                                instancePath: instancePath + "/location/latlng",
                                                schemaPath: "UserLocation/properties/latlng/type",
                                                keyword: "type",
                                                params: {
                                                  type: schema47.properties.latlng.type
                                                },
                                                message: "must be string,null"
                                              };
                                              if (vErrors === null) {
                                                vErrors = [err6];
                                              } else {
                                                vErrors.push(err6);
                                              }
                                              errors++;
                                            }
                                            var valid6 = _errs42 === errors;
                                          } else {
                                            var valid6 = true;
                                          }
                                          if (valid6) {
                                            if (data15.city !== void 0) {
                                              let data18 = data15.city;
                                              const _errs44 = errors;
                                              if (typeof data18 !== "string" && data18 !== null) {
                                                const err7 = {
                                                  instancePath: instancePath + "/location/city",
                                                  schemaPath: "UserLocation/properties/city/type",
                                                  keyword: "type",
                                                  params: {
                                                    type: schema47.properties.city.type
                                                  },
                                                  message: "must be string,null"
                                                };
                                                if (vErrors === null) {
                                                  vErrors = [err7];
                                                } else {
                                                  vErrors.push(err7);
                                                }
                                                errors++;
                                              }
                                              var valid6 = _errs44 === errors;
                                            } else {
                                              var valid6 = true;
                                            }
                                            if (valid6) {
                                              if (data15.country !== void 0) {
                                                let data19 = data15.country;
                                                const _errs46 = errors;
                                                if (typeof data19 !== "string" && data19 !== null) {
                                                  const err8 = {
                                                    instancePath: instancePath + "/location/country",
                                                    schemaPath: "UserLocation/properties/country/type",
                                                    keyword: "type",
                                                    params: {
                                                      type: schema47.properties.country.type
                                                    },
                                                    message: "must be string,null"
                                                  };
                                                  if (vErrors === null) {
                                                    vErrors = [err8];
                                                  } else {
                                                    vErrors.push(err8);
                                                  }
                                                  errors++;
                                                }
                                                var valid6 = _errs46 === errors;
                                              } else {
                                                var valid6 = true;
                                              }
                                              if (valid6) {
                                                if (data15.region !== void 0) {
                                                  let data20 = data15.region;
                                                  const _errs48 = errors;
                                                  if (typeof data20 !== "string" && data20 !== null) {
                                                    const err9 = {
                                                      instancePath: instancePath + "/location/region",
                                                      schemaPath: "UserLocation/properties/region/type",
                                                      keyword: "type",
                                                      params: {
                                                        type: schema47.properties.region.type
                                                      },
                                                      message: "must be string,null"
                                                    };
                                                    if (vErrors === null) {
                                                      vErrors = [err9];
                                                    } else {
                                                      vErrors.push(err9);
                                                    }
                                                    errors++;
                                                  }
                                                  var valid6 = _errs48 === errors;
                                                } else {
                                                  var valid6 = true;
                                                }
                                              }
                                            }
                                          }
                                        }
                                      }
                                    } else {
                                      const err10 = {
                                        instancePath: instancePath + "/location",
                                        schemaPath: "UserLocation/type",
                                        keyword: "type",
                                        params: {
                                          type: "object"
                                        },
                                        message: "must be object"
                                      };
                                      if (vErrors === null) {
                                        vErrors = [err10];
                                      } else {
                                        vErrors.push(err10);
                                      }
                                      errors++;
                                    }
                                  }
                                  var _valid1 = _errs37 === errors;
                                  valid4 = valid4 || _valid1;
                                  if (!valid4) {
                                    const _errs50 = errors;
                                    if (data15 !== null) {
                                      const err11 = {
                                        instancePath: instancePath + "/location",
                                        schemaPath: "#/properties/location/anyOf/1/type",
                                        keyword: "type",
                                        params: {
                                          type: "null"
                                        },
                                        message: "must be null"
                                      };
                                      if (vErrors === null) {
                                        vErrors = [err11];
                                      } else {
                                        vErrors.push(err11);
                                      }
                                      errors++;
                                    }
                                    var _valid1 = _errs50 === errors;
                                    valid4 = valid4 || _valid1;
                                  }
                                  if (!valid4) {
                                    const err12 = {
                                      instancePath: instancePath + "/location",
                                      schemaPath: "#/properties/location/anyOf",
                                      keyword: "anyOf",
                                      params: {},
                                      message: "must match a schema in anyOf"
                                    };
                                    if (vErrors === null) {
                                      vErrors = [err12];
                                    } else {
                                      vErrors.push(err12);
                                    }
                                    errors++;
                                    validate36.errors = vErrors;
                                    return false;
                                  } else {
                                    errors = _errs36;
                                    if (vErrors !== null) {
                                      if (_errs36) {
                                        vErrors.length = _errs36;
                                      } else {
                                        vErrors = null;
                                      }
                                    }
                                  }
                                  var valid0 = _errs35 === errors;
                                } else {
                                  var valid0 = true;
                                }
                              }
                            }
                          }
                        }
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
    } else {
      validate36.errors = [{
        instancePath,
        schemaPath: "#/type",
        keyword: "type",
        params: {
          type: "object"
        },
        message: "must be object"
      }];
      return false;
    }
  }
  validate36.errors = vErrors;
  return errors === 0;
}
const StripeSavedPaymentMethods = validate37;
function validate37(data, {
  instancePath = "",
  parentData,
  parentDataProperty,
  rootData = data
} = {}) {
  let vErrors = null;
  let errors = 0;
  {
    if (data && typeof data == "object" && !Array.isArray(data)) {
      let missing0;
      if (data.paymentMethodId === void 0 && (missing0 = "paymentMethodId") || data.type === void 0 && (missing0 = "type") || data.description === void 0 && (missing0 = "description")) {
        validate37.errors = [{
          instancePath,
          schemaPath: "#/required",
          keyword: "required",
          params: {
            missingProperty: missing0
          },
          message: "must have required property '" + missing0 + "'"
        }];
        return false;
      } else {
        if (data.paymentMethodId !== void 0) {
          const _errs1 = errors;
          if (typeof data.paymentMethodId !== "string") {
            validate37.errors = [{
              instancePath: instancePath + "/paymentMethodId",
              schemaPath: "#/properties/paymentMethodId/type",
              keyword: "type",
              params: {
                type: "string"
              },
              message: "must be string"
            }];
            return false;
          }
          var valid0 = _errs1 === errors;
        } else {
          var valid0 = true;
        }
        if (valid0) {
          if (data.type !== void 0) {
            const _errs3 = errors;
            if (typeof data.type !== "string") {
              validate37.errors = [{
                instancePath: instancePath + "/type",
                schemaPath: "#/properties/type/type",
                keyword: "type",
                params: {
                  type: "string"
                },
                message: "must be string"
              }];
              return false;
            }
            var valid0 = _errs3 === errors;
          } else {
            var valid0 = true;
          }
          if (valid0) {
            if (data.description !== void 0) {
              const _errs5 = errors;
              if (typeof data.description !== "string") {
                validate37.errors = [{
                  instancePath: instancePath + "/description",
                  schemaPath: "#/properties/description/type",
                  keyword: "type",
                  params: {
                    type: "string"
                  },
                  message: "must be string"
                }];
                return false;
              }
              var valid0 = _errs5 === errors;
            } else {
              var valid0 = true;
            }
          }
        }
      }
    } else {
      validate37.errors = [{
        instancePath,
        schemaPath: "#/type",
        keyword: "type",
        params: {
          type: "object"
        },
        message: "must be object"
      }];
      return false;
    }
  }
  validate37.errors = vErrors;
  return errors === 0;
}
const StripePaymentSystemOpaque = validate38;
function validate38(data, {
  instancePath = "",
  parentData,
  parentDataProperty,
  rootData = data
} = {}) {
  let vErrors = null;
  let errors = 0;
  {
    if (data && typeof data == "object" && !Array.isArray(data)) {
      let missing0;
      if (data.provider === void 0 && (missing0 = "provider") || data.transactionClientSecret === void 0 && (missing0 = "transactionClientSecret") || data.stripePublicKey === void 0 && (missing0 = "stripePublicKey")) {
        validate38.errors = [{
          instancePath,
          schemaPath: "#/required",
          keyword: "required",
          params: {
            missingProperty: missing0
          },
          message: "must have required property '" + missing0 + "'"
        }];
        return false;
      } else {
        if (data.provider !== void 0) {
          let data0 = data.provider;
          const _errs1 = errors;
          if (typeof data0 !== "string") {
            validate38.errors = [{
              instancePath: instancePath + "/provider",
              schemaPath: "#/properties/provider/type",
              keyword: "type",
              params: {
                type: "string"
              },
              message: "must be string"
            }];
            return false;
          }
          if ("STRIPE" !== data0) {
            validate38.errors = [{
              instancePath: instancePath + "/provider",
              schemaPath: "#/properties/provider/const",
              keyword: "const",
              params: {
                allowedValue: "STRIPE"
              },
              message: "must be equal to constant"
            }];
            return false;
          }
          var valid0 = _errs1 === errors;
        } else {
          var valid0 = true;
        }
        if (valid0) {
          if (data.transactionClientSecret !== void 0) {
            const _errs3 = errors;
            if (typeof data.transactionClientSecret !== "string") {
              validate38.errors = [{
                instancePath: instancePath + "/transactionClientSecret",
                schemaPath: "#/properties/transactionClientSecret/type",
                keyword: "type",
                params: {
                  type: "string"
                },
                message: "must be string"
              }];
              return false;
            }
            var valid0 = _errs3 === errors;
          } else {
            var valid0 = true;
          }
          if (valid0) {
            if (data.stripePublicKey !== void 0) {
              const _errs5 = errors;
              if (typeof data.stripePublicKey !== "string") {
                validate38.errors = [{
                  instancePath: instancePath + "/stripePublicKey",
                  schemaPath: "#/properties/stripePublicKey/type",
                  keyword: "type",
                  params: {
                    type: "string"
                  },
                  message: "must be string"
                }];
                return false;
              }
              var valid0 = _errs5 === errors;
            } else {
              var valid0 = true;
            }
          }
        }
      }
    } else {
      validate38.errors = [{
        instancePath,
        schemaPath: "#/type",
        keyword: "type",
        params: {
          type: "object"
        },
        message: "must be object"
      }];
      return false;
    }
  }
  validate38.errors = vErrors;
  return errors === 0;
}
const StripePaymentOptionsForUser = validate39;
function validate39(data, {
  instancePath = "",
  parentData,
  parentDataProperty,
  rootData = data
} = {}) {
  let vErrors = null;
  let errors = 0;
  {
    if (data && typeof data == "object" && !Array.isArray(data)) {
      let missing0;
      if (data.newMethodIntent === void 0 && (missing0 = "newMethodIntent") || data.environmentId === void 0 && (missing0 = "environmentId")) {
        validate39.errors = [{
          instancePath,
          schemaPath: "#/required",
          keyword: "required",
          params: {
            missingProperty: missing0
          },
          message: "must have required property '" + missing0 + "'"
        }];
        return false;
      } else {
        if (data.savedMethods !== void 0) {
          let data0 = data.savedMethods;
          const _errs1 = errors;
          {
            if (Array.isArray(data0)) {
              var valid1 = true;
              const len0 = data0.length;
              for (let i0 = 0; i0 < len0; i0++) {
                let data1 = data0[i0];
                const _errs3 = errors;
                {
                  if (data1 && typeof data1 == "object" && !Array.isArray(data1)) {
                    let missing1;
                    if (data1.paymentMethodId === void 0 && (missing1 = "paymentMethodId") || data1.type === void 0 && (missing1 = "type") || data1.description === void 0 && (missing1 = "description")) {
                      validate39.errors = [{
                        instancePath: instancePath + "/savedMethods/" + i0,
                        schemaPath: "StripeSavedPaymentMethods/required",
                        keyword: "required",
                        params: {
                          missingProperty: missing1
                        },
                        message: "must have required property '" + missing1 + "'"
                      }];
                      return false;
                    } else {
                      if (data1.paymentMethodId !== void 0) {
                        const _errs6 = errors;
                        if (typeof data1.paymentMethodId !== "string") {
                          validate39.errors = [{
                            instancePath: instancePath + "/savedMethods/" + i0 + "/paymentMethodId",
                            schemaPath: "StripeSavedPaymentMethods/properties/paymentMethodId/type",
                            keyword: "type",
                            params: {
                              type: "string"
                            },
                            message: "must be string"
                          }];
                          return false;
                        }
                        var valid3 = _errs6 === errors;
                      } else {
                        var valid3 = true;
                      }
                      if (valid3) {
                        if (data1.type !== void 0) {
                          const _errs8 = errors;
                          if (typeof data1.type !== "string") {
                            validate39.errors = [{
                              instancePath: instancePath + "/savedMethods/" + i0 + "/type",
                              schemaPath: "StripeSavedPaymentMethods/properties/type/type",
                              keyword: "type",
                              params: {
                                type: "string"
                              },
                              message: "must be string"
                            }];
                            return false;
                          }
                          var valid3 = _errs8 === errors;
                        } else {
                          var valid3 = true;
                        }
                        if (valid3) {
                          if (data1.description !== void 0) {
                            const _errs10 = errors;
                            if (typeof data1.description !== "string") {
                              validate39.errors = [{
                                instancePath: instancePath + "/savedMethods/" + i0 + "/description",
                                schemaPath: "StripeSavedPaymentMethods/properties/description/type",
                                keyword: "type",
                                params: {
                                  type: "string"
                                },
                                message: "must be string"
                              }];
                              return false;
                            }
                            var valid3 = _errs10 === errors;
                          } else {
                            var valid3 = true;
                          }
                        }
                      }
                    }
                  } else {
                    validate39.errors = [{
                      instancePath: instancePath + "/savedMethods/" + i0,
                      schemaPath: "StripeSavedPaymentMethods/type",
                      keyword: "type",
                      params: {
                        type: "object"
                      },
                      message: "must be object"
                    }];
                    return false;
                  }
                }
                var valid1 = _errs3 === errors;
                if (!valid1) {
                  break;
                }
              }
            } else {
              validate39.errors = [{
                instancePath: instancePath + "/savedMethods",
                schemaPath: "#/properties/savedMethods/type",
                keyword: "type",
                params: {
                  type: "array"
                },
                message: "must be array"
              }];
              return false;
            }
          }
          var valid0 = _errs1 === errors;
        } else {
          var valid0 = true;
        }
        if (valid0) {
          if (data.newMethodIntent !== void 0) {
            let data5 = data.newMethodIntent;
            const _errs12 = errors;
            {
              if (data5 && typeof data5 == "object" && !Array.isArray(data5)) {
                let missing2;
                if (data5.clientSecret === void 0 && (missing2 = "clientSecret") || data5.publicKey === void 0 && (missing2 = "publicKey")) {
                  validate39.errors = [{
                    instancePath: instancePath + "/newMethodIntent",
                    schemaPath: "#/properties/newMethodIntent/required",
                    keyword: "required",
                    params: {
                      missingProperty: missing2
                    },
                    message: "must have required property '" + missing2 + "'"
                  }];
                  return false;
                } else {
                  if (data5.clientSecret !== void 0) {
                    const _errs14 = errors;
                    if (typeof data5.clientSecret !== "string") {
                      validate39.errors = [{
                        instancePath: instancePath + "/newMethodIntent/clientSecret",
                        schemaPath: "#/properties/newMethodIntent/properties/clientSecret/type",
                        keyword: "type",
                        params: {
                          type: "string"
                        },
                        message: "must be string"
                      }];
                      return false;
                    }
                    var valid4 = _errs14 === errors;
                  } else {
                    var valid4 = true;
                  }
                  if (valid4) {
                    if (data5.publicKey !== void 0) {
                      const _errs16 = errors;
                      if (typeof data5.publicKey !== "string") {
                        validate39.errors = [{
                          instancePath: instancePath + "/newMethodIntent/publicKey",
                          schemaPath: "#/properties/newMethodIntent/properties/publicKey/type",
                          keyword: "type",
                          params: {
                            type: "string"
                          },
                          message: "must be string"
                        }];
                        return false;
                      }
                      var valid4 = _errs16 === errors;
                    } else {
                      var valid4 = true;
                    }
                  }
                }
              } else {
                validate39.errors = [{
                  instancePath: instancePath + "/newMethodIntent",
                  schemaPath: "#/properties/newMethodIntent/type",
                  keyword: "type",
                  params: {
                    type: "object"
                  },
                  message: "must be object"
                }];
                return false;
              }
            }
            var valid0 = _errs12 === errors;
          } else {
            var valid0 = true;
          }
          if (valid0) {
            if (data.environmentId !== void 0) {
              const _errs18 = errors;
              if (typeof data.environmentId !== "string") {
                validate39.errors = [{
                  instancePath: instancePath + "/environmentId",
                  schemaPath: "#/properties/environmentId/type",
                  keyword: "type",
                  params: {
                    type: "string"
                  },
                  message: "must be string"
                }];
                return false;
              }
              var valid0 = _errs18 === errors;
            } else {
              var valid0 = true;
            }
          }
        }
      }
    } else {
      validate39.errors = [{
        instancePath,
        schemaPath: "#/type",
        keyword: "type",
        params: {
          type: "object"
        },
        message: "must be object"
      }];
      return false;
    }
  }
  validate39.errors = vErrors;
  return errors === 0;
}
const StripeTicketMetaData = validate40;
function validate40(data, {
  instancePath = "",
  parentData,
  parentDataProperty,
  rootData = data
} = {}) {
  let vErrors = null;
  let errors = 0;
  {
    if (data && typeof data == "object" && !Array.isArray(data)) {
      let missing0;
      if (data.videoId === void 0 && (missing0 = "videoId") || data.eventId === void 0 && (missing0 = "eventId") || data.channelId === void 0 && (missing0 = "channelId") || data.organizationId === void 0 && (missing0 = "organizationId") || data.ticketEntryId === void 0 && (missing0 = "ticketEntryId") || data.userId === void 0 && (missing0 = "userId")) {
        validate40.errors = [{
          instancePath,
          schemaPath: "#/required",
          keyword: "required",
          params: {
            missingProperty: missing0
          },
          message: "must have required property '" + missing0 + "'"
        }];
        return false;
      } else {
        if (data.videoId !== void 0) {
          const _errs1 = errors;
          if (typeof data.videoId !== "string") {
            validate40.errors = [{
              instancePath: instancePath + "/videoId",
              schemaPath: "#/properties/videoId/type",
              keyword: "type",
              params: {
                type: "string"
              },
              message: "must be string"
            }];
            return false;
          }
          var valid0 = _errs1 === errors;
        } else {
          var valid0 = true;
        }
        if (valid0) {
          if (data.videoTitleDescription !== void 0) {
            const _errs3 = errors;
            if (typeof data.videoTitleDescription !== "string") {
              validate40.errors = [{
                instancePath: instancePath + "/videoTitleDescription",
                schemaPath: "#/properties/videoTitleDescription/type",
                keyword: "type",
                params: {
                  type: "string"
                },
                message: "must be string"
              }];
              return false;
            }
            var valid0 = _errs3 === errors;
          } else {
            var valid0 = true;
          }
          if (valid0) {
            if (data.eventId !== void 0) {
              const _errs5 = errors;
              if (typeof data.eventId !== "string") {
                validate40.errors = [{
                  instancePath: instancePath + "/eventId",
                  schemaPath: "#/properties/eventId/type",
                  keyword: "type",
                  params: {
                    type: "string"
                  },
                  message: "must be string"
                }];
                return false;
              }
              var valid0 = _errs5 === errors;
            } else {
              var valid0 = true;
            }
            if (valid0) {
              if (data.eventName !== void 0) {
                const _errs7 = errors;
                if (typeof data.eventName !== "string") {
                  validate40.errors = [{
                    instancePath: instancePath + "/eventName",
                    schemaPath: "#/properties/eventName/type",
                    keyword: "type",
                    params: {
                      type: "string"
                    },
                    message: "must be string"
                  }];
                  return false;
                }
                var valid0 = _errs7 === errors;
              } else {
                var valid0 = true;
              }
              if (valid0) {
                if (data.channelId !== void 0) {
                  const _errs9 = errors;
                  if (typeof data.channelId !== "string") {
                    validate40.errors = [{
                      instancePath: instancePath + "/channelId",
                      schemaPath: "#/properties/channelId/type",
                      keyword: "type",
                      params: {
                        type: "string"
                      },
                      message: "must be string"
                    }];
                    return false;
                  }
                  var valid0 = _errs9 === errors;
                } else {
                  var valid0 = true;
                }
                if (valid0) {
                  if (data.organizationId !== void 0) {
                    const _errs11 = errors;
                    if (typeof data.organizationId !== "string") {
                      validate40.errors = [{
                        instancePath: instancePath + "/organizationId",
                        schemaPath: "#/properties/organizationId/type",
                        keyword: "type",
                        params: {
                          type: "string"
                        },
                        message: "must be string"
                      }];
                      return false;
                    }
                    var valid0 = _errs11 === errors;
                  } else {
                    var valid0 = true;
                  }
                  if (valid0) {
                    if (data.ticketEntryId !== void 0) {
                      const _errs13 = errors;
                      if (typeof data.ticketEntryId !== "string") {
                        validate40.errors = [{
                          instancePath: instancePath + "/ticketEntryId",
                          schemaPath: "#/properties/ticketEntryId/type",
                          keyword: "type",
                          params: {
                            type: "string"
                          },
                          message: "must be string"
                        }];
                        return false;
                      }
                      var valid0 = _errs13 === errors;
                    } else {
                      var valid0 = true;
                    }
                    if (valid0) {
                      if (data.userId !== void 0) {
                        const _errs15 = errors;
                        if (typeof data.userId !== "string") {
                          validate40.errors = [{
                            instancePath: instancePath + "/userId",
                            schemaPath: "#/properties/userId/type",
                            keyword: "type",
                            params: {
                              type: "string"
                            },
                            message: "must be string"
                          }];
                          return false;
                        }
                        var valid0 = _errs15 === errors;
                      } else {
                        var valid0 = true;
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
    } else {
      validate40.errors = [{
        instancePath,
        schemaPath: "#/type",
        keyword: "type",
        params: {
          type: "object"
        },
        message: "must be object"
      }];
      return false;
    }
  }
  validate40.errors = vErrors;
  return errors === 0;
}
const StripeSubscriptionMetadata = validate41;
function validate41(data, {
  instancePath = "",
  parentData,
  parentDataProperty,
  rootData = data
} = {}) {
  let vErrors = null;
  let errors = 0;
  {
    if (data && typeof data == "object" && !Array.isArray(data)) {
      let missing0;
      if (data.channelId === void 0 && (missing0 = "channelId") || data.organizationId === void 0 && (missing0 = "organizationId") || data.planId === void 0 && (missing0 = "planId") || data.userId === void 0 && (missing0 = "userId") || data.subscriptionId === void 0 && (missing0 = "subscriptionId")) {
        validate41.errors = [{
          instancePath,
          schemaPath: "#/required",
          keyword: "required",
          params: {
            missingProperty: missing0
          },
          message: "must have required property '" + missing0 + "'"
        }];
        return false;
      } else {
        if (data.channelId !== void 0) {
          const _errs1 = errors;
          if (typeof data.channelId !== "string") {
            validate41.errors = [{
              instancePath: instancePath + "/channelId",
              schemaPath: "#/properties/channelId/type",
              keyword: "type",
              params: {
                type: "string"
              },
              message: "must be string"
            }];
            return false;
          }
          var valid0 = _errs1 === errors;
        } else {
          var valid0 = true;
        }
        if (valid0) {
          if (data.organizationId !== void 0) {
            const _errs3 = errors;
            if (typeof data.organizationId !== "string") {
              validate41.errors = [{
                instancePath: instancePath + "/organizationId",
                schemaPath: "#/properties/organizationId/type",
                keyword: "type",
                params: {
                  type: "string"
                },
                message: "must be string"
              }];
              return false;
            }
            var valid0 = _errs3 === errors;
          } else {
            var valid0 = true;
          }
          if (valid0) {
            if (data.planId !== void 0) {
              const _errs5 = errors;
              if (typeof data.planId !== "string") {
                validate41.errors = [{
                  instancePath: instancePath + "/planId",
                  schemaPath: "#/properties/planId/type",
                  keyword: "type",
                  params: {
                    type: "string"
                  },
                  message: "must be string"
                }];
                return false;
              }
              var valid0 = _errs5 === errors;
            } else {
              var valid0 = true;
            }
            if (valid0) {
              if (data.userId !== void 0) {
                const _errs7 = errors;
                if (typeof data.userId !== "string") {
                  validate41.errors = [{
                    instancePath: instancePath + "/userId",
                    schemaPath: "#/properties/userId/type",
                    keyword: "type",
                    params: {
                      type: "string"
                    },
                    message: "must be string"
                  }];
                  return false;
                }
                var valid0 = _errs7 === errors;
              } else {
                var valid0 = true;
              }
              if (valid0) {
                if (data.subscriptionId !== void 0) {
                  const _errs9 = errors;
                  if (typeof data.subscriptionId !== "string") {
                    validate41.errors = [{
                      instancePath: instancePath + "/subscriptionId",
                      schemaPath: "#/properties/subscriptionId/type",
                      keyword: "type",
                      params: {
                        type: "string"
                      },
                      message: "must be string"
                    }];
                    return false;
                  }
                  var valid0 = _errs9 === errors;
                } else {
                  var valid0 = true;
                }
                if (valid0) {
                  if (data.app_canceled !== void 0) {
                    const _errs11 = errors;
                    if (typeof data.app_canceled !== "string") {
                      validate41.errors = [{
                        instancePath: instancePath + "/app_canceled",
                        schemaPath: "#/properties/app_canceled/type",
                        keyword: "type",
                        params: {
                          type: "string"
                        },
                        message: "must be string"
                      }];
                      return false;
                    }
                    var valid0 = _errs11 === errors;
                  } else {
                    var valid0 = true;
                  }
                  if (valid0) {
                    if (data.proxy_promo_code !== void 0) {
                      const _errs13 = errors;
                      if (typeof data.proxy_promo_code !== "string") {
                        validate41.errors = [{
                          instancePath: instancePath + "/proxy_promo_code",
                          schemaPath: "#/properties/proxy_promo_code/type",
                          keyword: "type",
                          params: {
                            type: "string"
                          },
                          message: "must be string"
                        }];
                        return false;
                      }
                      var valid0 = _errs13 === errors;
                    } else {
                      var valid0 = true;
                    }
                    if (valid0) {
                      if (data.initial_discount_phase !== void 0) {
                        const _errs15 = errors;
                        if (typeof data.initial_discount_phase !== "string") {
                          validate41.errors = [{
                            instancePath: instancePath + "/initial_discount_phase",
                            schemaPath: "#/properties/initial_discount_phase/type",
                            keyword: "type",
                            params: {
                              type: "string"
                            },
                            message: "must be string"
                          }];
                          return false;
                        }
                        var valid0 = _errs15 === errors;
                      } else {
                        var valid0 = true;
                      }
                      if (valid0) {
                        if (data.initial_discount_renewal_price !== void 0) {
                          const _errs17 = errors;
                          if (typeof data.initial_discount_renewal_price !== "string") {
                            validate41.errors = [{
                              instancePath: instancePath + "/initial_discount_renewal_price",
                              schemaPath: "#/properties/initial_discount_renewal_price/type",
                              keyword: "type",
                              params: {
                                type: "string"
                              },
                              message: "must be string"
                            }];
                            return false;
                          }
                          var valid0 = _errs17 === errors;
                        } else {
                          var valid0 = true;
                        }
                        if (valid0) {
                          if (data.initial_discount_price !== void 0) {
                            const _errs19 = errors;
                            if (typeof data.initial_discount_price !== "string") {
                              validate41.errors = [{
                                instancePath: instancePath + "/initial_discount_price",
                                schemaPath: "#/properties/initial_discount_price/type",
                                keyword: "type",
                                params: {
                                  type: "string"
                                },
                                message: "must be string"
                              }];
                              return false;
                            }
                            var valid0 = _errs19 === errors;
                          } else {
                            var valid0 = true;
                          }
                          if (valid0) {
                            if (data.initial_discount_phase_is_until !== void 0) {
                              const _errs21 = errors;
                              if (typeof data.initial_discount_phase_is_until !== "string") {
                                validate41.errors = [{
                                  instancePath: instancePath + "/initial_discount_phase_is_until",
                                  schemaPath: "#/properties/initial_discount_phase_is_until/type",
                                  keyword: "type",
                                  params: {
                                    type: "string"
                                  },
                                  message: "must be string"
                                }];
                                return false;
                              }
                              var valid0 = _errs21 === errors;
                            } else {
                              var valid0 = true;
                            }
                          }
                        }
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
    } else {
      validate41.errors = [{
        instancePath,
        schemaPath: "#/type",
        keyword: "type",
        params: {
          type: "object"
        },
        message: "must be object"
      }];
      return false;
    }
  }
  validate41.errors = vErrors;
  return errors === 0;
}
const StripeCouponMetadata = validate42;
function validate42(data, {
  instancePath = "",
  parentData,
  parentDataProperty,
  rootData = data
} = {}) {
  let vErrors = null;
  let errors = 0;
  {
    if (data && typeof data == "object" && !Array.isArray(data)) {
      if (data.planId !== void 0) {
        const _errs1 = errors;
        if (typeof data.planId !== "string") {
          validate42.errors = [{
            instancePath: instancePath + "/planId",
            schemaPath: "#/properties/planId/type",
            keyword: "type",
            params: {
              type: "string"
            },
            message: "must be string"
          }];
          return false;
        }
        var valid0 = _errs1 === errors;
      } else {
        var valid0 = true;
      }
      if (valid0) {
        if (data.channelId !== void 0) {
          const _errs3 = errors;
          if (typeof data.channelId !== "string") {
            validate42.errors = [{
              instancePath: instancePath + "/channelId",
              schemaPath: "#/properties/channelId/type",
              keyword: "type",
              params: {
                type: "string"
              },
              message: "must be string"
            }];
            return false;
          }
          var valid0 = _errs3 === errors;
        } else {
          var valid0 = true;
        }
        if (valid0) {
          if (data.organizationId !== void 0) {
            const _errs5 = errors;
            if (typeof data.organizationId !== "string") {
              validate42.errors = [{
                instancePath: instancePath + "/organizationId",
                schemaPath: "#/properties/organizationId/type",
                keyword: "type",
                params: {
                  type: "string"
                },
                message: "must be string"
              }];
              return false;
            }
            var valid0 = _errs5 === errors;
          } else {
            var valid0 = true;
          }
          if (valid0) {
            if (data.periodicity !== void 0) {
              const _errs7 = errors;
              if (typeof data.periodicity !== "string") {
                validate42.errors = [{
                  instancePath: instancePath + "/periodicity",
                  schemaPath: "#/properties/periodicity/type",
                  keyword: "type",
                  params: {
                    type: "string"
                  },
                  message: "must be string"
                }];
                return false;
              }
              var valid0 = _errs7 === errors;
            } else {
              var valid0 = true;
            }
          }
        }
      }
    } else {
      validate42.errors = [{
        instancePath,
        schemaPath: "#/type",
        keyword: "type",
        params: {
          type: "object"
        },
        message: "must be object"
      }];
      return false;
    }
  }
  validate42.errors = vErrors;
  return errors === 0;
}
const BuyTicketRequest = validate43;
function validate43(data, {
  instancePath = "",
  parentData,
  parentDataProperty,
  rootData = data
} = {}) {
  let vErrors = null;
  let errors = 0;
  {
    if (data && typeof data == "object" && !Array.isArray(data)) {
      let missing0;
      if (data.channelId === void 0 && (missing0 = "channelId") || data.eventId === void 0 && (missing0 = "eventId") || data.ticketId === void 0 && (missing0 = "ticketId") || data.paymentMethodId === void 0 && (missing0 = "paymentMethodId")) {
        validate43.errors = [{
          instancePath,
          schemaPath: "#/required",
          keyword: "required",
          params: {
            missingProperty: missing0
          },
          message: "must have required property '" + missing0 + "'"
        }];
        return false;
      } else {
        if (data.channelId !== void 0) {
          const _errs1 = errors;
          if (typeof data.channelId !== "string") {
            validate43.errors = [{
              instancePath: instancePath + "/channelId",
              schemaPath: "#/properties/channelId/type",
              keyword: "type",
              params: {
                type: "string"
              },
              message: "must be string"
            }];
            return false;
          }
          var valid0 = _errs1 === errors;
        } else {
          var valid0 = true;
        }
        if (valid0) {
          if (data.eventId !== void 0) {
            const _errs3 = errors;
            if (typeof data.eventId !== "string") {
              validate43.errors = [{
                instancePath: instancePath + "/eventId",
                schemaPath: "#/properties/eventId/type",
                keyword: "type",
                params: {
                  type: "string"
                },
                message: "must be string"
              }];
              return false;
            }
            var valid0 = _errs3 === errors;
          } else {
            var valid0 = true;
          }
          if (valid0) {
            if (data.ticketId !== void 0) {
              const _errs5 = errors;
              if (typeof data.ticketId !== "string") {
                validate43.errors = [{
                  instancePath: instancePath + "/ticketId",
                  schemaPath: "#/properties/ticketId/type",
                  keyword: "type",
                  params: {
                    type: "string"
                  },
                  message: "must be string"
                }];
                return false;
              }
              var valid0 = _errs5 === errors;
            } else {
              var valid0 = true;
            }
            if (valid0) {
              if (data.videoId !== void 0) {
                const _errs7 = errors;
                if (typeof data.videoId !== "string") {
                  validate43.errors = [{
                    instancePath: instancePath + "/videoId",
                    schemaPath: "#/properties/videoId/type",
                    keyword: "type",
                    params: {
                      type: "string"
                    },
                    message: "must be string"
                  }];
                  return false;
                }
                var valid0 = _errs7 === errors;
              } else {
                var valid0 = true;
              }
              if (valid0) {
                if (data.selectedCurrency !== void 0) {
                  const _errs9 = errors;
                  if (typeof data.selectedCurrency !== "string") {
                    validate43.errors = [{
                      instancePath: instancePath + "/selectedCurrency",
                      schemaPath: "#/properties/selectedCurrency/type",
                      keyword: "type",
                      params: {
                        type: "string"
                      },
                      message: "must be string"
                    }];
                    return false;
                  }
                  var valid0 = _errs9 === errors;
                } else {
                  var valid0 = true;
                }
                if (valid0) {
                  if (data.paymentMethodId !== void 0) {
                    const _errs11 = errors;
                    if (typeof data.paymentMethodId !== "string") {
                      validate43.errors = [{
                        instancePath: instancePath + "/paymentMethodId",
                        schemaPath: "#/properties/paymentMethodId/type",
                        keyword: "type",
                        params: {
                          type: "string"
                        },
                        message: "must be string"
                      }];
                      return false;
                    }
                    var valid0 = _errs11 === errors;
                  } else {
                    var valid0 = true;
                  }
                }
              }
            }
          }
        }
      }
    } else {
      validate43.errors = [{
        instancePath,
        schemaPath: "#/type",
        keyword: "type",
        params: {
          type: "object"
        },
        message: "must be object"
      }];
      return false;
    }
  }
  validate43.errors = vErrors;
  return errors === 0;
}
const BuyTicketSuccessfulResponse = validate44;
function validate44(data, {
  instancePath = "",
  parentData,
  parentDataProperty,
  rootData = data
} = {}) {
  let vErrors = null;
  let errors = 0;
  if (errors === 0) {
    if (data && typeof data == "object" && !Array.isArray(data)) {
      let missing0;
      if (data.success === void 0 && (missing0 = "success") || data.ticketEntryId === void 0 && (missing0 = "ticketEntryId") || data.ticketEntry === void 0 && (missing0 = "ticketEntry") || data.paymentSystemOpaque === void 0 && (missing0 = "paymentSystemOpaque")) {
        validate44.errors = [{
          instancePath,
          schemaPath: "#/required",
          keyword: "required",
          params: {
            missingProperty: missing0
          },
          message: "must have required property '" + missing0 + "'"
        }];
        return false;
      } else {
        if (data.success !== void 0) {
          let data0 = data.success;
          const _errs1 = errors;
          if (typeof data0 !== "boolean") {
            validate44.errors = [{
              instancePath: instancePath + "/success",
              schemaPath: "#/properties/success/type",
              keyword: "type",
              params: {
                type: "boolean"
              },
              message: "must be boolean"
            }];
            return false;
          }
          if (true !== data0) {
            validate44.errors = [{
              instancePath: instancePath + "/success",
              schemaPath: "#/properties/success/const",
              keyword: "const",
              params: {
                allowedValue: true
              },
              message: "must be equal to constant"
            }];
            return false;
          }
          var valid0 = _errs1 === errors;
        } else {
          var valid0 = true;
        }
        if (valid0) {
          if (data.ticketEntryId !== void 0) {
            const _errs3 = errors;
            if (typeof data.ticketEntryId !== "string") {
              validate44.errors = [{
                instancePath: instancePath + "/ticketEntryId",
                schemaPath: "#/properties/ticketEntryId/type",
                keyword: "type",
                params: {
                  type: "string"
                },
                message: "must be string"
              }];
              return false;
            }
            var valid0 = _errs3 === errors;
          } else {
            var valid0 = true;
          }
          if (valid0) {
            if (data.ticketEntry !== void 0) {
              const _errs5 = errors;
              if (!validate36(data.ticketEntry, {
                instancePath: instancePath + "/ticketEntry",
                parentData: data,
                parentDataProperty: "ticketEntry",
                rootData
              })) {
                vErrors = vErrors === null ? validate36.errors : vErrors.concat(validate36.errors);
                errors = vErrors.length;
              }
              var valid0 = _errs5 === errors;
            } else {
              var valid0 = true;
            }
            if (valid0) {
              if (data.paymentSystemOpaque !== void 0) {
                let data3 = data.paymentSystemOpaque;
                const _errs6 = errors;
                const _errs7 = errors;
                if (errors === _errs7) {
                  if (data3 && typeof data3 == "object" && !Array.isArray(data3)) {
                    let missing1;
                    if (data3.provider === void 0 && (missing1 = "provider") || data3.transactionClientSecret === void 0 && (missing1 = "transactionClientSecret") || data3.stripePublicKey === void 0 && (missing1 = "stripePublicKey")) {
                      validate44.errors = [{
                        instancePath: instancePath + "/paymentSystemOpaque",
                        schemaPath: "StripePaymentSystemOpaque/required",
                        keyword: "required",
                        params: {
                          missingProperty: missing1
                        },
                        message: "must have required property '" + missing1 + "'"
                      }];
                      return false;
                    } else {
                      if (data3.provider !== void 0) {
                        let data4 = data3.provider;
                        const _errs9 = errors;
                        if (typeof data4 !== "string") {
                          validate44.errors = [{
                            instancePath: instancePath + "/paymentSystemOpaque/provider",
                            schemaPath: "StripePaymentSystemOpaque/properties/provider/type",
                            keyword: "type",
                            params: {
                              type: "string"
                            },
                            message: "must be string"
                          }];
                          return false;
                        }
                        if ("STRIPE" !== data4) {
                          validate44.errors = [{
                            instancePath: instancePath + "/paymentSystemOpaque/provider",
                            schemaPath: "StripePaymentSystemOpaque/properties/provider/const",
                            keyword: "const",
                            params: {
                              allowedValue: "STRIPE"
                            },
                            message: "must be equal to constant"
                          }];
                          return false;
                        }
                        var valid2 = _errs9 === errors;
                      } else {
                        var valid2 = true;
                      }
                      if (valid2) {
                        if (data3.transactionClientSecret !== void 0) {
                          const _errs11 = errors;
                          if (typeof data3.transactionClientSecret !== "string") {
                            validate44.errors = [{
                              instancePath: instancePath + "/paymentSystemOpaque/transactionClientSecret",
                              schemaPath: "StripePaymentSystemOpaque/properties/transactionClientSecret/type",
                              keyword: "type",
                              params: {
                                type: "string"
                              },
                              message: "must be string"
                            }];
                            return false;
                          }
                          var valid2 = _errs11 === errors;
                        } else {
                          var valid2 = true;
                        }
                        if (valid2) {
                          if (data3.stripePublicKey !== void 0) {
                            const _errs13 = errors;
                            if (typeof data3.stripePublicKey !== "string") {
                              validate44.errors = [{
                                instancePath: instancePath + "/paymentSystemOpaque/stripePublicKey",
                                schemaPath: "StripePaymentSystemOpaque/properties/stripePublicKey/type",
                                keyword: "type",
                                params: {
                                  type: "string"
                                },
                                message: "must be string"
                              }];
                              return false;
                            }
                            var valid2 = _errs13 === errors;
                          } else {
                            var valid2 = true;
                          }
                        }
                      }
                    }
                  } else {
                    validate44.errors = [{
                      instancePath: instancePath + "/paymentSystemOpaque",
                      schemaPath: "StripePaymentSystemOpaque/type",
                      keyword: "type",
                      params: {
                        type: "object"
                      },
                      message: "must be object"
                    }];
                    return false;
                  }
                }
                var valid0 = _errs6 === errors;
              } else {
                var valid0 = true;
              }
            }
          }
        }
      }
    } else {
      validate44.errors = [{
        instancePath,
        schemaPath: "#/type",
        keyword: "type",
        params: {
          type: "object"
        },
        message: "must be object"
      }];
      return false;
    }
  }
  validate44.errors = vErrors;
  return errors === 0;
}
const BuyTicketErrorResponse = validate46;
function validate46(data, {
  instancePath = "",
  parentData,
  parentDataProperty,
  rootData = data
} = {}) {
  let vErrors = null;
  let errors = 0;
  {
    if (data && typeof data == "object" && !Array.isArray(data)) {
      let missing0;
      if (data.success === void 0 && (missing0 = "success") || data.errorReason === void 0 && (missing0 = "errorReason")) {
        validate46.errors = [{
          instancePath,
          schemaPath: "#/required",
          keyword: "required",
          params: {
            missingProperty: missing0
          },
          message: "must have required property '" + missing0 + "'"
        }];
        return false;
      } else {
        if (data.success !== void 0) {
          let data0 = data.success;
          const _errs1 = errors;
          if (typeof data0 !== "boolean") {
            validate46.errors = [{
              instancePath: instancePath + "/success",
              schemaPath: "#/properties/success/type",
              keyword: "type",
              params: {
                type: "boolean"
              },
              message: "must be boolean"
            }];
            return false;
          }
          if (false !== data0) {
            validate46.errors = [{
              instancePath: instancePath + "/success",
              schemaPath: "#/properties/success/const",
              keyword: "const",
              params: {
                allowedValue: false
              },
              message: "must be equal to constant"
            }];
            return false;
          }
          var valid0 = _errs1 === errors;
        } else {
          var valid0 = true;
        }
        if (valid0) {
          if (data.errorReason !== void 0) {
            const _errs3 = errors;
            if (typeof data.errorReason !== "string") {
              validate46.errors = [{
                instancePath: instancePath + "/errorReason",
                schemaPath: "#/properties/errorReason/type",
                keyword: "type",
                params: {
                  type: "string"
                },
                message: "must be string"
              }];
              return false;
            }
            var valid0 = _errs3 === errors;
          } else {
            var valid0 = true;
          }
        }
      }
    } else {
      validate46.errors = [{
        instancePath,
        schemaPath: "#/type",
        keyword: "type",
        params: {
          type: "object"
        },
        message: "must be object"
      }];
      return false;
    }
  }
  validate46.errors = vErrors;
  return errors === 0;
}
const BuyTicketResponse = validate47;
function validate47(data, {
  instancePath = "",
  parentData,
  parentDataProperty,
  rootData = data
} = {}) {
  let vErrors = null;
  let errors = 0;
  const _errs0 = errors;
  let valid0 = false;
  const _errs1 = errors;
  if (!validate44(data, {
    instancePath,
    parentData,
    parentDataProperty,
    rootData
  })) {
    vErrors = vErrors === null ? validate44.errors : vErrors.concat(validate44.errors);
    errors = vErrors.length;
  }
  var _valid0 = _errs1 === errors;
  valid0 = valid0 || _valid0;
  if (!valid0) {
    const _errs2 = errors;
    const _errs3 = errors;
    if (errors === _errs3) {
      if (data && typeof data == "object" && !Array.isArray(data)) {
        let missing0;
        if (data.success === void 0 && (missing0 = "success") || data.errorReason === void 0 && (missing0 = "errorReason")) {
          const err0 = {
            instancePath,
            schemaPath: "BuyTicketErrorResponse/required",
            keyword: "required",
            params: {
              missingProperty: missing0
            },
            message: "must have required property '" + missing0 + "'"
          };
          if (vErrors === null) {
            vErrors = [err0];
          } else {
            vErrors.push(err0);
          }
          errors++;
        } else {
          if (data.success !== void 0) {
            let data0 = data.success;
            const _errs5 = errors;
            if (typeof data0 !== "boolean") {
              const err1 = {
                instancePath: instancePath + "/success",
                schemaPath: "BuyTicketErrorResponse/properties/success/type",
                keyword: "type",
                params: {
                  type: "boolean"
                },
                message: "must be boolean"
              };
              if (vErrors === null) {
                vErrors = [err1];
              } else {
                vErrors.push(err1);
              }
              errors++;
            }
            if (false !== data0) {
              const err2 = {
                instancePath: instancePath + "/success",
                schemaPath: "BuyTicketErrorResponse/properties/success/const",
                keyword: "const",
                params: {
                  allowedValue: false
                },
                message: "must be equal to constant"
              };
              if (vErrors === null) {
                vErrors = [err2];
              } else {
                vErrors.push(err2);
              }
              errors++;
            }
            var valid2 = _errs5 === errors;
          } else {
            var valid2 = true;
          }
          if (valid2) {
            if (data.errorReason !== void 0) {
              const _errs7 = errors;
              if (typeof data.errorReason !== "string") {
                const err3 = {
                  instancePath: instancePath + "/errorReason",
                  schemaPath: "BuyTicketErrorResponse/properties/errorReason/type",
                  keyword: "type",
                  params: {
                    type: "string"
                  },
                  message: "must be string"
                };
                if (vErrors === null) {
                  vErrors = [err3];
                } else {
                  vErrors.push(err3);
                }
                errors++;
              }
              var valid2 = _errs7 === errors;
            } else {
              var valid2 = true;
            }
          }
        }
      } else {
        const err4 = {
          instancePath,
          schemaPath: "BuyTicketErrorResponse/type",
          keyword: "type",
          params: {
            type: "object"
          },
          message: "must be object"
        };
        if (vErrors === null) {
          vErrors = [err4];
        } else {
          vErrors.push(err4);
        }
        errors++;
      }
    }
    var _valid0 = _errs2 === errors;
    valid0 = valid0 || _valid0;
  }
  if (!valid0) {
    const err5 = {
      instancePath,
      schemaPath: "#/anyOf",
      keyword: "anyOf",
      params: {},
      message: "must match a schema in anyOf"
    };
    if (vErrors === null) {
      vErrors = [err5];
    } else {
      vErrors.push(err5);
    }
    errors++;
    validate47.errors = vErrors;
    return false;
  } else {
    errors = _errs0;
    if (vErrors !== null) {
      if (_errs0) {
        vErrors.length = _errs0;
      } else {
        vErrors = null;
      }
    }
  }
  validate47.errors = vErrors;
  return errors === 0;
}
const EventListSource = validate49;
const schema63 = {
  "$id": "EventListSource",
  "$schema": "http://json-schema.org/draft-07/schema#",
  "type": "object",
  "properties": {
    "eventIds": {
      "type": "array",
      "items": {
        "type": "string"
      }
    },
    "onlyState": {
      "type": "string",
      "enum": ["UPCOMING", "ACTIVE", "PASSED", "ACTIVE_AND_UPCOMING", "PASSED_AND_ACTIVE"]
    }
  }
};
function validate49(data, {
  instancePath = "",
  parentData,
  parentDataProperty,
  rootData = data
} = {}) {
  let vErrors = null;
  let errors = 0;
  {
    if (data && typeof data == "object" && !Array.isArray(data)) {
      if (data.eventIds !== void 0) {
        let data0 = data.eventIds;
        const _errs1 = errors;
        {
          if (Array.isArray(data0)) {
            var valid1 = true;
            const len0 = data0.length;
            for (let i0 = 0; i0 < len0; i0++) {
              const _errs3 = errors;
              if (typeof data0[i0] !== "string") {
                validate49.errors = [{
                  instancePath: instancePath + "/eventIds/" + i0,
                  schemaPath: "#/properties/eventIds/items/type",
                  keyword: "type",
                  params: {
                    type: "string"
                  },
                  message: "must be string"
                }];
                return false;
              }
              var valid1 = _errs3 === errors;
              if (!valid1) {
                break;
              }
            }
          } else {
            validate49.errors = [{
              instancePath: instancePath + "/eventIds",
              schemaPath: "#/properties/eventIds/type",
              keyword: "type",
              params: {
                type: "array"
              },
              message: "must be array"
            }];
            return false;
          }
        }
        var valid0 = _errs1 === errors;
      } else {
        var valid0 = true;
      }
      if (valid0) {
        if (data.onlyState !== void 0) {
          let data2 = data.onlyState;
          const _errs5 = errors;
          if (typeof data2 !== "string") {
            validate49.errors = [{
              instancePath: instancePath + "/onlyState",
              schemaPath: "#/properties/onlyState/type",
              keyword: "type",
              params: {
                type: "string"
              },
              message: "must be string"
            }];
            return false;
          }
          if (!(data2 === "UPCOMING" || data2 === "ACTIVE" || data2 === "PASSED" || data2 === "ACTIVE_AND_UPCOMING" || data2 === "PASSED_AND_ACTIVE")) {
            validate49.errors = [{
              instancePath: instancePath + "/onlyState",
              schemaPath: "#/properties/onlyState/enum",
              keyword: "enum",
              params: {
                allowedValues: schema63.properties.onlyState.enum
              },
              message: "must be equal to one of the allowed values"
            }];
            return false;
          }
          var valid0 = _errs5 === errors;
        } else {
          var valid0 = true;
        }
      }
    } else {
      validate49.errors = [{
        instancePath,
        schemaPath: "#/type",
        keyword: "type",
        params: {
          type: "object"
        },
        message: "must be object"
      }];
      return false;
    }
  }
  validate49.errors = vErrors;
  return errors === 0;
}
const EventListModule = validate50;
const schema64 = {
  "$id": "EventListModule",
  "$schema": "http://json-schema.org/draft-07/schema#",
  "type": "object",
  "properties": {
    "moduleType": {
      "type": "string",
      "const": "EVENTS_LIST"
    },
    "heading": {
      "type": "string"
    },
    "subHeading": {
      "type": "string"
    },
    "layoutType": {
      "type": "string",
      "enum": ["CAROUSEL", "GRID"]
    },
    "density": {
      "type": "string",
      "enum": ["NORMAL", "DENSE", "DENSEST"]
    },
    "preferedGridSize": {
      "type": "object",
      "properties": {
        "columns": {
          "type": "number"
        },
        "rows": {
          "type": "number"
        }
      },
      "required": ["columns", "rows"]
    },
    "listSource": {
      "$ref": "EventListSource"
    },
    "sort": {
      "type": "string",
      "const": "DATE"
    },
    "order": {
      "type": "string",
      "enum": ["ASC", "DESC"]
    },
    "size": {
      "type": "number"
    }
  },
  "required": ["density", "layoutType", "listSource", "moduleType", "size"],
  "description": "Specifies a list of events to be shown in cards. The list can be static, or dynamic"
};
function validate50(data, {
  instancePath = "",
  parentData,
  parentDataProperty,
  rootData = data
} = {}) {
  let vErrors = null;
  let errors = 0;
  {
    if (data && typeof data == "object" && !Array.isArray(data)) {
      let missing0;
      if (data.density === void 0 && (missing0 = "density") || data.layoutType === void 0 && (missing0 = "layoutType") || data.listSource === void 0 && (missing0 = "listSource") || data.moduleType === void 0 && (missing0 = "moduleType") || data.size === void 0 && (missing0 = "size")) {
        validate50.errors = [{
          instancePath,
          schemaPath: "#/required",
          keyword: "required",
          params: {
            missingProperty: missing0
          },
          message: "must have required property '" + missing0 + "'"
        }];
        return false;
      } else {
        if (data.moduleType !== void 0) {
          let data0 = data.moduleType;
          const _errs1 = errors;
          if (typeof data0 !== "string") {
            validate50.errors = [{
              instancePath: instancePath + "/moduleType",
              schemaPath: "#/properties/moduleType/type",
              keyword: "type",
              params: {
                type: "string"
              },
              message: "must be string"
            }];
            return false;
          }
          if ("EVENTS_LIST" !== data0) {
            validate50.errors = [{
              instancePath: instancePath + "/moduleType",
              schemaPath: "#/properties/moduleType/const",
              keyword: "const",
              params: {
                allowedValue: "EVENTS_LIST"
              },
              message: "must be equal to constant"
            }];
            return false;
          }
          var valid0 = _errs1 === errors;
        } else {
          var valid0 = true;
        }
        if (valid0) {
          if (data.heading !== void 0) {
            const _errs3 = errors;
            if (typeof data.heading !== "string") {
              validate50.errors = [{
                instancePath: instancePath + "/heading",
                schemaPath: "#/properties/heading/type",
                keyword: "type",
                params: {
                  type: "string"
                },
                message: "must be string"
              }];
              return false;
            }
            var valid0 = _errs3 === errors;
          } else {
            var valid0 = true;
          }
          if (valid0) {
            if (data.subHeading !== void 0) {
              const _errs5 = errors;
              if (typeof data.subHeading !== "string") {
                validate50.errors = [{
                  instancePath: instancePath + "/subHeading",
                  schemaPath: "#/properties/subHeading/type",
                  keyword: "type",
                  params: {
                    type: "string"
                  },
                  message: "must be string"
                }];
                return false;
              }
              var valid0 = _errs5 === errors;
            } else {
              var valid0 = true;
            }
            if (valid0) {
              if (data.layoutType !== void 0) {
                let data3 = data.layoutType;
                const _errs7 = errors;
                if (typeof data3 !== "string") {
                  validate50.errors = [{
                    instancePath: instancePath + "/layoutType",
                    schemaPath: "#/properties/layoutType/type",
                    keyword: "type",
                    params: {
                      type: "string"
                    },
                    message: "must be string"
                  }];
                  return false;
                }
                if (!(data3 === "CAROUSEL" || data3 === "GRID")) {
                  validate50.errors = [{
                    instancePath: instancePath + "/layoutType",
                    schemaPath: "#/properties/layoutType/enum",
                    keyword: "enum",
                    params: {
                      allowedValues: schema64.properties.layoutType.enum
                    },
                    message: "must be equal to one of the allowed values"
                  }];
                  return false;
                }
                var valid0 = _errs7 === errors;
              } else {
                var valid0 = true;
              }
              if (valid0) {
                if (data.density !== void 0) {
                  let data4 = data.density;
                  const _errs9 = errors;
                  if (typeof data4 !== "string") {
                    validate50.errors = [{
                      instancePath: instancePath + "/density",
                      schemaPath: "#/properties/density/type",
                      keyword: "type",
                      params: {
                        type: "string"
                      },
                      message: "must be string"
                    }];
                    return false;
                  }
                  if (!(data4 === "NORMAL" || data4 === "DENSE" || data4 === "DENSEST")) {
                    validate50.errors = [{
                      instancePath: instancePath + "/density",
                      schemaPath: "#/properties/density/enum",
                      keyword: "enum",
                      params: {
                        allowedValues: schema64.properties.density.enum
                      },
                      message: "must be equal to one of the allowed values"
                    }];
                    return false;
                  }
                  var valid0 = _errs9 === errors;
                } else {
                  var valid0 = true;
                }
                if (valid0) {
                  if (data.preferedGridSize !== void 0) {
                    let data5 = data.preferedGridSize;
                    const _errs11 = errors;
                    {
                      if (data5 && typeof data5 == "object" && !Array.isArray(data5)) {
                        let missing1;
                        if (data5.columns === void 0 && (missing1 = "columns") || data5.rows === void 0 && (missing1 = "rows")) {
                          validate50.errors = [{
                            instancePath: instancePath + "/preferedGridSize",
                            schemaPath: "#/properties/preferedGridSize/required",
                            keyword: "required",
                            params: {
                              missingProperty: missing1
                            },
                            message: "must have required property '" + missing1 + "'"
                          }];
                          return false;
                        } else {
                          if (data5.columns !== void 0) {
                            let data6 = data5.columns;
                            const _errs13 = errors;
                            if (!(typeof data6 == "number" && isFinite(data6))) {
                              validate50.errors = [{
                                instancePath: instancePath + "/preferedGridSize/columns",
                                schemaPath: "#/properties/preferedGridSize/properties/columns/type",
                                keyword: "type",
                                params: {
                                  type: "number"
                                },
                                message: "must be number"
                              }];
                              return false;
                            }
                            var valid1 = _errs13 === errors;
                          } else {
                            var valid1 = true;
                          }
                          if (valid1) {
                            if (data5.rows !== void 0) {
                              let data7 = data5.rows;
                              const _errs15 = errors;
                              if (!(typeof data7 == "number" && isFinite(data7))) {
                                validate50.errors = [{
                                  instancePath: instancePath + "/preferedGridSize/rows",
                                  schemaPath: "#/properties/preferedGridSize/properties/rows/type",
                                  keyword: "type",
                                  params: {
                                    type: "number"
                                  },
                                  message: "must be number"
                                }];
                                return false;
                              }
                              var valid1 = _errs15 === errors;
                            } else {
                              var valid1 = true;
                            }
                          }
                        }
                      } else {
                        validate50.errors = [{
                          instancePath: instancePath + "/preferedGridSize",
                          schemaPath: "#/properties/preferedGridSize/type",
                          keyword: "type",
                          params: {
                            type: "object"
                          },
                          message: "must be object"
                        }];
                        return false;
                      }
                    }
                    var valid0 = _errs11 === errors;
                  } else {
                    var valid0 = true;
                  }
                  if (valid0) {
                    if (data.listSource !== void 0) {
                      let data8 = data.listSource;
                      const _errs17 = errors;
                      {
                        if (data8 && typeof data8 == "object" && !Array.isArray(data8)) {
                          if (data8.eventIds !== void 0) {
                            let data9 = data8.eventIds;
                            const _errs20 = errors;
                            {
                              if (Array.isArray(data9)) {
                                var valid4 = true;
                                const len0 = data9.length;
                                for (let i0 = 0; i0 < len0; i0++) {
                                  const _errs22 = errors;
                                  if (typeof data9[i0] !== "string") {
                                    validate50.errors = [{
                                      instancePath: instancePath + "/listSource/eventIds/" + i0,
                                      schemaPath: "EventListSource/properties/eventIds/items/type",
                                      keyword: "type",
                                      params: {
                                        type: "string"
                                      },
                                      message: "must be string"
                                    }];
                                    return false;
                                  }
                                  var valid4 = _errs22 === errors;
                                  if (!valid4) {
                                    break;
                                  }
                                }
                              } else {
                                validate50.errors = [{
                                  instancePath: instancePath + "/listSource/eventIds",
                                  schemaPath: "EventListSource/properties/eventIds/type",
                                  keyword: "type",
                                  params: {
                                    type: "array"
                                  },
                                  message: "must be array"
                                }];
                                return false;
                              }
                            }
                            var valid3 = _errs20 === errors;
                          } else {
                            var valid3 = true;
                          }
                          if (valid3) {
                            if (data8.onlyState !== void 0) {
                              let data11 = data8.onlyState;
                              const _errs24 = errors;
                              if (typeof data11 !== "string") {
                                validate50.errors = [{
                                  instancePath: instancePath + "/listSource/onlyState",
                                  schemaPath: "EventListSource/properties/onlyState/type",
                                  keyword: "type",
                                  params: {
                                    type: "string"
                                  },
                                  message: "must be string"
                                }];
                                return false;
                              }
                              if (!(data11 === "UPCOMING" || data11 === "ACTIVE" || data11 === "PASSED" || data11 === "ACTIVE_AND_UPCOMING" || data11 === "PASSED_AND_ACTIVE")) {
                                validate50.errors = [{
                                  instancePath: instancePath + "/listSource/onlyState",
                                  schemaPath: "EventListSource/properties/onlyState/enum",
                                  keyword: "enum",
                                  params: {
                                    allowedValues: schema63.properties.onlyState.enum
                                  },
                                  message: "must be equal to one of the allowed values"
                                }];
                                return false;
                              }
                              var valid3 = _errs24 === errors;
                            } else {
                              var valid3 = true;
                            }
                          }
                        } else {
                          validate50.errors = [{
                            instancePath: instancePath + "/listSource",
                            schemaPath: "EventListSource/type",
                            keyword: "type",
                            params: {
                              type: "object"
                            },
                            message: "must be object"
                          }];
                          return false;
                        }
                      }
                      var valid0 = _errs17 === errors;
                    } else {
                      var valid0 = true;
                    }
                    if (valid0) {
                      if (data.sort !== void 0) {
                        let data12 = data.sort;
                        const _errs26 = errors;
                        if (typeof data12 !== "string") {
                          validate50.errors = [{
                            instancePath: instancePath + "/sort",
                            schemaPath: "#/properties/sort/type",
                            keyword: "type",
                            params: {
                              type: "string"
                            },
                            message: "must be string"
                          }];
                          return false;
                        }
                        if ("DATE" !== data12) {
                          validate50.errors = [{
                            instancePath: instancePath + "/sort",
                            schemaPath: "#/properties/sort/const",
                            keyword: "const",
                            params: {
                              allowedValue: "DATE"
                            },
                            message: "must be equal to constant"
                          }];
                          return false;
                        }
                        var valid0 = _errs26 === errors;
                      } else {
                        var valid0 = true;
                      }
                      if (valid0) {
                        if (data.order !== void 0) {
                          let data13 = data.order;
                          const _errs28 = errors;
                          if (typeof data13 !== "string") {
                            validate50.errors = [{
                              instancePath: instancePath + "/order",
                              schemaPath: "#/properties/order/type",
                              keyword: "type",
                              params: {
                                type: "string"
                              },
                              message: "must be string"
                            }];
                            return false;
                          }
                          if (!(data13 === "ASC" || data13 === "DESC")) {
                            validate50.errors = [{
                              instancePath: instancePath + "/order",
                              schemaPath: "#/properties/order/enum",
                              keyword: "enum",
                              params: {
                                allowedValues: schema64.properties.order.enum
                              },
                              message: "must be equal to one of the allowed values"
                            }];
                            return false;
                          }
                          var valid0 = _errs28 === errors;
                        } else {
                          var valid0 = true;
                        }
                        if (valid0) {
                          if (data.size !== void 0) {
                            let data14 = data.size;
                            const _errs30 = errors;
                            if (!(typeof data14 == "number" && isFinite(data14))) {
                              validate50.errors = [{
                                instancePath: instancePath + "/size",
                                schemaPath: "#/properties/size/type",
                                keyword: "type",
                                params: {
                                  type: "number"
                                },
                                message: "must be number"
                              }];
                              return false;
                            }
                            var valid0 = _errs30 === errors;
                          } else {
                            var valid0 = true;
                          }
                        }
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
    } else {
      validate50.errors = [{
        instancePath,
        schemaPath: "#/type",
        keyword: "type",
        params: {
          type: "object"
        },
        message: "must be object"
      }];
      return false;
    }
  }
  validate50.errors = vErrors;
  return errors === 0;
}
const PromoButtonAction = validate51;
const schema67 = {
  "$id": "SingleOptionLink",
  "$schema": "http://json-schema.org/draft-07/schema#",
  "type": "object",
  "properties": {
    "type": {
      "type": "string",
      "enum": ["URL", "EVENT_TICKET", "PLAN"]
    },
    "id": {
      "type": "string"
    },
    "openInNewContext": {
      "type": "boolean"
    }
  },
  "required": ["type", "id"],
  "description": "Links to a specific product or page"
};
function validate51(data, {
  instancePath = "",
  parentData,
  parentDataProperty,
  rootData = data
} = {}) {
  let vErrors = null;
  let errors = 0;
  if (errors === 0) {
    if (data && typeof data == "object" && !Array.isArray(data)) {
      let missing0;
      if (data.text === void 0 && (missing0 = "text") || data.linkTo === void 0 && (missing0 = "linkTo")) {
        validate51.errors = [{
          instancePath,
          schemaPath: "#/required",
          keyword: "required",
          params: {
            missingProperty: missing0
          },
          message: "must have required property '" + missing0 + "'"
        }];
        return false;
      } else {
        if (data.text !== void 0) {
          const _errs1 = errors;
          if (typeof data.text !== "string") {
            validate51.errors = [{
              instancePath: instancePath + "/text",
              schemaPath: "#/properties/text/type",
              keyword: "type",
              params: {
                type: "string"
              },
              message: "must be string"
            }];
            return false;
          }
          var valid0 = _errs1 === errors;
        } else {
          var valid0 = true;
        }
        if (valid0) {
          if (data.linkTo !== void 0) {
            let data1 = data.linkTo;
            const _errs3 = errors;
            const _errs4 = errors;
            let valid1 = false;
            const _errs5 = errors;
            const _errs6 = errors;
            if (errors === _errs6) {
              if (data1 && typeof data1 == "object" && !Array.isArray(data1)) {
                let missing1;
                if (data1.type === void 0 && (missing1 = "type") || data1.id === void 0 && (missing1 = "id")) {
                  const err0 = {
                    instancePath: instancePath + "/linkTo",
                    schemaPath: "SingleOptionLink/required",
                    keyword: "required",
                    params: {
                      missingProperty: missing1
                    },
                    message: "must have required property '" + missing1 + "'"
                  };
                  if (vErrors === null) {
                    vErrors = [err0];
                  } else {
                    vErrors.push(err0);
                  }
                  errors++;
                } else {
                  if (data1.type !== void 0) {
                    let data2 = data1.type;
                    const _errs8 = errors;
                    if (typeof data2 !== "string") {
                      const err1 = {
                        instancePath: instancePath + "/linkTo/type",
                        schemaPath: "SingleOptionLink/properties/type/type",
                        keyword: "type",
                        params: {
                          type: "string"
                        },
                        message: "must be string"
                      };
                      if (vErrors === null) {
                        vErrors = [err1];
                      } else {
                        vErrors.push(err1);
                      }
                      errors++;
                    }
                    if (!(data2 === "URL" || data2 === "EVENT_TICKET" || data2 === "PLAN")) {
                      const err2 = {
                        instancePath: instancePath + "/linkTo/type",
                        schemaPath: "SingleOptionLink/properties/type/enum",
                        keyword: "enum",
                        params: {
                          allowedValues: schema67.properties.type.enum
                        },
                        message: "must be equal to one of the allowed values"
                      };
                      if (vErrors === null) {
                        vErrors = [err2];
                      } else {
                        vErrors.push(err2);
                      }
                      errors++;
                    }
                    var valid3 = _errs8 === errors;
                  } else {
                    var valid3 = true;
                  }
                  if (valid3) {
                    if (data1.id !== void 0) {
                      const _errs10 = errors;
                      if (typeof data1.id !== "string") {
                        const err3 = {
                          instancePath: instancePath + "/linkTo/id",
                          schemaPath: "SingleOptionLink/properties/id/type",
                          keyword: "type",
                          params: {
                            type: "string"
                          },
                          message: "must be string"
                        };
                        if (vErrors === null) {
                          vErrors = [err3];
                        } else {
                          vErrors.push(err3);
                        }
                        errors++;
                      }
                      var valid3 = _errs10 === errors;
                    } else {
                      var valid3 = true;
                    }
                    if (valid3) {
                      if (data1.openInNewContext !== void 0) {
                        const _errs12 = errors;
                        if (typeof data1.openInNewContext !== "boolean") {
                          const err4 = {
                            instancePath: instancePath + "/linkTo/openInNewContext",
                            schemaPath: "SingleOptionLink/properties/openInNewContext/type",
                            keyword: "type",
                            params: {
                              type: "boolean"
                            },
                            message: "must be boolean"
                          };
                          if (vErrors === null) {
                            vErrors = [err4];
                          } else {
                            vErrors.push(err4);
                          }
                          errors++;
                        }
                        var valid3 = _errs12 === errors;
                      } else {
                        var valid3 = true;
                      }
                    }
                  }
                }
              } else {
                const err5 = {
                  instancePath: instancePath + "/linkTo",
                  schemaPath: "SingleOptionLink/type",
                  keyword: "type",
                  params: {
                    type: "object"
                  },
                  message: "must be object"
                };
                if (vErrors === null) {
                  vErrors = [err5];
                } else {
                  vErrors.push(err5);
                }
                errors++;
              }
            }
            var _valid0 = _errs5 === errors;
            valid1 = valid1 || _valid0;
            if (!valid1) {
              const _errs14 = errors;
              const _errs15 = errors;
              if (errors === _errs15) {
                if (data1 && typeof data1 == "object" && !Array.isArray(data1)) {
                  let missing2;
                  if (data1.type === void 0 && (missing2 = "type") || data1.sections === void 0 && (missing2 = "sections")) {
                    const err6 = {
                      instancePath: instancePath + "/linkTo",
                      schemaPath: "OptionsListLink/required",
                      keyword: "required",
                      params: {
                        missingProperty: missing2
                      },
                      message: "must have required property '" + missing2 + "'"
                    };
                    if (vErrors === null) {
                      vErrors = [err6];
                    } else {
                      vErrors.push(err6);
                    }
                    errors++;
                  } else {
                    if (data1.type !== void 0) {
                      let data5 = data1.type;
                      const _errs17 = errors;
                      if (typeof data5 !== "string") {
                        const err7 = {
                          instancePath: instancePath + "/linkTo/type",
                          schemaPath: "OptionsListLink/properties/type/type",
                          keyword: "type",
                          params: {
                            type: "string"
                          },
                          message: "must be string"
                        };
                        if (vErrors === null) {
                          vErrors = [err7];
                        } else {
                          vErrors.push(err7);
                        }
                        errors++;
                      }
                      if ("LIST_OPTIONS" !== data5) {
                        const err8 = {
                          instancePath: instancePath + "/linkTo/type",
                          schemaPath: "OptionsListLink/properties/type/const",
                          keyword: "const",
                          params: {
                            allowedValue: "LIST_OPTIONS"
                          },
                          message: "must be equal to constant"
                        };
                        if (vErrors === null) {
                          vErrors = [err8];
                        } else {
                          vErrors.push(err8);
                        }
                        errors++;
                      }
                      var valid5 = _errs17 === errors;
                    } else {
                      var valid5 = true;
                    }
                    if (valid5) {
                      if (data1.dialogTitle !== void 0) {
                        const _errs19 = errors;
                        if (typeof data1.dialogTitle !== "string") {
                          const err9 = {
                            instancePath: instancePath + "/linkTo/dialogTitle",
                            schemaPath: "OptionsListLink/properties/dialogTitle/type",
                            keyword: "type",
                            params: {
                              type: "string"
                            },
                            message: "must be string"
                          };
                          if (vErrors === null) {
                            vErrors = [err9];
                          } else {
                            vErrors.push(err9);
                          }
                          errors++;
                        }
                        var valid5 = _errs19 === errors;
                      } else {
                        var valid5 = true;
                      }
                      if (valid5) {
                        if (data1.sections !== void 0) {
                          let data7 = data1.sections;
                          const _errs21 = errors;
                          if (errors === _errs21) {
                            if (Array.isArray(data7)) {
                              var valid6 = true;
                              const len0 = data7.length;
                              for (let i0 = 0; i0 < len0; i0++) {
                                let data8 = data7[i0];
                                const _errs23 = errors;
                                if (errors === _errs23) {
                                  if (data8 && typeof data8 == "object" && !Array.isArray(data8)) {
                                    let missing3;
                                    if (data8.title === void 0 && (missing3 = "title") || data8.ids === void 0 && (missing3 = "ids")) {
                                      const err10 = {
                                        instancePath: instancePath + "/linkTo/sections/" + i0,
                                        schemaPath: "OptionsListLink/properties/sections/items/required",
                                        keyword: "required",
                                        params: {
                                          missingProperty: missing3
                                        },
                                        message: "must have required property '" + missing3 + "'"
                                      };
                                      if (vErrors === null) {
                                        vErrors = [err10];
                                      } else {
                                        vErrors.push(err10);
                                      }
                                      errors++;
                                    } else {
                                      if (data8.title !== void 0) {
                                        const _errs25 = errors;
                                        if (typeof data8.title !== "string") {
                                          const err11 = {
                                            instancePath: instancePath + "/linkTo/sections/" + i0 + "/title",
                                            schemaPath: "OptionsListLink/properties/sections/items/properties/title/type",
                                            keyword: "type",
                                            params: {
                                              type: "string"
                                            },
                                            message: "must be string"
                                          };
                                          if (vErrors === null) {
                                            vErrors = [err11];
                                          } else {
                                            vErrors.push(err11);
                                          }
                                          errors++;
                                        }
                                        var valid7 = _errs25 === errors;
                                      } else {
                                        var valid7 = true;
                                      }
                                      if (valid7) {
                                        if (data8.ids !== void 0) {
                                          let data10 = data8.ids;
                                          const _errs27 = errors;
                                          if (errors === _errs27) {
                                            if (Array.isArray(data10)) {
                                              var valid8 = true;
                                              const len1 = data10.length;
                                              for (let i1 = 0; i1 < len1; i1++) {
                                                const _errs29 = errors;
                                                if (typeof data10[i1] !== "string") {
                                                  const err12 = {
                                                    instancePath: instancePath + "/linkTo/sections/" + i0 + "/ids/" + i1,
                                                    schemaPath: "OptionsListLink/properties/sections/items/properties/ids/items/type",
                                                    keyword: "type",
                                                    params: {
                                                      type: "string"
                                                    },
                                                    message: "must be string"
                                                  };
                                                  if (vErrors === null) {
                                                    vErrors = [err12];
                                                  } else {
                                                    vErrors.push(err12);
                                                  }
                                                  errors++;
                                                }
                                                var valid8 = _errs29 === errors;
                                                if (!valid8) {
                                                  break;
                                                }
                                              }
                                            } else {
                                              const err13 = {
                                                instancePath: instancePath + "/linkTo/sections/" + i0 + "/ids",
                                                schemaPath: "OptionsListLink/properties/sections/items/properties/ids/type",
                                                keyword: "type",
                                                params: {
                                                  type: "array"
                                                },
                                                message: "must be array"
                                              };
                                              if (vErrors === null) {
                                                vErrors = [err13];
                                              } else {
                                                vErrors.push(err13);
                                              }
                                              errors++;
                                            }
                                          }
                                          var valid7 = _errs27 === errors;
                                        } else {
                                          var valid7 = true;
                                        }
                                      }
                                    }
                                  } else {
                                    const err14 = {
                                      instancePath: instancePath + "/linkTo/sections/" + i0,
                                      schemaPath: "OptionsListLink/properties/sections/items/type",
                                      keyword: "type",
                                      params: {
                                        type: "object"
                                      },
                                      message: "must be object"
                                    };
                                    if (vErrors === null) {
                                      vErrors = [err14];
                                    } else {
                                      vErrors.push(err14);
                                    }
                                    errors++;
                                  }
                                }
                                var valid6 = _errs23 === errors;
                                if (!valid6) {
                                  break;
                                }
                              }
                            } else {
                              const err15 = {
                                instancePath: instancePath + "/linkTo/sections",
                                schemaPath: "OptionsListLink/properties/sections/type",
                                keyword: "type",
                                params: {
                                  type: "array"
                                },
                                message: "must be array"
                              };
                              if (vErrors === null) {
                                vErrors = [err15];
                              } else {
                                vErrors.push(err15);
                              }
                              errors++;
                            }
                          }
                          var valid5 = _errs21 === errors;
                        } else {
                          var valid5 = true;
                        }
                        if (valid5) {
                          if (data1.hideUnavailableOptions !== void 0) {
                            const _errs31 = errors;
                            if (typeof data1.hideUnavailableOptions !== "boolean") {
                              const err16 = {
                                instancePath: instancePath + "/linkTo/hideUnavailableOptions",
                                schemaPath: "OptionsListLink/properties/hideUnavailableOptions/type",
                                keyword: "type",
                                params: {
                                  type: "boolean"
                                },
                                message: "must be boolean"
                              };
                              if (vErrors === null) {
                                vErrors = [err16];
                              } else {
                                vErrors.push(err16);
                              }
                              errors++;
                            }
                            var valid5 = _errs31 === errors;
                          } else {
                            var valid5 = true;
                          }
                        }
                      }
                    }
                  }
                } else {
                  const err17 = {
                    instancePath: instancePath + "/linkTo",
                    schemaPath: "OptionsListLink/type",
                    keyword: "type",
                    params: {
                      type: "object"
                    },
                    message: "must be object"
                  };
                  if (vErrors === null) {
                    vErrors = [err17];
                  } else {
                    vErrors.push(err17);
                  }
                  errors++;
                }
              }
              var _valid0 = _errs14 === errors;
              valid1 = valid1 || _valid0;
            }
            if (!valid1) {
              const err18 = {
                instancePath: instancePath + "/linkTo",
                schemaPath: "#/properties/linkTo/anyOf",
                keyword: "anyOf",
                params: {},
                message: "must match a schema in anyOf"
              };
              if (vErrors === null) {
                vErrors = [err18];
              } else {
                vErrors.push(err18);
              }
              errors++;
              validate51.errors = vErrors;
              return false;
            } else {
              errors = _errs4;
              if (vErrors !== null) {
                if (_errs4) {
                  vErrors.length = _errs4;
                } else {
                  vErrors = null;
                }
              }
            }
            var valid0 = _errs3 === errors;
          } else {
            var valid0 = true;
          }
        }
      }
    } else {
      validate51.errors = [{
        instancePath,
        schemaPath: "#/type",
        keyword: "type",
        params: {
          type: "object"
        },
        message: "must be object"
      }];
      return false;
    }
  }
  validate51.errors = vErrors;
  return errors === 0;
}
const SingleOptionLink = validate52;
function validate52(data, {
  instancePath = "",
  parentData,
  parentDataProperty,
  rootData = data
} = {}) {
  let vErrors = null;
  let errors = 0;
  {
    if (data && typeof data == "object" && !Array.isArray(data)) {
      let missing0;
      if (data.type === void 0 && (missing0 = "type") || data.id === void 0 && (missing0 = "id")) {
        validate52.errors = [{
          instancePath,
          schemaPath: "#/required",
          keyword: "required",
          params: {
            missingProperty: missing0
          },
          message: "must have required property '" + missing0 + "'"
        }];
        return false;
      } else {
        if (data.type !== void 0) {
          let data0 = data.type;
          const _errs1 = errors;
          if (typeof data0 !== "string") {
            validate52.errors = [{
              instancePath: instancePath + "/type",
              schemaPath: "#/properties/type/type",
              keyword: "type",
              params: {
                type: "string"
              },
              message: "must be string"
            }];
            return false;
          }
          if (!(data0 === "URL" || data0 === "EVENT_TICKET" || data0 === "PLAN")) {
            validate52.errors = [{
              instancePath: instancePath + "/type",
              schemaPath: "#/properties/type/enum",
              keyword: "enum",
              params: {
                allowedValues: schema67.properties.type.enum
              },
              message: "must be equal to one of the allowed values"
            }];
            return false;
          }
          var valid0 = _errs1 === errors;
        } else {
          var valid0 = true;
        }
        if (valid0) {
          if (data.id !== void 0) {
            const _errs3 = errors;
            if (typeof data.id !== "string") {
              validate52.errors = [{
                instancePath: instancePath + "/id",
                schemaPath: "#/properties/id/type",
                keyword: "type",
                params: {
                  type: "string"
                },
                message: "must be string"
              }];
              return false;
            }
            var valid0 = _errs3 === errors;
          } else {
            var valid0 = true;
          }
          if (valid0) {
            if (data.openInNewContext !== void 0) {
              const _errs5 = errors;
              if (typeof data.openInNewContext !== "boolean") {
                validate52.errors = [{
                  instancePath: instancePath + "/openInNewContext",
                  schemaPath: "#/properties/openInNewContext/type",
                  keyword: "type",
                  params: {
                    type: "boolean"
                  },
                  message: "must be boolean"
                }];
                return false;
              }
              var valid0 = _errs5 === errors;
            } else {
              var valid0 = true;
            }
          }
        }
      }
    } else {
      validate52.errors = [{
        instancePath,
        schemaPath: "#/type",
        keyword: "type",
        params: {
          type: "object"
        },
        message: "must be object"
      }];
      return false;
    }
  }
  validate52.errors = vErrors;
  return errors === 0;
}
const OptionsListLink = validate53;
function validate53(data, {
  instancePath = "",
  parentData,
  parentDataProperty,
  rootData = data
} = {}) {
  let vErrors = null;
  let errors = 0;
  {
    if (data && typeof data == "object" && !Array.isArray(data)) {
      let missing0;
      if (data.type === void 0 && (missing0 = "type") || data.sections === void 0 && (missing0 = "sections")) {
        validate53.errors = [{
          instancePath,
          schemaPath: "#/required",
          keyword: "required",
          params: {
            missingProperty: missing0
          },
          message: "must have required property '" + missing0 + "'"
        }];
        return false;
      } else {
        if (data.type !== void 0) {
          let data0 = data.type;
          const _errs1 = errors;
          if (typeof data0 !== "string") {
            validate53.errors = [{
              instancePath: instancePath + "/type",
              schemaPath: "#/properties/type/type",
              keyword: "type",
              params: {
                type: "string"
              },
              message: "must be string"
            }];
            return false;
          }
          if ("LIST_OPTIONS" !== data0) {
            validate53.errors = [{
              instancePath: instancePath + "/type",
              schemaPath: "#/properties/type/const",
              keyword: "const",
              params: {
                allowedValue: "LIST_OPTIONS"
              },
              message: "must be equal to constant"
            }];
            return false;
          }
          var valid0 = _errs1 === errors;
        } else {
          var valid0 = true;
        }
        if (valid0) {
          if (data.dialogTitle !== void 0) {
            const _errs3 = errors;
            if (typeof data.dialogTitle !== "string") {
              validate53.errors = [{
                instancePath: instancePath + "/dialogTitle",
                schemaPath: "#/properties/dialogTitle/type",
                keyword: "type",
                params: {
                  type: "string"
                },
                message: "must be string"
              }];
              return false;
            }
            var valid0 = _errs3 === errors;
          } else {
            var valid0 = true;
          }
          if (valid0) {
            if (data.sections !== void 0) {
              let data2 = data.sections;
              const _errs5 = errors;
              {
                if (Array.isArray(data2)) {
                  var valid1 = true;
                  const len0 = data2.length;
                  for (let i0 = 0; i0 < len0; i0++) {
                    let data3 = data2[i0];
                    const _errs7 = errors;
                    {
                      if (data3 && typeof data3 == "object" && !Array.isArray(data3)) {
                        let missing1;
                        if (data3.title === void 0 && (missing1 = "title") || data3.ids === void 0 && (missing1 = "ids")) {
                          validate53.errors = [{
                            instancePath: instancePath + "/sections/" + i0,
                            schemaPath: "#/properties/sections/items/required",
                            keyword: "required",
                            params: {
                              missingProperty: missing1
                            },
                            message: "must have required property '" + missing1 + "'"
                          }];
                          return false;
                        } else {
                          if (data3.title !== void 0) {
                            const _errs9 = errors;
                            if (typeof data3.title !== "string") {
                              validate53.errors = [{
                                instancePath: instancePath + "/sections/" + i0 + "/title",
                                schemaPath: "#/properties/sections/items/properties/title/type",
                                keyword: "type",
                                params: {
                                  type: "string"
                                },
                                message: "must be string"
                              }];
                              return false;
                            }
                            var valid2 = _errs9 === errors;
                          } else {
                            var valid2 = true;
                          }
                          if (valid2) {
                            if (data3.ids !== void 0) {
                              let data5 = data3.ids;
                              const _errs11 = errors;
                              {
                                if (Array.isArray(data5)) {
                                  var valid3 = true;
                                  const len1 = data5.length;
                                  for (let i1 = 0; i1 < len1; i1++) {
                                    const _errs13 = errors;
                                    if (typeof data5[i1] !== "string") {
                                      validate53.errors = [{
                                        instancePath: instancePath + "/sections/" + i0 + "/ids/" + i1,
                                        schemaPath: "#/properties/sections/items/properties/ids/items/type",
                                        keyword: "type",
                                        params: {
                                          type: "string"
                                        },
                                        message: "must be string"
                                      }];
                                      return false;
                                    }
                                    var valid3 = _errs13 === errors;
                                    if (!valid3) {
                                      break;
                                    }
                                  }
                                } else {
                                  validate53.errors = [{
                                    instancePath: instancePath + "/sections/" + i0 + "/ids",
                                    schemaPath: "#/properties/sections/items/properties/ids/type",
                                    keyword: "type",
                                    params: {
                                      type: "array"
                                    },
                                    message: "must be array"
                                  }];
                                  return false;
                                }
                              }
                              var valid2 = _errs11 === errors;
                            } else {
                              var valid2 = true;
                            }
                          }
                        }
                      } else {
                        validate53.errors = [{
                          instancePath: instancePath + "/sections/" + i0,
                          schemaPath: "#/properties/sections/items/type",
                          keyword: "type",
                          params: {
                            type: "object"
                          },
                          message: "must be object"
                        }];
                        return false;
                      }
                    }
                    var valid1 = _errs7 === errors;
                    if (!valid1) {
                      break;
                    }
                  }
                } else {
                  validate53.errors = [{
                    instancePath: instancePath + "/sections",
                    schemaPath: "#/properties/sections/type",
                    keyword: "type",
                    params: {
                      type: "array"
                    },
                    message: "must be array"
                  }];
                  return false;
                }
              }
              var valid0 = _errs5 === errors;
            } else {
              var valid0 = true;
            }
            if (valid0) {
              if (data.hideUnavailableOptions !== void 0) {
                const _errs15 = errors;
                if (typeof data.hideUnavailableOptions !== "boolean") {
                  validate53.errors = [{
                    instancePath: instancePath + "/hideUnavailableOptions",
                    schemaPath: "#/properties/hideUnavailableOptions/type",
                    keyword: "type",
                    params: {
                      type: "boolean"
                    },
                    message: "must be boolean"
                  }];
                  return false;
                }
                var valid0 = _errs15 === errors;
              } else {
                var valid0 = true;
              }
            }
          }
        }
      }
    } else {
      validate53.errors = [{
        instancePath,
        schemaPath: "#/type",
        keyword: "type",
        params: {
          type: "object"
        },
        message: "must be object"
      }];
      return false;
    }
  }
  validate53.errors = vErrors;
  return errors === 0;
}
const PromotionalBlock = validate54;
function validate55(data, {
  instancePath = "",
  parentData,
  parentDataProperty,
  rootData = data
} = {}) {
  let vErrors = null;
  let errors = 0;
  if (errors === 0) {
    if (data && typeof data == "object" && !Array.isArray(data)) {
      let missing0;
      if (data.condition === void 0 && (missing0 = "condition") || data.type === void 0 && (missing0 = "type") || data.label === void 0 && (missing0 = "label") || data.details === void 0 && (missing0 = "details") || data.action === void 0 && (missing0 = "action")) {
        validate55.errors = [{
          instancePath,
          schemaPath: "#/required",
          keyword: "required",
          params: {
            missingProperty: missing0
          },
          message: "must have required property '" + missing0 + "'"
        }];
        return false;
      } else {
        if (data.condition !== void 0) {
          const _errs1 = errors;
          if (data.condition !== null) {
            validate55.errors = [{
              instancePath: instancePath + "/condition",
              schemaPath: "#/properties/condition/type",
              keyword: "type",
              params: {
                type: "null"
              },
              message: "must be null"
            }];
            return false;
          }
          var valid0 = _errs1 === errors;
        } else {
          var valid0 = true;
        }
        if (valid0) {
          if (data.type !== void 0) {
            let data1 = data.type;
            const _errs3 = errors;
            if (typeof data1 !== "string") {
              validate55.errors = [{
                instancePath: instancePath + "/type",
                schemaPath: "#/properties/type/type",
                keyword: "type",
                params: {
                  type: "string"
                },
                message: "must be string"
              }];
              return false;
            }
            if ("BUTTON" !== data1) {
              validate55.errors = [{
                instancePath: instancePath + "/type",
                schemaPath: "#/properties/type/const",
                keyword: "const",
                params: {
                  allowedValue: "BUTTON"
                },
                message: "must be equal to constant"
              }];
              return false;
            }
            var valid0 = _errs3 === errors;
          } else {
            var valid0 = true;
          }
          if (valid0) {
            if (data.label !== void 0) {
              const _errs5 = errors;
              if (typeof data.label !== "string") {
                validate55.errors = [{
                  instancePath: instancePath + "/label",
                  schemaPath: "#/properties/label/type",
                  keyword: "type",
                  params: {
                    type: "string"
                  },
                  message: "must be string"
                }];
                return false;
              }
              var valid0 = _errs5 === errors;
            } else {
              var valid0 = true;
            }
            if (valid0) {
              if (data.details !== void 0) {
                const _errs7 = errors;
                if (typeof data.details !== "string") {
                  validate55.errors = [{
                    instancePath: instancePath + "/details",
                    schemaPath: "#/properties/details/type",
                    keyword: "type",
                    params: {
                      type: "string"
                    },
                    message: "must be string"
                  }];
                  return false;
                }
                var valid0 = _errs7 === errors;
              } else {
                var valid0 = true;
              }
              if (valid0) {
                if (data.action !== void 0) {
                  const _errs9 = errors;
                  if (!validate51(data.action, {
                    instancePath: instancePath + "/action",
                    parentData: data,
                    parentDataProperty: "action",
                    rootData
                  })) {
                    vErrors = vErrors === null ? validate51.errors : vErrors.concat(validate51.errors);
                    errors = vErrors.length;
                  }
                  var valid0 = _errs9 === errors;
                } else {
                  var valid0 = true;
                }
                if (valid0) {
                  if (data.hideIfNoValidAction !== void 0) {
                    const _errs10 = errors;
                    if (typeof data.hideIfNoValidAction !== "boolean") {
                      validate55.errors = [{
                        instancePath: instancePath + "/hideIfNoValidAction",
                        schemaPath: "#/properties/hideIfNoValidAction/type",
                        keyword: "type",
                        params: {
                          type: "boolean"
                        },
                        message: "must be boolean"
                      }];
                      return false;
                    }
                    var valid0 = _errs10 === errors;
                  } else {
                    var valid0 = true;
                  }
                }
              }
            }
          }
        }
      }
    } else {
      validate55.errors = [{
        instancePath,
        schemaPath: "#/type",
        keyword: "type",
        params: {
          type: "object"
        },
        message: "must be object"
      }];
      return false;
    }
  }
  validate55.errors = vErrors;
  return errors === 0;
}
function validate58(data, {
  instancePath = "",
  parentData,
  parentDataProperty,
  rootData = data
} = {}) {
  let vErrors = null;
  let errors = 0;
  if (errors === 0) {
    if (data && typeof data == "object" && !Array.isArray(data)) {
      let missing0;
      if (data.condition === void 0 && (missing0 = "condition") || data.type === void 0 && (missing0 = "type") || data.title === void 0 && (missing0 = "title") || data.promoBlock === void 0 && (missing0 = "promoBlock") || data.actionBlocks === void 0 && (missing0 = "actionBlocks") || data.infoText === void 0 && (missing0 = "infoText")) {
        validate58.errors = [{
          instancePath,
          schemaPath: "#/required",
          keyword: "required",
          params: {
            missingProperty: missing0
          },
          message: "must have required property '" + missing0 + "'"
        }];
        return false;
      } else {
        if (data.condition !== void 0) {
          const _errs1 = errors;
          if (data.condition !== null) {
            validate58.errors = [{
              instancePath: instancePath + "/condition",
              schemaPath: "#/properties/condition/type",
              keyword: "type",
              params: {
                type: "null"
              },
              message: "must be null"
            }];
            return false;
          }
          var valid0 = _errs1 === errors;
        } else {
          var valid0 = true;
        }
        if (valid0) {
          if (data.type !== void 0) {
            let data1 = data.type;
            const _errs3 = errors;
            if (typeof data1 !== "string") {
              validate58.errors = [{
                instancePath: instancePath + "/type",
                schemaPath: "#/properties/type/type",
                keyword: "type",
                params: {
                  type: "string"
                },
                message: "must be string"
              }];
              return false;
            }
            if ("CARD" !== data1) {
              validate58.errors = [{
                instancePath: instancePath + "/type",
                schemaPath: "#/properties/type/const",
                keyword: "const",
                params: {
                  allowedValue: "CARD"
                },
                message: "must be equal to constant"
              }];
              return false;
            }
            var valid0 = _errs3 === errors;
          } else {
            var valid0 = true;
          }
          if (valid0) {
            if (data.title !== void 0) {
              const _errs5 = errors;
              if (typeof data.title !== "string") {
                validate58.errors = [{
                  instancePath: instancePath + "/title",
                  schemaPath: "#/properties/title/type",
                  keyword: "type",
                  params: {
                    type: "string"
                  },
                  message: "must be string"
                }];
                return false;
              }
              var valid0 = _errs5 === errors;
            } else {
              var valid0 = true;
            }
            if (valid0) {
              if (data.promoBlock !== void 0) {
                let data3 = data.promoBlock;
                const _errs7 = errors;
                const _errs8 = errors;
                let valid1 = false;
                const _errs9 = errors;
                if (errors === _errs9) {
                  if (data3 && typeof data3 == "object" && !Array.isArray(data3)) {
                    let missing1;
                    if (data3.title === void 0 && (missing1 = "title") || data3.description === void 0 && (missing1 = "description")) {
                      const err0 = {
                        instancePath: instancePath + "/promoBlock",
                        schemaPath: "#/properties/promoBlock/anyOf/0/required",
                        keyword: "required",
                        params: {
                          missingProperty: missing1
                        },
                        message: "must have required property '" + missing1 + "'"
                      };
                      if (vErrors === null) {
                        vErrors = [err0];
                      } else {
                        vErrors.push(err0);
                      }
                      errors++;
                    } else {
                      if (data3.title !== void 0) {
                        const _errs11 = errors;
                        if (typeof data3.title !== "string") {
                          const err1 = {
                            instancePath: instancePath + "/promoBlock/title",
                            schemaPath: "#/properties/promoBlock/anyOf/0/properties/title/type",
                            keyword: "type",
                            params: {
                              type: "string"
                            },
                            message: "must be string"
                          };
                          if (vErrors === null) {
                            vErrors = [err1];
                          } else {
                            vErrors.push(err1);
                          }
                          errors++;
                        }
                        var valid2 = _errs11 === errors;
                      } else {
                        var valid2 = true;
                      }
                      if (valid2) {
                        if (data3.description !== void 0) {
                          const _errs13 = errors;
                          if (typeof data3.description !== "string") {
                            const err2 = {
                              instancePath: instancePath + "/promoBlock/description",
                              schemaPath: "#/properties/promoBlock/anyOf/0/properties/description/type",
                              keyword: "type",
                              params: {
                                type: "string"
                              },
                              message: "must be string"
                            };
                            if (vErrors === null) {
                              vErrors = [err2];
                            } else {
                              vErrors.push(err2);
                            }
                            errors++;
                          }
                          var valid2 = _errs13 === errors;
                        } else {
                          var valid2 = true;
                        }
                      }
                    }
                  } else {
                    const err3 = {
                      instancePath: instancePath + "/promoBlock",
                      schemaPath: "#/properties/promoBlock/anyOf/0/type",
                      keyword: "type",
                      params: {
                        type: "object"
                      },
                      message: "must be object"
                    };
                    if (vErrors === null) {
                      vErrors = [err3];
                    } else {
                      vErrors.push(err3);
                    }
                    errors++;
                  }
                }
                var _valid0 = _errs9 === errors;
                valid1 = valid1 || _valid0;
                if (!valid1) {
                  const _errs15 = errors;
                  if (data3 !== null) {
                    const err4 = {
                      instancePath: instancePath + "/promoBlock",
                      schemaPath: "#/properties/promoBlock/anyOf/1/type",
                      keyword: "type",
                      params: {
                        type: "null"
                      },
                      message: "must be null"
                    };
                    if (vErrors === null) {
                      vErrors = [err4];
                    } else {
                      vErrors.push(err4);
                    }
                    errors++;
                  }
                  var _valid0 = _errs15 === errors;
                  valid1 = valid1 || _valid0;
                }
                if (!valid1) {
                  const err5 = {
                    instancePath: instancePath + "/promoBlock",
                    schemaPath: "#/properties/promoBlock/anyOf",
                    keyword: "anyOf",
                    params: {},
                    message: "must match a schema in anyOf"
                  };
                  if (vErrors === null) {
                    vErrors = [err5];
                  } else {
                    vErrors.push(err5);
                  }
                  errors++;
                  validate58.errors = vErrors;
                  return false;
                } else {
                  errors = _errs8;
                  if (vErrors !== null) {
                    if (_errs8) {
                      vErrors.length = _errs8;
                    } else {
                      vErrors = null;
                    }
                  }
                }
                var valid0 = _errs7 === errors;
              } else {
                var valid0 = true;
              }
              if (valid0) {
                if (data.actionBlocks !== void 0) {
                  let data6 = data.actionBlocks;
                  const _errs17 = errors;
                  if (errors === _errs17) {
                    if (Array.isArray(data6)) {
                      var valid3 = true;
                      const len0 = data6.length;
                      for (let i0 = 0; i0 < len0; i0++) {
                        let data7 = data6[i0];
                        const _errs19 = errors;
                        if (errors === _errs19) {
                          if (data7 && typeof data7 == "object" && !Array.isArray(data7)) {
                            let missing2;
                            if (data7.discountTag === void 0 && (missing2 = "discountTag") || data7.label === void 0 && (missing2 = "label") || data7.details === void 0 && (missing2 = "details") || data7.action === void 0 && (missing2 = "action")) {
                              validate58.errors = [{
                                instancePath: instancePath + "/actionBlocks/" + i0,
                                schemaPath: "#/properties/actionBlocks/items/required",
                                keyword: "required",
                                params: {
                                  missingProperty: missing2
                                },
                                message: "must have required property '" + missing2 + "'"
                              }];
                              return false;
                            } else {
                              if (data7.discountTag !== void 0) {
                                const _errs21 = errors;
                                if (typeof data7.discountTag !== "string") {
                                  validate58.errors = [{
                                    instancePath: instancePath + "/actionBlocks/" + i0 + "/discountTag",
                                    schemaPath: "#/properties/actionBlocks/items/properties/discountTag/type",
                                    keyword: "type",
                                    params: {
                                      type: "string"
                                    },
                                    message: "must be string"
                                  }];
                                  return false;
                                }
                                var valid4 = _errs21 === errors;
                              } else {
                                var valid4 = true;
                              }
                              if (valid4) {
                                if (data7.label !== void 0) {
                                  const _errs23 = errors;
                                  if (typeof data7.label !== "string") {
                                    validate58.errors = [{
                                      instancePath: instancePath + "/actionBlocks/" + i0 + "/label",
                                      schemaPath: "#/properties/actionBlocks/items/properties/label/type",
                                      keyword: "type",
                                      params: {
                                        type: "string"
                                      },
                                      message: "must be string"
                                    }];
                                    return false;
                                  }
                                  var valid4 = _errs23 === errors;
                                } else {
                                  var valid4 = true;
                                }
                                if (valid4) {
                                  if (data7.details !== void 0) {
                                    const _errs25 = errors;
                                    if (typeof data7.details !== "string") {
                                      validate58.errors = [{
                                        instancePath: instancePath + "/actionBlocks/" + i0 + "/details",
                                        schemaPath: "#/properties/actionBlocks/items/properties/details/type",
                                        keyword: "type",
                                        params: {
                                          type: "string"
                                        },
                                        message: "must be string"
                                      }];
                                      return false;
                                    }
                                    var valid4 = _errs25 === errors;
                                  } else {
                                    var valid4 = true;
                                  }
                                  if (valid4) {
                                    if (data7.action !== void 0) {
                                      const _errs27 = errors;
                                      if (!validate51(data7.action, {
                                        instancePath: instancePath + "/actionBlocks/" + i0 + "/action",
                                        parentData: data7,
                                        parentDataProperty: "action",
                                        rootData
                                      })) {
                                        vErrors = vErrors === null ? validate51.errors : vErrors.concat(validate51.errors);
                                        errors = vErrors.length;
                                      }
                                      var valid4 = _errs27 === errors;
                                    } else {
                                      var valid4 = true;
                                    }
                                  }
                                }
                              }
                            }
                          } else {
                            validate58.errors = [{
                              instancePath: instancePath + "/actionBlocks/" + i0,
                              schemaPath: "#/properties/actionBlocks/items/type",
                              keyword: "type",
                              params: {
                                type: "object"
                              },
                              message: "must be object"
                            }];
                            return false;
                          }
                        }
                        var valid3 = _errs19 === errors;
                        if (!valid3) {
                          break;
                        }
                      }
                    } else {
                      validate58.errors = [{
                        instancePath: instancePath + "/actionBlocks",
                        schemaPath: "#/properties/actionBlocks/type",
                        keyword: "type",
                        params: {
                          type: "array"
                        },
                        message: "must be array"
                      }];
                      return false;
                    }
                  }
                  var valid0 = _errs17 === errors;
                } else {
                  var valid0 = true;
                }
                if (valid0) {
                  if (data.infoText !== void 0) {
                    const _errs28 = errors;
                    if (typeof data.infoText !== "string") {
                      validate58.errors = [{
                        instancePath: instancePath + "/infoText",
                        schemaPath: "#/properties/infoText/type",
                        keyword: "type",
                        params: {
                          type: "string"
                        },
                        message: "must be string"
                      }];
                      return false;
                    }
                    var valid0 = _errs28 === errors;
                  } else {
                    var valid0 = true;
                  }
                  if (valid0) {
                    if (data.hideIfNoValidAction !== void 0) {
                      const _errs30 = errors;
                      if (typeof data.hideIfNoValidAction !== "boolean") {
                        validate58.errors = [{
                          instancePath: instancePath + "/hideIfNoValidAction",
                          schemaPath: "#/properties/hideIfNoValidAction/type",
                          keyword: "type",
                          params: {
                            type: "boolean"
                          },
                          message: "must be boolean"
                        }];
                        return false;
                      }
                      var valid0 = _errs30 === errors;
                    } else {
                      var valid0 = true;
                    }
                  }
                }
              }
            }
          }
        }
      }
    } else {
      validate58.errors = [{
        instancePath,
        schemaPath: "#/type",
        keyword: "type",
        params: {
          type: "object"
        },
        message: "must be object"
      }];
      return false;
    }
  }
  validate58.errors = vErrors;
  return errors === 0;
}
function validate54(data, {
  instancePath = "",
  parentData,
  parentDataProperty,
  rootData = data
} = {}) {
  let vErrors = null;
  let errors = 0;
  const _errs0 = errors;
  let valid0 = false;
  const _errs1 = errors;
  if (!validate55(data, {
    instancePath,
    parentData,
    parentDataProperty,
    rootData
  })) {
    vErrors = vErrors === null ? validate55.errors : vErrors.concat(validate55.errors);
    errors = vErrors.length;
  }
  var _valid0 = _errs1 === errors;
  valid0 = valid0 || _valid0;
  if (!valid0) {
    const _errs2 = errors;
    if (!validate58(data, {
      instancePath,
      parentData,
      parentDataProperty,
      rootData
    })) {
      vErrors = vErrors === null ? validate58.errors : vErrors.concat(validate58.errors);
      errors = vErrors.length;
    }
    var _valid0 = _errs2 === errors;
    valid0 = valid0 || _valid0;
  }
  if (!valid0) {
    const err0 = {
      instancePath,
      schemaPath: "#/anyOf",
      keyword: "anyOf",
      params: {},
      message: "must match a schema in anyOf"
    };
    if (vErrors === null) {
      vErrors = [err0];
    } else {
      vErrors.push(err0);
    }
    errors++;
    validate54.errors = vErrors;
    return false;
  } else {
    errors = _errs0;
    if (vErrors !== null) {
      if (_errs0) {
        vErrors.length = _errs0;
      } else {
        vErrors = null;
      }
    }
  }
  validate54.errors = vErrors;
  return errors === 0;
}
const ButtonPromotionalBlock = validate55;
const CardPromotionalBlock = validate58;
const HeaderModule = validate61;
function validate62(data, {
  instancePath = "",
  parentData,
  parentDataProperty,
  rootData = data
} = {}) {
  let vErrors = null;
  let errors = 0;
  if (errors === 0) {
    if (data && typeof data == "object" && !Array.isArray(data)) {
      let missing0;
      if (data.text === void 0 && (missing0 = "text") || data.subText === void 0 && (missing0 = "subText") || data.bannerImages === void 0 && (missing0 = "bannerImages")) {
        validate62.errors = [{
          instancePath,
          schemaPath: "#/required",
          keyword: "required",
          params: {
            missingProperty: missing0
          },
          message: "must have required property '" + missing0 + "'"
        }];
        return false;
      } else {
        if (data.logoImage !== void 0) {
          const _errs1 = errors;
          if (typeof data.logoImage !== "string") {
            validate62.errors = [{
              instancePath: instancePath + "/logoImage",
              schemaPath: "#/properties/logoImage/type",
              keyword: "type",
              params: {
                type: "string"
              },
              message: "must be string"
            }];
            return false;
          }
          var valid0 = _errs1 === errors;
        } else {
          var valid0 = true;
        }
        if (valid0) {
          if (data.text !== void 0) {
            const _errs3 = errors;
            if (typeof data.text !== "string") {
              validate62.errors = [{
                instancePath: instancePath + "/text",
                schemaPath: "#/properties/text/type",
                keyword: "type",
                params: {
                  type: "string"
                },
                message: "must be string"
              }];
              return false;
            }
            var valid0 = _errs3 === errors;
          } else {
            var valid0 = true;
          }
          if (valid0) {
            if (data.subText !== void 0) {
              const _errs5 = errors;
              if (typeof data.subText !== "string") {
                validate62.errors = [{
                  instancePath: instancePath + "/subText",
                  schemaPath: "#/properties/subText/type",
                  keyword: "type",
                  params: {
                    type: "string"
                  },
                  message: "must be string"
                }];
                return false;
              }
              var valid0 = _errs5 === errors;
            } else {
              var valid0 = true;
            }
            if (valid0) {
              if (data.bannerImages !== void 0) {
                let data3 = data.bannerImages;
                const _errs7 = errors;
                const _errs8 = errors;
                let valid1 = false;
                const _errs9 = errors;
                if (typeof data3 !== "string") {
                  const err0 = {
                    instancePath: instancePath + "/bannerImages",
                    schemaPath: "#/properties/bannerImages/anyOf/0/type",
                    keyword: "type",
                    params: {
                      type: "string"
                    },
                    message: "must be string"
                  };
                  if (vErrors === null) {
                    vErrors = [err0];
                  } else {
                    vErrors.push(err0);
                  }
                  errors++;
                }
                if ("NONE" !== data3) {
                  const err1 = {
                    instancePath: instancePath + "/bannerImages",
                    schemaPath: "#/properties/bannerImages/anyOf/0/const",
                    keyword: "const",
                    params: {
                      allowedValue: "NONE"
                    },
                    message: "must be equal to constant"
                  };
                  if (vErrors === null) {
                    vErrors = [err1];
                  } else {
                    vErrors.push(err1);
                  }
                  errors++;
                }
                var _valid0 = _errs9 === errors;
                valid1 = valid1 || _valid0;
                if (!valid1) {
                  const _errs11 = errors;
                  if (typeof data3 !== "string") {
                    const err2 = {
                      instancePath: instancePath + "/bannerImages",
                      schemaPath: "#/properties/bannerImages/anyOf/1/type",
                      keyword: "type",
                      params: {
                        type: "string"
                      },
                      message: "must be string"
                    };
                    if (vErrors === null) {
                      vErrors = [err2];
                    } else {
                      vErrors.push(err2);
                    }
                    errors++;
                  }
                  if ("INHERIT" !== data3) {
                    const err3 = {
                      instancePath: instancePath + "/bannerImages",
                      schemaPath: "#/properties/bannerImages/anyOf/1/const",
                      keyword: "const",
                      params: {
                        allowedValue: "INHERIT"
                      },
                      message: "must be equal to constant"
                    };
                    if (vErrors === null) {
                      vErrors = [err3];
                    } else {
                      vErrors.push(err3);
                    }
                    errors++;
                  }
                  var _valid0 = _errs11 === errors;
                  valid1 = valid1 || _valid0;
                  if (!valid1) {
                    const _errs13 = errors;
                    if (errors === _errs13) {
                      if (data3 && typeof data3 == "object" && !Array.isArray(data3)) {
                        let missing1;
                        if (data3["3/1"] === void 0 && (missing1 = "3/1") || data3["3/4"] === void 0 && (missing1 = "3/4") || data3["16/9"] === void 0 && (missing1 = "16/9")) {
                          const err4 = {
                            instancePath: instancePath + "/bannerImages",
                            schemaPath: "#/properties/bannerImages/anyOf/2/required",
                            keyword: "required",
                            params: {
                              missingProperty: missing1
                            },
                            message: "must have required property '" + missing1 + "'"
                          };
                          if (vErrors === null) {
                            vErrors = [err4];
                          } else {
                            vErrors.push(err4);
                          }
                          errors++;
                        } else {
                          if (data3["3/1"] !== void 0) {
                            const _errs15 = errors;
                            if (typeof data3["3/1"] !== "string") {
                              const err5 = {
                                instancePath: instancePath + "/bannerImages/3~11",
                                schemaPath: "#/properties/bannerImages/anyOf/2/properties/3~11/type",
                                keyword: "type",
                                params: {
                                  type: "string"
                                },
                                message: "must be string"
                              };
                              if (vErrors === null) {
                                vErrors = [err5];
                              } else {
                                vErrors.push(err5);
                              }
                              errors++;
                            }
                            var valid2 = _errs15 === errors;
                          } else {
                            var valid2 = true;
                          }
                          if (valid2) {
                            if (data3["3/4"] !== void 0) {
                              const _errs17 = errors;
                              if (typeof data3["3/4"] !== "string") {
                                const err6 = {
                                  instancePath: instancePath + "/bannerImages/3~14",
                                  schemaPath: "#/properties/bannerImages/anyOf/2/properties/3~14/type",
                                  keyword: "type",
                                  params: {
                                    type: "string"
                                  },
                                  message: "must be string"
                                };
                                if (vErrors === null) {
                                  vErrors = [err6];
                                } else {
                                  vErrors.push(err6);
                                }
                                errors++;
                              }
                              var valid2 = _errs17 === errors;
                            } else {
                              var valid2 = true;
                            }
                            if (valid2) {
                              if (data3["16/9"] !== void 0) {
                                const _errs19 = errors;
                                if (typeof data3["16/9"] !== "string") {
                                  const err7 = {
                                    instancePath: instancePath + "/bannerImages/16~19",
                                    schemaPath: "#/properties/bannerImages/anyOf/2/properties/16~19/type",
                                    keyword: "type",
                                    params: {
                                      type: "string"
                                    },
                                    message: "must be string"
                                  };
                                  if (vErrors === null) {
                                    vErrors = [err7];
                                  } else {
                                    vErrors.push(err7);
                                  }
                                  errors++;
                                }
                                var valid2 = _errs19 === errors;
                              } else {
                                var valid2 = true;
                              }
                            }
                          }
                        }
                      } else {
                        const err8 = {
                          instancePath: instancePath + "/bannerImages",
                          schemaPath: "#/properties/bannerImages/anyOf/2/type",
                          keyword: "type",
                          params: {
                            type: "object"
                          },
                          message: "must be object"
                        };
                        if (vErrors === null) {
                          vErrors = [err8];
                        } else {
                          vErrors.push(err8);
                        }
                        errors++;
                      }
                    }
                    var _valid0 = _errs13 === errors;
                    valid1 = valid1 || _valid0;
                  }
                }
                if (!valid1) {
                  const err9 = {
                    instancePath: instancePath + "/bannerImages",
                    schemaPath: "#/properties/bannerImages/anyOf",
                    keyword: "anyOf",
                    params: {},
                    message: "must match a schema in anyOf"
                  };
                  if (vErrors === null) {
                    vErrors = [err9];
                  } else {
                    vErrors.push(err9);
                  }
                  errors++;
                  validate62.errors = vErrors;
                  return false;
                } else {
                  errors = _errs8;
                  if (vErrors !== null) {
                    if (_errs8) {
                      vErrors.length = _errs8;
                    } else {
                      vErrors = null;
                    }
                  }
                }
                var valid0 = _errs7 === errors;
              } else {
                var valid0 = true;
              }
              if (valid0) {
                if (data.promoBlocks !== void 0) {
                  let data7 = data.promoBlocks;
                  const _errs21 = errors;
                  if (errors === _errs21) {
                    if (Array.isArray(data7)) {
                      var valid3 = true;
                      const len0 = data7.length;
                      for (let i0 = 0; i0 < len0; i0++) {
                        const _errs23 = errors;
                        if (!validate54(data7[i0], {
                          instancePath: instancePath + "/promoBlocks/" + i0,
                          parentData: data7,
                          parentDataProperty: i0,
                          rootData
                        })) {
                          vErrors = vErrors === null ? validate54.errors : vErrors.concat(validate54.errors);
                          errors = vErrors.length;
                        }
                        var valid3 = _errs23 === errors;
                        if (!valid3) {
                          break;
                        }
                      }
                    } else {
                      validate62.errors = [{
                        instancePath: instancePath + "/promoBlocks",
                        schemaPath: "#/properties/promoBlocks/type",
                        keyword: "type",
                        params: {
                          type: "array"
                        },
                        message: "must be array"
                      }];
                      return false;
                    }
                  }
                  var valid0 = _errs21 === errors;
                } else {
                  var valid0 = true;
                }
              }
            }
          }
        }
      }
    } else {
      validate62.errors = [{
        instancePath,
        schemaPath: "#/type",
        keyword: "type",
        params: {
          type: "object"
        },
        message: "must be object"
      }];
      return false;
    }
  }
  validate62.errors = vErrors;
  return errors === 0;
}
function validate61(data, {
  instancePath = "",
  parentData,
  parentDataProperty,
  rootData = data
} = {}) {
  let vErrors = null;
  let errors = 0;
  if (!validate62(data, {
    instancePath,
    parentData,
    parentDataProperty,
    rootData
  })) {
    vErrors = vErrors === null ? validate62.errors : vErrors.concat(validate62.errors);
    errors = vErrors.length;
  }
  validate61.errors = vErrors;
  return errors === 0;
}
const ClassicHeaderModule = validate62;
const LiveAndUpcomingListModule = validate65;
const schema76 = {
  "$id": "LiveAndUpcomingListModule",
  "$schema": "http://json-schema.org/draft-07/schema#",
  "type": "object",
  "properties": {
    "moduleType": {
      "type": "string",
      "const": "LIVE_AND_UPCOMING_LIST"
    },
    "heading": {
      "type": "string"
    },
    "subHeading": {
      "type": "string"
    },
    "layoutType": {
      "type": "string",
      "enum": ["CAROUSEL", "GRID"]
    },
    "density": {
      "type": "string",
      "enum": ["NORMAL", "DENSE", "DENSEST"]
    },
    "preferedGridSize": {
      "type": "object",
      "properties": {
        "columns": {
          "type": "number"
        },
        "rows": {
          "type": "number"
        }
      },
      "required": ["columns", "rows"]
    },
    "listSource": {
      "type": "object",
      "properties": {
        "tags": {
          "type": "object",
          "properties": {
            "kind": {
              "type": "string",
              "enum": ["ALL", "SOME"]
            },
            "list": {
              "type": "array",
              "items": {
                "type": "string"
              }
            }
          },
          "required": ["kind", "list"]
        },
        "eventId": {
          "type": "string"
        }
      }
    },
    "size": {
      "type": "number"
    },
    "dateRange": {
      "type": "array",
      "items": {
        "anyOf": [{
          "type": "string",
          "const": "NOW"
        }, {
          "type": "object",
          "format": "date-time"
        }, {
          "type": "null"
        }]
      },
      "minItems": 2,
      "maxItems": 2
    }
  },
  "required": ["density", "layoutType", "listSource", "moduleType", "size"],
  "description": "Loads a list of streams that are either live or upcoming. This only loads videos of type STREAM and with a state other than 'PASSED'."
};
function validate65(data, {
  instancePath = "",
  parentData,
  parentDataProperty,
  rootData = data
} = {}) {
  let vErrors = null;
  let errors = 0;
  if (errors === 0) {
    if (data && typeof data == "object" && !Array.isArray(data)) {
      let missing0;
      if (data.density === void 0 && (missing0 = "density") || data.layoutType === void 0 && (missing0 = "layoutType") || data.listSource === void 0 && (missing0 = "listSource") || data.moduleType === void 0 && (missing0 = "moduleType") || data.size === void 0 && (missing0 = "size")) {
        validate65.errors = [{
          instancePath,
          schemaPath: "#/required",
          keyword: "required",
          params: {
            missingProperty: missing0
          },
          message: "must have required property '" + missing0 + "'"
        }];
        return false;
      } else {
        if (data.moduleType !== void 0) {
          let data0 = data.moduleType;
          const _errs1 = errors;
          if (typeof data0 !== "string") {
            validate65.errors = [{
              instancePath: instancePath + "/moduleType",
              schemaPath: "#/properties/moduleType/type",
              keyword: "type",
              params: {
                type: "string"
              },
              message: "must be string"
            }];
            return false;
          }
          if ("LIVE_AND_UPCOMING_LIST" !== data0) {
            validate65.errors = [{
              instancePath: instancePath + "/moduleType",
              schemaPath: "#/properties/moduleType/const",
              keyword: "const",
              params: {
                allowedValue: "LIVE_AND_UPCOMING_LIST"
              },
              message: "must be equal to constant"
            }];
            return false;
          }
          var valid0 = _errs1 === errors;
        } else {
          var valid0 = true;
        }
        if (valid0) {
          if (data.heading !== void 0) {
            const _errs3 = errors;
            if (typeof data.heading !== "string") {
              validate65.errors = [{
                instancePath: instancePath + "/heading",
                schemaPath: "#/properties/heading/type",
                keyword: "type",
                params: {
                  type: "string"
                },
                message: "must be string"
              }];
              return false;
            }
            var valid0 = _errs3 === errors;
          } else {
            var valid0 = true;
          }
          if (valid0) {
            if (data.subHeading !== void 0) {
              const _errs5 = errors;
              if (typeof data.subHeading !== "string") {
                validate65.errors = [{
                  instancePath: instancePath + "/subHeading",
                  schemaPath: "#/properties/subHeading/type",
                  keyword: "type",
                  params: {
                    type: "string"
                  },
                  message: "must be string"
                }];
                return false;
              }
              var valid0 = _errs5 === errors;
            } else {
              var valid0 = true;
            }
            if (valid0) {
              if (data.layoutType !== void 0) {
                let data3 = data.layoutType;
                const _errs7 = errors;
                if (typeof data3 !== "string") {
                  validate65.errors = [{
                    instancePath: instancePath + "/layoutType",
                    schemaPath: "#/properties/layoutType/type",
                    keyword: "type",
                    params: {
                      type: "string"
                    },
                    message: "must be string"
                  }];
                  return false;
                }
                if (!(data3 === "CAROUSEL" || data3 === "GRID")) {
                  validate65.errors = [{
                    instancePath: instancePath + "/layoutType",
                    schemaPath: "#/properties/layoutType/enum",
                    keyword: "enum",
                    params: {
                      allowedValues: schema76.properties.layoutType.enum
                    },
                    message: "must be equal to one of the allowed values"
                  }];
                  return false;
                }
                var valid0 = _errs7 === errors;
              } else {
                var valid0 = true;
              }
              if (valid0) {
                if (data.density !== void 0) {
                  let data4 = data.density;
                  const _errs9 = errors;
                  if (typeof data4 !== "string") {
                    validate65.errors = [{
                      instancePath: instancePath + "/density",
                      schemaPath: "#/properties/density/type",
                      keyword: "type",
                      params: {
                        type: "string"
                      },
                      message: "must be string"
                    }];
                    return false;
                  }
                  if (!(data4 === "NORMAL" || data4 === "DENSE" || data4 === "DENSEST")) {
                    validate65.errors = [{
                      instancePath: instancePath + "/density",
                      schemaPath: "#/properties/density/enum",
                      keyword: "enum",
                      params: {
                        allowedValues: schema76.properties.density.enum
                      },
                      message: "must be equal to one of the allowed values"
                    }];
                    return false;
                  }
                  var valid0 = _errs9 === errors;
                } else {
                  var valid0 = true;
                }
                if (valid0) {
                  if (data.preferedGridSize !== void 0) {
                    let data5 = data.preferedGridSize;
                    const _errs11 = errors;
                    if (errors === _errs11) {
                      if (data5 && typeof data5 == "object" && !Array.isArray(data5)) {
                        let missing1;
                        if (data5.columns === void 0 && (missing1 = "columns") || data5.rows === void 0 && (missing1 = "rows")) {
                          validate65.errors = [{
                            instancePath: instancePath + "/preferedGridSize",
                            schemaPath: "#/properties/preferedGridSize/required",
                            keyword: "required",
                            params: {
                              missingProperty: missing1
                            },
                            message: "must have required property '" + missing1 + "'"
                          }];
                          return false;
                        } else {
                          if (data5.columns !== void 0) {
                            let data6 = data5.columns;
                            const _errs13 = errors;
                            if (!(typeof data6 == "number" && isFinite(data6))) {
                              validate65.errors = [{
                                instancePath: instancePath + "/preferedGridSize/columns",
                                schemaPath: "#/properties/preferedGridSize/properties/columns/type",
                                keyword: "type",
                                params: {
                                  type: "number"
                                },
                                message: "must be number"
                              }];
                              return false;
                            }
                            var valid1 = _errs13 === errors;
                          } else {
                            var valid1 = true;
                          }
                          if (valid1) {
                            if (data5.rows !== void 0) {
                              let data7 = data5.rows;
                              const _errs15 = errors;
                              if (!(typeof data7 == "number" && isFinite(data7))) {
                                validate65.errors = [{
                                  instancePath: instancePath + "/preferedGridSize/rows",
                                  schemaPath: "#/properties/preferedGridSize/properties/rows/type",
                                  keyword: "type",
                                  params: {
                                    type: "number"
                                  },
                                  message: "must be number"
                                }];
                                return false;
                              }
                              var valid1 = _errs15 === errors;
                            } else {
                              var valid1 = true;
                            }
                          }
                        }
                      } else {
                        validate65.errors = [{
                          instancePath: instancePath + "/preferedGridSize",
                          schemaPath: "#/properties/preferedGridSize/type",
                          keyword: "type",
                          params: {
                            type: "object"
                          },
                          message: "must be object"
                        }];
                        return false;
                      }
                    }
                    var valid0 = _errs11 === errors;
                  } else {
                    var valid0 = true;
                  }
                  if (valid0) {
                    if (data.listSource !== void 0) {
                      let data8 = data.listSource;
                      const _errs17 = errors;
                      if (errors === _errs17) {
                        if (data8 && typeof data8 == "object" && !Array.isArray(data8)) {
                          if (data8.tags !== void 0) {
                            let data9 = data8.tags;
                            const _errs19 = errors;
                            if (errors === _errs19) {
                              if (data9 && typeof data9 == "object" && !Array.isArray(data9)) {
                                let missing2;
                                if (data9.kind === void 0 && (missing2 = "kind") || data9.list === void 0 && (missing2 = "list")) {
                                  validate65.errors = [{
                                    instancePath: instancePath + "/listSource/tags",
                                    schemaPath: "#/properties/listSource/properties/tags/required",
                                    keyword: "required",
                                    params: {
                                      missingProperty: missing2
                                    },
                                    message: "must have required property '" + missing2 + "'"
                                  }];
                                  return false;
                                } else {
                                  if (data9.kind !== void 0) {
                                    let data10 = data9.kind;
                                    const _errs21 = errors;
                                    if (typeof data10 !== "string") {
                                      validate65.errors = [{
                                        instancePath: instancePath + "/listSource/tags/kind",
                                        schemaPath: "#/properties/listSource/properties/tags/properties/kind/type",
                                        keyword: "type",
                                        params: {
                                          type: "string"
                                        },
                                        message: "must be string"
                                      }];
                                      return false;
                                    }
                                    if (!(data10 === "ALL" || data10 === "SOME")) {
                                      validate65.errors = [{
                                        instancePath: instancePath + "/listSource/tags/kind",
                                        schemaPath: "#/properties/listSource/properties/tags/properties/kind/enum",
                                        keyword: "enum",
                                        params: {
                                          allowedValues: schema76.properties.listSource.properties.tags.properties.kind.enum
                                        },
                                        message: "must be equal to one of the allowed values"
                                      }];
                                      return false;
                                    }
                                    var valid3 = _errs21 === errors;
                                  } else {
                                    var valid3 = true;
                                  }
                                  if (valid3) {
                                    if (data9.list !== void 0) {
                                      let data11 = data9.list;
                                      const _errs23 = errors;
                                      if (errors === _errs23) {
                                        if (Array.isArray(data11)) {
                                          var valid4 = true;
                                          const len0 = data11.length;
                                          for (let i0 = 0; i0 < len0; i0++) {
                                            const _errs25 = errors;
                                            if (typeof data11[i0] !== "string") {
                                              validate65.errors = [{
                                                instancePath: instancePath + "/listSource/tags/list/" + i0,
                                                schemaPath: "#/properties/listSource/properties/tags/properties/list/items/type",
                                                keyword: "type",
                                                params: {
                                                  type: "string"
                                                },
                                                message: "must be string"
                                              }];
                                              return false;
                                            }
                                            var valid4 = _errs25 === errors;
                                            if (!valid4) {
                                              break;
                                            }
                                          }
                                        } else {
                                          validate65.errors = [{
                                            instancePath: instancePath + "/listSource/tags/list",
                                            schemaPath: "#/properties/listSource/properties/tags/properties/list/type",
                                            keyword: "type",
                                            params: {
                                              type: "array"
                                            },
                                            message: "must be array"
                                          }];
                                          return false;
                                        }
                                      }
                                      var valid3 = _errs23 === errors;
                                    } else {
                                      var valid3 = true;
                                    }
                                  }
                                }
                              } else {
                                validate65.errors = [{
                                  instancePath: instancePath + "/listSource/tags",
                                  schemaPath: "#/properties/listSource/properties/tags/type",
                                  keyword: "type",
                                  params: {
                                    type: "object"
                                  },
                                  message: "must be object"
                                }];
                                return false;
                              }
                            }
                            var valid2 = _errs19 === errors;
                          } else {
                            var valid2 = true;
                          }
                          if (valid2) {
                            if (data8.eventId !== void 0) {
                              const _errs27 = errors;
                              if (typeof data8.eventId !== "string") {
                                validate65.errors = [{
                                  instancePath: instancePath + "/listSource/eventId",
                                  schemaPath: "#/properties/listSource/properties/eventId/type",
                                  keyword: "type",
                                  params: {
                                    type: "string"
                                  },
                                  message: "must be string"
                                }];
                                return false;
                              }
                              var valid2 = _errs27 === errors;
                            } else {
                              var valid2 = true;
                            }
                          }
                        } else {
                          validate65.errors = [{
                            instancePath: instancePath + "/listSource",
                            schemaPath: "#/properties/listSource/type",
                            keyword: "type",
                            params: {
                              type: "object"
                            },
                            message: "must be object"
                          }];
                          return false;
                        }
                      }
                      var valid0 = _errs17 === errors;
                    } else {
                      var valid0 = true;
                    }
                    if (valid0) {
                      if (data.size !== void 0) {
                        let data14 = data.size;
                        const _errs29 = errors;
                        if (!(typeof data14 == "number" && isFinite(data14))) {
                          validate65.errors = [{
                            instancePath: instancePath + "/size",
                            schemaPath: "#/properties/size/type",
                            keyword: "type",
                            params: {
                              type: "number"
                            },
                            message: "must be number"
                          }];
                          return false;
                        }
                        var valid0 = _errs29 === errors;
                      } else {
                        var valid0 = true;
                      }
                      if (valid0) {
                        if (data.dateRange !== void 0) {
                          let data15 = data.dateRange;
                          const _errs31 = errors;
                          if (errors === _errs31) {
                            if (Array.isArray(data15)) {
                              if (data15.length > 2) {
                                validate65.errors = [{
                                  instancePath: instancePath + "/dateRange",
                                  schemaPath: "#/properties/dateRange/maxItems",
                                  keyword: "maxItems",
                                  params: {
                                    limit: 2
                                  },
                                  message: "must NOT have more than 2 items"
                                }];
                                return false;
                              } else {
                                if (data15.length < 2) {
                                  validate65.errors = [{
                                    instancePath: instancePath + "/dateRange",
                                    schemaPath: "#/properties/dateRange/minItems",
                                    keyword: "minItems",
                                    params: {
                                      limit: 2
                                    },
                                    message: "must NOT have fewer than 2 items"
                                  }];
                                  return false;
                                } else {
                                  var valid5 = true;
                                  const len1 = data15.length;
                                  for (let i1 = 0; i1 < len1; i1++) {
                                    let data16 = data15[i1];
                                    const _errs33 = errors;
                                    const _errs34 = errors;
                                    let valid6 = false;
                                    const _errs35 = errors;
                                    if (typeof data16 !== "string") {
                                      const err0 = {
                                        instancePath: instancePath + "/dateRange/" + i1,
                                        schemaPath: "#/properties/dateRange/items/anyOf/0/type",
                                        keyword: "type",
                                        params: {
                                          type: "string"
                                        },
                                        message: "must be string"
                                      };
                                      if (vErrors === null) {
                                        vErrors = [err0];
                                      } else {
                                        vErrors.push(err0);
                                      }
                                      errors++;
                                    }
                                    if ("NOW" !== data16) {
                                      const err1 = {
                                        instancePath: instancePath + "/dateRange/" + i1,
                                        schemaPath: "#/properties/dateRange/items/anyOf/0/const",
                                        keyword: "const",
                                        params: {
                                          allowedValue: "NOW"
                                        },
                                        message: "must be equal to constant"
                                      };
                                      if (vErrors === null) {
                                        vErrors = [err1];
                                      } else {
                                        vErrors.push(err1);
                                      }
                                      errors++;
                                    }
                                    var _valid0 = _errs35 === errors;
                                    valid6 = valid6 || _valid0;
                                    if (!valid6) {
                                      const _errs37 = errors;
                                      if (!(data16 && typeof data16 == "object" && !Array.isArray(data16))) {
                                        const err2 = {
                                          instancePath: instancePath + "/dateRange/" + i1,
                                          schemaPath: "#/properties/dateRange/items/anyOf/1/type",
                                          keyword: "type",
                                          params: {
                                            type: "object"
                                          },
                                          message: "must be object"
                                        };
                                        if (vErrors === null) {
                                          vErrors = [err2];
                                        } else {
                                          vErrors.push(err2);
                                        }
                                        errors++;
                                      }
                                      if (errors === _errs37) {
                                        if (errors === _errs37) {
                                          if (typeof data16 === "string") {
                                            if (!formats0(data16)) {
                                              const err3 = {
                                                instancePath: instancePath + "/dateRange/" + i1,
                                                schemaPath: "#/properties/dateRange/items/anyOf/1/format",
                                                keyword: "format",
                                                params: {
                                                  format: "date-time"
                                                },
                                                message: 'must match format "date-time"'
                                              };
                                              if (vErrors === null) {
                                                vErrors = [err3];
                                              } else {
                                                vErrors.push(err3);
                                              }
                                              errors++;
                                            }
                                          }
                                        }
                                      }
                                      var _valid0 = _errs37 === errors;
                                      valid6 = valid6 || _valid0;
                                      if (!valid6) {
                                        const _errs39 = errors;
                                        if (data16 !== null) {
                                          const err4 = {
                                            instancePath: instancePath + "/dateRange/" + i1,
                                            schemaPath: "#/properties/dateRange/items/anyOf/2/type",
                                            keyword: "type",
                                            params: {
                                              type: "null"
                                            },
                                            message: "must be null"
                                          };
                                          if (vErrors === null) {
                                            vErrors = [err4];
                                          } else {
                                            vErrors.push(err4);
                                          }
                                          errors++;
                                        }
                                        var _valid0 = _errs39 === errors;
                                        valid6 = valid6 || _valid0;
                                      }
                                    }
                                    if (!valid6) {
                                      const err5 = {
                                        instancePath: instancePath + "/dateRange/" + i1,
                                        schemaPath: "#/properties/dateRange/items/anyOf",
                                        keyword: "anyOf",
                                        params: {},
                                        message: "must match a schema in anyOf"
                                      };
                                      if (vErrors === null) {
                                        vErrors = [err5];
                                      } else {
                                        vErrors.push(err5);
                                      }
                                      errors++;
                                      validate65.errors = vErrors;
                                      return false;
                                    } else {
                                      errors = _errs34;
                                      if (vErrors !== null) {
                                        if (_errs34) {
                                          vErrors.length = _errs34;
                                        } else {
                                          vErrors = null;
                                        }
                                      }
                                    }
                                    var valid5 = _errs33 === errors;
                                    if (!valid5) {
                                      break;
                                    }
                                  }
                                }
                              }
                            } else {
                              validate65.errors = [{
                                instancePath: instancePath + "/dateRange",
                                schemaPath: "#/properties/dateRange/type",
                                keyword: "type",
                                params: {
                                  type: "array"
                                },
                                message: "must be array"
                              }];
                              return false;
                            }
                          }
                          var valid0 = _errs31 === errors;
                        } else {
                          var valid0 = true;
                        }
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
    } else {
      validate65.errors = [{
        instancePath,
        schemaPath: "#/type",
        keyword: "type",
        params: {
          type: "object"
        },
        message: "must be object"
      }];
      return false;
    }
  }
  validate65.errors = vErrors;
  return errors === 0;
}
const StaticNamedTagListSource = validate66;
function validate66(data, {
  instancePath = "",
  parentData,
  parentDataProperty,
  rootData = data
} = {}) {
  let vErrors = null;
  let errors = 0;
  {
    if (data && typeof data == "object" && !Array.isArray(data)) {
      let missing0;
      if (data.tagIds === void 0 && (missing0 = "tagIds")) {
        validate66.errors = [{
          instancePath,
          schemaPath: "#/required",
          keyword: "required",
          params: {
            missingProperty: missing0
          },
          message: "must have required property '" + missing0 + "'"
        }];
        return false;
      } else {
        if (data.tagIds !== void 0) {
          let data0 = data.tagIds;
          {
            if (Array.isArray(data0)) {
              var valid1 = true;
              const len0 = data0.length;
              for (let i0 = 0; i0 < len0; i0++) {
                const _errs3 = errors;
                if (typeof data0[i0] !== "string") {
                  validate66.errors = [{
                    instancePath: instancePath + "/tagIds/" + i0,
                    schemaPath: "#/properties/tagIds/items/type",
                    keyword: "type",
                    params: {
                      type: "string"
                    },
                    message: "must be string"
                  }];
                  return false;
                }
                var valid1 = _errs3 === errors;
                if (!valid1) {
                  break;
                }
              }
            } else {
              validate66.errors = [{
                instancePath: instancePath + "/tagIds",
                schemaPath: "#/properties/tagIds/type",
                keyword: "type",
                params: {
                  type: "array"
                },
                message: "must be array"
              }];
              return false;
            }
          }
        }
      }
    } else {
      validate66.errors = [{
        instancePath,
        schemaPath: "#/type",
        keyword: "type",
        params: {
          type: "object"
        },
        message: "must be object"
      }];
      return false;
    }
  }
  validate66.errors = vErrors;
  return errors === 0;
}
const DynamicNamedTagListSource = validate67;
const schema78 = {
  "$id": "DynamicNamedTagListSource",
  "$schema": "http://json-schema.org/draft-07/schema#",
  "type": "object",
  "properties": {
    "type": {
      "type": "string",
      "enum": ["EVENT", "ATHLETE", "PLACE", "TOURNAMENT", "TEAM", "SEASON"]
    }
  },
  "required": ["type"]
};
function validate67(data, {
  instancePath = "",
  parentData,
  parentDataProperty,
  rootData = data
} = {}) {
  let vErrors = null;
  let errors = 0;
  {
    if (data && typeof data == "object" && !Array.isArray(data)) {
      let missing0;
      if (data.type === void 0 && (missing0 = "type")) {
        validate67.errors = [{
          instancePath,
          schemaPath: "#/required",
          keyword: "required",
          params: {
            missingProperty: missing0
          },
          message: "must have required property '" + missing0 + "'"
        }];
        return false;
      } else {
        if (data.type !== void 0) {
          let data0 = data.type;
          if (typeof data0 !== "string") {
            validate67.errors = [{
              instancePath: instancePath + "/type",
              schemaPath: "#/properties/type/type",
              keyword: "type",
              params: {
                type: "string"
              },
              message: "must be string"
            }];
            return false;
          }
          if (!(data0 === "EVENT" || data0 === "ATHLETE" || data0 === "PLACE" || data0 === "TOURNAMENT" || data0 === "TEAM" || data0 === "SEASON")) {
            validate67.errors = [{
              instancePath: instancePath + "/type",
              schemaPath: "#/properties/type/enum",
              keyword: "enum",
              params: {
                allowedValues: schema78.properties.type.enum
              },
              message: "must be equal to one of the allowed values"
            }];
            return false;
          }
        }
      }
    } else {
      validate67.errors = [{
        instancePath,
        schemaPath: "#/type",
        keyword: "type",
        params: {
          type: "object"
        },
        message: "must be object"
      }];
      return false;
    }
  }
  validate67.errors = vErrors;
  return errors === 0;
}
const NamedTagListSource = validate68;
function validate68(data, {
  instancePath = "",
  parentData,
  parentDataProperty,
  rootData = data
} = {}) {
  let vErrors = null;
  let errors = 0;
  const _errs0 = errors;
  let valid0 = false;
  const _errs1 = errors;
  const _errs2 = errors;
  if (errors === _errs2) {
    if (data && typeof data == "object" && !Array.isArray(data)) {
      let missing0;
      if (data.tagIds === void 0 && (missing0 = "tagIds")) {
        const err0 = {
          instancePath,
          schemaPath: "StaticNamedTagListSource/required",
          keyword: "required",
          params: {
            missingProperty: missing0
          },
          message: "must have required property '" + missing0 + "'"
        };
        if (vErrors === null) {
          vErrors = [err0];
        } else {
          vErrors.push(err0);
        }
        errors++;
      } else {
        if (data.tagIds !== void 0) {
          let data0 = data.tagIds;
          const _errs4 = errors;
          if (errors === _errs4) {
            if (Array.isArray(data0)) {
              var valid3 = true;
              const len0 = data0.length;
              for (let i0 = 0; i0 < len0; i0++) {
                const _errs6 = errors;
                if (typeof data0[i0] !== "string") {
                  const err1 = {
                    instancePath: instancePath + "/tagIds/" + i0,
                    schemaPath: "StaticNamedTagListSource/properties/tagIds/items/type",
                    keyword: "type",
                    params: {
                      type: "string"
                    },
                    message: "must be string"
                  };
                  if (vErrors === null) {
                    vErrors = [err1];
                  } else {
                    vErrors.push(err1);
                  }
                  errors++;
                }
                var valid3 = _errs6 === errors;
                if (!valid3) {
                  break;
                }
              }
            } else {
              const err2 = {
                instancePath: instancePath + "/tagIds",
                schemaPath: "StaticNamedTagListSource/properties/tagIds/type",
                keyword: "type",
                params: {
                  type: "array"
                },
                message: "must be array"
              };
              if (vErrors === null) {
                vErrors = [err2];
              } else {
                vErrors.push(err2);
              }
              errors++;
            }
          }
        }
      }
    } else {
      const err3 = {
        instancePath,
        schemaPath: "StaticNamedTagListSource/type",
        keyword: "type",
        params: {
          type: "object"
        },
        message: "must be object"
      };
      if (vErrors === null) {
        vErrors = [err3];
      } else {
        vErrors.push(err3);
      }
      errors++;
    }
  }
  var _valid0 = _errs1 === errors;
  valid0 = valid0 || _valid0;
  if (!valid0) {
    const _errs8 = errors;
    const _errs9 = errors;
    if (errors === _errs9) {
      if (data && typeof data == "object" && !Array.isArray(data)) {
        let missing1;
        if (data.type === void 0 && (missing1 = "type")) {
          const err4 = {
            instancePath,
            schemaPath: "DynamicNamedTagListSource/required",
            keyword: "required",
            params: {
              missingProperty: missing1
            },
            message: "must have required property '" + missing1 + "'"
          };
          if (vErrors === null) {
            vErrors = [err4];
          } else {
            vErrors.push(err4);
          }
          errors++;
        } else {
          if (data.type !== void 0) {
            let data2 = data.type;
            if (typeof data2 !== "string") {
              const err5 = {
                instancePath: instancePath + "/type",
                schemaPath: "DynamicNamedTagListSource/properties/type/type",
                keyword: "type",
                params: {
                  type: "string"
                },
                message: "must be string"
              };
              if (vErrors === null) {
                vErrors = [err5];
              } else {
                vErrors.push(err5);
              }
              errors++;
            }
            if (!(data2 === "EVENT" || data2 === "ATHLETE" || data2 === "PLACE" || data2 === "TOURNAMENT" || data2 === "TEAM" || data2 === "SEASON")) {
              const err6 = {
                instancePath: instancePath + "/type",
                schemaPath: "DynamicNamedTagListSource/properties/type/enum",
                keyword: "enum",
                params: {
                  allowedValues: schema78.properties.type.enum
                },
                message: "must be equal to one of the allowed values"
              };
              if (vErrors === null) {
                vErrors = [err6];
              } else {
                vErrors.push(err6);
              }
              errors++;
            }
          }
        }
      } else {
        const err7 = {
          instancePath,
          schemaPath: "DynamicNamedTagListSource/type",
          keyword: "type",
          params: {
            type: "object"
          },
          message: "must be object"
        };
        if (vErrors === null) {
          vErrors = [err7];
        } else {
          vErrors.push(err7);
        }
        errors++;
      }
    }
    var _valid0 = _errs8 === errors;
    valid0 = valid0 || _valid0;
  }
  if (!valid0) {
    const err8 = {
      instancePath,
      schemaPath: "#/anyOf",
      keyword: "anyOf",
      params: {},
      message: "must match a schema in anyOf"
    };
    if (vErrors === null) {
      vErrors = [err8];
    } else {
      vErrors.push(err8);
    }
    errors++;
    validate68.errors = vErrors;
    return false;
  } else {
    errors = _errs0;
    if (vErrors !== null) {
      if (_errs0) {
        vErrors.length = _errs0;
      } else {
        vErrors = null;
      }
    }
  }
  validate68.errors = vErrors;
  return errors === 0;
}
const NamedTagsListModule = validate69;
const schema82 = {
  "$id": "NamedTagsListModule",
  "$schema": "http://json-schema.org/draft-07/schema#",
  "type": "object",
  "properties": {
    "moduleType": {
      "type": "string",
      "const": "NAMED_TAGS_LIST"
    },
    "heading": {
      "type": "string"
    },
    "subHeading": {
      "type": "string"
    },
    "layoutType": {
      "type": "string",
      "enum": ["CAROUSEL", "GRID"]
    },
    "density": {
      "type": "string",
      "enum": ["NORMAL", "DENSE", "DENSEST"]
    },
    "preferedGridSize": {
      "type": "object",
      "properties": {
        "columns": {
          "type": "number"
        },
        "rows": {
          "type": "number"
        }
      },
      "required": ["columns", "rows"]
    },
    "listSource": {
      "$ref": "NamedTagListSource"
    },
    "size": {
      "type": "number"
    }
  },
  "required": ["density", "layoutType", "listSource", "moduleType", "size"]
};
function validate69(data, {
  instancePath = "",
  parentData,
  parentDataProperty,
  rootData = data
} = {}) {
  let vErrors = null;
  let errors = 0;
  if (errors === 0) {
    if (data && typeof data == "object" && !Array.isArray(data)) {
      let missing0;
      if (data.density === void 0 && (missing0 = "density") || data.layoutType === void 0 && (missing0 = "layoutType") || data.listSource === void 0 && (missing0 = "listSource") || data.moduleType === void 0 && (missing0 = "moduleType") || data.size === void 0 && (missing0 = "size")) {
        validate69.errors = [{
          instancePath,
          schemaPath: "#/required",
          keyword: "required",
          params: {
            missingProperty: missing0
          },
          message: "must have required property '" + missing0 + "'"
        }];
        return false;
      } else {
        if (data.moduleType !== void 0) {
          let data0 = data.moduleType;
          const _errs1 = errors;
          if (typeof data0 !== "string") {
            validate69.errors = [{
              instancePath: instancePath + "/moduleType",
              schemaPath: "#/properties/moduleType/type",
              keyword: "type",
              params: {
                type: "string"
              },
              message: "must be string"
            }];
            return false;
          }
          if ("NAMED_TAGS_LIST" !== data0) {
            validate69.errors = [{
              instancePath: instancePath + "/moduleType",
              schemaPath: "#/properties/moduleType/const",
              keyword: "const",
              params: {
                allowedValue: "NAMED_TAGS_LIST"
              },
              message: "must be equal to constant"
            }];
            return false;
          }
          var valid0 = _errs1 === errors;
        } else {
          var valid0 = true;
        }
        if (valid0) {
          if (data.heading !== void 0) {
            const _errs3 = errors;
            if (typeof data.heading !== "string") {
              validate69.errors = [{
                instancePath: instancePath + "/heading",
                schemaPath: "#/properties/heading/type",
                keyword: "type",
                params: {
                  type: "string"
                },
                message: "must be string"
              }];
              return false;
            }
            var valid0 = _errs3 === errors;
          } else {
            var valid0 = true;
          }
          if (valid0) {
            if (data.subHeading !== void 0) {
              const _errs5 = errors;
              if (typeof data.subHeading !== "string") {
                validate69.errors = [{
                  instancePath: instancePath + "/subHeading",
                  schemaPath: "#/properties/subHeading/type",
                  keyword: "type",
                  params: {
                    type: "string"
                  },
                  message: "must be string"
                }];
                return false;
              }
              var valid0 = _errs5 === errors;
            } else {
              var valid0 = true;
            }
            if (valid0) {
              if (data.layoutType !== void 0) {
                let data3 = data.layoutType;
                const _errs7 = errors;
                if (typeof data3 !== "string") {
                  validate69.errors = [{
                    instancePath: instancePath + "/layoutType",
                    schemaPath: "#/properties/layoutType/type",
                    keyword: "type",
                    params: {
                      type: "string"
                    },
                    message: "must be string"
                  }];
                  return false;
                }
                if (!(data3 === "CAROUSEL" || data3 === "GRID")) {
                  validate69.errors = [{
                    instancePath: instancePath + "/layoutType",
                    schemaPath: "#/properties/layoutType/enum",
                    keyword: "enum",
                    params: {
                      allowedValues: schema82.properties.layoutType.enum
                    },
                    message: "must be equal to one of the allowed values"
                  }];
                  return false;
                }
                var valid0 = _errs7 === errors;
              } else {
                var valid0 = true;
              }
              if (valid0) {
                if (data.density !== void 0) {
                  let data4 = data.density;
                  const _errs9 = errors;
                  if (typeof data4 !== "string") {
                    validate69.errors = [{
                      instancePath: instancePath + "/density",
                      schemaPath: "#/properties/density/type",
                      keyword: "type",
                      params: {
                        type: "string"
                      },
                      message: "must be string"
                    }];
                    return false;
                  }
                  if (!(data4 === "NORMAL" || data4 === "DENSE" || data4 === "DENSEST")) {
                    validate69.errors = [{
                      instancePath: instancePath + "/density",
                      schemaPath: "#/properties/density/enum",
                      keyword: "enum",
                      params: {
                        allowedValues: schema82.properties.density.enum
                      },
                      message: "must be equal to one of the allowed values"
                    }];
                    return false;
                  }
                  var valid0 = _errs9 === errors;
                } else {
                  var valid0 = true;
                }
                if (valid0) {
                  if (data.preferedGridSize !== void 0) {
                    let data5 = data.preferedGridSize;
                    const _errs11 = errors;
                    if (errors === _errs11) {
                      if (data5 && typeof data5 == "object" && !Array.isArray(data5)) {
                        let missing1;
                        if (data5.columns === void 0 && (missing1 = "columns") || data5.rows === void 0 && (missing1 = "rows")) {
                          validate69.errors = [{
                            instancePath: instancePath + "/preferedGridSize",
                            schemaPath: "#/properties/preferedGridSize/required",
                            keyword: "required",
                            params: {
                              missingProperty: missing1
                            },
                            message: "must have required property '" + missing1 + "'"
                          }];
                          return false;
                        } else {
                          if (data5.columns !== void 0) {
                            let data6 = data5.columns;
                            const _errs13 = errors;
                            if (!(typeof data6 == "number" && isFinite(data6))) {
                              validate69.errors = [{
                                instancePath: instancePath + "/preferedGridSize/columns",
                                schemaPath: "#/properties/preferedGridSize/properties/columns/type",
                                keyword: "type",
                                params: {
                                  type: "number"
                                },
                                message: "must be number"
                              }];
                              return false;
                            }
                            var valid1 = _errs13 === errors;
                          } else {
                            var valid1 = true;
                          }
                          if (valid1) {
                            if (data5.rows !== void 0) {
                              let data7 = data5.rows;
                              const _errs15 = errors;
                              if (!(typeof data7 == "number" && isFinite(data7))) {
                                validate69.errors = [{
                                  instancePath: instancePath + "/preferedGridSize/rows",
                                  schemaPath: "#/properties/preferedGridSize/properties/rows/type",
                                  keyword: "type",
                                  params: {
                                    type: "number"
                                  },
                                  message: "must be number"
                                }];
                                return false;
                              }
                              var valid1 = _errs15 === errors;
                            } else {
                              var valid1 = true;
                            }
                          }
                        }
                      } else {
                        validate69.errors = [{
                          instancePath: instancePath + "/preferedGridSize",
                          schemaPath: "#/properties/preferedGridSize/type",
                          keyword: "type",
                          params: {
                            type: "object"
                          },
                          message: "must be object"
                        }];
                        return false;
                      }
                    }
                    var valid0 = _errs11 === errors;
                  } else {
                    var valid0 = true;
                  }
                  if (valid0) {
                    if (data.listSource !== void 0) {
                      const _errs17 = errors;
                      if (!validate68(data.listSource, {
                        instancePath: instancePath + "/listSource",
                        parentData: data,
                        parentDataProperty: "listSource",
                        rootData
                      })) {
                        vErrors = vErrors === null ? validate68.errors : vErrors.concat(validate68.errors);
                        errors = vErrors.length;
                      }
                      var valid0 = _errs17 === errors;
                    } else {
                      var valid0 = true;
                    }
                    if (valid0) {
                      if (data.size !== void 0) {
                        let data9 = data.size;
                        const _errs18 = errors;
                        if (!(typeof data9 == "number" && isFinite(data9))) {
                          validate69.errors = [{
                            instancePath: instancePath + "/size",
                            schemaPath: "#/properties/size/type",
                            keyword: "type",
                            params: {
                              type: "number"
                            },
                            message: "must be number"
                          }];
                          return false;
                        }
                        var valid0 = _errs18 === errors;
                      } else {
                        var valid0 = true;
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
    } else {
      validate69.errors = [{
        instancePath,
        schemaPath: "#/type",
        keyword: "type",
        params: {
          type: "object"
        },
        message: "must be object"
      }];
      return false;
    }
  }
  validate69.errors = vErrors;
  return errors === 0;
}
const TagsListModule = validate71;
function validate71(data, {
  instancePath = "",
  parentData,
  parentDataProperty,
  rootData = data
} = {}) {
  let vErrors = null;
  let errors = 0;
  {
    if (data && typeof data == "object" && !Array.isArray(data)) {
      let missing0;
      if (data.moduleType === void 0 && (missing0 = "moduleType") || data.tags === void 0 && (missing0 = "tags")) {
        validate71.errors = [{
          instancePath,
          schemaPath: "#/required",
          keyword: "required",
          params: {
            missingProperty: missing0
          },
          message: "must have required property '" + missing0 + "'"
        }];
        return false;
      } else {
        if (data.moduleType !== void 0) {
          let data0 = data.moduleType;
          const _errs1 = errors;
          if (typeof data0 !== "string") {
            validate71.errors = [{
              instancePath: instancePath + "/moduleType",
              schemaPath: "#/properties/moduleType/type",
              keyword: "type",
              params: {
                type: "string"
              },
              message: "must be string"
            }];
            return false;
          }
          if ("TAGS_LIST" !== data0) {
            validate71.errors = [{
              instancePath: instancePath + "/moduleType",
              schemaPath: "#/properties/moduleType/const",
              keyword: "const",
              params: {
                allowedValue: "TAGS_LIST"
              },
              message: "must be equal to constant"
            }];
            return false;
          }
          var valid0 = _errs1 === errors;
        } else {
          var valid0 = true;
        }
        if (valid0) {
          if (data.heading !== void 0) {
            const _errs3 = errors;
            if (typeof data.heading !== "string") {
              validate71.errors = [{
                instancePath: instancePath + "/heading",
                schemaPath: "#/properties/heading/type",
                keyword: "type",
                params: {
                  type: "string"
                },
                message: "must be string"
              }];
              return false;
            }
            var valid0 = _errs3 === errors;
          } else {
            var valid0 = true;
          }
          if (valid0) {
            if (data.subHeading !== void 0) {
              const _errs5 = errors;
              if (typeof data.subHeading !== "string") {
                validate71.errors = [{
                  instancePath: instancePath + "/subHeading",
                  schemaPath: "#/properties/subHeading/type",
                  keyword: "type",
                  params: {
                    type: "string"
                  },
                  message: "must be string"
                }];
                return false;
              }
              var valid0 = _errs5 === errors;
            } else {
              var valid0 = true;
            }
            if (valid0) {
              if (data.tags !== void 0) {
                let data3 = data.tags;
                const _errs7 = errors;
                {
                  if (Array.isArray(data3)) {
                    var valid1 = true;
                    const len0 = data3.length;
                    for (let i0 = 0; i0 < len0; i0++) {
                      const _errs9 = errors;
                      if (typeof data3[i0] !== "string") {
                        validate71.errors = [{
                          instancePath: instancePath + "/tags/" + i0,
                          schemaPath: "#/properties/tags/items/type",
                          keyword: "type",
                          params: {
                            type: "string"
                          },
                          message: "must be string"
                        }];
                        return false;
                      }
                      var valid1 = _errs9 === errors;
                      if (!valid1) {
                        break;
                      }
                    }
                  } else {
                    validate71.errors = [{
                      instancePath: instancePath + "/tags",
                      schemaPath: "#/properties/tags/type",
                      keyword: "type",
                      params: {
                        type: "array"
                      },
                      message: "must be array"
                    }];
                    return false;
                  }
                }
                var valid0 = _errs7 === errors;
              } else {
                var valid0 = true;
              }
            }
          }
        }
      }
    } else {
      validate71.errors = [{
        instancePath,
        schemaPath: "#/type",
        keyword: "type",
        params: {
          type: "object"
        },
        message: "must be object"
      }];
      return false;
    }
  }
  validate71.errors = vErrors;
  return errors === 0;
}
const AttributeKey = validate72;
const schema84 = {
  "$id": "AttributeKey",
  "$schema": "http://json-schema.org/draft-07/schema#",
  "type": "string",
  "enum": ["attr0", "attr1", "attr2", "attr3"]
};
function validate72(data, {
  instancePath = "",
  parentData,
  parentDataProperty,
  rootData = data
} = {}) {
  let vErrors = null;
  let errors = 0;
  if (typeof data !== "string") {
    validate72.errors = [{
      instancePath,
      schemaPath: "#/type",
      keyword: "type",
      params: {
        type: "string"
      },
      message: "must be string"
    }];
    return false;
  }
  if (!(data === "attr0" || data === "attr1" || data === "attr2" || data === "attr3")) {
    validate72.errors = [{
      instancePath,
      schemaPath: "#/enum",
      keyword: "enum",
      params: {
        allowedValues: schema84.enum
      },
      message: "must be equal to one of the allowed values"
    }];
    return false;
  }
  validate72.errors = vErrors;
  return errors === 0;
}
const CustomAttributes = validate73;
function validate73(data, {
  instancePath = "",
  parentData,
  parentDataProperty,
  rootData = data
} = {}) {
  let vErrors = null;
  let errors = 0;
  {
    if (data && typeof data == "object" && !Array.isArray(data)) {
      if (data.attr0 !== void 0) {
        const _errs1 = errors;
        if (typeof data.attr0 !== "string") {
          validate73.errors = [{
            instancePath: instancePath + "/attr0",
            schemaPath: "#/properties/attr0/type",
            keyword: "type",
            params: {
              type: "string"
            },
            message: "must be string"
          }];
          return false;
        }
        var valid0 = _errs1 === errors;
      } else {
        var valid0 = true;
      }
      if (valid0) {
        if (data.attr1 !== void 0) {
          const _errs3 = errors;
          if (typeof data.attr1 !== "string") {
            validate73.errors = [{
              instancePath: instancePath + "/attr1",
              schemaPath: "#/properties/attr1/type",
              keyword: "type",
              params: {
                type: "string"
              },
              message: "must be string"
            }];
            return false;
          }
          var valid0 = _errs3 === errors;
        } else {
          var valid0 = true;
        }
        if (valid0) {
          if (data.attr2 !== void 0) {
            const _errs5 = errors;
            if (typeof data.attr2 !== "string") {
              validate73.errors = [{
                instancePath: instancePath + "/attr2",
                schemaPath: "#/properties/attr2/type",
                keyword: "type",
                params: {
                  type: "string"
                },
                message: "must be string"
              }];
              return false;
            }
            var valid0 = _errs5 === errors;
          } else {
            var valid0 = true;
          }
          if (valid0) {
            if (data.attr3 !== void 0) {
              const _errs7 = errors;
              if (typeof data.attr3 !== "string") {
                validate73.errors = [{
                  instancePath: instancePath + "/attr3",
                  schemaPath: "#/properties/attr3/type",
                  keyword: "type",
                  params: {
                    type: "string"
                  },
                  message: "must be string"
                }];
                return false;
              }
              var valid0 = _errs7 === errors;
            } else {
              var valid0 = true;
            }
          }
        }
      }
    } else {
      validate73.errors = [{
        instancePath,
        schemaPath: "#/type",
        keyword: "type",
        params: {
          type: "object"
        },
        message: "must be object"
      }];
      return false;
    }
  }
  validate73.errors = vErrors;
  return errors === 0;
}
const FiltersAttributeDefinition = validate74;
const schema86 = {
  "$id": "FiltersAttributeDefinition",
  "$schema": "http://json-schema.org/draft-07/schema#",
  "anyOf": [{
    "type": "object",
    "properties": {
      "source": {
        "type": "string",
        "enum": ["tag", "event", "date"]
      }
    },
    "required": ["source"]
  }, {
    "$ref": "AttributeSource"
  }]
};
function validate75(data, {
  instancePath = "",
  parentData,
  parentDataProperty,
  rootData = data
} = {}) {
  let vErrors = null;
  let errors = 0;
  const _errs0 = errors;
  let valid0 = false;
  const _errs1 = errors;
  if (errors === _errs1) {
    if (data && typeof data == "object" && !Array.isArray(data)) {
      let missing0;
      if (data.source === void 0 && (missing0 = "source")) {
        const err0 = {
          instancePath,
          schemaPath: "#/anyOf/0/required",
          keyword: "required",
          params: {
            missingProperty: missing0
          },
          message: "must have required property '" + missing0 + "'"
        };
        if (vErrors === null) {
          vErrors = [err0];
        } else {
          vErrors.push(err0);
        }
        errors++;
      } else {
        if (data.source !== void 0) {
          let data0 = data.source;
          if (typeof data0 !== "string") {
            const err1 = {
              instancePath: instancePath + "/source",
              schemaPath: "AttributeKey/type",
              keyword: "type",
              params: {
                type: "string"
              },
              message: "must be string"
            };
            if (vErrors === null) {
              vErrors = [err1];
            } else {
              vErrors.push(err1);
            }
            errors++;
          }
          if (!(data0 === "attr0" || data0 === "attr1" || data0 === "attr2" || data0 === "attr3")) {
            const err2 = {
              instancePath: instancePath + "/source",
              schemaPath: "AttributeKey/enum",
              keyword: "enum",
              params: {
                allowedValues: schema84.enum
              },
              message: "must be equal to one of the allowed values"
            };
            if (vErrors === null) {
              vErrors = [err2];
            } else {
              vErrors.push(err2);
            }
            errors++;
          }
        }
      }
    } else {
      const err3 = {
        instancePath,
        schemaPath: "#/anyOf/0/type",
        keyword: "type",
        params: {
          type: "object"
        },
        message: "must be object"
      };
      if (vErrors === null) {
        vErrors = [err3];
      } else {
        vErrors.push(err3);
      }
      errors++;
    }
  }
  var _valid0 = _errs1 === errors;
  valid0 = valid0 || _valid0;
  if (!valid0) {
    const _errs6 = errors;
    if (errors === _errs6) {
      if (data && typeof data == "object" && !Array.isArray(data)) {
        let missing1;
        if (data.source === void 0 && (missing1 = "source") || data.groups === void 0 && (missing1 = "groups")) {
          const err4 = {
            instancePath,
            schemaPath: "#/anyOf/1/required",
            keyword: "required",
            params: {
              missingProperty: missing1
            },
            message: "must have required property '" + missing1 + "'"
          };
          if (vErrors === null) {
            vErrors = [err4];
          } else {
            vErrors.push(err4);
          }
          errors++;
        } else {
          if (data.source !== void 0) {
            let data1 = data.source;
            const _errs8 = errors;
            if (typeof data1 !== "string") {
              const err5 = {
                instancePath: instancePath + "/source",
                schemaPath: "AttributeKey/type",
                keyword: "type",
                params: {
                  type: "string"
                },
                message: "must be string"
              };
              if (vErrors === null) {
                vErrors = [err5];
              } else {
                vErrors.push(err5);
              }
              errors++;
            }
            if (!(data1 === "attr0" || data1 === "attr1" || data1 === "attr2" || data1 === "attr3")) {
              const err6 = {
                instancePath: instancePath + "/source",
                schemaPath: "AttributeKey/enum",
                keyword: "enum",
                params: {
                  allowedValues: schema84.enum
                },
                message: "must be equal to one of the allowed values"
              };
              if (vErrors === null) {
                vErrors = [err6];
              } else {
                vErrors.push(err6);
              }
              errors++;
            }
            var valid3 = _errs8 === errors;
          } else {
            var valid3 = true;
          }
          if (valid3) {
            if (data.groups !== void 0) {
              let data2 = data.groups;
              const _errs11 = errors;
              if (errors === _errs11) {
                if (Array.isArray(data2)) {
                  var valid5 = true;
                  const len0 = data2.length;
                  for (let i0 = 0; i0 < len0; i0++) {
                    const _errs13 = errors;
                    if (typeof data2[i0] !== "string") {
                      const err7 = {
                        instancePath: instancePath + "/groups/" + i0,
                        schemaPath: "#/anyOf/1/properties/groups/items/type",
                        keyword: "type",
                        params: {
                          type: "string"
                        },
                        message: "must be string"
                      };
                      if (vErrors === null) {
                        vErrors = [err7];
                      } else {
                        vErrors.push(err7);
                      }
                      errors++;
                    }
                    var valid5 = _errs13 === errors;
                    if (!valid5) {
                      break;
                    }
                  }
                } else {
                  const err8 = {
                    instancePath: instancePath + "/groups",
                    schemaPath: "#/anyOf/1/properties/groups/type",
                    keyword: "type",
                    params: {
                      type: "array"
                    },
                    message: "must be array"
                  };
                  if (vErrors === null) {
                    vErrors = [err8];
                  } else {
                    vErrors.push(err8);
                  }
                  errors++;
                }
              }
              var valid3 = _errs11 === errors;
            } else {
              var valid3 = true;
            }
          }
        }
      } else {
        const err9 = {
          instancePath,
          schemaPath: "#/anyOf/1/type",
          keyword: "type",
          params: {
            type: "object"
          },
          message: "must be object"
        };
        if (vErrors === null) {
          vErrors = [err9];
        } else {
          vErrors.push(err9);
        }
        errors++;
      }
    }
    var _valid0 = _errs6 === errors;
    valid0 = valid0 || _valid0;
    if (!valid0) {
      const _errs15 = errors;
      if (errors === _errs15) {
        if (data && typeof data == "object" && !Array.isArray(data)) {
          let missing2;
          if (data.source === void 0 && (missing2 = "source") || data.values === void 0 && (missing2 = "values")) {
            const err10 = {
              instancePath,
              schemaPath: "#/anyOf/2/required",
              keyword: "required",
              params: {
                missingProperty: missing2
              },
              message: "must have required property '" + missing2 + "'"
            };
            if (vErrors === null) {
              vErrors = [err10];
            } else {
              vErrors.push(err10);
            }
            errors++;
          } else {
            if (data.source !== void 0) {
              let data4 = data.source;
              const _errs17 = errors;
              if (typeof data4 !== "string") {
                const err11 = {
                  instancePath: instancePath + "/source",
                  schemaPath: "AttributeKey/type",
                  keyword: "type",
                  params: {
                    type: "string"
                  },
                  message: "must be string"
                };
                if (vErrors === null) {
                  vErrors = [err11];
                } else {
                  vErrors.push(err11);
                }
                errors++;
              }
              if (!(data4 === "attr0" || data4 === "attr1" || data4 === "attr2" || data4 === "attr3")) {
                const err12 = {
                  instancePath: instancePath + "/source",
                  schemaPath: "AttributeKey/enum",
                  keyword: "enum",
                  params: {
                    allowedValues: schema84.enum
                  },
                  message: "must be equal to one of the allowed values"
                };
                if (vErrors === null) {
                  vErrors = [err12];
                } else {
                  vErrors.push(err12);
                }
                errors++;
              }
              var valid6 = _errs17 === errors;
            } else {
              var valid6 = true;
            }
            if (valid6) {
              if (data.values !== void 0) {
                let data5 = data.values;
                const _errs20 = errors;
                if (errors === _errs20) {
                  if (Array.isArray(data5)) {
                    var valid8 = true;
                    const len1 = data5.length;
                    for (let i1 = 0; i1 < len1; i1++) {
                      const _errs22 = errors;
                      if (typeof data5[i1] !== "string") {
                        const err13 = {
                          instancePath: instancePath + "/values/" + i1,
                          schemaPath: "#/anyOf/2/properties/values/items/type",
                          keyword: "type",
                          params: {
                            type: "string"
                          },
                          message: "must be string"
                        };
                        if (vErrors === null) {
                          vErrors = [err13];
                        } else {
                          vErrors.push(err13);
                        }
                        errors++;
                      }
                      var valid8 = _errs22 === errors;
                      if (!valid8) {
                        break;
                      }
                    }
                  } else {
                    const err14 = {
                      instancePath: instancePath + "/values",
                      schemaPath: "#/anyOf/2/properties/values/type",
                      keyword: "type",
                      params: {
                        type: "array"
                      },
                      message: "must be array"
                    };
                    if (vErrors === null) {
                      vErrors = [err14];
                    } else {
                      vErrors.push(err14);
                    }
                    errors++;
                  }
                }
                var valid6 = _errs20 === errors;
              } else {
                var valid6 = true;
              }
            }
          }
        } else {
          const err15 = {
            instancePath,
            schemaPath: "#/anyOf/2/type",
            keyword: "type",
            params: {
              type: "object"
            },
            message: "must be object"
          };
          if (vErrors === null) {
            vErrors = [err15];
          } else {
            vErrors.push(err15);
          }
          errors++;
        }
      }
      var _valid0 = _errs15 === errors;
      valid0 = valid0 || _valid0;
    }
  }
  if (!valid0) {
    const err16 = {
      instancePath,
      schemaPath: "#/anyOf",
      keyword: "anyOf",
      params: {},
      message: "must match a schema in anyOf"
    };
    if (vErrors === null) {
      vErrors = [err16];
    } else {
      vErrors.push(err16);
    }
    errors++;
    validate75.errors = vErrors;
    return false;
  } else {
    errors = _errs0;
    if (vErrors !== null) {
      if (_errs0) {
        vErrors.length = _errs0;
      } else {
        vErrors = null;
      }
    }
  }
  validate75.errors = vErrors;
  return errors === 0;
}
function validate74(data, {
  instancePath = "",
  parentData,
  parentDataProperty,
  rootData = data
} = {}) {
  let vErrors = null;
  let errors = 0;
  const _errs0 = errors;
  let valid0 = false;
  const _errs1 = errors;
  if (errors === _errs1) {
    if (data && typeof data == "object" && !Array.isArray(data)) {
      let missing0;
      if (data.source === void 0 && (missing0 = "source")) {
        const err0 = {
          instancePath,
          schemaPath: "#/anyOf/0/required",
          keyword: "required",
          params: {
            missingProperty: missing0
          },
          message: "must have required property '" + missing0 + "'"
        };
        if (vErrors === null) {
          vErrors = [err0];
        } else {
          vErrors.push(err0);
        }
        errors++;
      } else {
        if (data.source !== void 0) {
          let data0 = data.source;
          if (typeof data0 !== "string") {
            const err1 = {
              instancePath: instancePath + "/source",
              schemaPath: "#/anyOf/0/properties/source/type",
              keyword: "type",
              params: {
                type: "string"
              },
              message: "must be string"
            };
            if (vErrors === null) {
              vErrors = [err1];
            } else {
              vErrors.push(err1);
            }
            errors++;
          }
          if (!(data0 === "tag" || data0 === "event" || data0 === "date")) {
            const err2 = {
              instancePath: instancePath + "/source",
              schemaPath: "#/anyOf/0/properties/source/enum",
              keyword: "enum",
              params: {
                allowedValues: schema86.anyOf[0].properties.source.enum
              },
              message: "must be equal to one of the allowed values"
            };
            if (vErrors === null) {
              vErrors = [err2];
            } else {
              vErrors.push(err2);
            }
            errors++;
          }
        }
      }
    } else {
      const err3 = {
        instancePath,
        schemaPath: "#/anyOf/0/type",
        keyword: "type",
        params: {
          type: "object"
        },
        message: "must be object"
      };
      if (vErrors === null) {
        vErrors = [err3];
      } else {
        vErrors.push(err3);
      }
      errors++;
    }
  }
  var _valid0 = _errs1 === errors;
  valid0 = valid0 || _valid0;
  if (!valid0) {
    const _errs5 = errors;
    if (!validate75(data, {
      instancePath,
      parentData,
      parentDataProperty,
      rootData
    })) {
      vErrors = vErrors === null ? validate75.errors : vErrors.concat(validate75.errors);
      errors = vErrors.length;
    }
    var _valid0 = _errs5 === errors;
    valid0 = valid0 || _valid0;
  }
  if (!valid0) {
    const err4 = {
      instancePath,
      schemaPath: "#/anyOf",
      keyword: "anyOf",
      params: {},
      message: "must match a schema in anyOf"
    };
    if (vErrors === null) {
      vErrors = [err4];
    } else {
      vErrors.push(err4);
    }
    errors++;
    validate74.errors = vErrors;
    return false;
  } else {
    errors = _errs0;
    if (vErrors !== null) {
      if (_errs0) {
        vErrors.length = _errs0;
      } else {
        vErrors = null;
      }
    }
  }
  validate74.errors = vErrors;
  return errors === 0;
}
const AttributeSource = validate75;
const DynamicVideoListSource = validate77;
const schema91 = {
  "$id": "DynamicVideoListSource",
  "$schema": "http://json-schema.org/draft-07/schema#",
  "type": "object",
  "properties": {
    "tags": {
      "type": "object",
      "properties": {
        "kind": {
          "type": "string",
          "enum": ["ALL", "SOME"]
        },
        "list": {
          "type": "array",
          "items": {
            "type": "string"
          }
        }
      },
      "required": ["kind", "list"]
    },
    "eventId": {
      "type": "string"
    },
    "type": {
      "type": "string",
      "enum": ["SHORT", "STREAM", "UPLOAD"]
    },
    "streamState": {
      "type": "string",
      "enum": ["LIVE", "SCHEDULED", "FINISHED"]
    },
    "attributes": {
      "$ref": "CustomAttributes"
    },
    "paged": {
      "type": "boolean"
    }
  },
  "description": "A source referencing a dynamic list of videos that need to be loaded at runtime"
};
function validate77(data, {
  instancePath = "",
  parentData,
  parentDataProperty,
  rootData = data
} = {}) {
  let vErrors = null;
  let errors = 0;
  {
    if (data && typeof data == "object" && !Array.isArray(data)) {
      if (data.tags !== void 0) {
        let data0 = data.tags;
        const _errs1 = errors;
        {
          if (data0 && typeof data0 == "object" && !Array.isArray(data0)) {
            let missing0;
            if (data0.kind === void 0 && (missing0 = "kind") || data0.list === void 0 && (missing0 = "list")) {
              validate77.errors = [{
                instancePath: instancePath + "/tags",
                schemaPath: "#/properties/tags/required",
                keyword: "required",
                params: {
                  missingProperty: missing0
                },
                message: "must have required property '" + missing0 + "'"
              }];
              return false;
            } else {
              if (data0.kind !== void 0) {
                let data1 = data0.kind;
                const _errs3 = errors;
                if (typeof data1 !== "string") {
                  validate77.errors = [{
                    instancePath: instancePath + "/tags/kind",
                    schemaPath: "#/properties/tags/properties/kind/type",
                    keyword: "type",
                    params: {
                      type: "string"
                    },
                    message: "must be string"
                  }];
                  return false;
                }
                if (!(data1 === "ALL" || data1 === "SOME")) {
                  validate77.errors = [{
                    instancePath: instancePath + "/tags/kind",
                    schemaPath: "#/properties/tags/properties/kind/enum",
                    keyword: "enum",
                    params: {
                      allowedValues: schema91.properties.tags.properties.kind.enum
                    },
                    message: "must be equal to one of the allowed values"
                  }];
                  return false;
                }
                var valid1 = _errs3 === errors;
              } else {
                var valid1 = true;
              }
              if (valid1) {
                if (data0.list !== void 0) {
                  let data2 = data0.list;
                  const _errs5 = errors;
                  {
                    if (Array.isArray(data2)) {
                      var valid2 = true;
                      const len0 = data2.length;
                      for (let i0 = 0; i0 < len0; i0++) {
                        const _errs7 = errors;
                        if (typeof data2[i0] !== "string") {
                          validate77.errors = [{
                            instancePath: instancePath + "/tags/list/" + i0,
                            schemaPath: "#/properties/tags/properties/list/items/type",
                            keyword: "type",
                            params: {
                              type: "string"
                            },
                            message: "must be string"
                          }];
                          return false;
                        }
                        var valid2 = _errs7 === errors;
                        if (!valid2) {
                          break;
                        }
                      }
                    } else {
                      validate77.errors = [{
                        instancePath: instancePath + "/tags/list",
                        schemaPath: "#/properties/tags/properties/list/type",
                        keyword: "type",
                        params: {
                          type: "array"
                        },
                        message: "must be array"
                      }];
                      return false;
                    }
                  }
                  var valid1 = _errs5 === errors;
                } else {
                  var valid1 = true;
                }
              }
            }
          } else {
            validate77.errors = [{
              instancePath: instancePath + "/tags",
              schemaPath: "#/properties/tags/type",
              keyword: "type",
              params: {
                type: "object"
              },
              message: "must be object"
            }];
            return false;
          }
        }
        var valid0 = _errs1 === errors;
      } else {
        var valid0 = true;
      }
      if (valid0) {
        if (data.eventId !== void 0) {
          const _errs9 = errors;
          if (typeof data.eventId !== "string") {
            validate77.errors = [{
              instancePath: instancePath + "/eventId",
              schemaPath: "#/properties/eventId/type",
              keyword: "type",
              params: {
                type: "string"
              },
              message: "must be string"
            }];
            return false;
          }
          var valid0 = _errs9 === errors;
        } else {
          var valid0 = true;
        }
        if (valid0) {
          if (data.type !== void 0) {
            let data5 = data.type;
            const _errs11 = errors;
            if (typeof data5 !== "string") {
              validate77.errors = [{
                instancePath: instancePath + "/type",
                schemaPath: "#/properties/type/type",
                keyword: "type",
                params: {
                  type: "string"
                },
                message: "must be string"
              }];
              return false;
            }
            if (!(data5 === "SHORT" || data5 === "STREAM" || data5 === "UPLOAD")) {
              validate77.errors = [{
                instancePath: instancePath + "/type",
                schemaPath: "#/properties/type/enum",
                keyword: "enum",
                params: {
                  allowedValues: schema91.properties.type.enum
                },
                message: "must be equal to one of the allowed values"
              }];
              return false;
            }
            var valid0 = _errs11 === errors;
          } else {
            var valid0 = true;
          }
          if (valid0) {
            if (data.streamState !== void 0) {
              let data6 = data.streamState;
              const _errs13 = errors;
              if (typeof data6 !== "string") {
                validate77.errors = [{
                  instancePath: instancePath + "/streamState",
                  schemaPath: "#/properties/streamState/type",
                  keyword: "type",
                  params: {
                    type: "string"
                  },
                  message: "must be string"
                }];
                return false;
              }
              if (!(data6 === "LIVE" || data6 === "SCHEDULED" || data6 === "FINISHED")) {
                validate77.errors = [{
                  instancePath: instancePath + "/streamState",
                  schemaPath: "#/properties/streamState/enum",
                  keyword: "enum",
                  params: {
                    allowedValues: schema91.properties.streamState.enum
                  },
                  message: "must be equal to one of the allowed values"
                }];
                return false;
              }
              var valid0 = _errs13 === errors;
            } else {
              var valid0 = true;
            }
            if (valid0) {
              if (data.attributes !== void 0) {
                let data7 = data.attributes;
                const _errs15 = errors;
                {
                  if (data7 && typeof data7 == "object" && !Array.isArray(data7)) {
                    if (data7.attr0 !== void 0) {
                      const _errs18 = errors;
                      if (typeof data7.attr0 !== "string") {
                        validate77.errors = [{
                          instancePath: instancePath + "/attributes/attr0",
                          schemaPath: "CustomAttributes/properties/attr0/type",
                          keyword: "type",
                          params: {
                            type: "string"
                          },
                          message: "must be string"
                        }];
                        return false;
                      }
                      var valid4 = _errs18 === errors;
                    } else {
                      var valid4 = true;
                    }
                    if (valid4) {
                      if (data7.attr1 !== void 0) {
                        const _errs20 = errors;
                        if (typeof data7.attr1 !== "string") {
                          validate77.errors = [{
                            instancePath: instancePath + "/attributes/attr1",
                            schemaPath: "CustomAttributes/properties/attr1/type",
                            keyword: "type",
                            params: {
                              type: "string"
                            },
                            message: "must be string"
                          }];
                          return false;
                        }
                        var valid4 = _errs20 === errors;
                      } else {
                        var valid4 = true;
                      }
                      if (valid4) {
                        if (data7.attr2 !== void 0) {
                          const _errs22 = errors;
                          if (typeof data7.attr2 !== "string") {
                            validate77.errors = [{
                              instancePath: instancePath + "/attributes/attr2",
                              schemaPath: "CustomAttributes/properties/attr2/type",
                              keyword: "type",
                              params: {
                                type: "string"
                              },
                              message: "must be string"
                            }];
                            return false;
                          }
                          var valid4 = _errs22 === errors;
                        } else {
                          var valid4 = true;
                        }
                        if (valid4) {
                          if (data7.attr3 !== void 0) {
                            const _errs24 = errors;
                            if (typeof data7.attr3 !== "string") {
                              validate77.errors = [{
                                instancePath: instancePath + "/attributes/attr3",
                                schemaPath: "CustomAttributes/properties/attr3/type",
                                keyword: "type",
                                params: {
                                  type: "string"
                                },
                                message: "must be string"
                              }];
                              return false;
                            }
                            var valid4 = _errs24 === errors;
                          } else {
                            var valid4 = true;
                          }
                        }
                      }
                    }
                  } else {
                    validate77.errors = [{
                      instancePath: instancePath + "/attributes",
                      schemaPath: "CustomAttributes/type",
                      keyword: "type",
                      params: {
                        type: "object"
                      },
                      message: "must be object"
                    }];
                    return false;
                  }
                }
                var valid0 = _errs15 === errors;
              } else {
                var valid0 = true;
              }
              if (valid0) {
                if (data.paged !== void 0) {
                  const _errs26 = errors;
                  if (typeof data.paged !== "boolean") {
                    validate77.errors = [{
                      instancePath: instancePath + "/paged",
                      schemaPath: "#/properties/paged/type",
                      keyword: "type",
                      params: {
                        type: "boolean"
                      },
                      message: "must be boolean"
                    }];
                    return false;
                  }
                  var valid0 = _errs26 === errors;
                } else {
                  var valid0 = true;
                }
              }
            }
          }
        }
      }
    } else {
      validate77.errors = [{
        instancePath,
        schemaPath: "#/type",
        keyword: "type",
        params: {
          type: "object"
        },
        message: "must be object"
      }];
      return false;
    }
  }
  validate77.errors = vErrors;
  return errors === 0;
}
const StaticVideoListSource = validate78;
function validate78(data, {
  instancePath = "",
  parentData,
  parentDataProperty,
  rootData = data
} = {}) {
  let vErrors = null;
  let errors = 0;
  {
    if (data && typeof data == "object" && !Array.isArray(data)) {
      let missing0;
      if (data.videoIds === void 0 && (missing0 = "videoIds")) {
        validate78.errors = [{
          instancePath,
          schemaPath: "#/required",
          keyword: "required",
          params: {
            missingProperty: missing0
          },
          message: "must have required property '" + missing0 + "'"
        }];
        return false;
      } else {
        if (data.videoIds !== void 0) {
          let data0 = data.videoIds;
          {
            if (Array.isArray(data0)) {
              var valid1 = true;
              const len0 = data0.length;
              for (let i0 = 0; i0 < len0; i0++) {
                const _errs3 = errors;
                if (typeof data0[i0] !== "string") {
                  validate78.errors = [{
                    instancePath: instancePath + "/videoIds/" + i0,
                    schemaPath: "#/properties/videoIds/items/type",
                    keyword: "type",
                    params: {
                      type: "string"
                    },
                    message: "must be string"
                  }];
                  return false;
                }
                var valid1 = _errs3 === errors;
                if (!valid1) {
                  break;
                }
              }
            } else {
              validate78.errors = [{
                instancePath: instancePath + "/videoIds",
                schemaPath: "#/properties/videoIds/type",
                keyword: "type",
                params: {
                  type: "array"
                },
                message: "must be array"
              }];
              return false;
            }
          }
        }
      }
    } else {
      validate78.errors = [{
        instancePath,
        schemaPath: "#/type",
        keyword: "type",
        params: {
          type: "object"
        },
        message: "must be object"
      }];
      return false;
    }
  }
  validate78.errors = vErrors;
  return errors === 0;
}
const VideoListSource = validate79;
function validate79(data, {
  instancePath = "",
  parentData,
  parentDataProperty,
  rootData = data
} = {}) {
  let vErrors = null;
  let errors = 0;
  const _errs0 = errors;
  let valid0 = false;
  const _errs1 = errors;
  const _errs2 = errors;
  if (errors === _errs2) {
    if (data && typeof data == "object" && !Array.isArray(data)) {
      let missing0;
      if (data.videoIds === void 0 && (missing0 = "videoIds")) {
        const err0 = {
          instancePath,
          schemaPath: "StaticVideoListSource/required",
          keyword: "required",
          params: {
            missingProperty: missing0
          },
          message: "must have required property '" + missing0 + "'"
        };
        if (vErrors === null) {
          vErrors = [err0];
        } else {
          vErrors.push(err0);
        }
        errors++;
      } else {
        if (data.videoIds !== void 0) {
          let data0 = data.videoIds;
          const _errs4 = errors;
          if (errors === _errs4) {
            if (Array.isArray(data0)) {
              var valid3 = true;
              const len0 = data0.length;
              for (let i0 = 0; i0 < len0; i0++) {
                const _errs6 = errors;
                if (typeof data0[i0] !== "string") {
                  const err1 = {
                    instancePath: instancePath + "/videoIds/" + i0,
                    schemaPath: "StaticVideoListSource/properties/videoIds/items/type",
                    keyword: "type",
                    params: {
                      type: "string"
                    },
                    message: "must be string"
                  };
                  if (vErrors === null) {
                    vErrors = [err1];
                  } else {
                    vErrors.push(err1);
                  }
                  errors++;
                }
                var valid3 = _errs6 === errors;
                if (!valid3) {
                  break;
                }
              }
            } else {
              const err2 = {
                instancePath: instancePath + "/videoIds",
                schemaPath: "StaticVideoListSource/properties/videoIds/type",
                keyword: "type",
                params: {
                  type: "array"
                },
                message: "must be array"
              };
              if (vErrors === null) {
                vErrors = [err2];
              } else {
                vErrors.push(err2);
              }
              errors++;
            }
          }
        }
      }
    } else {
      const err3 = {
        instancePath,
        schemaPath: "StaticVideoListSource/type",
        keyword: "type",
        params: {
          type: "object"
        },
        message: "must be object"
      };
      if (vErrors === null) {
        vErrors = [err3];
      } else {
        vErrors.push(err3);
      }
      errors++;
    }
  }
  var _valid0 = _errs1 === errors;
  valid0 = valid0 || _valid0;
  if (!valid0) {
    const _errs8 = errors;
    if (!validate77(data, {
      instancePath,
      parentData,
      parentDataProperty,
      rootData
    })) {
      vErrors = vErrors === null ? validate77.errors : vErrors.concat(validate77.errors);
      errors = vErrors.length;
    }
    var _valid0 = _errs8 === errors;
    valid0 = valid0 || _valid0;
  }
  if (!valid0) {
    const err4 = {
      instancePath,
      schemaPath: "#/anyOf",
      keyword: "anyOf",
      params: {},
      message: "must match a schema in anyOf"
    };
    if (vErrors === null) {
      vErrors = [err4];
    } else {
      vErrors.push(err4);
    }
    errors++;
    validate79.errors = vErrors;
    return false;
  } else {
    errors = _errs0;
    if (vErrors !== null) {
      if (_errs0) {
        vErrors.length = _errs0;
      } else {
        vErrors = null;
      }
    }
  }
  validate79.errors = vErrors;
  return errors === 0;
}
const VideoListModuleBase = validate81;
const schema96 = {
  "$id": "VideoListModuleBase",
  "$schema": "http://json-schema.org/draft-07/schema#",
  "type": "object",
  "properties": {
    "moduleType": {
      "type": "string"
    },
    "heading": {
      "type": "string"
    },
    "subHeading": {
      "type": "string"
    },
    "layoutType": {
      "type": "string",
      "enum": ["CAROUSEL", "GRID"]
    },
    "density": {
      "type": "string",
      "enum": ["NORMAL", "DENSE", "DENSEST"]
    },
    "preferedGridSize": {
      "type": "object",
      "properties": {
        "columns": {
          "type": "number"
        },
        "rows": {
          "type": "number"
        }
      },
      "required": ["columns", "rows"]
    },
    "sort": {
      "type": "string",
      "enum": ["DATE", "DATE_TRIMMED"]
    },
    "order": {
      "type": "string",
      "enum": ["ASC", "DESC"]
    },
    "size": {
      "type": "number"
    },
    "dateRange": {
      "type": "array",
      "items": {
        "anyOf": [{
          "type": "string",
          "const": "NOW"
        }, {
          "type": "object",
          "format": "date-time"
        }, {
          "type": "null"
        }]
      },
      "minItems": 2,
      "maxItems": 2
    }
  },
  "required": ["density", "layoutType", "moduleType", "size"]
};
function validate81(data, {
  instancePath = "",
  parentData,
  parentDataProperty,
  rootData = data
} = {}) {
  let vErrors = null;
  let errors = 0;
  if (errors === 0) {
    if (data && typeof data == "object" && !Array.isArray(data)) {
      let missing0;
      if (data.density === void 0 && (missing0 = "density") || data.layoutType === void 0 && (missing0 = "layoutType") || data.moduleType === void 0 && (missing0 = "moduleType") || data.size === void 0 && (missing0 = "size")) {
        validate81.errors = [{
          instancePath,
          schemaPath: "#/required",
          keyword: "required",
          params: {
            missingProperty: missing0
          },
          message: "must have required property '" + missing0 + "'"
        }];
        return false;
      } else {
        if (data.moduleType !== void 0) {
          const _errs1 = errors;
          if (typeof data.moduleType !== "string") {
            validate81.errors = [{
              instancePath: instancePath + "/moduleType",
              schemaPath: "#/properties/moduleType/type",
              keyword: "type",
              params: {
                type: "string"
              },
              message: "must be string"
            }];
            return false;
          }
          var valid0 = _errs1 === errors;
        } else {
          var valid0 = true;
        }
        if (valid0) {
          if (data.heading !== void 0) {
            const _errs3 = errors;
            if (typeof data.heading !== "string") {
              validate81.errors = [{
                instancePath: instancePath + "/heading",
                schemaPath: "#/properties/heading/type",
                keyword: "type",
                params: {
                  type: "string"
                },
                message: "must be string"
              }];
              return false;
            }
            var valid0 = _errs3 === errors;
          } else {
            var valid0 = true;
          }
          if (valid0) {
            if (data.subHeading !== void 0) {
              const _errs5 = errors;
              if (typeof data.subHeading !== "string") {
                validate81.errors = [{
                  instancePath: instancePath + "/subHeading",
                  schemaPath: "#/properties/subHeading/type",
                  keyword: "type",
                  params: {
                    type: "string"
                  },
                  message: "must be string"
                }];
                return false;
              }
              var valid0 = _errs5 === errors;
            } else {
              var valid0 = true;
            }
            if (valid0) {
              if (data.layoutType !== void 0) {
                let data3 = data.layoutType;
                const _errs7 = errors;
                if (typeof data3 !== "string") {
                  validate81.errors = [{
                    instancePath: instancePath + "/layoutType",
                    schemaPath: "#/properties/layoutType/type",
                    keyword: "type",
                    params: {
                      type: "string"
                    },
                    message: "must be string"
                  }];
                  return false;
                }
                if (!(data3 === "CAROUSEL" || data3 === "GRID")) {
                  validate81.errors = [{
                    instancePath: instancePath + "/layoutType",
                    schemaPath: "#/properties/layoutType/enum",
                    keyword: "enum",
                    params: {
                      allowedValues: schema96.properties.layoutType.enum
                    },
                    message: "must be equal to one of the allowed values"
                  }];
                  return false;
                }
                var valid0 = _errs7 === errors;
              } else {
                var valid0 = true;
              }
              if (valid0) {
                if (data.density !== void 0) {
                  let data4 = data.density;
                  const _errs9 = errors;
                  if (typeof data4 !== "string") {
                    validate81.errors = [{
                      instancePath: instancePath + "/density",
                      schemaPath: "#/properties/density/type",
                      keyword: "type",
                      params: {
                        type: "string"
                      },
                      message: "must be string"
                    }];
                    return false;
                  }
                  if (!(data4 === "NORMAL" || data4 === "DENSE" || data4 === "DENSEST")) {
                    validate81.errors = [{
                      instancePath: instancePath + "/density",
                      schemaPath: "#/properties/density/enum",
                      keyword: "enum",
                      params: {
                        allowedValues: schema96.properties.density.enum
                      },
                      message: "must be equal to one of the allowed values"
                    }];
                    return false;
                  }
                  var valid0 = _errs9 === errors;
                } else {
                  var valid0 = true;
                }
                if (valid0) {
                  if (data.preferedGridSize !== void 0) {
                    let data5 = data.preferedGridSize;
                    const _errs11 = errors;
                    if (errors === _errs11) {
                      if (data5 && typeof data5 == "object" && !Array.isArray(data5)) {
                        let missing1;
                        if (data5.columns === void 0 && (missing1 = "columns") || data5.rows === void 0 && (missing1 = "rows")) {
                          validate81.errors = [{
                            instancePath: instancePath + "/preferedGridSize",
                            schemaPath: "#/properties/preferedGridSize/required",
                            keyword: "required",
                            params: {
                              missingProperty: missing1
                            },
                            message: "must have required property '" + missing1 + "'"
                          }];
                          return false;
                        } else {
                          if (data5.columns !== void 0) {
                            let data6 = data5.columns;
                            const _errs13 = errors;
                            if (!(typeof data6 == "number" && isFinite(data6))) {
                              validate81.errors = [{
                                instancePath: instancePath + "/preferedGridSize/columns",
                                schemaPath: "#/properties/preferedGridSize/properties/columns/type",
                                keyword: "type",
                                params: {
                                  type: "number"
                                },
                                message: "must be number"
                              }];
                              return false;
                            }
                            var valid1 = _errs13 === errors;
                          } else {
                            var valid1 = true;
                          }
                          if (valid1) {
                            if (data5.rows !== void 0) {
                              let data7 = data5.rows;
                              const _errs15 = errors;
                              if (!(typeof data7 == "number" && isFinite(data7))) {
                                validate81.errors = [{
                                  instancePath: instancePath + "/preferedGridSize/rows",
                                  schemaPath: "#/properties/preferedGridSize/properties/rows/type",
                                  keyword: "type",
                                  params: {
                                    type: "number"
                                  },
                                  message: "must be number"
                                }];
                                return false;
                              }
                              var valid1 = _errs15 === errors;
                            } else {
                              var valid1 = true;
                            }
                          }
                        }
                      } else {
                        validate81.errors = [{
                          instancePath: instancePath + "/preferedGridSize",
                          schemaPath: "#/properties/preferedGridSize/type",
                          keyword: "type",
                          params: {
                            type: "object"
                          },
                          message: "must be object"
                        }];
                        return false;
                      }
                    }
                    var valid0 = _errs11 === errors;
                  } else {
                    var valid0 = true;
                  }
                  if (valid0) {
                    if (data.sort !== void 0) {
                      let data8 = data.sort;
                      const _errs17 = errors;
                      if (typeof data8 !== "string") {
                        validate81.errors = [{
                          instancePath: instancePath + "/sort",
                          schemaPath: "#/properties/sort/type",
                          keyword: "type",
                          params: {
                            type: "string"
                          },
                          message: "must be string"
                        }];
                        return false;
                      }
                      if (!(data8 === "DATE" || data8 === "DATE_TRIMMED")) {
                        validate81.errors = [{
                          instancePath: instancePath + "/sort",
                          schemaPath: "#/properties/sort/enum",
                          keyword: "enum",
                          params: {
                            allowedValues: schema96.properties.sort.enum
                          },
                          message: "must be equal to one of the allowed values"
                        }];
                        return false;
                      }
                      var valid0 = _errs17 === errors;
                    } else {
                      var valid0 = true;
                    }
                    if (valid0) {
                      if (data.order !== void 0) {
                        let data9 = data.order;
                        const _errs19 = errors;
                        if (typeof data9 !== "string") {
                          validate81.errors = [{
                            instancePath: instancePath + "/order",
                            schemaPath: "#/properties/order/type",
                            keyword: "type",
                            params: {
                              type: "string"
                            },
                            message: "must be string"
                          }];
                          return false;
                        }
                        if (!(data9 === "ASC" || data9 === "DESC")) {
                          validate81.errors = [{
                            instancePath: instancePath + "/order",
                            schemaPath: "#/properties/order/enum",
                            keyword: "enum",
                            params: {
                              allowedValues: schema96.properties.order.enum
                            },
                            message: "must be equal to one of the allowed values"
                          }];
                          return false;
                        }
                        var valid0 = _errs19 === errors;
                      } else {
                        var valid0 = true;
                      }
                      if (valid0) {
                        if (data.size !== void 0) {
                          let data10 = data.size;
                          const _errs21 = errors;
                          if (!(typeof data10 == "number" && isFinite(data10))) {
                            validate81.errors = [{
                              instancePath: instancePath + "/size",
                              schemaPath: "#/properties/size/type",
                              keyword: "type",
                              params: {
                                type: "number"
                              },
                              message: "must be number"
                            }];
                            return false;
                          }
                          var valid0 = _errs21 === errors;
                        } else {
                          var valid0 = true;
                        }
                        if (valid0) {
                          if (data.dateRange !== void 0) {
                            let data11 = data.dateRange;
                            const _errs23 = errors;
                            if (errors === _errs23) {
                              if (Array.isArray(data11)) {
                                if (data11.length > 2) {
                                  validate81.errors = [{
                                    instancePath: instancePath + "/dateRange",
                                    schemaPath: "#/properties/dateRange/maxItems",
                                    keyword: "maxItems",
                                    params: {
                                      limit: 2
                                    },
                                    message: "must NOT have more than 2 items"
                                  }];
                                  return false;
                                } else {
                                  if (data11.length < 2) {
                                    validate81.errors = [{
                                      instancePath: instancePath + "/dateRange",
                                      schemaPath: "#/properties/dateRange/minItems",
                                      keyword: "minItems",
                                      params: {
                                        limit: 2
                                      },
                                      message: "must NOT have fewer than 2 items"
                                    }];
                                    return false;
                                  } else {
                                    var valid2 = true;
                                    const len0 = data11.length;
                                    for (let i0 = 0; i0 < len0; i0++) {
                                      let data12 = data11[i0];
                                      const _errs25 = errors;
                                      const _errs26 = errors;
                                      let valid3 = false;
                                      const _errs27 = errors;
                                      if (typeof data12 !== "string") {
                                        const err0 = {
                                          instancePath: instancePath + "/dateRange/" + i0,
                                          schemaPath: "#/properties/dateRange/items/anyOf/0/type",
                                          keyword: "type",
                                          params: {
                                            type: "string"
                                          },
                                          message: "must be string"
                                        };
                                        if (vErrors === null) {
                                          vErrors = [err0];
                                        } else {
                                          vErrors.push(err0);
                                        }
                                        errors++;
                                      }
                                      if ("NOW" !== data12) {
                                        const err1 = {
                                          instancePath: instancePath + "/dateRange/" + i0,
                                          schemaPath: "#/properties/dateRange/items/anyOf/0/const",
                                          keyword: "const",
                                          params: {
                                            allowedValue: "NOW"
                                          },
                                          message: "must be equal to constant"
                                        };
                                        if (vErrors === null) {
                                          vErrors = [err1];
                                        } else {
                                          vErrors.push(err1);
                                        }
                                        errors++;
                                      }
                                      var _valid0 = _errs27 === errors;
                                      valid3 = valid3 || _valid0;
                                      if (!valid3) {
                                        const _errs29 = errors;
                                        if (!(data12 && typeof data12 == "object" && !Array.isArray(data12))) {
                                          const err2 = {
                                            instancePath: instancePath + "/dateRange/" + i0,
                                            schemaPath: "#/properties/dateRange/items/anyOf/1/type",
                                            keyword: "type",
                                            params: {
                                              type: "object"
                                            },
                                            message: "must be object"
                                          };
                                          if (vErrors === null) {
                                            vErrors = [err2];
                                          } else {
                                            vErrors.push(err2);
                                          }
                                          errors++;
                                        }
                                        if (errors === _errs29) {
                                          if (errors === _errs29) {
                                            if (typeof data12 === "string") {
                                              if (!formats0(data12)) {
                                                const err3 = {
                                                  instancePath: instancePath + "/dateRange/" + i0,
                                                  schemaPath: "#/properties/dateRange/items/anyOf/1/format",
                                                  keyword: "format",
                                                  params: {
                                                    format: "date-time"
                                                  },
                                                  message: 'must match format "date-time"'
                                                };
                                                if (vErrors === null) {
                                                  vErrors = [err3];
                                                } else {
                                                  vErrors.push(err3);
                                                }
                                                errors++;
                                              }
                                            }
                                          }
                                        }
                                        var _valid0 = _errs29 === errors;
                                        valid3 = valid3 || _valid0;
                                        if (!valid3) {
                                          const _errs31 = errors;
                                          if (data12 !== null) {
                                            const err4 = {
                                              instancePath: instancePath + "/dateRange/" + i0,
                                              schemaPath: "#/properties/dateRange/items/anyOf/2/type",
                                              keyword: "type",
                                              params: {
                                                type: "null"
                                              },
                                              message: "must be null"
                                            };
                                            if (vErrors === null) {
                                              vErrors = [err4];
                                            } else {
                                              vErrors.push(err4);
                                            }
                                            errors++;
                                          }
                                          var _valid0 = _errs31 === errors;
                                          valid3 = valid3 || _valid0;
                                        }
                                      }
                                      if (!valid3) {
                                        const err5 = {
                                          instancePath: instancePath + "/dateRange/" + i0,
                                          schemaPath: "#/properties/dateRange/items/anyOf",
                                          keyword: "anyOf",
                                          params: {},
                                          message: "must match a schema in anyOf"
                                        };
                                        if (vErrors === null) {
                                          vErrors = [err5];
                                        } else {
                                          vErrors.push(err5);
                                        }
                                        errors++;
                                        validate81.errors = vErrors;
                                        return false;
                                      } else {
                                        errors = _errs26;
                                        if (vErrors !== null) {
                                          if (_errs26) {
                                            vErrors.length = _errs26;
                                          } else {
                                            vErrors = null;
                                          }
                                        }
                                      }
                                      var valid2 = _errs25 === errors;
                                      if (!valid2) {
                                        break;
                                      }
                                    }
                                  }
                                }
                              } else {
                                validate81.errors = [{
                                  instancePath: instancePath + "/dateRange",
                                  schemaPath: "#/properties/dateRange/type",
                                  keyword: "type",
                                  params: {
                                    type: "array"
                                  },
                                  message: "must be array"
                                }];
                                return false;
                              }
                            }
                            var valid0 = _errs23 === errors;
                          } else {
                            var valid0 = true;
                          }
                        }
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
    } else {
      validate81.errors = [{
        instancePath,
        schemaPath: "#/type",
        keyword: "type",
        params: {
          type: "object"
        },
        message: "must be object"
      }];
      return false;
    }
  }
  validate81.errors = vErrors;
  return errors === 0;
}
const VideoListModule = validate82;
const schema97 = {
  "$id": "VideoListModule",
  "$schema": "http://json-schema.org/draft-07/schema#",
  "type": "object",
  "properties": {
    "moduleType": {
      "type": "string",
      "const": "VIDEOS_LIST"
    },
    "heading": {
      "type": "string"
    },
    "subHeading": {
      "type": "string"
    },
    "layoutType": {
      "type": "string",
      "enum": ["CAROUSEL", "GRID"]
    },
    "density": {
      "type": "string",
      "enum": ["NORMAL", "DENSE", "DENSEST"]
    },
    "preferedGridSize": {
      "type": "object",
      "properties": {
        "columns": {
          "type": "number"
        },
        "rows": {
          "type": "number"
        }
      },
      "required": ["columns", "rows"]
    },
    "sort": {
      "type": "string",
      "enum": ["DATE", "DATE_TRIMMED"]
    },
    "order": {
      "type": "string",
      "enum": ["ASC", "DESC"]
    },
    "size": {
      "type": "number"
    },
    "dateRange": {
      "type": "array",
      "items": {
        "anyOf": [{
          "type": "string",
          "const": "NOW"
        }, {
          "type": "object",
          "format": "date-time"
        }, {
          "type": "null"
        }]
      },
      "minItems": 2,
      "maxItems": 2
    },
    "listSource": {
      "$ref": "VideoListSource"
    }
  },
  "required": ["density", "layoutType", "listSource", "moduleType", "size"],
  "description": "Specifies a list of videos that satisfies certain criteria using listSource and also defines the way the data should be sorted and presented."
};
function validate82(data, {
  instancePath = "",
  parentData,
  parentDataProperty,
  rootData = data
} = {}) {
  let vErrors = null;
  let errors = 0;
  if (errors === 0) {
    if (data && typeof data == "object" && !Array.isArray(data)) {
      let missing0;
      if (data.density === void 0 && (missing0 = "density") || data.layoutType === void 0 && (missing0 = "layoutType") || data.listSource === void 0 && (missing0 = "listSource") || data.moduleType === void 0 && (missing0 = "moduleType") || data.size === void 0 && (missing0 = "size")) {
        validate82.errors = [{
          instancePath,
          schemaPath: "#/required",
          keyword: "required",
          params: {
            missingProperty: missing0
          },
          message: "must have required property '" + missing0 + "'"
        }];
        return false;
      } else {
        if (data.moduleType !== void 0) {
          let data0 = data.moduleType;
          const _errs1 = errors;
          if (typeof data0 !== "string") {
            validate82.errors = [{
              instancePath: instancePath + "/moduleType",
              schemaPath: "#/properties/moduleType/type",
              keyword: "type",
              params: {
                type: "string"
              },
              message: "must be string"
            }];
            return false;
          }
          if ("VIDEOS_LIST" !== data0) {
            validate82.errors = [{
              instancePath: instancePath + "/moduleType",
              schemaPath: "#/properties/moduleType/const",
              keyword: "const",
              params: {
                allowedValue: "VIDEOS_LIST"
              },
              message: "must be equal to constant"
            }];
            return false;
          }
          var valid0 = _errs1 === errors;
        } else {
          var valid0 = true;
        }
        if (valid0) {
          if (data.heading !== void 0) {
            const _errs3 = errors;
            if (typeof data.heading !== "string") {
              validate82.errors = [{
                instancePath: instancePath + "/heading",
                schemaPath: "#/properties/heading/type",
                keyword: "type",
                params: {
                  type: "string"
                },
                message: "must be string"
              }];
              return false;
            }
            var valid0 = _errs3 === errors;
          } else {
            var valid0 = true;
          }
          if (valid0) {
            if (data.subHeading !== void 0) {
              const _errs5 = errors;
              if (typeof data.subHeading !== "string") {
                validate82.errors = [{
                  instancePath: instancePath + "/subHeading",
                  schemaPath: "#/properties/subHeading/type",
                  keyword: "type",
                  params: {
                    type: "string"
                  },
                  message: "must be string"
                }];
                return false;
              }
              var valid0 = _errs5 === errors;
            } else {
              var valid0 = true;
            }
            if (valid0) {
              if (data.layoutType !== void 0) {
                let data3 = data.layoutType;
                const _errs7 = errors;
                if (typeof data3 !== "string") {
                  validate82.errors = [{
                    instancePath: instancePath + "/layoutType",
                    schemaPath: "#/properties/layoutType/type",
                    keyword: "type",
                    params: {
                      type: "string"
                    },
                    message: "must be string"
                  }];
                  return false;
                }
                if (!(data3 === "CAROUSEL" || data3 === "GRID")) {
                  validate82.errors = [{
                    instancePath: instancePath + "/layoutType",
                    schemaPath: "#/properties/layoutType/enum",
                    keyword: "enum",
                    params: {
                      allowedValues: schema97.properties.layoutType.enum
                    },
                    message: "must be equal to one of the allowed values"
                  }];
                  return false;
                }
                var valid0 = _errs7 === errors;
              } else {
                var valid0 = true;
              }
              if (valid0) {
                if (data.density !== void 0) {
                  let data4 = data.density;
                  const _errs9 = errors;
                  if (typeof data4 !== "string") {
                    validate82.errors = [{
                      instancePath: instancePath + "/density",
                      schemaPath: "#/properties/density/type",
                      keyword: "type",
                      params: {
                        type: "string"
                      },
                      message: "must be string"
                    }];
                    return false;
                  }
                  if (!(data4 === "NORMAL" || data4 === "DENSE" || data4 === "DENSEST")) {
                    validate82.errors = [{
                      instancePath: instancePath + "/density",
                      schemaPath: "#/properties/density/enum",
                      keyword: "enum",
                      params: {
                        allowedValues: schema97.properties.density.enum
                      },
                      message: "must be equal to one of the allowed values"
                    }];
                    return false;
                  }
                  var valid0 = _errs9 === errors;
                } else {
                  var valid0 = true;
                }
                if (valid0) {
                  if (data.preferedGridSize !== void 0) {
                    let data5 = data.preferedGridSize;
                    const _errs11 = errors;
                    if (errors === _errs11) {
                      if (data5 && typeof data5 == "object" && !Array.isArray(data5)) {
                        let missing1;
                        if (data5.columns === void 0 && (missing1 = "columns") || data5.rows === void 0 && (missing1 = "rows")) {
                          validate82.errors = [{
                            instancePath: instancePath + "/preferedGridSize",
                            schemaPath: "#/properties/preferedGridSize/required",
                            keyword: "required",
                            params: {
                              missingProperty: missing1
                            },
                            message: "must have required property '" + missing1 + "'"
                          }];
                          return false;
                        } else {
                          if (data5.columns !== void 0) {
                            let data6 = data5.columns;
                            const _errs13 = errors;
                            if (!(typeof data6 == "number" && isFinite(data6))) {
                              validate82.errors = [{
                                instancePath: instancePath + "/preferedGridSize/columns",
                                schemaPath: "#/properties/preferedGridSize/properties/columns/type",
                                keyword: "type",
                                params: {
                                  type: "number"
                                },
                                message: "must be number"
                              }];
                              return false;
                            }
                            var valid1 = _errs13 === errors;
                          } else {
                            var valid1 = true;
                          }
                          if (valid1) {
                            if (data5.rows !== void 0) {
                              let data7 = data5.rows;
                              const _errs15 = errors;
                              if (!(typeof data7 == "number" && isFinite(data7))) {
                                validate82.errors = [{
                                  instancePath: instancePath + "/preferedGridSize/rows",
                                  schemaPath: "#/properties/preferedGridSize/properties/rows/type",
                                  keyword: "type",
                                  params: {
                                    type: "number"
                                  },
                                  message: "must be number"
                                }];
                                return false;
                              }
                              var valid1 = _errs15 === errors;
                            } else {
                              var valid1 = true;
                            }
                          }
                        }
                      } else {
                        validate82.errors = [{
                          instancePath: instancePath + "/preferedGridSize",
                          schemaPath: "#/properties/preferedGridSize/type",
                          keyword: "type",
                          params: {
                            type: "object"
                          },
                          message: "must be object"
                        }];
                        return false;
                      }
                    }
                    var valid0 = _errs11 === errors;
                  } else {
                    var valid0 = true;
                  }
                  if (valid0) {
                    if (data.sort !== void 0) {
                      let data8 = data.sort;
                      const _errs17 = errors;
                      if (typeof data8 !== "string") {
                        validate82.errors = [{
                          instancePath: instancePath + "/sort",
                          schemaPath: "#/properties/sort/type",
                          keyword: "type",
                          params: {
                            type: "string"
                          },
                          message: "must be string"
                        }];
                        return false;
                      }
                      if (!(data8 === "DATE" || data8 === "DATE_TRIMMED")) {
                        validate82.errors = [{
                          instancePath: instancePath + "/sort",
                          schemaPath: "#/properties/sort/enum",
                          keyword: "enum",
                          params: {
                            allowedValues: schema97.properties.sort.enum
                          },
                          message: "must be equal to one of the allowed values"
                        }];
                        return false;
                      }
                      var valid0 = _errs17 === errors;
                    } else {
                      var valid0 = true;
                    }
                    if (valid0) {
                      if (data.order !== void 0) {
                        let data9 = data.order;
                        const _errs19 = errors;
                        if (typeof data9 !== "string") {
                          validate82.errors = [{
                            instancePath: instancePath + "/order",
                            schemaPath: "#/properties/order/type",
                            keyword: "type",
                            params: {
                              type: "string"
                            },
                            message: "must be string"
                          }];
                          return false;
                        }
                        if (!(data9 === "ASC" || data9 === "DESC")) {
                          validate82.errors = [{
                            instancePath: instancePath + "/order",
                            schemaPath: "#/properties/order/enum",
                            keyword: "enum",
                            params: {
                              allowedValues: schema97.properties.order.enum
                            },
                            message: "must be equal to one of the allowed values"
                          }];
                          return false;
                        }
                        var valid0 = _errs19 === errors;
                      } else {
                        var valid0 = true;
                      }
                      if (valid0) {
                        if (data.size !== void 0) {
                          let data10 = data.size;
                          const _errs21 = errors;
                          if (!(typeof data10 == "number" && isFinite(data10))) {
                            validate82.errors = [{
                              instancePath: instancePath + "/size",
                              schemaPath: "#/properties/size/type",
                              keyword: "type",
                              params: {
                                type: "number"
                              },
                              message: "must be number"
                            }];
                            return false;
                          }
                          var valid0 = _errs21 === errors;
                        } else {
                          var valid0 = true;
                        }
                        if (valid0) {
                          if (data.dateRange !== void 0) {
                            let data11 = data.dateRange;
                            const _errs23 = errors;
                            if (errors === _errs23) {
                              if (Array.isArray(data11)) {
                                if (data11.length > 2) {
                                  validate82.errors = [{
                                    instancePath: instancePath + "/dateRange",
                                    schemaPath: "#/properties/dateRange/maxItems",
                                    keyword: "maxItems",
                                    params: {
                                      limit: 2
                                    },
                                    message: "must NOT have more than 2 items"
                                  }];
                                  return false;
                                } else {
                                  if (data11.length < 2) {
                                    validate82.errors = [{
                                      instancePath: instancePath + "/dateRange",
                                      schemaPath: "#/properties/dateRange/minItems",
                                      keyword: "minItems",
                                      params: {
                                        limit: 2
                                      },
                                      message: "must NOT have fewer than 2 items"
                                    }];
                                    return false;
                                  } else {
                                    var valid2 = true;
                                    const len0 = data11.length;
                                    for (let i0 = 0; i0 < len0; i0++) {
                                      let data12 = data11[i0];
                                      const _errs25 = errors;
                                      const _errs26 = errors;
                                      let valid3 = false;
                                      const _errs27 = errors;
                                      if (typeof data12 !== "string") {
                                        const err0 = {
                                          instancePath: instancePath + "/dateRange/" + i0,
                                          schemaPath: "#/properties/dateRange/items/anyOf/0/type",
                                          keyword: "type",
                                          params: {
                                            type: "string"
                                          },
                                          message: "must be string"
                                        };
                                        if (vErrors === null) {
                                          vErrors = [err0];
                                        } else {
                                          vErrors.push(err0);
                                        }
                                        errors++;
                                      }
                                      if ("NOW" !== data12) {
                                        const err1 = {
                                          instancePath: instancePath + "/dateRange/" + i0,
                                          schemaPath: "#/properties/dateRange/items/anyOf/0/const",
                                          keyword: "const",
                                          params: {
                                            allowedValue: "NOW"
                                          },
                                          message: "must be equal to constant"
                                        };
                                        if (vErrors === null) {
                                          vErrors = [err1];
                                        } else {
                                          vErrors.push(err1);
                                        }
                                        errors++;
                                      }
                                      var _valid0 = _errs27 === errors;
                                      valid3 = valid3 || _valid0;
                                      if (!valid3) {
                                        const _errs29 = errors;
                                        if (!(data12 && typeof data12 == "object" && !Array.isArray(data12))) {
                                          const err2 = {
                                            instancePath: instancePath + "/dateRange/" + i0,
                                            schemaPath: "#/properties/dateRange/items/anyOf/1/type",
                                            keyword: "type",
                                            params: {
                                              type: "object"
                                            },
                                            message: "must be object"
                                          };
                                          if (vErrors === null) {
                                            vErrors = [err2];
                                          } else {
                                            vErrors.push(err2);
                                          }
                                          errors++;
                                        }
                                        if (errors === _errs29) {
                                          if (errors === _errs29) {
                                            if (typeof data12 === "string") {
                                              if (!formats0(data12)) {
                                                const err3 = {
                                                  instancePath: instancePath + "/dateRange/" + i0,
                                                  schemaPath: "#/properties/dateRange/items/anyOf/1/format",
                                                  keyword: "format",
                                                  params: {
                                                    format: "date-time"
                                                  },
                                                  message: 'must match format "date-time"'
                                                };
                                                if (vErrors === null) {
                                                  vErrors = [err3];
                                                } else {
                                                  vErrors.push(err3);
                                                }
                                                errors++;
                                              }
                                            }
                                          }
                                        }
                                        var _valid0 = _errs29 === errors;
                                        valid3 = valid3 || _valid0;
                                        if (!valid3) {
                                          const _errs31 = errors;
                                          if (data12 !== null) {
                                            const err4 = {
                                              instancePath: instancePath + "/dateRange/" + i0,
                                              schemaPath: "#/properties/dateRange/items/anyOf/2/type",
                                              keyword: "type",
                                              params: {
                                                type: "null"
                                              },
                                              message: "must be null"
                                            };
                                            if (vErrors === null) {
                                              vErrors = [err4];
                                            } else {
                                              vErrors.push(err4);
                                            }
                                            errors++;
                                          }
                                          var _valid0 = _errs31 === errors;
                                          valid3 = valid3 || _valid0;
                                        }
                                      }
                                      if (!valid3) {
                                        const err5 = {
                                          instancePath: instancePath + "/dateRange/" + i0,
                                          schemaPath: "#/properties/dateRange/items/anyOf",
                                          keyword: "anyOf",
                                          params: {},
                                          message: "must match a schema in anyOf"
                                        };
                                        if (vErrors === null) {
                                          vErrors = [err5];
                                        } else {
                                          vErrors.push(err5);
                                        }
                                        errors++;
                                        validate82.errors = vErrors;
                                        return false;
                                      } else {
                                        errors = _errs26;
                                        if (vErrors !== null) {
                                          if (_errs26) {
                                            vErrors.length = _errs26;
                                          } else {
                                            vErrors = null;
                                          }
                                        }
                                      }
                                      var valid2 = _errs25 === errors;
                                      if (!valid2) {
                                        break;
                                      }
                                    }
                                  }
                                }
                              } else {
                                validate82.errors = [{
                                  instancePath: instancePath + "/dateRange",
                                  schemaPath: "#/properties/dateRange/type",
                                  keyword: "type",
                                  params: {
                                    type: "array"
                                  },
                                  message: "must be array"
                                }];
                                return false;
                              }
                            }
                            var valid0 = _errs23 === errors;
                          } else {
                            var valid0 = true;
                          }
                          if (valid0) {
                            if (data.listSource !== void 0) {
                              const _errs33 = errors;
                              if (!validate79(data.listSource, {
                                instancePath: instancePath + "/listSource",
                                parentData: data,
                                parentDataProperty: "listSource",
                                rootData
                              })) {
                                vErrors = vErrors === null ? validate79.errors : vErrors.concat(validate79.errors);
                                errors = vErrors.length;
                              }
                              var valid0 = _errs33 === errors;
                            } else {
                              var valid0 = true;
                            }
                          }
                        }
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
    } else {
      validate82.errors = [{
        instancePath,
        schemaPath: "#/type",
        keyword: "type",
        params: {
          type: "object"
        },
        message: "must be object"
      }];
      return false;
    }
  }
  validate82.errors = vErrors;
  return errors === 0;
}
const FilteredVideoListModule = validate84;
const schema98 = {
  "$id": "FilteredVideoListModule",
  "$schema": "http://json-schema.org/draft-07/schema#",
  "type": "object",
  "properties": {
    "moduleType": {
      "type": "string",
      "const": "FILTERED_VIDEOS_LIST"
    },
    "heading": {
      "type": "string"
    },
    "subHeading": {
      "type": "string"
    },
    "layoutType": {
      "type": "string",
      "enum": ["CAROUSEL", "GRID"]
    },
    "density": {
      "type": "string",
      "enum": ["NORMAL", "DENSE", "DENSEST"]
    },
    "preferedGridSize": {
      "type": "object",
      "properties": {
        "columns": {
          "type": "number"
        },
        "rows": {
          "type": "number"
        }
      },
      "required": ["columns", "rows"]
    },
    "sort": {
      "type": "string",
      "enum": ["DATE", "DATE_TRIMMED"]
    },
    "order": {
      "type": "string",
      "enum": ["ASC", "DESC"]
    },
    "size": {
      "type": "number"
    },
    "dateRange": {
      "type": "array",
      "items": {
        "anyOf": [{
          "type": "string",
          "const": "NOW"
        }, {
          "type": "object",
          "format": "date-time"
        }, {
          "type": "null"
        }]
      },
      "minItems": 2,
      "maxItems": 2
    },
    "listSource": {
      "$ref": "DynamicVideoListSource"
    },
    "filters": {
      "anyOf": [{
        "type": "string",
        "const": "DEFAULT"
      }, {
        "type": "array",
        "items": {
          "$ref": "FiltersAttributeDefinition"
        }
      }]
    }
  },
  "required": ["density", "filters", "layoutType", "listSource", "moduleType", "size"],
  "description": "A variation of the VideoListModule that show filtering options to the user. The attributes selected by the user will override any attributes specified in the listSource."
};
function validate84(data, {
  instancePath = "",
  parentData,
  parentDataProperty,
  rootData = data
} = {}) {
  let vErrors = null;
  let errors = 0;
  if (errors === 0) {
    if (data && typeof data == "object" && !Array.isArray(data)) {
      let missing0;
      if (data.density === void 0 && (missing0 = "density") || data.filters === void 0 && (missing0 = "filters") || data.layoutType === void 0 && (missing0 = "layoutType") || data.listSource === void 0 && (missing0 = "listSource") || data.moduleType === void 0 && (missing0 = "moduleType") || data.size === void 0 && (missing0 = "size")) {
        validate84.errors = [{
          instancePath,
          schemaPath: "#/required",
          keyword: "required",
          params: {
            missingProperty: missing0
          },
          message: "must have required property '" + missing0 + "'"
        }];
        return false;
      } else {
        if (data.moduleType !== void 0) {
          let data0 = data.moduleType;
          const _errs1 = errors;
          if (typeof data0 !== "string") {
            validate84.errors = [{
              instancePath: instancePath + "/moduleType",
              schemaPath: "#/properties/moduleType/type",
              keyword: "type",
              params: {
                type: "string"
              },
              message: "must be string"
            }];
            return false;
          }
          if ("FILTERED_VIDEOS_LIST" !== data0) {
            validate84.errors = [{
              instancePath: instancePath + "/moduleType",
              schemaPath: "#/properties/moduleType/const",
              keyword: "const",
              params: {
                allowedValue: "FILTERED_VIDEOS_LIST"
              },
              message: "must be equal to constant"
            }];
            return false;
          }
          var valid0 = _errs1 === errors;
        } else {
          var valid0 = true;
        }
        if (valid0) {
          if (data.heading !== void 0) {
            const _errs3 = errors;
            if (typeof data.heading !== "string") {
              validate84.errors = [{
                instancePath: instancePath + "/heading",
                schemaPath: "#/properties/heading/type",
                keyword: "type",
                params: {
                  type: "string"
                },
                message: "must be string"
              }];
              return false;
            }
            var valid0 = _errs3 === errors;
          } else {
            var valid0 = true;
          }
          if (valid0) {
            if (data.subHeading !== void 0) {
              const _errs5 = errors;
              if (typeof data.subHeading !== "string") {
                validate84.errors = [{
                  instancePath: instancePath + "/subHeading",
                  schemaPath: "#/properties/subHeading/type",
                  keyword: "type",
                  params: {
                    type: "string"
                  },
                  message: "must be string"
                }];
                return false;
              }
              var valid0 = _errs5 === errors;
            } else {
              var valid0 = true;
            }
            if (valid0) {
              if (data.layoutType !== void 0) {
                let data3 = data.layoutType;
                const _errs7 = errors;
                if (typeof data3 !== "string") {
                  validate84.errors = [{
                    instancePath: instancePath + "/layoutType",
                    schemaPath: "#/properties/layoutType/type",
                    keyword: "type",
                    params: {
                      type: "string"
                    },
                    message: "must be string"
                  }];
                  return false;
                }
                if (!(data3 === "CAROUSEL" || data3 === "GRID")) {
                  validate84.errors = [{
                    instancePath: instancePath + "/layoutType",
                    schemaPath: "#/properties/layoutType/enum",
                    keyword: "enum",
                    params: {
                      allowedValues: schema98.properties.layoutType.enum
                    },
                    message: "must be equal to one of the allowed values"
                  }];
                  return false;
                }
                var valid0 = _errs7 === errors;
              } else {
                var valid0 = true;
              }
              if (valid0) {
                if (data.density !== void 0) {
                  let data4 = data.density;
                  const _errs9 = errors;
                  if (typeof data4 !== "string") {
                    validate84.errors = [{
                      instancePath: instancePath + "/density",
                      schemaPath: "#/properties/density/type",
                      keyword: "type",
                      params: {
                        type: "string"
                      },
                      message: "must be string"
                    }];
                    return false;
                  }
                  if (!(data4 === "NORMAL" || data4 === "DENSE" || data4 === "DENSEST")) {
                    validate84.errors = [{
                      instancePath: instancePath + "/density",
                      schemaPath: "#/properties/density/enum",
                      keyword: "enum",
                      params: {
                        allowedValues: schema98.properties.density.enum
                      },
                      message: "must be equal to one of the allowed values"
                    }];
                    return false;
                  }
                  var valid0 = _errs9 === errors;
                } else {
                  var valid0 = true;
                }
                if (valid0) {
                  if (data.preferedGridSize !== void 0) {
                    let data5 = data.preferedGridSize;
                    const _errs11 = errors;
                    if (errors === _errs11) {
                      if (data5 && typeof data5 == "object" && !Array.isArray(data5)) {
                        let missing1;
                        if (data5.columns === void 0 && (missing1 = "columns") || data5.rows === void 0 && (missing1 = "rows")) {
                          validate84.errors = [{
                            instancePath: instancePath + "/preferedGridSize",
                            schemaPath: "#/properties/preferedGridSize/required",
                            keyword: "required",
                            params: {
                              missingProperty: missing1
                            },
                            message: "must have required property '" + missing1 + "'"
                          }];
                          return false;
                        } else {
                          if (data5.columns !== void 0) {
                            let data6 = data5.columns;
                            const _errs13 = errors;
                            if (!(typeof data6 == "number" && isFinite(data6))) {
                              validate84.errors = [{
                                instancePath: instancePath + "/preferedGridSize/columns",
                                schemaPath: "#/properties/preferedGridSize/properties/columns/type",
                                keyword: "type",
                                params: {
                                  type: "number"
                                },
                                message: "must be number"
                              }];
                              return false;
                            }
                            var valid1 = _errs13 === errors;
                          } else {
                            var valid1 = true;
                          }
                          if (valid1) {
                            if (data5.rows !== void 0) {
                              let data7 = data5.rows;
                              const _errs15 = errors;
                              if (!(typeof data7 == "number" && isFinite(data7))) {
                                validate84.errors = [{
                                  instancePath: instancePath + "/preferedGridSize/rows",
                                  schemaPath: "#/properties/preferedGridSize/properties/rows/type",
                                  keyword: "type",
                                  params: {
                                    type: "number"
                                  },
                                  message: "must be number"
                                }];
                                return false;
                              }
                              var valid1 = _errs15 === errors;
                            } else {
                              var valid1 = true;
                            }
                          }
                        }
                      } else {
                        validate84.errors = [{
                          instancePath: instancePath + "/preferedGridSize",
                          schemaPath: "#/properties/preferedGridSize/type",
                          keyword: "type",
                          params: {
                            type: "object"
                          },
                          message: "must be object"
                        }];
                        return false;
                      }
                    }
                    var valid0 = _errs11 === errors;
                  } else {
                    var valid0 = true;
                  }
                  if (valid0) {
                    if (data.sort !== void 0) {
                      let data8 = data.sort;
                      const _errs17 = errors;
                      if (typeof data8 !== "string") {
                        validate84.errors = [{
                          instancePath: instancePath + "/sort",
                          schemaPath: "#/properties/sort/type",
                          keyword: "type",
                          params: {
                            type: "string"
                          },
                          message: "must be string"
                        }];
                        return false;
                      }
                      if (!(data8 === "DATE" || data8 === "DATE_TRIMMED")) {
                        validate84.errors = [{
                          instancePath: instancePath + "/sort",
                          schemaPath: "#/properties/sort/enum",
                          keyword: "enum",
                          params: {
                            allowedValues: schema98.properties.sort.enum
                          },
                          message: "must be equal to one of the allowed values"
                        }];
                        return false;
                      }
                      var valid0 = _errs17 === errors;
                    } else {
                      var valid0 = true;
                    }
                    if (valid0) {
                      if (data.order !== void 0) {
                        let data9 = data.order;
                        const _errs19 = errors;
                        if (typeof data9 !== "string") {
                          validate84.errors = [{
                            instancePath: instancePath + "/order",
                            schemaPath: "#/properties/order/type",
                            keyword: "type",
                            params: {
                              type: "string"
                            },
                            message: "must be string"
                          }];
                          return false;
                        }
                        if (!(data9 === "ASC" || data9 === "DESC")) {
                          validate84.errors = [{
                            instancePath: instancePath + "/order",
                            schemaPath: "#/properties/order/enum",
                            keyword: "enum",
                            params: {
                              allowedValues: schema98.properties.order.enum
                            },
                            message: "must be equal to one of the allowed values"
                          }];
                          return false;
                        }
                        var valid0 = _errs19 === errors;
                      } else {
                        var valid0 = true;
                      }
                      if (valid0) {
                        if (data.size !== void 0) {
                          let data10 = data.size;
                          const _errs21 = errors;
                          if (!(typeof data10 == "number" && isFinite(data10))) {
                            validate84.errors = [{
                              instancePath: instancePath + "/size",
                              schemaPath: "#/properties/size/type",
                              keyword: "type",
                              params: {
                                type: "number"
                              },
                              message: "must be number"
                            }];
                            return false;
                          }
                          var valid0 = _errs21 === errors;
                        } else {
                          var valid0 = true;
                        }
                        if (valid0) {
                          if (data.dateRange !== void 0) {
                            let data11 = data.dateRange;
                            const _errs23 = errors;
                            if (errors === _errs23) {
                              if (Array.isArray(data11)) {
                                if (data11.length > 2) {
                                  validate84.errors = [{
                                    instancePath: instancePath + "/dateRange",
                                    schemaPath: "#/properties/dateRange/maxItems",
                                    keyword: "maxItems",
                                    params: {
                                      limit: 2
                                    },
                                    message: "must NOT have more than 2 items"
                                  }];
                                  return false;
                                } else {
                                  if (data11.length < 2) {
                                    validate84.errors = [{
                                      instancePath: instancePath + "/dateRange",
                                      schemaPath: "#/properties/dateRange/minItems",
                                      keyword: "minItems",
                                      params: {
                                        limit: 2
                                      },
                                      message: "must NOT have fewer than 2 items"
                                    }];
                                    return false;
                                  } else {
                                    var valid2 = true;
                                    const len0 = data11.length;
                                    for (let i0 = 0; i0 < len0; i0++) {
                                      let data12 = data11[i0];
                                      const _errs25 = errors;
                                      const _errs26 = errors;
                                      let valid3 = false;
                                      const _errs27 = errors;
                                      if (typeof data12 !== "string") {
                                        const err0 = {
                                          instancePath: instancePath + "/dateRange/" + i0,
                                          schemaPath: "#/properties/dateRange/items/anyOf/0/type",
                                          keyword: "type",
                                          params: {
                                            type: "string"
                                          },
                                          message: "must be string"
                                        };
                                        if (vErrors === null) {
                                          vErrors = [err0];
                                        } else {
                                          vErrors.push(err0);
                                        }
                                        errors++;
                                      }
                                      if ("NOW" !== data12) {
                                        const err1 = {
                                          instancePath: instancePath + "/dateRange/" + i0,
                                          schemaPath: "#/properties/dateRange/items/anyOf/0/const",
                                          keyword: "const",
                                          params: {
                                            allowedValue: "NOW"
                                          },
                                          message: "must be equal to constant"
                                        };
                                        if (vErrors === null) {
                                          vErrors = [err1];
                                        } else {
                                          vErrors.push(err1);
                                        }
                                        errors++;
                                      }
                                      var _valid0 = _errs27 === errors;
                                      valid3 = valid3 || _valid0;
                                      if (!valid3) {
                                        const _errs29 = errors;
                                        if (!(data12 && typeof data12 == "object" && !Array.isArray(data12))) {
                                          const err2 = {
                                            instancePath: instancePath + "/dateRange/" + i0,
                                            schemaPath: "#/properties/dateRange/items/anyOf/1/type",
                                            keyword: "type",
                                            params: {
                                              type: "object"
                                            },
                                            message: "must be object"
                                          };
                                          if (vErrors === null) {
                                            vErrors = [err2];
                                          } else {
                                            vErrors.push(err2);
                                          }
                                          errors++;
                                        }
                                        if (errors === _errs29) {
                                          if (errors === _errs29) {
                                            if (typeof data12 === "string") {
                                              if (!formats0(data12)) {
                                                const err3 = {
                                                  instancePath: instancePath + "/dateRange/" + i0,
                                                  schemaPath: "#/properties/dateRange/items/anyOf/1/format",
                                                  keyword: "format",
                                                  params: {
                                                    format: "date-time"
                                                  },
                                                  message: 'must match format "date-time"'
                                                };
                                                if (vErrors === null) {
                                                  vErrors = [err3];
                                                } else {
                                                  vErrors.push(err3);
                                                }
                                                errors++;
                                              }
                                            }
                                          }
                                        }
                                        var _valid0 = _errs29 === errors;
                                        valid3 = valid3 || _valid0;
                                        if (!valid3) {
                                          const _errs31 = errors;
                                          if (data12 !== null) {
                                            const err4 = {
                                              instancePath: instancePath + "/dateRange/" + i0,
                                              schemaPath: "#/properties/dateRange/items/anyOf/2/type",
                                              keyword: "type",
                                              params: {
                                                type: "null"
                                              },
                                              message: "must be null"
                                            };
                                            if (vErrors === null) {
                                              vErrors = [err4];
                                            } else {
                                              vErrors.push(err4);
                                            }
                                            errors++;
                                          }
                                          var _valid0 = _errs31 === errors;
                                          valid3 = valid3 || _valid0;
                                        }
                                      }
                                      if (!valid3) {
                                        const err5 = {
                                          instancePath: instancePath + "/dateRange/" + i0,
                                          schemaPath: "#/properties/dateRange/items/anyOf",
                                          keyword: "anyOf",
                                          params: {},
                                          message: "must match a schema in anyOf"
                                        };
                                        if (vErrors === null) {
                                          vErrors = [err5];
                                        } else {
                                          vErrors.push(err5);
                                        }
                                        errors++;
                                        validate84.errors = vErrors;
                                        return false;
                                      } else {
                                        errors = _errs26;
                                        if (vErrors !== null) {
                                          if (_errs26) {
                                            vErrors.length = _errs26;
                                          } else {
                                            vErrors = null;
                                          }
                                        }
                                      }
                                      var valid2 = _errs25 === errors;
                                      if (!valid2) {
                                        break;
                                      }
                                    }
                                  }
                                }
                              } else {
                                validate84.errors = [{
                                  instancePath: instancePath + "/dateRange",
                                  schemaPath: "#/properties/dateRange/type",
                                  keyword: "type",
                                  params: {
                                    type: "array"
                                  },
                                  message: "must be array"
                                }];
                                return false;
                              }
                            }
                            var valid0 = _errs23 === errors;
                          } else {
                            var valid0 = true;
                          }
                          if (valid0) {
                            if (data.listSource !== void 0) {
                              const _errs33 = errors;
                              if (!validate77(data.listSource, {
                                instancePath: instancePath + "/listSource",
                                parentData: data,
                                parentDataProperty: "listSource",
                                rootData
                              })) {
                                vErrors = vErrors === null ? validate77.errors : vErrors.concat(validate77.errors);
                                errors = vErrors.length;
                              }
                              var valid0 = _errs33 === errors;
                            } else {
                              var valid0 = true;
                            }
                            if (valid0) {
                              if (data.filters !== void 0) {
                                let data14 = data.filters;
                                const _errs34 = errors;
                                const _errs35 = errors;
                                let valid4 = false;
                                const _errs36 = errors;
                                if (typeof data14 !== "string") {
                                  const err6 = {
                                    instancePath: instancePath + "/filters",
                                    schemaPath: "#/properties/filters/anyOf/0/type",
                                    keyword: "type",
                                    params: {
                                      type: "string"
                                    },
                                    message: "must be string"
                                  };
                                  if (vErrors === null) {
                                    vErrors = [err6];
                                  } else {
                                    vErrors.push(err6);
                                  }
                                  errors++;
                                }
                                if ("DEFAULT" !== data14) {
                                  const err7 = {
                                    instancePath: instancePath + "/filters",
                                    schemaPath: "#/properties/filters/anyOf/0/const",
                                    keyword: "const",
                                    params: {
                                      allowedValue: "DEFAULT"
                                    },
                                    message: "must be equal to constant"
                                  };
                                  if (vErrors === null) {
                                    vErrors = [err7];
                                  } else {
                                    vErrors.push(err7);
                                  }
                                  errors++;
                                }
                                var _valid1 = _errs36 === errors;
                                valid4 = valid4 || _valid1;
                                if (!valid4) {
                                  const _errs38 = errors;
                                  if (errors === _errs38) {
                                    if (Array.isArray(data14)) {
                                      var valid5 = true;
                                      const len1 = data14.length;
                                      for (let i1 = 0; i1 < len1; i1++) {
                                        const _errs40 = errors;
                                        if (!validate74(data14[i1], {
                                          instancePath: instancePath + "/filters/" + i1,
                                          parentData: data14,
                                          parentDataProperty: i1,
                                          rootData
                                        })) {
                                          vErrors = vErrors === null ? validate74.errors : vErrors.concat(validate74.errors);
                                          errors = vErrors.length;
                                        }
                                        var valid5 = _errs40 === errors;
                                        if (!valid5) {
                                          break;
                                        }
                                      }
                                    } else {
                                      const err8 = {
                                        instancePath: instancePath + "/filters",
                                        schemaPath: "#/properties/filters/anyOf/1/type",
                                        keyword: "type",
                                        params: {
                                          type: "array"
                                        },
                                        message: "must be array"
                                      };
                                      if (vErrors === null) {
                                        vErrors = [err8];
                                      } else {
                                        vErrors.push(err8);
                                      }
                                      errors++;
                                    }
                                  }
                                  var _valid1 = _errs38 === errors;
                                  valid4 = valid4 || _valid1;
                                }
                                if (!valid4) {
                                  const err9 = {
                                    instancePath: instancePath + "/filters",
                                    schemaPath: "#/properties/filters/anyOf",
                                    keyword: "anyOf",
                                    params: {},
                                    message: "must match a schema in anyOf"
                                  };
                                  if (vErrors === null) {
                                    vErrors = [err9];
                                  } else {
                                    vErrors.push(err9);
                                  }
                                  errors++;
                                  validate84.errors = vErrors;
                                  return false;
                                } else {
                                  errors = _errs35;
                                  if (vErrors !== null) {
                                    if (_errs35) {
                                      vErrors.length = _errs35;
                                    } else {
                                      vErrors = null;
                                    }
                                  }
                                }
                                var valid0 = _errs34 === errors;
                              } else {
                                var valid0 = true;
                              }
                            }
                          }
                        }
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
    } else {
      validate84.errors = [{
        instancePath,
        schemaPath: "#/type",
        keyword: "type",
        params: {
          type: "object"
        },
        message: "must be object"
      }];
      return false;
    }
  }
  validate84.errors = vErrors;
  return errors === 0;
}
const VideoModule = validate87;
function validate87(data, {
  instancePath = "",
  parentData,
  parentDataProperty,
  rootData = data
} = {}) {
  let vErrors = null;
  let errors = 0;
  {
    if (data && typeof data == "object" && !Array.isArray(data)) {
      let missing0;
      if (data.moduleType === void 0 && (missing0 = "moduleType") || data.sourceId === void 0 && (missing0 = "sourceId")) {
        validate87.errors = [{
          instancePath,
          schemaPath: "#/required",
          keyword: "required",
          params: {
            missingProperty: missing0
          },
          message: "must have required property '" + missing0 + "'"
        }];
        return false;
      } else {
        if (data.moduleType !== void 0) {
          let data0 = data.moduleType;
          const _errs1 = errors;
          if (typeof data0 !== "string") {
            validate87.errors = [{
              instancePath: instancePath + "/moduleType",
              schemaPath: "#/properties/moduleType/type",
              keyword: "type",
              params: {
                type: "string"
              },
              message: "must be string"
            }];
            return false;
          }
          if ("SINGLE_VIDEO" !== data0) {
            validate87.errors = [{
              instancePath: instancePath + "/moduleType",
              schemaPath: "#/properties/moduleType/const",
              keyword: "const",
              params: {
                allowedValue: "SINGLE_VIDEO"
              },
              message: "must be equal to constant"
            }];
            return false;
          }
          var valid0 = _errs1 === errors;
        } else {
          var valid0 = true;
        }
        if (valid0) {
          if (data.heading !== void 0) {
            const _errs3 = errors;
            if (typeof data.heading !== "string") {
              validate87.errors = [{
                instancePath: instancePath + "/heading",
                schemaPath: "#/properties/heading/type",
                keyword: "type",
                params: {
                  type: "string"
                },
                message: "must be string"
              }];
              return false;
            }
            var valid0 = _errs3 === errors;
          } else {
            var valid0 = true;
          }
          if (valid0) {
            if (data.subHeading !== void 0) {
              const _errs5 = errors;
              if (typeof data.subHeading !== "string") {
                validate87.errors = [{
                  instancePath: instancePath + "/subHeading",
                  schemaPath: "#/properties/subHeading/type",
                  keyword: "type",
                  params: {
                    type: "string"
                  },
                  message: "must be string"
                }];
                return false;
              }
              var valid0 = _errs5 === errors;
            } else {
              var valid0 = true;
            }
            if (valid0) {
              if (data.sourceId !== void 0) {
                const _errs7 = errors;
                if (typeof data.sourceId !== "string") {
                  validate87.errors = [{
                    instancePath: instancePath + "/sourceId",
                    schemaPath: "#/properties/sourceId/type",
                    keyword: "type",
                    params: {
                      type: "string"
                    },
                    message: "must be string"
                  }];
                  return false;
                }
                var valid0 = _errs7 === errors;
              } else {
                var valid0 = true;
              }
            }
          }
        }
      }
    } else {
      validate87.errors = [{
        instancePath,
        schemaPath: "#/type",
        keyword: "type",
        params: {
          type: "object"
        },
        message: "must be object"
      }];
      return false;
    }
  }
  validate87.errors = vErrors;
  return errors === 0;
}
const PageModule = validate88;
function validate88(data, {
  instancePath = "",
  parentData,
  parentDataProperty,
  rootData = data
} = {}) {
  let vErrors = null;
  let errors = 0;
  const _errs0 = errors;
  let valid0 = false;
  const _errs1 = errors;
  if (!validate50(data, {
    instancePath,
    parentData,
    parentDataProperty,
    rootData
  })) {
    vErrors = vErrors === null ? validate50.errors : vErrors.concat(validate50.errors);
    errors = vErrors.length;
  }
  var _valid0 = _errs1 === errors;
  valid0 = valid0 || _valid0;
  if (!valid0) {
    const _errs2 = errors;
    if (!validate69(data, {
      instancePath,
      parentData,
      parentDataProperty,
      rootData
    })) {
      vErrors = vErrors === null ? validate69.errors : vErrors.concat(validate69.errors);
      errors = vErrors.length;
    }
    var _valid0 = _errs2 === errors;
    valid0 = valid0 || _valid0;
    if (!valid0) {
      const _errs3 = errors;
      const _errs4 = errors;
      if (errors === _errs4) {
        if (data && typeof data == "object" && !Array.isArray(data)) {
          let missing0;
          if (data.moduleType === void 0 && (missing0 = "moduleType") || data.tags === void 0 && (missing0 = "tags")) {
            const err0 = {
              instancePath,
              schemaPath: "TagsListModule/required",
              keyword: "required",
              params: {
                missingProperty: missing0
              },
              message: "must have required property '" + missing0 + "'"
            };
            if (vErrors === null) {
              vErrors = [err0];
            } else {
              vErrors.push(err0);
            }
            errors++;
          } else {
            if (data.moduleType !== void 0) {
              let data0 = data.moduleType;
              const _errs6 = errors;
              if (typeof data0 !== "string") {
                const err1 = {
                  instancePath: instancePath + "/moduleType",
                  schemaPath: "TagsListModule/properties/moduleType/type",
                  keyword: "type",
                  params: {
                    type: "string"
                  },
                  message: "must be string"
                };
                if (vErrors === null) {
                  vErrors = [err1];
                } else {
                  vErrors.push(err1);
                }
                errors++;
              }
              if ("TAGS_LIST" !== data0) {
                const err2 = {
                  instancePath: instancePath + "/moduleType",
                  schemaPath: "TagsListModule/properties/moduleType/const",
                  keyword: "const",
                  params: {
                    allowedValue: "TAGS_LIST"
                  },
                  message: "must be equal to constant"
                };
                if (vErrors === null) {
                  vErrors = [err2];
                } else {
                  vErrors.push(err2);
                }
                errors++;
              }
              var valid2 = _errs6 === errors;
            } else {
              var valid2 = true;
            }
            if (valid2) {
              if (data.heading !== void 0) {
                const _errs8 = errors;
                if (typeof data.heading !== "string") {
                  const err3 = {
                    instancePath: instancePath + "/heading",
                    schemaPath: "TagsListModule/properties/heading/type",
                    keyword: "type",
                    params: {
                      type: "string"
                    },
                    message: "must be string"
                  };
                  if (vErrors === null) {
                    vErrors = [err3];
                  } else {
                    vErrors.push(err3);
                  }
                  errors++;
                }
                var valid2 = _errs8 === errors;
              } else {
                var valid2 = true;
              }
              if (valid2) {
                if (data.subHeading !== void 0) {
                  const _errs10 = errors;
                  if (typeof data.subHeading !== "string") {
                    const err4 = {
                      instancePath: instancePath + "/subHeading",
                      schemaPath: "TagsListModule/properties/subHeading/type",
                      keyword: "type",
                      params: {
                        type: "string"
                      },
                      message: "must be string"
                    };
                    if (vErrors === null) {
                      vErrors = [err4];
                    } else {
                      vErrors.push(err4);
                    }
                    errors++;
                  }
                  var valid2 = _errs10 === errors;
                } else {
                  var valid2 = true;
                }
                if (valid2) {
                  if (data.tags !== void 0) {
                    let data3 = data.tags;
                    const _errs12 = errors;
                    if (errors === _errs12) {
                      if (Array.isArray(data3)) {
                        var valid3 = true;
                        const len0 = data3.length;
                        for (let i0 = 0; i0 < len0; i0++) {
                          const _errs14 = errors;
                          if (typeof data3[i0] !== "string") {
                            const err5 = {
                              instancePath: instancePath + "/tags/" + i0,
                              schemaPath: "TagsListModule/properties/tags/items/type",
                              keyword: "type",
                              params: {
                                type: "string"
                              },
                              message: "must be string"
                            };
                            if (vErrors === null) {
                              vErrors = [err5];
                            } else {
                              vErrors.push(err5);
                            }
                            errors++;
                          }
                          var valid3 = _errs14 === errors;
                          if (!valid3) {
                            break;
                          }
                        }
                      } else {
                        const err6 = {
                          instancePath: instancePath + "/tags",
                          schemaPath: "TagsListModule/properties/tags/type",
                          keyword: "type",
                          params: {
                            type: "array"
                          },
                          message: "must be array"
                        };
                        if (vErrors === null) {
                          vErrors = [err6];
                        } else {
                          vErrors.push(err6);
                        }
                        errors++;
                      }
                    }
                    var valid2 = _errs12 === errors;
                  } else {
                    var valid2 = true;
                  }
                }
              }
            }
          }
        } else {
          const err7 = {
            instancePath,
            schemaPath: "TagsListModule/type",
            keyword: "type",
            params: {
              type: "object"
            },
            message: "must be object"
          };
          if (vErrors === null) {
            vErrors = [err7];
          } else {
            vErrors.push(err7);
          }
          errors++;
        }
      }
      var _valid0 = _errs3 === errors;
      valid0 = valid0 || _valid0;
      if (!valid0) {
        const _errs16 = errors;
        if (!validate82(data, {
          instancePath,
          parentData,
          parentDataProperty,
          rootData
        })) {
          vErrors = vErrors === null ? validate82.errors : vErrors.concat(validate82.errors);
          errors = vErrors.length;
        }
        var _valid0 = _errs16 === errors;
        valid0 = valid0 || _valid0;
        if (!valid0) {
          const _errs17 = errors;
          if (!validate84(data, {
            instancePath,
            parentData,
            parentDataProperty,
            rootData
          })) {
            vErrors = vErrors === null ? validate84.errors : vErrors.concat(validate84.errors);
            errors = vErrors.length;
          }
          var _valid0 = _errs17 === errors;
          valid0 = valid0 || _valid0;
          if (!valid0) {
            const _errs18 = errors;
            const _errs19 = errors;
            if (errors === _errs19) {
              if (data && typeof data == "object" && !Array.isArray(data)) {
                let missing1;
                if (data.moduleType === void 0 && (missing1 = "moduleType") || data.sourceId === void 0 && (missing1 = "sourceId")) {
                  const err8 = {
                    instancePath,
                    schemaPath: "VideoModule/required",
                    keyword: "required",
                    params: {
                      missingProperty: missing1
                    },
                    message: "must have required property '" + missing1 + "'"
                  };
                  if (vErrors === null) {
                    vErrors = [err8];
                  } else {
                    vErrors.push(err8);
                  }
                  errors++;
                } else {
                  if (data.moduleType !== void 0) {
                    let data5 = data.moduleType;
                    const _errs21 = errors;
                    if (typeof data5 !== "string") {
                      const err9 = {
                        instancePath: instancePath + "/moduleType",
                        schemaPath: "VideoModule/properties/moduleType/type",
                        keyword: "type",
                        params: {
                          type: "string"
                        },
                        message: "must be string"
                      };
                      if (vErrors === null) {
                        vErrors = [err9];
                      } else {
                        vErrors.push(err9);
                      }
                      errors++;
                    }
                    if ("SINGLE_VIDEO" !== data5) {
                      const err10 = {
                        instancePath: instancePath + "/moduleType",
                        schemaPath: "VideoModule/properties/moduleType/const",
                        keyword: "const",
                        params: {
                          allowedValue: "SINGLE_VIDEO"
                        },
                        message: "must be equal to constant"
                      };
                      if (vErrors === null) {
                        vErrors = [err10];
                      } else {
                        vErrors.push(err10);
                      }
                      errors++;
                    }
                    var valid5 = _errs21 === errors;
                  } else {
                    var valid5 = true;
                  }
                  if (valid5) {
                    if (data.heading !== void 0) {
                      const _errs23 = errors;
                      if (typeof data.heading !== "string") {
                        const err11 = {
                          instancePath: instancePath + "/heading",
                          schemaPath: "VideoModule/properties/heading/type",
                          keyword: "type",
                          params: {
                            type: "string"
                          },
                          message: "must be string"
                        };
                        if (vErrors === null) {
                          vErrors = [err11];
                        } else {
                          vErrors.push(err11);
                        }
                        errors++;
                      }
                      var valid5 = _errs23 === errors;
                    } else {
                      var valid5 = true;
                    }
                    if (valid5) {
                      if (data.subHeading !== void 0) {
                        const _errs25 = errors;
                        if (typeof data.subHeading !== "string") {
                          const err12 = {
                            instancePath: instancePath + "/subHeading",
                            schemaPath: "VideoModule/properties/subHeading/type",
                            keyword: "type",
                            params: {
                              type: "string"
                            },
                            message: "must be string"
                          };
                          if (vErrors === null) {
                            vErrors = [err12];
                          } else {
                            vErrors.push(err12);
                          }
                          errors++;
                        }
                        var valid5 = _errs25 === errors;
                      } else {
                        var valid5 = true;
                      }
                      if (valid5) {
                        if (data.sourceId !== void 0) {
                          const _errs27 = errors;
                          if (typeof data.sourceId !== "string") {
                            const err13 = {
                              instancePath: instancePath + "/sourceId",
                              schemaPath: "VideoModule/properties/sourceId/type",
                              keyword: "type",
                              params: {
                                type: "string"
                              },
                              message: "must be string"
                            };
                            if (vErrors === null) {
                              vErrors = [err13];
                            } else {
                              vErrors.push(err13);
                            }
                            errors++;
                          }
                          var valid5 = _errs27 === errors;
                        } else {
                          var valid5 = true;
                        }
                      }
                    }
                  }
                }
              } else {
                const err14 = {
                  instancePath,
                  schemaPath: "VideoModule/type",
                  keyword: "type",
                  params: {
                    type: "object"
                  },
                  message: "must be object"
                };
                if (vErrors === null) {
                  vErrors = [err14];
                } else {
                  vErrors.push(err14);
                }
                errors++;
              }
            }
            var _valid0 = _errs18 === errors;
            valid0 = valid0 || _valid0;
            if (!valid0) {
              const _errs29 = errors;
              const _errs30 = errors;
              if (errors === _errs30) {
                if (data && typeof data == "object" && !Array.isArray(data)) {
                  let missing2;
                  if (data.density === void 0 && (missing2 = "density") || data.layoutType === void 0 && (missing2 = "layoutType") || data.listSource === void 0 && (missing2 = "listSource") || data.moduleType === void 0 && (missing2 = "moduleType") || data.size === void 0 && (missing2 = "size")) {
                    const err15 = {
                      instancePath,
                      schemaPath: "LiveAndUpcomingListModule/required",
                      keyword: "required",
                      params: {
                        missingProperty: missing2
                      },
                      message: "must have required property '" + missing2 + "'"
                    };
                    if (vErrors === null) {
                      vErrors = [err15];
                    } else {
                      vErrors.push(err15);
                    }
                    errors++;
                  } else {
                    if (data.moduleType !== void 0) {
                      let data9 = data.moduleType;
                      const _errs32 = errors;
                      if (typeof data9 !== "string") {
                        const err16 = {
                          instancePath: instancePath + "/moduleType",
                          schemaPath: "LiveAndUpcomingListModule/properties/moduleType/type",
                          keyword: "type",
                          params: {
                            type: "string"
                          },
                          message: "must be string"
                        };
                        if (vErrors === null) {
                          vErrors = [err16];
                        } else {
                          vErrors.push(err16);
                        }
                        errors++;
                      }
                      if ("LIVE_AND_UPCOMING_LIST" !== data9) {
                        const err17 = {
                          instancePath: instancePath + "/moduleType",
                          schemaPath: "LiveAndUpcomingListModule/properties/moduleType/const",
                          keyword: "const",
                          params: {
                            allowedValue: "LIVE_AND_UPCOMING_LIST"
                          },
                          message: "must be equal to constant"
                        };
                        if (vErrors === null) {
                          vErrors = [err17];
                        } else {
                          vErrors.push(err17);
                        }
                        errors++;
                      }
                      var valid7 = _errs32 === errors;
                    } else {
                      var valid7 = true;
                    }
                    if (valid7) {
                      if (data.heading !== void 0) {
                        const _errs34 = errors;
                        if (typeof data.heading !== "string") {
                          const err18 = {
                            instancePath: instancePath + "/heading",
                            schemaPath: "LiveAndUpcomingListModule/properties/heading/type",
                            keyword: "type",
                            params: {
                              type: "string"
                            },
                            message: "must be string"
                          };
                          if (vErrors === null) {
                            vErrors = [err18];
                          } else {
                            vErrors.push(err18);
                          }
                          errors++;
                        }
                        var valid7 = _errs34 === errors;
                      } else {
                        var valid7 = true;
                      }
                      if (valid7) {
                        if (data.subHeading !== void 0) {
                          const _errs36 = errors;
                          if (typeof data.subHeading !== "string") {
                            const err19 = {
                              instancePath: instancePath + "/subHeading",
                              schemaPath: "LiveAndUpcomingListModule/properties/subHeading/type",
                              keyword: "type",
                              params: {
                                type: "string"
                              },
                              message: "must be string"
                            };
                            if (vErrors === null) {
                              vErrors = [err19];
                            } else {
                              vErrors.push(err19);
                            }
                            errors++;
                          }
                          var valid7 = _errs36 === errors;
                        } else {
                          var valid7 = true;
                        }
                        if (valid7) {
                          if (data.layoutType !== void 0) {
                            let data12 = data.layoutType;
                            const _errs38 = errors;
                            if (typeof data12 !== "string") {
                              const err20 = {
                                instancePath: instancePath + "/layoutType",
                                schemaPath: "LiveAndUpcomingListModule/properties/layoutType/type",
                                keyword: "type",
                                params: {
                                  type: "string"
                                },
                                message: "must be string"
                              };
                              if (vErrors === null) {
                                vErrors = [err20];
                              } else {
                                vErrors.push(err20);
                              }
                              errors++;
                            }
                            if (!(data12 === "CAROUSEL" || data12 === "GRID")) {
                              const err21 = {
                                instancePath: instancePath + "/layoutType",
                                schemaPath: "LiveAndUpcomingListModule/properties/layoutType/enum",
                                keyword: "enum",
                                params: {
                                  allowedValues: schema76.properties.layoutType.enum
                                },
                                message: "must be equal to one of the allowed values"
                              };
                              if (vErrors === null) {
                                vErrors = [err21];
                              } else {
                                vErrors.push(err21);
                              }
                              errors++;
                            }
                            var valid7 = _errs38 === errors;
                          } else {
                            var valid7 = true;
                          }
                          if (valid7) {
                            if (data.density !== void 0) {
                              let data13 = data.density;
                              const _errs40 = errors;
                              if (typeof data13 !== "string") {
                                const err22 = {
                                  instancePath: instancePath + "/density",
                                  schemaPath: "LiveAndUpcomingListModule/properties/density/type",
                                  keyword: "type",
                                  params: {
                                    type: "string"
                                  },
                                  message: "must be string"
                                };
                                if (vErrors === null) {
                                  vErrors = [err22];
                                } else {
                                  vErrors.push(err22);
                                }
                                errors++;
                              }
                              if (!(data13 === "NORMAL" || data13 === "DENSE" || data13 === "DENSEST")) {
                                const err23 = {
                                  instancePath: instancePath + "/density",
                                  schemaPath: "LiveAndUpcomingListModule/properties/density/enum",
                                  keyword: "enum",
                                  params: {
                                    allowedValues: schema76.properties.density.enum
                                  },
                                  message: "must be equal to one of the allowed values"
                                };
                                if (vErrors === null) {
                                  vErrors = [err23];
                                } else {
                                  vErrors.push(err23);
                                }
                                errors++;
                              }
                              var valid7 = _errs40 === errors;
                            } else {
                              var valid7 = true;
                            }
                            if (valid7) {
                              if (data.preferedGridSize !== void 0) {
                                let data14 = data.preferedGridSize;
                                const _errs42 = errors;
                                if (errors === _errs42) {
                                  if (data14 && typeof data14 == "object" && !Array.isArray(data14)) {
                                    let missing3;
                                    if (data14.columns === void 0 && (missing3 = "columns") || data14.rows === void 0 && (missing3 = "rows")) {
                                      const err24 = {
                                        instancePath: instancePath + "/preferedGridSize",
                                        schemaPath: "LiveAndUpcomingListModule/properties/preferedGridSize/required",
                                        keyword: "required",
                                        params: {
                                          missingProperty: missing3
                                        },
                                        message: "must have required property '" + missing3 + "'"
                                      };
                                      if (vErrors === null) {
                                        vErrors = [err24];
                                      } else {
                                        vErrors.push(err24);
                                      }
                                      errors++;
                                    } else {
                                      if (data14.columns !== void 0) {
                                        let data15 = data14.columns;
                                        const _errs44 = errors;
                                        if (!(typeof data15 == "number" && isFinite(data15))) {
                                          const err25 = {
                                            instancePath: instancePath + "/preferedGridSize/columns",
                                            schemaPath: "LiveAndUpcomingListModule/properties/preferedGridSize/properties/columns/type",
                                            keyword: "type",
                                            params: {
                                              type: "number"
                                            },
                                            message: "must be number"
                                          };
                                          if (vErrors === null) {
                                            vErrors = [err25];
                                          } else {
                                            vErrors.push(err25);
                                          }
                                          errors++;
                                        }
                                        var valid8 = _errs44 === errors;
                                      } else {
                                        var valid8 = true;
                                      }
                                      if (valid8) {
                                        if (data14.rows !== void 0) {
                                          let data16 = data14.rows;
                                          const _errs46 = errors;
                                          if (!(typeof data16 == "number" && isFinite(data16))) {
                                            const err26 = {
                                              instancePath: instancePath + "/preferedGridSize/rows",
                                              schemaPath: "LiveAndUpcomingListModule/properties/preferedGridSize/properties/rows/type",
                                              keyword: "type",
                                              params: {
                                                type: "number"
                                              },
                                              message: "must be number"
                                            };
                                            if (vErrors === null) {
                                              vErrors = [err26];
                                            } else {
                                              vErrors.push(err26);
                                            }
                                            errors++;
                                          }
                                          var valid8 = _errs46 === errors;
                                        } else {
                                          var valid8 = true;
                                        }
                                      }
                                    }
                                  } else {
                                    const err27 = {
                                      instancePath: instancePath + "/preferedGridSize",
                                      schemaPath: "LiveAndUpcomingListModule/properties/preferedGridSize/type",
                                      keyword: "type",
                                      params: {
                                        type: "object"
                                      },
                                      message: "must be object"
                                    };
                                    if (vErrors === null) {
                                      vErrors = [err27];
                                    } else {
                                      vErrors.push(err27);
                                    }
                                    errors++;
                                  }
                                }
                                var valid7 = _errs42 === errors;
                              } else {
                                var valid7 = true;
                              }
                              if (valid7) {
                                if (data.listSource !== void 0) {
                                  let data17 = data.listSource;
                                  const _errs48 = errors;
                                  if (errors === _errs48) {
                                    if (data17 && typeof data17 == "object" && !Array.isArray(data17)) {
                                      if (data17.tags !== void 0) {
                                        let data18 = data17.tags;
                                        const _errs50 = errors;
                                        if (errors === _errs50) {
                                          if (data18 && typeof data18 == "object" && !Array.isArray(data18)) {
                                            let missing4;
                                            if (data18.kind === void 0 && (missing4 = "kind") || data18.list === void 0 && (missing4 = "list")) {
                                              const err28 = {
                                                instancePath: instancePath + "/listSource/tags",
                                                schemaPath: "LiveAndUpcomingListModule/properties/listSource/properties/tags/required",
                                                keyword: "required",
                                                params: {
                                                  missingProperty: missing4
                                                },
                                                message: "must have required property '" + missing4 + "'"
                                              };
                                              if (vErrors === null) {
                                                vErrors = [err28];
                                              } else {
                                                vErrors.push(err28);
                                              }
                                              errors++;
                                            } else {
                                              if (data18.kind !== void 0) {
                                                let data19 = data18.kind;
                                                const _errs52 = errors;
                                                if (typeof data19 !== "string") {
                                                  const err29 = {
                                                    instancePath: instancePath + "/listSource/tags/kind",
                                                    schemaPath: "LiveAndUpcomingListModule/properties/listSource/properties/tags/properties/kind/type",
                                                    keyword: "type",
                                                    params: {
                                                      type: "string"
                                                    },
                                                    message: "must be string"
                                                  };
                                                  if (vErrors === null) {
                                                    vErrors = [err29];
                                                  } else {
                                                    vErrors.push(err29);
                                                  }
                                                  errors++;
                                                }
                                                if (!(data19 === "ALL" || data19 === "SOME")) {
                                                  const err30 = {
                                                    instancePath: instancePath + "/listSource/tags/kind",
                                                    schemaPath: "LiveAndUpcomingListModule/properties/listSource/properties/tags/properties/kind/enum",
                                                    keyword: "enum",
                                                    params: {
                                                      allowedValues: schema76.properties.listSource.properties.tags.properties.kind.enum
                                                    },
                                                    message: "must be equal to one of the allowed values"
                                                  };
                                                  if (vErrors === null) {
                                                    vErrors = [err30];
                                                  } else {
                                                    vErrors.push(err30);
                                                  }
                                                  errors++;
                                                }
                                                var valid10 = _errs52 === errors;
                                              } else {
                                                var valid10 = true;
                                              }
                                              if (valid10) {
                                                if (data18.list !== void 0) {
                                                  let data20 = data18.list;
                                                  const _errs54 = errors;
                                                  if (errors === _errs54) {
                                                    if (Array.isArray(data20)) {
                                                      var valid11 = true;
                                                      const len1 = data20.length;
                                                      for (let i1 = 0; i1 < len1; i1++) {
                                                        const _errs56 = errors;
                                                        if (typeof data20[i1] !== "string") {
                                                          const err31 = {
                                                            instancePath: instancePath + "/listSource/tags/list/" + i1,
                                                            schemaPath: "LiveAndUpcomingListModule/properties/listSource/properties/tags/properties/list/items/type",
                                                            keyword: "type",
                                                            params: {
                                                              type: "string"
                                                            },
                                                            message: "must be string"
                                                          };
                                                          if (vErrors === null) {
                                                            vErrors = [err31];
                                                          } else {
                                                            vErrors.push(err31);
                                                          }
                                                          errors++;
                                                        }
                                                        var valid11 = _errs56 === errors;
                                                        if (!valid11) {
                                                          break;
                                                        }
                                                      }
                                                    } else {
                                                      const err32 = {
                                                        instancePath: instancePath + "/listSource/tags/list",
                                                        schemaPath: "LiveAndUpcomingListModule/properties/listSource/properties/tags/properties/list/type",
                                                        keyword: "type",
                                                        params: {
                                                          type: "array"
                                                        },
                                                        message: "must be array"
                                                      };
                                                      if (vErrors === null) {
                                                        vErrors = [err32];
                                                      } else {
                                                        vErrors.push(err32);
                                                      }
                                                      errors++;
                                                    }
                                                  }
                                                  var valid10 = _errs54 === errors;
                                                } else {
                                                  var valid10 = true;
                                                }
                                              }
                                            }
                                          } else {
                                            const err33 = {
                                              instancePath: instancePath + "/listSource/tags",
                                              schemaPath: "LiveAndUpcomingListModule/properties/listSource/properties/tags/type",
                                              keyword: "type",
                                              params: {
                                                type: "object"
                                              },
                                              message: "must be object"
                                            };
                                            if (vErrors === null) {
                                              vErrors = [err33];
                                            } else {
                                              vErrors.push(err33);
                                            }
                                            errors++;
                                          }
                                        }
                                        var valid9 = _errs50 === errors;
                                      } else {
                                        var valid9 = true;
                                      }
                                      if (valid9) {
                                        if (data17.eventId !== void 0) {
                                          const _errs58 = errors;
                                          if (typeof data17.eventId !== "string") {
                                            const err34 = {
                                              instancePath: instancePath + "/listSource/eventId",
                                              schemaPath: "LiveAndUpcomingListModule/properties/listSource/properties/eventId/type",
                                              keyword: "type",
                                              params: {
                                                type: "string"
                                              },
                                              message: "must be string"
                                            };
                                            if (vErrors === null) {
                                              vErrors = [err34];
                                            } else {
                                              vErrors.push(err34);
                                            }
                                            errors++;
                                          }
                                          var valid9 = _errs58 === errors;
                                        } else {
                                          var valid9 = true;
                                        }
                                      }
                                    } else {
                                      const err35 = {
                                        instancePath: instancePath + "/listSource",
                                        schemaPath: "LiveAndUpcomingListModule/properties/listSource/type",
                                        keyword: "type",
                                        params: {
                                          type: "object"
                                        },
                                        message: "must be object"
                                      };
                                      if (vErrors === null) {
                                        vErrors = [err35];
                                      } else {
                                        vErrors.push(err35);
                                      }
                                      errors++;
                                    }
                                  }
                                  var valid7 = _errs48 === errors;
                                } else {
                                  var valid7 = true;
                                }
                                if (valid7) {
                                  if (data.size !== void 0) {
                                    let data23 = data.size;
                                    const _errs60 = errors;
                                    if (!(typeof data23 == "number" && isFinite(data23))) {
                                      const err36 = {
                                        instancePath: instancePath + "/size",
                                        schemaPath: "LiveAndUpcomingListModule/properties/size/type",
                                        keyword: "type",
                                        params: {
                                          type: "number"
                                        },
                                        message: "must be number"
                                      };
                                      if (vErrors === null) {
                                        vErrors = [err36];
                                      } else {
                                        vErrors.push(err36);
                                      }
                                      errors++;
                                    }
                                    var valid7 = _errs60 === errors;
                                  } else {
                                    var valid7 = true;
                                  }
                                  if (valid7) {
                                    if (data.dateRange !== void 0) {
                                      let data24 = data.dateRange;
                                      const _errs62 = errors;
                                      if (errors === _errs62) {
                                        if (Array.isArray(data24)) {
                                          if (data24.length > 2) {
                                            const err37 = {
                                              instancePath: instancePath + "/dateRange",
                                              schemaPath: "LiveAndUpcomingListModule/properties/dateRange/maxItems",
                                              keyword: "maxItems",
                                              params: {
                                                limit: 2
                                              },
                                              message: "must NOT have more than 2 items"
                                            };
                                            if (vErrors === null) {
                                              vErrors = [err37];
                                            } else {
                                              vErrors.push(err37);
                                            }
                                            errors++;
                                          } else {
                                            if (data24.length < 2) {
                                              const err38 = {
                                                instancePath: instancePath + "/dateRange",
                                                schemaPath: "LiveAndUpcomingListModule/properties/dateRange/minItems",
                                                keyword: "minItems",
                                                params: {
                                                  limit: 2
                                                },
                                                message: "must NOT have fewer than 2 items"
                                              };
                                              if (vErrors === null) {
                                                vErrors = [err38];
                                              } else {
                                                vErrors.push(err38);
                                              }
                                              errors++;
                                            } else {
                                              var valid12 = true;
                                              const len2 = data24.length;
                                              for (let i2 = 0; i2 < len2; i2++) {
                                                let data25 = data24[i2];
                                                const _errs64 = errors;
                                                const _errs65 = errors;
                                                let valid13 = false;
                                                const _errs66 = errors;
                                                if (typeof data25 !== "string") {
                                                  const err39 = {
                                                    instancePath: instancePath + "/dateRange/" + i2,
                                                    schemaPath: "LiveAndUpcomingListModule/properties/dateRange/items/anyOf/0/type",
                                                    keyword: "type",
                                                    params: {
                                                      type: "string"
                                                    },
                                                    message: "must be string"
                                                  };
                                                  if (vErrors === null) {
                                                    vErrors = [err39];
                                                  } else {
                                                    vErrors.push(err39);
                                                  }
                                                  errors++;
                                                }
                                                if ("NOW" !== data25) {
                                                  const err40 = {
                                                    instancePath: instancePath + "/dateRange/" + i2,
                                                    schemaPath: "LiveAndUpcomingListModule/properties/dateRange/items/anyOf/0/const",
                                                    keyword: "const",
                                                    params: {
                                                      allowedValue: "NOW"
                                                    },
                                                    message: "must be equal to constant"
                                                  };
                                                  if (vErrors === null) {
                                                    vErrors = [err40];
                                                  } else {
                                                    vErrors.push(err40);
                                                  }
                                                  errors++;
                                                }
                                                var _valid1 = _errs66 === errors;
                                                valid13 = valid13 || _valid1;
                                                if (!valid13) {
                                                  const _errs68 = errors;
                                                  if (!(data25 && typeof data25 == "object" && !Array.isArray(data25))) {
                                                    const err41 = {
                                                      instancePath: instancePath + "/dateRange/" + i2,
                                                      schemaPath: "LiveAndUpcomingListModule/properties/dateRange/items/anyOf/1/type",
                                                      keyword: "type",
                                                      params: {
                                                        type: "object"
                                                      },
                                                      message: "must be object"
                                                    };
                                                    if (vErrors === null) {
                                                      vErrors = [err41];
                                                    } else {
                                                      vErrors.push(err41);
                                                    }
                                                    errors++;
                                                  }
                                                  if (errors === _errs68) {
                                                    if (errors === _errs68) {
                                                      if (typeof data25 === "string") {
                                                        if (!formats0(data25)) {
                                                          const err42 = {
                                                            instancePath: instancePath + "/dateRange/" + i2,
                                                            schemaPath: "LiveAndUpcomingListModule/properties/dateRange/items/anyOf/1/format",
                                                            keyword: "format",
                                                            params: {
                                                              format: "date-time"
                                                            },
                                                            message: 'must match format "date-time"'
                                                          };
                                                          if (vErrors === null) {
                                                            vErrors = [err42];
                                                          } else {
                                                            vErrors.push(err42);
                                                          }
                                                          errors++;
                                                        }
                                                      }
                                                    }
                                                  }
                                                  var _valid1 = _errs68 === errors;
                                                  valid13 = valid13 || _valid1;
                                                  if (!valid13) {
                                                    const _errs70 = errors;
                                                    if (data25 !== null) {
                                                      const err43 = {
                                                        instancePath: instancePath + "/dateRange/" + i2,
                                                        schemaPath: "LiveAndUpcomingListModule/properties/dateRange/items/anyOf/2/type",
                                                        keyword: "type",
                                                        params: {
                                                          type: "null"
                                                        },
                                                        message: "must be null"
                                                      };
                                                      if (vErrors === null) {
                                                        vErrors = [err43];
                                                      } else {
                                                        vErrors.push(err43);
                                                      }
                                                      errors++;
                                                    }
                                                    var _valid1 = _errs70 === errors;
                                                    valid13 = valid13 || _valid1;
                                                  }
                                                }
                                                if (!valid13) {
                                                  const err44 = {
                                                    instancePath: instancePath + "/dateRange/" + i2,
                                                    schemaPath: "LiveAndUpcomingListModule/properties/dateRange/items/anyOf",
                                                    keyword: "anyOf",
                                                    params: {},
                                                    message: "must match a schema in anyOf"
                                                  };
                                                  if (vErrors === null) {
                                                    vErrors = [err44];
                                                  } else {
                                                    vErrors.push(err44);
                                                  }
                                                  errors++;
                                                } else {
                                                  errors = _errs65;
                                                  if (vErrors !== null) {
                                                    if (_errs65) {
                                                      vErrors.length = _errs65;
                                                    } else {
                                                      vErrors = null;
                                                    }
                                                  }
                                                }
                                                var valid12 = _errs64 === errors;
                                                if (!valid12) {
                                                  break;
                                                }
                                              }
                                            }
                                          }
                                        } else {
                                          const err45 = {
                                            instancePath: instancePath + "/dateRange",
                                            schemaPath: "LiveAndUpcomingListModule/properties/dateRange/type",
                                            keyword: "type",
                                            params: {
                                              type: "array"
                                            },
                                            message: "must be array"
                                          };
                                          if (vErrors === null) {
                                            vErrors = [err45];
                                          } else {
                                            vErrors.push(err45);
                                          }
                                          errors++;
                                        }
                                      }
                                      var valid7 = _errs62 === errors;
                                    } else {
                                      var valid7 = true;
                                    }
                                  }
                                }
                              }
                            }
                          }
                        }
                      }
                    }
                  }
                } else {
                  const err46 = {
                    instancePath,
                    schemaPath: "LiveAndUpcomingListModule/type",
                    keyword: "type",
                    params: {
                      type: "object"
                    },
                    message: "must be object"
                  };
                  if (vErrors === null) {
                    vErrors = [err46];
                  } else {
                    vErrors.push(err46);
                  }
                  errors++;
                }
              }
              var _valid0 = _errs29 === errors;
              valid0 = valid0 || _valid0;
              if (!valid0) {
                const _errs72 = errors;
                const _errs73 = errors;
                if (errors === _errs73) {
                  if (data && typeof data == "object" && !Array.isArray(data)) {
                    let missing5;
                    if (data.hideFilter === void 0 && (missing5 = "hideFilter") || data.image === void 0 && (missing5 = "image") || data.moduleType === void 0 && (missing5 = "moduleType")) {
                      const err47 = {
                        instancePath,
                        schemaPath: "AdSpaceModule/required",
                        keyword: "required",
                        params: {
                          missingProperty: missing5
                        },
                        message: "must have required property '" + missing5 + "'"
                      };
                      if (vErrors === null) {
                        vErrors = [err47];
                      } else {
                        vErrors.push(err47);
                      }
                      errors++;
                    } else {
                      if (data.moduleType !== void 0) {
                        let data26 = data.moduleType;
                        const _errs75 = errors;
                        if (typeof data26 !== "string") {
                          const err48 = {
                            instancePath: instancePath + "/moduleType",
                            schemaPath: "AdSpaceModule/properties/moduleType/type",
                            keyword: "type",
                            params: {
                              type: "string"
                            },
                            message: "must be string"
                          };
                          if (vErrors === null) {
                            vErrors = [err48];
                          } else {
                            vErrors.push(err48);
                          }
                          errors++;
                        }
                        if ("AD_SPACE" !== data26) {
                          const err49 = {
                            instancePath: instancePath + "/moduleType",
                            schemaPath: "AdSpaceModule/properties/moduleType/const",
                            keyword: "const",
                            params: {
                              allowedValue: "AD_SPACE"
                            },
                            message: "must be equal to constant"
                          };
                          if (vErrors === null) {
                            vErrors = [err49];
                          } else {
                            vErrors.push(err49);
                          }
                          errors++;
                        }
                        var valid15 = _errs75 === errors;
                      } else {
                        var valid15 = true;
                      }
                      if (valid15) {
                        if (data.heading !== void 0) {
                          const _errs77 = errors;
                          if (typeof data.heading !== "string") {
                            const err50 = {
                              instancePath: instancePath + "/heading",
                              schemaPath: "AdSpaceModule/properties/heading/type",
                              keyword: "type",
                              params: {
                                type: "string"
                              },
                              message: "must be string"
                            };
                            if (vErrors === null) {
                              vErrors = [err50];
                            } else {
                              vErrors.push(err50);
                            }
                            errors++;
                          }
                          var valid15 = _errs77 === errors;
                        } else {
                          var valid15 = true;
                        }
                        if (valid15) {
                          if (data.subHeading !== void 0) {
                            const _errs79 = errors;
                            if (typeof data.subHeading !== "string") {
                              const err51 = {
                                instancePath: instancePath + "/subHeading",
                                schemaPath: "AdSpaceModule/properties/subHeading/type",
                                keyword: "type",
                                params: {
                                  type: "string"
                                },
                                message: "must be string"
                              };
                              if (vErrors === null) {
                                vErrors = [err51];
                              } else {
                                vErrors.push(err51);
                              }
                              errors++;
                            }
                            var valid15 = _errs79 === errors;
                          } else {
                            var valid15 = true;
                          }
                          if (valid15) {
                            if (data.hideFilter !== void 0) {
                              let data29 = data.hideFilter;
                              const _errs81 = errors;
                              const _errs82 = errors;
                              let valid16 = false;
                              const _errs83 = errors;
                              if (errors === _errs83) {
                                if (Array.isArray(data29)) {
                                  var valid17 = true;
                                  const len3 = data29.length;
                                  for (let i3 = 0; i3 < len3; i3++) {
                                    let data30 = data29[i3];
                                    const _errs85 = errors;
                                    if (typeof data30 !== "string") {
                                      const err52 = {
                                        instancePath: instancePath + "/hideFilter/" + i3,
                                        schemaPath: "AdSpaceModule/properties/hideFilter/anyOf/0/items/type",
                                        keyword: "type",
                                        params: {
                                          type: "string"
                                        },
                                        message: "must be string"
                                      };
                                      if (vErrors === null) {
                                        vErrors = [err52];
                                      } else {
                                        vErrors.push(err52);
                                      }
                                      errors++;
                                    }
                                    if (!(data30 === "SUBSCRIBED" || data30 === "REGISTERED")) {
                                      const err53 = {
                                        instancePath: instancePath + "/hideFilter/" + i3,
                                        schemaPath: "AdSpaceModule/properties/hideFilter/anyOf/0/items/enum",
                                        keyword: "enum",
                                        params: {
                                          allowedValues: schema20.properties.hideFilter.anyOf[0].items.enum
                                        },
                                        message: "must be equal to one of the allowed values"
                                      };
                                      if (vErrors === null) {
                                        vErrors = [err53];
                                      } else {
                                        vErrors.push(err53);
                                      }
                                      errors++;
                                    }
                                    var valid17 = _errs85 === errors;
                                    if (!valid17) {
                                      break;
                                    }
                                  }
                                } else {
                                  const err54 = {
                                    instancePath: instancePath + "/hideFilter",
                                    schemaPath: "AdSpaceModule/properties/hideFilter/anyOf/0/type",
                                    keyword: "type",
                                    params: {
                                      type: "array"
                                    },
                                    message: "must be array"
                                  };
                                  if (vErrors === null) {
                                    vErrors = [err54];
                                  } else {
                                    vErrors.push(err54);
                                  }
                                  errors++;
                                }
                              }
                              var _valid2 = _errs83 === errors;
                              valid16 = valid16 || _valid2;
                              if (!valid16) {
                                const _errs87 = errors;
                                if (data29 !== null) {
                                  const err55 = {
                                    instancePath: instancePath + "/hideFilter",
                                    schemaPath: "AdSpaceModule/properties/hideFilter/anyOf/1/type",
                                    keyword: "type",
                                    params: {
                                      type: "null"
                                    },
                                    message: "must be null"
                                  };
                                  if (vErrors === null) {
                                    vErrors = [err55];
                                  } else {
                                    vErrors.push(err55);
                                  }
                                  errors++;
                                }
                                var _valid2 = _errs87 === errors;
                                valid16 = valid16 || _valid2;
                              }
                              if (!valid16) {
                                const err56 = {
                                  instancePath: instancePath + "/hideFilter",
                                  schemaPath: "AdSpaceModule/properties/hideFilter/anyOf",
                                  keyword: "anyOf",
                                  params: {},
                                  message: "must match a schema in anyOf"
                                };
                                if (vErrors === null) {
                                  vErrors = [err56];
                                } else {
                                  vErrors.push(err56);
                                }
                                errors++;
                              } else {
                                errors = _errs82;
                                if (vErrors !== null) {
                                  if (_errs82) {
                                    vErrors.length = _errs82;
                                  } else {
                                    vErrors = null;
                                  }
                                }
                              }
                              var valid15 = _errs81 === errors;
                            } else {
                              var valid15 = true;
                            }
                            if (valid15) {
                              if (data.link !== void 0) {
                                const _errs89 = errors;
                                if (typeof data.link !== "string") {
                                  const err57 = {
                                    instancePath: instancePath + "/link",
                                    schemaPath: "AdSpaceModule/properties/link/type",
                                    keyword: "type",
                                    params: {
                                      type: "string"
                                    },
                                    message: "must be string"
                                  };
                                  if (vErrors === null) {
                                    vErrors = [err57];
                                  } else {
                                    vErrors.push(err57);
                                  }
                                  errors++;
                                }
                                var valid15 = _errs89 === errors;
                              } else {
                                var valid15 = true;
                              }
                              if (valid15) {
                                if (data.internal !== void 0) {
                                  const _errs91 = errors;
                                  if (typeof data.internal !== "boolean") {
                                    const err58 = {
                                      instancePath: instancePath + "/internal",
                                      schemaPath: "AdSpaceModule/properties/internal/type",
                                      keyword: "type",
                                      params: {
                                        type: "boolean"
                                      },
                                      message: "must be boolean"
                                    };
                                    if (vErrors === null) {
                                      vErrors = [err58];
                                    } else {
                                      vErrors.push(err58);
                                    }
                                    errors++;
                                  }
                                  var valid15 = _errs91 === errors;
                                } else {
                                  var valid15 = true;
                                }
                                if (valid15) {
                                  if (data.image !== void 0) {
                                    let data33 = data.image;
                                    const _errs93 = errors;
                                    if (errors === _errs93) {
                                      if (data33 && typeof data33 == "object" && !Array.isArray(data33)) {
                                        let missing6;
                                        if (data33.largeViewport === void 0 && (missing6 = "largeViewport")) {
                                          const err59 = {
                                            instancePath: instancePath + "/image",
                                            schemaPath: "AdSpaceModule/properties/image/required",
                                            keyword: "required",
                                            params: {
                                              missingProperty: missing6
                                            },
                                            message: "must have required property '" + missing6 + "'"
                                          };
                                          if (vErrors === null) {
                                            vErrors = [err59];
                                          } else {
                                            vErrors.push(err59);
                                          }
                                          errors++;
                                        } else {
                                          if (data33.largeViewport !== void 0) {
                                            const _errs95 = errors;
                                            if (typeof data33.largeViewport !== "string") {
                                              const err60 = {
                                                instancePath: instancePath + "/image/largeViewport",
                                                schemaPath: "AdSpaceModule/properties/image/properties/largeViewport/type",
                                                keyword: "type",
                                                params: {
                                                  type: "string"
                                                },
                                                message: "must be string"
                                              };
                                              if (vErrors === null) {
                                                vErrors = [err60];
                                              } else {
                                                vErrors.push(err60);
                                              }
                                              errors++;
                                            }
                                            var valid18 = _errs95 === errors;
                                          } else {
                                            var valid18 = true;
                                          }
                                          if (valid18) {
                                            if (data33.smallViewport !== void 0) {
                                              const _errs97 = errors;
                                              if (typeof data33.smallViewport !== "string") {
                                                const err61 = {
                                                  instancePath: instancePath + "/image/smallViewport",
                                                  schemaPath: "AdSpaceModule/properties/image/properties/smallViewport/type",
                                                  keyword: "type",
                                                  params: {
                                                    type: "string"
                                                  },
                                                  message: "must be string"
                                                };
                                                if (vErrors === null) {
                                                  vErrors = [err61];
                                                } else {
                                                  vErrors.push(err61);
                                                }
                                                errors++;
                                              }
                                              var valid18 = _errs97 === errors;
                                            } else {
                                              var valid18 = true;
                                            }
                                          }
                                        }
                                      } else {
                                        const err62 = {
                                          instancePath: instancePath + "/image",
                                          schemaPath: "AdSpaceModule/properties/image/type",
                                          keyword: "type",
                                          params: {
                                            type: "object"
                                          },
                                          message: "must be object"
                                        };
                                        if (vErrors === null) {
                                          vErrors = [err62];
                                        } else {
                                          vErrors.push(err62);
                                        }
                                        errors++;
                                      }
                                    }
                                    var valid15 = _errs93 === errors;
                                  } else {
                                    var valid15 = true;
                                  }
                                }
                              }
                            }
                          }
                        }
                      }
                    }
                  } else {
                    const err63 = {
                      instancePath,
                      schemaPath: "AdSpaceModule/type",
                      keyword: "type",
                      params: {
                        type: "object"
                      },
                      message: "must be object"
                    };
                    if (vErrors === null) {
                      vErrors = [err63];
                    } else {
                      vErrors.push(err63);
                    }
                    errors++;
                  }
                }
                var _valid0 = _errs72 === errors;
                valid0 = valid0 || _valid0;
                if (!valid0) {
                  const _errs99 = errors;
                  if (!validate16(data, {
                    instancePath,
                    parentData,
                    parentDataProperty,
                    rootData
                  })) {
                    vErrors = vErrors === null ? validate16.errors : vErrors.concat(validate16.errors);
                    errors = vErrors.length;
                  }
                  var _valid0 = _errs99 === errors;
                  valid0 = valid0 || _valid0;
                }
              }
            }
          }
        }
      }
    }
  }
  if (!valid0) {
    const err64 = {
      instancePath,
      schemaPath: "#/anyOf",
      keyword: "anyOf",
      params: {},
      message: "must match a schema in anyOf"
    };
    if (vErrors === null) {
      vErrors = [err64];
    } else {
      vErrors.push(err64);
    }
    errors++;
    validate88.errors = vErrors;
    return false;
  } else {
    errors = _errs0;
    if (vErrors !== null) {
      if (_errs0) {
        vErrors.length = _errs0;
      } else {
        vErrors = null;
      }
    }
  }
  validate88.errors = vErrors;
  return errors === 0;
}
const PageTab = validate94;
function validate94(data, {
  instancePath = "",
  parentData,
  parentDataProperty,
  rootData = data
} = {}) {
  let vErrors = null;
  let errors = 0;
  if (errors === 0) {
    if (data && typeof data == "object" && !Array.isArray(data)) {
      let missing0;
      if (data.condition === void 0 && (missing0 = "condition") || data.name === void 0 && (missing0 = "name") || data.default === void 0 && (missing0 = "default") || data.order === void 0 && (missing0 = "order") || data.modules === void 0 && (missing0 = "modules")) {
        validate94.errors = [{
          instancePath,
          schemaPath: "#/required",
          keyword: "required",
          params: {
            missingProperty: missing0
          },
          message: "must have required property '" + missing0 + "'"
        }];
        return false;
      } else {
        if (data.condition !== void 0) {
          const _errs1 = errors;
          if (data.condition !== null) {
            validate94.errors = [{
              instancePath: instancePath + "/condition",
              schemaPath: "#/properties/condition/type",
              keyword: "type",
              params: {
                type: "null"
              },
              message: "must be null"
            }];
            return false;
          }
          var valid0 = _errs1 === errors;
        } else {
          var valid0 = true;
        }
        if (valid0) {
          if (data.name !== void 0) {
            const _errs3 = errors;
            if (typeof data.name !== "string") {
              validate94.errors = [{
                instancePath: instancePath + "/name",
                schemaPath: "#/properties/name/type",
                keyword: "type",
                params: {
                  type: "string"
                },
                message: "must be string"
              }];
              return false;
            }
            var valid0 = _errs3 === errors;
          } else {
            var valid0 = true;
          }
          if (valid0) {
            if (data.icon !== void 0) {
              const _errs5 = errors;
              if (typeof data.icon !== "string") {
                validate94.errors = [{
                  instancePath: instancePath + "/icon",
                  schemaPath: "#/properties/icon/type",
                  keyword: "type",
                  params: {
                    type: "string"
                  },
                  message: "must be string"
                }];
                return false;
              }
              var valid0 = _errs5 === errors;
            } else {
              var valid0 = true;
            }
            if (valid0) {
              if (data.default !== void 0) {
                const _errs7 = errors;
                if (typeof data.default !== "boolean") {
                  validate94.errors = [{
                    instancePath: instancePath + "/default",
                    schemaPath: "#/properties/default/type",
                    keyword: "type",
                    params: {
                      type: "boolean"
                    },
                    message: "must be boolean"
                  }];
                  return false;
                }
                var valid0 = _errs7 === errors;
              } else {
                var valid0 = true;
              }
              if (valid0) {
                if (data.order !== void 0) {
                  let data4 = data.order;
                  const _errs9 = errors;
                  if (!(typeof data4 == "number" && isFinite(data4))) {
                    validate94.errors = [{
                      instancePath: instancePath + "/order",
                      schemaPath: "#/properties/order/type",
                      keyword: "type",
                      params: {
                        type: "number"
                      },
                      message: "must be number"
                    }];
                    return false;
                  }
                  var valid0 = _errs9 === errors;
                } else {
                  var valid0 = true;
                }
                if (valid0) {
                  if (data.modules !== void 0) {
                    let data5 = data.modules;
                    const _errs11 = errors;
                    if (errors === _errs11) {
                      if (Array.isArray(data5)) {
                        var valid1 = true;
                        const len0 = data5.length;
                        for (let i0 = 0; i0 < len0; i0++) {
                          const _errs13 = errors;
                          if (!validate88(data5[i0], {
                            instancePath: instancePath + "/modules/" + i0,
                            parentData: data5,
                            parentDataProperty: i0,
                            rootData
                          })) {
                            vErrors = vErrors === null ? validate88.errors : vErrors.concat(validate88.errors);
                            errors = vErrors.length;
                          }
                          var valid1 = _errs13 === errors;
                          if (!valid1) {
                            break;
                          }
                        }
                      } else {
                        validate94.errors = [{
                          instancePath: instancePath + "/modules",
                          schemaPath: "#/properties/modules/type",
                          keyword: "type",
                          params: {
                            type: "array"
                          },
                          message: "must be array"
                        }];
                        return false;
                      }
                    }
                    var valid0 = _errs11 === errors;
                  } else {
                    var valid0 = true;
                  }
                }
              }
            }
          }
        }
      }
    } else {
      validate94.errors = [{
        instancePath,
        schemaPath: "#/type",
        keyword: "type",
        params: {
          type: "object"
        },
        message: "must be object"
      }];
      return false;
    }
  }
  validate94.errors = vErrors;
  return errors === 0;
}
const TabbedPageModules = validate96;
function validate96(data, {
  instancePath = "",
  parentData,
  parentDataProperty,
  rootData = data
} = {}) {
  let vErrors = null;
  let errors = 0;
  if (errors === 0) {
    if (data && typeof data == "object" && !Array.isArray(data)) {
      for (const key0 in data) {
        const _errs2 = errors;
        if (!validate94(data[key0], {
          instancePath: instancePath + "/" + key0.replace(/~/g, "~0").replace(/\//g, "~1"),
          parentData: data,
          parentDataProperty: key0,
          rootData
        })) {
          vErrors = vErrors === null ? validate94.errors : vErrors.concat(validate94.errors);
          errors = vErrors.length;
        }
        var valid0 = _errs2 === errors;
        if (!valid0) {
          break;
        }
      }
    } else {
      validate96.errors = [{
        instancePath,
        schemaPath: "#/type",
        keyword: "type",
        params: {
          type: "object"
        },
        message: "must be object"
      }];
      return false;
    }
  }
  validate96.errors = vErrors;
  return errors === 0;
}
const PageModuleList = validate98;
function validate98(data, {
  instancePath = "",
  parentData,
  parentDataProperty,
  rootData = data
} = {}) {
  let vErrors = null;
  let errors = 0;
  if (errors === 0) {
    if (Array.isArray(data)) {
      var valid0 = true;
      const len0 = data.length;
      for (let i0 = 0; i0 < len0; i0++) {
        const _errs1 = errors;
        if (!validate88(data[i0], {
          instancePath: instancePath + "/" + i0,
          parentData: data,
          parentDataProperty: i0,
          rootData
        })) {
          vErrors = vErrors === null ? validate88.errors : vErrors.concat(validate88.errors);
          errors = vErrors.length;
        }
        var valid0 = _errs1 === errors;
        if (!valid0) {
          break;
        }
      }
    } else {
      validate98.errors = [{
        instancePath,
        schemaPath: "#/type",
        keyword: "type",
        params: {
          type: "array"
        },
        message: "must be array"
      }];
      return false;
    }
  }
  validate98.errors = vErrors;
  return errors === 0;
}
const Page = validate100;
const schema108 = {
  "$id": "Page",
  "$schema": "http://json-schema.org/draft-07/schema#",
  "type": "object",
  "properties": {
    "name": {
      "type": "string"
    },
    "brandingOverride": {
      "type": "object",
      "properties": {
        "accentColor": {
          "type": "string"
        },
        "backgroundColor": {
          "type": "string"
        },
        "themeStyle": {
          "type": "string",
          "enum": ["rounded", "hard"]
        },
        "bannerImages": {
          "type": "object",
          "properties": {
            "3/1": {
              "type": "string"
            },
            "3/4": {
              "type": "string"
            },
            "16/9": {
              "type": "string"
            }
          },
          "required": ["3/1", "3/4", "16/9"]
        },
        "logoImage": {
          "type": "string"
        },
        "contactInformation": {
          "type": "object",
          "properties": {
            "socialMediaLinks": {
              "anyOf": [{
                "type": "array",
                "items": {
                  "type": "object",
                  "properties": {
                    "type": {
                      "type": "string"
                    },
                    "url": {
                      "type": "string"
                    }
                  },
                  "required": ["type", "url"]
                }
              }, {
                "type": "null"
              }]
            },
            "contactAddressLines": {
              "anyOf": [{
                "type": "array",
                "items": {
                  "type": "string"
                }
              }, {
                "type": "null"
              }]
            },
            "contactPhone": {
              "type": ["string", "null"]
            },
            "contactEmail": {
              "type": ["string", "null"]
            },
            "streamHelpText": {
              "type": ["string", "null"]
            },
            "supportEmail": {
              "type": ["string", "null"]
            },
            "faqLink": {
              "type": ["string", "null"]
            },
            "copyrightNotice": {
              "type": ["string", "null"]
            },
            "privacyPolicy": {
              "anyOf": [{
                "type": "array",
                "items": {
                  "type": "string"
                }
              }, {
                "type": "null"
              }]
            },
            "logoImage": {
              "type": ["string", "null"]
            }
          },
          "required": ["socialMediaLinks", "contactAddressLines", "contactPhone", "contactEmail", "supportEmail", "copyrightNotice"]
        }
      }
    },
    "status": {
      "type": "string",
      "enum": ["PUBLISHED", "DRAFT"]
    },
    "active": {
      "type": "boolean"
    },
    "header": {
      "$ref": "HeaderModule"
    },
    "modules": {
      "anyOf": [{
        "$ref": "TabbedPageModules"
      }, {
        "$ref": "PageModuleList"
      }]
    },
    "metaTags": {
      "type": "array",
      "items": {
        "type": "object",
        "properties": {
          "property": {
            "type": "string"
          },
          "content": {
            "type": "string"
          }
        },
        "required": ["property", "content"]
      }
    }
  },
  "required": ["name", "status", "active", "modules"],
  "description": "A page models the layout (order, and content) of a browsable entity (eg: a channel page or organization). The page itself should be abstract enough so that it can be used by multiple target devices (mobile/desktop) and applications (web/mobile app/tv app). Pages will be authored using Backoffice and then eventually Studio."
};
function validate100(data, {
  instancePath = "",
  parentData,
  parentDataProperty,
  rootData = data
} = {}) {
  let vErrors = null;
  let errors = 0;
  if (errors === 0) {
    if (data && typeof data == "object" && !Array.isArray(data)) {
      let missing0;
      if (data.name === void 0 && (missing0 = "name") || data.status === void 0 && (missing0 = "status") || data.active === void 0 && (missing0 = "active") || data.modules === void 0 && (missing0 = "modules")) {
        validate100.errors = [{
          instancePath,
          schemaPath: "#/required",
          keyword: "required",
          params: {
            missingProperty: missing0
          },
          message: "must have required property '" + missing0 + "'"
        }];
        return false;
      } else {
        if (data.name !== void 0) {
          const _errs1 = errors;
          if (typeof data.name !== "string") {
            validate100.errors = [{
              instancePath: instancePath + "/name",
              schemaPath: "#/properties/name/type",
              keyword: "type",
              params: {
                type: "string"
              },
              message: "must be string"
            }];
            return false;
          }
          var valid0 = _errs1 === errors;
        } else {
          var valid0 = true;
        }
        if (valid0) {
          if (data.brandingOverride !== void 0) {
            let data1 = data.brandingOverride;
            const _errs3 = errors;
            if (errors === _errs3) {
              if (data1 && typeof data1 == "object" && !Array.isArray(data1)) {
                if (data1.accentColor !== void 0) {
                  const _errs5 = errors;
                  if (typeof data1.accentColor !== "string") {
                    validate100.errors = [{
                      instancePath: instancePath + "/brandingOverride/accentColor",
                      schemaPath: "#/properties/brandingOverride/properties/accentColor/type",
                      keyword: "type",
                      params: {
                        type: "string"
                      },
                      message: "must be string"
                    }];
                    return false;
                  }
                  var valid1 = _errs5 === errors;
                } else {
                  var valid1 = true;
                }
                if (valid1) {
                  if (data1.backgroundColor !== void 0) {
                    const _errs7 = errors;
                    if (typeof data1.backgroundColor !== "string") {
                      validate100.errors = [{
                        instancePath: instancePath + "/brandingOverride/backgroundColor",
                        schemaPath: "#/properties/brandingOverride/properties/backgroundColor/type",
                        keyword: "type",
                        params: {
                          type: "string"
                        },
                        message: "must be string"
                      }];
                      return false;
                    }
                    var valid1 = _errs7 === errors;
                  } else {
                    var valid1 = true;
                  }
                  if (valid1) {
                    if (data1.themeStyle !== void 0) {
                      let data4 = data1.themeStyle;
                      const _errs9 = errors;
                      if (typeof data4 !== "string") {
                        validate100.errors = [{
                          instancePath: instancePath + "/brandingOverride/themeStyle",
                          schemaPath: "#/properties/brandingOverride/properties/themeStyle/type",
                          keyword: "type",
                          params: {
                            type: "string"
                          },
                          message: "must be string"
                        }];
                        return false;
                      }
                      if (!(data4 === "rounded" || data4 === "hard")) {
                        validate100.errors = [{
                          instancePath: instancePath + "/brandingOverride/themeStyle",
                          schemaPath: "#/properties/brandingOverride/properties/themeStyle/enum",
                          keyword: "enum",
                          params: {
                            allowedValues: schema108.properties.brandingOverride.properties.themeStyle.enum
                          },
                          message: "must be equal to one of the allowed values"
                        }];
                        return false;
                      }
                      var valid1 = _errs9 === errors;
                    } else {
                      var valid1 = true;
                    }
                    if (valid1) {
                      if (data1.bannerImages !== void 0) {
                        let data5 = data1.bannerImages;
                        const _errs11 = errors;
                        if (errors === _errs11) {
                          if (data5 && typeof data5 == "object" && !Array.isArray(data5)) {
                            let missing1;
                            if (data5["3/1"] === void 0 && (missing1 = "3/1") || data5["3/4"] === void 0 && (missing1 = "3/4") || data5["16/9"] === void 0 && (missing1 = "16/9")) {
                              validate100.errors = [{
                                instancePath: instancePath + "/brandingOverride/bannerImages",
                                schemaPath: "#/properties/brandingOverride/properties/bannerImages/required",
                                keyword: "required",
                                params: {
                                  missingProperty: missing1
                                },
                                message: "must have required property '" + missing1 + "'"
                              }];
                              return false;
                            } else {
                              if (data5["3/1"] !== void 0) {
                                const _errs13 = errors;
                                if (typeof data5["3/1"] !== "string") {
                                  validate100.errors = [{
                                    instancePath: instancePath + "/brandingOverride/bannerImages/3~11",
                                    schemaPath: "#/properties/brandingOverride/properties/bannerImages/properties/3~11/type",
                                    keyword: "type",
                                    params: {
                                      type: "string"
                                    },
                                    message: "must be string"
                                  }];
                                  return false;
                                }
                                var valid2 = _errs13 === errors;
                              } else {
                                var valid2 = true;
                              }
                              if (valid2) {
                                if (data5["3/4"] !== void 0) {
                                  const _errs15 = errors;
                                  if (typeof data5["3/4"] !== "string") {
                                    validate100.errors = [{
                                      instancePath: instancePath + "/brandingOverride/bannerImages/3~14",
                                      schemaPath: "#/properties/brandingOverride/properties/bannerImages/properties/3~14/type",
                                      keyword: "type",
                                      params: {
                                        type: "string"
                                      },
                                      message: "must be string"
                                    }];
                                    return false;
                                  }
                                  var valid2 = _errs15 === errors;
                                } else {
                                  var valid2 = true;
                                }
                                if (valid2) {
                                  if (data5["16/9"] !== void 0) {
                                    const _errs17 = errors;
                                    if (typeof data5["16/9"] !== "string") {
                                      validate100.errors = [{
                                        instancePath: instancePath + "/brandingOverride/bannerImages/16~19",
                                        schemaPath: "#/properties/brandingOverride/properties/bannerImages/properties/16~19/type",
                                        keyword: "type",
                                        params: {
                                          type: "string"
                                        },
                                        message: "must be string"
                                      }];
                                      return false;
                                    }
                                    var valid2 = _errs17 === errors;
                                  } else {
                                    var valid2 = true;
                                  }
                                }
                              }
                            }
                          } else {
                            validate100.errors = [{
                              instancePath: instancePath + "/brandingOverride/bannerImages",
                              schemaPath: "#/properties/brandingOverride/properties/bannerImages/type",
                              keyword: "type",
                              params: {
                                type: "object"
                              },
                              message: "must be object"
                            }];
                            return false;
                          }
                        }
                        var valid1 = _errs11 === errors;
                      } else {
                        var valid1 = true;
                      }
                      if (valid1) {
                        if (data1.logoImage !== void 0) {
                          const _errs19 = errors;
                          if (typeof data1.logoImage !== "string") {
                            validate100.errors = [{
                              instancePath: instancePath + "/brandingOverride/logoImage",
                              schemaPath: "#/properties/brandingOverride/properties/logoImage/type",
                              keyword: "type",
                              params: {
                                type: "string"
                              },
                              message: "must be string"
                            }];
                            return false;
                          }
                          var valid1 = _errs19 === errors;
                        } else {
                          var valid1 = true;
                        }
                        if (valid1) {
                          if (data1.contactInformation !== void 0) {
                            let data10 = data1.contactInformation;
                            const _errs21 = errors;
                            if (errors === _errs21) {
                              if (data10 && typeof data10 == "object" && !Array.isArray(data10)) {
                                let missing2;
                                if (data10.socialMediaLinks === void 0 && (missing2 = "socialMediaLinks") || data10.contactAddressLines === void 0 && (missing2 = "contactAddressLines") || data10.contactPhone === void 0 && (missing2 = "contactPhone") || data10.contactEmail === void 0 && (missing2 = "contactEmail") || data10.supportEmail === void 0 && (missing2 = "supportEmail") || data10.copyrightNotice === void 0 && (missing2 = "copyrightNotice")) {
                                  validate100.errors = [{
                                    instancePath: instancePath + "/brandingOverride/contactInformation",
                                    schemaPath: "#/properties/brandingOverride/properties/contactInformation/required",
                                    keyword: "required",
                                    params: {
                                      missingProperty: missing2
                                    },
                                    message: "must have required property '" + missing2 + "'"
                                  }];
                                  return false;
                                } else {
                                  if (data10.socialMediaLinks !== void 0) {
                                    let data11 = data10.socialMediaLinks;
                                    const _errs23 = errors;
                                    const _errs24 = errors;
                                    let valid4 = false;
                                    const _errs25 = errors;
                                    if (errors === _errs25) {
                                      if (Array.isArray(data11)) {
                                        var valid5 = true;
                                        const len0 = data11.length;
                                        for (let i0 = 0; i0 < len0; i0++) {
                                          let data12 = data11[i0];
                                          const _errs27 = errors;
                                          if (errors === _errs27) {
                                            if (data12 && typeof data12 == "object" && !Array.isArray(data12)) {
                                              let missing3;
                                              if (data12.type === void 0 && (missing3 = "type") || data12.url === void 0 && (missing3 = "url")) {
                                                const err0 = {
                                                  instancePath: instancePath + "/brandingOverride/contactInformation/socialMediaLinks/" + i0,
                                                  schemaPath: "#/properties/brandingOverride/properties/contactInformation/properties/socialMediaLinks/anyOf/0/items/required",
                                                  keyword: "required",
                                                  params: {
                                                    missingProperty: missing3
                                                  },
                                                  message: "must have required property '" + missing3 + "'"
                                                };
                                                if (vErrors === null) {
                                                  vErrors = [err0];
                                                } else {
                                                  vErrors.push(err0);
                                                }
                                                errors++;
                                              } else {
                                                if (data12.type !== void 0) {
                                                  const _errs29 = errors;
                                                  if (typeof data12.type !== "string") {
                                                    const err1 = {
                                                      instancePath: instancePath + "/brandingOverride/contactInformation/socialMediaLinks/" + i0 + "/type",
                                                      schemaPath: "#/properties/brandingOverride/properties/contactInformation/properties/socialMediaLinks/anyOf/0/items/properties/type/type",
                                                      keyword: "type",
                                                      params: {
                                                        type: "string"
                                                      },
                                                      message: "must be string"
                                                    };
                                                    if (vErrors === null) {
                                                      vErrors = [err1];
                                                    } else {
                                                      vErrors.push(err1);
                                                    }
                                                    errors++;
                                                  }
                                                  var valid6 = _errs29 === errors;
                                                } else {
                                                  var valid6 = true;
                                                }
                                                if (valid6) {
                                                  if (data12.url !== void 0) {
                                                    const _errs31 = errors;
                                                    if (typeof data12.url !== "string") {
                                                      const err2 = {
                                                        instancePath: instancePath + "/brandingOverride/contactInformation/socialMediaLinks/" + i0 + "/url",
                                                        schemaPath: "#/properties/brandingOverride/properties/contactInformation/properties/socialMediaLinks/anyOf/0/items/properties/url/type",
                                                        keyword: "type",
                                                        params: {
                                                          type: "string"
                                                        },
                                                        message: "must be string"
                                                      };
                                                      if (vErrors === null) {
                                                        vErrors = [err2];
                                                      } else {
                                                        vErrors.push(err2);
                                                      }
                                                      errors++;
                                                    }
                                                    var valid6 = _errs31 === errors;
                                                  } else {
                                                    var valid6 = true;
                                                  }
                                                }
                                              }
                                            } else {
                                              const err3 = {
                                                instancePath: instancePath + "/brandingOverride/contactInformation/socialMediaLinks/" + i0,
                                                schemaPath: "#/properties/brandingOverride/properties/contactInformation/properties/socialMediaLinks/anyOf/0/items/type",
                                                keyword: "type",
                                                params: {
                                                  type: "object"
                                                },
                                                message: "must be object"
                                              };
                                              if (vErrors === null) {
                                                vErrors = [err3];
                                              } else {
                                                vErrors.push(err3);
                                              }
                                              errors++;
                                            }
                                          }
                                          var valid5 = _errs27 === errors;
                                          if (!valid5) {
                                            break;
                                          }
                                        }
                                      } else {
                                        const err4 = {
                                          instancePath: instancePath + "/brandingOverride/contactInformation/socialMediaLinks",
                                          schemaPath: "#/properties/brandingOverride/properties/contactInformation/properties/socialMediaLinks/anyOf/0/type",
                                          keyword: "type",
                                          params: {
                                            type: "array"
                                          },
                                          message: "must be array"
                                        };
                                        if (vErrors === null) {
                                          vErrors = [err4];
                                        } else {
                                          vErrors.push(err4);
                                        }
                                        errors++;
                                      }
                                    }
                                    var _valid0 = _errs25 === errors;
                                    valid4 = valid4 || _valid0;
                                    if (!valid4) {
                                      const _errs33 = errors;
                                      if (data11 !== null) {
                                        const err5 = {
                                          instancePath: instancePath + "/brandingOverride/contactInformation/socialMediaLinks",
                                          schemaPath: "#/properties/brandingOverride/properties/contactInformation/properties/socialMediaLinks/anyOf/1/type",
                                          keyword: "type",
                                          params: {
                                            type: "null"
                                          },
                                          message: "must be null"
                                        };
                                        if (vErrors === null) {
                                          vErrors = [err5];
                                        } else {
                                          vErrors.push(err5);
                                        }
                                        errors++;
                                      }
                                      var _valid0 = _errs33 === errors;
                                      valid4 = valid4 || _valid0;
                                    }
                                    if (!valid4) {
                                      const err6 = {
                                        instancePath: instancePath + "/brandingOverride/contactInformation/socialMediaLinks",
                                        schemaPath: "#/properties/brandingOverride/properties/contactInformation/properties/socialMediaLinks/anyOf",
                                        keyword: "anyOf",
                                        params: {},
                                        message: "must match a schema in anyOf"
                                      };
                                      if (vErrors === null) {
                                        vErrors = [err6];
                                      } else {
                                        vErrors.push(err6);
                                      }
                                      errors++;
                                      validate100.errors = vErrors;
                                      return false;
                                    } else {
                                      errors = _errs24;
                                      if (vErrors !== null) {
                                        if (_errs24) {
                                          vErrors.length = _errs24;
                                        } else {
                                          vErrors = null;
                                        }
                                      }
                                    }
                                    var valid3 = _errs23 === errors;
                                  } else {
                                    var valid3 = true;
                                  }
                                  if (valid3) {
                                    if (data10.contactAddressLines !== void 0) {
                                      let data15 = data10.contactAddressLines;
                                      const _errs35 = errors;
                                      const _errs36 = errors;
                                      let valid7 = false;
                                      const _errs37 = errors;
                                      if (errors === _errs37) {
                                        if (Array.isArray(data15)) {
                                          var valid8 = true;
                                          const len1 = data15.length;
                                          for (let i1 = 0; i1 < len1; i1++) {
                                            const _errs39 = errors;
                                            if (typeof data15[i1] !== "string") {
                                              const err7 = {
                                                instancePath: instancePath + "/brandingOverride/contactInformation/contactAddressLines/" + i1,
                                                schemaPath: "#/properties/brandingOverride/properties/contactInformation/properties/contactAddressLines/anyOf/0/items/type",
                                                keyword: "type",
                                                params: {
                                                  type: "string"
                                                },
                                                message: "must be string"
                                              };
                                              if (vErrors === null) {
                                                vErrors = [err7];
                                              } else {
                                                vErrors.push(err7);
                                              }
                                              errors++;
                                            }
                                            var valid8 = _errs39 === errors;
                                            if (!valid8) {
                                              break;
                                            }
                                          }
                                        } else {
                                          const err8 = {
                                            instancePath: instancePath + "/brandingOverride/contactInformation/contactAddressLines",
                                            schemaPath: "#/properties/brandingOverride/properties/contactInformation/properties/contactAddressLines/anyOf/0/type",
                                            keyword: "type",
                                            params: {
                                              type: "array"
                                            },
                                            message: "must be array"
                                          };
                                          if (vErrors === null) {
                                            vErrors = [err8];
                                          } else {
                                            vErrors.push(err8);
                                          }
                                          errors++;
                                        }
                                      }
                                      var _valid1 = _errs37 === errors;
                                      valid7 = valid7 || _valid1;
                                      if (!valid7) {
                                        const _errs41 = errors;
                                        if (data15 !== null) {
                                          const err9 = {
                                            instancePath: instancePath + "/brandingOverride/contactInformation/contactAddressLines",
                                            schemaPath: "#/properties/brandingOverride/properties/contactInformation/properties/contactAddressLines/anyOf/1/type",
                                            keyword: "type",
                                            params: {
                                              type: "null"
                                            },
                                            message: "must be null"
                                          };
                                          if (vErrors === null) {
                                            vErrors = [err9];
                                          } else {
                                            vErrors.push(err9);
                                          }
                                          errors++;
                                        }
                                        var _valid1 = _errs41 === errors;
                                        valid7 = valid7 || _valid1;
                                      }
                                      if (!valid7) {
                                        const err10 = {
                                          instancePath: instancePath + "/brandingOverride/contactInformation/contactAddressLines",
                                          schemaPath: "#/properties/brandingOverride/properties/contactInformation/properties/contactAddressLines/anyOf",
                                          keyword: "anyOf",
                                          params: {},
                                          message: "must match a schema in anyOf"
                                        };
                                        if (vErrors === null) {
                                          vErrors = [err10];
                                        } else {
                                          vErrors.push(err10);
                                        }
                                        errors++;
                                        validate100.errors = vErrors;
                                        return false;
                                      } else {
                                        errors = _errs36;
                                        if (vErrors !== null) {
                                          if (_errs36) {
                                            vErrors.length = _errs36;
                                          } else {
                                            vErrors = null;
                                          }
                                        }
                                      }
                                      var valid3 = _errs35 === errors;
                                    } else {
                                      var valid3 = true;
                                    }
                                    if (valid3) {
                                      if (data10.contactPhone !== void 0) {
                                        let data17 = data10.contactPhone;
                                        const _errs43 = errors;
                                        if (typeof data17 !== "string" && data17 !== null) {
                                          validate100.errors = [{
                                            instancePath: instancePath + "/brandingOverride/contactInformation/contactPhone",
                                            schemaPath: "#/properties/brandingOverride/properties/contactInformation/properties/contactPhone/type",
                                            keyword: "type",
                                            params: {
                                              type: schema108.properties.brandingOverride.properties.contactInformation.properties.contactPhone.type
                                            },
                                            message: "must be string,null"
                                          }];
                                          return false;
                                        }
                                        var valid3 = _errs43 === errors;
                                      } else {
                                        var valid3 = true;
                                      }
                                      if (valid3) {
                                        if (data10.contactEmail !== void 0) {
                                          let data18 = data10.contactEmail;
                                          const _errs45 = errors;
                                          if (typeof data18 !== "string" && data18 !== null) {
                                            validate100.errors = [{
                                              instancePath: instancePath + "/brandingOverride/contactInformation/contactEmail",
                                              schemaPath: "#/properties/brandingOverride/properties/contactInformation/properties/contactEmail/type",
                                              keyword: "type",
                                              params: {
                                                type: schema108.properties.brandingOverride.properties.contactInformation.properties.contactEmail.type
                                              },
                                              message: "must be string,null"
                                            }];
                                            return false;
                                          }
                                          var valid3 = _errs45 === errors;
                                        } else {
                                          var valid3 = true;
                                        }
                                        if (valid3) {
                                          if (data10.streamHelpText !== void 0) {
                                            let data19 = data10.streamHelpText;
                                            const _errs47 = errors;
                                            if (typeof data19 !== "string" && data19 !== null) {
                                              validate100.errors = [{
                                                instancePath: instancePath + "/brandingOverride/contactInformation/streamHelpText",
                                                schemaPath: "#/properties/brandingOverride/properties/contactInformation/properties/streamHelpText/type",
                                                keyword: "type",
                                                params: {
                                                  type: schema108.properties.brandingOverride.properties.contactInformation.properties.streamHelpText.type
                                                },
                                                message: "must be string,null"
                                              }];
                                              return false;
                                            }
                                            var valid3 = _errs47 === errors;
                                          } else {
                                            var valid3 = true;
                                          }
                                          if (valid3) {
                                            if (data10.supportEmail !== void 0) {
                                              let data20 = data10.supportEmail;
                                              const _errs49 = errors;
                                              if (typeof data20 !== "string" && data20 !== null) {
                                                validate100.errors = [{
                                                  instancePath: instancePath + "/brandingOverride/contactInformation/supportEmail",
                                                  schemaPath: "#/properties/brandingOverride/properties/contactInformation/properties/supportEmail/type",
                                                  keyword: "type",
                                                  params: {
                                                    type: schema108.properties.brandingOverride.properties.contactInformation.properties.supportEmail.type
                                                  },
                                                  message: "must be string,null"
                                                }];
                                                return false;
                                              }
                                              var valid3 = _errs49 === errors;
                                            } else {
                                              var valid3 = true;
                                            }
                                            if (valid3) {
                                              if (data10.faqLink !== void 0) {
                                                let data21 = data10.faqLink;
                                                const _errs51 = errors;
                                                if (typeof data21 !== "string" && data21 !== null) {
                                                  validate100.errors = [{
                                                    instancePath: instancePath + "/brandingOverride/contactInformation/faqLink",
                                                    schemaPath: "#/properties/brandingOverride/properties/contactInformation/properties/faqLink/type",
                                                    keyword: "type",
                                                    params: {
                                                      type: schema108.properties.brandingOverride.properties.contactInformation.properties.faqLink.type
                                                    },
                                                    message: "must be string,null"
                                                  }];
                                                  return false;
                                                }
                                                var valid3 = _errs51 === errors;
                                              } else {
                                                var valid3 = true;
                                              }
                                              if (valid3) {
                                                if (data10.copyrightNotice !== void 0) {
                                                  let data22 = data10.copyrightNotice;
                                                  const _errs53 = errors;
                                                  if (typeof data22 !== "string" && data22 !== null) {
                                                    validate100.errors = [{
                                                      instancePath: instancePath + "/brandingOverride/contactInformation/copyrightNotice",
                                                      schemaPath: "#/properties/brandingOverride/properties/contactInformation/properties/copyrightNotice/type",
                                                      keyword: "type",
                                                      params: {
                                                        type: schema108.properties.brandingOverride.properties.contactInformation.properties.copyrightNotice.type
                                                      },
                                                      message: "must be string,null"
                                                    }];
                                                    return false;
                                                  }
                                                  var valid3 = _errs53 === errors;
                                                } else {
                                                  var valid3 = true;
                                                }
                                                if (valid3) {
                                                  if (data10.privacyPolicy !== void 0) {
                                                    let data23 = data10.privacyPolicy;
                                                    const _errs55 = errors;
                                                    const _errs56 = errors;
                                                    let valid9 = false;
                                                    const _errs57 = errors;
                                                    if (errors === _errs57) {
                                                      if (Array.isArray(data23)) {
                                                        var valid10 = true;
                                                        const len2 = data23.length;
                                                        for (let i2 = 0; i2 < len2; i2++) {
                                                          const _errs59 = errors;
                                                          if (typeof data23[i2] !== "string") {
                                                            const err11 = {
                                                              instancePath: instancePath + "/brandingOverride/contactInformation/privacyPolicy/" + i2,
                                                              schemaPath: "#/properties/brandingOverride/properties/contactInformation/properties/privacyPolicy/anyOf/0/items/type",
                                                              keyword: "type",
                                                              params: {
                                                                type: "string"
                                                              },
                                                              message: "must be string"
                                                            };
                                                            if (vErrors === null) {
                                                              vErrors = [err11];
                                                            } else {
                                                              vErrors.push(err11);
                                                            }
                                                            errors++;
                                                          }
                                                          var valid10 = _errs59 === errors;
                                                          if (!valid10) {
                                                            break;
                                                          }
                                                        }
                                                      } else {
                                                        const err12 = {
                                                          instancePath: instancePath + "/brandingOverride/contactInformation/privacyPolicy",
                                                          schemaPath: "#/properties/brandingOverride/properties/contactInformation/properties/privacyPolicy/anyOf/0/type",
                                                          keyword: "type",
                                                          params: {
                                                            type: "array"
                                                          },
                                                          message: "must be array"
                                                        };
                                                        if (vErrors === null) {
                                                          vErrors = [err12];
                                                        } else {
                                                          vErrors.push(err12);
                                                        }
                                                        errors++;
                                                      }
                                                    }
                                                    var _valid2 = _errs57 === errors;
                                                    valid9 = valid9 || _valid2;
                                                    if (!valid9) {
                                                      const _errs61 = errors;
                                                      if (data23 !== null) {
                                                        const err13 = {
                                                          instancePath: instancePath + "/brandingOverride/contactInformation/privacyPolicy",
                                                          schemaPath: "#/properties/brandingOverride/properties/contactInformation/properties/privacyPolicy/anyOf/1/type",
                                                          keyword: "type",
                                                          params: {
                                                            type: "null"
                                                          },
                                                          message: "must be null"
                                                        };
                                                        if (vErrors === null) {
                                                          vErrors = [err13];
                                                        } else {
                                                          vErrors.push(err13);
                                                        }
                                                        errors++;
                                                      }
                                                      var _valid2 = _errs61 === errors;
                                                      valid9 = valid9 || _valid2;
                                                    }
                                                    if (!valid9) {
                                                      const err14 = {
                                                        instancePath: instancePath + "/brandingOverride/contactInformation/privacyPolicy",
                                                        schemaPath: "#/properties/brandingOverride/properties/contactInformation/properties/privacyPolicy/anyOf",
                                                        keyword: "anyOf",
                                                        params: {},
                                                        message: "must match a schema in anyOf"
                                                      };
                                                      if (vErrors === null) {
                                                        vErrors = [err14];
                                                      } else {
                                                        vErrors.push(err14);
                                                      }
                                                      errors++;
                                                      validate100.errors = vErrors;
                                                      return false;
                                                    } else {
                                                      errors = _errs56;
                                                      if (vErrors !== null) {
                                                        if (_errs56) {
                                                          vErrors.length = _errs56;
                                                        } else {
                                                          vErrors = null;
                                                        }
                                                      }
                                                    }
                                                    var valid3 = _errs55 === errors;
                                                  } else {
                                                    var valid3 = true;
                                                  }
                                                  if (valid3) {
                                                    if (data10.logoImage !== void 0) {
                                                      let data25 = data10.logoImage;
                                                      const _errs63 = errors;
                                                      if (typeof data25 !== "string" && data25 !== null) {
                                                        validate100.errors = [{
                                                          instancePath: instancePath + "/brandingOverride/contactInformation/logoImage",
                                                          schemaPath: "#/properties/brandingOverride/properties/contactInformation/properties/logoImage/type",
                                                          keyword: "type",
                                                          params: {
                                                            type: schema108.properties.brandingOverride.properties.contactInformation.properties.logoImage.type
                                                          },
                                                          message: "must be string,null"
                                                        }];
                                                        return false;
                                                      }
                                                      var valid3 = _errs63 === errors;
                                                    } else {
                                                      var valid3 = true;
                                                    }
                                                  }
                                                }
                                              }
                                            }
                                          }
                                        }
                                      }
                                    }
                                  }
                                }
                              } else {
                                validate100.errors = [{
                                  instancePath: instancePath + "/brandingOverride/contactInformation",
                                  schemaPath: "#/properties/brandingOverride/properties/contactInformation/type",
                                  keyword: "type",
                                  params: {
                                    type: "object"
                                  },
                                  message: "must be object"
                                }];
                                return false;
                              }
                            }
                            var valid1 = _errs21 === errors;
                          } else {
                            var valid1 = true;
                          }
                        }
                      }
                    }
                  }
                }
              } else {
                validate100.errors = [{
                  instancePath: instancePath + "/brandingOverride",
                  schemaPath: "#/properties/brandingOverride/type",
                  keyword: "type",
                  params: {
                    type: "object"
                  },
                  message: "must be object"
                }];
                return false;
              }
            }
            var valid0 = _errs3 === errors;
          } else {
            var valid0 = true;
          }
          if (valid0) {
            if (data.status !== void 0) {
              let data26 = data.status;
              const _errs65 = errors;
              if (typeof data26 !== "string") {
                validate100.errors = [{
                  instancePath: instancePath + "/status",
                  schemaPath: "#/properties/status/type",
                  keyword: "type",
                  params: {
                    type: "string"
                  },
                  message: "must be string"
                }];
                return false;
              }
              if (!(data26 === "PUBLISHED" || data26 === "DRAFT")) {
                validate100.errors = [{
                  instancePath: instancePath + "/status",
                  schemaPath: "#/properties/status/enum",
                  keyword: "enum",
                  params: {
                    allowedValues: schema108.properties.status.enum
                  },
                  message: "must be equal to one of the allowed values"
                }];
                return false;
              }
              var valid0 = _errs65 === errors;
            } else {
              var valid0 = true;
            }
            if (valid0) {
              if (data.active !== void 0) {
                const _errs67 = errors;
                if (typeof data.active !== "boolean") {
                  validate100.errors = [{
                    instancePath: instancePath + "/active",
                    schemaPath: "#/properties/active/type",
                    keyword: "type",
                    params: {
                      type: "boolean"
                    },
                    message: "must be boolean"
                  }];
                  return false;
                }
                var valid0 = _errs67 === errors;
              } else {
                var valid0 = true;
              }
              if (valid0) {
                if (data.header !== void 0) {
                  const _errs69 = errors;
                  if (!validate61(data.header, {
                    instancePath: instancePath + "/header",
                    parentData: data,
                    parentDataProperty: "header",
                    rootData
                  })) {
                    vErrors = vErrors === null ? validate61.errors : vErrors.concat(validate61.errors);
                    errors = vErrors.length;
                  }
                  var valid0 = _errs69 === errors;
                } else {
                  var valid0 = true;
                }
                if (valid0) {
                  if (data.modules !== void 0) {
                    let data29 = data.modules;
                    const _errs70 = errors;
                    const _errs71 = errors;
                    let valid11 = false;
                    const _errs72 = errors;
                    if (!validate96(data29, {
                      instancePath: instancePath + "/modules",
                      parentData: data,
                      parentDataProperty: "modules",
                      rootData
                    })) {
                      vErrors = vErrors === null ? validate96.errors : vErrors.concat(validate96.errors);
                      errors = vErrors.length;
                    }
                    var _valid3 = _errs72 === errors;
                    valid11 = valid11 || _valid3;
                    if (!valid11) {
                      const _errs73 = errors;
                      if (!validate98(data29, {
                        instancePath: instancePath + "/modules",
                        parentData: data,
                        parentDataProperty: "modules",
                        rootData
                      })) {
                        vErrors = vErrors === null ? validate98.errors : vErrors.concat(validate98.errors);
                        errors = vErrors.length;
                      }
                      var _valid3 = _errs73 === errors;
                      valid11 = valid11 || _valid3;
                    }
                    if (!valid11) {
                      const err15 = {
                        instancePath: instancePath + "/modules",
                        schemaPath: "#/properties/modules/anyOf",
                        keyword: "anyOf",
                        params: {},
                        message: "must match a schema in anyOf"
                      };
                      if (vErrors === null) {
                        vErrors = [err15];
                      } else {
                        vErrors.push(err15);
                      }
                      errors++;
                      validate100.errors = vErrors;
                      return false;
                    } else {
                      errors = _errs71;
                      if (vErrors !== null) {
                        if (_errs71) {
                          vErrors.length = _errs71;
                        } else {
                          vErrors = null;
                        }
                      }
                    }
                    var valid0 = _errs70 === errors;
                  } else {
                    var valid0 = true;
                  }
                  if (valid0) {
                    if (data.metaTags !== void 0) {
                      let data30 = data.metaTags;
                      const _errs74 = errors;
                      if (errors === _errs74) {
                        if (Array.isArray(data30)) {
                          var valid12 = true;
                          const len3 = data30.length;
                          for (let i3 = 0; i3 < len3; i3++) {
                            let data31 = data30[i3];
                            const _errs76 = errors;
                            if (errors === _errs76) {
                              if (data31 && typeof data31 == "object" && !Array.isArray(data31)) {
                                let missing4;
                                if (data31.property === void 0 && (missing4 = "property") || data31.content === void 0 && (missing4 = "content")) {
                                  validate100.errors = [{
                                    instancePath: instancePath + "/metaTags/" + i3,
                                    schemaPath: "#/properties/metaTags/items/required",
                                    keyword: "required",
                                    params: {
                                      missingProperty: missing4
                                    },
                                    message: "must have required property '" + missing4 + "'"
                                  }];
                                  return false;
                                } else {
                                  if (data31.property !== void 0) {
                                    const _errs78 = errors;
                                    if (typeof data31.property !== "string") {
                                      validate100.errors = [{
                                        instancePath: instancePath + "/metaTags/" + i3 + "/property",
                                        schemaPath: "#/properties/metaTags/items/properties/property/type",
                                        keyword: "type",
                                        params: {
                                          type: "string"
                                        },
                                        message: "must be string"
                                      }];
                                      return false;
                                    }
                                    var valid13 = _errs78 === errors;
                                  } else {
                                    var valid13 = true;
                                  }
                                  if (valid13) {
                                    if (data31.content !== void 0) {
                                      const _errs80 = errors;
                                      if (typeof data31.content !== "string") {
                                        validate100.errors = [{
                                          instancePath: instancePath + "/metaTags/" + i3 + "/content",
                                          schemaPath: "#/properties/metaTags/items/properties/content/type",
                                          keyword: "type",
                                          params: {
                                            type: "string"
                                          },
                                          message: "must be string"
                                        }];
                                        return false;
                                      }
                                      var valid13 = _errs80 === errors;
                                    } else {
                                      var valid13 = true;
                                    }
                                  }
                                }
                              } else {
                                validate100.errors = [{
                                  instancePath: instancePath + "/metaTags/" + i3,
                                  schemaPath: "#/properties/metaTags/items/type",
                                  keyword: "type",
                                  params: {
                                    type: "object"
                                  },
                                  message: "must be object"
                                }];
                                return false;
                              }
                            }
                            var valid12 = _errs76 === errors;
                            if (!valid12) {
                              break;
                            }
                          }
                        } else {
                          validate100.errors = [{
                            instancePath: instancePath + "/metaTags",
                            schemaPath: "#/properties/metaTags/type",
                            keyword: "type",
                            params: {
                              type: "array"
                            },
                            message: "must be array"
                          }];
                          return false;
                        }
                      }
                      var valid0 = _errs74 === errors;
                    } else {
                      var valid0 = true;
                    }
                  }
                }
              }
            }
          }
        }
      }
    } else {
      validate100.errors = [{
        instancePath,
        schemaPath: "#/type",
        keyword: "type",
        params: {
          type: "object"
        },
        message: "must be object"
      }];
      return false;
    }
  }
  validate100.errors = vErrors;
  return errors === 0;
}
const NamedTagType = validate104;
const schema109 = {
  "$id": "NamedTagType",
  "$schema": "http://json-schema.org/draft-07/schema#",
  "type": "string",
  "enum": ["EVENT", "ATHLETE", "PLACE", "TOURNAMENT", "TEAM", "SEASON"]
};
function validate104(data, {
  instancePath = "",
  parentData,
  parentDataProperty,
  rootData = data
} = {}) {
  let vErrors = null;
  let errors = 0;
  if (typeof data !== "string") {
    validate104.errors = [{
      instancePath,
      schemaPath: "#/type",
      keyword: "type",
      params: {
        type: "string"
      },
      message: "must be string"
    }];
    return false;
  }
  if (!(data === "EVENT" || data === "ATHLETE" || data === "PLACE" || data === "TOURNAMENT" || data === "TEAM" || data === "SEASON")) {
    validate104.errors = [{
      instancePath,
      schemaPath: "#/enum",
      keyword: "enum",
      params: {
        allowedValues: schema109.enum
      },
      message: "must be equal to one of the allowed values"
    }];
    return false;
  }
  validate104.errors = vErrors;
  return errors === 0;
}
const NamedTag = validate105;
const schema110 = {
  "$id": "NamedTag",
  "$schema": "http://json-schema.org/draft-07/schema#",
  "type": "object",
  "properties": {
    "name": {
      "type": "string"
    },
    "displayName": {
      "type": ["string", "null"]
    },
    "description": {
      "type": "string"
    },
    "logo": {
      "type": "string"
    },
    "cover": {
      "type": ["string", "null"]
    },
    "url": {
      "type": "string"
    },
    "type": {
      "$ref": "NamedTagType"
    },
    "pages": {
      "anyOf": [{
        "type": "array",
        "items": {
          "$ref": "Page"
        }
      }, {
        "type": "null"
      }]
    },
    "metaData": {
      "type": "array",
      "items": {
        "type": "object",
        "properties": {
          "property": {
            "type": "string"
          },
          "content": {
            "type": "string"
          }
        },
        "required": ["property", "content"]
      }
    }
  },
  "required": ["name", "displayName", "description", "logo", "cover", "url", "type", "pages", "metaData"],
  "description": "Named tags add context and information to specific tags."
};
function validate105(data, {
  instancePath = "",
  parentData,
  parentDataProperty,
  rootData = data
} = {}) {
  let vErrors = null;
  let errors = 0;
  if (errors === 0) {
    if (data && typeof data == "object" && !Array.isArray(data)) {
      let missing0;
      if (data.name === void 0 && (missing0 = "name") || data.displayName === void 0 && (missing0 = "displayName") || data.description === void 0 && (missing0 = "description") || data.logo === void 0 && (missing0 = "logo") || data.cover === void 0 && (missing0 = "cover") || data.url === void 0 && (missing0 = "url") || data.type === void 0 && (missing0 = "type") || data.pages === void 0 && (missing0 = "pages") || data.metaData === void 0 && (missing0 = "metaData")) {
        validate105.errors = [{
          instancePath,
          schemaPath: "#/required",
          keyword: "required",
          params: {
            missingProperty: missing0
          },
          message: "must have required property '" + missing0 + "'"
        }];
        return false;
      } else {
        if (data.name !== void 0) {
          const _errs1 = errors;
          if (typeof data.name !== "string") {
            validate105.errors = [{
              instancePath: instancePath + "/name",
              schemaPath: "#/properties/name/type",
              keyword: "type",
              params: {
                type: "string"
              },
              message: "must be string"
            }];
            return false;
          }
          var valid0 = _errs1 === errors;
        } else {
          var valid0 = true;
        }
        if (valid0) {
          if (data.displayName !== void 0) {
            let data1 = data.displayName;
            const _errs3 = errors;
            if (typeof data1 !== "string" && data1 !== null) {
              validate105.errors = [{
                instancePath: instancePath + "/displayName",
                schemaPath: "#/properties/displayName/type",
                keyword: "type",
                params: {
                  type: schema110.properties.displayName.type
                },
                message: "must be string,null"
              }];
              return false;
            }
            var valid0 = _errs3 === errors;
          } else {
            var valid0 = true;
          }
          if (valid0) {
            if (data.description !== void 0) {
              const _errs5 = errors;
              if (typeof data.description !== "string") {
                validate105.errors = [{
                  instancePath: instancePath + "/description",
                  schemaPath: "#/properties/description/type",
                  keyword: "type",
                  params: {
                    type: "string"
                  },
                  message: "must be string"
                }];
                return false;
              }
              var valid0 = _errs5 === errors;
            } else {
              var valid0 = true;
            }
            if (valid0) {
              if (data.logo !== void 0) {
                const _errs7 = errors;
                if (typeof data.logo !== "string") {
                  validate105.errors = [{
                    instancePath: instancePath + "/logo",
                    schemaPath: "#/properties/logo/type",
                    keyword: "type",
                    params: {
                      type: "string"
                    },
                    message: "must be string"
                  }];
                  return false;
                }
                var valid0 = _errs7 === errors;
              } else {
                var valid0 = true;
              }
              if (valid0) {
                if (data.cover !== void 0) {
                  let data4 = data.cover;
                  const _errs9 = errors;
                  if (typeof data4 !== "string" && data4 !== null) {
                    validate105.errors = [{
                      instancePath: instancePath + "/cover",
                      schemaPath: "#/properties/cover/type",
                      keyword: "type",
                      params: {
                        type: schema110.properties.cover.type
                      },
                      message: "must be string,null"
                    }];
                    return false;
                  }
                  var valid0 = _errs9 === errors;
                } else {
                  var valid0 = true;
                }
                if (valid0) {
                  if (data.url !== void 0) {
                    const _errs11 = errors;
                    if (typeof data.url !== "string") {
                      validate105.errors = [{
                        instancePath: instancePath + "/url",
                        schemaPath: "#/properties/url/type",
                        keyword: "type",
                        params: {
                          type: "string"
                        },
                        message: "must be string"
                      }];
                      return false;
                    }
                    var valid0 = _errs11 === errors;
                  } else {
                    var valid0 = true;
                  }
                  if (valid0) {
                    if (data.type !== void 0) {
                      let data6 = data.type;
                      const _errs13 = errors;
                      if (typeof data6 !== "string") {
                        validate105.errors = [{
                          instancePath: instancePath + "/type",
                          schemaPath: "NamedTagType/type",
                          keyword: "type",
                          params: {
                            type: "string"
                          },
                          message: "must be string"
                        }];
                        return false;
                      }
                      if (!(data6 === "EVENT" || data6 === "ATHLETE" || data6 === "PLACE" || data6 === "TOURNAMENT" || data6 === "TEAM" || data6 === "SEASON")) {
                        validate105.errors = [{
                          instancePath: instancePath + "/type",
                          schemaPath: "NamedTagType/enum",
                          keyword: "enum",
                          params: {
                            allowedValues: schema109.enum
                          },
                          message: "must be equal to one of the allowed values"
                        }];
                        return false;
                      }
                      var valid0 = _errs13 === errors;
                    } else {
                      var valid0 = true;
                    }
                    if (valid0) {
                      if (data.pages !== void 0) {
                        let data7 = data.pages;
                        const _errs16 = errors;
                        const _errs17 = errors;
                        let valid2 = false;
                        const _errs18 = errors;
                        if (errors === _errs18) {
                          if (Array.isArray(data7)) {
                            var valid3 = true;
                            const len0 = data7.length;
                            for (let i0 = 0; i0 < len0; i0++) {
                              const _errs20 = errors;
                              if (!validate100(data7[i0], {
                                instancePath: instancePath + "/pages/" + i0,
                                parentData: data7,
                                parentDataProperty: i0,
                                rootData
                              })) {
                                vErrors = vErrors === null ? validate100.errors : vErrors.concat(validate100.errors);
                                errors = vErrors.length;
                              }
                              var valid3 = _errs20 === errors;
                              if (!valid3) {
                                break;
                              }
                            }
                          } else {
                            const err0 = {
                              instancePath: instancePath + "/pages",
                              schemaPath: "#/properties/pages/anyOf/0/type",
                              keyword: "type",
                              params: {
                                type: "array"
                              },
                              message: "must be array"
                            };
                            if (vErrors === null) {
                              vErrors = [err0];
                            } else {
                              vErrors.push(err0);
                            }
                            errors++;
                          }
                        }
                        var _valid0 = _errs18 === errors;
                        valid2 = valid2 || _valid0;
                        if (!valid2) {
                          const _errs21 = errors;
                          if (data7 !== null) {
                            const err1 = {
                              instancePath: instancePath + "/pages",
                              schemaPath: "#/properties/pages/anyOf/1/type",
                              keyword: "type",
                              params: {
                                type: "null"
                              },
                              message: "must be null"
                            };
                            if (vErrors === null) {
                              vErrors = [err1];
                            } else {
                              vErrors.push(err1);
                            }
                            errors++;
                          }
                          var _valid0 = _errs21 === errors;
                          valid2 = valid2 || _valid0;
                        }
                        if (!valid2) {
                          const err2 = {
                            instancePath: instancePath + "/pages",
                            schemaPath: "#/properties/pages/anyOf",
                            keyword: "anyOf",
                            params: {},
                            message: "must match a schema in anyOf"
                          };
                          if (vErrors === null) {
                            vErrors = [err2];
                          } else {
                            vErrors.push(err2);
                          }
                          errors++;
                          validate105.errors = vErrors;
                          return false;
                        } else {
                          errors = _errs17;
                          if (vErrors !== null) {
                            if (_errs17) {
                              vErrors.length = _errs17;
                            } else {
                              vErrors = null;
                            }
                          }
                        }
                        var valid0 = _errs16 === errors;
                      } else {
                        var valid0 = true;
                      }
                      if (valid0) {
                        if (data.metaData !== void 0) {
                          let data9 = data.metaData;
                          const _errs23 = errors;
                          if (errors === _errs23) {
                            if (Array.isArray(data9)) {
                              var valid4 = true;
                              const len1 = data9.length;
                              for (let i1 = 0; i1 < len1; i1++) {
                                let data10 = data9[i1];
                                const _errs25 = errors;
                                if (errors === _errs25) {
                                  if (data10 && typeof data10 == "object" && !Array.isArray(data10)) {
                                    let missing1;
                                    if (data10.property === void 0 && (missing1 = "property") || data10.content === void 0 && (missing1 = "content")) {
                                      validate105.errors = [{
                                        instancePath: instancePath + "/metaData/" + i1,
                                        schemaPath: "#/properties/metaData/items/required",
                                        keyword: "required",
                                        params: {
                                          missingProperty: missing1
                                        },
                                        message: "must have required property '" + missing1 + "'"
                                      }];
                                      return false;
                                    } else {
                                      if (data10.property !== void 0) {
                                        const _errs27 = errors;
                                        if (typeof data10.property !== "string") {
                                          validate105.errors = [{
                                            instancePath: instancePath + "/metaData/" + i1 + "/property",
                                            schemaPath: "#/properties/metaData/items/properties/property/type",
                                            keyword: "type",
                                            params: {
                                              type: "string"
                                            },
                                            message: "must be string"
                                          }];
                                          return false;
                                        }
                                        var valid5 = _errs27 === errors;
                                      } else {
                                        var valid5 = true;
                                      }
                                      if (valid5) {
                                        if (data10.content !== void 0) {
                                          const _errs29 = errors;
                                          if (typeof data10.content !== "string") {
                                            validate105.errors = [{
                                              instancePath: instancePath + "/metaData/" + i1 + "/content",
                                              schemaPath: "#/properties/metaData/items/properties/content/type",
                                              keyword: "type",
                                              params: {
                                                type: "string"
                                              },
                                              message: "must be string"
                                            }];
                                            return false;
                                          }
                                          var valid5 = _errs29 === errors;
                                        } else {
                                          var valid5 = true;
                                        }
                                      }
                                    }
                                  } else {
                                    validate105.errors = [{
                                      instancePath: instancePath + "/metaData/" + i1,
                                      schemaPath: "#/properties/metaData/items/type",
                                      keyword: "type",
                                      params: {
                                        type: "object"
                                      },
                                      message: "must be object"
                                    }];
                                    return false;
                                  }
                                }
                                var valid4 = _errs25 === errors;
                                if (!valid4) {
                                  break;
                                }
                              }
                            } else {
                              validate105.errors = [{
                                instancePath: instancePath + "/metaData",
                                schemaPath: "#/properties/metaData/type",
                                keyword: "type",
                                params: {
                                  type: "array"
                                },
                                message: "must be array"
                              }];
                              return false;
                            }
                          }
                          var valid0 = _errs23 === errors;
                        } else {
                          var valid0 = true;
                        }
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
    } else {
      validate105.errors = [{
        instancePath,
        schemaPath: "#/type",
        keyword: "type",
        params: {
          type: "object"
        },
        message: "must be object"
      }];
      return false;
    }
  }
  validate105.errors = vErrors;
  return errors === 0;
}
const LinkNavigationResource = validate107;
function validate107(data, {
  instancePath = "",
  parentData,
  parentDataProperty,
  rootData = data
} = {}) {
  let vErrors = null;
  let errors = 0;
  const _errs0 = errors;
  let valid0 = false;
  const _errs1 = errors;
  if (errors === _errs1) {
    if (data && typeof data == "object" && !Array.isArray(data)) {
      let missing0;
      if (data.label === void 0 && (missing0 = "label") || data.linkType === void 0 && (missing0 = "linkType") || data.type === void 0 && (missing0 = "type") || data.url === void 0 && (missing0 = "url")) {
        const err0 = {
          instancePath,
          schemaPath: "#/anyOf/0/required",
          keyword: "required",
          params: {
            missingProperty: missing0
          },
          message: "must have required property '" + missing0 + "'"
        };
        if (vErrors === null) {
          vErrors = [err0];
        } else {
          vErrors.push(err0);
        }
        errors++;
      } else {
        if (data.linkType !== void 0) {
          let data0 = data.linkType;
          const _errs3 = errors;
          if (typeof data0 !== "string") {
            const err1 = {
              instancePath: instancePath + "/linkType",
              schemaPath: "#/anyOf/0/properties/linkType/type",
              keyword: "type",
              params: {
                type: "string"
              },
              message: "must be string"
            };
            if (vErrors === null) {
              vErrors = [err1];
            } else {
              vErrors.push(err1);
            }
            errors++;
          }
          if ("url" !== data0) {
            const err2 = {
              instancePath: instancePath + "/linkType",
              schemaPath: "#/anyOf/0/properties/linkType/const",
              keyword: "const",
              params: {
                allowedValue: "url"
              },
              message: "must be equal to constant"
            };
            if (vErrors === null) {
              vErrors = [err2];
            } else {
              vErrors.push(err2);
            }
            errors++;
          }
          var valid1 = _errs3 === errors;
        } else {
          var valid1 = true;
        }
        if (valid1) {
          if (data.url !== void 0) {
            const _errs5 = errors;
            if (typeof data.url !== "string") {
              const err3 = {
                instancePath: instancePath + "/url",
                schemaPath: "#/anyOf/0/properties/url/type",
                keyword: "type",
                params: {
                  type: "string"
                },
                message: "must be string"
              };
              if (vErrors === null) {
                vErrors = [err3];
              } else {
                vErrors.push(err3);
              }
              errors++;
            }
            var valid1 = _errs5 === errors;
          } else {
            var valid1 = true;
          }
          if (valid1) {
            if (data.type !== void 0) {
              let data2 = data.type;
              const _errs7 = errors;
              if (typeof data2 !== "string") {
                const err4 = {
                  instancePath: instancePath + "/type",
                  schemaPath: "#/anyOf/0/properties/type/type",
                  keyword: "type",
                  params: {
                    type: "string"
                  },
                  message: "must be string"
                };
                if (vErrors === null) {
                  vErrors = [err4];
                } else {
                  vErrors.push(err4);
                }
                errors++;
              }
              if ("LINK" !== data2) {
                const err5 = {
                  instancePath: instancePath + "/type",
                  schemaPath: "#/anyOf/0/properties/type/const",
                  keyword: "const",
                  params: {
                    allowedValue: "LINK"
                  },
                  message: "must be equal to constant"
                };
                if (vErrors === null) {
                  vErrors = [err5];
                } else {
                  vErrors.push(err5);
                }
                errors++;
              }
              var valid1 = _errs7 === errors;
            } else {
              var valid1 = true;
            }
            if (valid1) {
              if (data.label !== void 0) {
                const _errs9 = errors;
                if (typeof data.label !== "string") {
                  const err6 = {
                    instancePath: instancePath + "/label",
                    schemaPath: "#/anyOf/0/properties/label/type",
                    keyword: "type",
                    params: {
                      type: "string"
                    },
                    message: "must be string"
                  };
                  if (vErrors === null) {
                    vErrors = [err6];
                  } else {
                    vErrors.push(err6);
                  }
                  errors++;
                }
                var valid1 = _errs9 === errors;
              } else {
                var valid1 = true;
              }
              if (valid1) {
                if (data.external !== void 0) {
                  const _errs11 = errors;
                  if (typeof data.external !== "boolean") {
                    const err7 = {
                      instancePath: instancePath + "/external",
                      schemaPath: "#/anyOf/0/properties/external/type",
                      keyword: "type",
                      params: {
                        type: "boolean"
                      },
                      message: "must be boolean"
                    };
                    if (vErrors === null) {
                      vErrors = [err7];
                    } else {
                      vErrors.push(err7);
                    }
                    errors++;
                  }
                  var valid1 = _errs11 === errors;
                } else {
                  var valid1 = true;
                }
              }
            }
          }
        }
      }
    } else {
      const err8 = {
        instancePath,
        schemaPath: "#/anyOf/0/type",
        keyword: "type",
        params: {
          type: "object"
        },
        message: "must be object"
      };
      if (vErrors === null) {
        vErrors = [err8];
      } else {
        vErrors.push(err8);
      }
      errors++;
    }
  }
  var _valid0 = _errs1 === errors;
  valid0 = valid0 || _valid0;
  if (!valid0) {
    const _errs13 = errors;
    if (errors === _errs13) {
      if (data && typeof data == "object" && !Array.isArray(data)) {
        let missing1;
        if (data.label === void 0 && (missing1 = "label") || data.linkType === void 0 && (missing1 = "linkType") || data.pageId === void 0 && (missing1 = "pageId") || data.type === void 0 && (missing1 = "type")) {
          const err9 = {
            instancePath,
            schemaPath: "#/anyOf/1/required",
            keyword: "required",
            params: {
              missingProperty: missing1
            },
            message: "must have required property '" + missing1 + "'"
          };
          if (vErrors === null) {
            vErrors = [err9];
          } else {
            vErrors.push(err9);
          }
          errors++;
        } else {
          if (data.linkType !== void 0) {
            let data5 = data.linkType;
            const _errs15 = errors;
            if (typeof data5 !== "string") {
              const err10 = {
                instancePath: instancePath + "/linkType",
                schemaPath: "#/anyOf/1/properties/linkType/type",
                keyword: "type",
                params: {
                  type: "string"
                },
                message: "must be string"
              };
              if (vErrors === null) {
                vErrors = [err10];
              } else {
                vErrors.push(err10);
              }
              errors++;
            }
            if ("page" !== data5) {
              const err11 = {
                instancePath: instancePath + "/linkType",
                schemaPath: "#/anyOf/1/properties/linkType/const",
                keyword: "const",
                params: {
                  allowedValue: "page"
                },
                message: "must be equal to constant"
              };
              if (vErrors === null) {
                vErrors = [err11];
              } else {
                vErrors.push(err11);
              }
              errors++;
            }
            var valid2 = _errs15 === errors;
          } else {
            var valid2 = true;
          }
          if (valid2) {
            if (data.pageId !== void 0) {
              const _errs17 = errors;
              if (typeof data.pageId !== "string") {
                const err12 = {
                  instancePath: instancePath + "/pageId",
                  schemaPath: "#/anyOf/1/properties/pageId/type",
                  keyword: "type",
                  params: {
                    type: "string"
                  },
                  message: "must be string"
                };
                if (vErrors === null) {
                  vErrors = [err12];
                } else {
                  vErrors.push(err12);
                }
                errors++;
              }
              var valid2 = _errs17 === errors;
            } else {
              var valid2 = true;
            }
            if (valid2) {
              if (data.type !== void 0) {
                let data7 = data.type;
                const _errs19 = errors;
                if (typeof data7 !== "string") {
                  const err13 = {
                    instancePath: instancePath + "/type",
                    schemaPath: "#/anyOf/1/properties/type/type",
                    keyword: "type",
                    params: {
                      type: "string"
                    },
                    message: "must be string"
                  };
                  if (vErrors === null) {
                    vErrors = [err13];
                  } else {
                    vErrors.push(err13);
                  }
                  errors++;
                }
                if ("LINK" !== data7) {
                  const err14 = {
                    instancePath: instancePath + "/type",
                    schemaPath: "#/anyOf/1/properties/type/const",
                    keyword: "const",
                    params: {
                      allowedValue: "LINK"
                    },
                    message: "must be equal to constant"
                  };
                  if (vErrors === null) {
                    vErrors = [err14];
                  } else {
                    vErrors.push(err14);
                  }
                  errors++;
                }
                var valid2 = _errs19 === errors;
              } else {
                var valid2 = true;
              }
              if (valid2) {
                if (data.label !== void 0) {
                  const _errs21 = errors;
                  if (typeof data.label !== "string") {
                    const err15 = {
                      instancePath: instancePath + "/label",
                      schemaPath: "#/anyOf/1/properties/label/type",
                      keyword: "type",
                      params: {
                        type: "string"
                      },
                      message: "must be string"
                    };
                    if (vErrors === null) {
                      vErrors = [err15];
                    } else {
                      vErrors.push(err15);
                    }
                    errors++;
                  }
                  var valid2 = _errs21 === errors;
                } else {
                  var valid2 = true;
                }
                if (valid2) {
                  if (data.external !== void 0) {
                    const _errs23 = errors;
                    if (typeof data.external !== "boolean") {
                      const err16 = {
                        instancePath: instancePath + "/external",
                        schemaPath: "#/anyOf/1/properties/external/type",
                        keyword: "type",
                        params: {
                          type: "boolean"
                        },
                        message: "must be boolean"
                      };
                      if (vErrors === null) {
                        vErrors = [err16];
                      } else {
                        vErrors.push(err16);
                      }
                      errors++;
                    }
                    var valid2 = _errs23 === errors;
                  } else {
                    var valid2 = true;
                  }
                }
              }
            }
          }
        }
      } else {
        const err17 = {
          instancePath,
          schemaPath: "#/anyOf/1/type",
          keyword: "type",
          params: {
            type: "object"
          },
          message: "must be object"
        };
        if (vErrors === null) {
          vErrors = [err17];
        } else {
          vErrors.push(err17);
        }
        errors++;
      }
    }
    var _valid0 = _errs13 === errors;
    valid0 = valid0 || _valid0;
    if (!valid0) {
      const _errs25 = errors;
      if (errors === _errs25) {
        if (data && typeof data == "object" && !Array.isArray(data)) {
          let missing2;
          if (data.eventId === void 0 && (missing2 = "eventId") || data.label === void 0 && (missing2 = "label") || data.linkType === void 0 && (missing2 = "linkType") || data.type === void 0 && (missing2 = "type")) {
            const err18 = {
              instancePath,
              schemaPath: "#/anyOf/2/required",
              keyword: "required",
              params: {
                missingProperty: missing2
              },
              message: "must have required property '" + missing2 + "'"
            };
            if (vErrors === null) {
              vErrors = [err18];
            } else {
              vErrors.push(err18);
            }
            errors++;
          } else {
            if (data.linkType !== void 0) {
              let data10 = data.linkType;
              const _errs27 = errors;
              if (typeof data10 !== "string") {
                const err19 = {
                  instancePath: instancePath + "/linkType",
                  schemaPath: "#/anyOf/2/properties/linkType/type",
                  keyword: "type",
                  params: {
                    type: "string"
                  },
                  message: "must be string"
                };
                if (vErrors === null) {
                  vErrors = [err19];
                } else {
                  vErrors.push(err19);
                }
                errors++;
              }
              if ("event" !== data10) {
                const err20 = {
                  instancePath: instancePath + "/linkType",
                  schemaPath: "#/anyOf/2/properties/linkType/const",
                  keyword: "const",
                  params: {
                    allowedValue: "event"
                  },
                  message: "must be equal to constant"
                };
                if (vErrors === null) {
                  vErrors = [err20];
                } else {
                  vErrors.push(err20);
                }
                errors++;
              }
              var valid3 = _errs27 === errors;
            } else {
              var valid3 = true;
            }
            if (valid3) {
              if (data.eventId !== void 0) {
                const _errs29 = errors;
                if (typeof data.eventId !== "string") {
                  const err21 = {
                    instancePath: instancePath + "/eventId",
                    schemaPath: "#/anyOf/2/properties/eventId/type",
                    keyword: "type",
                    params: {
                      type: "string"
                    },
                    message: "must be string"
                  };
                  if (vErrors === null) {
                    vErrors = [err21];
                  } else {
                    vErrors.push(err21);
                  }
                  errors++;
                }
                var valid3 = _errs29 === errors;
              } else {
                var valid3 = true;
              }
              if (valid3) {
                if (data.type !== void 0) {
                  let data12 = data.type;
                  const _errs31 = errors;
                  if (typeof data12 !== "string") {
                    const err22 = {
                      instancePath: instancePath + "/type",
                      schemaPath: "#/anyOf/2/properties/type/type",
                      keyword: "type",
                      params: {
                        type: "string"
                      },
                      message: "must be string"
                    };
                    if (vErrors === null) {
                      vErrors = [err22];
                    } else {
                      vErrors.push(err22);
                    }
                    errors++;
                  }
                  if ("LINK" !== data12) {
                    const err23 = {
                      instancePath: instancePath + "/type",
                      schemaPath: "#/anyOf/2/properties/type/const",
                      keyword: "const",
                      params: {
                        allowedValue: "LINK"
                      },
                      message: "must be equal to constant"
                    };
                    if (vErrors === null) {
                      vErrors = [err23];
                    } else {
                      vErrors.push(err23);
                    }
                    errors++;
                  }
                  var valid3 = _errs31 === errors;
                } else {
                  var valid3 = true;
                }
                if (valid3) {
                  if (data.label !== void 0) {
                    const _errs33 = errors;
                    if (typeof data.label !== "string") {
                      const err24 = {
                        instancePath: instancePath + "/label",
                        schemaPath: "#/anyOf/2/properties/label/type",
                        keyword: "type",
                        params: {
                          type: "string"
                        },
                        message: "must be string"
                      };
                      if (vErrors === null) {
                        vErrors = [err24];
                      } else {
                        vErrors.push(err24);
                      }
                      errors++;
                    }
                    var valid3 = _errs33 === errors;
                  } else {
                    var valid3 = true;
                  }
                  if (valid3) {
                    if (data.external !== void 0) {
                      const _errs35 = errors;
                      if (typeof data.external !== "boolean") {
                        const err25 = {
                          instancePath: instancePath + "/external",
                          schemaPath: "#/anyOf/2/properties/external/type",
                          keyword: "type",
                          params: {
                            type: "boolean"
                          },
                          message: "must be boolean"
                        };
                        if (vErrors === null) {
                          vErrors = [err25];
                        } else {
                          vErrors.push(err25);
                        }
                        errors++;
                      }
                      var valid3 = _errs35 === errors;
                    } else {
                      var valid3 = true;
                    }
                  }
                }
              }
            }
          }
        } else {
          const err26 = {
            instancePath,
            schemaPath: "#/anyOf/2/type",
            keyword: "type",
            params: {
              type: "object"
            },
            message: "must be object"
          };
          if (vErrors === null) {
            vErrors = [err26];
          } else {
            vErrors.push(err26);
          }
          errors++;
        }
      }
      var _valid0 = _errs25 === errors;
      valid0 = valid0 || _valid0;
      if (!valid0) {
        const _errs37 = errors;
        if (errors === _errs37) {
          if (data && typeof data == "object" && !Array.isArray(data)) {
            let missing3;
            if (data.label === void 0 && (missing3 = "label") || data.linkType === void 0 && (missing3 = "linkType") || data.type === void 0 && (missing3 = "type") || data.videoId === void 0 && (missing3 = "videoId")) {
              const err27 = {
                instancePath,
                schemaPath: "#/anyOf/3/required",
                keyword: "required",
                params: {
                  missingProperty: missing3
                },
                message: "must have required property '" + missing3 + "'"
              };
              if (vErrors === null) {
                vErrors = [err27];
              } else {
                vErrors.push(err27);
              }
              errors++;
            } else {
              if (data.linkType !== void 0) {
                let data15 = data.linkType;
                const _errs39 = errors;
                if (typeof data15 !== "string") {
                  const err28 = {
                    instancePath: instancePath + "/linkType",
                    schemaPath: "#/anyOf/3/properties/linkType/type",
                    keyword: "type",
                    params: {
                      type: "string"
                    },
                    message: "must be string"
                  };
                  if (vErrors === null) {
                    vErrors = [err28];
                  } else {
                    vErrors.push(err28);
                  }
                  errors++;
                }
                if ("video" !== data15) {
                  const err29 = {
                    instancePath: instancePath + "/linkType",
                    schemaPath: "#/anyOf/3/properties/linkType/const",
                    keyword: "const",
                    params: {
                      allowedValue: "video"
                    },
                    message: "must be equal to constant"
                  };
                  if (vErrors === null) {
                    vErrors = [err29];
                  } else {
                    vErrors.push(err29);
                  }
                  errors++;
                }
                var valid4 = _errs39 === errors;
              } else {
                var valid4 = true;
              }
              if (valid4) {
                if (data.videoId !== void 0) {
                  const _errs41 = errors;
                  if (typeof data.videoId !== "string") {
                    const err30 = {
                      instancePath: instancePath + "/videoId",
                      schemaPath: "#/anyOf/3/properties/videoId/type",
                      keyword: "type",
                      params: {
                        type: "string"
                      },
                      message: "must be string"
                    };
                    if (vErrors === null) {
                      vErrors = [err30];
                    } else {
                      vErrors.push(err30);
                    }
                    errors++;
                  }
                  var valid4 = _errs41 === errors;
                } else {
                  var valid4 = true;
                }
                if (valid4) {
                  if (data.type !== void 0) {
                    let data17 = data.type;
                    const _errs43 = errors;
                    if (typeof data17 !== "string") {
                      const err31 = {
                        instancePath: instancePath + "/type",
                        schemaPath: "#/anyOf/3/properties/type/type",
                        keyword: "type",
                        params: {
                          type: "string"
                        },
                        message: "must be string"
                      };
                      if (vErrors === null) {
                        vErrors = [err31];
                      } else {
                        vErrors.push(err31);
                      }
                      errors++;
                    }
                    if ("LINK" !== data17) {
                      const err32 = {
                        instancePath: instancePath + "/type",
                        schemaPath: "#/anyOf/3/properties/type/const",
                        keyword: "const",
                        params: {
                          allowedValue: "LINK"
                        },
                        message: "must be equal to constant"
                      };
                      if (vErrors === null) {
                        vErrors = [err32];
                      } else {
                        vErrors.push(err32);
                      }
                      errors++;
                    }
                    var valid4 = _errs43 === errors;
                  } else {
                    var valid4 = true;
                  }
                  if (valid4) {
                    if (data.label !== void 0) {
                      const _errs45 = errors;
                      if (typeof data.label !== "string") {
                        const err33 = {
                          instancePath: instancePath + "/label",
                          schemaPath: "#/anyOf/3/properties/label/type",
                          keyword: "type",
                          params: {
                            type: "string"
                          },
                          message: "must be string"
                        };
                        if (vErrors === null) {
                          vErrors = [err33];
                        } else {
                          vErrors.push(err33);
                        }
                        errors++;
                      }
                      var valid4 = _errs45 === errors;
                    } else {
                      var valid4 = true;
                    }
                    if (valid4) {
                      if (data.external !== void 0) {
                        const _errs47 = errors;
                        if (typeof data.external !== "boolean") {
                          const err34 = {
                            instancePath: instancePath + "/external",
                            schemaPath: "#/anyOf/3/properties/external/type",
                            keyword: "type",
                            params: {
                              type: "boolean"
                            },
                            message: "must be boolean"
                          };
                          if (vErrors === null) {
                            vErrors = [err34];
                          } else {
                            vErrors.push(err34);
                          }
                          errors++;
                        }
                        var valid4 = _errs47 === errors;
                      } else {
                        var valid4 = true;
                      }
                    }
                  }
                }
              }
            }
          } else {
            const err35 = {
              instancePath,
              schemaPath: "#/anyOf/3/type",
              keyword: "type",
              params: {
                type: "object"
              },
              message: "must be object"
            };
            if (vErrors === null) {
              vErrors = [err35];
            } else {
              vErrors.push(err35);
            }
            errors++;
          }
        }
        var _valid0 = _errs37 === errors;
        valid0 = valid0 || _valid0;
        if (!valid0) {
          const _errs49 = errors;
          if (errors === _errs49) {
            if (data && typeof data == "object" && !Array.isArray(data)) {
              let missing4;
              if (data.label === void 0 && (missing4 = "label") || data.linkType === void 0 && (missing4 = "linkType") || data.tagName === void 0 && (missing4 = "tagName") || data.type === void 0 && (missing4 = "type")) {
                const err36 = {
                  instancePath,
                  schemaPath: "#/anyOf/4/required",
                  keyword: "required",
                  params: {
                    missingProperty: missing4
                  },
                  message: "must have required property '" + missing4 + "'"
                };
                if (vErrors === null) {
                  vErrors = [err36];
                } else {
                  vErrors.push(err36);
                }
                errors++;
              } else {
                if (data.linkType !== void 0) {
                  let data20 = data.linkType;
                  const _errs51 = errors;
                  if (typeof data20 !== "string") {
                    const err37 = {
                      instancePath: instancePath + "/linkType",
                      schemaPath: "#/anyOf/4/properties/linkType/type",
                      keyword: "type",
                      params: {
                        type: "string"
                      },
                      message: "must be string"
                    };
                    if (vErrors === null) {
                      vErrors = [err37];
                    } else {
                      vErrors.push(err37);
                    }
                    errors++;
                  }
                  if ("tag" !== data20) {
                    const err38 = {
                      instancePath: instancePath + "/linkType",
                      schemaPath: "#/anyOf/4/properties/linkType/const",
                      keyword: "const",
                      params: {
                        allowedValue: "tag"
                      },
                      message: "must be equal to constant"
                    };
                    if (vErrors === null) {
                      vErrors = [err38];
                    } else {
                      vErrors.push(err38);
                    }
                    errors++;
                  }
                  var valid5 = _errs51 === errors;
                } else {
                  var valid5 = true;
                }
                if (valid5) {
                  if (data.tagName !== void 0) {
                    const _errs53 = errors;
                    if (typeof data.tagName !== "string") {
                      const err39 = {
                        instancePath: instancePath + "/tagName",
                        schemaPath: "#/anyOf/4/properties/tagName/type",
                        keyword: "type",
                        params: {
                          type: "string"
                        },
                        message: "must be string"
                      };
                      if (vErrors === null) {
                        vErrors = [err39];
                      } else {
                        vErrors.push(err39);
                      }
                      errors++;
                    }
                    var valid5 = _errs53 === errors;
                  } else {
                    var valid5 = true;
                  }
                  if (valid5) {
                    if (data.type !== void 0) {
                      let data22 = data.type;
                      const _errs55 = errors;
                      if (typeof data22 !== "string") {
                        const err40 = {
                          instancePath: instancePath + "/type",
                          schemaPath: "#/anyOf/4/properties/type/type",
                          keyword: "type",
                          params: {
                            type: "string"
                          },
                          message: "must be string"
                        };
                        if (vErrors === null) {
                          vErrors = [err40];
                        } else {
                          vErrors.push(err40);
                        }
                        errors++;
                      }
                      if ("LINK" !== data22) {
                        const err41 = {
                          instancePath: instancePath + "/type",
                          schemaPath: "#/anyOf/4/properties/type/const",
                          keyword: "const",
                          params: {
                            allowedValue: "LINK"
                          },
                          message: "must be equal to constant"
                        };
                        if (vErrors === null) {
                          vErrors = [err41];
                        } else {
                          vErrors.push(err41);
                        }
                        errors++;
                      }
                      var valid5 = _errs55 === errors;
                    } else {
                      var valid5 = true;
                    }
                    if (valid5) {
                      if (data.label !== void 0) {
                        const _errs57 = errors;
                        if (typeof data.label !== "string") {
                          const err42 = {
                            instancePath: instancePath + "/label",
                            schemaPath: "#/anyOf/4/properties/label/type",
                            keyword: "type",
                            params: {
                              type: "string"
                            },
                            message: "must be string"
                          };
                          if (vErrors === null) {
                            vErrors = [err42];
                          } else {
                            vErrors.push(err42);
                          }
                          errors++;
                        }
                        var valid5 = _errs57 === errors;
                      } else {
                        var valid5 = true;
                      }
                      if (valid5) {
                        if (data.external !== void 0) {
                          const _errs59 = errors;
                          if (typeof data.external !== "boolean") {
                            const err43 = {
                              instancePath: instancePath + "/external",
                              schemaPath: "#/anyOf/4/properties/external/type",
                              keyword: "type",
                              params: {
                                type: "boolean"
                              },
                              message: "must be boolean"
                            };
                            if (vErrors === null) {
                              vErrors = [err43];
                            } else {
                              vErrors.push(err43);
                            }
                            errors++;
                          }
                          var valid5 = _errs59 === errors;
                        } else {
                          var valid5 = true;
                        }
                      }
                    }
                  }
                }
              }
            } else {
              const err44 = {
                instancePath,
                schemaPath: "#/anyOf/4/type",
                keyword: "type",
                params: {
                  type: "object"
                },
                message: "must be object"
              };
              if (vErrors === null) {
                vErrors = [err44];
              } else {
                vErrors.push(err44);
              }
              errors++;
            }
          }
          var _valid0 = _errs49 === errors;
          valid0 = valid0 || _valid0;
        }
      }
    }
  }
  if (!valid0) {
    const err45 = {
      instancePath,
      schemaPath: "#/anyOf",
      keyword: "anyOf",
      params: {},
      message: "must match a schema in anyOf"
    };
    if (vErrors === null) {
      vErrors = [err45];
    } else {
      vErrors.push(err45);
    }
    errors++;
    validate107.errors = vErrors;
    return false;
  } else {
    errors = _errs0;
    if (vErrors !== null) {
      if (_errs0) {
        vErrors.length = _errs0;
      } else {
        vErrors = null;
      }
    }
  }
  validate107.errors = vErrors;
  return errors === 0;
}
const RootNavigationResource = validate108;
const schema113 = {
  "$id": "RootNavigationResource",
  "$schema": "http://json-schema.org/draft-07/schema#",
  "anyOf": [{
    "type": "object",
    "properties": {
      "type": {
        "type": "string",
        "const": "CALENDAR"
      }
    },
    "required": ["type"]
  }, {
    "type": "object",
    "properties": {
      "type": {
        "type": "string",
        "const": "EVENTS"
      },
      "label": {
        "type": "string"
      },
      "listSources": {
        "type": "array",
        "items": {
          "type": "object",
          "properties": {
            "label": {
              "type": "string"
            },
            "source": {
              "$ref": "EventListSource"
            },
            "order": {
              "type": "string",
              "enum": ["ASC", "DESC"]
            }
          },
          "required": ["label", "source", "order"]
        }
      }
    },
    "required": ["type"]
  }, {
    "type": "object",
    "properties": {
      "type": {
        "type": "string",
        "const": "NAMED_TAGS"
      },
      "tagType": {
        "$ref": "NamedTagType"
      },
      "label": {
        "type": "string"
      }
    },
    "required": ["type", "tagType"]
  }, {
    "type": "object",
    "properties": {
      "type": {
        "type": "string",
        "const": "MENU"
      },
      "label": {
        "type": "string"
      },
      "items": {
        "type": "array",
        "items": {
          "$ref": "LinkNavigationResource"
        }
      }
    },
    "required": ["type", "label", "items"]
  }, {
    "$ref": "LinkNavigationResource"
  }]
};
function validate108(data, {
  instancePath = "",
  parentData,
  parentDataProperty,
  rootData = data
} = {}) {
  let vErrors = null;
  let errors = 0;
  const _errs0 = errors;
  let valid0 = false;
  const _errs1 = errors;
  if (errors === _errs1) {
    if (data && typeof data == "object" && !Array.isArray(data)) {
      let missing0;
      if (data.type === void 0 && (missing0 = "type")) {
        const err0 = {
          instancePath,
          schemaPath: "#/anyOf/0/required",
          keyword: "required",
          params: {
            missingProperty: missing0
          },
          message: "must have required property '" + missing0 + "'"
        };
        if (vErrors === null) {
          vErrors = [err0];
        } else {
          vErrors.push(err0);
        }
        errors++;
      } else {
        if (data.type !== void 0) {
          let data0 = data.type;
          if (typeof data0 !== "string") {
            const err1 = {
              instancePath: instancePath + "/type",
              schemaPath: "#/anyOf/0/properties/type/type",
              keyword: "type",
              params: {
                type: "string"
              },
              message: "must be string"
            };
            if (vErrors === null) {
              vErrors = [err1];
            } else {
              vErrors.push(err1);
            }
            errors++;
          }
          if ("CALENDAR" !== data0) {
            const err2 = {
              instancePath: instancePath + "/type",
              schemaPath: "#/anyOf/0/properties/type/const",
              keyword: "const",
              params: {
                allowedValue: "CALENDAR"
              },
              message: "must be equal to constant"
            };
            if (vErrors === null) {
              vErrors = [err2];
            } else {
              vErrors.push(err2);
            }
            errors++;
          }
        }
      }
    } else {
      const err3 = {
        instancePath,
        schemaPath: "#/anyOf/0/type",
        keyword: "type",
        params: {
          type: "object"
        },
        message: "must be object"
      };
      if (vErrors === null) {
        vErrors = [err3];
      } else {
        vErrors.push(err3);
      }
      errors++;
    }
  }
  var _valid0 = _errs1 === errors;
  valid0 = valid0 || _valid0;
  if (!valid0) {
    const _errs5 = errors;
    if (errors === _errs5) {
      if (data && typeof data == "object" && !Array.isArray(data)) {
        let missing1;
        if (data.type === void 0 && (missing1 = "type")) {
          const err4 = {
            instancePath,
            schemaPath: "#/anyOf/1/required",
            keyword: "required",
            params: {
              missingProperty: missing1
            },
            message: "must have required property '" + missing1 + "'"
          };
          if (vErrors === null) {
            vErrors = [err4];
          } else {
            vErrors.push(err4);
          }
          errors++;
        } else {
          if (data.type !== void 0) {
            let data1 = data.type;
            const _errs7 = errors;
            if (typeof data1 !== "string") {
              const err5 = {
                instancePath: instancePath + "/type",
                schemaPath: "#/anyOf/1/properties/type/type",
                keyword: "type",
                params: {
                  type: "string"
                },
                message: "must be string"
              };
              if (vErrors === null) {
                vErrors = [err5];
              } else {
                vErrors.push(err5);
              }
              errors++;
            }
            if ("EVENTS" !== data1) {
              const err6 = {
                instancePath: instancePath + "/type",
                schemaPath: "#/anyOf/1/properties/type/const",
                keyword: "const",
                params: {
                  allowedValue: "EVENTS"
                },
                message: "must be equal to constant"
              };
              if (vErrors === null) {
                vErrors = [err6];
              } else {
                vErrors.push(err6);
              }
              errors++;
            }
            var valid2 = _errs7 === errors;
          } else {
            var valid2 = true;
          }
          if (valid2) {
            if (data.label !== void 0) {
              const _errs9 = errors;
              if (typeof data.label !== "string") {
                const err7 = {
                  instancePath: instancePath + "/label",
                  schemaPath: "#/anyOf/1/properties/label/type",
                  keyword: "type",
                  params: {
                    type: "string"
                  },
                  message: "must be string"
                };
                if (vErrors === null) {
                  vErrors = [err7];
                } else {
                  vErrors.push(err7);
                }
                errors++;
              }
              var valid2 = _errs9 === errors;
            } else {
              var valid2 = true;
            }
            if (valid2) {
              if (data.listSources !== void 0) {
                let data3 = data.listSources;
                const _errs11 = errors;
                if (errors === _errs11) {
                  if (Array.isArray(data3)) {
                    var valid3 = true;
                    const len0 = data3.length;
                    for (let i0 = 0; i0 < len0; i0++) {
                      let data4 = data3[i0];
                      const _errs13 = errors;
                      if (errors === _errs13) {
                        if (data4 && typeof data4 == "object" && !Array.isArray(data4)) {
                          let missing2;
                          if (data4.label === void 0 && (missing2 = "label") || data4.source === void 0 && (missing2 = "source") || data4.order === void 0 && (missing2 = "order")) {
                            const err8 = {
                              instancePath: instancePath + "/listSources/" + i0,
                              schemaPath: "#/anyOf/1/properties/listSources/items/required",
                              keyword: "required",
                              params: {
                                missingProperty: missing2
                              },
                              message: "must have required property '" + missing2 + "'"
                            };
                            if (vErrors === null) {
                              vErrors = [err8];
                            } else {
                              vErrors.push(err8);
                            }
                            errors++;
                          } else {
                            if (data4.label !== void 0) {
                              const _errs15 = errors;
                              if (typeof data4.label !== "string") {
                                const err9 = {
                                  instancePath: instancePath + "/listSources/" + i0 + "/label",
                                  schemaPath: "#/anyOf/1/properties/listSources/items/properties/label/type",
                                  keyword: "type",
                                  params: {
                                    type: "string"
                                  },
                                  message: "must be string"
                                };
                                if (vErrors === null) {
                                  vErrors = [err9];
                                } else {
                                  vErrors.push(err9);
                                }
                                errors++;
                              }
                              var valid4 = _errs15 === errors;
                            } else {
                              var valid4 = true;
                            }
                            if (valid4) {
                              if (data4.source !== void 0) {
                                let data6 = data4.source;
                                const _errs17 = errors;
                                const _errs18 = errors;
                                if (errors === _errs18) {
                                  if (data6 && typeof data6 == "object" && !Array.isArray(data6)) {
                                    if (data6.eventIds !== void 0) {
                                      let data7 = data6.eventIds;
                                      const _errs20 = errors;
                                      if (errors === _errs20) {
                                        if (Array.isArray(data7)) {
                                          var valid7 = true;
                                          const len1 = data7.length;
                                          for (let i1 = 0; i1 < len1; i1++) {
                                            const _errs22 = errors;
                                            if (typeof data7[i1] !== "string") {
                                              const err10 = {
                                                instancePath: instancePath + "/listSources/" + i0 + "/source/eventIds/" + i1,
                                                schemaPath: "EventListSource/properties/eventIds/items/type",
                                                keyword: "type",
                                                params: {
                                                  type: "string"
                                                },
                                                message: "must be string"
                                              };
                                              if (vErrors === null) {
                                                vErrors = [err10];
                                              } else {
                                                vErrors.push(err10);
                                              }
                                              errors++;
                                            }
                                            var valid7 = _errs22 === errors;
                                            if (!valid7) {
                                              break;
                                            }
                                          }
                                        } else {
                                          const err11 = {
                                            instancePath: instancePath + "/listSources/" + i0 + "/source/eventIds",
                                            schemaPath: "EventListSource/properties/eventIds/type",
                                            keyword: "type",
                                            params: {
                                              type: "array"
                                            },
                                            message: "must be array"
                                          };
                                          if (vErrors === null) {
                                            vErrors = [err11];
                                          } else {
                                            vErrors.push(err11);
                                          }
                                          errors++;
                                        }
                                      }
                                      var valid6 = _errs20 === errors;
                                    } else {
                                      var valid6 = true;
                                    }
                                    if (valid6) {
                                      if (data6.onlyState !== void 0) {
                                        let data9 = data6.onlyState;
                                        const _errs24 = errors;
                                        if (typeof data9 !== "string") {
                                          const err12 = {
                                            instancePath: instancePath + "/listSources/" + i0 + "/source/onlyState",
                                            schemaPath: "EventListSource/properties/onlyState/type",
                                            keyword: "type",
                                            params: {
                                              type: "string"
                                            },
                                            message: "must be string"
                                          };
                                          if (vErrors === null) {
                                            vErrors = [err12];
                                          } else {
                                            vErrors.push(err12);
                                          }
                                          errors++;
                                        }
                                        if (!(data9 === "UPCOMING" || data9 === "ACTIVE" || data9 === "PASSED" || data9 === "ACTIVE_AND_UPCOMING" || data9 === "PASSED_AND_ACTIVE")) {
                                          const err13 = {
                                            instancePath: instancePath + "/listSources/" + i0 + "/source/onlyState",
                                            schemaPath: "EventListSource/properties/onlyState/enum",
                                            keyword: "enum",
                                            params: {
                                              allowedValues: schema63.properties.onlyState.enum
                                            },
                                            message: "must be equal to one of the allowed values"
                                          };
                                          if (vErrors === null) {
                                            vErrors = [err13];
                                          } else {
                                            vErrors.push(err13);
                                          }
                                          errors++;
                                        }
                                        var valid6 = _errs24 === errors;
                                      } else {
                                        var valid6 = true;
                                      }
                                    }
                                  } else {
                                    const err14 = {
                                      instancePath: instancePath + "/listSources/" + i0 + "/source",
                                      schemaPath: "EventListSource/type",
                                      keyword: "type",
                                      params: {
                                        type: "object"
                                      },
                                      message: "must be object"
                                    };
                                    if (vErrors === null) {
                                      vErrors = [err14];
                                    } else {
                                      vErrors.push(err14);
                                    }
                                    errors++;
                                  }
                                }
                                var valid4 = _errs17 === errors;
                              } else {
                                var valid4 = true;
                              }
                              if (valid4) {
                                if (data4.order !== void 0) {
                                  let data10 = data4.order;
                                  const _errs26 = errors;
                                  if (typeof data10 !== "string") {
                                    const err15 = {
                                      instancePath: instancePath + "/listSources/" + i0 + "/order",
                                      schemaPath: "#/anyOf/1/properties/listSources/items/properties/order/type",
                                      keyword: "type",
                                      params: {
                                        type: "string"
                                      },
                                      message: "must be string"
                                    };
                                    if (vErrors === null) {
                                      vErrors = [err15];
                                    } else {
                                      vErrors.push(err15);
                                    }
                                    errors++;
                                  }
                                  if (!(data10 === "ASC" || data10 === "DESC")) {
                                    const err16 = {
                                      instancePath: instancePath + "/listSources/" + i0 + "/order",
                                      schemaPath: "#/anyOf/1/properties/listSources/items/properties/order/enum",
                                      keyword: "enum",
                                      params: {
                                        allowedValues: schema113.anyOf[1].properties.listSources.items.properties.order.enum
                                      },
                                      message: "must be equal to one of the allowed values"
                                    };
                                    if (vErrors === null) {
                                      vErrors = [err16];
                                    } else {
                                      vErrors.push(err16);
                                    }
                                    errors++;
                                  }
                                  var valid4 = _errs26 === errors;
                                } else {
                                  var valid4 = true;
                                }
                              }
                            }
                          }
                        } else {
                          const err17 = {
                            instancePath: instancePath + "/listSources/" + i0,
                            schemaPath: "#/anyOf/1/properties/listSources/items/type",
                            keyword: "type",
                            params: {
                              type: "object"
                            },
                            message: "must be object"
                          };
                          if (vErrors === null) {
                            vErrors = [err17];
                          } else {
                            vErrors.push(err17);
                          }
                          errors++;
                        }
                      }
                      var valid3 = _errs13 === errors;
                      if (!valid3) {
                        break;
                      }
                    }
                  } else {
                    const err18 = {
                      instancePath: instancePath + "/listSources",
                      schemaPath: "#/anyOf/1/properties/listSources/type",
                      keyword: "type",
                      params: {
                        type: "array"
                      },
                      message: "must be array"
                    };
                    if (vErrors === null) {
                      vErrors = [err18];
                    } else {
                      vErrors.push(err18);
                    }
                    errors++;
                  }
                }
                var valid2 = _errs11 === errors;
              } else {
                var valid2 = true;
              }
            }
          }
        }
      } else {
        const err19 = {
          instancePath,
          schemaPath: "#/anyOf/1/type",
          keyword: "type",
          params: {
            type: "object"
          },
          message: "must be object"
        };
        if (vErrors === null) {
          vErrors = [err19];
        } else {
          vErrors.push(err19);
        }
        errors++;
      }
    }
    var _valid0 = _errs5 === errors;
    valid0 = valid0 || _valid0;
    if (!valid0) {
      const _errs28 = errors;
      if (errors === _errs28) {
        if (data && typeof data == "object" && !Array.isArray(data)) {
          let missing3;
          if (data.type === void 0 && (missing3 = "type") || data.tagType === void 0 && (missing3 = "tagType")) {
            const err20 = {
              instancePath,
              schemaPath: "#/anyOf/2/required",
              keyword: "required",
              params: {
                missingProperty: missing3
              },
              message: "must have required property '" + missing3 + "'"
            };
            if (vErrors === null) {
              vErrors = [err20];
            } else {
              vErrors.push(err20);
            }
            errors++;
          } else {
            if (data.type !== void 0) {
              let data11 = data.type;
              const _errs30 = errors;
              if (typeof data11 !== "string") {
                const err21 = {
                  instancePath: instancePath + "/type",
                  schemaPath: "#/anyOf/2/properties/type/type",
                  keyword: "type",
                  params: {
                    type: "string"
                  },
                  message: "must be string"
                };
                if (vErrors === null) {
                  vErrors = [err21];
                } else {
                  vErrors.push(err21);
                }
                errors++;
              }
              if ("NAMED_TAGS" !== data11) {
                const err22 = {
                  instancePath: instancePath + "/type",
                  schemaPath: "#/anyOf/2/properties/type/const",
                  keyword: "const",
                  params: {
                    allowedValue: "NAMED_TAGS"
                  },
                  message: "must be equal to constant"
                };
                if (vErrors === null) {
                  vErrors = [err22];
                } else {
                  vErrors.push(err22);
                }
                errors++;
              }
              var valid8 = _errs30 === errors;
            } else {
              var valid8 = true;
            }
            if (valid8) {
              if (data.tagType !== void 0) {
                let data12 = data.tagType;
                const _errs32 = errors;
                if (typeof data12 !== "string") {
                  const err23 = {
                    instancePath: instancePath + "/tagType",
                    schemaPath: "NamedTagType/type",
                    keyword: "type",
                    params: {
                      type: "string"
                    },
                    message: "must be string"
                  };
                  if (vErrors === null) {
                    vErrors = [err23];
                  } else {
                    vErrors.push(err23);
                  }
                  errors++;
                }
                if (!(data12 === "EVENT" || data12 === "ATHLETE" || data12 === "PLACE" || data12 === "TOURNAMENT" || data12 === "TEAM" || data12 === "SEASON")) {
                  const err24 = {
                    instancePath: instancePath + "/tagType",
                    schemaPath: "NamedTagType/enum",
                    keyword: "enum",
                    params: {
                      allowedValues: schema109.enum
                    },
                    message: "must be equal to one of the allowed values"
                  };
                  if (vErrors === null) {
                    vErrors = [err24];
                  } else {
                    vErrors.push(err24);
                  }
                  errors++;
                }
                var valid8 = _errs32 === errors;
              } else {
                var valid8 = true;
              }
              if (valid8) {
                if (data.label !== void 0) {
                  const _errs35 = errors;
                  if (typeof data.label !== "string") {
                    const err25 = {
                      instancePath: instancePath + "/label",
                      schemaPath: "#/anyOf/2/properties/label/type",
                      keyword: "type",
                      params: {
                        type: "string"
                      },
                      message: "must be string"
                    };
                    if (vErrors === null) {
                      vErrors = [err25];
                    } else {
                      vErrors.push(err25);
                    }
                    errors++;
                  }
                  var valid8 = _errs35 === errors;
                } else {
                  var valid8 = true;
                }
              }
            }
          }
        } else {
          const err26 = {
            instancePath,
            schemaPath: "#/anyOf/2/type",
            keyword: "type",
            params: {
              type: "object"
            },
            message: "must be object"
          };
          if (vErrors === null) {
            vErrors = [err26];
          } else {
            vErrors.push(err26);
          }
          errors++;
        }
      }
      var _valid0 = _errs28 === errors;
      valid0 = valid0 || _valid0;
      if (!valid0) {
        const _errs37 = errors;
        if (errors === _errs37) {
          if (data && typeof data == "object" && !Array.isArray(data)) {
            let missing4;
            if (data.type === void 0 && (missing4 = "type") || data.label === void 0 && (missing4 = "label") || data.items === void 0 && (missing4 = "items")) {
              const err27 = {
                instancePath,
                schemaPath: "#/anyOf/3/required",
                keyword: "required",
                params: {
                  missingProperty: missing4
                },
                message: "must have required property '" + missing4 + "'"
              };
              if (vErrors === null) {
                vErrors = [err27];
              } else {
                vErrors.push(err27);
              }
              errors++;
            } else {
              if (data.type !== void 0) {
                let data14 = data.type;
                const _errs39 = errors;
                if (typeof data14 !== "string") {
                  const err28 = {
                    instancePath: instancePath + "/type",
                    schemaPath: "#/anyOf/3/properties/type/type",
                    keyword: "type",
                    params: {
                      type: "string"
                    },
                    message: "must be string"
                  };
                  if (vErrors === null) {
                    vErrors = [err28];
                  } else {
                    vErrors.push(err28);
                  }
                  errors++;
                }
                if ("MENU" !== data14) {
                  const err29 = {
                    instancePath: instancePath + "/type",
                    schemaPath: "#/anyOf/3/properties/type/const",
                    keyword: "const",
                    params: {
                      allowedValue: "MENU"
                    },
                    message: "must be equal to constant"
                  };
                  if (vErrors === null) {
                    vErrors = [err29];
                  } else {
                    vErrors.push(err29);
                  }
                  errors++;
                }
                var valid10 = _errs39 === errors;
              } else {
                var valid10 = true;
              }
              if (valid10) {
                if (data.label !== void 0) {
                  const _errs41 = errors;
                  if (typeof data.label !== "string") {
                    const err30 = {
                      instancePath: instancePath + "/label",
                      schemaPath: "#/anyOf/3/properties/label/type",
                      keyword: "type",
                      params: {
                        type: "string"
                      },
                      message: "must be string"
                    };
                    if (vErrors === null) {
                      vErrors = [err30];
                    } else {
                      vErrors.push(err30);
                    }
                    errors++;
                  }
                  var valid10 = _errs41 === errors;
                } else {
                  var valid10 = true;
                }
                if (valid10) {
                  if (data.items !== void 0) {
                    let data16 = data.items;
                    const _errs43 = errors;
                    if (errors === _errs43) {
                      if (Array.isArray(data16)) {
                        var valid11 = true;
                        const len2 = data16.length;
                        for (let i2 = 0; i2 < len2; i2++) {
                          let data17 = data16[i2];
                          const _errs45 = errors;
                          const _errs47 = errors;
                          let valid13 = false;
                          const _errs48 = errors;
                          if (errors === _errs48) {
                            if (data17 && typeof data17 == "object" && !Array.isArray(data17)) {
                              let missing5;
                              if (data17.label === void 0 && (missing5 = "label") || data17.linkType === void 0 && (missing5 = "linkType") || data17.type === void 0 && (missing5 = "type") || data17.url === void 0 && (missing5 = "url")) {
                                const err31 = {
                                  instancePath: instancePath + "/items/" + i2,
                                  schemaPath: "LinkNavigationResource/anyOf/0/required",
                                  keyword: "required",
                                  params: {
                                    missingProperty: missing5
                                  },
                                  message: "must have required property '" + missing5 + "'"
                                };
                                if (vErrors === null) {
                                  vErrors = [err31];
                                } else {
                                  vErrors.push(err31);
                                }
                                errors++;
                              } else {
                                if (data17.linkType !== void 0) {
                                  let data18 = data17.linkType;
                                  const _errs50 = errors;
                                  if (typeof data18 !== "string") {
                                    const err32 = {
                                      instancePath: instancePath + "/items/" + i2 + "/linkType",
                                      schemaPath: "LinkNavigationResource/anyOf/0/properties/linkType/type",
                                      keyword: "type",
                                      params: {
                                        type: "string"
                                      },
                                      message: "must be string"
                                    };
                                    if (vErrors === null) {
                                      vErrors = [err32];
                                    } else {
                                      vErrors.push(err32);
                                    }
                                    errors++;
                                  }
                                  if ("url" !== data18) {
                                    const err33 = {
                                      instancePath: instancePath + "/items/" + i2 + "/linkType",
                                      schemaPath: "LinkNavigationResource/anyOf/0/properties/linkType/const",
                                      keyword: "const",
                                      params: {
                                        allowedValue: "url"
                                      },
                                      message: "must be equal to constant"
                                    };
                                    if (vErrors === null) {
                                      vErrors = [err33];
                                    } else {
                                      vErrors.push(err33);
                                    }
                                    errors++;
                                  }
                                  var valid14 = _errs50 === errors;
                                } else {
                                  var valid14 = true;
                                }
                                if (valid14) {
                                  if (data17.url !== void 0) {
                                    const _errs52 = errors;
                                    if (typeof data17.url !== "string") {
                                      const err34 = {
                                        instancePath: instancePath + "/items/" + i2 + "/url",
                                        schemaPath: "LinkNavigationResource/anyOf/0/properties/url/type",
                                        keyword: "type",
                                        params: {
                                          type: "string"
                                        },
                                        message: "must be string"
                                      };
                                      if (vErrors === null) {
                                        vErrors = [err34];
                                      } else {
                                        vErrors.push(err34);
                                      }
                                      errors++;
                                    }
                                    var valid14 = _errs52 === errors;
                                  } else {
                                    var valid14 = true;
                                  }
                                  if (valid14) {
                                    if (data17.type !== void 0) {
                                      let data20 = data17.type;
                                      const _errs54 = errors;
                                      if (typeof data20 !== "string") {
                                        const err35 = {
                                          instancePath: instancePath + "/items/" + i2 + "/type",
                                          schemaPath: "LinkNavigationResource/anyOf/0/properties/type/type",
                                          keyword: "type",
                                          params: {
                                            type: "string"
                                          },
                                          message: "must be string"
                                        };
                                        if (vErrors === null) {
                                          vErrors = [err35];
                                        } else {
                                          vErrors.push(err35);
                                        }
                                        errors++;
                                      }
                                      if ("LINK" !== data20) {
                                        const err36 = {
                                          instancePath: instancePath + "/items/" + i2 + "/type",
                                          schemaPath: "LinkNavigationResource/anyOf/0/properties/type/const",
                                          keyword: "const",
                                          params: {
                                            allowedValue: "LINK"
                                          },
                                          message: "must be equal to constant"
                                        };
                                        if (vErrors === null) {
                                          vErrors = [err36];
                                        } else {
                                          vErrors.push(err36);
                                        }
                                        errors++;
                                      }
                                      var valid14 = _errs54 === errors;
                                    } else {
                                      var valid14 = true;
                                    }
                                    if (valid14) {
                                      if (data17.label !== void 0) {
                                        const _errs56 = errors;
                                        if (typeof data17.label !== "string") {
                                          const err37 = {
                                            instancePath: instancePath + "/items/" + i2 + "/label",
                                            schemaPath: "LinkNavigationResource/anyOf/0/properties/label/type",
                                            keyword: "type",
                                            params: {
                                              type: "string"
                                            },
                                            message: "must be string"
                                          };
                                          if (vErrors === null) {
                                            vErrors = [err37];
                                          } else {
                                            vErrors.push(err37);
                                          }
                                          errors++;
                                        }
                                        var valid14 = _errs56 === errors;
                                      } else {
                                        var valid14 = true;
                                      }
                                      if (valid14) {
                                        if (data17.external !== void 0) {
                                          const _errs58 = errors;
                                          if (typeof data17.external !== "boolean") {
                                            const err38 = {
                                              instancePath: instancePath + "/items/" + i2 + "/external",
                                              schemaPath: "LinkNavigationResource/anyOf/0/properties/external/type",
                                              keyword: "type",
                                              params: {
                                                type: "boolean"
                                              },
                                              message: "must be boolean"
                                            };
                                            if (vErrors === null) {
                                              vErrors = [err38];
                                            } else {
                                              vErrors.push(err38);
                                            }
                                            errors++;
                                          }
                                          var valid14 = _errs58 === errors;
                                        } else {
                                          var valid14 = true;
                                        }
                                      }
                                    }
                                  }
                                }
                              }
                            } else {
                              const err39 = {
                                instancePath: instancePath + "/items/" + i2,
                                schemaPath: "LinkNavigationResource/anyOf/0/type",
                                keyword: "type",
                                params: {
                                  type: "object"
                                },
                                message: "must be object"
                              };
                              if (vErrors === null) {
                                vErrors = [err39];
                              } else {
                                vErrors.push(err39);
                              }
                              errors++;
                            }
                          }
                          var _valid1 = _errs48 === errors;
                          valid13 = valid13 || _valid1;
                          if (!valid13) {
                            const _errs60 = errors;
                            if (errors === _errs60) {
                              if (data17 && typeof data17 == "object" && !Array.isArray(data17)) {
                                let missing6;
                                if (data17.label === void 0 && (missing6 = "label") || data17.linkType === void 0 && (missing6 = "linkType") || data17.pageId === void 0 && (missing6 = "pageId") || data17.type === void 0 && (missing6 = "type")) {
                                  const err40 = {
                                    instancePath: instancePath + "/items/" + i2,
                                    schemaPath: "LinkNavigationResource/anyOf/1/required",
                                    keyword: "required",
                                    params: {
                                      missingProperty: missing6
                                    },
                                    message: "must have required property '" + missing6 + "'"
                                  };
                                  if (vErrors === null) {
                                    vErrors = [err40];
                                  } else {
                                    vErrors.push(err40);
                                  }
                                  errors++;
                                } else {
                                  if (data17.linkType !== void 0) {
                                    let data23 = data17.linkType;
                                    const _errs62 = errors;
                                    if (typeof data23 !== "string") {
                                      const err41 = {
                                        instancePath: instancePath + "/items/" + i2 + "/linkType",
                                        schemaPath: "LinkNavigationResource/anyOf/1/properties/linkType/type",
                                        keyword: "type",
                                        params: {
                                          type: "string"
                                        },
                                        message: "must be string"
                                      };
                                      if (vErrors === null) {
                                        vErrors = [err41];
                                      } else {
                                        vErrors.push(err41);
                                      }
                                      errors++;
                                    }
                                    if ("page" !== data23) {
                                      const err42 = {
                                        instancePath: instancePath + "/items/" + i2 + "/linkType",
                                        schemaPath: "LinkNavigationResource/anyOf/1/properties/linkType/const",
                                        keyword: "const",
                                        params: {
                                          allowedValue: "page"
                                        },
                                        message: "must be equal to constant"
                                      };
                                      if (vErrors === null) {
                                        vErrors = [err42];
                                      } else {
                                        vErrors.push(err42);
                                      }
                                      errors++;
                                    }
                                    var valid15 = _errs62 === errors;
                                  } else {
                                    var valid15 = true;
                                  }
                                  if (valid15) {
                                    if (data17.pageId !== void 0) {
                                      const _errs64 = errors;
                                      if (typeof data17.pageId !== "string") {
                                        const err43 = {
                                          instancePath: instancePath + "/items/" + i2 + "/pageId",
                                          schemaPath: "LinkNavigationResource/anyOf/1/properties/pageId/type",
                                          keyword: "type",
                                          params: {
                                            type: "string"
                                          },
                                          message: "must be string"
                                        };
                                        if (vErrors === null) {
                                          vErrors = [err43];
                                        } else {
                                          vErrors.push(err43);
                                        }
                                        errors++;
                                      }
                                      var valid15 = _errs64 === errors;
                                    } else {
                                      var valid15 = true;
                                    }
                                    if (valid15) {
                                      if (data17.type !== void 0) {
                                        let data25 = data17.type;
                                        const _errs66 = errors;
                                        if (typeof data25 !== "string") {
                                          const err44 = {
                                            instancePath: instancePath + "/items/" + i2 + "/type",
                                            schemaPath: "LinkNavigationResource/anyOf/1/properties/type/type",
                                            keyword: "type",
                                            params: {
                                              type: "string"
                                            },
                                            message: "must be string"
                                          };
                                          if (vErrors === null) {
                                            vErrors = [err44];
                                          } else {
                                            vErrors.push(err44);
                                          }
                                          errors++;
                                        }
                                        if ("LINK" !== data25) {
                                          const err45 = {
                                            instancePath: instancePath + "/items/" + i2 + "/type",
                                            schemaPath: "LinkNavigationResource/anyOf/1/properties/type/const",
                                            keyword: "const",
                                            params: {
                                              allowedValue: "LINK"
                                            },
                                            message: "must be equal to constant"
                                          };
                                          if (vErrors === null) {
                                            vErrors = [err45];
                                          } else {
                                            vErrors.push(err45);
                                          }
                                          errors++;
                                        }
                                        var valid15 = _errs66 === errors;
                                      } else {
                                        var valid15 = true;
                                      }
                                      if (valid15) {
                                        if (data17.label !== void 0) {
                                          const _errs68 = errors;
                                          if (typeof data17.label !== "string") {
                                            const err46 = {
                                              instancePath: instancePath + "/items/" + i2 + "/label",
                                              schemaPath: "LinkNavigationResource/anyOf/1/properties/label/type",
                                              keyword: "type",
                                              params: {
                                                type: "string"
                                              },
                                              message: "must be string"
                                            };
                                            if (vErrors === null) {
                                              vErrors = [err46];
                                            } else {
                                              vErrors.push(err46);
                                            }
                                            errors++;
                                          }
                                          var valid15 = _errs68 === errors;
                                        } else {
                                          var valid15 = true;
                                        }
                                        if (valid15) {
                                          if (data17.external !== void 0) {
                                            const _errs70 = errors;
                                            if (typeof data17.external !== "boolean") {
                                              const err47 = {
                                                instancePath: instancePath + "/items/" + i2 + "/external",
                                                schemaPath: "LinkNavigationResource/anyOf/1/properties/external/type",
                                                keyword: "type",
                                                params: {
                                                  type: "boolean"
                                                },
                                                message: "must be boolean"
                                              };
                                              if (vErrors === null) {
                                                vErrors = [err47];
                                              } else {
                                                vErrors.push(err47);
                                              }
                                              errors++;
                                            }
                                            var valid15 = _errs70 === errors;
                                          } else {
                                            var valid15 = true;
                                          }
                                        }
                                      }
                                    }
                                  }
                                }
                              } else {
                                const err48 = {
                                  instancePath: instancePath + "/items/" + i2,
                                  schemaPath: "LinkNavigationResource/anyOf/1/type",
                                  keyword: "type",
                                  params: {
                                    type: "object"
                                  },
                                  message: "must be object"
                                };
                                if (vErrors === null) {
                                  vErrors = [err48];
                                } else {
                                  vErrors.push(err48);
                                }
                                errors++;
                              }
                            }
                            var _valid1 = _errs60 === errors;
                            valid13 = valid13 || _valid1;
                            if (!valid13) {
                              const _errs72 = errors;
                              if (errors === _errs72) {
                                if (data17 && typeof data17 == "object" && !Array.isArray(data17)) {
                                  let missing7;
                                  if (data17.eventId === void 0 && (missing7 = "eventId") || data17.label === void 0 && (missing7 = "label") || data17.linkType === void 0 && (missing7 = "linkType") || data17.type === void 0 && (missing7 = "type")) {
                                    const err49 = {
                                      instancePath: instancePath + "/items/" + i2,
                                      schemaPath: "LinkNavigationResource/anyOf/2/required",
                                      keyword: "required",
                                      params: {
                                        missingProperty: missing7
                                      },
                                      message: "must have required property '" + missing7 + "'"
                                    };
                                    if (vErrors === null) {
                                      vErrors = [err49];
                                    } else {
                                      vErrors.push(err49);
                                    }
                                    errors++;
                                  } else {
                                    if (data17.linkType !== void 0) {
                                      let data28 = data17.linkType;
                                      const _errs74 = errors;
                                      if (typeof data28 !== "string") {
                                        const err50 = {
                                          instancePath: instancePath + "/items/" + i2 + "/linkType",
                                          schemaPath: "LinkNavigationResource/anyOf/2/properties/linkType/type",
                                          keyword: "type",
                                          params: {
                                            type: "string"
                                          },
                                          message: "must be string"
                                        };
                                        if (vErrors === null) {
                                          vErrors = [err50];
                                        } else {
                                          vErrors.push(err50);
                                        }
                                        errors++;
                                      }
                                      if ("event" !== data28) {
                                        const err51 = {
                                          instancePath: instancePath + "/items/" + i2 + "/linkType",
                                          schemaPath: "LinkNavigationResource/anyOf/2/properties/linkType/const",
                                          keyword: "const",
                                          params: {
                                            allowedValue: "event"
                                          },
                                          message: "must be equal to constant"
                                        };
                                        if (vErrors === null) {
                                          vErrors = [err51];
                                        } else {
                                          vErrors.push(err51);
                                        }
                                        errors++;
                                      }
                                      var valid16 = _errs74 === errors;
                                    } else {
                                      var valid16 = true;
                                    }
                                    if (valid16) {
                                      if (data17.eventId !== void 0) {
                                        const _errs76 = errors;
                                        if (typeof data17.eventId !== "string") {
                                          const err52 = {
                                            instancePath: instancePath + "/items/" + i2 + "/eventId",
                                            schemaPath: "LinkNavigationResource/anyOf/2/properties/eventId/type",
                                            keyword: "type",
                                            params: {
                                              type: "string"
                                            },
                                            message: "must be string"
                                          };
                                          if (vErrors === null) {
                                            vErrors = [err52];
                                          } else {
                                            vErrors.push(err52);
                                          }
                                          errors++;
                                        }
                                        var valid16 = _errs76 === errors;
                                      } else {
                                        var valid16 = true;
                                      }
                                      if (valid16) {
                                        if (data17.type !== void 0) {
                                          let data30 = data17.type;
                                          const _errs78 = errors;
                                          if (typeof data30 !== "string") {
                                            const err53 = {
                                              instancePath: instancePath + "/items/" + i2 + "/type",
                                              schemaPath: "LinkNavigationResource/anyOf/2/properties/type/type",
                                              keyword: "type",
                                              params: {
                                                type: "string"
                                              },
                                              message: "must be string"
                                            };
                                            if (vErrors === null) {
                                              vErrors = [err53];
                                            } else {
                                              vErrors.push(err53);
                                            }
                                            errors++;
                                          }
                                          if ("LINK" !== data30) {
                                            const err54 = {
                                              instancePath: instancePath + "/items/" + i2 + "/type",
                                              schemaPath: "LinkNavigationResource/anyOf/2/properties/type/const",
                                              keyword: "const",
                                              params: {
                                                allowedValue: "LINK"
                                              },
                                              message: "must be equal to constant"
                                            };
                                            if (vErrors === null) {
                                              vErrors = [err54];
                                            } else {
                                              vErrors.push(err54);
                                            }
                                            errors++;
                                          }
                                          var valid16 = _errs78 === errors;
                                        } else {
                                          var valid16 = true;
                                        }
                                        if (valid16) {
                                          if (data17.label !== void 0) {
                                            const _errs80 = errors;
                                            if (typeof data17.label !== "string") {
                                              const err55 = {
                                                instancePath: instancePath + "/items/" + i2 + "/label",
                                                schemaPath: "LinkNavigationResource/anyOf/2/properties/label/type",
                                                keyword: "type",
                                                params: {
                                                  type: "string"
                                                },
                                                message: "must be string"
                                              };
                                              if (vErrors === null) {
                                                vErrors = [err55];
                                              } else {
                                                vErrors.push(err55);
                                              }
                                              errors++;
                                            }
                                            var valid16 = _errs80 === errors;
                                          } else {
                                            var valid16 = true;
                                          }
                                          if (valid16) {
                                            if (data17.external !== void 0) {
                                              const _errs82 = errors;
                                              if (typeof data17.external !== "boolean") {
                                                const err56 = {
                                                  instancePath: instancePath + "/items/" + i2 + "/external",
                                                  schemaPath: "LinkNavigationResource/anyOf/2/properties/external/type",
                                                  keyword: "type",
                                                  params: {
                                                    type: "boolean"
                                                  },
                                                  message: "must be boolean"
                                                };
                                                if (vErrors === null) {
                                                  vErrors = [err56];
                                                } else {
                                                  vErrors.push(err56);
                                                }
                                                errors++;
                                              }
                                              var valid16 = _errs82 === errors;
                                            } else {
                                              var valid16 = true;
                                            }
                                          }
                                        }
                                      }
                                    }
                                  }
                                } else {
                                  const err57 = {
                                    instancePath: instancePath + "/items/" + i2,
                                    schemaPath: "LinkNavigationResource/anyOf/2/type",
                                    keyword: "type",
                                    params: {
                                      type: "object"
                                    },
                                    message: "must be object"
                                  };
                                  if (vErrors === null) {
                                    vErrors = [err57];
                                  } else {
                                    vErrors.push(err57);
                                  }
                                  errors++;
                                }
                              }
                              var _valid1 = _errs72 === errors;
                              valid13 = valid13 || _valid1;
                              if (!valid13) {
                                const _errs84 = errors;
                                if (errors === _errs84) {
                                  if (data17 && typeof data17 == "object" && !Array.isArray(data17)) {
                                    let missing8;
                                    if (data17.label === void 0 && (missing8 = "label") || data17.linkType === void 0 && (missing8 = "linkType") || data17.type === void 0 && (missing8 = "type") || data17.videoId === void 0 && (missing8 = "videoId")) {
                                      const err58 = {
                                        instancePath: instancePath + "/items/" + i2,
                                        schemaPath: "LinkNavigationResource/anyOf/3/required",
                                        keyword: "required",
                                        params: {
                                          missingProperty: missing8
                                        },
                                        message: "must have required property '" + missing8 + "'"
                                      };
                                      if (vErrors === null) {
                                        vErrors = [err58];
                                      } else {
                                        vErrors.push(err58);
                                      }
                                      errors++;
                                    } else {
                                      if (data17.linkType !== void 0) {
                                        let data33 = data17.linkType;
                                        const _errs86 = errors;
                                        if (typeof data33 !== "string") {
                                          const err59 = {
                                            instancePath: instancePath + "/items/" + i2 + "/linkType",
                                            schemaPath: "LinkNavigationResource/anyOf/3/properties/linkType/type",
                                            keyword: "type",
                                            params: {
                                              type: "string"
                                            },
                                            message: "must be string"
                                          };
                                          if (vErrors === null) {
                                            vErrors = [err59];
                                          } else {
                                            vErrors.push(err59);
                                          }
                                          errors++;
                                        }
                                        if ("video" !== data33) {
                                          const err60 = {
                                            instancePath: instancePath + "/items/" + i2 + "/linkType",
                                            schemaPath: "LinkNavigationResource/anyOf/3/properties/linkType/const",
                                            keyword: "const",
                                            params: {
                                              allowedValue: "video"
                                            },
                                            message: "must be equal to constant"
                                          };
                                          if (vErrors === null) {
                                            vErrors = [err60];
                                          } else {
                                            vErrors.push(err60);
                                          }
                                          errors++;
                                        }
                                        var valid17 = _errs86 === errors;
                                      } else {
                                        var valid17 = true;
                                      }
                                      if (valid17) {
                                        if (data17.videoId !== void 0) {
                                          const _errs88 = errors;
                                          if (typeof data17.videoId !== "string") {
                                            const err61 = {
                                              instancePath: instancePath + "/items/" + i2 + "/videoId",
                                              schemaPath: "LinkNavigationResource/anyOf/3/properties/videoId/type",
                                              keyword: "type",
                                              params: {
                                                type: "string"
                                              },
                                              message: "must be string"
                                            };
                                            if (vErrors === null) {
                                              vErrors = [err61];
                                            } else {
                                              vErrors.push(err61);
                                            }
                                            errors++;
                                          }
                                          var valid17 = _errs88 === errors;
                                        } else {
                                          var valid17 = true;
                                        }
                                        if (valid17) {
                                          if (data17.type !== void 0) {
                                            let data35 = data17.type;
                                            const _errs90 = errors;
                                            if (typeof data35 !== "string") {
                                              const err62 = {
                                                instancePath: instancePath + "/items/" + i2 + "/type",
                                                schemaPath: "LinkNavigationResource/anyOf/3/properties/type/type",
                                                keyword: "type",
                                                params: {
                                                  type: "string"
                                                },
                                                message: "must be string"
                                              };
                                              if (vErrors === null) {
                                                vErrors = [err62];
                                              } else {
                                                vErrors.push(err62);
                                              }
                                              errors++;
                                            }
                                            if ("LINK" !== data35) {
                                              const err63 = {
                                                instancePath: instancePath + "/items/" + i2 + "/type",
                                                schemaPath: "LinkNavigationResource/anyOf/3/properties/type/const",
                                                keyword: "const",
                                                params: {
                                                  allowedValue: "LINK"
                                                },
                                                message: "must be equal to constant"
                                              };
                                              if (vErrors === null) {
                                                vErrors = [err63];
                                              } else {
                                                vErrors.push(err63);
                                              }
                                              errors++;
                                            }
                                            var valid17 = _errs90 === errors;
                                          } else {
                                            var valid17 = true;
                                          }
                                          if (valid17) {
                                            if (data17.label !== void 0) {
                                              const _errs92 = errors;
                                              if (typeof data17.label !== "string") {
                                                const err64 = {
                                                  instancePath: instancePath + "/items/" + i2 + "/label",
                                                  schemaPath: "LinkNavigationResource/anyOf/3/properties/label/type",
                                                  keyword: "type",
                                                  params: {
                                                    type: "string"
                                                  },
                                                  message: "must be string"
                                                };
                                                if (vErrors === null) {
                                                  vErrors = [err64];
                                                } else {
                                                  vErrors.push(err64);
                                                }
                                                errors++;
                                              }
                                              var valid17 = _errs92 === errors;
                                            } else {
                                              var valid17 = true;
                                            }
                                            if (valid17) {
                                              if (data17.external !== void 0) {
                                                const _errs94 = errors;
                                                if (typeof data17.external !== "boolean") {
                                                  const err65 = {
                                                    instancePath: instancePath + "/items/" + i2 + "/external",
                                                    schemaPath: "LinkNavigationResource/anyOf/3/properties/external/type",
                                                    keyword: "type",
                                                    params: {
                                                      type: "boolean"
                                                    },
                                                    message: "must be boolean"
                                                  };
                                                  if (vErrors === null) {
                                                    vErrors = [err65];
                                                  } else {
                                                    vErrors.push(err65);
                                                  }
                                                  errors++;
                                                }
                                                var valid17 = _errs94 === errors;
                                              } else {
                                                var valid17 = true;
                                              }
                                            }
                                          }
                                        }
                                      }
                                    }
                                  } else {
                                    const err66 = {
                                      instancePath: instancePath + "/items/" + i2,
                                      schemaPath: "LinkNavigationResource/anyOf/3/type",
                                      keyword: "type",
                                      params: {
                                        type: "object"
                                      },
                                      message: "must be object"
                                    };
                                    if (vErrors === null) {
                                      vErrors = [err66];
                                    } else {
                                      vErrors.push(err66);
                                    }
                                    errors++;
                                  }
                                }
                                var _valid1 = _errs84 === errors;
                                valid13 = valid13 || _valid1;
                                if (!valid13) {
                                  const _errs96 = errors;
                                  if (errors === _errs96) {
                                    if (data17 && typeof data17 == "object" && !Array.isArray(data17)) {
                                      let missing9;
                                      if (data17.label === void 0 && (missing9 = "label") || data17.linkType === void 0 && (missing9 = "linkType") || data17.tagName === void 0 && (missing9 = "tagName") || data17.type === void 0 && (missing9 = "type")) {
                                        const err67 = {
                                          instancePath: instancePath + "/items/" + i2,
                                          schemaPath: "LinkNavigationResource/anyOf/4/required",
                                          keyword: "required",
                                          params: {
                                            missingProperty: missing9
                                          },
                                          message: "must have required property '" + missing9 + "'"
                                        };
                                        if (vErrors === null) {
                                          vErrors = [err67];
                                        } else {
                                          vErrors.push(err67);
                                        }
                                        errors++;
                                      } else {
                                        if (data17.linkType !== void 0) {
                                          let data38 = data17.linkType;
                                          const _errs98 = errors;
                                          if (typeof data38 !== "string") {
                                            const err68 = {
                                              instancePath: instancePath + "/items/" + i2 + "/linkType",
                                              schemaPath: "LinkNavigationResource/anyOf/4/properties/linkType/type",
                                              keyword: "type",
                                              params: {
                                                type: "string"
                                              },
                                              message: "must be string"
                                            };
                                            if (vErrors === null) {
                                              vErrors = [err68];
                                            } else {
                                              vErrors.push(err68);
                                            }
                                            errors++;
                                          }
                                          if ("tag" !== data38) {
                                            const err69 = {
                                              instancePath: instancePath + "/items/" + i2 + "/linkType",
                                              schemaPath: "LinkNavigationResource/anyOf/4/properties/linkType/const",
                                              keyword: "const",
                                              params: {
                                                allowedValue: "tag"
                                              },
                                              message: "must be equal to constant"
                                            };
                                            if (vErrors === null) {
                                              vErrors = [err69];
                                            } else {
                                              vErrors.push(err69);
                                            }
                                            errors++;
                                          }
                                          var valid18 = _errs98 === errors;
                                        } else {
                                          var valid18 = true;
                                        }
                                        if (valid18) {
                                          if (data17.tagName !== void 0) {
                                            const _errs100 = errors;
                                            if (typeof data17.tagName !== "string") {
                                              const err70 = {
                                                instancePath: instancePath + "/items/" + i2 + "/tagName",
                                                schemaPath: "LinkNavigationResource/anyOf/4/properties/tagName/type",
                                                keyword: "type",
                                                params: {
                                                  type: "string"
                                                },
                                                message: "must be string"
                                              };
                                              if (vErrors === null) {
                                                vErrors = [err70];
                                              } else {
                                                vErrors.push(err70);
                                              }
                                              errors++;
                                            }
                                            var valid18 = _errs100 === errors;
                                          } else {
                                            var valid18 = true;
                                          }
                                          if (valid18) {
                                            if (data17.type !== void 0) {
                                              let data40 = data17.type;
                                              const _errs102 = errors;
                                              if (typeof data40 !== "string") {
                                                const err71 = {
                                                  instancePath: instancePath + "/items/" + i2 + "/type",
                                                  schemaPath: "LinkNavigationResource/anyOf/4/properties/type/type",
                                                  keyword: "type",
                                                  params: {
                                                    type: "string"
                                                  },
                                                  message: "must be string"
                                                };
                                                if (vErrors === null) {
                                                  vErrors = [err71];
                                                } else {
                                                  vErrors.push(err71);
                                                }
                                                errors++;
                                              }
                                              if ("LINK" !== data40) {
                                                const err72 = {
                                                  instancePath: instancePath + "/items/" + i2 + "/type",
                                                  schemaPath: "LinkNavigationResource/anyOf/4/properties/type/const",
                                                  keyword: "const",
                                                  params: {
                                                    allowedValue: "LINK"
                                                  },
                                                  message: "must be equal to constant"
                                                };
                                                if (vErrors === null) {
                                                  vErrors = [err72];
                                                } else {
                                                  vErrors.push(err72);
                                                }
                                                errors++;
                                              }
                                              var valid18 = _errs102 === errors;
                                            } else {
                                              var valid18 = true;
                                            }
                                            if (valid18) {
                                              if (data17.label !== void 0) {
                                                const _errs104 = errors;
                                                if (typeof data17.label !== "string") {
                                                  const err73 = {
                                                    instancePath: instancePath + "/items/" + i2 + "/label",
                                                    schemaPath: "LinkNavigationResource/anyOf/4/properties/label/type",
                                                    keyword: "type",
                                                    params: {
                                                      type: "string"
                                                    },
                                                    message: "must be string"
                                                  };
                                                  if (vErrors === null) {
                                                    vErrors = [err73];
                                                  } else {
                                                    vErrors.push(err73);
                                                  }
                                                  errors++;
                                                }
                                                var valid18 = _errs104 === errors;
                                              } else {
                                                var valid18 = true;
                                              }
                                              if (valid18) {
                                                if (data17.external !== void 0) {
                                                  const _errs106 = errors;
                                                  if (typeof data17.external !== "boolean") {
                                                    const err74 = {
                                                      instancePath: instancePath + "/items/" + i2 + "/external",
                                                      schemaPath: "LinkNavigationResource/anyOf/4/properties/external/type",
                                                      keyword: "type",
                                                      params: {
                                                        type: "boolean"
                                                      },
                                                      message: "must be boolean"
                                                    };
                                                    if (vErrors === null) {
                                                      vErrors = [err74];
                                                    } else {
                                                      vErrors.push(err74);
                                                    }
                                                    errors++;
                                                  }
                                                  var valid18 = _errs106 === errors;
                                                } else {
                                                  var valid18 = true;
                                                }
                                              }
                                            }
                                          }
                                        }
                                      }
                                    } else {
                                      const err75 = {
                                        instancePath: instancePath + "/items/" + i2,
                                        schemaPath: "LinkNavigationResource/anyOf/4/type",
                                        keyword: "type",
                                        params: {
                                          type: "object"
                                        },
                                        message: "must be object"
                                      };
                                      if (vErrors === null) {
                                        vErrors = [err75];
                                      } else {
                                        vErrors.push(err75);
                                      }
                                      errors++;
                                    }
                                  }
                                  var _valid1 = _errs96 === errors;
                                  valid13 = valid13 || _valid1;
                                }
                              }
                            }
                          }
                          if (!valid13) {
                            const err76 = {
                              instancePath: instancePath + "/items/" + i2,
                              schemaPath: "LinkNavigationResource/anyOf",
                              keyword: "anyOf",
                              params: {},
                              message: "must match a schema in anyOf"
                            };
                            if (vErrors === null) {
                              vErrors = [err76];
                            } else {
                              vErrors.push(err76);
                            }
                            errors++;
                          } else {
                            errors = _errs47;
                            if (vErrors !== null) {
                              if (_errs47) {
                                vErrors.length = _errs47;
                              } else {
                                vErrors = null;
                              }
                            }
                          }
                          var valid11 = _errs45 === errors;
                          if (!valid11) {
                            break;
                          }
                        }
                      } else {
                        const err77 = {
                          instancePath: instancePath + "/items",
                          schemaPath: "#/anyOf/3/properties/items/type",
                          keyword: "type",
                          params: {
                            type: "array"
                          },
                          message: "must be array"
                        };
                        if (vErrors === null) {
                          vErrors = [err77];
                        } else {
                          vErrors.push(err77);
                        }
                        errors++;
                      }
                    }
                    var valid10 = _errs43 === errors;
                  } else {
                    var valid10 = true;
                  }
                }
              }
            }
          } else {
            const err78 = {
              instancePath,
              schemaPath: "#/anyOf/3/type",
              keyword: "type",
              params: {
                type: "object"
              },
              message: "must be object"
            };
            if (vErrors === null) {
              vErrors = [err78];
            } else {
              vErrors.push(err78);
            }
            errors++;
          }
        }
        var _valid0 = _errs37 === errors;
        valid0 = valid0 || _valid0;
        if (!valid0) {
          const _errs108 = errors;
          const _errs110 = errors;
          let valid20 = false;
          const _errs111 = errors;
          if (errors === _errs111) {
            if (data && typeof data == "object" && !Array.isArray(data)) {
              let missing10;
              if (data.label === void 0 && (missing10 = "label") || data.linkType === void 0 && (missing10 = "linkType") || data.type === void 0 && (missing10 = "type") || data.url === void 0 && (missing10 = "url")) {
                const err79 = {
                  instancePath,
                  schemaPath: "LinkNavigationResource/anyOf/0/required",
                  keyword: "required",
                  params: {
                    missingProperty: missing10
                  },
                  message: "must have required property '" + missing10 + "'"
                };
                if (vErrors === null) {
                  vErrors = [err79];
                } else {
                  vErrors.push(err79);
                }
                errors++;
              } else {
                if (data.linkType !== void 0) {
                  let data43 = data.linkType;
                  const _errs113 = errors;
                  if (typeof data43 !== "string") {
                    const err80 = {
                      instancePath: instancePath + "/linkType",
                      schemaPath: "LinkNavigationResource/anyOf/0/properties/linkType/type",
                      keyword: "type",
                      params: {
                        type: "string"
                      },
                      message: "must be string"
                    };
                    if (vErrors === null) {
                      vErrors = [err80];
                    } else {
                      vErrors.push(err80);
                    }
                    errors++;
                  }
                  if ("url" !== data43) {
                    const err81 = {
                      instancePath: instancePath + "/linkType",
                      schemaPath: "LinkNavigationResource/anyOf/0/properties/linkType/const",
                      keyword: "const",
                      params: {
                        allowedValue: "url"
                      },
                      message: "must be equal to constant"
                    };
                    if (vErrors === null) {
                      vErrors = [err81];
                    } else {
                      vErrors.push(err81);
                    }
                    errors++;
                  }
                  var valid21 = _errs113 === errors;
                } else {
                  var valid21 = true;
                }
                if (valid21) {
                  if (data.url !== void 0) {
                    const _errs115 = errors;
                    if (typeof data.url !== "string") {
                      const err82 = {
                        instancePath: instancePath + "/url",
                        schemaPath: "LinkNavigationResource/anyOf/0/properties/url/type",
                        keyword: "type",
                        params: {
                          type: "string"
                        },
                        message: "must be string"
                      };
                      if (vErrors === null) {
                        vErrors = [err82];
                      } else {
                        vErrors.push(err82);
                      }
                      errors++;
                    }
                    var valid21 = _errs115 === errors;
                  } else {
                    var valid21 = true;
                  }
                  if (valid21) {
                    if (data.type !== void 0) {
                      let data45 = data.type;
                      const _errs117 = errors;
                      if (typeof data45 !== "string") {
                        const err83 = {
                          instancePath: instancePath + "/type",
                          schemaPath: "LinkNavigationResource/anyOf/0/properties/type/type",
                          keyword: "type",
                          params: {
                            type: "string"
                          },
                          message: "must be string"
                        };
                        if (vErrors === null) {
                          vErrors = [err83];
                        } else {
                          vErrors.push(err83);
                        }
                        errors++;
                      }
                      if ("LINK" !== data45) {
                        const err84 = {
                          instancePath: instancePath + "/type",
                          schemaPath: "LinkNavigationResource/anyOf/0/properties/type/const",
                          keyword: "const",
                          params: {
                            allowedValue: "LINK"
                          },
                          message: "must be equal to constant"
                        };
                        if (vErrors === null) {
                          vErrors = [err84];
                        } else {
                          vErrors.push(err84);
                        }
                        errors++;
                      }
                      var valid21 = _errs117 === errors;
                    } else {
                      var valid21 = true;
                    }
                    if (valid21) {
                      if (data.label !== void 0) {
                        const _errs119 = errors;
                        if (typeof data.label !== "string") {
                          const err85 = {
                            instancePath: instancePath + "/label",
                            schemaPath: "LinkNavigationResource/anyOf/0/properties/label/type",
                            keyword: "type",
                            params: {
                              type: "string"
                            },
                            message: "must be string"
                          };
                          if (vErrors === null) {
                            vErrors = [err85];
                          } else {
                            vErrors.push(err85);
                          }
                          errors++;
                        }
                        var valid21 = _errs119 === errors;
                      } else {
                        var valid21 = true;
                      }
                      if (valid21) {
                        if (data.external !== void 0) {
                          const _errs121 = errors;
                          if (typeof data.external !== "boolean") {
                            const err86 = {
                              instancePath: instancePath + "/external",
                              schemaPath: "LinkNavigationResource/anyOf/0/properties/external/type",
                              keyword: "type",
                              params: {
                                type: "boolean"
                              },
                              message: "must be boolean"
                            };
                            if (vErrors === null) {
                              vErrors = [err86];
                            } else {
                              vErrors.push(err86);
                            }
                            errors++;
                          }
                          var valid21 = _errs121 === errors;
                        } else {
                          var valid21 = true;
                        }
                      }
                    }
                  }
                }
              }
            } else {
              const err87 = {
                instancePath,
                schemaPath: "LinkNavigationResource/anyOf/0/type",
                keyword: "type",
                params: {
                  type: "object"
                },
                message: "must be object"
              };
              if (vErrors === null) {
                vErrors = [err87];
              } else {
                vErrors.push(err87);
              }
              errors++;
            }
          }
          var _valid2 = _errs111 === errors;
          valid20 = valid20 || _valid2;
          if (!valid20) {
            const _errs123 = errors;
            if (errors === _errs123) {
              if (data && typeof data == "object" && !Array.isArray(data)) {
                let missing11;
                if (data.label === void 0 && (missing11 = "label") || data.linkType === void 0 && (missing11 = "linkType") || data.pageId === void 0 && (missing11 = "pageId") || data.type === void 0 && (missing11 = "type")) {
                  const err88 = {
                    instancePath,
                    schemaPath: "LinkNavigationResource/anyOf/1/required",
                    keyword: "required",
                    params: {
                      missingProperty: missing11
                    },
                    message: "must have required property '" + missing11 + "'"
                  };
                  if (vErrors === null) {
                    vErrors = [err88];
                  } else {
                    vErrors.push(err88);
                  }
                  errors++;
                } else {
                  if (data.linkType !== void 0) {
                    let data48 = data.linkType;
                    const _errs125 = errors;
                    if (typeof data48 !== "string") {
                      const err89 = {
                        instancePath: instancePath + "/linkType",
                        schemaPath: "LinkNavigationResource/anyOf/1/properties/linkType/type",
                        keyword: "type",
                        params: {
                          type: "string"
                        },
                        message: "must be string"
                      };
                      if (vErrors === null) {
                        vErrors = [err89];
                      } else {
                        vErrors.push(err89);
                      }
                      errors++;
                    }
                    if ("page" !== data48) {
                      const err90 = {
                        instancePath: instancePath + "/linkType",
                        schemaPath: "LinkNavigationResource/anyOf/1/properties/linkType/const",
                        keyword: "const",
                        params: {
                          allowedValue: "page"
                        },
                        message: "must be equal to constant"
                      };
                      if (vErrors === null) {
                        vErrors = [err90];
                      } else {
                        vErrors.push(err90);
                      }
                      errors++;
                    }
                    var valid22 = _errs125 === errors;
                  } else {
                    var valid22 = true;
                  }
                  if (valid22) {
                    if (data.pageId !== void 0) {
                      const _errs127 = errors;
                      if (typeof data.pageId !== "string") {
                        const err91 = {
                          instancePath: instancePath + "/pageId",
                          schemaPath: "LinkNavigationResource/anyOf/1/properties/pageId/type",
                          keyword: "type",
                          params: {
                            type: "string"
                          },
                          message: "must be string"
                        };
                        if (vErrors === null) {
                          vErrors = [err91];
                        } else {
                          vErrors.push(err91);
                        }
                        errors++;
                      }
                      var valid22 = _errs127 === errors;
                    } else {
                      var valid22 = true;
                    }
                    if (valid22) {
                      if (data.type !== void 0) {
                        let data50 = data.type;
                        const _errs129 = errors;
                        if (typeof data50 !== "string") {
                          const err92 = {
                            instancePath: instancePath + "/type",
                            schemaPath: "LinkNavigationResource/anyOf/1/properties/type/type",
                            keyword: "type",
                            params: {
                              type: "string"
                            },
                            message: "must be string"
                          };
                          if (vErrors === null) {
                            vErrors = [err92];
                          } else {
                            vErrors.push(err92);
                          }
                          errors++;
                        }
                        if ("LINK" !== data50) {
                          const err93 = {
                            instancePath: instancePath + "/type",
                            schemaPath: "LinkNavigationResource/anyOf/1/properties/type/const",
                            keyword: "const",
                            params: {
                              allowedValue: "LINK"
                            },
                            message: "must be equal to constant"
                          };
                          if (vErrors === null) {
                            vErrors = [err93];
                          } else {
                            vErrors.push(err93);
                          }
                          errors++;
                        }
                        var valid22 = _errs129 === errors;
                      } else {
                        var valid22 = true;
                      }
                      if (valid22) {
                        if (data.label !== void 0) {
                          const _errs131 = errors;
                          if (typeof data.label !== "string") {
                            const err94 = {
                              instancePath: instancePath + "/label",
                              schemaPath: "LinkNavigationResource/anyOf/1/properties/label/type",
                              keyword: "type",
                              params: {
                                type: "string"
                              },
                              message: "must be string"
                            };
                            if (vErrors === null) {
                              vErrors = [err94];
                            } else {
                              vErrors.push(err94);
                            }
                            errors++;
                          }
                          var valid22 = _errs131 === errors;
                        } else {
                          var valid22 = true;
                        }
                        if (valid22) {
                          if (data.external !== void 0) {
                            const _errs133 = errors;
                            if (typeof data.external !== "boolean") {
                              const err95 = {
                                instancePath: instancePath + "/external",
                                schemaPath: "LinkNavigationResource/anyOf/1/properties/external/type",
                                keyword: "type",
                                params: {
                                  type: "boolean"
                                },
                                message: "must be boolean"
                              };
                              if (vErrors === null) {
                                vErrors = [err95];
                              } else {
                                vErrors.push(err95);
                              }
                              errors++;
                            }
                            var valid22 = _errs133 === errors;
                          } else {
                            var valid22 = true;
                          }
                        }
                      }
                    }
                  }
                }
              } else {
                const err96 = {
                  instancePath,
                  schemaPath: "LinkNavigationResource/anyOf/1/type",
                  keyword: "type",
                  params: {
                    type: "object"
                  },
                  message: "must be object"
                };
                if (vErrors === null) {
                  vErrors = [err96];
                } else {
                  vErrors.push(err96);
                }
                errors++;
              }
            }
            var _valid2 = _errs123 === errors;
            valid20 = valid20 || _valid2;
            if (!valid20) {
              const _errs135 = errors;
              if (errors === _errs135) {
                if (data && typeof data == "object" && !Array.isArray(data)) {
                  let missing12;
                  if (data.eventId === void 0 && (missing12 = "eventId") || data.label === void 0 && (missing12 = "label") || data.linkType === void 0 && (missing12 = "linkType") || data.type === void 0 && (missing12 = "type")) {
                    const err97 = {
                      instancePath,
                      schemaPath: "LinkNavigationResource/anyOf/2/required",
                      keyword: "required",
                      params: {
                        missingProperty: missing12
                      },
                      message: "must have required property '" + missing12 + "'"
                    };
                    if (vErrors === null) {
                      vErrors = [err97];
                    } else {
                      vErrors.push(err97);
                    }
                    errors++;
                  } else {
                    if (data.linkType !== void 0) {
                      let data53 = data.linkType;
                      const _errs137 = errors;
                      if (typeof data53 !== "string") {
                        const err98 = {
                          instancePath: instancePath + "/linkType",
                          schemaPath: "LinkNavigationResource/anyOf/2/properties/linkType/type",
                          keyword: "type",
                          params: {
                            type: "string"
                          },
                          message: "must be string"
                        };
                        if (vErrors === null) {
                          vErrors = [err98];
                        } else {
                          vErrors.push(err98);
                        }
                        errors++;
                      }
                      if ("event" !== data53) {
                        const err99 = {
                          instancePath: instancePath + "/linkType",
                          schemaPath: "LinkNavigationResource/anyOf/2/properties/linkType/const",
                          keyword: "const",
                          params: {
                            allowedValue: "event"
                          },
                          message: "must be equal to constant"
                        };
                        if (vErrors === null) {
                          vErrors = [err99];
                        } else {
                          vErrors.push(err99);
                        }
                        errors++;
                      }
                      var valid23 = _errs137 === errors;
                    } else {
                      var valid23 = true;
                    }
                    if (valid23) {
                      if (data.eventId !== void 0) {
                        const _errs139 = errors;
                        if (typeof data.eventId !== "string") {
                          const err100 = {
                            instancePath: instancePath + "/eventId",
                            schemaPath: "LinkNavigationResource/anyOf/2/properties/eventId/type",
                            keyword: "type",
                            params: {
                              type: "string"
                            },
                            message: "must be string"
                          };
                          if (vErrors === null) {
                            vErrors = [err100];
                          } else {
                            vErrors.push(err100);
                          }
                          errors++;
                        }
                        var valid23 = _errs139 === errors;
                      } else {
                        var valid23 = true;
                      }
                      if (valid23) {
                        if (data.type !== void 0) {
                          let data55 = data.type;
                          const _errs141 = errors;
                          if (typeof data55 !== "string") {
                            const err101 = {
                              instancePath: instancePath + "/type",
                              schemaPath: "LinkNavigationResource/anyOf/2/properties/type/type",
                              keyword: "type",
                              params: {
                                type: "string"
                              },
                              message: "must be string"
                            };
                            if (vErrors === null) {
                              vErrors = [err101];
                            } else {
                              vErrors.push(err101);
                            }
                            errors++;
                          }
                          if ("LINK" !== data55) {
                            const err102 = {
                              instancePath: instancePath + "/type",
                              schemaPath: "LinkNavigationResource/anyOf/2/properties/type/const",
                              keyword: "const",
                              params: {
                                allowedValue: "LINK"
                              },
                              message: "must be equal to constant"
                            };
                            if (vErrors === null) {
                              vErrors = [err102];
                            } else {
                              vErrors.push(err102);
                            }
                            errors++;
                          }
                          var valid23 = _errs141 === errors;
                        } else {
                          var valid23 = true;
                        }
                        if (valid23) {
                          if (data.label !== void 0) {
                            const _errs143 = errors;
                            if (typeof data.label !== "string") {
                              const err103 = {
                                instancePath: instancePath + "/label",
                                schemaPath: "LinkNavigationResource/anyOf/2/properties/label/type",
                                keyword: "type",
                                params: {
                                  type: "string"
                                },
                                message: "must be string"
                              };
                              if (vErrors === null) {
                                vErrors = [err103];
                              } else {
                                vErrors.push(err103);
                              }
                              errors++;
                            }
                            var valid23 = _errs143 === errors;
                          } else {
                            var valid23 = true;
                          }
                          if (valid23) {
                            if (data.external !== void 0) {
                              const _errs145 = errors;
                              if (typeof data.external !== "boolean") {
                                const err104 = {
                                  instancePath: instancePath + "/external",
                                  schemaPath: "LinkNavigationResource/anyOf/2/properties/external/type",
                                  keyword: "type",
                                  params: {
                                    type: "boolean"
                                  },
                                  message: "must be boolean"
                                };
                                if (vErrors === null) {
                                  vErrors = [err104];
                                } else {
                                  vErrors.push(err104);
                                }
                                errors++;
                              }
                              var valid23 = _errs145 === errors;
                            } else {
                              var valid23 = true;
                            }
                          }
                        }
                      }
                    }
                  }
                } else {
                  const err105 = {
                    instancePath,
                    schemaPath: "LinkNavigationResource/anyOf/2/type",
                    keyword: "type",
                    params: {
                      type: "object"
                    },
                    message: "must be object"
                  };
                  if (vErrors === null) {
                    vErrors = [err105];
                  } else {
                    vErrors.push(err105);
                  }
                  errors++;
                }
              }
              var _valid2 = _errs135 === errors;
              valid20 = valid20 || _valid2;
              if (!valid20) {
                const _errs147 = errors;
                if (errors === _errs147) {
                  if (data && typeof data == "object" && !Array.isArray(data)) {
                    let missing13;
                    if (data.label === void 0 && (missing13 = "label") || data.linkType === void 0 && (missing13 = "linkType") || data.type === void 0 && (missing13 = "type") || data.videoId === void 0 && (missing13 = "videoId")) {
                      const err106 = {
                        instancePath,
                        schemaPath: "LinkNavigationResource/anyOf/3/required",
                        keyword: "required",
                        params: {
                          missingProperty: missing13
                        },
                        message: "must have required property '" + missing13 + "'"
                      };
                      if (vErrors === null) {
                        vErrors = [err106];
                      } else {
                        vErrors.push(err106);
                      }
                      errors++;
                    } else {
                      if (data.linkType !== void 0) {
                        let data58 = data.linkType;
                        const _errs149 = errors;
                        if (typeof data58 !== "string") {
                          const err107 = {
                            instancePath: instancePath + "/linkType",
                            schemaPath: "LinkNavigationResource/anyOf/3/properties/linkType/type",
                            keyword: "type",
                            params: {
                              type: "string"
                            },
                            message: "must be string"
                          };
                          if (vErrors === null) {
                            vErrors = [err107];
                          } else {
                            vErrors.push(err107);
                          }
                          errors++;
                        }
                        if ("video" !== data58) {
                          const err108 = {
                            instancePath: instancePath + "/linkType",
                            schemaPath: "LinkNavigationResource/anyOf/3/properties/linkType/const",
                            keyword: "const",
                            params: {
                              allowedValue: "video"
                            },
                            message: "must be equal to constant"
                          };
                          if (vErrors === null) {
                            vErrors = [err108];
                          } else {
                            vErrors.push(err108);
                          }
                          errors++;
                        }
                        var valid24 = _errs149 === errors;
                      } else {
                        var valid24 = true;
                      }
                      if (valid24) {
                        if (data.videoId !== void 0) {
                          const _errs151 = errors;
                          if (typeof data.videoId !== "string") {
                            const err109 = {
                              instancePath: instancePath + "/videoId",
                              schemaPath: "LinkNavigationResource/anyOf/3/properties/videoId/type",
                              keyword: "type",
                              params: {
                                type: "string"
                              },
                              message: "must be string"
                            };
                            if (vErrors === null) {
                              vErrors = [err109];
                            } else {
                              vErrors.push(err109);
                            }
                            errors++;
                          }
                          var valid24 = _errs151 === errors;
                        } else {
                          var valid24 = true;
                        }
                        if (valid24) {
                          if (data.type !== void 0) {
                            let data60 = data.type;
                            const _errs153 = errors;
                            if (typeof data60 !== "string") {
                              const err110 = {
                                instancePath: instancePath + "/type",
                                schemaPath: "LinkNavigationResource/anyOf/3/properties/type/type",
                                keyword: "type",
                                params: {
                                  type: "string"
                                },
                                message: "must be string"
                              };
                              if (vErrors === null) {
                                vErrors = [err110];
                              } else {
                                vErrors.push(err110);
                              }
                              errors++;
                            }
                            if ("LINK" !== data60) {
                              const err111 = {
                                instancePath: instancePath + "/type",
                                schemaPath: "LinkNavigationResource/anyOf/3/properties/type/const",
                                keyword: "const",
                                params: {
                                  allowedValue: "LINK"
                                },
                                message: "must be equal to constant"
                              };
                              if (vErrors === null) {
                                vErrors = [err111];
                              } else {
                                vErrors.push(err111);
                              }
                              errors++;
                            }
                            var valid24 = _errs153 === errors;
                          } else {
                            var valid24 = true;
                          }
                          if (valid24) {
                            if (data.label !== void 0) {
                              const _errs155 = errors;
                              if (typeof data.label !== "string") {
                                const err112 = {
                                  instancePath: instancePath + "/label",
                                  schemaPath: "LinkNavigationResource/anyOf/3/properties/label/type",
                                  keyword: "type",
                                  params: {
                                    type: "string"
                                  },
                                  message: "must be string"
                                };
                                if (vErrors === null) {
                                  vErrors = [err112];
                                } else {
                                  vErrors.push(err112);
                                }
                                errors++;
                              }
                              var valid24 = _errs155 === errors;
                            } else {
                              var valid24 = true;
                            }
                            if (valid24) {
                              if (data.external !== void 0) {
                                const _errs157 = errors;
                                if (typeof data.external !== "boolean") {
                                  const err113 = {
                                    instancePath: instancePath + "/external",
                                    schemaPath: "LinkNavigationResource/anyOf/3/properties/external/type",
                                    keyword: "type",
                                    params: {
                                      type: "boolean"
                                    },
                                    message: "must be boolean"
                                  };
                                  if (vErrors === null) {
                                    vErrors = [err113];
                                  } else {
                                    vErrors.push(err113);
                                  }
                                  errors++;
                                }
                                var valid24 = _errs157 === errors;
                              } else {
                                var valid24 = true;
                              }
                            }
                          }
                        }
                      }
                    }
                  } else {
                    const err114 = {
                      instancePath,
                      schemaPath: "LinkNavigationResource/anyOf/3/type",
                      keyword: "type",
                      params: {
                        type: "object"
                      },
                      message: "must be object"
                    };
                    if (vErrors === null) {
                      vErrors = [err114];
                    } else {
                      vErrors.push(err114);
                    }
                    errors++;
                  }
                }
                var _valid2 = _errs147 === errors;
                valid20 = valid20 || _valid2;
                if (!valid20) {
                  const _errs159 = errors;
                  if (errors === _errs159) {
                    if (data && typeof data == "object" && !Array.isArray(data)) {
                      let missing14;
                      if (data.label === void 0 && (missing14 = "label") || data.linkType === void 0 && (missing14 = "linkType") || data.tagName === void 0 && (missing14 = "tagName") || data.type === void 0 && (missing14 = "type")) {
                        const err115 = {
                          instancePath,
                          schemaPath: "LinkNavigationResource/anyOf/4/required",
                          keyword: "required",
                          params: {
                            missingProperty: missing14
                          },
                          message: "must have required property '" + missing14 + "'"
                        };
                        if (vErrors === null) {
                          vErrors = [err115];
                        } else {
                          vErrors.push(err115);
                        }
                        errors++;
                      } else {
                        if (data.linkType !== void 0) {
                          let data63 = data.linkType;
                          const _errs161 = errors;
                          if (typeof data63 !== "string") {
                            const err116 = {
                              instancePath: instancePath + "/linkType",
                              schemaPath: "LinkNavigationResource/anyOf/4/properties/linkType/type",
                              keyword: "type",
                              params: {
                                type: "string"
                              },
                              message: "must be string"
                            };
                            if (vErrors === null) {
                              vErrors = [err116];
                            } else {
                              vErrors.push(err116);
                            }
                            errors++;
                          }
                          if ("tag" !== data63) {
                            const err117 = {
                              instancePath: instancePath + "/linkType",
                              schemaPath: "LinkNavigationResource/anyOf/4/properties/linkType/const",
                              keyword: "const",
                              params: {
                                allowedValue: "tag"
                              },
                              message: "must be equal to constant"
                            };
                            if (vErrors === null) {
                              vErrors = [err117];
                            } else {
                              vErrors.push(err117);
                            }
                            errors++;
                          }
                          var valid25 = _errs161 === errors;
                        } else {
                          var valid25 = true;
                        }
                        if (valid25) {
                          if (data.tagName !== void 0) {
                            const _errs163 = errors;
                            if (typeof data.tagName !== "string") {
                              const err118 = {
                                instancePath: instancePath + "/tagName",
                                schemaPath: "LinkNavigationResource/anyOf/4/properties/tagName/type",
                                keyword: "type",
                                params: {
                                  type: "string"
                                },
                                message: "must be string"
                              };
                              if (vErrors === null) {
                                vErrors = [err118];
                              } else {
                                vErrors.push(err118);
                              }
                              errors++;
                            }
                            var valid25 = _errs163 === errors;
                          } else {
                            var valid25 = true;
                          }
                          if (valid25) {
                            if (data.type !== void 0) {
                              let data65 = data.type;
                              const _errs165 = errors;
                              if (typeof data65 !== "string") {
                                const err119 = {
                                  instancePath: instancePath + "/type",
                                  schemaPath: "LinkNavigationResource/anyOf/4/properties/type/type",
                                  keyword: "type",
                                  params: {
                                    type: "string"
                                  },
                                  message: "must be string"
                                };
                                if (vErrors === null) {
                                  vErrors = [err119];
                                } else {
                                  vErrors.push(err119);
                                }
                                errors++;
                              }
                              if ("LINK" !== data65) {
                                const err120 = {
                                  instancePath: instancePath + "/type",
                                  schemaPath: "LinkNavigationResource/anyOf/4/properties/type/const",
                                  keyword: "const",
                                  params: {
                                    allowedValue: "LINK"
                                  },
                                  message: "must be equal to constant"
                                };
                                if (vErrors === null) {
                                  vErrors = [err120];
                                } else {
                                  vErrors.push(err120);
                                }
                                errors++;
                              }
                              var valid25 = _errs165 === errors;
                            } else {
                              var valid25 = true;
                            }
                            if (valid25) {
                              if (data.label !== void 0) {
                                const _errs167 = errors;
                                if (typeof data.label !== "string") {
                                  const err121 = {
                                    instancePath: instancePath + "/label",
                                    schemaPath: "LinkNavigationResource/anyOf/4/properties/label/type",
                                    keyword: "type",
                                    params: {
                                      type: "string"
                                    },
                                    message: "must be string"
                                  };
                                  if (vErrors === null) {
                                    vErrors = [err121];
                                  } else {
                                    vErrors.push(err121);
                                  }
                                  errors++;
                                }
                                var valid25 = _errs167 === errors;
                              } else {
                                var valid25 = true;
                              }
                              if (valid25) {
                                if (data.external !== void 0) {
                                  const _errs169 = errors;
                                  if (typeof data.external !== "boolean") {
                                    const err122 = {
                                      instancePath: instancePath + "/external",
                                      schemaPath: "LinkNavigationResource/anyOf/4/properties/external/type",
                                      keyword: "type",
                                      params: {
                                        type: "boolean"
                                      },
                                      message: "must be boolean"
                                    };
                                    if (vErrors === null) {
                                      vErrors = [err122];
                                    } else {
                                      vErrors.push(err122);
                                    }
                                    errors++;
                                  }
                                  var valid25 = _errs169 === errors;
                                } else {
                                  var valid25 = true;
                                }
                              }
                            }
                          }
                        }
                      }
                    } else {
                      const err123 = {
                        instancePath,
                        schemaPath: "LinkNavigationResource/anyOf/4/type",
                        keyword: "type",
                        params: {
                          type: "object"
                        },
                        message: "must be object"
                      };
                      if (vErrors === null) {
                        vErrors = [err123];
                      } else {
                        vErrors.push(err123);
                      }
                      errors++;
                    }
                  }
                  var _valid2 = _errs159 === errors;
                  valid20 = valid20 || _valid2;
                }
              }
            }
          }
          if (!valid20) {
            const err124 = {
              instancePath,
              schemaPath: "LinkNavigationResource/anyOf",
              keyword: "anyOf",
              params: {},
              message: "must match a schema in anyOf"
            };
            if (vErrors === null) {
              vErrors = [err124];
            } else {
              vErrors.push(err124);
            }
            errors++;
          } else {
            errors = _errs110;
            if (vErrors !== null) {
              if (_errs110) {
                vErrors.length = _errs110;
              } else {
                vErrors = null;
              }
            }
          }
          var _valid0 = _errs108 === errors;
          valid0 = valid0 || _valid0;
        }
      }
    }
  }
  if (!valid0) {
    const err125 = {
      instancePath,
      schemaPath: "#/anyOf",
      keyword: "anyOf",
      params: {},
      message: "must match a schema in anyOf"
    };
    if (vErrors === null) {
      vErrors = [err125];
    } else {
      vErrors.push(err125);
    }
    errors++;
    validate108.errors = vErrors;
    return false;
  } else {
    errors = _errs0;
    if (vErrors !== null) {
      if (_errs0) {
        vErrors.length = _errs0;
      } else {
        vErrors = null;
      }
    }
  }
  validate108.errors = vErrors;
  return errors === 0;
}
const ChannelNavigation = validate109;
function validate109(data, {
  instancePath = "",
  parentData,
  parentDataProperty,
  rootData = data
} = {}) {
  let vErrors = null;
  let errors = 0;
  if (errors === 0) {
    if (Array.isArray(data)) {
      var valid0 = true;
      const len0 = data.length;
      for (let i0 = 0; i0 < len0; i0++) {
        const _errs1 = errors;
        if (!validate108(data[i0], {
          instancePath: instancePath + "/" + i0,
          parentData: data,
          parentDataProperty: i0,
          rootData
        })) {
          vErrors = vErrors === null ? validate108.errors : vErrors.concat(validate108.errors);
          errors = vErrors.length;
        }
        var valid0 = _errs1 === errors;
        if (!valid0) {
          break;
        }
      }
    } else {
      validate109.errors = [{
        instancePath,
        schemaPath: "#/type",
        keyword: "type",
        params: {
          type: "array"
        },
        message: "must be array"
      }];
      return false;
    }
  }
  validate109.errors = vErrors;
  return errors === 0;
}
const Channel = validate111;
const schema119 = {
  "$id": "Channel",
  "$schema": "http://json-schema.org/draft-07/schema#",
  "type": "object",
  "properties": {
    "archived": {
      "type": "boolean"
    },
    "name": {
      "type": "string"
    },
    "description": {
      "type": "string"
    },
    "slug": {
      "type": "string"
    },
    "organizationId": {
      "type": ["string", "null"]
    },
    "country": {
      "type": "string"
    },
    "branding": {
      "$ref": "Branding"
    },
    "pages": {
      "type": "array",
      "items": {
        "$ref": "Page"
      }
    },
    "domain": {
      "type": ["string", "null"]
    },
    "channelNavigation": {
      "$ref": "ChannelNavigation"
    }
  },
  "required": ["archived", "name", "description", "slug", "organizationId", "country", "branding", "pages", "domain"],
  "description": "Aggregates the needed data to render a channel."
};
function validate111(data, {
  instancePath = "",
  parentData,
  parentDataProperty,
  rootData = data
} = {}) {
  let vErrors = null;
  let errors = 0;
  if (errors === 0) {
    if (data && typeof data == "object" && !Array.isArray(data)) {
      let missing0;
      if (data.archived === void 0 && (missing0 = "archived") || data.name === void 0 && (missing0 = "name") || data.description === void 0 && (missing0 = "description") || data.slug === void 0 && (missing0 = "slug") || data.organizationId === void 0 && (missing0 = "organizationId") || data.country === void 0 && (missing0 = "country") || data.branding === void 0 && (missing0 = "branding") || data.pages === void 0 && (missing0 = "pages") || data.domain === void 0 && (missing0 = "domain")) {
        validate111.errors = [{
          instancePath,
          schemaPath: "#/required",
          keyword: "required",
          params: {
            missingProperty: missing0
          },
          message: "must have required property '" + missing0 + "'"
        }];
        return false;
      } else {
        if (data.archived !== void 0) {
          const _errs1 = errors;
          if (typeof data.archived !== "boolean") {
            validate111.errors = [{
              instancePath: instancePath + "/archived",
              schemaPath: "#/properties/archived/type",
              keyword: "type",
              params: {
                type: "boolean"
              },
              message: "must be boolean"
            }];
            return false;
          }
          var valid0 = _errs1 === errors;
        } else {
          var valid0 = true;
        }
        if (valid0) {
          if (data.name !== void 0) {
            const _errs3 = errors;
            if (typeof data.name !== "string") {
              validate111.errors = [{
                instancePath: instancePath + "/name",
                schemaPath: "#/properties/name/type",
                keyword: "type",
                params: {
                  type: "string"
                },
                message: "must be string"
              }];
              return false;
            }
            var valid0 = _errs3 === errors;
          } else {
            var valid0 = true;
          }
          if (valid0) {
            if (data.description !== void 0) {
              const _errs5 = errors;
              if (typeof data.description !== "string") {
                validate111.errors = [{
                  instancePath: instancePath + "/description",
                  schemaPath: "#/properties/description/type",
                  keyword: "type",
                  params: {
                    type: "string"
                  },
                  message: "must be string"
                }];
                return false;
              }
              var valid0 = _errs5 === errors;
            } else {
              var valid0 = true;
            }
            if (valid0) {
              if (data.slug !== void 0) {
                const _errs7 = errors;
                if (typeof data.slug !== "string") {
                  validate111.errors = [{
                    instancePath: instancePath + "/slug",
                    schemaPath: "#/properties/slug/type",
                    keyword: "type",
                    params: {
                      type: "string"
                    },
                    message: "must be string"
                  }];
                  return false;
                }
                var valid0 = _errs7 === errors;
              } else {
                var valid0 = true;
              }
              if (valid0) {
                if (data.organizationId !== void 0) {
                  let data4 = data.organizationId;
                  const _errs9 = errors;
                  if (typeof data4 !== "string" && data4 !== null) {
                    validate111.errors = [{
                      instancePath: instancePath + "/organizationId",
                      schemaPath: "#/properties/organizationId/type",
                      keyword: "type",
                      params: {
                        type: schema119.properties.organizationId.type
                      },
                      message: "must be string,null"
                    }];
                    return false;
                  }
                  var valid0 = _errs9 === errors;
                } else {
                  var valid0 = true;
                }
                if (valid0) {
                  if (data.country !== void 0) {
                    const _errs11 = errors;
                    if (typeof data.country !== "string") {
                      validate111.errors = [{
                        instancePath: instancePath + "/country",
                        schemaPath: "#/properties/country/type",
                        keyword: "type",
                        params: {
                          type: "string"
                        },
                        message: "must be string"
                      }];
                      return false;
                    }
                    var valid0 = _errs11 === errors;
                  } else {
                    var valid0 = true;
                  }
                  if (valid0) {
                    if (data.branding !== void 0) {
                      let data6 = data.branding;
                      const _errs13 = errors;
                      const _errs14 = errors;
                      if (errors === _errs14) {
                        if (data6 && typeof data6 == "object" && !Array.isArray(data6)) {
                          let missing1;
                          if (data6.accentColor === void 0 && (missing1 = "accentColor") || data6.backgroundColor === void 0 && (missing1 = "backgroundColor") || data6.themeStyle === void 0 && (missing1 = "themeStyle") || data6.bannerImages === void 0 && (missing1 = "bannerImages") || data6.logoImage === void 0 && (missing1 = "logoImage")) {
                            validate111.errors = [{
                              instancePath: instancePath + "/branding",
                              schemaPath: "Branding/required",
                              keyword: "required",
                              params: {
                                missingProperty: missing1
                              },
                              message: "must have required property '" + missing1 + "'"
                            }];
                            return false;
                          } else {
                            if (data6.accentColor !== void 0) {
                              const _errs16 = errors;
                              if (typeof data6.accentColor !== "string") {
                                validate111.errors = [{
                                  instancePath: instancePath + "/branding/accentColor",
                                  schemaPath: "Branding/properties/accentColor/type",
                                  keyword: "type",
                                  params: {
                                    type: "string"
                                  },
                                  message: "must be string"
                                }];
                                return false;
                              }
                              var valid2 = _errs16 === errors;
                            } else {
                              var valid2 = true;
                            }
                            if (valid2) {
                              if (data6.backgroundColor !== void 0) {
                                const _errs18 = errors;
                                if (typeof data6.backgroundColor !== "string") {
                                  validate111.errors = [{
                                    instancePath: instancePath + "/branding/backgroundColor",
                                    schemaPath: "Branding/properties/backgroundColor/type",
                                    keyword: "type",
                                    params: {
                                      type: "string"
                                    },
                                    message: "must be string"
                                  }];
                                  return false;
                                }
                                var valid2 = _errs18 === errors;
                              } else {
                                var valid2 = true;
                              }
                              if (valid2) {
                                if (data6.themeStyle !== void 0) {
                                  let data9 = data6.themeStyle;
                                  const _errs20 = errors;
                                  if (typeof data9 !== "string") {
                                    validate111.errors = [{
                                      instancePath: instancePath + "/branding/themeStyle",
                                      schemaPath: "Branding/properties/themeStyle/type",
                                      keyword: "type",
                                      params: {
                                        type: "string"
                                      },
                                      message: "must be string"
                                    }];
                                    return false;
                                  }
                                  if (!(data9 === "rounded" || data9 === "hard")) {
                                    validate111.errors = [{
                                      instancePath: instancePath + "/branding/themeStyle",
                                      schemaPath: "Branding/properties/themeStyle/enum",
                                      keyword: "enum",
                                      params: {
                                        allowedValues: schema39.properties.themeStyle.enum
                                      },
                                      message: "must be equal to one of the allowed values"
                                    }];
                                    return false;
                                  }
                                  var valid2 = _errs20 === errors;
                                } else {
                                  var valid2 = true;
                                }
                                if (valid2) {
                                  if (data6.bannerImages !== void 0) {
                                    let data10 = data6.bannerImages;
                                    const _errs22 = errors;
                                    if (errors === _errs22) {
                                      if (data10 && typeof data10 == "object" && !Array.isArray(data10)) {
                                        let missing2;
                                        if (data10["3/1"] === void 0 && (missing2 = "3/1") || data10["3/4"] === void 0 && (missing2 = "3/4") || data10["16/9"] === void 0 && (missing2 = "16/9")) {
                                          validate111.errors = [{
                                            instancePath: instancePath + "/branding/bannerImages",
                                            schemaPath: "Branding/properties/bannerImages/required",
                                            keyword: "required",
                                            params: {
                                              missingProperty: missing2
                                            },
                                            message: "must have required property '" + missing2 + "'"
                                          }];
                                          return false;
                                        } else {
                                          if (data10["3/1"] !== void 0) {
                                            const _errs24 = errors;
                                            if (typeof data10["3/1"] !== "string") {
                                              validate111.errors = [{
                                                instancePath: instancePath + "/branding/bannerImages/3~11",
                                                schemaPath: "Branding/properties/bannerImages/properties/3~11/type",
                                                keyword: "type",
                                                params: {
                                                  type: "string"
                                                },
                                                message: "must be string"
                                              }];
                                              return false;
                                            }
                                            var valid3 = _errs24 === errors;
                                          } else {
                                            var valid3 = true;
                                          }
                                          if (valid3) {
                                            if (data10["3/4"] !== void 0) {
                                              const _errs26 = errors;
                                              if (typeof data10["3/4"] !== "string") {
                                                validate111.errors = [{
                                                  instancePath: instancePath + "/branding/bannerImages/3~14",
                                                  schemaPath: "Branding/properties/bannerImages/properties/3~14/type",
                                                  keyword: "type",
                                                  params: {
                                                    type: "string"
                                                  },
                                                  message: "must be string"
                                                }];
                                                return false;
                                              }
                                              var valid3 = _errs26 === errors;
                                            } else {
                                              var valid3 = true;
                                            }
                                            if (valid3) {
                                              if (data10["16/9"] !== void 0) {
                                                const _errs28 = errors;
                                                if (typeof data10["16/9"] !== "string") {
                                                  validate111.errors = [{
                                                    instancePath: instancePath + "/branding/bannerImages/16~19",
                                                    schemaPath: "Branding/properties/bannerImages/properties/16~19/type",
                                                    keyword: "type",
                                                    params: {
                                                      type: "string"
                                                    },
                                                    message: "must be string"
                                                  }];
                                                  return false;
                                                }
                                                var valid3 = _errs28 === errors;
                                              } else {
                                                var valid3 = true;
                                              }
                                            }
                                          }
                                        }
                                      } else {
                                        validate111.errors = [{
                                          instancePath: instancePath + "/branding/bannerImages",
                                          schemaPath: "Branding/properties/bannerImages/type",
                                          keyword: "type",
                                          params: {
                                            type: "object"
                                          },
                                          message: "must be object"
                                        }];
                                        return false;
                                      }
                                    }
                                    var valid2 = _errs22 === errors;
                                  } else {
                                    var valid2 = true;
                                  }
                                  if (valid2) {
                                    if (data6.logoImage !== void 0) {
                                      const _errs30 = errors;
                                      if (typeof data6.logoImage !== "string") {
                                        validate111.errors = [{
                                          instancePath: instancePath + "/branding/logoImage",
                                          schemaPath: "Branding/properties/logoImage/type",
                                          keyword: "type",
                                          params: {
                                            type: "string"
                                          },
                                          message: "must be string"
                                        }];
                                        return false;
                                      }
                                      var valid2 = _errs30 === errors;
                                    } else {
                                      var valid2 = true;
                                    }
                                    if (valid2) {
                                      if (data6.contactInformation !== void 0) {
                                        let data15 = data6.contactInformation;
                                        const _errs32 = errors;
                                        if (errors === _errs32) {
                                          if (data15 && typeof data15 == "object" && !Array.isArray(data15)) {
                                            let missing3;
                                            if (data15.socialMediaLinks === void 0 && (missing3 = "socialMediaLinks") || data15.contactAddressLines === void 0 && (missing3 = "contactAddressLines") || data15.contactPhone === void 0 && (missing3 = "contactPhone") || data15.contactEmail === void 0 && (missing3 = "contactEmail") || data15.supportEmail === void 0 && (missing3 = "supportEmail") || data15.copyrightNotice === void 0 && (missing3 = "copyrightNotice")) {
                                              validate111.errors = [{
                                                instancePath: instancePath + "/branding/contactInformation",
                                                schemaPath: "Branding/properties/contactInformation/required",
                                                keyword: "required",
                                                params: {
                                                  missingProperty: missing3
                                                },
                                                message: "must have required property '" + missing3 + "'"
                                              }];
                                              return false;
                                            } else {
                                              if (data15.socialMediaLinks !== void 0) {
                                                let data16 = data15.socialMediaLinks;
                                                const _errs34 = errors;
                                                const _errs35 = errors;
                                                let valid5 = false;
                                                const _errs36 = errors;
                                                if (errors === _errs36) {
                                                  if (Array.isArray(data16)) {
                                                    var valid6 = true;
                                                    const len0 = data16.length;
                                                    for (let i0 = 0; i0 < len0; i0++) {
                                                      let data17 = data16[i0];
                                                      const _errs38 = errors;
                                                      if (errors === _errs38) {
                                                        if (data17 && typeof data17 == "object" && !Array.isArray(data17)) {
                                                          let missing4;
                                                          if (data17.type === void 0 && (missing4 = "type") || data17.url === void 0 && (missing4 = "url")) {
                                                            const err0 = {
                                                              instancePath: instancePath + "/branding/contactInformation/socialMediaLinks/" + i0,
                                                              schemaPath: "Branding/properties/contactInformation/properties/socialMediaLinks/anyOf/0/items/required",
                                                              keyword: "required",
                                                              params: {
                                                                missingProperty: missing4
                                                              },
                                                              message: "must have required property '" + missing4 + "'"
                                                            };
                                                            if (vErrors === null) {
                                                              vErrors = [err0];
                                                            } else {
                                                              vErrors.push(err0);
                                                            }
                                                            errors++;
                                                          } else {
                                                            if (data17.type !== void 0) {
                                                              const _errs40 = errors;
                                                              if (typeof data17.type !== "string") {
                                                                const err1 = {
                                                                  instancePath: instancePath + "/branding/contactInformation/socialMediaLinks/" + i0 + "/type",
                                                                  schemaPath: "Branding/properties/contactInformation/properties/socialMediaLinks/anyOf/0/items/properties/type/type",
                                                                  keyword: "type",
                                                                  params: {
                                                                    type: "string"
                                                                  },
                                                                  message: "must be string"
                                                                };
                                                                if (vErrors === null) {
                                                                  vErrors = [err1];
                                                                } else {
                                                                  vErrors.push(err1);
                                                                }
                                                                errors++;
                                                              }
                                                              var valid7 = _errs40 === errors;
                                                            } else {
                                                              var valid7 = true;
                                                            }
                                                            if (valid7) {
                                                              if (data17.url !== void 0) {
                                                                const _errs42 = errors;
                                                                if (typeof data17.url !== "string") {
                                                                  const err2 = {
                                                                    instancePath: instancePath + "/branding/contactInformation/socialMediaLinks/" + i0 + "/url",
                                                                    schemaPath: "Branding/properties/contactInformation/properties/socialMediaLinks/anyOf/0/items/properties/url/type",
                                                                    keyword: "type",
                                                                    params: {
                                                                      type: "string"
                                                                    },
                                                                    message: "must be string"
                                                                  };
                                                                  if (vErrors === null) {
                                                                    vErrors = [err2];
                                                                  } else {
                                                                    vErrors.push(err2);
                                                                  }
                                                                  errors++;
                                                                }
                                                                var valid7 = _errs42 === errors;
                                                              } else {
                                                                var valid7 = true;
                                                              }
                                                            }
                                                          }
                                                        } else {
                                                          const err3 = {
                                                            instancePath: instancePath + "/branding/contactInformation/socialMediaLinks/" + i0,
                                                            schemaPath: "Branding/properties/contactInformation/properties/socialMediaLinks/anyOf/0/items/type",
                                                            keyword: "type",
                                                            params: {
                                                              type: "object"
                                                            },
                                                            message: "must be object"
                                                          };
                                                          if (vErrors === null) {
                                                            vErrors = [err3];
                                                          } else {
                                                            vErrors.push(err3);
                                                          }
                                                          errors++;
                                                        }
                                                      }
                                                      var valid6 = _errs38 === errors;
                                                      if (!valid6) {
                                                        break;
                                                      }
                                                    }
                                                  } else {
                                                    const err4 = {
                                                      instancePath: instancePath + "/branding/contactInformation/socialMediaLinks",
                                                      schemaPath: "Branding/properties/contactInformation/properties/socialMediaLinks/anyOf/0/type",
                                                      keyword: "type",
                                                      params: {
                                                        type: "array"
                                                      },
                                                      message: "must be array"
                                                    };
                                                    if (vErrors === null) {
                                                      vErrors = [err4];
                                                    } else {
                                                      vErrors.push(err4);
                                                    }
                                                    errors++;
                                                  }
                                                }
                                                var _valid0 = _errs36 === errors;
                                                valid5 = valid5 || _valid0;
                                                if (!valid5) {
                                                  const _errs44 = errors;
                                                  if (data16 !== null) {
                                                    const err5 = {
                                                      instancePath: instancePath + "/branding/contactInformation/socialMediaLinks",
                                                      schemaPath: "Branding/properties/contactInformation/properties/socialMediaLinks/anyOf/1/type",
                                                      keyword: "type",
                                                      params: {
                                                        type: "null"
                                                      },
                                                      message: "must be null"
                                                    };
                                                    if (vErrors === null) {
                                                      vErrors = [err5];
                                                    } else {
                                                      vErrors.push(err5);
                                                    }
                                                    errors++;
                                                  }
                                                  var _valid0 = _errs44 === errors;
                                                  valid5 = valid5 || _valid0;
                                                }
                                                if (!valid5) {
                                                  const err6 = {
                                                    instancePath: instancePath + "/branding/contactInformation/socialMediaLinks",
                                                    schemaPath: "Branding/properties/contactInformation/properties/socialMediaLinks/anyOf",
                                                    keyword: "anyOf",
                                                    params: {},
                                                    message: "must match a schema in anyOf"
                                                  };
                                                  if (vErrors === null) {
                                                    vErrors = [err6];
                                                  } else {
                                                    vErrors.push(err6);
                                                  }
                                                  errors++;
                                                  validate111.errors = vErrors;
                                                  return false;
                                                } else {
                                                  errors = _errs35;
                                                  if (vErrors !== null) {
                                                    if (_errs35) {
                                                      vErrors.length = _errs35;
                                                    } else {
                                                      vErrors = null;
                                                    }
                                                  }
                                                }
                                                var valid4 = _errs34 === errors;
                                              } else {
                                                var valid4 = true;
                                              }
                                              if (valid4) {
                                                if (data15.contactAddressLines !== void 0) {
                                                  let data20 = data15.contactAddressLines;
                                                  const _errs46 = errors;
                                                  const _errs47 = errors;
                                                  let valid8 = false;
                                                  const _errs48 = errors;
                                                  if (errors === _errs48) {
                                                    if (Array.isArray(data20)) {
                                                      var valid9 = true;
                                                      const len1 = data20.length;
                                                      for (let i1 = 0; i1 < len1; i1++) {
                                                        const _errs50 = errors;
                                                        if (typeof data20[i1] !== "string") {
                                                          const err7 = {
                                                            instancePath: instancePath + "/branding/contactInformation/contactAddressLines/" + i1,
                                                            schemaPath: "Branding/properties/contactInformation/properties/contactAddressLines/anyOf/0/items/type",
                                                            keyword: "type",
                                                            params: {
                                                              type: "string"
                                                            },
                                                            message: "must be string"
                                                          };
                                                          if (vErrors === null) {
                                                            vErrors = [err7];
                                                          } else {
                                                            vErrors.push(err7);
                                                          }
                                                          errors++;
                                                        }
                                                        var valid9 = _errs50 === errors;
                                                        if (!valid9) {
                                                          break;
                                                        }
                                                      }
                                                    } else {
                                                      const err8 = {
                                                        instancePath: instancePath + "/branding/contactInformation/contactAddressLines",
                                                        schemaPath: "Branding/properties/contactInformation/properties/contactAddressLines/anyOf/0/type",
                                                        keyword: "type",
                                                        params: {
                                                          type: "array"
                                                        },
                                                        message: "must be array"
                                                      };
                                                      if (vErrors === null) {
                                                        vErrors = [err8];
                                                      } else {
                                                        vErrors.push(err8);
                                                      }
                                                      errors++;
                                                    }
                                                  }
                                                  var _valid1 = _errs48 === errors;
                                                  valid8 = valid8 || _valid1;
                                                  if (!valid8) {
                                                    const _errs52 = errors;
                                                    if (data20 !== null) {
                                                      const err9 = {
                                                        instancePath: instancePath + "/branding/contactInformation/contactAddressLines",
                                                        schemaPath: "Branding/properties/contactInformation/properties/contactAddressLines/anyOf/1/type",
                                                        keyword: "type",
                                                        params: {
                                                          type: "null"
                                                        },
                                                        message: "must be null"
                                                      };
                                                      if (vErrors === null) {
                                                        vErrors = [err9];
                                                      } else {
                                                        vErrors.push(err9);
                                                      }
                                                      errors++;
                                                    }
                                                    var _valid1 = _errs52 === errors;
                                                    valid8 = valid8 || _valid1;
                                                  }
                                                  if (!valid8) {
                                                    const err10 = {
                                                      instancePath: instancePath + "/branding/contactInformation/contactAddressLines",
                                                      schemaPath: "Branding/properties/contactInformation/properties/contactAddressLines/anyOf",
                                                      keyword: "anyOf",
                                                      params: {},
                                                      message: "must match a schema in anyOf"
                                                    };
                                                    if (vErrors === null) {
                                                      vErrors = [err10];
                                                    } else {
                                                      vErrors.push(err10);
                                                    }
                                                    errors++;
                                                    validate111.errors = vErrors;
                                                    return false;
                                                  } else {
                                                    errors = _errs47;
                                                    if (vErrors !== null) {
                                                      if (_errs47) {
                                                        vErrors.length = _errs47;
                                                      } else {
                                                        vErrors = null;
                                                      }
                                                    }
                                                  }
                                                  var valid4 = _errs46 === errors;
                                                } else {
                                                  var valid4 = true;
                                                }
                                                if (valid4) {
                                                  if (data15.contactPhone !== void 0) {
                                                    let data22 = data15.contactPhone;
                                                    const _errs54 = errors;
                                                    if (typeof data22 !== "string" && data22 !== null) {
                                                      validate111.errors = [{
                                                        instancePath: instancePath + "/branding/contactInformation/contactPhone",
                                                        schemaPath: "Branding/properties/contactInformation/properties/contactPhone/type",
                                                        keyword: "type",
                                                        params: {
                                                          type: schema39.properties.contactInformation.properties.contactPhone.type
                                                        },
                                                        message: "must be string,null"
                                                      }];
                                                      return false;
                                                    }
                                                    var valid4 = _errs54 === errors;
                                                  } else {
                                                    var valid4 = true;
                                                  }
                                                  if (valid4) {
                                                    if (data15.contactEmail !== void 0) {
                                                      let data23 = data15.contactEmail;
                                                      const _errs56 = errors;
                                                      if (typeof data23 !== "string" && data23 !== null) {
                                                        validate111.errors = [{
                                                          instancePath: instancePath + "/branding/contactInformation/contactEmail",
                                                          schemaPath: "Branding/properties/contactInformation/properties/contactEmail/type",
                                                          keyword: "type",
                                                          params: {
                                                            type: schema39.properties.contactInformation.properties.contactEmail.type
                                                          },
                                                          message: "must be string,null"
                                                        }];
                                                        return false;
                                                      }
                                                      var valid4 = _errs56 === errors;
                                                    } else {
                                                      var valid4 = true;
                                                    }
                                                    if (valid4) {
                                                      if (data15.streamHelpText !== void 0) {
                                                        let data24 = data15.streamHelpText;
                                                        const _errs58 = errors;
                                                        if (typeof data24 !== "string" && data24 !== null) {
                                                          validate111.errors = [{
                                                            instancePath: instancePath + "/branding/contactInformation/streamHelpText",
                                                            schemaPath: "Branding/properties/contactInformation/properties/streamHelpText/type",
                                                            keyword: "type",
                                                            params: {
                                                              type: schema39.properties.contactInformation.properties.streamHelpText.type
                                                            },
                                                            message: "must be string,null"
                                                          }];
                                                          return false;
                                                        }
                                                        var valid4 = _errs58 === errors;
                                                      } else {
                                                        var valid4 = true;
                                                      }
                                                      if (valid4) {
                                                        if (data15.supportEmail !== void 0) {
                                                          let data25 = data15.supportEmail;
                                                          const _errs60 = errors;
                                                          if (typeof data25 !== "string" && data25 !== null) {
                                                            validate111.errors = [{
                                                              instancePath: instancePath + "/branding/contactInformation/supportEmail",
                                                              schemaPath: "Branding/properties/contactInformation/properties/supportEmail/type",
                                                              keyword: "type",
                                                              params: {
                                                                type: schema39.properties.contactInformation.properties.supportEmail.type
                                                              },
                                                              message: "must be string,null"
                                                            }];
                                                            return false;
                                                          }
                                                          var valid4 = _errs60 === errors;
                                                        } else {
                                                          var valid4 = true;
                                                        }
                                                        if (valid4) {
                                                          if (data15.faqLink !== void 0) {
                                                            let data26 = data15.faqLink;
                                                            const _errs62 = errors;
                                                            if (typeof data26 !== "string" && data26 !== null) {
                                                              validate111.errors = [{
                                                                instancePath: instancePath + "/branding/contactInformation/faqLink",
                                                                schemaPath: "Branding/properties/contactInformation/properties/faqLink/type",
                                                                keyword: "type",
                                                                params: {
                                                                  type: schema39.properties.contactInformation.properties.faqLink.type
                                                                },
                                                                message: "must be string,null"
                                                              }];
                                                              return false;
                                                            }
                                                            var valid4 = _errs62 === errors;
                                                          } else {
                                                            var valid4 = true;
                                                          }
                                                          if (valid4) {
                                                            if (data15.copyrightNotice !== void 0) {
                                                              let data27 = data15.copyrightNotice;
                                                              const _errs64 = errors;
                                                              if (typeof data27 !== "string" && data27 !== null) {
                                                                validate111.errors = [{
                                                                  instancePath: instancePath + "/branding/contactInformation/copyrightNotice",
                                                                  schemaPath: "Branding/properties/contactInformation/properties/copyrightNotice/type",
                                                                  keyword: "type",
                                                                  params: {
                                                                    type: schema39.properties.contactInformation.properties.copyrightNotice.type
                                                                  },
                                                                  message: "must be string,null"
                                                                }];
                                                                return false;
                                                              }
                                                              var valid4 = _errs64 === errors;
                                                            } else {
                                                              var valid4 = true;
                                                            }
                                                            if (valid4) {
                                                              if (data15.privacyPolicy !== void 0) {
                                                                let data28 = data15.privacyPolicy;
                                                                const _errs66 = errors;
                                                                const _errs67 = errors;
                                                                let valid10 = false;
                                                                const _errs68 = errors;
                                                                if (errors === _errs68) {
                                                                  if (Array.isArray(data28)) {
                                                                    var valid11 = true;
                                                                    const len2 = data28.length;
                                                                    for (let i2 = 0; i2 < len2; i2++) {
                                                                      const _errs70 = errors;
                                                                      if (typeof data28[i2] !== "string") {
                                                                        const err11 = {
                                                                          instancePath: instancePath + "/branding/contactInformation/privacyPolicy/" + i2,
                                                                          schemaPath: "Branding/properties/contactInformation/properties/privacyPolicy/anyOf/0/items/type",
                                                                          keyword: "type",
                                                                          params: {
                                                                            type: "string"
                                                                          },
                                                                          message: "must be string"
                                                                        };
                                                                        if (vErrors === null) {
                                                                          vErrors = [err11];
                                                                        } else {
                                                                          vErrors.push(err11);
                                                                        }
                                                                        errors++;
                                                                      }
                                                                      var valid11 = _errs70 === errors;
                                                                      if (!valid11) {
                                                                        break;
                                                                      }
                                                                    }
                                                                  } else {
                                                                    const err12 = {
                                                                      instancePath: instancePath + "/branding/contactInformation/privacyPolicy",
                                                                      schemaPath: "Branding/properties/contactInformation/properties/privacyPolicy/anyOf/0/type",
                                                                      keyword: "type",
                                                                      params: {
                                                                        type: "array"
                                                                      },
                                                                      message: "must be array"
                                                                    };
                                                                    if (vErrors === null) {
                                                                      vErrors = [err12];
                                                                    } else {
                                                                      vErrors.push(err12);
                                                                    }
                                                                    errors++;
                                                                  }
                                                                }
                                                                var _valid2 = _errs68 === errors;
                                                                valid10 = valid10 || _valid2;
                                                                if (!valid10) {
                                                                  const _errs72 = errors;
                                                                  if (data28 !== null) {
                                                                    const err13 = {
                                                                      instancePath: instancePath + "/branding/contactInformation/privacyPolicy",
                                                                      schemaPath: "Branding/properties/contactInformation/properties/privacyPolicy/anyOf/1/type",
                                                                      keyword: "type",
                                                                      params: {
                                                                        type: "null"
                                                                      },
                                                                      message: "must be null"
                                                                    };
                                                                    if (vErrors === null) {
                                                                      vErrors = [err13];
                                                                    } else {
                                                                      vErrors.push(err13);
                                                                    }
                                                                    errors++;
                                                                  }
                                                                  var _valid2 = _errs72 === errors;
                                                                  valid10 = valid10 || _valid2;
                                                                }
                                                                if (!valid10) {
                                                                  const err14 = {
                                                                    instancePath: instancePath + "/branding/contactInformation/privacyPolicy",
                                                                    schemaPath: "Branding/properties/contactInformation/properties/privacyPolicy/anyOf",
                                                                    keyword: "anyOf",
                                                                    params: {},
                                                                    message: "must match a schema in anyOf"
                                                                  };
                                                                  if (vErrors === null) {
                                                                    vErrors = [err14];
                                                                  } else {
                                                                    vErrors.push(err14);
                                                                  }
                                                                  errors++;
                                                                  validate111.errors = vErrors;
                                                                  return false;
                                                                } else {
                                                                  errors = _errs67;
                                                                  if (vErrors !== null) {
                                                                    if (_errs67) {
                                                                      vErrors.length = _errs67;
                                                                    } else {
                                                                      vErrors = null;
                                                                    }
                                                                  }
                                                                }
                                                                var valid4 = _errs66 === errors;
                                                              } else {
                                                                var valid4 = true;
                                                              }
                                                              if (valid4) {
                                                                if (data15.logoImage !== void 0) {
                                                                  let data30 = data15.logoImage;
                                                                  const _errs74 = errors;
                                                                  if (typeof data30 !== "string" && data30 !== null) {
                                                                    validate111.errors = [{
                                                                      instancePath: instancePath + "/branding/contactInformation/logoImage",
                                                                      schemaPath: "Branding/properties/contactInformation/properties/logoImage/type",
                                                                      keyword: "type",
                                                                      params: {
                                                                        type: schema39.properties.contactInformation.properties.logoImage.type
                                                                      },
                                                                      message: "must be string,null"
                                                                    }];
                                                                    return false;
                                                                  }
                                                                  var valid4 = _errs74 === errors;
                                                                } else {
                                                                  var valid4 = true;
                                                                }
                                                              }
                                                            }
                                                          }
                                                        }
                                                      }
                                                    }
                                                  }
                                                }
                                              }
                                            }
                                          } else {
                                            validate111.errors = [{
                                              instancePath: instancePath + "/branding/contactInformation",
                                              schemaPath: "Branding/properties/contactInformation/type",
                                              keyword: "type",
                                              params: {
                                                type: "object"
                                              },
                                              message: "must be object"
                                            }];
                                            return false;
                                          }
                                        }
                                        var valid2 = _errs32 === errors;
                                      } else {
                                        var valid2 = true;
                                      }
                                    }
                                  }
                                }
                              }
                            }
                          }
                        } else {
                          validate111.errors = [{
                            instancePath: instancePath + "/branding",
                            schemaPath: "Branding/type",
                            keyword: "type",
                            params: {
                              type: "object"
                            },
                            message: "must be object"
                          }];
                          return false;
                        }
                      }
                      var valid0 = _errs13 === errors;
                    } else {
                      var valid0 = true;
                    }
                    if (valid0) {
                      if (data.pages !== void 0) {
                        let data31 = data.pages;
                        const _errs76 = errors;
                        if (errors === _errs76) {
                          if (Array.isArray(data31)) {
                            var valid12 = true;
                            const len3 = data31.length;
                            for (let i3 = 0; i3 < len3; i3++) {
                              const _errs78 = errors;
                              if (!validate100(data31[i3], {
                                instancePath: instancePath + "/pages/" + i3,
                                parentData: data31,
                                parentDataProperty: i3,
                                rootData
                              })) {
                                vErrors = vErrors === null ? validate100.errors : vErrors.concat(validate100.errors);
                                errors = vErrors.length;
                              }
                              var valid12 = _errs78 === errors;
                              if (!valid12) {
                                break;
                              }
                            }
                          } else {
                            validate111.errors = [{
                              instancePath: instancePath + "/pages",
                              schemaPath: "#/properties/pages/type",
                              keyword: "type",
                              params: {
                                type: "array"
                              },
                              message: "must be array"
                            }];
                            return false;
                          }
                        }
                        var valid0 = _errs76 === errors;
                      } else {
                        var valid0 = true;
                      }
                      if (valid0) {
                        if (data.domain !== void 0) {
                          let data33 = data.domain;
                          const _errs79 = errors;
                          if (typeof data33 !== "string" && data33 !== null) {
                            validate111.errors = [{
                              instancePath: instancePath + "/domain",
                              schemaPath: "#/properties/domain/type",
                              keyword: "type",
                              params: {
                                type: schema119.properties.domain.type
                              },
                              message: "must be string,null"
                            }];
                            return false;
                          }
                          var valid0 = _errs79 === errors;
                        } else {
                          var valid0 = true;
                        }
                        if (valid0) {
                          if (data.channelNavigation !== void 0) {
                            const _errs81 = errors;
                            if (!validate109(data.channelNavigation, {
                              instancePath: instancePath + "/channelNavigation",
                              parentData: data,
                              parentDataProperty: "channelNavigation",
                              rootData
                            })) {
                              vErrors = vErrors === null ? validate109.errors : vErrors.concat(validate109.errors);
                              errors = vErrors.length;
                            }
                            var valid0 = _errs81 === errors;
                          } else {
                            var valid0 = true;
                          }
                        }
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
    } else {
      validate111.errors = [{
        instancePath,
        schemaPath: "#/type",
        keyword: "type",
        params: {
          type: "object"
        },
        message: "must be object"
      }];
      return false;
    }
  }
  validate111.errors = vErrors;
  return errors === 0;
}
const UserConsentRequest = validate114;
const schema121 = {
  "$id": "UserConsentRequest",
  "$schema": "http://json-schema.org/draft-07/schema#",
  "type": "object",
  "properties": {
    "id": {
      "type": "string"
    },
    "title": {
      "type": "string"
    },
    "description": {
      "type": "string"
    },
    "version": {
      "type": "number"
    },
    "group": {
      "type": ["string", "null"]
    }
  },
  "required": ["id", "title", "description", "version", "group"]
};
function validate114(data, {
  instancePath = "",
  parentData,
  parentDataProperty,
  rootData = data
} = {}) {
  let vErrors = null;
  let errors = 0;
  {
    if (data && typeof data == "object" && !Array.isArray(data)) {
      let missing0;
      if (data.id === void 0 && (missing0 = "id") || data.title === void 0 && (missing0 = "title") || data.description === void 0 && (missing0 = "description") || data.version === void 0 && (missing0 = "version") || data.group === void 0 && (missing0 = "group")) {
        validate114.errors = [{
          instancePath,
          schemaPath: "#/required",
          keyword: "required",
          params: {
            missingProperty: missing0
          },
          message: "must have required property '" + missing0 + "'"
        }];
        return false;
      } else {
        if (data.id !== void 0) {
          const _errs1 = errors;
          if (typeof data.id !== "string") {
            validate114.errors = [{
              instancePath: instancePath + "/id",
              schemaPath: "#/properties/id/type",
              keyword: "type",
              params: {
                type: "string"
              },
              message: "must be string"
            }];
            return false;
          }
          var valid0 = _errs1 === errors;
        } else {
          var valid0 = true;
        }
        if (valid0) {
          if (data.title !== void 0) {
            const _errs3 = errors;
            if (typeof data.title !== "string") {
              validate114.errors = [{
                instancePath: instancePath + "/title",
                schemaPath: "#/properties/title/type",
                keyword: "type",
                params: {
                  type: "string"
                },
                message: "must be string"
              }];
              return false;
            }
            var valid0 = _errs3 === errors;
          } else {
            var valid0 = true;
          }
          if (valid0) {
            if (data.description !== void 0) {
              const _errs5 = errors;
              if (typeof data.description !== "string") {
                validate114.errors = [{
                  instancePath: instancePath + "/description",
                  schemaPath: "#/properties/description/type",
                  keyword: "type",
                  params: {
                    type: "string"
                  },
                  message: "must be string"
                }];
                return false;
              }
              var valid0 = _errs5 === errors;
            } else {
              var valid0 = true;
            }
            if (valid0) {
              if (data.version !== void 0) {
                let data3 = data.version;
                const _errs7 = errors;
                if (!(typeof data3 == "number" && isFinite(data3))) {
                  validate114.errors = [{
                    instancePath: instancePath + "/version",
                    schemaPath: "#/properties/version/type",
                    keyword: "type",
                    params: {
                      type: "number"
                    },
                    message: "must be number"
                  }];
                  return false;
                }
                var valid0 = _errs7 === errors;
              } else {
                var valid0 = true;
              }
              if (valid0) {
                if (data.group !== void 0) {
                  let data4 = data.group;
                  const _errs9 = errors;
                  if (typeof data4 !== "string" && data4 !== null) {
                    validate114.errors = [{
                      instancePath: instancePath + "/group",
                      schemaPath: "#/properties/group/type",
                      keyword: "type",
                      params: {
                        type: schema121.properties.group.type
                      },
                      message: "must be string,null"
                    }];
                    return false;
                  }
                  var valid0 = _errs9 === errors;
                } else {
                  var valid0 = true;
                }
              }
            }
          }
        }
      }
    } else {
      validate114.errors = [{
        instancePath,
        schemaPath: "#/type",
        keyword: "type",
        params: {
          type: "object"
        },
        message: "must be object"
      }];
      return false;
    }
  }
  validate114.errors = vErrors;
  return errors === 0;
}
const ChannelTerms = validate115;
function validate115(data, {
  instancePath = "",
  parentData,
  parentDataProperty,
  rootData = data
} = {}) {
  let vErrors = null;
  let errors = 0;
  {
    if (data && typeof data == "object" && !Array.isArray(data)) {
      let missing0;
      if (data.id === void 0 && (missing0 = "id") || data.version === void 0 && (missing0 = "version") || data.title === void 0 && (missing0 = "title") || data.description === void 0 && (missing0 = "description") || data.externalLink === void 0 && (missing0 = "externalLink")) {
        validate115.errors = [{
          instancePath,
          schemaPath: "#/required",
          keyword: "required",
          params: {
            missingProperty: missing0
          },
          message: "must have required property '" + missing0 + "'"
        }];
        return false;
      } else {
        if (data.id !== void 0) {
          const _errs1 = errors;
          if (typeof data.id !== "string") {
            validate115.errors = [{
              instancePath: instancePath + "/id",
              schemaPath: "#/properties/id/type",
              keyword: "type",
              params: {
                type: "string"
              },
              message: "must be string"
            }];
            return false;
          }
          var valid0 = _errs1 === errors;
        } else {
          var valid0 = true;
        }
        if (valid0) {
          if (data.version !== void 0) {
            let data1 = data.version;
            const _errs3 = errors;
            if (!(typeof data1 == "number" && isFinite(data1))) {
              validate115.errors = [{
                instancePath: instancePath + "/version",
                schemaPath: "#/properties/version/type",
                keyword: "type",
                params: {
                  type: "number"
                },
                message: "must be number"
              }];
              return false;
            }
            var valid0 = _errs3 === errors;
          } else {
            var valid0 = true;
          }
          if (valid0) {
            if (data.title !== void 0) {
              const _errs5 = errors;
              if (typeof data.title !== "string") {
                validate115.errors = [{
                  instancePath: instancePath + "/title",
                  schemaPath: "#/properties/title/type",
                  keyword: "type",
                  params: {
                    type: "string"
                  },
                  message: "must be string"
                }];
                return false;
              }
              var valid0 = _errs5 === errors;
            } else {
              var valid0 = true;
            }
            if (valid0) {
              if (data.description !== void 0) {
                const _errs7 = errors;
                if (typeof data.description !== "string") {
                  validate115.errors = [{
                    instancePath: instancePath + "/description",
                    schemaPath: "#/properties/description/type",
                    keyword: "type",
                    params: {
                      type: "string"
                    },
                    message: "must be string"
                  }];
                  return false;
                }
                var valid0 = _errs7 === errors;
              } else {
                var valid0 = true;
              }
              if (valid0) {
                if (data.externalLink !== void 0) {
                  const _errs9 = errors;
                  if (typeof data.externalLink !== "string") {
                    validate115.errors = [{
                      instancePath: instancePath + "/externalLink",
                      schemaPath: "#/properties/externalLink/type",
                      keyword: "type",
                      params: {
                        type: "string"
                      },
                      message: "must be string"
                    }];
                    return false;
                  }
                  var valid0 = _errs9 === errors;
                } else {
                  var valid0 = true;
                }
              }
            }
          }
        }
      }
    } else {
      validate115.errors = [{
        instancePath,
        schemaPath: "#/type",
        keyword: "type",
        params: {
          type: "object"
        },
        message: "must be object"
      }];
      return false;
    }
  }
  validate115.errors = vErrors;
  return errors === 0;
}
const UserConsentSettings = validate116;
function validate116(data, {
  instancePath = "",
  parentData,
  parentDataProperty,
  rootData = data
} = {}) {
  let vErrors = null;
  let errors = 0;
  {
    if (data && typeof data == "object" && !Array.isArray(data)) {
      let missing0;
      if (data.groups === void 0 && (missing0 = "groups") || data.requests === void 0 && (missing0 = "requests") || data.terms === void 0 && (missing0 = "terms")) {
        validate116.errors = [{
          instancePath,
          schemaPath: "#/required",
          keyword: "required",
          params: {
            missingProperty: missing0
          },
          message: "must have required property '" + missing0 + "'"
        }];
        return false;
      } else {
        if (data.groups !== void 0) {
          let data0 = data.groups;
          const _errs1 = errors;
          {
            if (Array.isArray(data0)) {
              var valid1 = true;
              const len0 = data0.length;
              for (let i0 = 0; i0 < len0; i0++) {
                let data1 = data0[i0];
                const _errs3 = errors;
                {
                  if (data1 && typeof data1 == "object" && !Array.isArray(data1)) {
                    let missing1;
                    if (data1.id === void 0 && (missing1 = "id") || data1.title === void 0 && (missing1 = "title")) {
                      validate116.errors = [{
                        instancePath: instancePath + "/groups/" + i0,
                        schemaPath: "#/properties/groups/items/required",
                        keyword: "required",
                        params: {
                          missingProperty: missing1
                        },
                        message: "must have required property '" + missing1 + "'"
                      }];
                      return false;
                    } else {
                      if (data1.id !== void 0) {
                        const _errs5 = errors;
                        if (typeof data1.id !== "string") {
                          validate116.errors = [{
                            instancePath: instancePath + "/groups/" + i0 + "/id",
                            schemaPath: "#/properties/groups/items/properties/id/type",
                            keyword: "type",
                            params: {
                              type: "string"
                            },
                            message: "must be string"
                          }];
                          return false;
                        }
                        var valid2 = _errs5 === errors;
                      } else {
                        var valid2 = true;
                      }
                      if (valid2) {
                        if (data1.title !== void 0) {
                          const _errs7 = errors;
                          if (typeof data1.title !== "string") {
                            validate116.errors = [{
                              instancePath: instancePath + "/groups/" + i0 + "/title",
                              schemaPath: "#/properties/groups/items/properties/title/type",
                              keyword: "type",
                              params: {
                                type: "string"
                              },
                              message: "must be string"
                            }];
                            return false;
                          }
                          var valid2 = _errs7 === errors;
                        } else {
                          var valid2 = true;
                        }
                      }
                    }
                  } else {
                    validate116.errors = [{
                      instancePath: instancePath + "/groups/" + i0,
                      schemaPath: "#/properties/groups/items/type",
                      keyword: "type",
                      params: {
                        type: "object"
                      },
                      message: "must be object"
                    }];
                    return false;
                  }
                }
                var valid1 = _errs3 === errors;
                if (!valid1) {
                  break;
                }
              }
            } else {
              validate116.errors = [{
                instancePath: instancePath + "/groups",
                schemaPath: "#/properties/groups/type",
                keyword: "type",
                params: {
                  type: "array"
                },
                message: "must be array"
              }];
              return false;
            }
          }
          var valid0 = _errs1 === errors;
        } else {
          var valid0 = true;
        }
        if (valid0) {
          if (data.requests !== void 0) {
            let data4 = data.requests;
            const _errs9 = errors;
            {
              if (Array.isArray(data4)) {
                var valid3 = true;
                const len1 = data4.length;
                for (let i1 = 0; i1 < len1; i1++) {
                  let data5 = data4[i1];
                  const _errs11 = errors;
                  {
                    if (data5 && typeof data5 == "object" && !Array.isArray(data5)) {
                      let missing2;
                      if (data5.id === void 0 && (missing2 = "id") || data5.title === void 0 && (missing2 = "title") || data5.description === void 0 && (missing2 = "description") || data5.version === void 0 && (missing2 = "version") || data5.group === void 0 && (missing2 = "group")) {
                        validate116.errors = [{
                          instancePath: instancePath + "/requests/" + i1,
                          schemaPath: "UserConsentRequest/required",
                          keyword: "required",
                          params: {
                            missingProperty: missing2
                          },
                          message: "must have required property '" + missing2 + "'"
                        }];
                        return false;
                      } else {
                        if (data5.id !== void 0) {
                          const _errs14 = errors;
                          if (typeof data5.id !== "string") {
                            validate116.errors = [{
                              instancePath: instancePath + "/requests/" + i1 + "/id",
                              schemaPath: "UserConsentRequest/properties/id/type",
                              keyword: "type",
                              params: {
                                type: "string"
                              },
                              message: "must be string"
                            }];
                            return false;
                          }
                          var valid5 = _errs14 === errors;
                        } else {
                          var valid5 = true;
                        }
                        if (valid5) {
                          if (data5.title !== void 0) {
                            const _errs16 = errors;
                            if (typeof data5.title !== "string") {
                              validate116.errors = [{
                                instancePath: instancePath + "/requests/" + i1 + "/title",
                                schemaPath: "UserConsentRequest/properties/title/type",
                                keyword: "type",
                                params: {
                                  type: "string"
                                },
                                message: "must be string"
                              }];
                              return false;
                            }
                            var valid5 = _errs16 === errors;
                          } else {
                            var valid5 = true;
                          }
                          if (valid5) {
                            if (data5.description !== void 0) {
                              const _errs18 = errors;
                              if (typeof data5.description !== "string") {
                                validate116.errors = [{
                                  instancePath: instancePath + "/requests/" + i1 + "/description",
                                  schemaPath: "UserConsentRequest/properties/description/type",
                                  keyword: "type",
                                  params: {
                                    type: "string"
                                  },
                                  message: "must be string"
                                }];
                                return false;
                              }
                              var valid5 = _errs18 === errors;
                            } else {
                              var valid5 = true;
                            }
                            if (valid5) {
                              if (data5.version !== void 0) {
                                let data9 = data5.version;
                                const _errs20 = errors;
                                if (!(typeof data9 == "number" && isFinite(data9))) {
                                  validate116.errors = [{
                                    instancePath: instancePath + "/requests/" + i1 + "/version",
                                    schemaPath: "UserConsentRequest/properties/version/type",
                                    keyword: "type",
                                    params: {
                                      type: "number"
                                    },
                                    message: "must be number"
                                  }];
                                  return false;
                                }
                                var valid5 = _errs20 === errors;
                              } else {
                                var valid5 = true;
                              }
                              if (valid5) {
                                if (data5.group !== void 0) {
                                  let data10 = data5.group;
                                  const _errs22 = errors;
                                  if (typeof data10 !== "string" && data10 !== null) {
                                    validate116.errors = [{
                                      instancePath: instancePath + "/requests/" + i1 + "/group",
                                      schemaPath: "UserConsentRequest/properties/group/type",
                                      keyword: "type",
                                      params: {
                                        type: schema121.properties.group.type
                                      },
                                      message: "must be string,null"
                                    }];
                                    return false;
                                  }
                                  var valid5 = _errs22 === errors;
                                } else {
                                  var valid5 = true;
                                }
                              }
                            }
                          }
                        }
                      }
                    } else {
                      validate116.errors = [{
                        instancePath: instancePath + "/requests/" + i1,
                        schemaPath: "UserConsentRequest/type",
                        keyword: "type",
                        params: {
                          type: "object"
                        },
                        message: "must be object"
                      }];
                      return false;
                    }
                  }
                  var valid3 = _errs11 === errors;
                  if (!valid3) {
                    break;
                  }
                }
              } else {
                validate116.errors = [{
                  instancePath: instancePath + "/requests",
                  schemaPath: "#/properties/requests/type",
                  keyword: "type",
                  params: {
                    type: "array"
                  },
                  message: "must be array"
                }];
                return false;
              }
            }
            var valid0 = _errs9 === errors;
          } else {
            var valid0 = true;
          }
          if (valid0) {
            if (data.terms !== void 0) {
              let data11 = data.terms;
              const _errs24 = errors;
              {
                if (Array.isArray(data11)) {
                  var valid6 = true;
                  const len2 = data11.length;
                  for (let i2 = 0; i2 < len2; i2++) {
                    let data12 = data11[i2];
                    const _errs26 = errors;
                    {
                      if (data12 && typeof data12 == "object" && !Array.isArray(data12)) {
                        let missing3;
                        if (data12.id === void 0 && (missing3 = "id") || data12.version === void 0 && (missing3 = "version") || data12.title === void 0 && (missing3 = "title") || data12.description === void 0 && (missing3 = "description") || data12.externalLink === void 0 && (missing3 = "externalLink")) {
                          validate116.errors = [{
                            instancePath: instancePath + "/terms/" + i2,
                            schemaPath: "ChannelTerms/required",
                            keyword: "required",
                            params: {
                              missingProperty: missing3
                            },
                            message: "must have required property '" + missing3 + "'"
                          }];
                          return false;
                        } else {
                          if (data12.id !== void 0) {
                            const _errs29 = errors;
                            if (typeof data12.id !== "string") {
                              validate116.errors = [{
                                instancePath: instancePath + "/terms/" + i2 + "/id",
                                schemaPath: "ChannelTerms/properties/id/type",
                                keyword: "type",
                                params: {
                                  type: "string"
                                },
                                message: "must be string"
                              }];
                              return false;
                            }
                            var valid8 = _errs29 === errors;
                          } else {
                            var valid8 = true;
                          }
                          if (valid8) {
                            if (data12.version !== void 0) {
                              let data14 = data12.version;
                              const _errs31 = errors;
                              if (!(typeof data14 == "number" && isFinite(data14))) {
                                validate116.errors = [{
                                  instancePath: instancePath + "/terms/" + i2 + "/version",
                                  schemaPath: "ChannelTerms/properties/version/type",
                                  keyword: "type",
                                  params: {
                                    type: "number"
                                  },
                                  message: "must be number"
                                }];
                                return false;
                              }
                              var valid8 = _errs31 === errors;
                            } else {
                              var valid8 = true;
                            }
                            if (valid8) {
                              if (data12.title !== void 0) {
                                const _errs33 = errors;
                                if (typeof data12.title !== "string") {
                                  validate116.errors = [{
                                    instancePath: instancePath + "/terms/" + i2 + "/title",
                                    schemaPath: "ChannelTerms/properties/title/type",
                                    keyword: "type",
                                    params: {
                                      type: "string"
                                    },
                                    message: "must be string"
                                  }];
                                  return false;
                                }
                                var valid8 = _errs33 === errors;
                              } else {
                                var valid8 = true;
                              }
                              if (valid8) {
                                if (data12.description !== void 0) {
                                  const _errs35 = errors;
                                  if (typeof data12.description !== "string") {
                                    validate116.errors = [{
                                      instancePath: instancePath + "/terms/" + i2 + "/description",
                                      schemaPath: "ChannelTerms/properties/description/type",
                                      keyword: "type",
                                      params: {
                                        type: "string"
                                      },
                                      message: "must be string"
                                    }];
                                    return false;
                                  }
                                  var valid8 = _errs35 === errors;
                                } else {
                                  var valid8 = true;
                                }
                                if (valid8) {
                                  if (data12.externalLink !== void 0) {
                                    const _errs37 = errors;
                                    if (typeof data12.externalLink !== "string") {
                                      validate116.errors = [{
                                        instancePath: instancePath + "/terms/" + i2 + "/externalLink",
                                        schemaPath: "ChannelTerms/properties/externalLink/type",
                                        keyword: "type",
                                        params: {
                                          type: "string"
                                        },
                                        message: "must be string"
                                      }];
                                      return false;
                                    }
                                    var valid8 = _errs37 === errors;
                                  } else {
                                    var valid8 = true;
                                  }
                                }
                              }
                            }
                          }
                        }
                      } else {
                        validate116.errors = [{
                          instancePath: instancePath + "/terms/" + i2,
                          schemaPath: "ChannelTerms/type",
                          keyword: "type",
                          params: {
                            type: "object"
                          },
                          message: "must be object"
                        }];
                        return false;
                      }
                    }
                    var valid6 = _errs26 === errors;
                    if (!valid6) {
                      break;
                    }
                  }
                } else {
                  validate116.errors = [{
                    instancePath: instancePath + "/terms",
                    schemaPath: "#/properties/terms/type",
                    keyword: "type",
                    params: {
                      type: "array"
                    },
                    message: "must be array"
                  }];
                  return false;
                }
              }
              var valid0 = _errs24 === errors;
            } else {
              var valid0 = true;
            }
          }
        }
      }
    } else {
      validate116.errors = [{
        instancePath,
        schemaPath: "#/type",
        keyword: "type",
        params: {
          type: "object"
        },
        message: "must be object"
      }];
      return false;
    }
  }
  validate116.errors = vErrors;
  return errors === 0;
}
const Testimonial = validate117;
function validate117(data, {
  instancePath = "",
  parentData,
  parentDataProperty,
  rootData = data
} = {}) {
  let vErrors = null;
  let errors = 0;
  {
    if (data && typeof data == "object" && !Array.isArray(data)) {
      let missing0;
      if (data.imageUrl === void 0 && (missing0 = "imageUrl") || data.quote === void 0 && (missing0 = "quote") || data.name === void 0 && (missing0 = "name") || data.role === void 0 && (missing0 = "role")) {
        validate117.errors = [{
          instancePath,
          schemaPath: "#/required",
          keyword: "required",
          params: {
            missingProperty: missing0
          },
          message: "must have required property '" + missing0 + "'"
        }];
        return false;
      } else {
        if (data.imageUrl !== void 0) {
          const _errs1 = errors;
          if (typeof data.imageUrl !== "string") {
            validate117.errors = [{
              instancePath: instancePath + "/imageUrl",
              schemaPath: "#/properties/imageUrl/type",
              keyword: "type",
              params: {
                type: "string"
              },
              message: "must be string"
            }];
            return false;
          }
          var valid0 = _errs1 === errors;
        } else {
          var valid0 = true;
        }
        if (valid0) {
          if (data.quote !== void 0) {
            const _errs3 = errors;
            if (typeof data.quote !== "string") {
              validate117.errors = [{
                instancePath: instancePath + "/quote",
                schemaPath: "#/properties/quote/type",
                keyword: "type",
                params: {
                  type: "string"
                },
                message: "must be string"
              }];
              return false;
            }
            var valid0 = _errs3 === errors;
          } else {
            var valid0 = true;
          }
          if (valid0) {
            if (data.name !== void 0) {
              const _errs5 = errors;
              if (typeof data.name !== "string") {
                validate117.errors = [{
                  instancePath: instancePath + "/name",
                  schemaPath: "#/properties/name/type",
                  keyword: "type",
                  params: {
                    type: "string"
                  },
                  message: "must be string"
                }];
                return false;
              }
              var valid0 = _errs5 === errors;
            } else {
              var valid0 = true;
            }
            if (valid0) {
              if (data.role !== void 0) {
                const _errs7 = errors;
                if (typeof data.role !== "string") {
                  validate117.errors = [{
                    instancePath: instancePath + "/role",
                    schemaPath: "#/properties/role/type",
                    keyword: "type",
                    params: {
                      type: "string"
                    },
                    message: "must be string"
                  }];
                  return false;
                }
                var valid0 = _errs7 === errors;
              } else {
                var valid0 = true;
              }
            }
          }
        }
      }
    } else {
      validate117.errors = [{
        instancePath,
        schemaPath: "#/type",
        keyword: "type",
        params: {
          type: "object"
        },
        message: "must be object"
      }];
      return false;
    }
  }
  validate117.errors = vErrors;
  return errors === 0;
}
const ViewerRetentionSettings = validate118;
function validate118(data, {
  instancePath = "",
  parentData,
  parentDataProperty,
  rootData = data
} = {}) {
  let vErrors = null;
  let errors = 0;
  {
    if (data && typeof data == "object" && !Array.isArray(data)) {
      let missing0;
      if (data.title === void 0 && (missing0 = "title") || data.testimonials === void 0 && (missing0 = "testimonials") || data.cancellationReasons === void 0 && (missing0 = "cancellationReasons")) {
        validate118.errors = [{
          instancePath,
          schemaPath: "#/required",
          keyword: "required",
          params: {
            missingProperty: missing0
          },
          message: "must have required property '" + missing0 + "'"
        }];
        return false;
      } else {
        if (data.title !== void 0) {
          const _errs1 = errors;
          if (typeof data.title !== "string") {
            validate118.errors = [{
              instancePath: instancePath + "/title",
              schemaPath: "#/properties/title/type",
              keyword: "type",
              params: {
                type: "string"
              },
              message: "must be string"
            }];
            return false;
          }
          var valid0 = _errs1 === errors;
        } else {
          var valid0 = true;
        }
        if (valid0) {
          if (data.testimonials !== void 0) {
            let data1 = data.testimonials;
            const _errs3 = errors;
            {
              if (Array.isArray(data1)) {
                var valid1 = true;
                const len0 = data1.length;
                for (let i0 = 0; i0 < len0; i0++) {
                  let data2 = data1[i0];
                  const _errs5 = errors;
                  {
                    if (data2 && typeof data2 == "object" && !Array.isArray(data2)) {
                      let missing1;
                      if (data2.imageUrl === void 0 && (missing1 = "imageUrl") || data2.quote === void 0 && (missing1 = "quote") || data2.name === void 0 && (missing1 = "name") || data2.role === void 0 && (missing1 = "role")) {
                        validate118.errors = [{
                          instancePath: instancePath + "/testimonials/" + i0,
                          schemaPath: "Testimonial/required",
                          keyword: "required",
                          params: {
                            missingProperty: missing1
                          },
                          message: "must have required property '" + missing1 + "'"
                        }];
                        return false;
                      } else {
                        if (data2.imageUrl !== void 0) {
                          const _errs8 = errors;
                          if (typeof data2.imageUrl !== "string") {
                            validate118.errors = [{
                              instancePath: instancePath + "/testimonials/" + i0 + "/imageUrl",
                              schemaPath: "Testimonial/properties/imageUrl/type",
                              keyword: "type",
                              params: {
                                type: "string"
                              },
                              message: "must be string"
                            }];
                            return false;
                          }
                          var valid3 = _errs8 === errors;
                        } else {
                          var valid3 = true;
                        }
                        if (valid3) {
                          if (data2.quote !== void 0) {
                            const _errs10 = errors;
                            if (typeof data2.quote !== "string") {
                              validate118.errors = [{
                                instancePath: instancePath + "/testimonials/" + i0 + "/quote",
                                schemaPath: "Testimonial/properties/quote/type",
                                keyword: "type",
                                params: {
                                  type: "string"
                                },
                                message: "must be string"
                              }];
                              return false;
                            }
                            var valid3 = _errs10 === errors;
                          } else {
                            var valid3 = true;
                          }
                          if (valid3) {
                            if (data2.name !== void 0) {
                              const _errs12 = errors;
                              if (typeof data2.name !== "string") {
                                validate118.errors = [{
                                  instancePath: instancePath + "/testimonials/" + i0 + "/name",
                                  schemaPath: "Testimonial/properties/name/type",
                                  keyword: "type",
                                  params: {
                                    type: "string"
                                  },
                                  message: "must be string"
                                }];
                                return false;
                              }
                              var valid3 = _errs12 === errors;
                            } else {
                              var valid3 = true;
                            }
                            if (valid3) {
                              if (data2.role !== void 0) {
                                const _errs14 = errors;
                                if (typeof data2.role !== "string") {
                                  validate118.errors = [{
                                    instancePath: instancePath + "/testimonials/" + i0 + "/role",
                                    schemaPath: "Testimonial/properties/role/type",
                                    keyword: "type",
                                    params: {
                                      type: "string"
                                    },
                                    message: "must be string"
                                  }];
                                  return false;
                                }
                                var valid3 = _errs14 === errors;
                              } else {
                                var valid3 = true;
                              }
                            }
                          }
                        }
                      }
                    } else {
                      validate118.errors = [{
                        instancePath: instancePath + "/testimonials/" + i0,
                        schemaPath: "Testimonial/type",
                        keyword: "type",
                        params: {
                          type: "object"
                        },
                        message: "must be object"
                      }];
                      return false;
                    }
                  }
                  var valid1 = _errs5 === errors;
                  if (!valid1) {
                    break;
                  }
                }
              } else {
                validate118.errors = [{
                  instancePath: instancePath + "/testimonials",
                  schemaPath: "#/properties/testimonials/type",
                  keyword: "type",
                  params: {
                    type: "array"
                  },
                  message: "must be array"
                }];
                return false;
              }
            }
            var valid0 = _errs3 === errors;
          } else {
            var valid0 = true;
          }
          if (valid0) {
            if (data.cancellationReasons !== void 0) {
              let data7 = data.cancellationReasons;
              const _errs16 = errors;
              {
                if (Array.isArray(data7)) {
                  var valid4 = true;
                  const len1 = data7.length;
                  for (let i1 = 0; i1 < len1; i1++) {
                    const _errs18 = errors;
                    if (typeof data7[i1] !== "string") {
                      validate118.errors = [{
                        instancePath: instancePath + "/cancellationReasons/" + i1,
                        schemaPath: "#/properties/cancellationReasons/items/type",
                        keyword: "type",
                        params: {
                          type: "string"
                        },
                        message: "must be string"
                      }];
                      return false;
                    }
                    var valid4 = _errs18 === errors;
                    if (!valid4) {
                      break;
                    }
                  }
                } else {
                  validate118.errors = [{
                    instancePath: instancePath + "/cancellationReasons",
                    schemaPath: "#/properties/cancellationReasons/type",
                    keyword: "type",
                    params: {
                      type: "array"
                    },
                    message: "must be array"
                  }];
                  return false;
                }
              }
              var valid0 = _errs16 === errors;
            } else {
              var valid0 = true;
            }
          }
        }
      }
    } else {
      validate118.errors = [{
        instancePath,
        schemaPath: "#/type",
        keyword: "type",
        params: {
          type: "object"
        },
        message: "must be object"
      }];
      return false;
    }
  }
  validate118.errors = vErrors;
  return errors === 0;
}
const VideoAttributeValue = validate119;
function validate119(data, {
  instancePath = "",
  parentData,
  parentDataProperty,
  rootData = data
} = {}) {
  let vErrors = null;
  let errors = 0;
  {
    if (data && typeof data == "object" && !Array.isArray(data)) {
      let missing0;
      if (data.name === void 0 && (missing0 = "name")) {
        validate119.errors = [{
          instancePath,
          schemaPath: "#/required",
          keyword: "required",
          params: {
            missingProperty: missing0
          },
          message: "must have required property '" + missing0 + "'"
        }];
        return false;
      } else {
        if (data.name !== void 0) {
          const _errs1 = errors;
          if (typeof data.name !== "string") {
            validate119.errors = [{
              instancePath: instancePath + "/name",
              schemaPath: "#/properties/name/type",
              keyword: "type",
              params: {
                type: "string"
              },
              message: "must be string"
            }];
            return false;
          }
          var valid0 = _errs1 === errors;
        } else {
          var valid0 = true;
        }
        if (valid0) {
          if (data.icon !== void 0) {
            const _errs3 = errors;
            if (typeof data.icon !== "string") {
              validate119.errors = [{
                instancePath: instancePath + "/icon",
                schemaPath: "#/properties/icon/type",
                keyword: "type",
                params: {
                  type: "string"
                },
                message: "must be string"
              }];
              return false;
            }
            var valid0 = _errs3 === errors;
          } else {
            var valid0 = true;
          }
          if (valid0) {
            if (data.group !== void 0) {
              const _errs5 = errors;
              if (typeof data.group !== "string") {
                validate119.errors = [{
                  instancePath: instancePath + "/group",
                  schemaPath: "#/properties/group/type",
                  keyword: "type",
                  params: {
                    type: "string"
                  },
                  message: "must be string"
                }];
                return false;
              }
              var valid0 = _errs5 === errors;
            } else {
              var valid0 = true;
            }
            if (valid0) {
              if (data.label !== void 0) {
                const _errs7 = errors;
                if (typeof data.label !== "string") {
                  validate119.errors = [{
                    instancePath: instancePath + "/label",
                    schemaPath: "#/properties/label/type",
                    keyword: "type",
                    params: {
                      type: "string"
                    },
                    message: "must be string"
                  }];
                  return false;
                }
                var valid0 = _errs7 === errors;
              } else {
                var valid0 = true;
              }
            }
          }
        }
      }
    } else {
      validate119.errors = [{
        instancePath,
        schemaPath: "#/type",
        keyword: "type",
        params: {
          type: "object"
        },
        message: "must be object"
      }];
      return false;
    }
  }
  validate119.errors = vErrors;
  return errors === 0;
}
const VideoAttribute = validate120;
function validate120(data, {
  instancePath = "",
  parentData,
  parentDataProperty,
  rootData = data
} = {}) {
  let vErrors = null;
  let errors = 0;
  {
    if (data && typeof data == "object" && !Array.isArray(data)) {
      let missing0;
      if (data.name === void 0 && (missing0 = "name") || data.label === void 0 && (missing0 = "label") || data.values === void 0 && (missing0 = "values")) {
        validate120.errors = [{
          instancePath,
          schemaPath: "#/required",
          keyword: "required",
          params: {
            missingProperty: missing0
          },
          message: "must have required property '" + missing0 + "'"
        }];
        return false;
      } else {
        if (data.name !== void 0) {
          const _errs1 = errors;
          if (typeof data.name !== "string") {
            validate120.errors = [{
              instancePath: instancePath + "/name",
              schemaPath: "#/properties/name/type",
              keyword: "type",
              params: {
                type: "string"
              },
              message: "must be string"
            }];
            return false;
          }
          var valid0 = _errs1 === errors;
        } else {
          var valid0 = true;
        }
        if (valid0) {
          if (data.label !== void 0) {
            const _errs3 = errors;
            if (typeof data.label !== "string") {
              validate120.errors = [{
                instancePath: instancePath + "/label",
                schemaPath: "#/properties/label/type",
                keyword: "type",
                params: {
                  type: "string"
                },
                message: "must be string"
              }];
              return false;
            }
            var valid0 = _errs3 === errors;
          } else {
            var valid0 = true;
          }
          if (valid0) {
            if (data.icon !== void 0) {
              const _errs5 = errors;
              if (typeof data.icon !== "string") {
                validate120.errors = [{
                  instancePath: instancePath + "/icon",
                  schemaPath: "#/properties/icon/type",
                  keyword: "type",
                  params: {
                    type: "string"
                  },
                  message: "must be string"
                }];
                return false;
              }
              var valid0 = _errs5 === errors;
            } else {
              var valid0 = true;
            }
            if (valid0) {
              if (data.groups !== void 0) {
                let data3 = data.groups;
                const _errs7 = errors;
                {
                  if (Array.isArray(data3)) {
                    var valid1 = true;
                    const len0 = data3.length;
                    for (let i0 = 0; i0 < len0; i0++) {
                      let data4 = data3[i0];
                      const _errs9 = errors;
                      {
                        if (data4 && typeof data4 == "object" && !Array.isArray(data4)) {
                          let missing1;
                          if (data4.id === void 0 && (missing1 = "id") || data4.label === void 0 && (missing1 = "label")) {
                            validate120.errors = [{
                              instancePath: instancePath + "/groups/" + i0,
                              schemaPath: "#/properties/groups/items/required",
                              keyword: "required",
                              params: {
                                missingProperty: missing1
                              },
                              message: "must have required property '" + missing1 + "'"
                            }];
                            return false;
                          } else {
                            if (data4.id !== void 0) {
                              const _errs11 = errors;
                              if (typeof data4.id !== "string") {
                                validate120.errors = [{
                                  instancePath: instancePath + "/groups/" + i0 + "/id",
                                  schemaPath: "#/properties/groups/items/properties/id/type",
                                  keyword: "type",
                                  params: {
                                    type: "string"
                                  },
                                  message: "must be string"
                                }];
                                return false;
                              }
                              var valid2 = _errs11 === errors;
                            } else {
                              var valid2 = true;
                            }
                            if (valid2) {
                              if (data4.label !== void 0) {
                                const _errs13 = errors;
                                if (typeof data4.label !== "string") {
                                  validate120.errors = [{
                                    instancePath: instancePath + "/groups/" + i0 + "/label",
                                    schemaPath: "#/properties/groups/items/properties/label/type",
                                    keyword: "type",
                                    params: {
                                      type: "string"
                                    },
                                    message: "must be string"
                                  }];
                                  return false;
                                }
                                var valid2 = _errs13 === errors;
                              } else {
                                var valid2 = true;
                              }
                            }
                          }
                        } else {
                          validate120.errors = [{
                            instancePath: instancePath + "/groups/" + i0,
                            schemaPath: "#/properties/groups/items/type",
                            keyword: "type",
                            params: {
                              type: "object"
                            },
                            message: "must be object"
                          }];
                          return false;
                        }
                      }
                      var valid1 = _errs9 === errors;
                      if (!valid1) {
                        break;
                      }
                    }
                  } else {
                    validate120.errors = [{
                      instancePath: instancePath + "/groups",
                      schemaPath: "#/properties/groups/type",
                      keyword: "type",
                      params: {
                        type: "array"
                      },
                      message: "must be array"
                    }];
                    return false;
                  }
                }
                var valid0 = _errs7 === errors;
              } else {
                var valid0 = true;
              }
              if (valid0) {
                if (data.videoAnalyticsKey !== void 0) {
                  const _errs15 = errors;
                  if (typeof data.videoAnalyticsKey !== "string") {
                    validate120.errors = [{
                      instancePath: instancePath + "/videoAnalyticsKey",
                      schemaPath: "#/properties/videoAnalyticsKey/type",
                      keyword: "type",
                      params: {
                        type: "string"
                      },
                      message: "must be string"
                    }];
                    return false;
                  }
                  var valid0 = _errs15 === errors;
                } else {
                  var valid0 = true;
                }
                if (valid0) {
                  if (data.values !== void 0) {
                    let data8 = data.values;
                    const _errs17 = errors;
                    {
                      if (Array.isArray(data8)) {
                        var valid3 = true;
                        const len1 = data8.length;
                        for (let i1 = 0; i1 < len1; i1++) {
                          let data9 = data8[i1];
                          const _errs19 = errors;
                          {
                            if (data9 && typeof data9 == "object" && !Array.isArray(data9)) {
                              let missing2;
                              if (data9.name === void 0 && (missing2 = "name")) {
                                validate120.errors = [{
                                  instancePath: instancePath + "/values/" + i1,
                                  schemaPath: "VideoAttributeValue/required",
                                  keyword: "required",
                                  params: {
                                    missingProperty: missing2
                                  },
                                  message: "must have required property '" + missing2 + "'"
                                }];
                                return false;
                              } else {
                                if (data9.name !== void 0) {
                                  const _errs22 = errors;
                                  if (typeof data9.name !== "string") {
                                    validate120.errors = [{
                                      instancePath: instancePath + "/values/" + i1 + "/name",
                                      schemaPath: "VideoAttributeValue/properties/name/type",
                                      keyword: "type",
                                      params: {
                                        type: "string"
                                      },
                                      message: "must be string"
                                    }];
                                    return false;
                                  }
                                  var valid5 = _errs22 === errors;
                                } else {
                                  var valid5 = true;
                                }
                                if (valid5) {
                                  if (data9.icon !== void 0) {
                                    const _errs24 = errors;
                                    if (typeof data9.icon !== "string") {
                                      validate120.errors = [{
                                        instancePath: instancePath + "/values/" + i1 + "/icon",
                                        schemaPath: "VideoAttributeValue/properties/icon/type",
                                        keyword: "type",
                                        params: {
                                          type: "string"
                                        },
                                        message: "must be string"
                                      }];
                                      return false;
                                    }
                                    var valid5 = _errs24 === errors;
                                  } else {
                                    var valid5 = true;
                                  }
                                  if (valid5) {
                                    if (data9.group !== void 0) {
                                      const _errs26 = errors;
                                      if (typeof data9.group !== "string") {
                                        validate120.errors = [{
                                          instancePath: instancePath + "/values/" + i1 + "/group",
                                          schemaPath: "VideoAttributeValue/properties/group/type",
                                          keyword: "type",
                                          params: {
                                            type: "string"
                                          },
                                          message: "must be string"
                                        }];
                                        return false;
                                      }
                                      var valid5 = _errs26 === errors;
                                    } else {
                                      var valid5 = true;
                                    }
                                    if (valid5) {
                                      if (data9.label !== void 0) {
                                        const _errs28 = errors;
                                        if (typeof data9.label !== "string") {
                                          validate120.errors = [{
                                            instancePath: instancePath + "/values/" + i1 + "/label",
                                            schemaPath: "VideoAttributeValue/properties/label/type",
                                            keyword: "type",
                                            params: {
                                              type: "string"
                                            },
                                            message: "must be string"
                                          }];
                                          return false;
                                        }
                                        var valid5 = _errs28 === errors;
                                      } else {
                                        var valid5 = true;
                                      }
                                    }
                                  }
                                }
                              }
                            } else {
                              validate120.errors = [{
                                instancePath: instancePath + "/values/" + i1,
                                schemaPath: "VideoAttributeValue/type",
                                keyword: "type",
                                params: {
                                  type: "object"
                                },
                                message: "must be object"
                              }];
                              return false;
                            }
                          }
                          var valid3 = _errs19 === errors;
                          if (!valid3) {
                            break;
                          }
                        }
                      } else {
                        validate120.errors = [{
                          instancePath: instancePath + "/values",
                          schemaPath: "#/properties/values/type",
                          keyword: "type",
                          params: {
                            type: "array"
                          },
                          message: "must be array"
                        }];
                        return false;
                      }
                    }
                    var valid0 = _errs17 === errors;
                  } else {
                    var valid0 = true;
                  }
                }
              }
            }
          }
        }
      }
    } else {
      validate120.errors = [{
        instancePath,
        schemaPath: "#/type",
        keyword: "type",
        params: {
          type: "object"
        },
        message: "must be object"
      }];
      return false;
    }
  }
  validate120.errors = vErrors;
  return errors === 0;
}
const VideoAttributesMapping = validate121;
function validate121(data, {
  instancePath = "",
  parentData,
  parentDataProperty,
  rootData = data
} = {}) {
  let vErrors = null;
  let errors = 0;
  if (errors === 0) {
    if (data && typeof data == "object" && !Array.isArray(data)) {
      let missing0;
      if (data.mappings === void 0 && (missing0 = "mappings")) {
        validate121.errors = [{
          instancePath,
          schemaPath: "#/required",
          keyword: "required",
          params: {
            missingProperty: missing0
          },
          message: "must have required property '" + missing0 + "'"
        }];
        return false;
      } else {
        if (data.useNamedTagAsAttribute !== void 0) {
          let data0 = data.useNamedTagAsAttribute;
          const _errs1 = errors;
          if (errors === _errs1) {
            if (data0 && typeof data0 == "object" && !Array.isArray(data0)) {
              let missing1;
              if (data0.type === void 0 && (missing1 = "type") || data0.label === void 0 && (missing1 = "label") || data0.showIcon === void 0 && (missing1 = "showIcon")) {
                validate121.errors = [{
                  instancePath: instancePath + "/useNamedTagAsAttribute",
                  schemaPath: "#/properties/useNamedTagAsAttribute/required",
                  keyword: "required",
                  params: {
                    missingProperty: missing1
                  },
                  message: "must have required property '" + missing1 + "'"
                }];
                return false;
              } else {
                if (data0.type !== void 0) {
                  let data1 = data0.type;
                  const _errs3 = errors;
                  if (typeof data1 !== "string") {
                    validate121.errors = [{
                      instancePath: instancePath + "/useNamedTagAsAttribute/type",
                      schemaPath: "NamedTagType/type",
                      keyword: "type",
                      params: {
                        type: "string"
                      },
                      message: "must be string"
                    }];
                    return false;
                  }
                  if (!(data1 === "EVENT" || data1 === "ATHLETE" || data1 === "PLACE" || data1 === "TOURNAMENT" || data1 === "TEAM" || data1 === "SEASON")) {
                    validate121.errors = [{
                      instancePath: instancePath + "/useNamedTagAsAttribute/type",
                      schemaPath: "NamedTagType/enum",
                      keyword: "enum",
                      params: {
                        allowedValues: schema109.enum
                      },
                      message: "must be equal to one of the allowed values"
                    }];
                    return false;
                  }
                  var valid1 = _errs3 === errors;
                } else {
                  var valid1 = true;
                }
                if (valid1) {
                  if (data0.label !== void 0) {
                    const _errs6 = errors;
                    if (typeof data0.label !== "string") {
                      validate121.errors = [{
                        instancePath: instancePath + "/useNamedTagAsAttribute/label",
                        schemaPath: "#/properties/useNamedTagAsAttribute/properties/label/type",
                        keyword: "type",
                        params: {
                          type: "string"
                        },
                        message: "must be string"
                      }];
                      return false;
                    }
                    var valid1 = _errs6 === errors;
                  } else {
                    var valid1 = true;
                  }
                  if (valid1) {
                    if (data0.showIcon !== void 0) {
                      const _errs8 = errors;
                      if (typeof data0.showIcon !== "boolean") {
                        validate121.errors = [{
                          instancePath: instancePath + "/useNamedTagAsAttribute/showIcon",
                          schemaPath: "#/properties/useNamedTagAsAttribute/properties/showIcon/type",
                          keyword: "type",
                          params: {
                            type: "boolean"
                          },
                          message: "must be boolean"
                        }];
                        return false;
                      }
                      var valid1 = _errs8 === errors;
                    } else {
                      var valid1 = true;
                    }
                  }
                }
              }
            } else {
              validate121.errors = [{
                instancePath: instancePath + "/useNamedTagAsAttribute",
                schemaPath: "#/properties/useNamedTagAsAttribute/type",
                keyword: "type",
                params: {
                  type: "object"
                },
                message: "must be object"
              }];
              return false;
            }
          }
          var valid0 = _errs1 === errors;
        } else {
          var valid0 = true;
        }
        if (valid0) {
          if (data.mappings !== void 0) {
            let data4 = data.mappings;
            const _errs10 = errors;
            if (errors === _errs10) {
              if (data4 && typeof data4 == "object" && !Array.isArray(data4)) {
                if (data4.attr0 !== void 0) {
                  const _errs12 = errors;
                  if (!validate120(data4.attr0, {
                    instancePath: instancePath + "/mappings/attr0",
                    parentData: data4,
                    parentDataProperty: "attr0",
                    rootData
                  })) {
                    vErrors = vErrors === null ? validate120.errors : vErrors.concat(validate120.errors);
                    errors = vErrors.length;
                  }
                  var valid3 = _errs12 === errors;
                } else {
                  var valid3 = true;
                }
                if (valid3) {
                  if (data4.attr1 !== void 0) {
                    const _errs13 = errors;
                    if (!validate120(data4.attr1, {
                      instancePath: instancePath + "/mappings/attr1",
                      parentData: data4,
                      parentDataProperty: "attr1",
                      rootData
                    })) {
                      vErrors = vErrors === null ? validate120.errors : vErrors.concat(validate120.errors);
                      errors = vErrors.length;
                    }
                    var valid3 = _errs13 === errors;
                  } else {
                    var valid3 = true;
                  }
                  if (valid3) {
                    if (data4.attr2 !== void 0) {
                      const _errs14 = errors;
                      if (!validate120(data4.attr2, {
                        instancePath: instancePath + "/mappings/attr2",
                        parentData: data4,
                        parentDataProperty: "attr2",
                        rootData
                      })) {
                        vErrors = vErrors === null ? validate120.errors : vErrors.concat(validate120.errors);
                        errors = vErrors.length;
                      }
                      var valid3 = _errs14 === errors;
                    } else {
                      var valid3 = true;
                    }
                    if (valid3) {
                      if (data4.attr3 !== void 0) {
                        const _errs15 = errors;
                        if (!validate120(data4.attr3, {
                          instancePath: instancePath + "/mappings/attr3",
                          parentData: data4,
                          parentDataProperty: "attr3",
                          rootData
                        })) {
                          vErrors = vErrors === null ? validate120.errors : vErrors.concat(validate120.errors);
                          errors = vErrors.length;
                        }
                        var valid3 = _errs15 === errors;
                      } else {
                        var valid3 = true;
                      }
                    }
                  }
                }
              } else {
                validate121.errors = [{
                  instancePath: instancePath + "/mappings",
                  schemaPath: "#/properties/mappings/type",
                  keyword: "type",
                  params: {
                    type: "object"
                  },
                  message: "must be object"
                }];
                return false;
              }
            }
            var valid0 = _errs10 === errors;
          } else {
            var valid0 = true;
          }
          if (valid0) {
            if (data.defaultConfig !== void 0) {
              let data9 = data.defaultConfig;
              const _errs16 = errors;
              if (errors === _errs16) {
                if (Array.isArray(data9)) {
                  var valid4 = true;
                  const len0 = data9.length;
                  for (let i0 = 0; i0 < len0; i0++) {
                    const _errs18 = errors;
                    if (!validate74(data9[i0], {
                      instancePath: instancePath + "/defaultConfig/" + i0,
                      parentData: data9,
                      parentDataProperty: i0,
                      rootData
                    })) {
                      vErrors = vErrors === null ? validate74.errors : vErrors.concat(validate74.errors);
                      errors = vErrors.length;
                    }
                    var valid4 = _errs18 === errors;
                    if (!valid4) {
                      break;
                    }
                  }
                } else {
                  validate121.errors = [{
                    instancePath: instancePath + "/defaultConfig",
                    schemaPath: "#/properties/defaultConfig/type",
                    keyword: "type",
                    params: {
                      type: "array"
                    },
                    message: "must be array"
                  }];
                  return false;
                }
              }
              var valid0 = _errs16 === errors;
            } else {
              var valid0 = true;
            }
          }
        }
      }
    } else {
      validate121.errors = [{
        instancePath,
        schemaPath: "#/type",
        keyword: "type",
        params: {
          type: "object"
        },
        message: "must be object"
      }];
      return false;
    }
  }
  validate121.errors = vErrors;
  return errors === 0;
}
const Sport80PlanProvider = validate127;
function validate127(data, {
  instancePath = "",
  parentData,
  parentDataProperty,
  rootData = data
} = {}) {
  let vErrors = null;
  let errors = 0;
  if (errors === 0) {
    if (data && typeof data == "object" && !Array.isArray(data)) {
      let missing0;
      if (data.enabled === void 0 && (missing0 = "enabled") || data.name === void 0 && (missing0 = "name") || data.label === void 0 && (missing0 = "label")) {
        validate127.errors = [{
          instancePath,
          schemaPath: "#/required",
          keyword: "required",
          params: {
            missingProperty: missing0
          },
          message: "must have required property '" + missing0 + "'"
        }];
        return false;
      } else {
        if (data.enabled !== void 0) {
          let data0 = data.enabled;
          const _errs1 = errors;
          const _errs2 = errors;
          let valid1 = false;
          const _errs3 = errors;
          if (errors === _errs3) {
            if (Array.isArray(data0)) {
              var valid2 = true;
              const len0 = data0.length;
              for (let i0 = 0; i0 < len0; i0++) {
                const _errs5 = errors;
                if (typeof data0[i0] !== "string") {
                  const err0 = {
                    instancePath: instancePath + "/enabled/" + i0,
                    schemaPath: "#/properties/enabled/anyOf/0/items/type",
                    keyword: "type",
                    params: {
                      type: "string"
                    },
                    message: "must be string"
                  };
                  if (vErrors === null) {
                    vErrors = [err0];
                  } else {
                    vErrors.push(err0);
                  }
                  errors++;
                }
                var valid2 = _errs5 === errors;
                if (!valid2) {
                  break;
                }
              }
            } else {
              const err1 = {
                instancePath: instancePath + "/enabled",
                schemaPath: "#/properties/enabled/anyOf/0/type",
                keyword: "type",
                params: {
                  type: "array"
                },
                message: "must be array"
              };
              if (vErrors === null) {
                vErrors = [err1];
              } else {
                vErrors.push(err1);
              }
              errors++;
            }
          }
          var _valid0 = _errs3 === errors;
          valid1 = valid1 || _valid0;
          if (!valid1) {
            const _errs7 = errors;
            if (typeof data0 !== "boolean") {
              const err2 = {
                instancePath: instancePath + "/enabled",
                schemaPath: "#/properties/enabled/anyOf/1/type",
                keyword: "type",
                params: {
                  type: "boolean"
                },
                message: "must be boolean"
              };
              if (vErrors === null) {
                vErrors = [err2];
              } else {
                vErrors.push(err2);
              }
              errors++;
            }
            var _valid0 = _errs7 === errors;
            valid1 = valid1 || _valid0;
          }
          if (!valid1) {
            const err3 = {
              instancePath: instancePath + "/enabled",
              schemaPath: "#/properties/enabled/anyOf",
              keyword: "anyOf",
              params: {},
              message: "must match a schema in anyOf"
            };
            if (vErrors === null) {
              vErrors = [err3];
            } else {
              vErrors.push(err3);
            }
            errors++;
            validate127.errors = vErrors;
            return false;
          } else {
            errors = _errs2;
            if (vErrors !== null) {
              if (_errs2) {
                vErrors.length = _errs2;
              } else {
                vErrors = null;
              }
            }
          }
          var valid0 = _errs1 === errors;
        } else {
          var valid0 = true;
        }
        if (valid0) {
          if (data.name !== void 0) {
            const _errs9 = errors;
            if (typeof data.name !== "string") {
              validate127.errors = [{
                instancePath: instancePath + "/name",
                schemaPath: "#/properties/name/type",
                keyword: "type",
                params: {
                  type: "string"
                },
                message: "must be string"
              }];
              return false;
            }
            var valid0 = _errs9 === errors;
          } else {
            var valid0 = true;
          }
          if (valid0) {
            if (data.label !== void 0) {
              const _errs11 = errors;
              if (typeof data.label !== "string") {
                validate127.errors = [{
                  instancePath: instancePath + "/label",
                  schemaPath: "#/properties/label/type",
                  keyword: "type",
                  params: {
                    type: "string"
                  },
                  message: "must be string"
                }];
                return false;
              }
              var valid0 = _errs11 === errors;
            } else {
              var valid0 = true;
            }
            if (valid0) {
              if (data.logoUrl !== void 0) {
                const _errs13 = errors;
                if (typeof data.logoUrl !== "string") {
                  validate127.errors = [{
                    instancePath: instancePath + "/logoUrl",
                    schemaPath: "#/properties/logoUrl/type",
                    keyword: "type",
                    params: {
                      type: "string"
                    },
                    message: "must be string"
                  }];
                  return false;
                }
                var valid0 = _errs13 === errors;
              } else {
                var valid0 = true;
              }
              if (valid0) {
                if (data.description !== void 0) {
                  const _errs15 = errors;
                  if (typeof data.description !== "string") {
                    validate127.errors = [{
                      instancePath: instancePath + "/description",
                      schemaPath: "#/properties/description/type",
                      keyword: "type",
                      params: {
                        type: "string"
                      },
                      message: "must be string"
                    }];
                    return false;
                  }
                  var valid0 = _errs15 === errors;
                } else {
                  var valid0 = true;
                }
                if (valid0) {
                  if (data.descriptionWhenLinked !== void 0) {
                    const _errs17 = errors;
                    if (typeof data.descriptionWhenLinked !== "string") {
                      validate127.errors = [{
                        instancePath: instancePath + "/descriptionWhenLinked",
                        schemaPath: "#/properties/descriptionWhenLinked/type",
                        keyword: "type",
                        params: {
                          type: "string"
                        },
                        message: "must be string"
                      }];
                      return false;
                    }
                    var valid0 = _errs17 === errors;
                  } else {
                    var valid0 = true;
                  }
                  if (valid0) {
                    if (data.linkExplanation !== void 0) {
                      const _errs19 = errors;
                      if (typeof data.linkExplanation !== "string") {
                        validate127.errors = [{
                          instancePath: instancePath + "/linkExplanation",
                          schemaPath: "#/properties/linkExplanation/type",
                          keyword: "type",
                          params: {
                            type: "string"
                          },
                          message: "must be string"
                        }];
                        return false;
                      }
                      var valid0 = _errs19 === errors;
                    } else {
                      var valid0 = true;
                    }
                    if (valid0) {
                      if (data.unlinkExplanation !== void 0) {
                        const _errs21 = errors;
                        if (typeof data.unlinkExplanation !== "string") {
                          validate127.errors = [{
                            instancePath: instancePath + "/unlinkExplanation",
                            schemaPath: "#/properties/unlinkExplanation/type",
                            keyword: "type",
                            params: {
                              type: "string"
                            },
                            message: "must be string"
                          }];
                          return false;
                        }
                        var valid0 = _errs21 === errors;
                      } else {
                        var valid0 = true;
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
    } else {
      validate127.errors = [{
        instancePath,
        schemaPath: "#/type",
        keyword: "type",
        params: {
          type: "object"
        },
        message: "must be object"
      }];
      return false;
    }
  }
  validate127.errors = vErrors;
  return errors === 0;
}
const ChannelPublicSettings = validate128;
function validate128(data, {
  instancePath = "",
  parentData,
  parentDataProperty,
  rootData = data
} = {}) {
  let vErrors = null;
  let errors = 0;
  if (errors === 0) {
    if (data && typeof data == "object" && !Array.isArray(data)) {
      let missing0;
      if (data.userConsent === void 0 && (missing0 = "userConsent")) {
        validate128.errors = [{
          instancePath,
          schemaPath: "#/required",
          keyword: "required",
          params: {
            missingProperty: missing0
          },
          message: "must have required property '" + missing0 + "'"
        }];
        return false;
      } else {
        if (data.externalPlanProviders !== void 0) {
          let data0 = data.externalPlanProviders;
          const _errs1 = errors;
          if (errors === _errs1) {
            if (data0 && typeof data0 == "object" && !Array.isArray(data0)) {
              if (data0.sport80 !== void 0) {
                let data1 = data0.sport80;
                const _errs4 = errors;
                if (errors === _errs4) {
                  if (data1 && typeof data1 == "object" && !Array.isArray(data1)) {
                    let missing1;
                    if (data1.enabled === void 0 && (missing1 = "enabled") || data1.name === void 0 && (missing1 = "name") || data1.label === void 0 && (missing1 = "label")) {
                      validate128.errors = [{
                        instancePath: instancePath + "/externalPlanProviders/sport80",
                        schemaPath: "Sport80PlanProvider/required",
                        keyword: "required",
                        params: {
                          missingProperty: missing1
                        },
                        message: "must have required property '" + missing1 + "'"
                      }];
                      return false;
                    } else {
                      if (data1.enabled !== void 0) {
                        let data2 = data1.enabled;
                        const _errs6 = errors;
                        const _errs7 = errors;
                        let valid4 = false;
                        const _errs8 = errors;
                        if (errors === _errs8) {
                          if (Array.isArray(data2)) {
                            var valid5 = true;
                            const len0 = data2.length;
                            for (let i0 = 0; i0 < len0; i0++) {
                              const _errs10 = errors;
                              if (typeof data2[i0] !== "string") {
                                const err0 = {
                                  instancePath: instancePath + "/externalPlanProviders/sport80/enabled/" + i0,
                                  schemaPath: "Sport80PlanProvider/properties/enabled/anyOf/0/items/type",
                                  keyword: "type",
                                  params: {
                                    type: "string"
                                  },
                                  message: "must be string"
                                };
                                if (vErrors === null) {
                                  vErrors = [err0];
                                } else {
                                  vErrors.push(err0);
                                }
                                errors++;
                              }
                              var valid5 = _errs10 === errors;
                              if (!valid5) {
                                break;
                              }
                            }
                          } else {
                            const err1 = {
                              instancePath: instancePath + "/externalPlanProviders/sport80/enabled",
                              schemaPath: "Sport80PlanProvider/properties/enabled/anyOf/0/type",
                              keyword: "type",
                              params: {
                                type: "array"
                              },
                              message: "must be array"
                            };
                            if (vErrors === null) {
                              vErrors = [err1];
                            } else {
                              vErrors.push(err1);
                            }
                            errors++;
                          }
                        }
                        var _valid0 = _errs8 === errors;
                        valid4 = valid4 || _valid0;
                        if (!valid4) {
                          const _errs12 = errors;
                          if (typeof data2 !== "boolean") {
                            const err2 = {
                              instancePath: instancePath + "/externalPlanProviders/sport80/enabled",
                              schemaPath: "Sport80PlanProvider/properties/enabled/anyOf/1/type",
                              keyword: "type",
                              params: {
                                type: "boolean"
                              },
                              message: "must be boolean"
                            };
                            if (vErrors === null) {
                              vErrors = [err2];
                            } else {
                              vErrors.push(err2);
                            }
                            errors++;
                          }
                          var _valid0 = _errs12 === errors;
                          valid4 = valid4 || _valid0;
                        }
                        if (!valid4) {
                          const err3 = {
                            instancePath: instancePath + "/externalPlanProviders/sport80/enabled",
                            schemaPath: "Sport80PlanProvider/properties/enabled/anyOf",
                            keyword: "anyOf",
                            params: {},
                            message: "must match a schema in anyOf"
                          };
                          if (vErrors === null) {
                            vErrors = [err3];
                          } else {
                            vErrors.push(err3);
                          }
                          errors++;
                          validate128.errors = vErrors;
                          return false;
                        } else {
                          errors = _errs7;
                          if (vErrors !== null) {
                            if (_errs7) {
                              vErrors.length = _errs7;
                            } else {
                              vErrors = null;
                            }
                          }
                        }
                        var valid3 = _errs6 === errors;
                      } else {
                        var valid3 = true;
                      }
                      if (valid3) {
                        if (data1.name !== void 0) {
                          const _errs14 = errors;
                          if (typeof data1.name !== "string") {
                            validate128.errors = [{
                              instancePath: instancePath + "/externalPlanProviders/sport80/name",
                              schemaPath: "Sport80PlanProvider/properties/name/type",
                              keyword: "type",
                              params: {
                                type: "string"
                              },
                              message: "must be string"
                            }];
                            return false;
                          }
                          var valid3 = _errs14 === errors;
                        } else {
                          var valid3 = true;
                        }
                        if (valid3) {
                          if (data1.label !== void 0) {
                            const _errs16 = errors;
                            if (typeof data1.label !== "string") {
                              validate128.errors = [{
                                instancePath: instancePath + "/externalPlanProviders/sport80/label",
                                schemaPath: "Sport80PlanProvider/properties/label/type",
                                keyword: "type",
                                params: {
                                  type: "string"
                                },
                                message: "must be string"
                              }];
                              return false;
                            }
                            var valid3 = _errs16 === errors;
                          } else {
                            var valid3 = true;
                          }
                          if (valid3) {
                            if (data1.logoUrl !== void 0) {
                              const _errs18 = errors;
                              if (typeof data1.logoUrl !== "string") {
                                validate128.errors = [{
                                  instancePath: instancePath + "/externalPlanProviders/sport80/logoUrl",
                                  schemaPath: "Sport80PlanProvider/properties/logoUrl/type",
                                  keyword: "type",
                                  params: {
                                    type: "string"
                                  },
                                  message: "must be string"
                                }];
                                return false;
                              }
                              var valid3 = _errs18 === errors;
                            } else {
                              var valid3 = true;
                            }
                            if (valid3) {
                              if (data1.description !== void 0) {
                                const _errs20 = errors;
                                if (typeof data1.description !== "string") {
                                  validate128.errors = [{
                                    instancePath: instancePath + "/externalPlanProviders/sport80/description",
                                    schemaPath: "Sport80PlanProvider/properties/description/type",
                                    keyword: "type",
                                    params: {
                                      type: "string"
                                    },
                                    message: "must be string"
                                  }];
                                  return false;
                                }
                                var valid3 = _errs20 === errors;
                              } else {
                                var valid3 = true;
                              }
                              if (valid3) {
                                if (data1.descriptionWhenLinked !== void 0) {
                                  const _errs22 = errors;
                                  if (typeof data1.descriptionWhenLinked !== "string") {
                                    validate128.errors = [{
                                      instancePath: instancePath + "/externalPlanProviders/sport80/descriptionWhenLinked",
                                      schemaPath: "Sport80PlanProvider/properties/descriptionWhenLinked/type",
                                      keyword: "type",
                                      params: {
                                        type: "string"
                                      },
                                      message: "must be string"
                                    }];
                                    return false;
                                  }
                                  var valid3 = _errs22 === errors;
                                } else {
                                  var valid3 = true;
                                }
                                if (valid3) {
                                  if (data1.linkExplanation !== void 0) {
                                    const _errs24 = errors;
                                    if (typeof data1.linkExplanation !== "string") {
                                      validate128.errors = [{
                                        instancePath: instancePath + "/externalPlanProviders/sport80/linkExplanation",
                                        schemaPath: "Sport80PlanProvider/properties/linkExplanation/type",
                                        keyword: "type",
                                        params: {
                                          type: "string"
                                        },
                                        message: "must be string"
                                      }];
                                      return false;
                                    }
                                    var valid3 = _errs24 === errors;
                                  } else {
                                    var valid3 = true;
                                  }
                                  if (valid3) {
                                    if (data1.unlinkExplanation !== void 0) {
                                      const _errs26 = errors;
                                      if (typeof data1.unlinkExplanation !== "string") {
                                        validate128.errors = [{
                                          instancePath: instancePath + "/externalPlanProviders/sport80/unlinkExplanation",
                                          schemaPath: "Sport80PlanProvider/properties/unlinkExplanation/type",
                                          keyword: "type",
                                          params: {
                                            type: "string"
                                          },
                                          message: "must be string"
                                        }];
                                        return false;
                                      }
                                      var valid3 = _errs26 === errors;
                                    } else {
                                      var valid3 = true;
                                    }
                                  }
                                }
                              }
                            }
                          }
                        }
                      }
                    }
                  } else {
                    validate128.errors = [{
                      instancePath: instancePath + "/externalPlanProviders/sport80",
                      schemaPath: "Sport80PlanProvider/type",
                      keyword: "type",
                      params: {
                        type: "object"
                      },
                      message: "must be object"
                    }];
                    return false;
                  }
                }
              }
            } else {
              validate128.errors = [{
                instancePath: instancePath + "/externalPlanProviders",
                schemaPath: "#/properties/externalPlanProviders/type",
                keyword: "type",
                params: {
                  type: "object"
                },
                message: "must be object"
              }];
              return false;
            }
          }
          var valid0 = _errs1 === errors;
        } else {
          var valid0 = true;
        }
        if (valid0) {
          if (data.userConsent !== void 0) {
            const _errs28 = errors;
            if (!validate116(data.userConsent, {
              instancePath: instancePath + "/userConsent",
              parentData: data,
              parentDataProperty: "userConsent",
              rootData
            })) {
              vErrors = vErrors === null ? validate116.errors : vErrors.concat(validate116.errors);
              errors = vErrors.length;
            }
            var valid0 = _errs28 === errors;
          } else {
            var valid0 = true;
          }
          if (valid0) {
            if (data.viewerRetentionSettings !== void 0) {
              const _errs29 = errors;
              if (!validate118(data.viewerRetentionSettings, {
                instancePath: instancePath + "/viewerRetentionSettings",
                parentData: data,
                parentDataProperty: "viewerRetentionSettings",
                rootData
              })) {
                vErrors = vErrors === null ? validate118.errors : vErrors.concat(validate118.errors);
                errors = vErrors.length;
              }
              var valid0 = _errs29 === errors;
            } else {
              var valid0 = true;
            }
            if (valid0) {
              if (data.attributesMapping !== void 0) {
                const _errs30 = errors;
                if (!validate121(data.attributesMapping, {
                  instancePath: instancePath + "/attributesMapping",
                  parentData: data,
                  parentDataProperty: "attributesMapping",
                  rootData
                })) {
                  vErrors = vErrors === null ? validate121.errors : vErrors.concat(validate121.errors);
                  errors = vErrors.length;
                }
                var valid0 = _errs30 === errors;
              } else {
                var valid0 = true;
              }
            }
          }
        }
      }
    } else {
      validate128.errors = [{
        instancePath,
        schemaPath: "#/type",
        keyword: "type",
        params: {
          type: "object"
        },
        message: "must be object"
      }];
      return false;
    }
  }
  validate128.errors = vErrors;
  return errors === 0;
}
const CreateSetupIntentRequest = validate132;
function validate132(data, {
  instancePath = "",
  parentData,
  parentDataProperty,
  rootData = data
} = {}) {
  let vErrors = null;
  let errors = 0;
  {
    if (data && typeof data == "object" && !Array.isArray(data)) {
      let missing0;
      if (data.channelId === void 0 && (missing0 = "channelId")) {
        validate132.errors = [{
          instancePath,
          schemaPath: "#/required",
          keyword: "required",
          params: {
            missingProperty: missing0
          },
          message: "must have required property '" + missing0 + "'"
        }];
        return false;
      } else {
        if (data.channelId !== void 0) {
          if (typeof data.channelId !== "string") {
            validate132.errors = [{
              instancePath: instancePath + "/channelId",
              schemaPath: "#/properties/channelId/type",
              keyword: "type",
              params: {
                type: "string"
              },
              message: "must be string"
            }];
            return false;
          }
        }
      }
    } else {
      validate132.errors = [{
        instancePath,
        schemaPath: "#/type",
        keyword: "type",
        params: {
          type: "object"
        },
        message: "must be object"
      }];
      return false;
    }
  }
  validate132.errors = vErrors;
  return errors === 0;
}
const CreateSetupIntentResponse = validate133;
function validate133(data, {
  instancePath = "",
  parentData,
  parentDataProperty,
  rootData = data
} = {}) {
  let vErrors = null;
  let errors = 0;
  const _errs0 = errors;
  let valid0 = false;
  const _errs1 = errors;
  if (errors === _errs1) {
    if (data && typeof data == "object" && !Array.isArray(data)) {
      let missing0;
      if (data.success === void 0 && (missing0 = "success") || data.intent === void 0 && (missing0 = "intent")) {
        const err0 = {
          instancePath,
          schemaPath: "#/anyOf/0/required",
          keyword: "required",
          params: {
            missingProperty: missing0
          },
          message: "must have required property '" + missing0 + "'"
        };
        if (vErrors === null) {
          vErrors = [err0];
        } else {
          vErrors.push(err0);
        }
        errors++;
      } else {
        if (data.success !== void 0) {
          let data0 = data.success;
          const _errs3 = errors;
          if (typeof data0 !== "boolean") {
            const err1 = {
              instancePath: instancePath + "/success",
              schemaPath: "#/anyOf/0/properties/success/type",
              keyword: "type",
              params: {
                type: "boolean"
              },
              message: "must be boolean"
            };
            if (vErrors === null) {
              vErrors = [err1];
            } else {
              vErrors.push(err1);
            }
            errors++;
          }
          if (true !== data0) {
            const err2 = {
              instancePath: instancePath + "/success",
              schemaPath: "#/anyOf/0/properties/success/const",
              keyword: "const",
              params: {
                allowedValue: true
              },
              message: "must be equal to constant"
            };
            if (vErrors === null) {
              vErrors = [err2];
            } else {
              vErrors.push(err2);
            }
            errors++;
          }
          var valid1 = _errs3 === errors;
        } else {
          var valid1 = true;
        }
        if (valid1) {
          if (data.intent !== void 0) {
            let data1 = data.intent;
            const _errs5 = errors;
            if (errors === _errs5) {
              if (data1 && typeof data1 == "object" && !Array.isArray(data1)) {
                let missing1;
                if (data1.clientSecret === void 0 && (missing1 = "clientSecret") || data1.publicKey === void 0 && (missing1 = "publicKey")) {
                  const err3 = {
                    instancePath: instancePath + "/intent",
                    schemaPath: "#/anyOf/0/properties/intent/required",
                    keyword: "required",
                    params: {
                      missingProperty: missing1
                    },
                    message: "must have required property '" + missing1 + "'"
                  };
                  if (vErrors === null) {
                    vErrors = [err3];
                  } else {
                    vErrors.push(err3);
                  }
                  errors++;
                } else {
                  if (data1.clientSecret !== void 0) {
                    const _errs7 = errors;
                    if (typeof data1.clientSecret !== "string") {
                      const err4 = {
                        instancePath: instancePath + "/intent/clientSecret",
                        schemaPath: "#/anyOf/0/properties/intent/properties/clientSecret/type",
                        keyword: "type",
                        params: {
                          type: "string"
                        },
                        message: "must be string"
                      };
                      if (vErrors === null) {
                        vErrors = [err4];
                      } else {
                        vErrors.push(err4);
                      }
                      errors++;
                    }
                    var valid2 = _errs7 === errors;
                  } else {
                    var valid2 = true;
                  }
                  if (valid2) {
                    if (data1.publicKey !== void 0) {
                      const _errs9 = errors;
                      if (typeof data1.publicKey !== "string") {
                        const err5 = {
                          instancePath: instancePath + "/intent/publicKey",
                          schemaPath: "#/anyOf/0/properties/intent/properties/publicKey/type",
                          keyword: "type",
                          params: {
                            type: "string"
                          },
                          message: "must be string"
                        };
                        if (vErrors === null) {
                          vErrors = [err5];
                        } else {
                          vErrors.push(err5);
                        }
                        errors++;
                      }
                      var valid2 = _errs9 === errors;
                    } else {
                      var valid2 = true;
                    }
                  }
                }
              } else {
                const err6 = {
                  instancePath: instancePath + "/intent",
                  schemaPath: "#/anyOf/0/properties/intent/type",
                  keyword: "type",
                  params: {
                    type: "object"
                  },
                  message: "must be object"
                };
                if (vErrors === null) {
                  vErrors = [err6];
                } else {
                  vErrors.push(err6);
                }
                errors++;
              }
            }
            var valid1 = _errs5 === errors;
          } else {
            var valid1 = true;
          }
        }
      }
    } else {
      const err7 = {
        instancePath,
        schemaPath: "#/anyOf/0/type",
        keyword: "type",
        params: {
          type: "object"
        },
        message: "must be object"
      };
      if (vErrors === null) {
        vErrors = [err7];
      } else {
        vErrors.push(err7);
      }
      errors++;
    }
  }
  var _valid0 = _errs1 === errors;
  valid0 = valid0 || _valid0;
  if (!valid0) {
    const _errs11 = errors;
    if (errors === _errs11) {
      if (data && typeof data == "object" && !Array.isArray(data)) {
        let missing2;
        if (data.success === void 0 && (missing2 = "success") || data.errorReason === void 0 && (missing2 = "errorReason")) {
          const err8 = {
            instancePath,
            schemaPath: "#/anyOf/1/required",
            keyword: "required",
            params: {
              missingProperty: missing2
            },
            message: "must have required property '" + missing2 + "'"
          };
          if (vErrors === null) {
            vErrors = [err8];
          } else {
            vErrors.push(err8);
          }
          errors++;
        } else {
          if (data.success !== void 0) {
            let data4 = data.success;
            const _errs13 = errors;
            if (typeof data4 !== "boolean") {
              const err9 = {
                instancePath: instancePath + "/success",
                schemaPath: "#/anyOf/1/properties/success/type",
                keyword: "type",
                params: {
                  type: "boolean"
                },
                message: "must be boolean"
              };
              if (vErrors === null) {
                vErrors = [err9];
              } else {
                vErrors.push(err9);
              }
              errors++;
            }
            if (false !== data4) {
              const err10 = {
                instancePath: instancePath + "/success",
                schemaPath: "#/anyOf/1/properties/success/const",
                keyword: "const",
                params: {
                  allowedValue: false
                },
                message: "must be equal to constant"
              };
              if (vErrors === null) {
                vErrors = [err10];
              } else {
                vErrors.push(err10);
              }
              errors++;
            }
            var valid3 = _errs13 === errors;
          } else {
            var valid3 = true;
          }
          if (valid3) {
            if (data.errorReason !== void 0) {
              const _errs15 = errors;
              if (typeof data.errorReason !== "string") {
                const err11 = {
                  instancePath: instancePath + "/errorReason",
                  schemaPath: "#/anyOf/1/properties/errorReason/type",
                  keyword: "type",
                  params: {
                    type: "string"
                  },
                  message: "must be string"
                };
                if (vErrors === null) {
                  vErrors = [err11];
                } else {
                  vErrors.push(err11);
                }
                errors++;
              }
              var valid3 = _errs15 === errors;
            } else {
              var valid3 = true;
            }
          }
        }
      } else {
        const err12 = {
          instancePath,
          schemaPath: "#/anyOf/1/type",
          keyword: "type",
          params: {
            type: "object"
          },
          message: "must be object"
        };
        if (vErrors === null) {
          vErrors = [err12];
        } else {
          vErrors.push(err12);
        }
        errors++;
      }
    }
    var _valid0 = _errs11 === errors;
    valid0 = valid0 || _valid0;
  }
  if (!valid0) {
    const err13 = {
      instancePath,
      schemaPath: "#/anyOf",
      keyword: "anyOf",
      params: {},
      message: "must match a schema in anyOf"
    };
    if (vErrors === null) {
      vErrors = [err13];
    } else {
      vErrors.push(err13);
    }
    errors++;
    validate133.errors = vErrors;
    return false;
  } else {
    errors = _errs0;
    if (vErrors !== null) {
      if (_errs0) {
        vErrors.length = _errs0;
      } else {
        vErrors = null;
      }
    }
  }
  validate133.errors = vErrors;
  return errors === 0;
}
const CreateSubscriptionRequest = validate134;
function validate134(data, {
  instancePath = "",
  parentData,
  parentDataProperty,
  rootData = data
} = {}) {
  let vErrors = null;
  let errors = 0;
  {
    if (data && typeof data == "object" && !Array.isArray(data)) {
      let missing0;
      if (data.channelId === void 0 && (missing0 = "channelId") || data.planId === void 0 && (missing0 = "planId")) {
        validate134.errors = [{
          instancePath,
          schemaPath: "#/required",
          keyword: "required",
          params: {
            missingProperty: missing0
          },
          message: "must have required property '" + missing0 + "'"
        }];
        return false;
      } else {
        if (data.channelId !== void 0) {
          const _errs1 = errors;
          if (typeof data.channelId !== "string") {
            validate134.errors = [{
              instancePath: instancePath + "/channelId",
              schemaPath: "#/properties/channelId/type",
              keyword: "type",
              params: {
                type: "string"
              },
              message: "must be string"
            }];
            return false;
          }
          var valid0 = _errs1 === errors;
        } else {
          var valid0 = true;
        }
        if (valid0) {
          if (data.planId !== void 0) {
            const _errs3 = errors;
            if (typeof data.planId !== "string") {
              validate134.errors = [{
                instancePath: instancePath + "/planId",
                schemaPath: "#/properties/planId/type",
                keyword: "type",
                params: {
                  type: "string"
                },
                message: "must be string"
              }];
              return false;
            }
            var valid0 = _errs3 === errors;
          } else {
            var valid0 = true;
          }
          if (valid0) {
            if (data.selectedCurrency !== void 0) {
              const _errs5 = errors;
              if (typeof data.selectedCurrency !== "string") {
                validate134.errors = [{
                  instancePath: instancePath + "/selectedCurrency",
                  schemaPath: "#/properties/selectedCurrency/type",
                  keyword: "type",
                  params: {
                    type: "string"
                  },
                  message: "must be string"
                }];
                return false;
              }
              var valid0 = _errs5 === errors;
            } else {
              var valid0 = true;
            }
          }
        }
      }
    } else {
      validate134.errors = [{
        instancePath,
        schemaPath: "#/type",
        keyword: "type",
        params: {
          type: "object"
        },
        message: "must be object"
      }];
      return false;
    }
  }
  validate134.errors = vErrors;
  return errors === 0;
}
const CreateSubscriptionSuccessfulResponse = validate135;
function validate135(data, {
  instancePath = "",
  parentData,
  parentDataProperty,
  rootData = data
} = {}) {
  let vErrors = null;
  let errors = 0;
  {
    if (data && typeof data == "object" && !Array.isArray(data)) {
      let missing0;
      if (data.success === void 0 && (missing0 = "success") || data.subscriptionId === void 0 && (missing0 = "subscriptionId")) {
        validate135.errors = [{
          instancePath,
          schemaPath: "#/required",
          keyword: "required",
          params: {
            missingProperty: missing0
          },
          message: "must have required property '" + missing0 + "'"
        }];
        return false;
      } else {
        if (data.success !== void 0) {
          let data0 = data.success;
          const _errs1 = errors;
          if (typeof data0 !== "boolean") {
            validate135.errors = [{
              instancePath: instancePath + "/success",
              schemaPath: "#/properties/success/type",
              keyword: "type",
              params: {
                type: "boolean"
              },
              message: "must be boolean"
            }];
            return false;
          }
          if (true !== data0) {
            validate135.errors = [{
              instancePath: instancePath + "/success",
              schemaPath: "#/properties/success/const",
              keyword: "const",
              params: {
                allowedValue: true
              },
              message: "must be equal to constant"
            }];
            return false;
          }
          var valid0 = _errs1 === errors;
        } else {
          var valid0 = true;
        }
        if (valid0) {
          if (data.subscriptionId !== void 0) {
            const _errs3 = errors;
            if (typeof data.subscriptionId !== "string") {
              validate135.errors = [{
                instancePath: instancePath + "/subscriptionId",
                schemaPath: "#/properties/subscriptionId/type",
                keyword: "type",
                params: {
                  type: "string"
                },
                message: "must be string"
              }];
              return false;
            }
            var valid0 = _errs3 === errors;
          } else {
            var valid0 = true;
          }
        }
      }
    } else {
      validate135.errors = [{
        instancePath,
        schemaPath: "#/type",
        keyword: "type",
        params: {
          type: "object"
        },
        message: "must be object"
      }];
      return false;
    }
  }
  validate135.errors = vErrors;
  return errors === 0;
}
const CreateSubscriptionErrorResponse = validate136;
function validate136(data, {
  instancePath = "",
  parentData,
  parentDataProperty,
  rootData = data
} = {}) {
  let vErrors = null;
  let errors = 0;
  {
    if (data && typeof data == "object" && !Array.isArray(data)) {
      let missing0;
      if (data.success === void 0 && (missing0 = "success") || data.errorReason === void 0 && (missing0 = "errorReason")) {
        validate136.errors = [{
          instancePath,
          schemaPath: "#/required",
          keyword: "required",
          params: {
            missingProperty: missing0
          },
          message: "must have required property '" + missing0 + "'"
        }];
        return false;
      } else {
        if (data.success !== void 0) {
          let data0 = data.success;
          const _errs1 = errors;
          if (typeof data0 !== "boolean") {
            validate136.errors = [{
              instancePath: instancePath + "/success",
              schemaPath: "#/properties/success/type",
              keyword: "type",
              params: {
                type: "boolean"
              },
              message: "must be boolean"
            }];
            return false;
          }
          if (false !== data0) {
            validate136.errors = [{
              instancePath: instancePath + "/success",
              schemaPath: "#/properties/success/const",
              keyword: "const",
              params: {
                allowedValue: false
              },
              message: "must be equal to constant"
            }];
            return false;
          }
          var valid0 = _errs1 === errors;
        } else {
          var valid0 = true;
        }
        if (valid0) {
          if (data.errorReason !== void 0) {
            const _errs3 = errors;
            if (typeof data.errorReason !== "string") {
              validate136.errors = [{
                instancePath: instancePath + "/errorReason",
                schemaPath: "#/properties/errorReason/type",
                keyword: "type",
                params: {
                  type: "string"
                },
                message: "must be string"
              }];
              return false;
            }
            var valid0 = _errs3 === errors;
          } else {
            var valid0 = true;
          }
        }
      }
    } else {
      validate136.errors = [{
        instancePath,
        schemaPath: "#/type",
        keyword: "type",
        params: {
          type: "object"
        },
        message: "must be object"
      }];
      return false;
    }
  }
  validate136.errors = vErrors;
  return errors === 0;
}
const CreateSubscriptionResponse = validate137;
function validate137(data, {
  instancePath = "",
  parentData,
  parentDataProperty,
  rootData = data
} = {}) {
  let vErrors = null;
  let errors = 0;
  const _errs0 = errors;
  let valid0 = false;
  const _errs1 = errors;
  const _errs2 = errors;
  if (errors === _errs2) {
    if (data && typeof data == "object" && !Array.isArray(data)) {
      let missing0;
      if (data.success === void 0 && (missing0 = "success") || data.subscriptionId === void 0 && (missing0 = "subscriptionId")) {
        const err0 = {
          instancePath,
          schemaPath: "CreateSubscriptionSuccessfulResponse/required",
          keyword: "required",
          params: {
            missingProperty: missing0
          },
          message: "must have required property '" + missing0 + "'"
        };
        if (vErrors === null) {
          vErrors = [err0];
        } else {
          vErrors.push(err0);
        }
        errors++;
      } else {
        if (data.success !== void 0) {
          let data0 = data.success;
          const _errs4 = errors;
          if (typeof data0 !== "boolean") {
            const err1 = {
              instancePath: instancePath + "/success",
              schemaPath: "CreateSubscriptionSuccessfulResponse/properties/success/type",
              keyword: "type",
              params: {
                type: "boolean"
              },
              message: "must be boolean"
            };
            if (vErrors === null) {
              vErrors = [err1];
            } else {
              vErrors.push(err1);
            }
            errors++;
          }
          if (true !== data0) {
            const err2 = {
              instancePath: instancePath + "/success",
              schemaPath: "CreateSubscriptionSuccessfulResponse/properties/success/const",
              keyword: "const",
              params: {
                allowedValue: true
              },
              message: "must be equal to constant"
            };
            if (vErrors === null) {
              vErrors = [err2];
            } else {
              vErrors.push(err2);
            }
            errors++;
          }
          var valid2 = _errs4 === errors;
        } else {
          var valid2 = true;
        }
        if (valid2) {
          if (data.subscriptionId !== void 0) {
            const _errs6 = errors;
            if (typeof data.subscriptionId !== "string") {
              const err3 = {
                instancePath: instancePath + "/subscriptionId",
                schemaPath: "CreateSubscriptionSuccessfulResponse/properties/subscriptionId/type",
                keyword: "type",
                params: {
                  type: "string"
                },
                message: "must be string"
              };
              if (vErrors === null) {
                vErrors = [err3];
              } else {
                vErrors.push(err3);
              }
              errors++;
            }
            var valid2 = _errs6 === errors;
          } else {
            var valid2 = true;
          }
        }
      }
    } else {
      const err4 = {
        instancePath,
        schemaPath: "CreateSubscriptionSuccessfulResponse/type",
        keyword: "type",
        params: {
          type: "object"
        },
        message: "must be object"
      };
      if (vErrors === null) {
        vErrors = [err4];
      } else {
        vErrors.push(err4);
      }
      errors++;
    }
  }
  var _valid0 = _errs1 === errors;
  valid0 = valid0 || _valid0;
  if (!valid0) {
    const _errs8 = errors;
    const _errs9 = errors;
    if (errors === _errs9) {
      if (data && typeof data == "object" && !Array.isArray(data)) {
        let missing1;
        if (data.success === void 0 && (missing1 = "success") || data.errorReason === void 0 && (missing1 = "errorReason")) {
          const err5 = {
            instancePath,
            schemaPath: "CreateSubscriptionErrorResponse/required",
            keyword: "required",
            params: {
              missingProperty: missing1
            },
            message: "must have required property '" + missing1 + "'"
          };
          if (vErrors === null) {
            vErrors = [err5];
          } else {
            vErrors.push(err5);
          }
          errors++;
        } else {
          if (data.success !== void 0) {
            let data2 = data.success;
            const _errs11 = errors;
            if (typeof data2 !== "boolean") {
              const err6 = {
                instancePath: instancePath + "/success",
                schemaPath: "CreateSubscriptionErrorResponse/properties/success/type",
                keyword: "type",
                params: {
                  type: "boolean"
                },
                message: "must be boolean"
              };
              if (vErrors === null) {
                vErrors = [err6];
              } else {
                vErrors.push(err6);
              }
              errors++;
            }
            if (false !== data2) {
              const err7 = {
                instancePath: instancePath + "/success",
                schemaPath: "CreateSubscriptionErrorResponse/properties/success/const",
                keyword: "const",
                params: {
                  allowedValue: false
                },
                message: "must be equal to constant"
              };
              if (vErrors === null) {
                vErrors = [err7];
              } else {
                vErrors.push(err7);
              }
              errors++;
            }
            var valid4 = _errs11 === errors;
          } else {
            var valid4 = true;
          }
          if (valid4) {
            if (data.errorReason !== void 0) {
              const _errs13 = errors;
              if (typeof data.errorReason !== "string") {
                const err8 = {
                  instancePath: instancePath + "/errorReason",
                  schemaPath: "CreateSubscriptionErrorResponse/properties/errorReason/type",
                  keyword: "type",
                  params: {
                    type: "string"
                  },
                  message: "must be string"
                };
                if (vErrors === null) {
                  vErrors = [err8];
                } else {
                  vErrors.push(err8);
                }
                errors++;
              }
              var valid4 = _errs13 === errors;
            } else {
              var valid4 = true;
            }
          }
        }
      } else {
        const err9 = {
          instancePath,
          schemaPath: "CreateSubscriptionErrorResponse/type",
          keyword: "type",
          params: {
            type: "object"
          },
          message: "must be object"
        };
        if (vErrors === null) {
          vErrors = [err9];
        } else {
          vErrors.push(err9);
        }
        errors++;
      }
    }
    var _valid0 = _errs8 === errors;
    valid0 = valid0 || _valid0;
  }
  if (!valid0) {
    const err10 = {
      instancePath,
      schemaPath: "#/anyOf",
      keyword: "anyOf",
      params: {},
      message: "must match a schema in anyOf"
    };
    if (vErrors === null) {
      vErrors = [err10];
    } else {
      vErrors.push(err10);
    }
    errors++;
    validate137.errors = vErrors;
    return false;
  } else {
    errors = _errs0;
    if (vErrors !== null) {
      if (_errs0) {
        vErrors.length = _errs0;
      } else {
        vErrors = null;
      }
    }
  }
  validate137.errors = vErrors;
  return errors === 0;
}
const TicketPrice = validate138;
function validate138(data, {
  instancePath = "",
  parentData,
  parentDataProperty,
  rootData = data
} = {}) {
  let vErrors = null;
  let errors = 0;
  {
    if (data && typeof data == "object" && !Array.isArray(data)) {
      let missing0;
      if (data.effectiveDate === void 0 && (missing0 = "effectiveDate") || data.price === void 0 && (missing0 = "price") || data.currency === void 0 && (missing0 = "currency")) {
        validate138.errors = [{
          instancePath,
          schemaPath: "#/required",
          keyword: "required",
          params: {
            missingProperty: missing0
          },
          message: "must have required property '" + missing0 + "'"
        }];
        return false;
      } else {
        if (data.effectiveDate !== void 0) {
          let data0 = data.effectiveDate;
          const _errs1 = errors;
          if (!(data0 && typeof data0 == "object" && !Array.isArray(data0))) {
            validate138.errors = [{
              instancePath: instancePath + "/effectiveDate",
              schemaPath: "#/properties/effectiveDate/type",
              keyword: "type",
              params: {
                type: "object"
              },
              message: "must be object"
            }];
            return false;
          }
          {
            {
              if (typeof data0 === "string") {
                if (!formats0(data0)) {
                  validate138.errors = [{
                    instancePath: instancePath + "/effectiveDate",
                    schemaPath: "#/properties/effectiveDate/format",
                    keyword: "format",
                    params: {
                      format: "date-time"
                    },
                    message: 'must match format "date-time"'
                  }];
                  return false;
                }
              }
            }
          }
          var valid0 = _errs1 === errors;
        } else {
          var valid0 = true;
        }
        if (valid0) {
          if (data.price !== void 0) {
            let data1 = data.price;
            const _errs3 = errors;
            if (!(typeof data1 == "number" && isFinite(data1))) {
              validate138.errors = [{
                instancePath: instancePath + "/price",
                schemaPath: "#/properties/price/type",
                keyword: "type",
                params: {
                  type: "number"
                },
                message: "must be number"
              }];
              return false;
            }
            var valid0 = _errs3 === errors;
          } else {
            var valid0 = true;
          }
          if (valid0) {
            if (data.currency !== void 0) {
              const _errs5 = errors;
              if (typeof data.currency !== "string") {
                validate138.errors = [{
                  instancePath: instancePath + "/currency",
                  schemaPath: "#/properties/currency/type",
                  keyword: "type",
                  params: {
                    type: "string"
                  },
                  message: "must be string"
                }];
                return false;
              }
              var valid0 = _errs5 === errors;
            } else {
              var valid0 = true;
            }
            if (valid0) {
              if (data.alternateCurrencies !== void 0) {
                let data3 = data.alternateCurrencies;
                const _errs7 = errors;
                {
                  if (Array.isArray(data3)) {
                    var valid1 = true;
                    const len0 = data3.length;
                    for (let i0 = 0; i0 < len0; i0++) {
                      let data4 = data3[i0];
                      const _errs9 = errors;
                      {
                        if (data4 && typeof data4 == "object" && !Array.isArray(data4)) {
                          let missing1;
                          if (data4.price === void 0 && (missing1 = "price") || data4.currency === void 0 && (missing1 = "currency")) {
                            validate138.errors = [{
                              instancePath: instancePath + "/alternateCurrencies/" + i0,
                              schemaPath: "#/properties/alternateCurrencies/items/required",
                              keyword: "required",
                              params: {
                                missingProperty: missing1
                              },
                              message: "must have required property '" + missing1 + "'"
                            }];
                            return false;
                          } else {
                            if (data4.price !== void 0) {
                              let data5 = data4.price;
                              const _errs11 = errors;
                              if (!(typeof data5 == "number" && isFinite(data5))) {
                                validate138.errors = [{
                                  instancePath: instancePath + "/alternateCurrencies/" + i0 + "/price",
                                  schemaPath: "#/properties/alternateCurrencies/items/properties/price/type",
                                  keyword: "type",
                                  params: {
                                    type: "number"
                                  },
                                  message: "must be number"
                                }];
                                return false;
                              }
                              var valid2 = _errs11 === errors;
                            } else {
                              var valid2 = true;
                            }
                            if (valid2) {
                              if (data4.currency !== void 0) {
                                const _errs13 = errors;
                                if (typeof data4.currency !== "string") {
                                  validate138.errors = [{
                                    instancePath: instancePath + "/alternateCurrencies/" + i0 + "/currency",
                                    schemaPath: "#/properties/alternateCurrencies/items/properties/currency/type",
                                    keyword: "type",
                                    params: {
                                      type: "string"
                                    },
                                    message: "must be string"
                                  }];
                                  return false;
                                }
                                var valid2 = _errs13 === errors;
                              } else {
                                var valid2 = true;
                              }
                            }
                          }
                        } else {
                          validate138.errors = [{
                            instancePath: instancePath + "/alternateCurrencies/" + i0,
                            schemaPath: "#/properties/alternateCurrencies/items/type",
                            keyword: "type",
                            params: {
                              type: "object"
                            },
                            message: "must be object"
                          }];
                          return false;
                        }
                      }
                      var valid1 = _errs9 === errors;
                      if (!valid1) {
                        break;
                      }
                    }
                  } else {
                    validate138.errors = [{
                      instancePath: instancePath + "/alternateCurrencies",
                      schemaPath: "#/properties/alternateCurrencies/type",
                      keyword: "type",
                      params: {
                        type: "array"
                      },
                      message: "must be array"
                    }];
                    return false;
                  }
                }
                var valid0 = _errs7 === errors;
              } else {
                var valid0 = true;
              }
            }
          }
        }
      }
    } else {
      validate138.errors = [{
        instancePath,
        schemaPath: "#/type",
        keyword: "type",
        params: {
          type: "object"
        },
        message: "must be object"
      }];
      return false;
    }
  }
  validate138.errors = vErrors;
  return errors === 0;
}
const TicketScope = validate139;
const schema146 = {
  "$id": "TicketScope",
  "$schema": "http://json-schema.org/draft-07/schema#",
  "type": "object",
  "properties": {
    "initialCoverage": {
      "type": "boolean"
    },
    "appliesTo": {
      "type": "string",
      "enum": ["STREAMS", "UPLOADS", "STREAMS_AND_UPLOADS"]
    },
    "tags": {
      "anyOf": [{
        "type": "object",
        "properties": {
          "kind": {
            "type": "string",
            "enum": ["ALL", "SOME"]
          },
          "list": {
            "type": "array",
            "items": {
              "type": "string"
            }
          }
        },
        "required": ["kind", "list"]
      }, {
        "type": "null"
      }]
    },
    "excludeTags": {
      "anyOf": [{
        "type": "object",
        "properties": {
          "kind": {
            "type": "string",
            "enum": ["ALL", "SOME"]
          },
          "list": {
            "type": "array",
            "items": {
              "type": "string"
            }
          }
        },
        "required": ["kind", "list"]
      }, {
        "type": "null"
      }]
    },
    "attributes": {
      "anyOf": [{
        "type": "object",
        "properties": {
          "kind": {
            "type": "string",
            "enum": ["ALL", "SOME"]
          },
          "list": {
            "type": "array",
            "items": {
              "type": "string"
            }
          }
        },
        "required": ["kind", "list"]
      }, {
        "type": "null"
      }]
    },
    "excludeAttributes": {
      "anyOf": [{
        "type": "object",
        "properties": {
          "kind": {
            "type": "string",
            "enum": ["ALL", "SOME"]
          },
          "list": {
            "type": "array",
            "items": {
              "type": "string"
            }
          }
        },
        "required": ["kind", "list"]
      }, {
        "type": "null"
      }]
    },
    "videoIds": {
      "anyOf": [{
        "type": "array",
        "items": {
          "type": "string"
        }
      }, {
        "type": "null"
      }]
    },
    "excludeVideoIds": {
      "anyOf": [{
        "type": "array",
        "items": {
          "type": "string"
        }
      }, {
        "type": "null"
      }]
    },
    "redemptionLimit": {
      "type": ["number", "null"],
      "enum": [1, null]
    },
    "validityAfterRedemptionHours": {
      "type": ["number", "null"]
    }
  },
  "required": ["appliesTo", "redemptionLimit", "validityAfterRedemptionHours"],
  "description": 'Defines which videos are covered by a ticket. The scoping works by having inclusion and exclusion parameters and the algorithm works as follows:   0- if initialCoverage is defined and the value is false, consider the video **not covered**, otherwise consider it **covered**.   1- If a `tags` rule is set AND the video matches the tags defined by the rule, the video is considered **covered**, if it doesn\'t match consider it **not covered**.      If `tags` rule is not set, the result of this step is the same as step (0).   2- If the `excludedTags` rule is set and the video is **covered** in step (1), then if the video matches the exclusion rule consider the video **no covered**.      If the `excludedTags` rule is not defined, the result of this step is the same as from step (1).   3- if `attributes` is defined, check if the video defines the specified attributes.      If it does, assume the ***video coverage check" coverage is true***, else use the      ***coverage from previous steps***.      List is a list of string with the following format: `\u201Cattr[0-3]:.+"` for example      `["attr0:value","attr0:value2", "attr2:valueX"]` where `attr?` is the custom      attribute type, and `value` is one of the allowed values for that specific attribute type.   4- if `excludeAttributes` is defined, check if the video defines the the specified      attributes. If it does, assume the ***attribute coverage is false***, else use      the ***coverage from previous steps***. The list follows the same format as in for the step 2.3.   5- Regardless of the result of (4), if `videoIds` is defined and contains the id of the video, consider the video **covered**.      If `videoIds` is not defined, the result of this step is the same as step (2).   6- Regardless of the result of (5), if the `excludeVideoIds` is defined and contains the id of the video, consider the video **not covered**.\n\n== Redemption limit and validity == If a ticket has a redemption limit set (currently limited to 1), then the ticket has to be bound to a specific videoId, and will only be valid for that video. Since this type of tickets only makes sense in the context of 1 video, this type of tickets should not be shown in the tickets for an event. If `validityAfterRedemptionHours` is set, then the ticket will be considered valid only for that specific amount of time starting from the first valid redemption. A valid redemption means it is used to access a video that is not in the scheduled state. If `validityAfterRedemptionHours` is not set, the ticket is considered valid as long as the event is in progress.'
};
function validate139(data, {
  instancePath = "",
  parentData,
  parentDataProperty,
  rootData = data
} = {}) {
  let vErrors = null;
  let errors = 0;
  if (errors === 0) {
    if (data && typeof data == "object" && !Array.isArray(data)) {
      let missing0;
      if (data.appliesTo === void 0 && (missing0 = "appliesTo") || data.redemptionLimit === void 0 && (missing0 = "redemptionLimit") || data.validityAfterRedemptionHours === void 0 && (missing0 = "validityAfterRedemptionHours")) {
        validate139.errors = [{
          instancePath,
          schemaPath: "#/required",
          keyword: "required",
          params: {
            missingProperty: missing0
          },
          message: "must have required property '" + missing0 + "'"
        }];
        return false;
      } else {
        if (data.initialCoverage !== void 0) {
          const _errs1 = errors;
          if (typeof data.initialCoverage !== "boolean") {
            validate139.errors = [{
              instancePath: instancePath + "/initialCoverage",
              schemaPath: "#/properties/initialCoverage/type",
              keyword: "type",
              params: {
                type: "boolean"
              },
              message: "must be boolean"
            }];
            return false;
          }
          var valid0 = _errs1 === errors;
        } else {
          var valid0 = true;
        }
        if (valid0) {
          if (data.appliesTo !== void 0) {
            let data1 = data.appliesTo;
            const _errs3 = errors;
            if (typeof data1 !== "string") {
              validate139.errors = [{
                instancePath: instancePath + "/appliesTo",
                schemaPath: "#/properties/appliesTo/type",
                keyword: "type",
                params: {
                  type: "string"
                },
                message: "must be string"
              }];
              return false;
            }
            if (!(data1 === "STREAMS" || data1 === "UPLOADS" || data1 === "STREAMS_AND_UPLOADS")) {
              validate139.errors = [{
                instancePath: instancePath + "/appliesTo",
                schemaPath: "#/properties/appliesTo/enum",
                keyword: "enum",
                params: {
                  allowedValues: schema146.properties.appliesTo.enum
                },
                message: "must be equal to one of the allowed values"
              }];
              return false;
            }
            var valid0 = _errs3 === errors;
          } else {
            var valid0 = true;
          }
          if (valid0) {
            if (data.tags !== void 0) {
              let data2 = data.tags;
              const _errs5 = errors;
              const _errs6 = errors;
              let valid1 = false;
              const _errs7 = errors;
              if (errors === _errs7) {
                if (data2 && typeof data2 == "object" && !Array.isArray(data2)) {
                  let missing1;
                  if (data2.kind === void 0 && (missing1 = "kind") || data2.list === void 0 && (missing1 = "list")) {
                    const err0 = {
                      instancePath: instancePath + "/tags",
                      schemaPath: "#/properties/tags/anyOf/0/required",
                      keyword: "required",
                      params: {
                        missingProperty: missing1
                      },
                      message: "must have required property '" + missing1 + "'"
                    };
                    if (vErrors === null) {
                      vErrors = [err0];
                    } else {
                      vErrors.push(err0);
                    }
                    errors++;
                  } else {
                    if (data2.kind !== void 0) {
                      let data3 = data2.kind;
                      const _errs9 = errors;
                      if (typeof data3 !== "string") {
                        const err1 = {
                          instancePath: instancePath + "/tags/kind",
                          schemaPath: "#/properties/tags/anyOf/0/properties/kind/type",
                          keyword: "type",
                          params: {
                            type: "string"
                          },
                          message: "must be string"
                        };
                        if (vErrors === null) {
                          vErrors = [err1];
                        } else {
                          vErrors.push(err1);
                        }
                        errors++;
                      }
                      if (!(data3 === "ALL" || data3 === "SOME")) {
                        const err2 = {
                          instancePath: instancePath + "/tags/kind",
                          schemaPath: "#/properties/tags/anyOf/0/properties/kind/enum",
                          keyword: "enum",
                          params: {
                            allowedValues: schema146.properties.tags.anyOf[0].properties.kind.enum
                          },
                          message: "must be equal to one of the allowed values"
                        };
                        if (vErrors === null) {
                          vErrors = [err2];
                        } else {
                          vErrors.push(err2);
                        }
                        errors++;
                      }
                      var valid2 = _errs9 === errors;
                    } else {
                      var valid2 = true;
                    }
                    if (valid2) {
                      if (data2.list !== void 0) {
                        let data4 = data2.list;
                        const _errs11 = errors;
                        if (errors === _errs11) {
                          if (Array.isArray(data4)) {
                            var valid3 = true;
                            const len0 = data4.length;
                            for (let i0 = 0; i0 < len0; i0++) {
                              const _errs13 = errors;
                              if (typeof data4[i0] !== "string") {
                                const err3 = {
                                  instancePath: instancePath + "/tags/list/" + i0,
                                  schemaPath: "#/properties/tags/anyOf/0/properties/list/items/type",
                                  keyword: "type",
                                  params: {
                                    type: "string"
                                  },
                                  message: "must be string"
                                };
                                if (vErrors === null) {
                                  vErrors = [err3];
                                } else {
                                  vErrors.push(err3);
                                }
                                errors++;
                              }
                              var valid3 = _errs13 === errors;
                              if (!valid3) {
                                break;
                              }
                            }
                          } else {
                            const err4 = {
                              instancePath: instancePath + "/tags/list",
                              schemaPath: "#/properties/tags/anyOf/0/properties/list/type",
                              keyword: "type",
                              params: {
                                type: "array"
                              },
                              message: "must be array"
                            };
                            if (vErrors === null) {
                              vErrors = [err4];
                            } else {
                              vErrors.push(err4);
                            }
                            errors++;
                          }
                        }
                        var valid2 = _errs11 === errors;
                      } else {
                        var valid2 = true;
                      }
                    }
                  }
                } else {
                  const err5 = {
                    instancePath: instancePath + "/tags",
                    schemaPath: "#/properties/tags/anyOf/0/type",
                    keyword: "type",
                    params: {
                      type: "object"
                    },
                    message: "must be object"
                  };
                  if (vErrors === null) {
                    vErrors = [err5];
                  } else {
                    vErrors.push(err5);
                  }
                  errors++;
                }
              }
              var _valid0 = _errs7 === errors;
              valid1 = valid1 || _valid0;
              if (!valid1) {
                const _errs15 = errors;
                if (data2 !== null) {
                  const err6 = {
                    instancePath: instancePath + "/tags",
                    schemaPath: "#/properties/tags/anyOf/1/type",
                    keyword: "type",
                    params: {
                      type: "null"
                    },
                    message: "must be null"
                  };
                  if (vErrors === null) {
                    vErrors = [err6];
                  } else {
                    vErrors.push(err6);
                  }
                  errors++;
                }
                var _valid0 = _errs15 === errors;
                valid1 = valid1 || _valid0;
              }
              if (!valid1) {
                const err7 = {
                  instancePath: instancePath + "/tags",
                  schemaPath: "#/properties/tags/anyOf",
                  keyword: "anyOf",
                  params: {},
                  message: "must match a schema in anyOf"
                };
                if (vErrors === null) {
                  vErrors = [err7];
                } else {
                  vErrors.push(err7);
                }
                errors++;
                validate139.errors = vErrors;
                return false;
              } else {
                errors = _errs6;
                if (vErrors !== null) {
                  if (_errs6) {
                    vErrors.length = _errs6;
                  } else {
                    vErrors = null;
                  }
                }
              }
              var valid0 = _errs5 === errors;
            } else {
              var valid0 = true;
            }
            if (valid0) {
              if (data.excludeTags !== void 0) {
                let data6 = data.excludeTags;
                const _errs17 = errors;
                const _errs18 = errors;
                let valid4 = false;
                const _errs19 = errors;
                if (errors === _errs19) {
                  if (data6 && typeof data6 == "object" && !Array.isArray(data6)) {
                    let missing2;
                    if (data6.kind === void 0 && (missing2 = "kind") || data6.list === void 0 && (missing2 = "list")) {
                      const err8 = {
                        instancePath: instancePath + "/excludeTags",
                        schemaPath: "#/properties/excludeTags/anyOf/0/required",
                        keyword: "required",
                        params: {
                          missingProperty: missing2
                        },
                        message: "must have required property '" + missing2 + "'"
                      };
                      if (vErrors === null) {
                        vErrors = [err8];
                      } else {
                        vErrors.push(err8);
                      }
                      errors++;
                    } else {
                      if (data6.kind !== void 0) {
                        let data7 = data6.kind;
                        const _errs21 = errors;
                        if (typeof data7 !== "string") {
                          const err9 = {
                            instancePath: instancePath + "/excludeTags/kind",
                            schemaPath: "#/properties/excludeTags/anyOf/0/properties/kind/type",
                            keyword: "type",
                            params: {
                              type: "string"
                            },
                            message: "must be string"
                          };
                          if (vErrors === null) {
                            vErrors = [err9];
                          } else {
                            vErrors.push(err9);
                          }
                          errors++;
                        }
                        if (!(data7 === "ALL" || data7 === "SOME")) {
                          const err10 = {
                            instancePath: instancePath + "/excludeTags/kind",
                            schemaPath: "#/properties/excludeTags/anyOf/0/properties/kind/enum",
                            keyword: "enum",
                            params: {
                              allowedValues: schema146.properties.excludeTags.anyOf[0].properties.kind.enum
                            },
                            message: "must be equal to one of the allowed values"
                          };
                          if (vErrors === null) {
                            vErrors = [err10];
                          } else {
                            vErrors.push(err10);
                          }
                          errors++;
                        }
                        var valid5 = _errs21 === errors;
                      } else {
                        var valid5 = true;
                      }
                      if (valid5) {
                        if (data6.list !== void 0) {
                          let data8 = data6.list;
                          const _errs23 = errors;
                          if (errors === _errs23) {
                            if (Array.isArray(data8)) {
                              var valid6 = true;
                              const len1 = data8.length;
                              for (let i1 = 0; i1 < len1; i1++) {
                                const _errs25 = errors;
                                if (typeof data8[i1] !== "string") {
                                  const err11 = {
                                    instancePath: instancePath + "/excludeTags/list/" + i1,
                                    schemaPath: "#/properties/excludeTags/anyOf/0/properties/list/items/type",
                                    keyword: "type",
                                    params: {
                                      type: "string"
                                    },
                                    message: "must be string"
                                  };
                                  if (vErrors === null) {
                                    vErrors = [err11];
                                  } else {
                                    vErrors.push(err11);
                                  }
                                  errors++;
                                }
                                var valid6 = _errs25 === errors;
                                if (!valid6) {
                                  break;
                                }
                              }
                            } else {
                              const err12 = {
                                instancePath: instancePath + "/excludeTags/list",
                                schemaPath: "#/properties/excludeTags/anyOf/0/properties/list/type",
                                keyword: "type",
                                params: {
                                  type: "array"
                                },
                                message: "must be array"
                              };
                              if (vErrors === null) {
                                vErrors = [err12];
                              } else {
                                vErrors.push(err12);
                              }
                              errors++;
                            }
                          }
                          var valid5 = _errs23 === errors;
                        } else {
                          var valid5 = true;
                        }
                      }
                    }
                  } else {
                    const err13 = {
                      instancePath: instancePath + "/excludeTags",
                      schemaPath: "#/properties/excludeTags/anyOf/0/type",
                      keyword: "type",
                      params: {
                        type: "object"
                      },
                      message: "must be object"
                    };
                    if (vErrors === null) {
                      vErrors = [err13];
                    } else {
                      vErrors.push(err13);
                    }
                    errors++;
                  }
                }
                var _valid1 = _errs19 === errors;
                valid4 = valid4 || _valid1;
                if (!valid4) {
                  const _errs27 = errors;
                  if (data6 !== null) {
                    const err14 = {
                      instancePath: instancePath + "/excludeTags",
                      schemaPath: "#/properties/excludeTags/anyOf/1/type",
                      keyword: "type",
                      params: {
                        type: "null"
                      },
                      message: "must be null"
                    };
                    if (vErrors === null) {
                      vErrors = [err14];
                    } else {
                      vErrors.push(err14);
                    }
                    errors++;
                  }
                  var _valid1 = _errs27 === errors;
                  valid4 = valid4 || _valid1;
                }
                if (!valid4) {
                  const err15 = {
                    instancePath: instancePath + "/excludeTags",
                    schemaPath: "#/properties/excludeTags/anyOf",
                    keyword: "anyOf",
                    params: {},
                    message: "must match a schema in anyOf"
                  };
                  if (vErrors === null) {
                    vErrors = [err15];
                  } else {
                    vErrors.push(err15);
                  }
                  errors++;
                  validate139.errors = vErrors;
                  return false;
                } else {
                  errors = _errs18;
                  if (vErrors !== null) {
                    if (_errs18) {
                      vErrors.length = _errs18;
                    } else {
                      vErrors = null;
                    }
                  }
                }
                var valid0 = _errs17 === errors;
              } else {
                var valid0 = true;
              }
              if (valid0) {
                if (data.attributes !== void 0) {
                  let data10 = data.attributes;
                  const _errs29 = errors;
                  const _errs30 = errors;
                  let valid7 = false;
                  const _errs31 = errors;
                  if (errors === _errs31) {
                    if (data10 && typeof data10 == "object" && !Array.isArray(data10)) {
                      let missing3;
                      if (data10.kind === void 0 && (missing3 = "kind") || data10.list === void 0 && (missing3 = "list")) {
                        const err16 = {
                          instancePath: instancePath + "/attributes",
                          schemaPath: "#/properties/attributes/anyOf/0/required",
                          keyword: "required",
                          params: {
                            missingProperty: missing3
                          },
                          message: "must have required property '" + missing3 + "'"
                        };
                        if (vErrors === null) {
                          vErrors = [err16];
                        } else {
                          vErrors.push(err16);
                        }
                        errors++;
                      } else {
                        if (data10.kind !== void 0) {
                          let data11 = data10.kind;
                          const _errs33 = errors;
                          if (typeof data11 !== "string") {
                            const err17 = {
                              instancePath: instancePath + "/attributes/kind",
                              schemaPath: "#/properties/attributes/anyOf/0/properties/kind/type",
                              keyword: "type",
                              params: {
                                type: "string"
                              },
                              message: "must be string"
                            };
                            if (vErrors === null) {
                              vErrors = [err17];
                            } else {
                              vErrors.push(err17);
                            }
                            errors++;
                          }
                          if (!(data11 === "ALL" || data11 === "SOME")) {
                            const err18 = {
                              instancePath: instancePath + "/attributes/kind",
                              schemaPath: "#/properties/attributes/anyOf/0/properties/kind/enum",
                              keyword: "enum",
                              params: {
                                allowedValues: schema146.properties.attributes.anyOf[0].properties.kind.enum
                              },
                              message: "must be equal to one of the allowed values"
                            };
                            if (vErrors === null) {
                              vErrors = [err18];
                            } else {
                              vErrors.push(err18);
                            }
                            errors++;
                          }
                          var valid8 = _errs33 === errors;
                        } else {
                          var valid8 = true;
                        }
                        if (valid8) {
                          if (data10.list !== void 0) {
                            let data12 = data10.list;
                            const _errs35 = errors;
                            if (errors === _errs35) {
                              if (Array.isArray(data12)) {
                                var valid9 = true;
                                const len2 = data12.length;
                                for (let i2 = 0; i2 < len2; i2++) {
                                  const _errs37 = errors;
                                  if (typeof data12[i2] !== "string") {
                                    const err19 = {
                                      instancePath: instancePath + "/attributes/list/" + i2,
                                      schemaPath: "#/properties/attributes/anyOf/0/properties/list/items/type",
                                      keyword: "type",
                                      params: {
                                        type: "string"
                                      },
                                      message: "must be string"
                                    };
                                    if (vErrors === null) {
                                      vErrors = [err19];
                                    } else {
                                      vErrors.push(err19);
                                    }
                                    errors++;
                                  }
                                  var valid9 = _errs37 === errors;
                                  if (!valid9) {
                                    break;
                                  }
                                }
                              } else {
                                const err20 = {
                                  instancePath: instancePath + "/attributes/list",
                                  schemaPath: "#/properties/attributes/anyOf/0/properties/list/type",
                                  keyword: "type",
                                  params: {
                                    type: "array"
                                  },
                                  message: "must be array"
                                };
                                if (vErrors === null) {
                                  vErrors = [err20];
                                } else {
                                  vErrors.push(err20);
                                }
                                errors++;
                              }
                            }
                            var valid8 = _errs35 === errors;
                          } else {
                            var valid8 = true;
                          }
                        }
                      }
                    } else {
                      const err21 = {
                        instancePath: instancePath + "/attributes",
                        schemaPath: "#/properties/attributes/anyOf/0/type",
                        keyword: "type",
                        params: {
                          type: "object"
                        },
                        message: "must be object"
                      };
                      if (vErrors === null) {
                        vErrors = [err21];
                      } else {
                        vErrors.push(err21);
                      }
                      errors++;
                    }
                  }
                  var _valid2 = _errs31 === errors;
                  valid7 = valid7 || _valid2;
                  if (!valid7) {
                    const _errs39 = errors;
                    if (data10 !== null) {
                      const err22 = {
                        instancePath: instancePath + "/attributes",
                        schemaPath: "#/properties/attributes/anyOf/1/type",
                        keyword: "type",
                        params: {
                          type: "null"
                        },
                        message: "must be null"
                      };
                      if (vErrors === null) {
                        vErrors = [err22];
                      } else {
                        vErrors.push(err22);
                      }
                      errors++;
                    }
                    var _valid2 = _errs39 === errors;
                    valid7 = valid7 || _valid2;
                  }
                  if (!valid7) {
                    const err23 = {
                      instancePath: instancePath + "/attributes",
                      schemaPath: "#/properties/attributes/anyOf",
                      keyword: "anyOf",
                      params: {},
                      message: "must match a schema in anyOf"
                    };
                    if (vErrors === null) {
                      vErrors = [err23];
                    } else {
                      vErrors.push(err23);
                    }
                    errors++;
                    validate139.errors = vErrors;
                    return false;
                  } else {
                    errors = _errs30;
                    if (vErrors !== null) {
                      if (_errs30) {
                        vErrors.length = _errs30;
                      } else {
                        vErrors = null;
                      }
                    }
                  }
                  var valid0 = _errs29 === errors;
                } else {
                  var valid0 = true;
                }
                if (valid0) {
                  if (data.excludeAttributes !== void 0) {
                    let data14 = data.excludeAttributes;
                    const _errs41 = errors;
                    const _errs42 = errors;
                    let valid10 = false;
                    const _errs43 = errors;
                    if (errors === _errs43) {
                      if (data14 && typeof data14 == "object" && !Array.isArray(data14)) {
                        let missing4;
                        if (data14.kind === void 0 && (missing4 = "kind") || data14.list === void 0 && (missing4 = "list")) {
                          const err24 = {
                            instancePath: instancePath + "/excludeAttributes",
                            schemaPath: "#/properties/excludeAttributes/anyOf/0/required",
                            keyword: "required",
                            params: {
                              missingProperty: missing4
                            },
                            message: "must have required property '" + missing4 + "'"
                          };
                          if (vErrors === null) {
                            vErrors = [err24];
                          } else {
                            vErrors.push(err24);
                          }
                          errors++;
                        } else {
                          if (data14.kind !== void 0) {
                            let data15 = data14.kind;
                            const _errs45 = errors;
                            if (typeof data15 !== "string") {
                              const err25 = {
                                instancePath: instancePath + "/excludeAttributes/kind",
                                schemaPath: "#/properties/excludeAttributes/anyOf/0/properties/kind/type",
                                keyword: "type",
                                params: {
                                  type: "string"
                                },
                                message: "must be string"
                              };
                              if (vErrors === null) {
                                vErrors = [err25];
                              } else {
                                vErrors.push(err25);
                              }
                              errors++;
                            }
                            if (!(data15 === "ALL" || data15 === "SOME")) {
                              const err26 = {
                                instancePath: instancePath + "/excludeAttributes/kind",
                                schemaPath: "#/properties/excludeAttributes/anyOf/0/properties/kind/enum",
                                keyword: "enum",
                                params: {
                                  allowedValues: schema146.properties.excludeAttributes.anyOf[0].properties.kind.enum
                                },
                                message: "must be equal to one of the allowed values"
                              };
                              if (vErrors === null) {
                                vErrors = [err26];
                              } else {
                                vErrors.push(err26);
                              }
                              errors++;
                            }
                            var valid11 = _errs45 === errors;
                          } else {
                            var valid11 = true;
                          }
                          if (valid11) {
                            if (data14.list !== void 0) {
                              let data16 = data14.list;
                              const _errs47 = errors;
                              if (errors === _errs47) {
                                if (Array.isArray(data16)) {
                                  var valid12 = true;
                                  const len3 = data16.length;
                                  for (let i3 = 0; i3 < len3; i3++) {
                                    const _errs49 = errors;
                                    if (typeof data16[i3] !== "string") {
                                      const err27 = {
                                        instancePath: instancePath + "/excludeAttributes/list/" + i3,
                                        schemaPath: "#/properties/excludeAttributes/anyOf/0/properties/list/items/type",
                                        keyword: "type",
                                        params: {
                                          type: "string"
                                        },
                                        message: "must be string"
                                      };
                                      if (vErrors === null) {
                                        vErrors = [err27];
                                      } else {
                                        vErrors.push(err27);
                                      }
                                      errors++;
                                    }
                                    var valid12 = _errs49 === errors;
                                    if (!valid12) {
                                      break;
                                    }
                                  }
                                } else {
                                  const err28 = {
                                    instancePath: instancePath + "/excludeAttributes/list",
                                    schemaPath: "#/properties/excludeAttributes/anyOf/0/properties/list/type",
                                    keyword: "type",
                                    params: {
                                      type: "array"
                                    },
                                    message: "must be array"
                                  };
                                  if (vErrors === null) {
                                    vErrors = [err28];
                                  } else {
                                    vErrors.push(err28);
                                  }
                                  errors++;
                                }
                              }
                              var valid11 = _errs47 === errors;
                            } else {
                              var valid11 = true;
                            }
                          }
                        }
                      } else {
                        const err29 = {
                          instancePath: instancePath + "/excludeAttributes",
                          schemaPath: "#/properties/excludeAttributes/anyOf/0/type",
                          keyword: "type",
                          params: {
                            type: "object"
                          },
                          message: "must be object"
                        };
                        if (vErrors === null) {
                          vErrors = [err29];
                        } else {
                          vErrors.push(err29);
                        }
                        errors++;
                      }
                    }
                    var _valid3 = _errs43 === errors;
                    valid10 = valid10 || _valid3;
                    if (!valid10) {
                      const _errs51 = errors;
                      if (data14 !== null) {
                        const err30 = {
                          instancePath: instancePath + "/excludeAttributes",
                          schemaPath: "#/properties/excludeAttributes/anyOf/1/type",
                          keyword: "type",
                          params: {
                            type: "null"
                          },
                          message: "must be null"
                        };
                        if (vErrors === null) {
                          vErrors = [err30];
                        } else {
                          vErrors.push(err30);
                        }
                        errors++;
                      }
                      var _valid3 = _errs51 === errors;
                      valid10 = valid10 || _valid3;
                    }
                    if (!valid10) {
                      const err31 = {
                        instancePath: instancePath + "/excludeAttributes",
                        schemaPath: "#/properties/excludeAttributes/anyOf",
                        keyword: "anyOf",
                        params: {},
                        message: "must match a schema in anyOf"
                      };
                      if (vErrors === null) {
                        vErrors = [err31];
                      } else {
                        vErrors.push(err31);
                      }
                      errors++;
                      validate139.errors = vErrors;
                      return false;
                    } else {
                      errors = _errs42;
                      if (vErrors !== null) {
                        if (_errs42) {
                          vErrors.length = _errs42;
                        } else {
                          vErrors = null;
                        }
                      }
                    }
                    var valid0 = _errs41 === errors;
                  } else {
                    var valid0 = true;
                  }
                  if (valid0) {
                    if (data.videoIds !== void 0) {
                      let data18 = data.videoIds;
                      const _errs53 = errors;
                      const _errs54 = errors;
                      let valid13 = false;
                      const _errs55 = errors;
                      if (errors === _errs55) {
                        if (Array.isArray(data18)) {
                          var valid14 = true;
                          const len4 = data18.length;
                          for (let i4 = 0; i4 < len4; i4++) {
                            const _errs57 = errors;
                            if (typeof data18[i4] !== "string") {
                              const err32 = {
                                instancePath: instancePath + "/videoIds/" + i4,
                                schemaPath: "#/properties/videoIds/anyOf/0/items/type",
                                keyword: "type",
                                params: {
                                  type: "string"
                                },
                                message: "must be string"
                              };
                              if (vErrors === null) {
                                vErrors = [err32];
                              } else {
                                vErrors.push(err32);
                              }
                              errors++;
                            }
                            var valid14 = _errs57 === errors;
                            if (!valid14) {
                              break;
                            }
                          }
                        } else {
                          const err33 = {
                            instancePath: instancePath + "/videoIds",
                            schemaPath: "#/properties/videoIds/anyOf/0/type",
                            keyword: "type",
                            params: {
                              type: "array"
                            },
                            message: "must be array"
                          };
                          if (vErrors === null) {
                            vErrors = [err33];
                          } else {
                            vErrors.push(err33);
                          }
                          errors++;
                        }
                      }
                      var _valid4 = _errs55 === errors;
                      valid13 = valid13 || _valid4;
                      if (!valid13) {
                        const _errs59 = errors;
                        if (data18 !== null) {
                          const err34 = {
                            instancePath: instancePath + "/videoIds",
                            schemaPath: "#/properties/videoIds/anyOf/1/type",
                            keyword: "type",
                            params: {
                              type: "null"
                            },
                            message: "must be null"
                          };
                          if (vErrors === null) {
                            vErrors = [err34];
                          } else {
                            vErrors.push(err34);
                          }
                          errors++;
                        }
                        var _valid4 = _errs59 === errors;
                        valid13 = valid13 || _valid4;
                      }
                      if (!valid13) {
                        const err35 = {
                          instancePath: instancePath + "/videoIds",
                          schemaPath: "#/properties/videoIds/anyOf",
                          keyword: "anyOf",
                          params: {},
                          message: "must match a schema in anyOf"
                        };
                        if (vErrors === null) {
                          vErrors = [err35];
                        } else {
                          vErrors.push(err35);
                        }
                        errors++;
                        validate139.errors = vErrors;
                        return false;
                      } else {
                        errors = _errs54;
                        if (vErrors !== null) {
                          if (_errs54) {
                            vErrors.length = _errs54;
                          } else {
                            vErrors = null;
                          }
                        }
                      }
                      var valid0 = _errs53 === errors;
                    } else {
                      var valid0 = true;
                    }
                    if (valid0) {
                      if (data.excludeVideoIds !== void 0) {
                        let data20 = data.excludeVideoIds;
                        const _errs61 = errors;
                        const _errs62 = errors;
                        let valid15 = false;
                        const _errs63 = errors;
                        if (errors === _errs63) {
                          if (Array.isArray(data20)) {
                            var valid16 = true;
                            const len5 = data20.length;
                            for (let i5 = 0; i5 < len5; i5++) {
                              const _errs65 = errors;
                              if (typeof data20[i5] !== "string") {
                                const err36 = {
                                  instancePath: instancePath + "/excludeVideoIds/" + i5,
                                  schemaPath: "#/properties/excludeVideoIds/anyOf/0/items/type",
                                  keyword: "type",
                                  params: {
                                    type: "string"
                                  },
                                  message: "must be string"
                                };
                                if (vErrors === null) {
                                  vErrors = [err36];
                                } else {
                                  vErrors.push(err36);
                                }
                                errors++;
                              }
                              var valid16 = _errs65 === errors;
                              if (!valid16) {
                                break;
                              }
                            }
                          } else {
                            const err37 = {
                              instancePath: instancePath + "/excludeVideoIds",
                              schemaPath: "#/properties/excludeVideoIds/anyOf/0/type",
                              keyword: "type",
                              params: {
                                type: "array"
                              },
                              message: "must be array"
                            };
                            if (vErrors === null) {
                              vErrors = [err37];
                            } else {
                              vErrors.push(err37);
                            }
                            errors++;
                          }
                        }
                        var _valid5 = _errs63 === errors;
                        valid15 = valid15 || _valid5;
                        if (!valid15) {
                          const _errs67 = errors;
                          if (data20 !== null) {
                            const err38 = {
                              instancePath: instancePath + "/excludeVideoIds",
                              schemaPath: "#/properties/excludeVideoIds/anyOf/1/type",
                              keyword: "type",
                              params: {
                                type: "null"
                              },
                              message: "must be null"
                            };
                            if (vErrors === null) {
                              vErrors = [err38];
                            } else {
                              vErrors.push(err38);
                            }
                            errors++;
                          }
                          var _valid5 = _errs67 === errors;
                          valid15 = valid15 || _valid5;
                        }
                        if (!valid15) {
                          const err39 = {
                            instancePath: instancePath + "/excludeVideoIds",
                            schemaPath: "#/properties/excludeVideoIds/anyOf",
                            keyword: "anyOf",
                            params: {},
                            message: "must match a schema in anyOf"
                          };
                          if (vErrors === null) {
                            vErrors = [err39];
                          } else {
                            vErrors.push(err39);
                          }
                          errors++;
                          validate139.errors = vErrors;
                          return false;
                        } else {
                          errors = _errs62;
                          if (vErrors !== null) {
                            if (_errs62) {
                              vErrors.length = _errs62;
                            } else {
                              vErrors = null;
                            }
                          }
                        }
                        var valid0 = _errs61 === errors;
                      } else {
                        var valid0 = true;
                      }
                      if (valid0) {
                        if (data.redemptionLimit !== void 0) {
                          let data22 = data.redemptionLimit;
                          const _errs69 = errors;
                          if (!(typeof data22 == "number" && isFinite(data22)) && data22 !== null) {
                            validate139.errors = [{
                              instancePath: instancePath + "/redemptionLimit",
                              schemaPath: "#/properties/redemptionLimit/type",
                              keyword: "type",
                              params: {
                                type: schema146.properties.redemptionLimit.type
                              },
                              message: "must be number,null"
                            }];
                            return false;
                          }
                          if (!(data22 === 1 || data22 === null)) {
                            validate139.errors = [{
                              instancePath: instancePath + "/redemptionLimit",
                              schemaPath: "#/properties/redemptionLimit/enum",
                              keyword: "enum",
                              params: {
                                allowedValues: schema146.properties.redemptionLimit.enum
                              },
                              message: "must be equal to one of the allowed values"
                            }];
                            return false;
                          }
                          var valid0 = _errs69 === errors;
                        } else {
                          var valid0 = true;
                        }
                        if (valid0) {
                          if (data.validityAfterRedemptionHours !== void 0) {
                            let data23 = data.validityAfterRedemptionHours;
                            const _errs71 = errors;
                            if (!(typeof data23 == "number" && isFinite(data23)) && data23 !== null) {
                              validate139.errors = [{
                                instancePath: instancePath + "/validityAfterRedemptionHours",
                                schemaPath: "#/properties/validityAfterRedemptionHours/type",
                                keyword: "type",
                                params: {
                                  type: schema146.properties.validityAfterRedemptionHours.type
                                },
                                message: "must be number,null"
                              }];
                              return false;
                            }
                            var valid0 = _errs71 === errors;
                          } else {
                            var valid0 = true;
                          }
                        }
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
    } else {
      validate139.errors = [{
        instancePath,
        schemaPath: "#/type",
        keyword: "type",
        params: {
          type: "object"
        },
        message: "must be object"
      }];
      return false;
    }
  }
  validate139.errors = vErrors;
  return errors === 0;
}
const Ticket = validate140;
const schema147 = {
  "$id": "Ticket",
  "$schema": "http://json-schema.org/draft-07/schema#",
  "type": "object",
  "properties": {
    "id": {
      "type": "string"
    },
    "name": {
      "type": "string"
    },
    "description": {
      "type": "string"
    },
    "prices": {
      "type": "array",
      "items": {
        "$ref": "TicketPrice"
      }
    },
    "ticketImage": {
      "type": ["string", "null"]
    },
    "scope": {
      "anyOf": [{
        "$ref": "TicketScope"
      }, {
        "type": "null"
      }]
    },
    "geo_restriction": {
      "anyOf": [{
        "type": "array",
        "items": {
          "type": "string"
        }
      }, {
        "type": "null"
      }]
    },
    "available": {
      "type": "boolean"
    }
  },
  "required": ["id", "name", "description", "prices", "ticketImage", "scope", "geo_restriction", "available"],
  "description": "Paid events (or locked events), require a ticket to access. A ticket once purchased will unlock a set of streams in that event. The ticket is valid as long as the event is valid.\n*Scoping*: A scope (`TicketScope`) can be defined per ticket to restrict the range of viewable streams.\n*Prices*: Multiple price(s) can be defined for a ticket, but only one price can be effective at any given point in time. The *effective* price at any given point `t` is the one having the nearest `effectiveDate` satisfying the inequality `effectiveDate < t`. Having multiple price points can be used to implement features like early bird prices, or mid-season discounts."
};
function validate140(data, {
  instancePath = "",
  parentData,
  parentDataProperty,
  rootData = data
} = {}) {
  let vErrors = null;
  let errors = 0;
  if (errors === 0) {
    if (data && typeof data == "object" && !Array.isArray(data)) {
      let missing0;
      if (data.id === void 0 && (missing0 = "id") || data.name === void 0 && (missing0 = "name") || data.description === void 0 && (missing0 = "description") || data.prices === void 0 && (missing0 = "prices") || data.ticketImage === void 0 && (missing0 = "ticketImage") || data.scope === void 0 && (missing0 = "scope") || data.geo_restriction === void 0 && (missing0 = "geo_restriction") || data.available === void 0 && (missing0 = "available")) {
        validate140.errors = [{
          instancePath,
          schemaPath: "#/required",
          keyword: "required",
          params: {
            missingProperty: missing0
          },
          message: "must have required property '" + missing0 + "'"
        }];
        return false;
      } else {
        if (data.id !== void 0) {
          const _errs1 = errors;
          if (typeof data.id !== "string") {
            validate140.errors = [{
              instancePath: instancePath + "/id",
              schemaPath: "#/properties/id/type",
              keyword: "type",
              params: {
                type: "string"
              },
              message: "must be string"
            }];
            return false;
          }
          var valid0 = _errs1 === errors;
        } else {
          var valid0 = true;
        }
        if (valid0) {
          if (data.name !== void 0) {
            const _errs3 = errors;
            if (typeof data.name !== "string") {
              validate140.errors = [{
                instancePath: instancePath + "/name",
                schemaPath: "#/properties/name/type",
                keyword: "type",
                params: {
                  type: "string"
                },
                message: "must be string"
              }];
              return false;
            }
            var valid0 = _errs3 === errors;
          } else {
            var valid0 = true;
          }
          if (valid0) {
            if (data.description !== void 0) {
              const _errs5 = errors;
              if (typeof data.description !== "string") {
                validate140.errors = [{
                  instancePath: instancePath + "/description",
                  schemaPath: "#/properties/description/type",
                  keyword: "type",
                  params: {
                    type: "string"
                  },
                  message: "must be string"
                }];
                return false;
              }
              var valid0 = _errs5 === errors;
            } else {
              var valid0 = true;
            }
            if (valid0) {
              if (data.prices !== void 0) {
                let data3 = data.prices;
                const _errs7 = errors;
                if (errors === _errs7) {
                  if (Array.isArray(data3)) {
                    var valid1 = true;
                    const len0 = data3.length;
                    for (let i0 = 0; i0 < len0; i0++) {
                      let data4 = data3[i0];
                      const _errs9 = errors;
                      const _errs10 = errors;
                      if (errors === _errs10) {
                        if (data4 && typeof data4 == "object" && !Array.isArray(data4)) {
                          let missing1;
                          if (data4.effectiveDate === void 0 && (missing1 = "effectiveDate") || data4.price === void 0 && (missing1 = "price") || data4.currency === void 0 && (missing1 = "currency")) {
                            validate140.errors = [{
                              instancePath: instancePath + "/prices/" + i0,
                              schemaPath: "TicketPrice/required",
                              keyword: "required",
                              params: {
                                missingProperty: missing1
                              },
                              message: "must have required property '" + missing1 + "'"
                            }];
                            return false;
                          } else {
                            if (data4.effectiveDate !== void 0) {
                              let data5 = data4.effectiveDate;
                              const _errs12 = errors;
                              if (!(data5 && typeof data5 == "object" && !Array.isArray(data5))) {
                                validate140.errors = [{
                                  instancePath: instancePath + "/prices/" + i0 + "/effectiveDate",
                                  schemaPath: "TicketPrice/properties/effectiveDate/type",
                                  keyword: "type",
                                  params: {
                                    type: "object"
                                  },
                                  message: "must be object"
                                }];
                                return false;
                              }
                              if (errors === _errs12) {
                                if (errors === _errs12) {
                                  if (typeof data5 === "string") {
                                    if (!formats0(data5)) {
                                      validate140.errors = [{
                                        instancePath: instancePath + "/prices/" + i0 + "/effectiveDate",
                                        schemaPath: "TicketPrice/properties/effectiveDate/format",
                                        keyword: "format",
                                        params: {
                                          format: "date-time"
                                        },
                                        message: 'must match format "date-time"'
                                      }];
                                      return false;
                                    }
                                  }
                                }
                              }
                              var valid3 = _errs12 === errors;
                            } else {
                              var valid3 = true;
                            }
                            if (valid3) {
                              if (data4.price !== void 0) {
                                let data6 = data4.price;
                                const _errs14 = errors;
                                if (!(typeof data6 == "number" && isFinite(data6))) {
                                  validate140.errors = [{
                                    instancePath: instancePath + "/prices/" + i0 + "/price",
                                    schemaPath: "TicketPrice/properties/price/type",
                                    keyword: "type",
                                    params: {
                                      type: "number"
                                    },
                                    message: "must be number"
                                  }];
                                  return false;
                                }
                                var valid3 = _errs14 === errors;
                              } else {
                                var valid3 = true;
                              }
                              if (valid3) {
                                if (data4.currency !== void 0) {
                                  const _errs16 = errors;
                                  if (typeof data4.currency !== "string") {
                                    validate140.errors = [{
                                      instancePath: instancePath + "/prices/" + i0 + "/currency",
                                      schemaPath: "TicketPrice/properties/currency/type",
                                      keyword: "type",
                                      params: {
                                        type: "string"
                                      },
                                      message: "must be string"
                                    }];
                                    return false;
                                  }
                                  var valid3 = _errs16 === errors;
                                } else {
                                  var valid3 = true;
                                }
                                if (valid3) {
                                  if (data4.alternateCurrencies !== void 0) {
                                    let data8 = data4.alternateCurrencies;
                                    const _errs18 = errors;
                                    if (errors === _errs18) {
                                      if (Array.isArray(data8)) {
                                        var valid4 = true;
                                        const len1 = data8.length;
                                        for (let i1 = 0; i1 < len1; i1++) {
                                          let data9 = data8[i1];
                                          const _errs20 = errors;
                                          if (errors === _errs20) {
                                            if (data9 && typeof data9 == "object" && !Array.isArray(data9)) {
                                              let missing2;
                                              if (data9.price === void 0 && (missing2 = "price") || data9.currency === void 0 && (missing2 = "currency")) {
                                                validate140.errors = [{
                                                  instancePath: instancePath + "/prices/" + i0 + "/alternateCurrencies/" + i1,
                                                  schemaPath: "TicketPrice/properties/alternateCurrencies/items/required",
                                                  keyword: "required",
                                                  params: {
                                                    missingProperty: missing2
                                                  },
                                                  message: "must have required property '" + missing2 + "'"
                                                }];
                                                return false;
                                              } else {
                                                if (data9.price !== void 0) {
                                                  let data10 = data9.price;
                                                  const _errs22 = errors;
                                                  if (!(typeof data10 == "number" && isFinite(data10))) {
                                                    validate140.errors = [{
                                                      instancePath: instancePath + "/prices/" + i0 + "/alternateCurrencies/" + i1 + "/price",
                                                      schemaPath: "TicketPrice/properties/alternateCurrencies/items/properties/price/type",
                                                      keyword: "type",
                                                      params: {
                                                        type: "number"
                                                      },
                                                      message: "must be number"
                                                    }];
                                                    return false;
                                                  }
                                                  var valid5 = _errs22 === errors;
                                                } else {
                                                  var valid5 = true;
                                                }
                                                if (valid5) {
                                                  if (data9.currency !== void 0) {
                                                    const _errs24 = errors;
                                                    if (typeof data9.currency !== "string") {
                                                      validate140.errors = [{
                                                        instancePath: instancePath + "/prices/" + i0 + "/alternateCurrencies/" + i1 + "/currency",
                                                        schemaPath: "TicketPrice/properties/alternateCurrencies/items/properties/currency/type",
                                                        keyword: "type",
                                                        params: {
                                                          type: "string"
                                                        },
                                                        message: "must be string"
                                                      }];
                                                      return false;
                                                    }
                                                    var valid5 = _errs24 === errors;
                                                  } else {
                                                    var valid5 = true;
                                                  }
                                                }
                                              }
                                            } else {
                                              validate140.errors = [{
                                                instancePath: instancePath + "/prices/" + i0 + "/alternateCurrencies/" + i1,
                                                schemaPath: "TicketPrice/properties/alternateCurrencies/items/type",
                                                keyword: "type",
                                                params: {
                                                  type: "object"
                                                },
                                                message: "must be object"
                                              }];
                                              return false;
                                            }
                                          }
                                          var valid4 = _errs20 === errors;
                                          if (!valid4) {
                                            break;
                                          }
                                        }
                                      } else {
                                        validate140.errors = [{
                                          instancePath: instancePath + "/prices/" + i0 + "/alternateCurrencies",
                                          schemaPath: "TicketPrice/properties/alternateCurrencies/type",
                                          keyword: "type",
                                          params: {
                                            type: "array"
                                          },
                                          message: "must be array"
                                        }];
                                        return false;
                                      }
                                    }
                                    var valid3 = _errs18 === errors;
                                  } else {
                                    var valid3 = true;
                                  }
                                }
                              }
                            }
                          }
                        } else {
                          validate140.errors = [{
                            instancePath: instancePath + "/prices/" + i0,
                            schemaPath: "TicketPrice/type",
                            keyword: "type",
                            params: {
                              type: "object"
                            },
                            message: "must be object"
                          }];
                          return false;
                        }
                      }
                      var valid1 = _errs9 === errors;
                      if (!valid1) {
                        break;
                      }
                    }
                  } else {
                    validate140.errors = [{
                      instancePath: instancePath + "/prices",
                      schemaPath: "#/properties/prices/type",
                      keyword: "type",
                      params: {
                        type: "array"
                      },
                      message: "must be array"
                    }];
                    return false;
                  }
                }
                var valid0 = _errs7 === errors;
              } else {
                var valid0 = true;
              }
              if (valid0) {
                if (data.ticketImage !== void 0) {
                  let data12 = data.ticketImage;
                  const _errs26 = errors;
                  if (typeof data12 !== "string" && data12 !== null) {
                    validate140.errors = [{
                      instancePath: instancePath + "/ticketImage",
                      schemaPath: "#/properties/ticketImage/type",
                      keyword: "type",
                      params: {
                        type: schema147.properties.ticketImage.type
                      },
                      message: "must be string,null"
                    }];
                    return false;
                  }
                  var valid0 = _errs26 === errors;
                } else {
                  var valid0 = true;
                }
                if (valid0) {
                  if (data.scope !== void 0) {
                    let data13 = data.scope;
                    const _errs28 = errors;
                    const _errs29 = errors;
                    let valid6 = false;
                    const _errs30 = errors;
                    const _errs31 = errors;
                    if (errors === _errs31) {
                      if (data13 && typeof data13 == "object" && !Array.isArray(data13)) {
                        let missing3;
                        if (data13.appliesTo === void 0 && (missing3 = "appliesTo") || data13.redemptionLimit === void 0 && (missing3 = "redemptionLimit") || data13.validityAfterRedemptionHours === void 0 && (missing3 = "validityAfterRedemptionHours")) {
                          const err0 = {
                            instancePath: instancePath + "/scope",
                            schemaPath: "TicketScope/required",
                            keyword: "required",
                            params: {
                              missingProperty: missing3
                            },
                            message: "must have required property '" + missing3 + "'"
                          };
                          if (vErrors === null) {
                            vErrors = [err0];
                          } else {
                            vErrors.push(err0);
                          }
                          errors++;
                        } else {
                          if (data13.initialCoverage !== void 0) {
                            const _errs33 = errors;
                            if (typeof data13.initialCoverage !== "boolean") {
                              const err1 = {
                                instancePath: instancePath + "/scope/initialCoverage",
                                schemaPath: "TicketScope/properties/initialCoverage/type",
                                keyword: "type",
                                params: {
                                  type: "boolean"
                                },
                                message: "must be boolean"
                              };
                              if (vErrors === null) {
                                vErrors = [err1];
                              } else {
                                vErrors.push(err1);
                              }
                              errors++;
                            }
                            var valid8 = _errs33 === errors;
                          } else {
                            var valid8 = true;
                          }
                          if (valid8) {
                            if (data13.appliesTo !== void 0) {
                              let data15 = data13.appliesTo;
                              const _errs35 = errors;
                              if (typeof data15 !== "string") {
                                const err2 = {
                                  instancePath: instancePath + "/scope/appliesTo",
                                  schemaPath: "TicketScope/properties/appliesTo/type",
                                  keyword: "type",
                                  params: {
                                    type: "string"
                                  },
                                  message: "must be string"
                                };
                                if (vErrors === null) {
                                  vErrors = [err2];
                                } else {
                                  vErrors.push(err2);
                                }
                                errors++;
                              }
                              if (!(data15 === "STREAMS" || data15 === "UPLOADS" || data15 === "STREAMS_AND_UPLOADS")) {
                                const err3 = {
                                  instancePath: instancePath + "/scope/appliesTo",
                                  schemaPath: "TicketScope/properties/appliesTo/enum",
                                  keyword: "enum",
                                  params: {
                                    allowedValues: schema146.properties.appliesTo.enum
                                  },
                                  message: "must be equal to one of the allowed values"
                                };
                                if (vErrors === null) {
                                  vErrors = [err3];
                                } else {
                                  vErrors.push(err3);
                                }
                                errors++;
                              }
                              var valid8 = _errs35 === errors;
                            } else {
                              var valid8 = true;
                            }
                            if (valid8) {
                              if (data13.tags !== void 0) {
                                let data16 = data13.tags;
                                const _errs37 = errors;
                                const _errs38 = errors;
                                let valid9 = false;
                                const _errs39 = errors;
                                if (errors === _errs39) {
                                  if (data16 && typeof data16 == "object" && !Array.isArray(data16)) {
                                    let missing4;
                                    if (data16.kind === void 0 && (missing4 = "kind") || data16.list === void 0 && (missing4 = "list")) {
                                      const err4 = {
                                        instancePath: instancePath + "/scope/tags",
                                        schemaPath: "TicketScope/properties/tags/anyOf/0/required",
                                        keyword: "required",
                                        params: {
                                          missingProperty: missing4
                                        },
                                        message: "must have required property '" + missing4 + "'"
                                      };
                                      if (vErrors === null) {
                                        vErrors = [err4];
                                      } else {
                                        vErrors.push(err4);
                                      }
                                      errors++;
                                    } else {
                                      if (data16.kind !== void 0) {
                                        let data17 = data16.kind;
                                        const _errs41 = errors;
                                        if (typeof data17 !== "string") {
                                          const err5 = {
                                            instancePath: instancePath + "/scope/tags/kind",
                                            schemaPath: "TicketScope/properties/tags/anyOf/0/properties/kind/type",
                                            keyword: "type",
                                            params: {
                                              type: "string"
                                            },
                                            message: "must be string"
                                          };
                                          if (vErrors === null) {
                                            vErrors = [err5];
                                          } else {
                                            vErrors.push(err5);
                                          }
                                          errors++;
                                        }
                                        if (!(data17 === "ALL" || data17 === "SOME")) {
                                          const err6 = {
                                            instancePath: instancePath + "/scope/tags/kind",
                                            schemaPath: "TicketScope/properties/tags/anyOf/0/properties/kind/enum",
                                            keyword: "enum",
                                            params: {
                                              allowedValues: schema146.properties.tags.anyOf[0].properties.kind.enum
                                            },
                                            message: "must be equal to one of the allowed values"
                                          };
                                          if (vErrors === null) {
                                            vErrors = [err6];
                                          } else {
                                            vErrors.push(err6);
                                          }
                                          errors++;
                                        }
                                        var valid10 = _errs41 === errors;
                                      } else {
                                        var valid10 = true;
                                      }
                                      if (valid10) {
                                        if (data16.list !== void 0) {
                                          let data18 = data16.list;
                                          const _errs43 = errors;
                                          if (errors === _errs43) {
                                            if (Array.isArray(data18)) {
                                              var valid11 = true;
                                              const len2 = data18.length;
                                              for (let i2 = 0; i2 < len2; i2++) {
                                                const _errs45 = errors;
                                                if (typeof data18[i2] !== "string") {
                                                  const err7 = {
                                                    instancePath: instancePath + "/scope/tags/list/" + i2,
                                                    schemaPath: "TicketScope/properties/tags/anyOf/0/properties/list/items/type",
                                                    keyword: "type",
                                                    params: {
                                                      type: "string"
                                                    },
                                                    message: "must be string"
                                                  };
                                                  if (vErrors === null) {
                                                    vErrors = [err7];
                                                  } else {
                                                    vErrors.push(err7);
                                                  }
                                                  errors++;
                                                }
                                                var valid11 = _errs45 === errors;
                                                if (!valid11) {
                                                  break;
                                                }
                                              }
                                            } else {
                                              const err8 = {
                                                instancePath: instancePath + "/scope/tags/list",
                                                schemaPath: "TicketScope/properties/tags/anyOf/0/properties/list/type",
                                                keyword: "type",
                                                params: {
                                                  type: "array"
                                                },
                                                message: "must be array"
                                              };
                                              if (vErrors === null) {
                                                vErrors = [err8];
                                              } else {
                                                vErrors.push(err8);
                                              }
                                              errors++;
                                            }
                                          }
                                          var valid10 = _errs43 === errors;
                                        } else {
                                          var valid10 = true;
                                        }
                                      }
                                    }
                                  } else {
                                    const err9 = {
                                      instancePath: instancePath + "/scope/tags",
                                      schemaPath: "TicketScope/properties/tags/anyOf/0/type",
                                      keyword: "type",
                                      params: {
                                        type: "object"
                                      },
                                      message: "must be object"
                                    };
                                    if (vErrors === null) {
                                      vErrors = [err9];
                                    } else {
                                      vErrors.push(err9);
                                    }
                                    errors++;
                                  }
                                }
                                var _valid1 = _errs39 === errors;
                                valid9 = valid9 || _valid1;
                                if (!valid9) {
                                  const _errs47 = errors;
                                  if (data16 !== null) {
                                    const err10 = {
                                      instancePath: instancePath + "/scope/tags",
                                      schemaPath: "TicketScope/properties/tags/anyOf/1/type",
                                      keyword: "type",
                                      params: {
                                        type: "null"
                                      },
                                      message: "must be null"
                                    };
                                    if (vErrors === null) {
                                      vErrors = [err10];
                                    } else {
                                      vErrors.push(err10);
                                    }
                                    errors++;
                                  }
                                  var _valid1 = _errs47 === errors;
                                  valid9 = valid9 || _valid1;
                                }
                                if (!valid9) {
                                  const err11 = {
                                    instancePath: instancePath + "/scope/tags",
                                    schemaPath: "TicketScope/properties/tags/anyOf",
                                    keyword: "anyOf",
                                    params: {},
                                    message: "must match a schema in anyOf"
                                  };
                                  if (vErrors === null) {
                                    vErrors = [err11];
                                  } else {
                                    vErrors.push(err11);
                                  }
                                  errors++;
                                } else {
                                  errors = _errs38;
                                  if (vErrors !== null) {
                                    if (_errs38) {
                                      vErrors.length = _errs38;
                                    } else {
                                      vErrors = null;
                                    }
                                  }
                                }
                                var valid8 = _errs37 === errors;
                              } else {
                                var valid8 = true;
                              }
                              if (valid8) {
                                if (data13.excludeTags !== void 0) {
                                  let data20 = data13.excludeTags;
                                  const _errs49 = errors;
                                  const _errs50 = errors;
                                  let valid12 = false;
                                  const _errs51 = errors;
                                  if (errors === _errs51) {
                                    if (data20 && typeof data20 == "object" && !Array.isArray(data20)) {
                                      let missing5;
                                      if (data20.kind === void 0 && (missing5 = "kind") || data20.list === void 0 && (missing5 = "list")) {
                                        const err12 = {
                                          instancePath: instancePath + "/scope/excludeTags",
                                          schemaPath: "TicketScope/properties/excludeTags/anyOf/0/required",
                                          keyword: "required",
                                          params: {
                                            missingProperty: missing5
                                          },
                                          message: "must have required property '" + missing5 + "'"
                                        };
                                        if (vErrors === null) {
                                          vErrors = [err12];
                                        } else {
                                          vErrors.push(err12);
                                        }
                                        errors++;
                                      } else {
                                        if (data20.kind !== void 0) {
                                          let data21 = data20.kind;
                                          const _errs53 = errors;
                                          if (typeof data21 !== "string") {
                                            const err13 = {
                                              instancePath: instancePath + "/scope/excludeTags/kind",
                                              schemaPath: "TicketScope/properties/excludeTags/anyOf/0/properties/kind/type",
                                              keyword: "type",
                                              params: {
                                                type: "string"
                                              },
                                              message: "must be string"
                                            };
                                            if (vErrors === null) {
                                              vErrors = [err13];
                                            } else {
                                              vErrors.push(err13);
                                            }
                                            errors++;
                                          }
                                          if (!(data21 === "ALL" || data21 === "SOME")) {
                                            const err14 = {
                                              instancePath: instancePath + "/scope/excludeTags/kind",
                                              schemaPath: "TicketScope/properties/excludeTags/anyOf/0/properties/kind/enum",
                                              keyword: "enum",
                                              params: {
                                                allowedValues: schema146.properties.excludeTags.anyOf[0].properties.kind.enum
                                              },
                                              message: "must be equal to one of the allowed values"
                                            };
                                            if (vErrors === null) {
                                              vErrors = [err14];
                                            } else {
                                              vErrors.push(err14);
                                            }
                                            errors++;
                                          }
                                          var valid13 = _errs53 === errors;
                                        } else {
                                          var valid13 = true;
                                        }
                                        if (valid13) {
                                          if (data20.list !== void 0) {
                                            let data22 = data20.list;
                                            const _errs55 = errors;
                                            if (errors === _errs55) {
                                              if (Array.isArray(data22)) {
                                                var valid14 = true;
                                                const len3 = data22.length;
                                                for (let i3 = 0; i3 < len3; i3++) {
                                                  const _errs57 = errors;
                                                  if (typeof data22[i3] !== "string") {
                                                    const err15 = {
                                                      instancePath: instancePath + "/scope/excludeTags/list/" + i3,
                                                      schemaPath: "TicketScope/properties/excludeTags/anyOf/0/properties/list/items/type",
                                                      keyword: "type",
                                                      params: {
                                                        type: "string"
                                                      },
                                                      message: "must be string"
                                                    };
                                                    if (vErrors === null) {
                                                      vErrors = [err15];
                                                    } else {
                                                      vErrors.push(err15);
                                                    }
                                                    errors++;
                                                  }
                                                  var valid14 = _errs57 === errors;
                                                  if (!valid14) {
                                                    break;
                                                  }
                                                }
                                              } else {
                                                const err16 = {
                                                  instancePath: instancePath + "/scope/excludeTags/list",
                                                  schemaPath: "TicketScope/properties/excludeTags/anyOf/0/properties/list/type",
                                                  keyword: "type",
                                                  params: {
                                                    type: "array"
                                                  },
                                                  message: "must be array"
                                                };
                                                if (vErrors === null) {
                                                  vErrors = [err16];
                                                } else {
                                                  vErrors.push(err16);
                                                }
                                                errors++;
                                              }
                                            }
                                            var valid13 = _errs55 === errors;
                                          } else {
                                            var valid13 = true;
                                          }
                                        }
                                      }
                                    } else {
                                      const err17 = {
                                        instancePath: instancePath + "/scope/excludeTags",
                                        schemaPath: "TicketScope/properties/excludeTags/anyOf/0/type",
                                        keyword: "type",
                                        params: {
                                          type: "object"
                                        },
                                        message: "must be object"
                                      };
                                      if (vErrors === null) {
                                        vErrors = [err17];
                                      } else {
                                        vErrors.push(err17);
                                      }
                                      errors++;
                                    }
                                  }
                                  var _valid2 = _errs51 === errors;
                                  valid12 = valid12 || _valid2;
                                  if (!valid12) {
                                    const _errs59 = errors;
                                    if (data20 !== null) {
                                      const err18 = {
                                        instancePath: instancePath + "/scope/excludeTags",
                                        schemaPath: "TicketScope/properties/excludeTags/anyOf/1/type",
                                        keyword: "type",
                                        params: {
                                          type: "null"
                                        },
                                        message: "must be null"
                                      };
                                      if (vErrors === null) {
                                        vErrors = [err18];
                                      } else {
                                        vErrors.push(err18);
                                      }
                                      errors++;
                                    }
                                    var _valid2 = _errs59 === errors;
                                    valid12 = valid12 || _valid2;
                                  }
                                  if (!valid12) {
                                    const err19 = {
                                      instancePath: instancePath + "/scope/excludeTags",
                                      schemaPath: "TicketScope/properties/excludeTags/anyOf",
                                      keyword: "anyOf",
                                      params: {},
                                      message: "must match a schema in anyOf"
                                    };
                                    if (vErrors === null) {
                                      vErrors = [err19];
                                    } else {
                                      vErrors.push(err19);
                                    }
                                    errors++;
                                  } else {
                                    errors = _errs50;
                                    if (vErrors !== null) {
                                      if (_errs50) {
                                        vErrors.length = _errs50;
                                      } else {
                                        vErrors = null;
                                      }
                                    }
                                  }
                                  var valid8 = _errs49 === errors;
                                } else {
                                  var valid8 = true;
                                }
                                if (valid8) {
                                  if (data13.attributes !== void 0) {
                                    let data24 = data13.attributes;
                                    const _errs61 = errors;
                                    const _errs62 = errors;
                                    let valid15 = false;
                                    const _errs63 = errors;
                                    if (errors === _errs63) {
                                      if (data24 && typeof data24 == "object" && !Array.isArray(data24)) {
                                        let missing6;
                                        if (data24.kind === void 0 && (missing6 = "kind") || data24.list === void 0 && (missing6 = "list")) {
                                          const err20 = {
                                            instancePath: instancePath + "/scope/attributes",
                                            schemaPath: "TicketScope/properties/attributes/anyOf/0/required",
                                            keyword: "required",
                                            params: {
                                              missingProperty: missing6
                                            },
                                            message: "must have required property '" + missing6 + "'"
                                          };
                                          if (vErrors === null) {
                                            vErrors = [err20];
                                          } else {
                                            vErrors.push(err20);
                                          }
                                          errors++;
                                        } else {
                                          if (data24.kind !== void 0) {
                                            let data25 = data24.kind;
                                            const _errs65 = errors;
                                            if (typeof data25 !== "string") {
                                              const err21 = {
                                                instancePath: instancePath + "/scope/attributes/kind",
                                                schemaPath: "TicketScope/properties/attributes/anyOf/0/properties/kind/type",
                                                keyword: "type",
                                                params: {
                                                  type: "string"
                                                },
                                                message: "must be string"
                                              };
                                              if (vErrors === null) {
                                                vErrors = [err21];
                                              } else {
                                                vErrors.push(err21);
                                              }
                                              errors++;
                                            }
                                            if (!(data25 === "ALL" || data25 === "SOME")) {
                                              const err22 = {
                                                instancePath: instancePath + "/scope/attributes/kind",
                                                schemaPath: "TicketScope/properties/attributes/anyOf/0/properties/kind/enum",
                                                keyword: "enum",
                                                params: {
                                                  allowedValues: schema146.properties.attributes.anyOf[0].properties.kind.enum
                                                },
                                                message: "must be equal to one of the allowed values"
                                              };
                                              if (vErrors === null) {
                                                vErrors = [err22];
                                              } else {
                                                vErrors.push(err22);
                                              }
                                              errors++;
                                            }
                                            var valid16 = _errs65 === errors;
                                          } else {
                                            var valid16 = true;
                                          }
                                          if (valid16) {
                                            if (data24.list !== void 0) {
                                              let data26 = data24.list;
                                              const _errs67 = errors;
                                              if (errors === _errs67) {
                                                if (Array.isArray(data26)) {
                                                  var valid17 = true;
                                                  const len4 = data26.length;
                                                  for (let i4 = 0; i4 < len4; i4++) {
                                                    const _errs69 = errors;
                                                    if (typeof data26[i4] !== "string") {
                                                      const err23 = {
                                                        instancePath: instancePath + "/scope/attributes/list/" + i4,
                                                        schemaPath: "TicketScope/properties/attributes/anyOf/0/properties/list/items/type",
                                                        keyword: "type",
                                                        params: {
                                                          type: "string"
                                                        },
                                                        message: "must be string"
                                                      };
                                                      if (vErrors === null) {
                                                        vErrors = [err23];
                                                      } else {
                                                        vErrors.push(err23);
                                                      }
                                                      errors++;
                                                    }
                                                    var valid17 = _errs69 === errors;
                                                    if (!valid17) {
                                                      break;
                                                    }
                                                  }
                                                } else {
                                                  const err24 = {
                                                    instancePath: instancePath + "/scope/attributes/list",
                                                    schemaPath: "TicketScope/properties/attributes/anyOf/0/properties/list/type",
                                                    keyword: "type",
                                                    params: {
                                                      type: "array"
                                                    },
                                                    message: "must be array"
                                                  };
                                                  if (vErrors === null) {
                                                    vErrors = [err24];
                                                  } else {
                                                    vErrors.push(err24);
                                                  }
                                                  errors++;
                                                }
                                              }
                                              var valid16 = _errs67 === errors;
                                            } else {
                                              var valid16 = true;
                                            }
                                          }
                                        }
                                      } else {
                                        const err25 = {
                                          instancePath: instancePath + "/scope/attributes",
                                          schemaPath: "TicketScope/properties/attributes/anyOf/0/type",
                                          keyword: "type",
                                          params: {
                                            type: "object"
                                          },
                                          message: "must be object"
                                        };
                                        if (vErrors === null) {
                                          vErrors = [err25];
                                        } else {
                                          vErrors.push(err25);
                                        }
                                        errors++;
                                      }
                                    }
                                    var _valid3 = _errs63 === errors;
                                    valid15 = valid15 || _valid3;
                                    if (!valid15) {
                                      const _errs71 = errors;
                                      if (data24 !== null) {
                                        const err26 = {
                                          instancePath: instancePath + "/scope/attributes",
                                          schemaPath: "TicketScope/properties/attributes/anyOf/1/type",
                                          keyword: "type",
                                          params: {
                                            type: "null"
                                          },
                                          message: "must be null"
                                        };
                                        if (vErrors === null) {
                                          vErrors = [err26];
                                        } else {
                                          vErrors.push(err26);
                                        }
                                        errors++;
                                      }
                                      var _valid3 = _errs71 === errors;
                                      valid15 = valid15 || _valid3;
                                    }
                                    if (!valid15) {
                                      const err27 = {
                                        instancePath: instancePath + "/scope/attributes",
                                        schemaPath: "TicketScope/properties/attributes/anyOf",
                                        keyword: "anyOf",
                                        params: {},
                                        message: "must match a schema in anyOf"
                                      };
                                      if (vErrors === null) {
                                        vErrors = [err27];
                                      } else {
                                        vErrors.push(err27);
                                      }
                                      errors++;
                                    } else {
                                      errors = _errs62;
                                      if (vErrors !== null) {
                                        if (_errs62) {
                                          vErrors.length = _errs62;
                                        } else {
                                          vErrors = null;
                                        }
                                      }
                                    }
                                    var valid8 = _errs61 === errors;
                                  } else {
                                    var valid8 = true;
                                  }
                                  if (valid8) {
                                    if (data13.excludeAttributes !== void 0) {
                                      let data28 = data13.excludeAttributes;
                                      const _errs73 = errors;
                                      const _errs74 = errors;
                                      let valid18 = false;
                                      const _errs75 = errors;
                                      if (errors === _errs75) {
                                        if (data28 && typeof data28 == "object" && !Array.isArray(data28)) {
                                          let missing7;
                                          if (data28.kind === void 0 && (missing7 = "kind") || data28.list === void 0 && (missing7 = "list")) {
                                            const err28 = {
                                              instancePath: instancePath + "/scope/excludeAttributes",
                                              schemaPath: "TicketScope/properties/excludeAttributes/anyOf/0/required",
                                              keyword: "required",
                                              params: {
                                                missingProperty: missing7
                                              },
                                              message: "must have required property '" + missing7 + "'"
                                            };
                                            if (vErrors === null) {
                                              vErrors = [err28];
                                            } else {
                                              vErrors.push(err28);
                                            }
                                            errors++;
                                          } else {
                                            if (data28.kind !== void 0) {
                                              let data29 = data28.kind;
                                              const _errs77 = errors;
                                              if (typeof data29 !== "string") {
                                                const err29 = {
                                                  instancePath: instancePath + "/scope/excludeAttributes/kind",
                                                  schemaPath: "TicketScope/properties/excludeAttributes/anyOf/0/properties/kind/type",
                                                  keyword: "type",
                                                  params: {
                                                    type: "string"
                                                  },
                                                  message: "must be string"
                                                };
                                                if (vErrors === null) {
                                                  vErrors = [err29];
                                                } else {
                                                  vErrors.push(err29);
                                                }
                                                errors++;
                                              }
                                              if (!(data29 === "ALL" || data29 === "SOME")) {
                                                const err30 = {
                                                  instancePath: instancePath + "/scope/excludeAttributes/kind",
                                                  schemaPath: "TicketScope/properties/excludeAttributes/anyOf/0/properties/kind/enum",
                                                  keyword: "enum",
                                                  params: {
                                                    allowedValues: schema146.properties.excludeAttributes.anyOf[0].properties.kind.enum
                                                  },
                                                  message: "must be equal to one of the allowed values"
                                                };
                                                if (vErrors === null) {
                                                  vErrors = [err30];
                                                } else {
                                                  vErrors.push(err30);
                                                }
                                                errors++;
                                              }
                                              var valid19 = _errs77 === errors;
                                            } else {
                                              var valid19 = true;
                                            }
                                            if (valid19) {
                                              if (data28.list !== void 0) {
                                                let data30 = data28.list;
                                                const _errs79 = errors;
                                                if (errors === _errs79) {
                                                  if (Array.isArray(data30)) {
                                                    var valid20 = true;
                                                    const len5 = data30.length;
                                                    for (let i5 = 0; i5 < len5; i5++) {
                                                      const _errs81 = errors;
                                                      if (typeof data30[i5] !== "string") {
                                                        const err31 = {
                                                          instancePath: instancePath + "/scope/excludeAttributes/list/" + i5,
                                                          schemaPath: "TicketScope/properties/excludeAttributes/anyOf/0/properties/list/items/type",
                                                          keyword: "type",
                                                          params: {
                                                            type: "string"
                                                          },
                                                          message: "must be string"
                                                        };
                                                        if (vErrors === null) {
                                                          vErrors = [err31];
                                                        } else {
                                                          vErrors.push(err31);
                                                        }
                                                        errors++;
                                                      }
                                                      var valid20 = _errs81 === errors;
                                                      if (!valid20) {
                                                        break;
                                                      }
                                                    }
                                                  } else {
                                                    const err32 = {
                                                      instancePath: instancePath + "/scope/excludeAttributes/list",
                                                      schemaPath: "TicketScope/properties/excludeAttributes/anyOf/0/properties/list/type",
                                                      keyword: "type",
                                                      params: {
                                                        type: "array"
                                                      },
                                                      message: "must be array"
                                                    };
                                                    if (vErrors === null) {
                                                      vErrors = [err32];
                                                    } else {
                                                      vErrors.push(err32);
                                                    }
                                                    errors++;
                                                  }
                                                }
                                                var valid19 = _errs79 === errors;
                                              } else {
                                                var valid19 = true;
                                              }
                                            }
                                          }
                                        } else {
                                          const err33 = {
                                            instancePath: instancePath + "/scope/excludeAttributes",
                                            schemaPath: "TicketScope/properties/excludeAttributes/anyOf/0/type",
                                            keyword: "type",
                                            params: {
                                              type: "object"
                                            },
                                            message: "must be object"
                                          };
                                          if (vErrors === null) {
                                            vErrors = [err33];
                                          } else {
                                            vErrors.push(err33);
                                          }
                                          errors++;
                                        }
                                      }
                                      var _valid4 = _errs75 === errors;
                                      valid18 = valid18 || _valid4;
                                      if (!valid18) {
                                        const _errs83 = errors;
                                        if (data28 !== null) {
                                          const err34 = {
                                            instancePath: instancePath + "/scope/excludeAttributes",
                                            schemaPath: "TicketScope/properties/excludeAttributes/anyOf/1/type",
                                            keyword: "type",
                                            params: {
                                              type: "null"
                                            },
                                            message: "must be null"
                                          };
                                          if (vErrors === null) {
                                            vErrors = [err34];
                                          } else {
                                            vErrors.push(err34);
                                          }
                                          errors++;
                                        }
                                        var _valid4 = _errs83 === errors;
                                        valid18 = valid18 || _valid4;
                                      }
                                      if (!valid18) {
                                        const err35 = {
                                          instancePath: instancePath + "/scope/excludeAttributes",
                                          schemaPath: "TicketScope/properties/excludeAttributes/anyOf",
                                          keyword: "anyOf",
                                          params: {},
                                          message: "must match a schema in anyOf"
                                        };
                                        if (vErrors === null) {
                                          vErrors = [err35];
                                        } else {
                                          vErrors.push(err35);
                                        }
                                        errors++;
                                      } else {
                                        errors = _errs74;
                                        if (vErrors !== null) {
                                          if (_errs74) {
                                            vErrors.length = _errs74;
                                          } else {
                                            vErrors = null;
                                          }
                                        }
                                      }
                                      var valid8 = _errs73 === errors;
                                    } else {
                                      var valid8 = true;
                                    }
                                    if (valid8) {
                                      if (data13.videoIds !== void 0) {
                                        let data32 = data13.videoIds;
                                        const _errs85 = errors;
                                        const _errs86 = errors;
                                        let valid21 = false;
                                        const _errs87 = errors;
                                        if (errors === _errs87) {
                                          if (Array.isArray(data32)) {
                                            var valid22 = true;
                                            const len6 = data32.length;
                                            for (let i6 = 0; i6 < len6; i6++) {
                                              const _errs89 = errors;
                                              if (typeof data32[i6] !== "string") {
                                                const err36 = {
                                                  instancePath: instancePath + "/scope/videoIds/" + i6,
                                                  schemaPath: "TicketScope/properties/videoIds/anyOf/0/items/type",
                                                  keyword: "type",
                                                  params: {
                                                    type: "string"
                                                  },
                                                  message: "must be string"
                                                };
                                                if (vErrors === null) {
                                                  vErrors = [err36];
                                                } else {
                                                  vErrors.push(err36);
                                                }
                                                errors++;
                                              }
                                              var valid22 = _errs89 === errors;
                                              if (!valid22) {
                                                break;
                                              }
                                            }
                                          } else {
                                            const err37 = {
                                              instancePath: instancePath + "/scope/videoIds",
                                              schemaPath: "TicketScope/properties/videoIds/anyOf/0/type",
                                              keyword: "type",
                                              params: {
                                                type: "array"
                                              },
                                              message: "must be array"
                                            };
                                            if (vErrors === null) {
                                              vErrors = [err37];
                                            } else {
                                              vErrors.push(err37);
                                            }
                                            errors++;
                                          }
                                        }
                                        var _valid5 = _errs87 === errors;
                                        valid21 = valid21 || _valid5;
                                        if (!valid21) {
                                          const _errs91 = errors;
                                          if (data32 !== null) {
                                            const err38 = {
                                              instancePath: instancePath + "/scope/videoIds",
                                              schemaPath: "TicketScope/properties/videoIds/anyOf/1/type",
                                              keyword: "type",
                                              params: {
                                                type: "null"
                                              },
                                              message: "must be null"
                                            };
                                            if (vErrors === null) {
                                              vErrors = [err38];
                                            } else {
                                              vErrors.push(err38);
                                            }
                                            errors++;
                                          }
                                          var _valid5 = _errs91 === errors;
                                          valid21 = valid21 || _valid5;
                                        }
                                        if (!valid21) {
                                          const err39 = {
                                            instancePath: instancePath + "/scope/videoIds",
                                            schemaPath: "TicketScope/properties/videoIds/anyOf",
                                            keyword: "anyOf",
                                            params: {},
                                            message: "must match a schema in anyOf"
                                          };
                                          if (vErrors === null) {
                                            vErrors = [err39];
                                          } else {
                                            vErrors.push(err39);
                                          }
                                          errors++;
                                        } else {
                                          errors = _errs86;
                                          if (vErrors !== null) {
                                            if (_errs86) {
                                              vErrors.length = _errs86;
                                            } else {
                                              vErrors = null;
                                            }
                                          }
                                        }
                                        var valid8 = _errs85 === errors;
                                      } else {
                                        var valid8 = true;
                                      }
                                      if (valid8) {
                                        if (data13.excludeVideoIds !== void 0) {
                                          let data34 = data13.excludeVideoIds;
                                          const _errs93 = errors;
                                          const _errs94 = errors;
                                          let valid23 = false;
                                          const _errs95 = errors;
                                          if (errors === _errs95) {
                                            if (Array.isArray(data34)) {
                                              var valid24 = true;
                                              const len7 = data34.length;
                                              for (let i7 = 0; i7 < len7; i7++) {
                                                const _errs97 = errors;
                                                if (typeof data34[i7] !== "string") {
                                                  const err40 = {
                                                    instancePath: instancePath + "/scope/excludeVideoIds/" + i7,
                                                    schemaPath: "TicketScope/properties/excludeVideoIds/anyOf/0/items/type",
                                                    keyword: "type",
                                                    params: {
                                                      type: "string"
                                                    },
                                                    message: "must be string"
                                                  };
                                                  if (vErrors === null) {
                                                    vErrors = [err40];
                                                  } else {
                                                    vErrors.push(err40);
                                                  }
                                                  errors++;
                                                }
                                                var valid24 = _errs97 === errors;
                                                if (!valid24) {
                                                  break;
                                                }
                                              }
                                            } else {
                                              const err41 = {
                                                instancePath: instancePath + "/scope/excludeVideoIds",
                                                schemaPath: "TicketScope/properties/excludeVideoIds/anyOf/0/type",
                                                keyword: "type",
                                                params: {
                                                  type: "array"
                                                },
                                                message: "must be array"
                                              };
                                              if (vErrors === null) {
                                                vErrors = [err41];
                                              } else {
                                                vErrors.push(err41);
                                              }
                                              errors++;
                                            }
                                          }
                                          var _valid6 = _errs95 === errors;
                                          valid23 = valid23 || _valid6;
                                          if (!valid23) {
                                            const _errs99 = errors;
                                            if (data34 !== null) {
                                              const err42 = {
                                                instancePath: instancePath + "/scope/excludeVideoIds",
                                                schemaPath: "TicketScope/properties/excludeVideoIds/anyOf/1/type",
                                                keyword: "type",
                                                params: {
                                                  type: "null"
                                                },
                                                message: "must be null"
                                              };
                                              if (vErrors === null) {
                                                vErrors = [err42];
                                              } else {
                                                vErrors.push(err42);
                                              }
                                              errors++;
                                            }
                                            var _valid6 = _errs99 === errors;
                                            valid23 = valid23 || _valid6;
                                          }
                                          if (!valid23) {
                                            const err43 = {
                                              instancePath: instancePath + "/scope/excludeVideoIds",
                                              schemaPath: "TicketScope/properties/excludeVideoIds/anyOf",
                                              keyword: "anyOf",
                                              params: {},
                                              message: "must match a schema in anyOf"
                                            };
                                            if (vErrors === null) {
                                              vErrors = [err43];
                                            } else {
                                              vErrors.push(err43);
                                            }
                                            errors++;
                                          } else {
                                            errors = _errs94;
                                            if (vErrors !== null) {
                                              if (_errs94) {
                                                vErrors.length = _errs94;
                                              } else {
                                                vErrors = null;
                                              }
                                            }
                                          }
                                          var valid8 = _errs93 === errors;
                                        } else {
                                          var valid8 = true;
                                        }
                                        if (valid8) {
                                          if (data13.redemptionLimit !== void 0) {
                                            let data36 = data13.redemptionLimit;
                                            const _errs101 = errors;
                                            if (!(typeof data36 == "number" && isFinite(data36)) && data36 !== null) {
                                              const err44 = {
                                                instancePath: instancePath + "/scope/redemptionLimit",
                                                schemaPath: "TicketScope/properties/redemptionLimit/type",
                                                keyword: "type",
                                                params: {
                                                  type: schema146.properties.redemptionLimit.type
                                                },
                                                message: "must be number,null"
                                              };
                                              if (vErrors === null) {
                                                vErrors = [err44];
                                              } else {
                                                vErrors.push(err44);
                                              }
                                              errors++;
                                            }
                                            if (!(data36 === 1 || data36 === null)) {
                                              const err45 = {
                                                instancePath: instancePath + "/scope/redemptionLimit",
                                                schemaPath: "TicketScope/properties/redemptionLimit/enum",
                                                keyword: "enum",
                                                params: {
                                                  allowedValues: schema146.properties.redemptionLimit.enum
                                                },
                                                message: "must be equal to one of the allowed values"
                                              };
                                              if (vErrors === null) {
                                                vErrors = [err45];
                                              } else {
                                                vErrors.push(err45);
                                              }
                                              errors++;
                                            }
                                            var valid8 = _errs101 === errors;
                                          } else {
                                            var valid8 = true;
                                          }
                                          if (valid8) {
                                            if (data13.validityAfterRedemptionHours !== void 0) {
                                              let data37 = data13.validityAfterRedemptionHours;
                                              const _errs103 = errors;
                                              if (!(typeof data37 == "number" && isFinite(data37)) && data37 !== null) {
                                                const err46 = {
                                                  instancePath: instancePath + "/scope/validityAfterRedemptionHours",
                                                  schemaPath: "TicketScope/properties/validityAfterRedemptionHours/type",
                                                  keyword: "type",
                                                  params: {
                                                    type: schema146.properties.validityAfterRedemptionHours.type
                                                  },
                                                  message: "must be number,null"
                                                };
                                                if (vErrors === null) {
                                                  vErrors = [err46];
                                                } else {
                                                  vErrors.push(err46);
                                                }
                                                errors++;
                                              }
                                              var valid8 = _errs103 === errors;
                                            } else {
                                              var valid8 = true;
                                            }
                                          }
                                        }
                                      }
                                    }
                                  }
                                }
                              }
                            }
                          }
                        }
                      } else {
                        const err47 = {
                          instancePath: instancePath + "/scope",
                          schemaPath: "TicketScope/type",
                          keyword: "type",
                          params: {
                            type: "object"
                          },
                          message: "must be object"
                        };
                        if (vErrors === null) {
                          vErrors = [err47];
                        } else {
                          vErrors.push(err47);
                        }
                        errors++;
                      }
                    }
                    var _valid0 = _errs30 === errors;
                    valid6 = valid6 || _valid0;
                    if (!valid6) {
                      const _errs105 = errors;
                      if (data13 !== null) {
                        const err48 = {
                          instancePath: instancePath + "/scope",
                          schemaPath: "#/properties/scope/anyOf/1/type",
                          keyword: "type",
                          params: {
                            type: "null"
                          },
                          message: "must be null"
                        };
                        if (vErrors === null) {
                          vErrors = [err48];
                        } else {
                          vErrors.push(err48);
                        }
                        errors++;
                      }
                      var _valid0 = _errs105 === errors;
                      valid6 = valid6 || _valid0;
                    }
                    if (!valid6) {
                      const err49 = {
                        instancePath: instancePath + "/scope",
                        schemaPath: "#/properties/scope/anyOf",
                        keyword: "anyOf",
                        params: {},
                        message: "must match a schema in anyOf"
                      };
                      if (vErrors === null) {
                        vErrors = [err49];
                      } else {
                        vErrors.push(err49);
                      }
                      errors++;
                      validate140.errors = vErrors;
                      return false;
                    } else {
                      errors = _errs29;
                      if (vErrors !== null) {
                        if (_errs29) {
                          vErrors.length = _errs29;
                        } else {
                          vErrors = null;
                        }
                      }
                    }
                    var valid0 = _errs28 === errors;
                  } else {
                    var valid0 = true;
                  }
                  if (valid0) {
                    if (data.geo_restriction !== void 0) {
                      let data38 = data.geo_restriction;
                      const _errs107 = errors;
                      const _errs108 = errors;
                      let valid25 = false;
                      const _errs109 = errors;
                      if (errors === _errs109) {
                        if (Array.isArray(data38)) {
                          var valid26 = true;
                          const len8 = data38.length;
                          for (let i8 = 0; i8 < len8; i8++) {
                            const _errs111 = errors;
                            if (typeof data38[i8] !== "string") {
                              const err50 = {
                                instancePath: instancePath + "/geo_restriction/" + i8,
                                schemaPath: "#/properties/geo_restriction/anyOf/0/items/type",
                                keyword: "type",
                                params: {
                                  type: "string"
                                },
                                message: "must be string"
                              };
                              if (vErrors === null) {
                                vErrors = [err50];
                              } else {
                                vErrors.push(err50);
                              }
                              errors++;
                            }
                            var valid26 = _errs111 === errors;
                            if (!valid26) {
                              break;
                            }
                          }
                        } else {
                          const err51 = {
                            instancePath: instancePath + "/geo_restriction",
                            schemaPath: "#/properties/geo_restriction/anyOf/0/type",
                            keyword: "type",
                            params: {
                              type: "array"
                            },
                            message: "must be array"
                          };
                          if (vErrors === null) {
                            vErrors = [err51];
                          } else {
                            vErrors.push(err51);
                          }
                          errors++;
                        }
                      }
                      var _valid7 = _errs109 === errors;
                      valid25 = valid25 || _valid7;
                      if (!valid25) {
                        const _errs113 = errors;
                        if (data38 !== null) {
                          const err52 = {
                            instancePath: instancePath + "/geo_restriction",
                            schemaPath: "#/properties/geo_restriction/anyOf/1/type",
                            keyword: "type",
                            params: {
                              type: "null"
                            },
                            message: "must be null"
                          };
                          if (vErrors === null) {
                            vErrors = [err52];
                          } else {
                            vErrors.push(err52);
                          }
                          errors++;
                        }
                        var _valid7 = _errs113 === errors;
                        valid25 = valid25 || _valid7;
                      }
                      if (!valid25) {
                        const err53 = {
                          instancePath: instancePath + "/geo_restriction",
                          schemaPath: "#/properties/geo_restriction/anyOf",
                          keyword: "anyOf",
                          params: {},
                          message: "must match a schema in anyOf"
                        };
                        if (vErrors === null) {
                          vErrors = [err53];
                        } else {
                          vErrors.push(err53);
                        }
                        errors++;
                        validate140.errors = vErrors;
                        return false;
                      } else {
                        errors = _errs108;
                        if (vErrors !== null) {
                          if (_errs108) {
                            vErrors.length = _errs108;
                          } else {
                            vErrors = null;
                          }
                        }
                      }
                      var valid0 = _errs107 === errors;
                    } else {
                      var valid0 = true;
                    }
                    if (valid0) {
                      if (data.available !== void 0) {
                        const _errs115 = errors;
                        if (typeof data.available !== "boolean") {
                          validate140.errors = [{
                            instancePath: instancePath + "/available",
                            schemaPath: "#/properties/available/type",
                            keyword: "type",
                            params: {
                              type: "boolean"
                            },
                            message: "must be boolean"
                          }];
                          return false;
                        }
                        var valid0 = _errs115 === errors;
                      } else {
                        var valid0 = true;
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
    } else {
      validate140.errors = [{
        instancePath,
        schemaPath: "#/type",
        keyword: "type",
        params: {
          type: "object"
        },
        message: "must be object"
      }];
      return false;
    }
  }
  validate140.errors = vErrors;
  return errors === 0;
}
const Event = validate141;
const schema150 = {
  "$id": "Event",
  "$schema": "http://json-schema.org/draft-07/schema#",
  "type": "object",
  "properties": {
    "title": {
      "type": "string"
    },
    "description": {
      "type": "string"
    },
    "startTime": {
      "type": "object",
      "format": "date-time"
    },
    "endTime": {
      "type": "object",
      "format": "date-time"
    },
    "tickets": {
      "type": "array",
      "items": {
        "$ref": "Ticket"
      }
    },
    "hideTicketCTA": {
      "type": "boolean"
    },
    "pages": {
      "type": "array",
      "items": {
        "$ref": "Page"
      }
    },
    "published": {
      "type": "boolean"
    },
    "archived": {
      "type": "boolean"
    },
    "organizationId": {
      "type": ["string", "null"]
    },
    "channelId": {
      "type": "string"
    },
    "posterImage": {
      "type": "string"
    },
    "includedInPlans": {
      "anyOf": [{
        "type": "array",
        "items": {
          "type": "string"
        }
      }, {
        "type": "null"
      }]
    },
    "excludedFromPlans": {
      "anyOf": [{
        "type": "array",
        "items": {
          "type": "string"
        }
      }, {
        "type": "null"
      }]
    }
  },
  "required": ["title", "description", "startTime", "endTime", "tickets", "pages", "published", "archived", "organizationId", "channelId", "posterImage"],
  "description": "An event is the main content type in a channel and represents one or multiple live streams, uploads, ads, etc. The event can span multiple days and can be promoted in advance. The defining features of the event is that tickets can be purchased to unlock specific content."
};
function validate141(data, {
  instancePath = "",
  parentData,
  parentDataProperty,
  rootData = data
} = {}) {
  let vErrors = null;
  let errors = 0;
  if (errors === 0) {
    if (data && typeof data == "object" && !Array.isArray(data)) {
      let missing0;
      if (data.title === void 0 && (missing0 = "title") || data.description === void 0 && (missing0 = "description") || data.startTime === void 0 && (missing0 = "startTime") || data.endTime === void 0 && (missing0 = "endTime") || data.tickets === void 0 && (missing0 = "tickets") || data.pages === void 0 && (missing0 = "pages") || data.published === void 0 && (missing0 = "published") || data.archived === void 0 && (missing0 = "archived") || data.organizationId === void 0 && (missing0 = "organizationId") || data.channelId === void 0 && (missing0 = "channelId") || data.posterImage === void 0 && (missing0 = "posterImage")) {
        validate141.errors = [{
          instancePath,
          schemaPath: "#/required",
          keyword: "required",
          params: {
            missingProperty: missing0
          },
          message: "must have required property '" + missing0 + "'"
        }];
        return false;
      } else {
        if (data.title !== void 0) {
          const _errs1 = errors;
          if (typeof data.title !== "string") {
            validate141.errors = [{
              instancePath: instancePath + "/title",
              schemaPath: "#/properties/title/type",
              keyword: "type",
              params: {
                type: "string"
              },
              message: "must be string"
            }];
            return false;
          }
          var valid0 = _errs1 === errors;
        } else {
          var valid0 = true;
        }
        if (valid0) {
          if (data.description !== void 0) {
            const _errs3 = errors;
            if (typeof data.description !== "string") {
              validate141.errors = [{
                instancePath: instancePath + "/description",
                schemaPath: "#/properties/description/type",
                keyword: "type",
                params: {
                  type: "string"
                },
                message: "must be string"
              }];
              return false;
            }
            var valid0 = _errs3 === errors;
          } else {
            var valid0 = true;
          }
          if (valid0) {
            if (data.startTime !== void 0) {
              let data2 = data.startTime;
              const _errs5 = errors;
              if (!(data2 && typeof data2 == "object" && !Array.isArray(data2))) {
                validate141.errors = [{
                  instancePath: instancePath + "/startTime",
                  schemaPath: "#/properties/startTime/type",
                  keyword: "type",
                  params: {
                    type: "object"
                  },
                  message: "must be object"
                }];
                return false;
              }
              if (errors === _errs5) {
                if (errors === _errs5) {
                  if (typeof data2 === "string") {
                    if (!formats0(data2)) {
                      validate141.errors = [{
                        instancePath: instancePath + "/startTime",
                        schemaPath: "#/properties/startTime/format",
                        keyword: "format",
                        params: {
                          format: "date-time"
                        },
                        message: 'must match format "date-time"'
                      }];
                      return false;
                    }
                  }
                }
              }
              var valid0 = _errs5 === errors;
            } else {
              var valid0 = true;
            }
            if (valid0) {
              if (data.endTime !== void 0) {
                let data3 = data.endTime;
                const _errs7 = errors;
                if (!(data3 && typeof data3 == "object" && !Array.isArray(data3))) {
                  validate141.errors = [{
                    instancePath: instancePath + "/endTime",
                    schemaPath: "#/properties/endTime/type",
                    keyword: "type",
                    params: {
                      type: "object"
                    },
                    message: "must be object"
                  }];
                  return false;
                }
                if (errors === _errs7) {
                  if (errors === _errs7) {
                    if (typeof data3 === "string") {
                      if (!formats0(data3)) {
                        validate141.errors = [{
                          instancePath: instancePath + "/endTime",
                          schemaPath: "#/properties/endTime/format",
                          keyword: "format",
                          params: {
                            format: "date-time"
                          },
                          message: 'must match format "date-time"'
                        }];
                        return false;
                      }
                    }
                  }
                }
                var valid0 = _errs7 === errors;
              } else {
                var valid0 = true;
              }
              if (valid0) {
                if (data.tickets !== void 0) {
                  let data4 = data.tickets;
                  const _errs9 = errors;
                  if (errors === _errs9) {
                    if (Array.isArray(data4)) {
                      var valid1 = true;
                      const len0 = data4.length;
                      for (let i0 = 0; i0 < len0; i0++) {
                        const _errs11 = errors;
                        if (!validate140(data4[i0], {
                          instancePath: instancePath + "/tickets/" + i0,
                          parentData: data4,
                          parentDataProperty: i0,
                          rootData
                        })) {
                          vErrors = vErrors === null ? validate140.errors : vErrors.concat(validate140.errors);
                          errors = vErrors.length;
                        }
                        var valid1 = _errs11 === errors;
                        if (!valid1) {
                          break;
                        }
                      }
                    } else {
                      validate141.errors = [{
                        instancePath: instancePath + "/tickets",
                        schemaPath: "#/properties/tickets/type",
                        keyword: "type",
                        params: {
                          type: "array"
                        },
                        message: "must be array"
                      }];
                      return false;
                    }
                  }
                  var valid0 = _errs9 === errors;
                } else {
                  var valid0 = true;
                }
                if (valid0) {
                  if (data.hideTicketCTA !== void 0) {
                    const _errs12 = errors;
                    if (typeof data.hideTicketCTA !== "boolean") {
                      validate141.errors = [{
                        instancePath: instancePath + "/hideTicketCTA",
                        schemaPath: "#/properties/hideTicketCTA/type",
                        keyword: "type",
                        params: {
                          type: "boolean"
                        },
                        message: "must be boolean"
                      }];
                      return false;
                    }
                    var valid0 = _errs12 === errors;
                  } else {
                    var valid0 = true;
                  }
                  if (valid0) {
                    if (data.pages !== void 0) {
                      let data7 = data.pages;
                      const _errs14 = errors;
                      if (errors === _errs14) {
                        if (Array.isArray(data7)) {
                          var valid2 = true;
                          const len1 = data7.length;
                          for (let i1 = 0; i1 < len1; i1++) {
                            const _errs16 = errors;
                            if (!validate100(data7[i1], {
                              instancePath: instancePath + "/pages/" + i1,
                              parentData: data7,
                              parentDataProperty: i1,
                              rootData
                            })) {
                              vErrors = vErrors === null ? validate100.errors : vErrors.concat(validate100.errors);
                              errors = vErrors.length;
                            }
                            var valid2 = _errs16 === errors;
                            if (!valid2) {
                              break;
                            }
                          }
                        } else {
                          validate141.errors = [{
                            instancePath: instancePath + "/pages",
                            schemaPath: "#/properties/pages/type",
                            keyword: "type",
                            params: {
                              type: "array"
                            },
                            message: "must be array"
                          }];
                          return false;
                        }
                      }
                      var valid0 = _errs14 === errors;
                    } else {
                      var valid0 = true;
                    }
                    if (valid0) {
                      if (data.published !== void 0) {
                        const _errs17 = errors;
                        if (typeof data.published !== "boolean") {
                          validate141.errors = [{
                            instancePath: instancePath + "/published",
                            schemaPath: "#/properties/published/type",
                            keyword: "type",
                            params: {
                              type: "boolean"
                            },
                            message: "must be boolean"
                          }];
                          return false;
                        }
                        var valid0 = _errs17 === errors;
                      } else {
                        var valid0 = true;
                      }
                      if (valid0) {
                        if (data.archived !== void 0) {
                          const _errs19 = errors;
                          if (typeof data.archived !== "boolean") {
                            validate141.errors = [{
                              instancePath: instancePath + "/archived",
                              schemaPath: "#/properties/archived/type",
                              keyword: "type",
                              params: {
                                type: "boolean"
                              },
                              message: "must be boolean"
                            }];
                            return false;
                          }
                          var valid0 = _errs19 === errors;
                        } else {
                          var valid0 = true;
                        }
                        if (valid0) {
                          if (data.organizationId !== void 0) {
                            let data11 = data.organizationId;
                            const _errs21 = errors;
                            if (typeof data11 !== "string" && data11 !== null) {
                              validate141.errors = [{
                                instancePath: instancePath + "/organizationId",
                                schemaPath: "#/properties/organizationId/type",
                                keyword: "type",
                                params: {
                                  type: schema150.properties.organizationId.type
                                },
                                message: "must be string,null"
                              }];
                              return false;
                            }
                            var valid0 = _errs21 === errors;
                          } else {
                            var valid0 = true;
                          }
                          if (valid0) {
                            if (data.channelId !== void 0) {
                              const _errs23 = errors;
                              if (typeof data.channelId !== "string") {
                                validate141.errors = [{
                                  instancePath: instancePath + "/channelId",
                                  schemaPath: "#/properties/channelId/type",
                                  keyword: "type",
                                  params: {
                                    type: "string"
                                  },
                                  message: "must be string"
                                }];
                                return false;
                              }
                              var valid0 = _errs23 === errors;
                            } else {
                              var valid0 = true;
                            }
                            if (valid0) {
                              if (data.posterImage !== void 0) {
                                const _errs25 = errors;
                                if (typeof data.posterImage !== "string") {
                                  validate141.errors = [{
                                    instancePath: instancePath + "/posterImage",
                                    schemaPath: "#/properties/posterImage/type",
                                    keyword: "type",
                                    params: {
                                      type: "string"
                                    },
                                    message: "must be string"
                                  }];
                                  return false;
                                }
                                var valid0 = _errs25 === errors;
                              } else {
                                var valid0 = true;
                              }
                              if (valid0) {
                                if (data.includedInPlans !== void 0) {
                                  let data14 = data.includedInPlans;
                                  const _errs27 = errors;
                                  const _errs28 = errors;
                                  let valid3 = false;
                                  const _errs29 = errors;
                                  if (errors === _errs29) {
                                    if (Array.isArray(data14)) {
                                      var valid4 = true;
                                      const len2 = data14.length;
                                      for (let i2 = 0; i2 < len2; i2++) {
                                        const _errs31 = errors;
                                        if (typeof data14[i2] !== "string") {
                                          const err0 = {
                                            instancePath: instancePath + "/includedInPlans/" + i2,
                                            schemaPath: "#/properties/includedInPlans/anyOf/0/items/type",
                                            keyword: "type",
                                            params: {
                                              type: "string"
                                            },
                                            message: "must be string"
                                          };
                                          if (vErrors === null) {
                                            vErrors = [err0];
                                          } else {
                                            vErrors.push(err0);
                                          }
                                          errors++;
                                        }
                                        var valid4 = _errs31 === errors;
                                        if (!valid4) {
                                          break;
                                        }
                                      }
                                    } else {
                                      const err1 = {
                                        instancePath: instancePath + "/includedInPlans",
                                        schemaPath: "#/properties/includedInPlans/anyOf/0/type",
                                        keyword: "type",
                                        params: {
                                          type: "array"
                                        },
                                        message: "must be array"
                                      };
                                      if (vErrors === null) {
                                        vErrors = [err1];
                                      } else {
                                        vErrors.push(err1);
                                      }
                                      errors++;
                                    }
                                  }
                                  var _valid0 = _errs29 === errors;
                                  valid3 = valid3 || _valid0;
                                  if (!valid3) {
                                    const _errs33 = errors;
                                    if (data14 !== null) {
                                      const err2 = {
                                        instancePath: instancePath + "/includedInPlans",
                                        schemaPath: "#/properties/includedInPlans/anyOf/1/type",
                                        keyword: "type",
                                        params: {
                                          type: "null"
                                        },
                                        message: "must be null"
                                      };
                                      if (vErrors === null) {
                                        vErrors = [err2];
                                      } else {
                                        vErrors.push(err2);
                                      }
                                      errors++;
                                    }
                                    var _valid0 = _errs33 === errors;
                                    valid3 = valid3 || _valid0;
                                  }
                                  if (!valid3) {
                                    const err3 = {
                                      instancePath: instancePath + "/includedInPlans",
                                      schemaPath: "#/properties/includedInPlans/anyOf",
                                      keyword: "anyOf",
                                      params: {},
                                      message: "must match a schema in anyOf"
                                    };
                                    if (vErrors === null) {
                                      vErrors = [err3];
                                    } else {
                                      vErrors.push(err3);
                                    }
                                    errors++;
                                    validate141.errors = vErrors;
                                    return false;
                                  } else {
                                    errors = _errs28;
                                    if (vErrors !== null) {
                                      if (_errs28) {
                                        vErrors.length = _errs28;
                                      } else {
                                        vErrors = null;
                                      }
                                    }
                                  }
                                  var valid0 = _errs27 === errors;
                                } else {
                                  var valid0 = true;
                                }
                                if (valid0) {
                                  if (data.excludedFromPlans !== void 0) {
                                    let data16 = data.excludedFromPlans;
                                    const _errs35 = errors;
                                    const _errs36 = errors;
                                    let valid5 = false;
                                    const _errs37 = errors;
                                    if (errors === _errs37) {
                                      if (Array.isArray(data16)) {
                                        var valid6 = true;
                                        const len3 = data16.length;
                                        for (let i3 = 0; i3 < len3; i3++) {
                                          const _errs39 = errors;
                                          if (typeof data16[i3] !== "string") {
                                            const err4 = {
                                              instancePath: instancePath + "/excludedFromPlans/" + i3,
                                              schemaPath: "#/properties/excludedFromPlans/anyOf/0/items/type",
                                              keyword: "type",
                                              params: {
                                                type: "string"
                                              },
                                              message: "must be string"
                                            };
                                            if (vErrors === null) {
                                              vErrors = [err4];
                                            } else {
                                              vErrors.push(err4);
                                            }
                                            errors++;
                                          }
                                          var valid6 = _errs39 === errors;
                                          if (!valid6) {
                                            break;
                                          }
                                        }
                                      } else {
                                        const err5 = {
                                          instancePath: instancePath + "/excludedFromPlans",
                                          schemaPath: "#/properties/excludedFromPlans/anyOf/0/type",
                                          keyword: "type",
                                          params: {
                                            type: "array"
                                          },
                                          message: "must be array"
                                        };
                                        if (vErrors === null) {
                                          vErrors = [err5];
                                        } else {
                                          vErrors.push(err5);
                                        }
                                        errors++;
                                      }
                                    }
                                    var _valid1 = _errs37 === errors;
                                    valid5 = valid5 || _valid1;
                                    if (!valid5) {
                                      const _errs41 = errors;
                                      if (data16 !== null) {
                                        const err6 = {
                                          instancePath: instancePath + "/excludedFromPlans",
                                          schemaPath: "#/properties/excludedFromPlans/anyOf/1/type",
                                          keyword: "type",
                                          params: {
                                            type: "null"
                                          },
                                          message: "must be null"
                                        };
                                        if (vErrors === null) {
                                          vErrors = [err6];
                                        } else {
                                          vErrors.push(err6);
                                        }
                                        errors++;
                                      }
                                      var _valid1 = _errs41 === errors;
                                      valid5 = valid5 || _valid1;
                                    }
                                    if (!valid5) {
                                      const err7 = {
                                        instancePath: instancePath + "/excludedFromPlans",
                                        schemaPath: "#/properties/excludedFromPlans/anyOf",
                                        keyword: "anyOf",
                                        params: {},
                                        message: "must match a schema in anyOf"
                                      };
                                      if (vErrors === null) {
                                        vErrors = [err7];
                                      } else {
                                        vErrors.push(err7);
                                      }
                                      errors++;
                                      validate141.errors = vErrors;
                                      return false;
                                    } else {
                                      errors = _errs36;
                                      if (vErrors !== null) {
                                        if (_errs36) {
                                          vErrors.length = _errs36;
                                        } else {
                                          vErrors = null;
                                        }
                                      }
                                    }
                                    var valid0 = _errs35 === errors;
                                  } else {
                                    var valid0 = true;
                                  }
                                }
                              }
                            }
                          }
                        }
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
    } else {
      validate141.errors = [{
        instancePath,
        schemaPath: "#/type",
        keyword: "type",
        params: {
          type: "object"
        },
        message: "must be object"
      }];
      return false;
    }
  }
  validate141.errors = vErrors;
  return errors === 0;
}
const Feedback = validate144;
const schema151 = {
  "$id": "Feedback",
  "$schema": "http://json-schema.org/draft-07/schema#",
  "type": "object",
  "properties": {
    "type": {
      "type": "string",
      "const": "VIDEO"
    },
    "videoId": {
      "type": "string"
    },
    "eventId": {
      "type": ["string", "null"]
    },
    "videoType": {
      "type": "string",
      "enum": ["SHORT", "STREAM", "UPLOAD"]
    },
    "isLive": {
      "type": "boolean"
    },
    "timestamp": {
      "type": "object",
      "format": "date-time"
    },
    "userId": {
      "type": "string"
    },
    "testingGroup": {
      "type": "string"
    },
    "channelId": {
      "type": "string"
    },
    "accessType": {
      "type": "string",
      "enum": ["TICKET", "SUBSCRIPTION", "FREE"]
    },
    "feedback": {
      "type": "object",
      "properties": {
        "rating": {
          "type": ["number", "null"]
        },
        "message": {
          "type": ["string", "null"]
        }
      },
      "required": ["rating", "message"]
    },
    "location": {
      "anyOf": [{
        "$ref": "UserLocation"
      }, {
        "type": "null"
      }]
    }
  },
  "required": ["type", "videoId", "eventId", "videoType", "isLive", "timestamp", "userId", "testingGroup", "channelId", "accessType", "feedback", "location"]
};
function validate144(data, {
  instancePath = "",
  parentData,
  parentDataProperty,
  rootData = data
} = {}) {
  let vErrors = null;
  let errors = 0;
  if (errors === 0) {
    if (data && typeof data == "object" && !Array.isArray(data)) {
      let missing0;
      if (data.type === void 0 && (missing0 = "type") || data.videoId === void 0 && (missing0 = "videoId") || data.eventId === void 0 && (missing0 = "eventId") || data.videoType === void 0 && (missing0 = "videoType") || data.isLive === void 0 && (missing0 = "isLive") || data.timestamp === void 0 && (missing0 = "timestamp") || data.userId === void 0 && (missing0 = "userId") || data.testingGroup === void 0 && (missing0 = "testingGroup") || data.channelId === void 0 && (missing0 = "channelId") || data.accessType === void 0 && (missing0 = "accessType") || data.feedback === void 0 && (missing0 = "feedback") || data.location === void 0 && (missing0 = "location")) {
        validate144.errors = [{
          instancePath,
          schemaPath: "#/required",
          keyword: "required",
          params: {
            missingProperty: missing0
          },
          message: "must have required property '" + missing0 + "'"
        }];
        return false;
      } else {
        if (data.type !== void 0) {
          let data0 = data.type;
          const _errs1 = errors;
          if (typeof data0 !== "string") {
            validate144.errors = [{
              instancePath: instancePath + "/type",
              schemaPath: "#/properties/type/type",
              keyword: "type",
              params: {
                type: "string"
              },
              message: "must be string"
            }];
            return false;
          }
          if ("VIDEO" !== data0) {
            validate144.errors = [{
              instancePath: instancePath + "/type",
              schemaPath: "#/properties/type/const",
              keyword: "const",
              params: {
                allowedValue: "VIDEO"
              },
              message: "must be equal to constant"
            }];
            return false;
          }
          var valid0 = _errs1 === errors;
        } else {
          var valid0 = true;
        }
        if (valid0) {
          if (data.videoId !== void 0) {
            const _errs3 = errors;
            if (typeof data.videoId !== "string") {
              validate144.errors = [{
                instancePath: instancePath + "/videoId",
                schemaPath: "#/properties/videoId/type",
                keyword: "type",
                params: {
                  type: "string"
                },
                message: "must be string"
              }];
              return false;
            }
            var valid0 = _errs3 === errors;
          } else {
            var valid0 = true;
          }
          if (valid0) {
            if (data.eventId !== void 0) {
              let data2 = data.eventId;
              const _errs5 = errors;
              if (typeof data2 !== "string" && data2 !== null) {
                validate144.errors = [{
                  instancePath: instancePath + "/eventId",
                  schemaPath: "#/properties/eventId/type",
                  keyword: "type",
                  params: {
                    type: schema151.properties.eventId.type
                  },
                  message: "must be string,null"
                }];
                return false;
              }
              var valid0 = _errs5 === errors;
            } else {
              var valid0 = true;
            }
            if (valid0) {
              if (data.videoType !== void 0) {
                let data3 = data.videoType;
                const _errs7 = errors;
                if (typeof data3 !== "string") {
                  validate144.errors = [{
                    instancePath: instancePath + "/videoType",
                    schemaPath: "#/properties/videoType/type",
                    keyword: "type",
                    params: {
                      type: "string"
                    },
                    message: "must be string"
                  }];
                  return false;
                }
                if (!(data3 === "SHORT" || data3 === "STREAM" || data3 === "UPLOAD")) {
                  validate144.errors = [{
                    instancePath: instancePath + "/videoType",
                    schemaPath: "#/properties/videoType/enum",
                    keyword: "enum",
                    params: {
                      allowedValues: schema151.properties.videoType.enum
                    },
                    message: "must be equal to one of the allowed values"
                  }];
                  return false;
                }
                var valid0 = _errs7 === errors;
              } else {
                var valid0 = true;
              }
              if (valid0) {
                if (data.isLive !== void 0) {
                  const _errs9 = errors;
                  if (typeof data.isLive !== "boolean") {
                    validate144.errors = [{
                      instancePath: instancePath + "/isLive",
                      schemaPath: "#/properties/isLive/type",
                      keyword: "type",
                      params: {
                        type: "boolean"
                      },
                      message: "must be boolean"
                    }];
                    return false;
                  }
                  var valid0 = _errs9 === errors;
                } else {
                  var valid0 = true;
                }
                if (valid0) {
                  if (data.timestamp !== void 0) {
                    let data5 = data.timestamp;
                    const _errs11 = errors;
                    if (!(data5 && typeof data5 == "object" && !Array.isArray(data5))) {
                      validate144.errors = [{
                        instancePath: instancePath + "/timestamp",
                        schemaPath: "#/properties/timestamp/type",
                        keyword: "type",
                        params: {
                          type: "object"
                        },
                        message: "must be object"
                      }];
                      return false;
                    }
                    if (errors === _errs11) {
                      if (errors === _errs11) {
                        if (typeof data5 === "string") {
                          if (!formats0(data5)) {
                            validate144.errors = [{
                              instancePath: instancePath + "/timestamp",
                              schemaPath: "#/properties/timestamp/format",
                              keyword: "format",
                              params: {
                                format: "date-time"
                              },
                              message: 'must match format "date-time"'
                            }];
                            return false;
                          }
                        }
                      }
                    }
                    var valid0 = _errs11 === errors;
                  } else {
                    var valid0 = true;
                  }
                  if (valid0) {
                    if (data.userId !== void 0) {
                      const _errs13 = errors;
                      if (typeof data.userId !== "string") {
                        validate144.errors = [{
                          instancePath: instancePath + "/userId",
                          schemaPath: "#/properties/userId/type",
                          keyword: "type",
                          params: {
                            type: "string"
                          },
                          message: "must be string"
                        }];
                        return false;
                      }
                      var valid0 = _errs13 === errors;
                    } else {
                      var valid0 = true;
                    }
                    if (valid0) {
                      if (data.testingGroup !== void 0) {
                        const _errs15 = errors;
                        if (typeof data.testingGroup !== "string") {
                          validate144.errors = [{
                            instancePath: instancePath + "/testingGroup",
                            schemaPath: "#/properties/testingGroup/type",
                            keyword: "type",
                            params: {
                              type: "string"
                            },
                            message: "must be string"
                          }];
                          return false;
                        }
                        var valid0 = _errs15 === errors;
                      } else {
                        var valid0 = true;
                      }
                      if (valid0) {
                        if (data.channelId !== void 0) {
                          const _errs17 = errors;
                          if (typeof data.channelId !== "string") {
                            validate144.errors = [{
                              instancePath: instancePath + "/channelId",
                              schemaPath: "#/properties/channelId/type",
                              keyword: "type",
                              params: {
                                type: "string"
                              },
                              message: "must be string"
                            }];
                            return false;
                          }
                          var valid0 = _errs17 === errors;
                        } else {
                          var valid0 = true;
                        }
                        if (valid0) {
                          if (data.accessType !== void 0) {
                            let data9 = data.accessType;
                            const _errs19 = errors;
                            if (typeof data9 !== "string") {
                              validate144.errors = [{
                                instancePath: instancePath + "/accessType",
                                schemaPath: "#/properties/accessType/type",
                                keyword: "type",
                                params: {
                                  type: "string"
                                },
                                message: "must be string"
                              }];
                              return false;
                            }
                            if (!(data9 === "TICKET" || data9 === "SUBSCRIPTION" || data9 === "FREE")) {
                              validate144.errors = [{
                                instancePath: instancePath + "/accessType",
                                schemaPath: "#/properties/accessType/enum",
                                keyword: "enum",
                                params: {
                                  allowedValues: schema151.properties.accessType.enum
                                },
                                message: "must be equal to one of the allowed values"
                              }];
                              return false;
                            }
                            var valid0 = _errs19 === errors;
                          } else {
                            var valid0 = true;
                          }
                          if (valid0) {
                            if (data.feedback !== void 0) {
                              let data10 = data.feedback;
                              const _errs21 = errors;
                              if (errors === _errs21) {
                                if (data10 && typeof data10 == "object" && !Array.isArray(data10)) {
                                  let missing1;
                                  if (data10.rating === void 0 && (missing1 = "rating") || data10.message === void 0 && (missing1 = "message")) {
                                    validate144.errors = [{
                                      instancePath: instancePath + "/feedback",
                                      schemaPath: "#/properties/feedback/required",
                                      keyword: "required",
                                      params: {
                                        missingProperty: missing1
                                      },
                                      message: "must have required property '" + missing1 + "'"
                                    }];
                                    return false;
                                  } else {
                                    if (data10.rating !== void 0) {
                                      let data11 = data10.rating;
                                      const _errs23 = errors;
                                      if (!(typeof data11 == "number" && isFinite(data11)) && data11 !== null) {
                                        validate144.errors = [{
                                          instancePath: instancePath + "/feedback/rating",
                                          schemaPath: "#/properties/feedback/properties/rating/type",
                                          keyword: "type",
                                          params: {
                                            type: schema151.properties.feedback.properties.rating.type
                                          },
                                          message: "must be number,null"
                                        }];
                                        return false;
                                      }
                                      var valid1 = _errs23 === errors;
                                    } else {
                                      var valid1 = true;
                                    }
                                    if (valid1) {
                                      if (data10.message !== void 0) {
                                        let data12 = data10.message;
                                        const _errs25 = errors;
                                        if (typeof data12 !== "string" && data12 !== null) {
                                          validate144.errors = [{
                                            instancePath: instancePath + "/feedback/message",
                                            schemaPath: "#/properties/feedback/properties/message/type",
                                            keyword: "type",
                                            params: {
                                              type: schema151.properties.feedback.properties.message.type
                                            },
                                            message: "must be string,null"
                                          }];
                                          return false;
                                        }
                                        var valid1 = _errs25 === errors;
                                      } else {
                                        var valid1 = true;
                                      }
                                    }
                                  }
                                } else {
                                  validate144.errors = [{
                                    instancePath: instancePath + "/feedback",
                                    schemaPath: "#/properties/feedback/type",
                                    keyword: "type",
                                    params: {
                                      type: "object"
                                    },
                                    message: "must be object"
                                  }];
                                  return false;
                                }
                              }
                              var valid0 = _errs21 === errors;
                            } else {
                              var valid0 = true;
                            }
                            if (valid0) {
                              if (data.location !== void 0) {
                                let data13 = data.location;
                                const _errs27 = errors;
                                const _errs28 = errors;
                                let valid2 = false;
                                const _errs29 = errors;
                                const _errs30 = errors;
                                if (errors === _errs30) {
                                  if (data13 && typeof data13 == "object" && !Array.isArray(data13)) {
                                    let missing2;
                                    if (data13.IP === void 0 && (missing2 = "IP") || data13.latlng === void 0 && (missing2 = "latlng") || data13.city === void 0 && (missing2 = "city") || data13.country === void 0 && (missing2 = "country") || data13.region === void 0 && (missing2 = "region")) {
                                      const err0 = {
                                        instancePath: instancePath + "/location",
                                        schemaPath: "UserLocation/required",
                                        keyword: "required",
                                        params: {
                                          missingProperty: missing2
                                        },
                                        message: "must have required property '" + missing2 + "'"
                                      };
                                      if (vErrors === null) {
                                        vErrors = [err0];
                                      } else {
                                        vErrors.push(err0);
                                      }
                                      errors++;
                                    } else {
                                      if (data13.IP !== void 0) {
                                        let data14 = data13.IP;
                                        const _errs32 = errors;
                                        if (typeof data14 !== "string" && data14 !== null) {
                                          const err1 = {
                                            instancePath: instancePath + "/location/IP",
                                            schemaPath: "UserLocation/properties/IP/type",
                                            keyword: "type",
                                            params: {
                                              type: schema47.properties.IP.type
                                            },
                                            message: "must be string,null"
                                          };
                                          if (vErrors === null) {
                                            vErrors = [err1];
                                          } else {
                                            vErrors.push(err1);
                                          }
                                          errors++;
                                        }
                                        var valid4 = _errs32 === errors;
                                      } else {
                                        var valid4 = true;
                                      }
                                      if (valid4) {
                                        if (data13.latlng !== void 0) {
                                          let data15 = data13.latlng;
                                          const _errs34 = errors;
                                          if (typeof data15 !== "string" && data15 !== null) {
                                            const err2 = {
                                              instancePath: instancePath + "/location/latlng",
                                              schemaPath: "UserLocation/properties/latlng/type",
                                              keyword: "type",
                                              params: {
                                                type: schema47.properties.latlng.type
                                              },
                                              message: "must be string,null"
                                            };
                                            if (vErrors === null) {
                                              vErrors = [err2];
                                            } else {
                                              vErrors.push(err2);
                                            }
                                            errors++;
                                          }
                                          var valid4 = _errs34 === errors;
                                        } else {
                                          var valid4 = true;
                                        }
                                        if (valid4) {
                                          if (data13.city !== void 0) {
                                            let data16 = data13.city;
                                            const _errs36 = errors;
                                            if (typeof data16 !== "string" && data16 !== null) {
                                              const err3 = {
                                                instancePath: instancePath + "/location/city",
                                                schemaPath: "UserLocation/properties/city/type",
                                                keyword: "type",
                                                params: {
                                                  type: schema47.properties.city.type
                                                },
                                                message: "must be string,null"
                                              };
                                              if (vErrors === null) {
                                                vErrors = [err3];
                                              } else {
                                                vErrors.push(err3);
                                              }
                                              errors++;
                                            }
                                            var valid4 = _errs36 === errors;
                                          } else {
                                            var valid4 = true;
                                          }
                                          if (valid4) {
                                            if (data13.country !== void 0) {
                                              let data17 = data13.country;
                                              const _errs38 = errors;
                                              if (typeof data17 !== "string" && data17 !== null) {
                                                const err4 = {
                                                  instancePath: instancePath + "/location/country",
                                                  schemaPath: "UserLocation/properties/country/type",
                                                  keyword: "type",
                                                  params: {
                                                    type: schema47.properties.country.type
                                                  },
                                                  message: "must be string,null"
                                                };
                                                if (vErrors === null) {
                                                  vErrors = [err4];
                                                } else {
                                                  vErrors.push(err4);
                                                }
                                                errors++;
                                              }
                                              var valid4 = _errs38 === errors;
                                            } else {
                                              var valid4 = true;
                                            }
                                            if (valid4) {
                                              if (data13.region !== void 0) {
                                                let data18 = data13.region;
                                                const _errs40 = errors;
                                                if (typeof data18 !== "string" && data18 !== null) {
                                                  const err5 = {
                                                    instancePath: instancePath + "/location/region",
                                                    schemaPath: "UserLocation/properties/region/type",
                                                    keyword: "type",
                                                    params: {
                                                      type: schema47.properties.region.type
                                                    },
                                                    message: "must be string,null"
                                                  };
                                                  if (vErrors === null) {
                                                    vErrors = [err5];
                                                  } else {
                                                    vErrors.push(err5);
                                                  }
                                                  errors++;
                                                }
                                                var valid4 = _errs40 === errors;
                                              } else {
                                                var valid4 = true;
                                              }
                                            }
                                          }
                                        }
                                      }
                                    }
                                  } else {
                                    const err6 = {
                                      instancePath: instancePath + "/location",
                                      schemaPath: "UserLocation/type",
                                      keyword: "type",
                                      params: {
                                        type: "object"
                                      },
                                      message: "must be object"
                                    };
                                    if (vErrors === null) {
                                      vErrors = [err6];
                                    } else {
                                      vErrors.push(err6);
                                    }
                                    errors++;
                                  }
                                }
                                var _valid0 = _errs29 === errors;
                                valid2 = valid2 || _valid0;
                                if (!valid2) {
                                  const _errs42 = errors;
                                  if (data13 !== null) {
                                    const err7 = {
                                      instancePath: instancePath + "/location",
                                      schemaPath: "#/properties/location/anyOf/1/type",
                                      keyword: "type",
                                      params: {
                                        type: "null"
                                      },
                                      message: "must be null"
                                    };
                                    if (vErrors === null) {
                                      vErrors = [err7];
                                    } else {
                                      vErrors.push(err7);
                                    }
                                    errors++;
                                  }
                                  var _valid0 = _errs42 === errors;
                                  valid2 = valid2 || _valid0;
                                }
                                if (!valid2) {
                                  const err8 = {
                                    instancePath: instancePath + "/location",
                                    schemaPath: "#/properties/location/anyOf",
                                    keyword: "anyOf",
                                    params: {},
                                    message: "must match a schema in anyOf"
                                  };
                                  if (vErrors === null) {
                                    vErrors = [err8];
                                  } else {
                                    vErrors.push(err8);
                                  }
                                  errors++;
                                  validate144.errors = vErrors;
                                  return false;
                                } else {
                                  errors = _errs28;
                                  if (vErrors !== null) {
                                    if (_errs28) {
                                      vErrors.length = _errs28;
                                    } else {
                                      vErrors = null;
                                    }
                                  }
                                }
                                var valid0 = _errs27 === errors;
                              } else {
                                var valid0 = true;
                              }
                            }
                          }
                        }
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
    } else {
      validate144.errors = [{
        instancePath,
        schemaPath: "#/type",
        keyword: "type",
        params: {
          type: "object"
        },
        message: "must be object"
      }];
      return false;
    }
  }
  validate144.errors = vErrors;
  return errors === 0;
}
const SaveFeedbackRequest = validate145;
const schema153 = {
  "$id": "SaveFeedbackRequest",
  "$schema": "http://json-schema.org/draft-07/schema#",
  "type": "object",
  "properties": {
    "type": {
      "type": "string",
      "const": "VIDEO"
    },
    "videoId": {
      "type": "string"
    },
    "eventId": {
      "type": ["string", "null"]
    },
    "videoType": {
      "type": "string",
      "enum": ["SHORT", "STREAM", "UPLOAD"]
    },
    "isLive": {
      "type": "boolean"
    },
    "testingGroup": {
      "type": "string"
    },
    "channelId": {
      "type": "string"
    },
    "accessType": {
      "type": "string",
      "enum": ["TICKET", "SUBSCRIPTION", "FREE"]
    },
    "feedback": {
      "type": "object",
      "properties": {
        "rating": {
          "type": ["number", "null"]
        },
        "message": {
          "type": ["string", "null"]
        }
      },
      "required": ["rating", "message"]
    }
  },
  "required": ["type", "videoId", "eventId", "videoType", "isLive", "testingGroup", "channelId", "accessType", "feedback"]
};
function validate145(data, {
  instancePath = "",
  parentData,
  parentDataProperty,
  rootData = data
} = {}) {
  let vErrors = null;
  let errors = 0;
  {
    if (data && typeof data == "object" && !Array.isArray(data)) {
      let missing0;
      if (data.type === void 0 && (missing0 = "type") || data.videoId === void 0 && (missing0 = "videoId") || data.eventId === void 0 && (missing0 = "eventId") || data.videoType === void 0 && (missing0 = "videoType") || data.isLive === void 0 && (missing0 = "isLive") || data.testingGroup === void 0 && (missing0 = "testingGroup") || data.channelId === void 0 && (missing0 = "channelId") || data.accessType === void 0 && (missing0 = "accessType") || data.feedback === void 0 && (missing0 = "feedback")) {
        validate145.errors = [{
          instancePath,
          schemaPath: "#/required",
          keyword: "required",
          params: {
            missingProperty: missing0
          },
          message: "must have required property '" + missing0 + "'"
        }];
        return false;
      } else {
        if (data.type !== void 0) {
          let data0 = data.type;
          const _errs1 = errors;
          if (typeof data0 !== "string") {
            validate145.errors = [{
              instancePath: instancePath + "/type",
              schemaPath: "#/properties/type/type",
              keyword: "type",
              params: {
                type: "string"
              },
              message: "must be string"
            }];
            return false;
          }
          if ("VIDEO" !== data0) {
            validate145.errors = [{
              instancePath: instancePath + "/type",
              schemaPath: "#/properties/type/const",
              keyword: "const",
              params: {
                allowedValue: "VIDEO"
              },
              message: "must be equal to constant"
            }];
            return false;
          }
          var valid0 = _errs1 === errors;
        } else {
          var valid0 = true;
        }
        if (valid0) {
          if (data.videoId !== void 0) {
            const _errs3 = errors;
            if (typeof data.videoId !== "string") {
              validate145.errors = [{
                instancePath: instancePath + "/videoId",
                schemaPath: "#/properties/videoId/type",
                keyword: "type",
                params: {
                  type: "string"
                },
                message: "must be string"
              }];
              return false;
            }
            var valid0 = _errs3 === errors;
          } else {
            var valid0 = true;
          }
          if (valid0) {
            if (data.eventId !== void 0) {
              let data2 = data.eventId;
              const _errs5 = errors;
              if (typeof data2 !== "string" && data2 !== null) {
                validate145.errors = [{
                  instancePath: instancePath + "/eventId",
                  schemaPath: "#/properties/eventId/type",
                  keyword: "type",
                  params: {
                    type: schema153.properties.eventId.type
                  },
                  message: "must be string,null"
                }];
                return false;
              }
              var valid0 = _errs5 === errors;
            } else {
              var valid0 = true;
            }
            if (valid0) {
              if (data.videoType !== void 0) {
                let data3 = data.videoType;
                const _errs7 = errors;
                if (typeof data3 !== "string") {
                  validate145.errors = [{
                    instancePath: instancePath + "/videoType",
                    schemaPath: "#/properties/videoType/type",
                    keyword: "type",
                    params: {
                      type: "string"
                    },
                    message: "must be string"
                  }];
                  return false;
                }
                if (!(data3 === "SHORT" || data3 === "STREAM" || data3 === "UPLOAD")) {
                  validate145.errors = [{
                    instancePath: instancePath + "/videoType",
                    schemaPath: "#/properties/videoType/enum",
                    keyword: "enum",
                    params: {
                      allowedValues: schema153.properties.videoType.enum
                    },
                    message: "must be equal to one of the allowed values"
                  }];
                  return false;
                }
                var valid0 = _errs7 === errors;
              } else {
                var valid0 = true;
              }
              if (valid0) {
                if (data.isLive !== void 0) {
                  const _errs9 = errors;
                  if (typeof data.isLive !== "boolean") {
                    validate145.errors = [{
                      instancePath: instancePath + "/isLive",
                      schemaPath: "#/properties/isLive/type",
                      keyword: "type",
                      params: {
                        type: "boolean"
                      },
                      message: "must be boolean"
                    }];
                    return false;
                  }
                  var valid0 = _errs9 === errors;
                } else {
                  var valid0 = true;
                }
                if (valid0) {
                  if (data.testingGroup !== void 0) {
                    const _errs11 = errors;
                    if (typeof data.testingGroup !== "string") {
                      validate145.errors = [{
                        instancePath: instancePath + "/testingGroup",
                        schemaPath: "#/properties/testingGroup/type",
                        keyword: "type",
                        params: {
                          type: "string"
                        },
                        message: "must be string"
                      }];
                      return false;
                    }
                    var valid0 = _errs11 === errors;
                  } else {
                    var valid0 = true;
                  }
                  if (valid0) {
                    if (data.channelId !== void 0) {
                      const _errs13 = errors;
                      if (typeof data.channelId !== "string") {
                        validate145.errors = [{
                          instancePath: instancePath + "/channelId",
                          schemaPath: "#/properties/channelId/type",
                          keyword: "type",
                          params: {
                            type: "string"
                          },
                          message: "must be string"
                        }];
                        return false;
                      }
                      var valid0 = _errs13 === errors;
                    } else {
                      var valid0 = true;
                    }
                    if (valid0) {
                      if (data.accessType !== void 0) {
                        let data7 = data.accessType;
                        const _errs15 = errors;
                        if (typeof data7 !== "string") {
                          validate145.errors = [{
                            instancePath: instancePath + "/accessType",
                            schemaPath: "#/properties/accessType/type",
                            keyword: "type",
                            params: {
                              type: "string"
                            },
                            message: "must be string"
                          }];
                          return false;
                        }
                        if (!(data7 === "TICKET" || data7 === "SUBSCRIPTION" || data7 === "FREE")) {
                          validate145.errors = [{
                            instancePath: instancePath + "/accessType",
                            schemaPath: "#/properties/accessType/enum",
                            keyword: "enum",
                            params: {
                              allowedValues: schema153.properties.accessType.enum
                            },
                            message: "must be equal to one of the allowed values"
                          }];
                          return false;
                        }
                        var valid0 = _errs15 === errors;
                      } else {
                        var valid0 = true;
                      }
                      if (valid0) {
                        if (data.feedback !== void 0) {
                          let data8 = data.feedback;
                          const _errs17 = errors;
                          {
                            if (data8 && typeof data8 == "object" && !Array.isArray(data8)) {
                              let missing1;
                              if (data8.rating === void 0 && (missing1 = "rating") || data8.message === void 0 && (missing1 = "message")) {
                                validate145.errors = [{
                                  instancePath: instancePath + "/feedback",
                                  schemaPath: "#/properties/feedback/required",
                                  keyword: "required",
                                  params: {
                                    missingProperty: missing1
                                  },
                                  message: "must have required property '" + missing1 + "'"
                                }];
                                return false;
                              } else {
                                if (data8.rating !== void 0) {
                                  let data9 = data8.rating;
                                  const _errs19 = errors;
                                  if (!(typeof data9 == "number" && isFinite(data9)) && data9 !== null) {
                                    validate145.errors = [{
                                      instancePath: instancePath + "/feedback/rating",
                                      schemaPath: "#/properties/feedback/properties/rating/type",
                                      keyword: "type",
                                      params: {
                                        type: schema153.properties.feedback.properties.rating.type
                                      },
                                      message: "must be number,null"
                                    }];
                                    return false;
                                  }
                                  var valid1 = _errs19 === errors;
                                } else {
                                  var valid1 = true;
                                }
                                if (valid1) {
                                  if (data8.message !== void 0) {
                                    let data10 = data8.message;
                                    const _errs21 = errors;
                                    if (typeof data10 !== "string" && data10 !== null) {
                                      validate145.errors = [{
                                        instancePath: instancePath + "/feedback/message",
                                        schemaPath: "#/properties/feedback/properties/message/type",
                                        keyword: "type",
                                        params: {
                                          type: schema153.properties.feedback.properties.message.type
                                        },
                                        message: "must be string,null"
                                      }];
                                      return false;
                                    }
                                    var valid1 = _errs21 === errors;
                                  } else {
                                    var valid1 = true;
                                  }
                                }
                              }
                            } else {
                              validate145.errors = [{
                                instancePath: instancePath + "/feedback",
                                schemaPath: "#/properties/feedback/type",
                                keyword: "type",
                                params: {
                                  type: "object"
                                },
                                message: "must be object"
                              }];
                              return false;
                            }
                          }
                          var valid0 = _errs17 === errors;
                        } else {
                          var valid0 = true;
                        }
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
    } else {
      validate145.errors = [{
        instancePath,
        schemaPath: "#/type",
        keyword: "type",
        params: {
          type: "object"
        },
        message: "must be object"
      }];
      return false;
    }
  }
  validate145.errors = vErrors;
  return errors === 0;
}
const SaveFeedbackSuccessfulResponse = validate146;
function validate146(data, {
  instancePath = "",
  parentData,
  parentDataProperty,
  rootData = data
} = {}) {
  let vErrors = null;
  let errors = 0;
  {
    if (data && typeof data == "object" && !Array.isArray(data)) {
      let missing0;
      if (data.success === void 0 && (missing0 = "success") || data.feedbackId === void 0 && (missing0 = "feedbackId")) {
        validate146.errors = [{
          instancePath,
          schemaPath: "#/required",
          keyword: "required",
          params: {
            missingProperty: missing0
          },
          message: "must have required property '" + missing0 + "'"
        }];
        return false;
      } else {
        if (data.success !== void 0) {
          let data0 = data.success;
          const _errs1 = errors;
          if (typeof data0 !== "boolean") {
            validate146.errors = [{
              instancePath: instancePath + "/success",
              schemaPath: "#/properties/success/type",
              keyword: "type",
              params: {
                type: "boolean"
              },
              message: "must be boolean"
            }];
            return false;
          }
          if (true !== data0) {
            validate146.errors = [{
              instancePath: instancePath + "/success",
              schemaPath: "#/properties/success/const",
              keyword: "const",
              params: {
                allowedValue: true
              },
              message: "must be equal to constant"
            }];
            return false;
          }
          var valid0 = _errs1 === errors;
        } else {
          var valid0 = true;
        }
        if (valid0) {
          if (data.feedbackId !== void 0) {
            const _errs3 = errors;
            if (typeof data.feedbackId !== "string") {
              validate146.errors = [{
                instancePath: instancePath + "/feedbackId",
                schemaPath: "#/properties/feedbackId/type",
                keyword: "type",
                params: {
                  type: "string"
                },
                message: "must be string"
              }];
              return false;
            }
            var valid0 = _errs3 === errors;
          } else {
            var valid0 = true;
          }
        }
      }
    } else {
      validate146.errors = [{
        instancePath,
        schemaPath: "#/type",
        keyword: "type",
        params: {
          type: "object"
        },
        message: "must be object"
      }];
      return false;
    }
  }
  validate146.errors = vErrors;
  return errors === 0;
}
const SaveFeedbackErrorResponse = validate147;
function validate147(data, {
  instancePath = "",
  parentData,
  parentDataProperty,
  rootData = data
} = {}) {
  let vErrors = null;
  let errors = 0;
  {
    if (data && typeof data == "object" && !Array.isArray(data)) {
      let missing0;
      if (data.success === void 0 && (missing0 = "success") || data.error === void 0 && (missing0 = "error")) {
        validate147.errors = [{
          instancePath,
          schemaPath: "#/required",
          keyword: "required",
          params: {
            missingProperty: missing0
          },
          message: "must have required property '" + missing0 + "'"
        }];
        return false;
      } else {
        if (data.success !== void 0) {
          let data0 = data.success;
          const _errs1 = errors;
          if (typeof data0 !== "boolean") {
            validate147.errors = [{
              instancePath: instancePath + "/success",
              schemaPath: "#/properties/success/type",
              keyword: "type",
              params: {
                type: "boolean"
              },
              message: "must be boolean"
            }];
            return false;
          }
          if (false !== data0) {
            validate147.errors = [{
              instancePath: instancePath + "/success",
              schemaPath: "#/properties/success/const",
              keyword: "const",
              params: {
                allowedValue: false
              },
              message: "must be equal to constant"
            }];
            return false;
          }
          var valid0 = _errs1 === errors;
        } else {
          var valid0 = true;
        }
        if (valid0) {
          if (data.error !== void 0) {
            const _errs3 = errors;
            if (typeof data.error !== "string") {
              validate147.errors = [{
                instancePath: instancePath + "/error",
                schemaPath: "#/properties/error/type",
                keyword: "type",
                params: {
                  type: "string"
                },
                message: "must be string"
              }];
              return false;
            }
            var valid0 = _errs3 === errors;
          } else {
            var valid0 = true;
          }
        }
      }
    } else {
      validate147.errors = [{
        instancePath,
        schemaPath: "#/type",
        keyword: "type",
        params: {
          type: "object"
        },
        message: "must be object"
      }];
      return false;
    }
  }
  validate147.errors = vErrors;
  return errors === 0;
}
const SaveFeedbackResponse = validate148;
function validate148(data, {
  instancePath = "",
  parentData,
  parentDataProperty,
  rootData = data
} = {}) {
  let vErrors = null;
  let errors = 0;
  const _errs0 = errors;
  let valid0 = false;
  const _errs1 = errors;
  const _errs2 = errors;
  if (errors === _errs2) {
    if (data && typeof data == "object" && !Array.isArray(data)) {
      let missing0;
      if (data.success === void 0 && (missing0 = "success") || data.feedbackId === void 0 && (missing0 = "feedbackId")) {
        const err0 = {
          instancePath,
          schemaPath: "SaveFeedbackSuccessfulResponse/required",
          keyword: "required",
          params: {
            missingProperty: missing0
          },
          message: "must have required property '" + missing0 + "'"
        };
        if (vErrors === null) {
          vErrors = [err0];
        } else {
          vErrors.push(err0);
        }
        errors++;
      } else {
        if (data.success !== void 0) {
          let data0 = data.success;
          const _errs4 = errors;
          if (typeof data0 !== "boolean") {
            const err1 = {
              instancePath: instancePath + "/success",
              schemaPath: "SaveFeedbackSuccessfulResponse/properties/success/type",
              keyword: "type",
              params: {
                type: "boolean"
              },
              message: "must be boolean"
            };
            if (vErrors === null) {
              vErrors = [err1];
            } else {
              vErrors.push(err1);
            }
            errors++;
          }
          if (true !== data0) {
            const err2 = {
              instancePath: instancePath + "/success",
              schemaPath: "SaveFeedbackSuccessfulResponse/properties/success/const",
              keyword: "const",
              params: {
                allowedValue: true
              },
              message: "must be equal to constant"
            };
            if (vErrors === null) {
              vErrors = [err2];
            } else {
              vErrors.push(err2);
            }
            errors++;
          }
          var valid2 = _errs4 === errors;
        } else {
          var valid2 = true;
        }
        if (valid2) {
          if (data.feedbackId !== void 0) {
            const _errs6 = errors;
            if (typeof data.feedbackId !== "string") {
              const err3 = {
                instancePath: instancePath + "/feedbackId",
                schemaPath: "SaveFeedbackSuccessfulResponse/properties/feedbackId/type",
                keyword: "type",
                params: {
                  type: "string"
                },
                message: "must be string"
              };
              if (vErrors === null) {
                vErrors = [err3];
              } else {
                vErrors.push(err3);
              }
              errors++;
            }
            var valid2 = _errs6 === errors;
          } else {
            var valid2 = true;
          }
        }
      }
    } else {
      const err4 = {
        instancePath,
        schemaPath: "SaveFeedbackSuccessfulResponse/type",
        keyword: "type",
        params: {
          type: "object"
        },
        message: "must be object"
      };
      if (vErrors === null) {
        vErrors = [err4];
      } else {
        vErrors.push(err4);
      }
      errors++;
    }
  }
  var _valid0 = _errs1 === errors;
  valid0 = valid0 || _valid0;
  if (!valid0) {
    const _errs8 = errors;
    const _errs9 = errors;
    if (errors === _errs9) {
      if (data && typeof data == "object" && !Array.isArray(data)) {
        let missing1;
        if (data.success === void 0 && (missing1 = "success") || data.error === void 0 && (missing1 = "error")) {
          const err5 = {
            instancePath,
            schemaPath: "SaveFeedbackErrorResponse/required",
            keyword: "required",
            params: {
              missingProperty: missing1
            },
            message: "must have required property '" + missing1 + "'"
          };
          if (vErrors === null) {
            vErrors = [err5];
          } else {
            vErrors.push(err5);
          }
          errors++;
        } else {
          if (data.success !== void 0) {
            let data2 = data.success;
            const _errs11 = errors;
            if (typeof data2 !== "boolean") {
              const err6 = {
                instancePath: instancePath + "/success",
                schemaPath: "SaveFeedbackErrorResponse/properties/success/type",
                keyword: "type",
                params: {
                  type: "boolean"
                },
                message: "must be boolean"
              };
              if (vErrors === null) {
                vErrors = [err6];
              } else {
                vErrors.push(err6);
              }
              errors++;
            }
            if (false !== data2) {
              const err7 = {
                instancePath: instancePath + "/success",
                schemaPath: "SaveFeedbackErrorResponse/properties/success/const",
                keyword: "const",
                params: {
                  allowedValue: false
                },
                message: "must be equal to constant"
              };
              if (vErrors === null) {
                vErrors = [err7];
              } else {
                vErrors.push(err7);
              }
              errors++;
            }
            var valid4 = _errs11 === errors;
          } else {
            var valid4 = true;
          }
          if (valid4) {
            if (data.error !== void 0) {
              const _errs13 = errors;
              if (typeof data.error !== "string") {
                const err8 = {
                  instancePath: instancePath + "/error",
                  schemaPath: "SaveFeedbackErrorResponse/properties/error/type",
                  keyword: "type",
                  params: {
                    type: "string"
                  },
                  message: "must be string"
                };
                if (vErrors === null) {
                  vErrors = [err8];
                } else {
                  vErrors.push(err8);
                }
                errors++;
              }
              var valid4 = _errs13 === errors;
            } else {
              var valid4 = true;
            }
          }
        }
      } else {
        const err9 = {
          instancePath,
          schemaPath: "SaveFeedbackErrorResponse/type",
          keyword: "type",
          params: {
            type: "object"
          },
          message: "must be object"
        };
        if (vErrors === null) {
          vErrors = [err9];
        } else {
          vErrors.push(err9);
        }
        errors++;
      }
    }
    var _valid0 = _errs8 === errors;
    valid0 = valid0 || _valid0;
  }
  if (!valid0) {
    const err10 = {
      instancePath,
      schemaPath: "#/anyOf",
      keyword: "anyOf",
      params: {},
      message: "must match a schema in anyOf"
    };
    if (vErrors === null) {
      vErrors = [err10];
    } else {
      vErrors.push(err10);
    }
    errors++;
    validate148.errors = vErrors;
    return false;
  } else {
    errors = _errs0;
    if (vErrors !== null) {
      if (_errs0) {
        vErrors.length = _errs0;
      } else {
        vErrors = null;
      }
    }
  }
  validate148.errors = vErrors;
  return errors === 0;
}
const PlanScope = validate149;
const schema159 = {
  "$id": "PlanScope",
  "$schema": "http://json-schema.org/draft-07/schema#",
  "type": "object",
  "properties": {
    "initialCoverage": {
      "type": ["boolean", "null"]
    },
    "tags": {
      "anyOf": [{
        "type": "object",
        "properties": {
          "kind": {
            "type": "string",
            "enum": ["ALL", "SOME"]
          },
          "list": {
            "type": "array",
            "items": {
              "type": "string"
            }
          }
        },
        "required": ["kind", "list"]
      }, {
        "type": "null"
      }]
    },
    "excludeTags": {
      "anyOf": [{
        "type": "object",
        "properties": {
          "kind": {
            "type": "string",
            "enum": ["ALL", "SOME"]
          },
          "list": {
            "type": "array",
            "items": {
              "type": "string"
            }
          }
        },
        "required": ["kind", "list"]
      }, {
        "type": "null"
      }]
    },
    "attributes": {
      "anyOf": [{
        "type": "object",
        "properties": {
          "kind": {
            "type": "string",
            "enum": ["ALL", "SOME"]
          },
          "list": {
            "type": "array",
            "items": {
              "type": "string"
            }
          }
        },
        "required": ["kind", "list"]
      }, {
        "type": "null"
      }]
    },
    "excludeAttributes": {
      "anyOf": [{
        "type": "object",
        "properties": {
          "kind": {
            "type": "string",
            "enum": ["ALL", "SOME"]
          },
          "list": {
            "type": "array",
            "items": {
              "type": "string"
            }
          }
        },
        "required": ["kind", "list"]
      }, {
        "type": "null"
      }]
    },
    "predicateCombination": {
      "type": ["string", "null"],
      "enum": ["OR", "AND", null]
    },
    "includedPlans": {
      "anyOf": [{
        "type": "array",
        "items": {
          "type": "string"
        }
      }, {
        "type": "null"
      }]
    }
  },
  "description": 'Defines which videos a subscription would give you access to. The algorithm to determine if a video or event is allowed or denied is as follows:\n\n1. If `initialCoverage` is defined, use that value as a starting point to determine if the video or event is covered. Assume the value to be **true** if not defined. 2. Video Coverage Check:     1. If `tags` is defined, check if the video has the specified tags,        If it does, assume the ***video coverage check" coverage is true***, else use the        ***coverage from previous steps***.     2. if `excludeTags` is defined, check if the video has the specified tags,        If it does, assume the ***video coverage check" coverage is false***, else use the        ***coverage from previous steps***.     3. if `attributes` is defined, check if the video defines the specified attributes.        If it does, assume the ***video coverage check" coverage is true***, else use the        ***coverage from previous steps***.        List is a list of string with the following format: `\u201Cattr[0-3]:.+"` for example        `["attr0:value","attr0:value2", "attr2:valueX"]` where `attr?` is the custom        attribute type, and `value` is one of the allowed values for that specific attribute type.     4. if `excludeAttributes` is defined, check if the video defines the the specified        attributes. If it does, assume the ***attribute coverage is false***, else use        the ***coverage from previous steps***. The list follows the same format as in for the step 2.3. 3. Event Coverage Check     1. Check if the event itself defines the `Event#includedInPlans` property. If it does and        the current plan is listed. Consider the ***event coverage to be true***, else use        the ***initial coverage***.     2. Check if the event defines the `Event#excludedFromPlans` property. If it does and the current        plan is listed. Consider the ***event coverage to be false***, else use        the ***initial coverage***. 4. Use the `predicateCombination` operator to determine how to combine the results from    the *video coverage check* (step 2) and *event coverage check* (from step 3).    if `predicateCombination===null` then consider it as an `OR`. 5. If step 4 returns false: check recursively the included plans and return ***true***    ***only if at least one of the sub plans returns positive coverage***.'
};
function validate149(data, {
  instancePath = "",
  parentData,
  parentDataProperty,
  rootData = data
} = {}) {
  let vErrors = null;
  let errors = 0;
  if (errors === 0) {
    if (data && typeof data == "object" && !Array.isArray(data)) {
      if (data.initialCoverage !== void 0) {
        let data0 = data.initialCoverage;
        const _errs1 = errors;
        if (typeof data0 !== "boolean" && data0 !== null) {
          validate149.errors = [{
            instancePath: instancePath + "/initialCoverage",
            schemaPath: "#/properties/initialCoverage/type",
            keyword: "type",
            params: {
              type: schema159.properties.initialCoverage.type
            },
            message: "must be boolean,null"
          }];
          return false;
        }
        var valid0 = _errs1 === errors;
      } else {
        var valid0 = true;
      }
      if (valid0) {
        if (data.tags !== void 0) {
          let data1 = data.tags;
          const _errs3 = errors;
          const _errs4 = errors;
          let valid1 = false;
          const _errs5 = errors;
          if (errors === _errs5) {
            if (data1 && typeof data1 == "object" && !Array.isArray(data1)) {
              let missing0;
              if (data1.kind === void 0 && (missing0 = "kind") || data1.list === void 0 && (missing0 = "list")) {
                const err0 = {
                  instancePath: instancePath + "/tags",
                  schemaPath: "#/properties/tags/anyOf/0/required",
                  keyword: "required",
                  params: {
                    missingProperty: missing0
                  },
                  message: "must have required property '" + missing0 + "'"
                };
                if (vErrors === null) {
                  vErrors = [err0];
                } else {
                  vErrors.push(err0);
                }
                errors++;
              } else {
                if (data1.kind !== void 0) {
                  let data2 = data1.kind;
                  const _errs7 = errors;
                  if (typeof data2 !== "string") {
                    const err1 = {
                      instancePath: instancePath + "/tags/kind",
                      schemaPath: "#/properties/tags/anyOf/0/properties/kind/type",
                      keyword: "type",
                      params: {
                        type: "string"
                      },
                      message: "must be string"
                    };
                    if (vErrors === null) {
                      vErrors = [err1];
                    } else {
                      vErrors.push(err1);
                    }
                    errors++;
                  }
                  if (!(data2 === "ALL" || data2 === "SOME")) {
                    const err2 = {
                      instancePath: instancePath + "/tags/kind",
                      schemaPath: "#/properties/tags/anyOf/0/properties/kind/enum",
                      keyword: "enum",
                      params: {
                        allowedValues: schema159.properties.tags.anyOf[0].properties.kind.enum
                      },
                      message: "must be equal to one of the allowed values"
                    };
                    if (vErrors === null) {
                      vErrors = [err2];
                    } else {
                      vErrors.push(err2);
                    }
                    errors++;
                  }
                  var valid2 = _errs7 === errors;
                } else {
                  var valid2 = true;
                }
                if (valid2) {
                  if (data1.list !== void 0) {
                    let data3 = data1.list;
                    const _errs9 = errors;
                    if (errors === _errs9) {
                      if (Array.isArray(data3)) {
                        var valid3 = true;
                        const len0 = data3.length;
                        for (let i0 = 0; i0 < len0; i0++) {
                          const _errs11 = errors;
                          if (typeof data3[i0] !== "string") {
                            const err3 = {
                              instancePath: instancePath + "/tags/list/" + i0,
                              schemaPath: "#/properties/tags/anyOf/0/properties/list/items/type",
                              keyword: "type",
                              params: {
                                type: "string"
                              },
                              message: "must be string"
                            };
                            if (vErrors === null) {
                              vErrors = [err3];
                            } else {
                              vErrors.push(err3);
                            }
                            errors++;
                          }
                          var valid3 = _errs11 === errors;
                          if (!valid3) {
                            break;
                          }
                        }
                      } else {
                        const err4 = {
                          instancePath: instancePath + "/tags/list",
                          schemaPath: "#/properties/tags/anyOf/0/properties/list/type",
                          keyword: "type",
                          params: {
                            type: "array"
                          },
                          message: "must be array"
                        };
                        if (vErrors === null) {
                          vErrors = [err4];
                        } else {
                          vErrors.push(err4);
                        }
                        errors++;
                      }
                    }
                    var valid2 = _errs9 === errors;
                  } else {
                    var valid2 = true;
                  }
                }
              }
            } else {
              const err5 = {
                instancePath: instancePath + "/tags",
                schemaPath: "#/properties/tags/anyOf/0/type",
                keyword: "type",
                params: {
                  type: "object"
                },
                message: "must be object"
              };
              if (vErrors === null) {
                vErrors = [err5];
              } else {
                vErrors.push(err5);
              }
              errors++;
            }
          }
          var _valid0 = _errs5 === errors;
          valid1 = valid1 || _valid0;
          if (!valid1) {
            const _errs13 = errors;
            if (data1 !== null) {
              const err6 = {
                instancePath: instancePath + "/tags",
                schemaPath: "#/properties/tags/anyOf/1/type",
                keyword: "type",
                params: {
                  type: "null"
                },
                message: "must be null"
              };
              if (vErrors === null) {
                vErrors = [err6];
              } else {
                vErrors.push(err6);
              }
              errors++;
            }
            var _valid0 = _errs13 === errors;
            valid1 = valid1 || _valid0;
          }
          if (!valid1) {
            const err7 = {
              instancePath: instancePath + "/tags",
              schemaPath: "#/properties/tags/anyOf",
              keyword: "anyOf",
              params: {},
              message: "must match a schema in anyOf"
            };
            if (vErrors === null) {
              vErrors = [err7];
            } else {
              vErrors.push(err7);
            }
            errors++;
            validate149.errors = vErrors;
            return false;
          } else {
            errors = _errs4;
            if (vErrors !== null) {
              if (_errs4) {
                vErrors.length = _errs4;
              } else {
                vErrors = null;
              }
            }
          }
          var valid0 = _errs3 === errors;
        } else {
          var valid0 = true;
        }
        if (valid0) {
          if (data.excludeTags !== void 0) {
            let data5 = data.excludeTags;
            const _errs15 = errors;
            const _errs16 = errors;
            let valid4 = false;
            const _errs17 = errors;
            if (errors === _errs17) {
              if (data5 && typeof data5 == "object" && !Array.isArray(data5)) {
                let missing1;
                if (data5.kind === void 0 && (missing1 = "kind") || data5.list === void 0 && (missing1 = "list")) {
                  const err8 = {
                    instancePath: instancePath + "/excludeTags",
                    schemaPath: "#/properties/excludeTags/anyOf/0/required",
                    keyword: "required",
                    params: {
                      missingProperty: missing1
                    },
                    message: "must have required property '" + missing1 + "'"
                  };
                  if (vErrors === null) {
                    vErrors = [err8];
                  } else {
                    vErrors.push(err8);
                  }
                  errors++;
                } else {
                  if (data5.kind !== void 0) {
                    let data6 = data5.kind;
                    const _errs19 = errors;
                    if (typeof data6 !== "string") {
                      const err9 = {
                        instancePath: instancePath + "/excludeTags/kind",
                        schemaPath: "#/properties/excludeTags/anyOf/0/properties/kind/type",
                        keyword: "type",
                        params: {
                          type: "string"
                        },
                        message: "must be string"
                      };
                      if (vErrors === null) {
                        vErrors = [err9];
                      } else {
                        vErrors.push(err9);
                      }
                      errors++;
                    }
                    if (!(data6 === "ALL" || data6 === "SOME")) {
                      const err10 = {
                        instancePath: instancePath + "/excludeTags/kind",
                        schemaPath: "#/properties/excludeTags/anyOf/0/properties/kind/enum",
                        keyword: "enum",
                        params: {
                          allowedValues: schema159.properties.excludeTags.anyOf[0].properties.kind.enum
                        },
                        message: "must be equal to one of the allowed values"
                      };
                      if (vErrors === null) {
                        vErrors = [err10];
                      } else {
                        vErrors.push(err10);
                      }
                      errors++;
                    }
                    var valid5 = _errs19 === errors;
                  } else {
                    var valid5 = true;
                  }
                  if (valid5) {
                    if (data5.list !== void 0) {
                      let data7 = data5.list;
                      const _errs21 = errors;
                      if (errors === _errs21) {
                        if (Array.isArray(data7)) {
                          var valid6 = true;
                          const len1 = data7.length;
                          for (let i1 = 0; i1 < len1; i1++) {
                            const _errs23 = errors;
                            if (typeof data7[i1] !== "string") {
                              const err11 = {
                                instancePath: instancePath + "/excludeTags/list/" + i1,
                                schemaPath: "#/properties/excludeTags/anyOf/0/properties/list/items/type",
                                keyword: "type",
                                params: {
                                  type: "string"
                                },
                                message: "must be string"
                              };
                              if (vErrors === null) {
                                vErrors = [err11];
                              } else {
                                vErrors.push(err11);
                              }
                              errors++;
                            }
                            var valid6 = _errs23 === errors;
                            if (!valid6) {
                              break;
                            }
                          }
                        } else {
                          const err12 = {
                            instancePath: instancePath + "/excludeTags/list",
                            schemaPath: "#/properties/excludeTags/anyOf/0/properties/list/type",
                            keyword: "type",
                            params: {
                              type: "array"
                            },
                            message: "must be array"
                          };
                          if (vErrors === null) {
                            vErrors = [err12];
                          } else {
                            vErrors.push(err12);
                          }
                          errors++;
                        }
                      }
                      var valid5 = _errs21 === errors;
                    } else {
                      var valid5 = true;
                    }
                  }
                }
              } else {
                const err13 = {
                  instancePath: instancePath + "/excludeTags",
                  schemaPath: "#/properties/excludeTags/anyOf/0/type",
                  keyword: "type",
                  params: {
                    type: "object"
                  },
                  message: "must be object"
                };
                if (vErrors === null) {
                  vErrors = [err13];
                } else {
                  vErrors.push(err13);
                }
                errors++;
              }
            }
            var _valid1 = _errs17 === errors;
            valid4 = valid4 || _valid1;
            if (!valid4) {
              const _errs25 = errors;
              if (data5 !== null) {
                const err14 = {
                  instancePath: instancePath + "/excludeTags",
                  schemaPath: "#/properties/excludeTags/anyOf/1/type",
                  keyword: "type",
                  params: {
                    type: "null"
                  },
                  message: "must be null"
                };
                if (vErrors === null) {
                  vErrors = [err14];
                } else {
                  vErrors.push(err14);
                }
                errors++;
              }
              var _valid1 = _errs25 === errors;
              valid4 = valid4 || _valid1;
            }
            if (!valid4) {
              const err15 = {
                instancePath: instancePath + "/excludeTags",
                schemaPath: "#/properties/excludeTags/anyOf",
                keyword: "anyOf",
                params: {},
                message: "must match a schema in anyOf"
              };
              if (vErrors === null) {
                vErrors = [err15];
              } else {
                vErrors.push(err15);
              }
              errors++;
              validate149.errors = vErrors;
              return false;
            } else {
              errors = _errs16;
              if (vErrors !== null) {
                if (_errs16) {
                  vErrors.length = _errs16;
                } else {
                  vErrors = null;
                }
              }
            }
            var valid0 = _errs15 === errors;
          } else {
            var valid0 = true;
          }
          if (valid0) {
            if (data.attributes !== void 0) {
              let data9 = data.attributes;
              const _errs27 = errors;
              const _errs28 = errors;
              let valid7 = false;
              const _errs29 = errors;
              if (errors === _errs29) {
                if (data9 && typeof data9 == "object" && !Array.isArray(data9)) {
                  let missing2;
                  if (data9.kind === void 0 && (missing2 = "kind") || data9.list === void 0 && (missing2 = "list")) {
                    const err16 = {
                      instancePath: instancePath + "/attributes",
                      schemaPath: "#/properties/attributes/anyOf/0/required",
                      keyword: "required",
                      params: {
                        missingProperty: missing2
                      },
                      message: "must have required property '" + missing2 + "'"
                    };
                    if (vErrors === null) {
                      vErrors = [err16];
                    } else {
                      vErrors.push(err16);
                    }
                    errors++;
                  } else {
                    if (data9.kind !== void 0) {
                      let data10 = data9.kind;
                      const _errs31 = errors;
                      if (typeof data10 !== "string") {
                        const err17 = {
                          instancePath: instancePath + "/attributes/kind",
                          schemaPath: "#/properties/attributes/anyOf/0/properties/kind/type",
                          keyword: "type",
                          params: {
                            type: "string"
                          },
                          message: "must be string"
                        };
                        if (vErrors === null) {
                          vErrors = [err17];
                        } else {
                          vErrors.push(err17);
                        }
                        errors++;
                      }
                      if (!(data10 === "ALL" || data10 === "SOME")) {
                        const err18 = {
                          instancePath: instancePath + "/attributes/kind",
                          schemaPath: "#/properties/attributes/anyOf/0/properties/kind/enum",
                          keyword: "enum",
                          params: {
                            allowedValues: schema159.properties.attributes.anyOf[0].properties.kind.enum
                          },
                          message: "must be equal to one of the allowed values"
                        };
                        if (vErrors === null) {
                          vErrors = [err18];
                        } else {
                          vErrors.push(err18);
                        }
                        errors++;
                      }
                      var valid8 = _errs31 === errors;
                    } else {
                      var valid8 = true;
                    }
                    if (valid8) {
                      if (data9.list !== void 0) {
                        let data11 = data9.list;
                        const _errs33 = errors;
                        if (errors === _errs33) {
                          if (Array.isArray(data11)) {
                            var valid9 = true;
                            const len2 = data11.length;
                            for (let i2 = 0; i2 < len2; i2++) {
                              const _errs35 = errors;
                              if (typeof data11[i2] !== "string") {
                                const err19 = {
                                  instancePath: instancePath + "/attributes/list/" + i2,
                                  schemaPath: "#/properties/attributes/anyOf/0/properties/list/items/type",
                                  keyword: "type",
                                  params: {
                                    type: "string"
                                  },
                                  message: "must be string"
                                };
                                if (vErrors === null) {
                                  vErrors = [err19];
                                } else {
                                  vErrors.push(err19);
                                }
                                errors++;
                              }
                              var valid9 = _errs35 === errors;
                              if (!valid9) {
                                break;
                              }
                            }
                          } else {
                            const err20 = {
                              instancePath: instancePath + "/attributes/list",
                              schemaPath: "#/properties/attributes/anyOf/0/properties/list/type",
                              keyword: "type",
                              params: {
                                type: "array"
                              },
                              message: "must be array"
                            };
                            if (vErrors === null) {
                              vErrors = [err20];
                            } else {
                              vErrors.push(err20);
                            }
                            errors++;
                          }
                        }
                        var valid8 = _errs33 === errors;
                      } else {
                        var valid8 = true;
                      }
                    }
                  }
                } else {
                  const err21 = {
                    instancePath: instancePath + "/attributes",
                    schemaPath: "#/properties/attributes/anyOf/0/type",
                    keyword: "type",
                    params: {
                      type: "object"
                    },
                    message: "must be object"
                  };
                  if (vErrors === null) {
                    vErrors = [err21];
                  } else {
                    vErrors.push(err21);
                  }
                  errors++;
                }
              }
              var _valid2 = _errs29 === errors;
              valid7 = valid7 || _valid2;
              if (!valid7) {
                const _errs37 = errors;
                if (data9 !== null) {
                  const err22 = {
                    instancePath: instancePath + "/attributes",
                    schemaPath: "#/properties/attributes/anyOf/1/type",
                    keyword: "type",
                    params: {
                      type: "null"
                    },
                    message: "must be null"
                  };
                  if (vErrors === null) {
                    vErrors = [err22];
                  } else {
                    vErrors.push(err22);
                  }
                  errors++;
                }
                var _valid2 = _errs37 === errors;
                valid7 = valid7 || _valid2;
              }
              if (!valid7) {
                const err23 = {
                  instancePath: instancePath + "/attributes",
                  schemaPath: "#/properties/attributes/anyOf",
                  keyword: "anyOf",
                  params: {},
                  message: "must match a schema in anyOf"
                };
                if (vErrors === null) {
                  vErrors = [err23];
                } else {
                  vErrors.push(err23);
                }
                errors++;
                validate149.errors = vErrors;
                return false;
              } else {
                errors = _errs28;
                if (vErrors !== null) {
                  if (_errs28) {
                    vErrors.length = _errs28;
                  } else {
                    vErrors = null;
                  }
                }
              }
              var valid0 = _errs27 === errors;
            } else {
              var valid0 = true;
            }
            if (valid0) {
              if (data.excludeAttributes !== void 0) {
                let data13 = data.excludeAttributes;
                const _errs39 = errors;
                const _errs40 = errors;
                let valid10 = false;
                const _errs41 = errors;
                if (errors === _errs41) {
                  if (data13 && typeof data13 == "object" && !Array.isArray(data13)) {
                    let missing3;
                    if (data13.kind === void 0 && (missing3 = "kind") || data13.list === void 0 && (missing3 = "list")) {
                      const err24 = {
                        instancePath: instancePath + "/excludeAttributes",
                        schemaPath: "#/properties/excludeAttributes/anyOf/0/required",
                        keyword: "required",
                        params: {
                          missingProperty: missing3
                        },
                        message: "must have required property '" + missing3 + "'"
                      };
                      if (vErrors === null) {
                        vErrors = [err24];
                      } else {
                        vErrors.push(err24);
                      }
                      errors++;
                    } else {
                      if (data13.kind !== void 0) {
                        let data14 = data13.kind;
                        const _errs43 = errors;
                        if (typeof data14 !== "string") {
                          const err25 = {
                            instancePath: instancePath + "/excludeAttributes/kind",
                            schemaPath: "#/properties/excludeAttributes/anyOf/0/properties/kind/type",
                            keyword: "type",
                            params: {
                              type: "string"
                            },
                            message: "must be string"
                          };
                          if (vErrors === null) {
                            vErrors = [err25];
                          } else {
                            vErrors.push(err25);
                          }
                          errors++;
                        }
                        if (!(data14 === "ALL" || data14 === "SOME")) {
                          const err26 = {
                            instancePath: instancePath + "/excludeAttributes/kind",
                            schemaPath: "#/properties/excludeAttributes/anyOf/0/properties/kind/enum",
                            keyword: "enum",
                            params: {
                              allowedValues: schema159.properties.excludeAttributes.anyOf[0].properties.kind.enum
                            },
                            message: "must be equal to one of the allowed values"
                          };
                          if (vErrors === null) {
                            vErrors = [err26];
                          } else {
                            vErrors.push(err26);
                          }
                          errors++;
                        }
                        var valid11 = _errs43 === errors;
                      } else {
                        var valid11 = true;
                      }
                      if (valid11) {
                        if (data13.list !== void 0) {
                          let data15 = data13.list;
                          const _errs45 = errors;
                          if (errors === _errs45) {
                            if (Array.isArray(data15)) {
                              var valid12 = true;
                              const len3 = data15.length;
                              for (let i3 = 0; i3 < len3; i3++) {
                                const _errs47 = errors;
                                if (typeof data15[i3] !== "string") {
                                  const err27 = {
                                    instancePath: instancePath + "/excludeAttributes/list/" + i3,
                                    schemaPath: "#/properties/excludeAttributes/anyOf/0/properties/list/items/type",
                                    keyword: "type",
                                    params: {
                                      type: "string"
                                    },
                                    message: "must be string"
                                  };
                                  if (vErrors === null) {
                                    vErrors = [err27];
                                  } else {
                                    vErrors.push(err27);
                                  }
                                  errors++;
                                }
                                var valid12 = _errs47 === errors;
                                if (!valid12) {
                                  break;
                                }
                              }
                            } else {
                              const err28 = {
                                instancePath: instancePath + "/excludeAttributes/list",
                                schemaPath: "#/properties/excludeAttributes/anyOf/0/properties/list/type",
                                keyword: "type",
                                params: {
                                  type: "array"
                                },
                                message: "must be array"
                              };
                              if (vErrors === null) {
                                vErrors = [err28];
                              } else {
                                vErrors.push(err28);
                              }
                              errors++;
                            }
                          }
                          var valid11 = _errs45 === errors;
                        } else {
                          var valid11 = true;
                        }
                      }
                    }
                  } else {
                    const err29 = {
                      instancePath: instancePath + "/excludeAttributes",
                      schemaPath: "#/properties/excludeAttributes/anyOf/0/type",
                      keyword: "type",
                      params: {
                        type: "object"
                      },
                      message: "must be object"
                    };
                    if (vErrors === null) {
                      vErrors = [err29];
                    } else {
                      vErrors.push(err29);
                    }
                    errors++;
                  }
                }
                var _valid3 = _errs41 === errors;
                valid10 = valid10 || _valid3;
                if (!valid10) {
                  const _errs49 = errors;
                  if (data13 !== null) {
                    const err30 = {
                      instancePath: instancePath + "/excludeAttributes",
                      schemaPath: "#/properties/excludeAttributes/anyOf/1/type",
                      keyword: "type",
                      params: {
                        type: "null"
                      },
                      message: "must be null"
                    };
                    if (vErrors === null) {
                      vErrors = [err30];
                    } else {
                      vErrors.push(err30);
                    }
                    errors++;
                  }
                  var _valid3 = _errs49 === errors;
                  valid10 = valid10 || _valid3;
                }
                if (!valid10) {
                  const err31 = {
                    instancePath: instancePath + "/excludeAttributes",
                    schemaPath: "#/properties/excludeAttributes/anyOf",
                    keyword: "anyOf",
                    params: {},
                    message: "must match a schema in anyOf"
                  };
                  if (vErrors === null) {
                    vErrors = [err31];
                  } else {
                    vErrors.push(err31);
                  }
                  errors++;
                  validate149.errors = vErrors;
                  return false;
                } else {
                  errors = _errs40;
                  if (vErrors !== null) {
                    if (_errs40) {
                      vErrors.length = _errs40;
                    } else {
                      vErrors = null;
                    }
                  }
                }
                var valid0 = _errs39 === errors;
              } else {
                var valid0 = true;
              }
              if (valid0) {
                if (data.predicateCombination !== void 0) {
                  let data17 = data.predicateCombination;
                  const _errs51 = errors;
                  if (typeof data17 !== "string" && data17 !== null) {
                    validate149.errors = [{
                      instancePath: instancePath + "/predicateCombination",
                      schemaPath: "#/properties/predicateCombination/type",
                      keyword: "type",
                      params: {
                        type: schema159.properties.predicateCombination.type
                      },
                      message: "must be string,null"
                    }];
                    return false;
                  }
                  if (!(data17 === "OR" || data17 === "AND" || data17 === null)) {
                    validate149.errors = [{
                      instancePath: instancePath + "/predicateCombination",
                      schemaPath: "#/properties/predicateCombination/enum",
                      keyword: "enum",
                      params: {
                        allowedValues: schema159.properties.predicateCombination.enum
                      },
                      message: "must be equal to one of the allowed values"
                    }];
                    return false;
                  }
                  var valid0 = _errs51 === errors;
                } else {
                  var valid0 = true;
                }
                if (valid0) {
                  if (data.includedPlans !== void 0) {
                    let data18 = data.includedPlans;
                    const _errs53 = errors;
                    const _errs54 = errors;
                    let valid13 = false;
                    const _errs55 = errors;
                    if (errors === _errs55) {
                      if (Array.isArray(data18)) {
                        var valid14 = true;
                        const len4 = data18.length;
                        for (let i4 = 0; i4 < len4; i4++) {
                          const _errs57 = errors;
                          if (typeof data18[i4] !== "string") {
                            const err32 = {
                              instancePath: instancePath + "/includedPlans/" + i4,
                              schemaPath: "#/properties/includedPlans/anyOf/0/items/type",
                              keyword: "type",
                              params: {
                                type: "string"
                              },
                              message: "must be string"
                            };
                            if (vErrors === null) {
                              vErrors = [err32];
                            } else {
                              vErrors.push(err32);
                            }
                            errors++;
                          }
                          var valid14 = _errs57 === errors;
                          if (!valid14) {
                            break;
                          }
                        }
                      } else {
                        const err33 = {
                          instancePath: instancePath + "/includedPlans",
                          schemaPath: "#/properties/includedPlans/anyOf/0/type",
                          keyword: "type",
                          params: {
                            type: "array"
                          },
                          message: "must be array"
                        };
                        if (vErrors === null) {
                          vErrors = [err33];
                        } else {
                          vErrors.push(err33);
                        }
                        errors++;
                      }
                    }
                    var _valid4 = _errs55 === errors;
                    valid13 = valid13 || _valid4;
                    if (!valid13) {
                      const _errs59 = errors;
                      if (data18 !== null) {
                        const err34 = {
                          instancePath: instancePath + "/includedPlans",
                          schemaPath: "#/properties/includedPlans/anyOf/1/type",
                          keyword: "type",
                          params: {
                            type: "null"
                          },
                          message: "must be null"
                        };
                        if (vErrors === null) {
                          vErrors = [err34];
                        } else {
                          vErrors.push(err34);
                        }
                        errors++;
                      }
                      var _valid4 = _errs59 === errors;
                      valid13 = valid13 || _valid4;
                    }
                    if (!valid13) {
                      const err35 = {
                        instancePath: instancePath + "/includedPlans",
                        schemaPath: "#/properties/includedPlans/anyOf",
                        keyword: "anyOf",
                        params: {},
                        message: "must match a schema in anyOf"
                      };
                      if (vErrors === null) {
                        vErrors = [err35];
                      } else {
                        vErrors.push(err35);
                      }
                      errors++;
                      validate149.errors = vErrors;
                      return false;
                    } else {
                      errors = _errs54;
                      if (vErrors !== null) {
                        if (_errs54) {
                          vErrors.length = _errs54;
                        } else {
                          vErrors = null;
                        }
                      }
                    }
                    var valid0 = _errs53 === errors;
                  } else {
                    var valid0 = true;
                  }
                }
              }
            }
          }
        }
      }
    } else {
      validate149.errors = [{
        instancePath,
        schemaPath: "#/type",
        keyword: "type",
        params: {
          type: "object"
        },
        message: "must be object"
      }];
      return false;
    }
  }
  validate149.errors = vErrors;
  return errors === 0;
}
const Plan = validate150;
const schema160 = {
  "$id": "Plan",
  "$schema": "http://json-schema.org/draft-07/schema#",
  "type": "object",
  "properties": {
    "archived": {
      "type": "boolean"
    },
    "name": {
      "type": "string"
    },
    "descriptionShort": {
      "type": ["string", "null"]
    },
    "descriptionLong": {
      "type": ["string", "null"]
    },
    "available": {
      "type": "boolean"
    },
    "image": {
      "type": ["string", "null"]
    },
    "scope": {
      "anyOf": [{
        "$ref": "PlanScope"
      }, {
        "type": "null"
      }]
    },
    "priceAlternatives": {
      "type": "array",
      "items": {
        "$ref": "PlanPrice"
      }
    },
    "geo_restriction": {
      "anyOf": [{
        "type": "array",
        "items": {
          "type": "string"
        }
      }, {
        "type": "null"
      }]
    }
  },
  "required": ["archived", "name", "descriptionShort", "descriptionLong", "available", "image", "scope", "priceAlternatives", "geo_restriction"],
  "description": "Content in a channel is either locked or unlocked. Locked content can be accessed through a ticket (if that content is part of an event), or through a subscription. Free content is always accessible.   A channel can define multiple subscription \u201CPlans\u201D, each plan can define rules to restrict which content they unlock."
};
function validate150(data, {
  instancePath = "",
  parentData,
  parentDataProperty,
  rootData = data
} = {}) {
  let vErrors = null;
  let errors = 0;
  if (errors === 0) {
    if (data && typeof data == "object" && !Array.isArray(data)) {
      let missing0;
      if (data.archived === void 0 && (missing0 = "archived") || data.name === void 0 && (missing0 = "name") || data.descriptionShort === void 0 && (missing0 = "descriptionShort") || data.descriptionLong === void 0 && (missing0 = "descriptionLong") || data.available === void 0 && (missing0 = "available") || data.image === void 0 && (missing0 = "image") || data.scope === void 0 && (missing0 = "scope") || data.priceAlternatives === void 0 && (missing0 = "priceAlternatives") || data.geo_restriction === void 0 && (missing0 = "geo_restriction")) {
        validate150.errors = [{
          instancePath,
          schemaPath: "#/required",
          keyword: "required",
          params: {
            missingProperty: missing0
          },
          message: "must have required property '" + missing0 + "'"
        }];
        return false;
      } else {
        if (data.archived !== void 0) {
          const _errs1 = errors;
          if (typeof data.archived !== "boolean") {
            validate150.errors = [{
              instancePath: instancePath + "/archived",
              schemaPath: "#/properties/archived/type",
              keyword: "type",
              params: {
                type: "boolean"
              },
              message: "must be boolean"
            }];
            return false;
          }
          var valid0 = _errs1 === errors;
        } else {
          var valid0 = true;
        }
        if (valid0) {
          if (data.name !== void 0) {
            const _errs3 = errors;
            if (typeof data.name !== "string") {
              validate150.errors = [{
                instancePath: instancePath + "/name",
                schemaPath: "#/properties/name/type",
                keyword: "type",
                params: {
                  type: "string"
                },
                message: "must be string"
              }];
              return false;
            }
            var valid0 = _errs3 === errors;
          } else {
            var valid0 = true;
          }
          if (valid0) {
            if (data.descriptionShort !== void 0) {
              let data2 = data.descriptionShort;
              const _errs5 = errors;
              if (typeof data2 !== "string" && data2 !== null) {
                validate150.errors = [{
                  instancePath: instancePath + "/descriptionShort",
                  schemaPath: "#/properties/descriptionShort/type",
                  keyword: "type",
                  params: {
                    type: schema160.properties.descriptionShort.type
                  },
                  message: "must be string,null"
                }];
                return false;
              }
              var valid0 = _errs5 === errors;
            } else {
              var valid0 = true;
            }
            if (valid0) {
              if (data.descriptionLong !== void 0) {
                let data3 = data.descriptionLong;
                const _errs7 = errors;
                if (typeof data3 !== "string" && data3 !== null) {
                  validate150.errors = [{
                    instancePath: instancePath + "/descriptionLong",
                    schemaPath: "#/properties/descriptionLong/type",
                    keyword: "type",
                    params: {
                      type: schema160.properties.descriptionLong.type
                    },
                    message: "must be string,null"
                  }];
                  return false;
                }
                var valid0 = _errs7 === errors;
              } else {
                var valid0 = true;
              }
              if (valid0) {
                if (data.available !== void 0) {
                  const _errs9 = errors;
                  if (typeof data.available !== "boolean") {
                    validate150.errors = [{
                      instancePath: instancePath + "/available",
                      schemaPath: "#/properties/available/type",
                      keyword: "type",
                      params: {
                        type: "boolean"
                      },
                      message: "must be boolean"
                    }];
                    return false;
                  }
                  var valid0 = _errs9 === errors;
                } else {
                  var valid0 = true;
                }
                if (valid0) {
                  if (data.image !== void 0) {
                    let data5 = data.image;
                    const _errs11 = errors;
                    if (typeof data5 !== "string" && data5 !== null) {
                      validate150.errors = [{
                        instancePath: instancePath + "/image",
                        schemaPath: "#/properties/image/type",
                        keyword: "type",
                        params: {
                          type: schema160.properties.image.type
                        },
                        message: "must be string,null"
                      }];
                      return false;
                    }
                    var valid0 = _errs11 === errors;
                  } else {
                    var valid0 = true;
                  }
                  if (valid0) {
                    if (data.scope !== void 0) {
                      let data6 = data.scope;
                      const _errs13 = errors;
                      const _errs14 = errors;
                      let valid1 = false;
                      const _errs15 = errors;
                      const _errs16 = errors;
                      if (errors === _errs16) {
                        if (data6 && typeof data6 == "object" && !Array.isArray(data6)) {
                          if (data6.initialCoverage !== void 0) {
                            let data7 = data6.initialCoverage;
                            const _errs18 = errors;
                            if (typeof data7 !== "boolean" && data7 !== null) {
                              const err0 = {
                                instancePath: instancePath + "/scope/initialCoverage",
                                schemaPath: "PlanScope/properties/initialCoverage/type",
                                keyword: "type",
                                params: {
                                  type: schema159.properties.initialCoverage.type
                                },
                                message: "must be boolean,null"
                              };
                              if (vErrors === null) {
                                vErrors = [err0];
                              } else {
                                vErrors.push(err0);
                              }
                              errors++;
                            }
                            var valid3 = _errs18 === errors;
                          } else {
                            var valid3 = true;
                          }
                          if (valid3) {
                            if (data6.tags !== void 0) {
                              let data8 = data6.tags;
                              const _errs20 = errors;
                              const _errs21 = errors;
                              let valid4 = false;
                              const _errs22 = errors;
                              if (errors === _errs22) {
                                if (data8 && typeof data8 == "object" && !Array.isArray(data8)) {
                                  let missing1;
                                  if (data8.kind === void 0 && (missing1 = "kind") || data8.list === void 0 && (missing1 = "list")) {
                                    const err1 = {
                                      instancePath: instancePath + "/scope/tags",
                                      schemaPath: "PlanScope/properties/tags/anyOf/0/required",
                                      keyword: "required",
                                      params: {
                                        missingProperty: missing1
                                      },
                                      message: "must have required property '" + missing1 + "'"
                                    };
                                    if (vErrors === null) {
                                      vErrors = [err1];
                                    } else {
                                      vErrors.push(err1);
                                    }
                                    errors++;
                                  } else {
                                    if (data8.kind !== void 0) {
                                      let data9 = data8.kind;
                                      const _errs24 = errors;
                                      if (typeof data9 !== "string") {
                                        const err2 = {
                                          instancePath: instancePath + "/scope/tags/kind",
                                          schemaPath: "PlanScope/properties/tags/anyOf/0/properties/kind/type",
                                          keyword: "type",
                                          params: {
                                            type: "string"
                                          },
                                          message: "must be string"
                                        };
                                        if (vErrors === null) {
                                          vErrors = [err2];
                                        } else {
                                          vErrors.push(err2);
                                        }
                                        errors++;
                                      }
                                      if (!(data9 === "ALL" || data9 === "SOME")) {
                                        const err3 = {
                                          instancePath: instancePath + "/scope/tags/kind",
                                          schemaPath: "PlanScope/properties/tags/anyOf/0/properties/kind/enum",
                                          keyword: "enum",
                                          params: {
                                            allowedValues: schema159.properties.tags.anyOf[0].properties.kind.enum
                                          },
                                          message: "must be equal to one of the allowed values"
                                        };
                                        if (vErrors === null) {
                                          vErrors = [err3];
                                        } else {
                                          vErrors.push(err3);
                                        }
                                        errors++;
                                      }
                                      var valid5 = _errs24 === errors;
                                    } else {
                                      var valid5 = true;
                                    }
                                    if (valid5) {
                                      if (data8.list !== void 0) {
                                        let data10 = data8.list;
                                        const _errs26 = errors;
                                        if (errors === _errs26) {
                                          if (Array.isArray(data10)) {
                                            var valid6 = true;
                                            const len0 = data10.length;
                                            for (let i0 = 0; i0 < len0; i0++) {
                                              const _errs28 = errors;
                                              if (typeof data10[i0] !== "string") {
                                                const err4 = {
                                                  instancePath: instancePath + "/scope/tags/list/" + i0,
                                                  schemaPath: "PlanScope/properties/tags/anyOf/0/properties/list/items/type",
                                                  keyword: "type",
                                                  params: {
                                                    type: "string"
                                                  },
                                                  message: "must be string"
                                                };
                                                if (vErrors === null) {
                                                  vErrors = [err4];
                                                } else {
                                                  vErrors.push(err4);
                                                }
                                                errors++;
                                              }
                                              var valid6 = _errs28 === errors;
                                              if (!valid6) {
                                                break;
                                              }
                                            }
                                          } else {
                                            const err5 = {
                                              instancePath: instancePath + "/scope/tags/list",
                                              schemaPath: "PlanScope/properties/tags/anyOf/0/properties/list/type",
                                              keyword: "type",
                                              params: {
                                                type: "array"
                                              },
                                              message: "must be array"
                                            };
                                            if (vErrors === null) {
                                              vErrors = [err5];
                                            } else {
                                              vErrors.push(err5);
                                            }
                                            errors++;
                                          }
                                        }
                                        var valid5 = _errs26 === errors;
                                      } else {
                                        var valid5 = true;
                                      }
                                    }
                                  }
                                } else {
                                  const err6 = {
                                    instancePath: instancePath + "/scope/tags",
                                    schemaPath: "PlanScope/properties/tags/anyOf/0/type",
                                    keyword: "type",
                                    params: {
                                      type: "object"
                                    },
                                    message: "must be object"
                                  };
                                  if (vErrors === null) {
                                    vErrors = [err6];
                                  } else {
                                    vErrors.push(err6);
                                  }
                                  errors++;
                                }
                              }
                              var _valid1 = _errs22 === errors;
                              valid4 = valid4 || _valid1;
                              if (!valid4) {
                                const _errs30 = errors;
                                if (data8 !== null) {
                                  const err7 = {
                                    instancePath: instancePath + "/scope/tags",
                                    schemaPath: "PlanScope/properties/tags/anyOf/1/type",
                                    keyword: "type",
                                    params: {
                                      type: "null"
                                    },
                                    message: "must be null"
                                  };
                                  if (vErrors === null) {
                                    vErrors = [err7];
                                  } else {
                                    vErrors.push(err7);
                                  }
                                  errors++;
                                }
                                var _valid1 = _errs30 === errors;
                                valid4 = valid4 || _valid1;
                              }
                              if (!valid4) {
                                const err8 = {
                                  instancePath: instancePath + "/scope/tags",
                                  schemaPath: "PlanScope/properties/tags/anyOf",
                                  keyword: "anyOf",
                                  params: {},
                                  message: "must match a schema in anyOf"
                                };
                                if (vErrors === null) {
                                  vErrors = [err8];
                                } else {
                                  vErrors.push(err8);
                                }
                                errors++;
                              } else {
                                errors = _errs21;
                                if (vErrors !== null) {
                                  if (_errs21) {
                                    vErrors.length = _errs21;
                                  } else {
                                    vErrors = null;
                                  }
                                }
                              }
                              var valid3 = _errs20 === errors;
                            } else {
                              var valid3 = true;
                            }
                            if (valid3) {
                              if (data6.excludeTags !== void 0) {
                                let data12 = data6.excludeTags;
                                const _errs32 = errors;
                                const _errs33 = errors;
                                let valid7 = false;
                                const _errs34 = errors;
                                if (errors === _errs34) {
                                  if (data12 && typeof data12 == "object" && !Array.isArray(data12)) {
                                    let missing2;
                                    if (data12.kind === void 0 && (missing2 = "kind") || data12.list === void 0 && (missing2 = "list")) {
                                      const err9 = {
                                        instancePath: instancePath + "/scope/excludeTags",
                                        schemaPath: "PlanScope/properties/excludeTags/anyOf/0/required",
                                        keyword: "required",
                                        params: {
                                          missingProperty: missing2
                                        },
                                        message: "must have required property '" + missing2 + "'"
                                      };
                                      if (vErrors === null) {
                                        vErrors = [err9];
                                      } else {
                                        vErrors.push(err9);
                                      }
                                      errors++;
                                    } else {
                                      if (data12.kind !== void 0) {
                                        let data13 = data12.kind;
                                        const _errs36 = errors;
                                        if (typeof data13 !== "string") {
                                          const err10 = {
                                            instancePath: instancePath + "/scope/excludeTags/kind",
                                            schemaPath: "PlanScope/properties/excludeTags/anyOf/0/properties/kind/type",
                                            keyword: "type",
                                            params: {
                                              type: "string"
                                            },
                                            message: "must be string"
                                          };
                                          if (vErrors === null) {
                                            vErrors = [err10];
                                          } else {
                                            vErrors.push(err10);
                                          }
                                          errors++;
                                        }
                                        if (!(data13 === "ALL" || data13 === "SOME")) {
                                          const err11 = {
                                            instancePath: instancePath + "/scope/excludeTags/kind",
                                            schemaPath: "PlanScope/properties/excludeTags/anyOf/0/properties/kind/enum",
                                            keyword: "enum",
                                            params: {
                                              allowedValues: schema159.properties.excludeTags.anyOf[0].properties.kind.enum
                                            },
                                            message: "must be equal to one of the allowed values"
                                          };
                                          if (vErrors === null) {
                                            vErrors = [err11];
                                          } else {
                                            vErrors.push(err11);
                                          }
                                          errors++;
                                        }
                                        var valid8 = _errs36 === errors;
                                      } else {
                                        var valid8 = true;
                                      }
                                      if (valid8) {
                                        if (data12.list !== void 0) {
                                          let data14 = data12.list;
                                          const _errs38 = errors;
                                          if (errors === _errs38) {
                                            if (Array.isArray(data14)) {
                                              var valid9 = true;
                                              const len1 = data14.length;
                                              for (let i1 = 0; i1 < len1; i1++) {
                                                const _errs40 = errors;
                                                if (typeof data14[i1] !== "string") {
                                                  const err12 = {
                                                    instancePath: instancePath + "/scope/excludeTags/list/" + i1,
                                                    schemaPath: "PlanScope/properties/excludeTags/anyOf/0/properties/list/items/type",
                                                    keyword: "type",
                                                    params: {
                                                      type: "string"
                                                    },
                                                    message: "must be string"
                                                  };
                                                  if (vErrors === null) {
                                                    vErrors = [err12];
                                                  } else {
                                                    vErrors.push(err12);
                                                  }
                                                  errors++;
                                                }
                                                var valid9 = _errs40 === errors;
                                                if (!valid9) {
                                                  break;
                                                }
                                              }
                                            } else {
                                              const err13 = {
                                                instancePath: instancePath + "/scope/excludeTags/list",
                                                schemaPath: "PlanScope/properties/excludeTags/anyOf/0/properties/list/type",
                                                keyword: "type",
                                                params: {
                                                  type: "array"
                                                },
                                                message: "must be array"
                                              };
                                              if (vErrors === null) {
                                                vErrors = [err13];
                                              } else {
                                                vErrors.push(err13);
                                              }
                                              errors++;
                                            }
                                          }
                                          var valid8 = _errs38 === errors;
                                        } else {
                                          var valid8 = true;
                                        }
                                      }
                                    }
                                  } else {
                                    const err14 = {
                                      instancePath: instancePath + "/scope/excludeTags",
                                      schemaPath: "PlanScope/properties/excludeTags/anyOf/0/type",
                                      keyword: "type",
                                      params: {
                                        type: "object"
                                      },
                                      message: "must be object"
                                    };
                                    if (vErrors === null) {
                                      vErrors = [err14];
                                    } else {
                                      vErrors.push(err14);
                                    }
                                    errors++;
                                  }
                                }
                                var _valid2 = _errs34 === errors;
                                valid7 = valid7 || _valid2;
                                if (!valid7) {
                                  const _errs42 = errors;
                                  if (data12 !== null) {
                                    const err15 = {
                                      instancePath: instancePath + "/scope/excludeTags",
                                      schemaPath: "PlanScope/properties/excludeTags/anyOf/1/type",
                                      keyword: "type",
                                      params: {
                                        type: "null"
                                      },
                                      message: "must be null"
                                    };
                                    if (vErrors === null) {
                                      vErrors = [err15];
                                    } else {
                                      vErrors.push(err15);
                                    }
                                    errors++;
                                  }
                                  var _valid2 = _errs42 === errors;
                                  valid7 = valid7 || _valid2;
                                }
                                if (!valid7) {
                                  const err16 = {
                                    instancePath: instancePath + "/scope/excludeTags",
                                    schemaPath: "PlanScope/properties/excludeTags/anyOf",
                                    keyword: "anyOf",
                                    params: {},
                                    message: "must match a schema in anyOf"
                                  };
                                  if (vErrors === null) {
                                    vErrors = [err16];
                                  } else {
                                    vErrors.push(err16);
                                  }
                                  errors++;
                                } else {
                                  errors = _errs33;
                                  if (vErrors !== null) {
                                    if (_errs33) {
                                      vErrors.length = _errs33;
                                    } else {
                                      vErrors = null;
                                    }
                                  }
                                }
                                var valid3 = _errs32 === errors;
                              } else {
                                var valid3 = true;
                              }
                              if (valid3) {
                                if (data6.attributes !== void 0) {
                                  let data16 = data6.attributes;
                                  const _errs44 = errors;
                                  const _errs45 = errors;
                                  let valid10 = false;
                                  const _errs46 = errors;
                                  if (errors === _errs46) {
                                    if (data16 && typeof data16 == "object" && !Array.isArray(data16)) {
                                      let missing3;
                                      if (data16.kind === void 0 && (missing3 = "kind") || data16.list === void 0 && (missing3 = "list")) {
                                        const err17 = {
                                          instancePath: instancePath + "/scope/attributes",
                                          schemaPath: "PlanScope/properties/attributes/anyOf/0/required",
                                          keyword: "required",
                                          params: {
                                            missingProperty: missing3
                                          },
                                          message: "must have required property '" + missing3 + "'"
                                        };
                                        if (vErrors === null) {
                                          vErrors = [err17];
                                        } else {
                                          vErrors.push(err17);
                                        }
                                        errors++;
                                      } else {
                                        if (data16.kind !== void 0) {
                                          let data17 = data16.kind;
                                          const _errs48 = errors;
                                          if (typeof data17 !== "string") {
                                            const err18 = {
                                              instancePath: instancePath + "/scope/attributes/kind",
                                              schemaPath: "PlanScope/properties/attributes/anyOf/0/properties/kind/type",
                                              keyword: "type",
                                              params: {
                                                type: "string"
                                              },
                                              message: "must be string"
                                            };
                                            if (vErrors === null) {
                                              vErrors = [err18];
                                            } else {
                                              vErrors.push(err18);
                                            }
                                            errors++;
                                          }
                                          if (!(data17 === "ALL" || data17 === "SOME")) {
                                            const err19 = {
                                              instancePath: instancePath + "/scope/attributes/kind",
                                              schemaPath: "PlanScope/properties/attributes/anyOf/0/properties/kind/enum",
                                              keyword: "enum",
                                              params: {
                                                allowedValues: schema159.properties.attributes.anyOf[0].properties.kind.enum
                                              },
                                              message: "must be equal to one of the allowed values"
                                            };
                                            if (vErrors === null) {
                                              vErrors = [err19];
                                            } else {
                                              vErrors.push(err19);
                                            }
                                            errors++;
                                          }
                                          var valid11 = _errs48 === errors;
                                        } else {
                                          var valid11 = true;
                                        }
                                        if (valid11) {
                                          if (data16.list !== void 0) {
                                            let data18 = data16.list;
                                            const _errs50 = errors;
                                            if (errors === _errs50) {
                                              if (Array.isArray(data18)) {
                                                var valid12 = true;
                                                const len2 = data18.length;
                                                for (let i2 = 0; i2 < len2; i2++) {
                                                  const _errs52 = errors;
                                                  if (typeof data18[i2] !== "string") {
                                                    const err20 = {
                                                      instancePath: instancePath + "/scope/attributes/list/" + i2,
                                                      schemaPath: "PlanScope/properties/attributes/anyOf/0/properties/list/items/type",
                                                      keyword: "type",
                                                      params: {
                                                        type: "string"
                                                      },
                                                      message: "must be string"
                                                    };
                                                    if (vErrors === null) {
                                                      vErrors = [err20];
                                                    } else {
                                                      vErrors.push(err20);
                                                    }
                                                    errors++;
                                                  }
                                                  var valid12 = _errs52 === errors;
                                                  if (!valid12) {
                                                    break;
                                                  }
                                                }
                                              } else {
                                                const err21 = {
                                                  instancePath: instancePath + "/scope/attributes/list",
                                                  schemaPath: "PlanScope/properties/attributes/anyOf/0/properties/list/type",
                                                  keyword: "type",
                                                  params: {
                                                    type: "array"
                                                  },
                                                  message: "must be array"
                                                };
                                                if (vErrors === null) {
                                                  vErrors = [err21];
                                                } else {
                                                  vErrors.push(err21);
                                                }
                                                errors++;
                                              }
                                            }
                                            var valid11 = _errs50 === errors;
                                          } else {
                                            var valid11 = true;
                                          }
                                        }
                                      }
                                    } else {
                                      const err22 = {
                                        instancePath: instancePath + "/scope/attributes",
                                        schemaPath: "PlanScope/properties/attributes/anyOf/0/type",
                                        keyword: "type",
                                        params: {
                                          type: "object"
                                        },
                                        message: "must be object"
                                      };
                                      if (vErrors === null) {
                                        vErrors = [err22];
                                      } else {
                                        vErrors.push(err22);
                                      }
                                      errors++;
                                    }
                                  }
                                  var _valid3 = _errs46 === errors;
                                  valid10 = valid10 || _valid3;
                                  if (!valid10) {
                                    const _errs54 = errors;
                                    if (data16 !== null) {
                                      const err23 = {
                                        instancePath: instancePath + "/scope/attributes",
                                        schemaPath: "PlanScope/properties/attributes/anyOf/1/type",
                                        keyword: "type",
                                        params: {
                                          type: "null"
                                        },
                                        message: "must be null"
                                      };
                                      if (vErrors === null) {
                                        vErrors = [err23];
                                      } else {
                                        vErrors.push(err23);
                                      }
                                      errors++;
                                    }
                                    var _valid3 = _errs54 === errors;
                                    valid10 = valid10 || _valid3;
                                  }
                                  if (!valid10) {
                                    const err24 = {
                                      instancePath: instancePath + "/scope/attributes",
                                      schemaPath: "PlanScope/properties/attributes/anyOf",
                                      keyword: "anyOf",
                                      params: {},
                                      message: "must match a schema in anyOf"
                                    };
                                    if (vErrors === null) {
                                      vErrors = [err24];
                                    } else {
                                      vErrors.push(err24);
                                    }
                                    errors++;
                                  } else {
                                    errors = _errs45;
                                    if (vErrors !== null) {
                                      if (_errs45) {
                                        vErrors.length = _errs45;
                                      } else {
                                        vErrors = null;
                                      }
                                    }
                                  }
                                  var valid3 = _errs44 === errors;
                                } else {
                                  var valid3 = true;
                                }
                                if (valid3) {
                                  if (data6.excludeAttributes !== void 0) {
                                    let data20 = data6.excludeAttributes;
                                    const _errs56 = errors;
                                    const _errs57 = errors;
                                    let valid13 = false;
                                    const _errs58 = errors;
                                    if (errors === _errs58) {
                                      if (data20 && typeof data20 == "object" && !Array.isArray(data20)) {
                                        let missing4;
                                        if (data20.kind === void 0 && (missing4 = "kind") || data20.list === void 0 && (missing4 = "list")) {
                                          const err25 = {
                                            instancePath: instancePath + "/scope/excludeAttributes",
                                            schemaPath: "PlanScope/properties/excludeAttributes/anyOf/0/required",
                                            keyword: "required",
                                            params: {
                                              missingProperty: missing4
                                            },
                                            message: "must have required property '" + missing4 + "'"
                                          };
                                          if (vErrors === null) {
                                            vErrors = [err25];
                                          } else {
                                            vErrors.push(err25);
                                          }
                                          errors++;
                                        } else {
                                          if (data20.kind !== void 0) {
                                            let data21 = data20.kind;
                                            const _errs60 = errors;
                                            if (typeof data21 !== "string") {
                                              const err26 = {
                                                instancePath: instancePath + "/scope/excludeAttributes/kind",
                                                schemaPath: "PlanScope/properties/excludeAttributes/anyOf/0/properties/kind/type",
                                                keyword: "type",
                                                params: {
                                                  type: "string"
                                                },
                                                message: "must be string"
                                              };
                                              if (vErrors === null) {
                                                vErrors = [err26];
                                              } else {
                                                vErrors.push(err26);
                                              }
                                              errors++;
                                            }
                                            if (!(data21 === "ALL" || data21 === "SOME")) {
                                              const err27 = {
                                                instancePath: instancePath + "/scope/excludeAttributes/kind",
                                                schemaPath: "PlanScope/properties/excludeAttributes/anyOf/0/properties/kind/enum",
                                                keyword: "enum",
                                                params: {
                                                  allowedValues: schema159.properties.excludeAttributes.anyOf[0].properties.kind.enum
                                                },
                                                message: "must be equal to one of the allowed values"
                                              };
                                              if (vErrors === null) {
                                                vErrors = [err27];
                                              } else {
                                                vErrors.push(err27);
                                              }
                                              errors++;
                                            }
                                            var valid14 = _errs60 === errors;
                                          } else {
                                            var valid14 = true;
                                          }
                                          if (valid14) {
                                            if (data20.list !== void 0) {
                                              let data22 = data20.list;
                                              const _errs62 = errors;
                                              if (errors === _errs62) {
                                                if (Array.isArray(data22)) {
                                                  var valid15 = true;
                                                  const len3 = data22.length;
                                                  for (let i3 = 0; i3 < len3; i3++) {
                                                    const _errs64 = errors;
                                                    if (typeof data22[i3] !== "string") {
                                                      const err28 = {
                                                        instancePath: instancePath + "/scope/excludeAttributes/list/" + i3,
                                                        schemaPath: "PlanScope/properties/excludeAttributes/anyOf/0/properties/list/items/type",
                                                        keyword: "type",
                                                        params: {
                                                          type: "string"
                                                        },
                                                        message: "must be string"
                                                      };
                                                      if (vErrors === null) {
                                                        vErrors = [err28];
                                                      } else {
                                                        vErrors.push(err28);
                                                      }
                                                      errors++;
                                                    }
                                                    var valid15 = _errs64 === errors;
                                                    if (!valid15) {
                                                      break;
                                                    }
                                                  }
                                                } else {
                                                  const err29 = {
                                                    instancePath: instancePath + "/scope/excludeAttributes/list",
                                                    schemaPath: "PlanScope/properties/excludeAttributes/anyOf/0/properties/list/type",
                                                    keyword: "type",
                                                    params: {
                                                      type: "array"
                                                    },
                                                    message: "must be array"
                                                  };
                                                  if (vErrors === null) {
                                                    vErrors = [err29];
                                                  } else {
                                                    vErrors.push(err29);
                                                  }
                                                  errors++;
                                                }
                                              }
                                              var valid14 = _errs62 === errors;
                                            } else {
                                              var valid14 = true;
                                            }
                                          }
                                        }
                                      } else {
                                        const err30 = {
                                          instancePath: instancePath + "/scope/excludeAttributes",
                                          schemaPath: "PlanScope/properties/excludeAttributes/anyOf/0/type",
                                          keyword: "type",
                                          params: {
                                            type: "object"
                                          },
                                          message: "must be object"
                                        };
                                        if (vErrors === null) {
                                          vErrors = [err30];
                                        } else {
                                          vErrors.push(err30);
                                        }
                                        errors++;
                                      }
                                    }
                                    var _valid4 = _errs58 === errors;
                                    valid13 = valid13 || _valid4;
                                    if (!valid13) {
                                      const _errs66 = errors;
                                      if (data20 !== null) {
                                        const err31 = {
                                          instancePath: instancePath + "/scope/excludeAttributes",
                                          schemaPath: "PlanScope/properties/excludeAttributes/anyOf/1/type",
                                          keyword: "type",
                                          params: {
                                            type: "null"
                                          },
                                          message: "must be null"
                                        };
                                        if (vErrors === null) {
                                          vErrors = [err31];
                                        } else {
                                          vErrors.push(err31);
                                        }
                                        errors++;
                                      }
                                      var _valid4 = _errs66 === errors;
                                      valid13 = valid13 || _valid4;
                                    }
                                    if (!valid13) {
                                      const err32 = {
                                        instancePath: instancePath + "/scope/excludeAttributes",
                                        schemaPath: "PlanScope/properties/excludeAttributes/anyOf",
                                        keyword: "anyOf",
                                        params: {},
                                        message: "must match a schema in anyOf"
                                      };
                                      if (vErrors === null) {
                                        vErrors = [err32];
                                      } else {
                                        vErrors.push(err32);
                                      }
                                      errors++;
                                    } else {
                                      errors = _errs57;
                                      if (vErrors !== null) {
                                        if (_errs57) {
                                          vErrors.length = _errs57;
                                        } else {
                                          vErrors = null;
                                        }
                                      }
                                    }
                                    var valid3 = _errs56 === errors;
                                  } else {
                                    var valid3 = true;
                                  }
                                  if (valid3) {
                                    if (data6.predicateCombination !== void 0) {
                                      let data24 = data6.predicateCombination;
                                      const _errs68 = errors;
                                      if (typeof data24 !== "string" && data24 !== null) {
                                        const err33 = {
                                          instancePath: instancePath + "/scope/predicateCombination",
                                          schemaPath: "PlanScope/properties/predicateCombination/type",
                                          keyword: "type",
                                          params: {
                                            type: schema159.properties.predicateCombination.type
                                          },
                                          message: "must be string,null"
                                        };
                                        if (vErrors === null) {
                                          vErrors = [err33];
                                        } else {
                                          vErrors.push(err33);
                                        }
                                        errors++;
                                      }
                                      if (!(data24 === "OR" || data24 === "AND" || data24 === null)) {
                                        const err34 = {
                                          instancePath: instancePath + "/scope/predicateCombination",
                                          schemaPath: "PlanScope/properties/predicateCombination/enum",
                                          keyword: "enum",
                                          params: {
                                            allowedValues: schema159.properties.predicateCombination.enum
                                          },
                                          message: "must be equal to one of the allowed values"
                                        };
                                        if (vErrors === null) {
                                          vErrors = [err34];
                                        } else {
                                          vErrors.push(err34);
                                        }
                                        errors++;
                                      }
                                      var valid3 = _errs68 === errors;
                                    } else {
                                      var valid3 = true;
                                    }
                                    if (valid3) {
                                      if (data6.includedPlans !== void 0) {
                                        let data25 = data6.includedPlans;
                                        const _errs70 = errors;
                                        const _errs71 = errors;
                                        let valid16 = false;
                                        const _errs72 = errors;
                                        if (errors === _errs72) {
                                          if (Array.isArray(data25)) {
                                            var valid17 = true;
                                            const len4 = data25.length;
                                            for (let i4 = 0; i4 < len4; i4++) {
                                              const _errs74 = errors;
                                              if (typeof data25[i4] !== "string") {
                                                const err35 = {
                                                  instancePath: instancePath + "/scope/includedPlans/" + i4,
                                                  schemaPath: "PlanScope/properties/includedPlans/anyOf/0/items/type",
                                                  keyword: "type",
                                                  params: {
                                                    type: "string"
                                                  },
                                                  message: "must be string"
                                                };
                                                if (vErrors === null) {
                                                  vErrors = [err35];
                                                } else {
                                                  vErrors.push(err35);
                                                }
                                                errors++;
                                              }
                                              var valid17 = _errs74 === errors;
                                              if (!valid17) {
                                                break;
                                              }
                                            }
                                          } else {
                                            const err36 = {
                                              instancePath: instancePath + "/scope/includedPlans",
                                              schemaPath: "PlanScope/properties/includedPlans/anyOf/0/type",
                                              keyword: "type",
                                              params: {
                                                type: "array"
                                              },
                                              message: "must be array"
                                            };
                                            if (vErrors === null) {
                                              vErrors = [err36];
                                            } else {
                                              vErrors.push(err36);
                                            }
                                            errors++;
                                          }
                                        }
                                        var _valid5 = _errs72 === errors;
                                        valid16 = valid16 || _valid5;
                                        if (!valid16) {
                                          const _errs76 = errors;
                                          if (data25 !== null) {
                                            const err37 = {
                                              instancePath: instancePath + "/scope/includedPlans",
                                              schemaPath: "PlanScope/properties/includedPlans/anyOf/1/type",
                                              keyword: "type",
                                              params: {
                                                type: "null"
                                              },
                                              message: "must be null"
                                            };
                                            if (vErrors === null) {
                                              vErrors = [err37];
                                            } else {
                                              vErrors.push(err37);
                                            }
                                            errors++;
                                          }
                                          var _valid5 = _errs76 === errors;
                                          valid16 = valid16 || _valid5;
                                        }
                                        if (!valid16) {
                                          const err38 = {
                                            instancePath: instancePath + "/scope/includedPlans",
                                            schemaPath: "PlanScope/properties/includedPlans/anyOf",
                                            keyword: "anyOf",
                                            params: {},
                                            message: "must match a schema in anyOf"
                                          };
                                          if (vErrors === null) {
                                            vErrors = [err38];
                                          } else {
                                            vErrors.push(err38);
                                          }
                                          errors++;
                                        } else {
                                          errors = _errs71;
                                          if (vErrors !== null) {
                                            if (_errs71) {
                                              vErrors.length = _errs71;
                                            } else {
                                              vErrors = null;
                                            }
                                          }
                                        }
                                        var valid3 = _errs70 === errors;
                                      } else {
                                        var valid3 = true;
                                      }
                                    }
                                  }
                                }
                              }
                            }
                          }
                        } else {
                          const err39 = {
                            instancePath: instancePath + "/scope",
                            schemaPath: "PlanScope/type",
                            keyword: "type",
                            params: {
                              type: "object"
                            },
                            message: "must be object"
                          };
                          if (vErrors === null) {
                            vErrors = [err39];
                          } else {
                            vErrors.push(err39);
                          }
                          errors++;
                        }
                      }
                      var _valid0 = _errs15 === errors;
                      valid1 = valid1 || _valid0;
                      if (!valid1) {
                        const _errs78 = errors;
                        if (data6 !== null) {
                          const err40 = {
                            instancePath: instancePath + "/scope",
                            schemaPath: "#/properties/scope/anyOf/1/type",
                            keyword: "type",
                            params: {
                              type: "null"
                            },
                            message: "must be null"
                          };
                          if (vErrors === null) {
                            vErrors = [err40];
                          } else {
                            vErrors.push(err40);
                          }
                          errors++;
                        }
                        var _valid0 = _errs78 === errors;
                        valid1 = valid1 || _valid0;
                      }
                      if (!valid1) {
                        const err41 = {
                          instancePath: instancePath + "/scope",
                          schemaPath: "#/properties/scope/anyOf",
                          keyword: "anyOf",
                          params: {},
                          message: "must match a schema in anyOf"
                        };
                        if (vErrors === null) {
                          vErrors = [err41];
                        } else {
                          vErrors.push(err41);
                        }
                        errors++;
                        validate150.errors = vErrors;
                        return false;
                      } else {
                        errors = _errs14;
                        if (vErrors !== null) {
                          if (_errs14) {
                            vErrors.length = _errs14;
                          } else {
                            vErrors = null;
                          }
                        }
                      }
                      var valid0 = _errs13 === errors;
                    } else {
                      var valid0 = true;
                    }
                    if (valid0) {
                      if (data.priceAlternatives !== void 0) {
                        let data27 = data.priceAlternatives;
                        const _errs80 = errors;
                        if (errors === _errs80) {
                          if (Array.isArray(data27)) {
                            var valid18 = true;
                            const len5 = data27.length;
                            for (let i5 = 0; i5 < len5; i5++) {
                              const _errs82 = errors;
                              if (!validate24(data27[i5], {
                                instancePath: instancePath + "/priceAlternatives/" + i5,
                                parentData: data27,
                                parentDataProperty: i5,
                                rootData
                              })) {
                                vErrors = vErrors === null ? validate24.errors : vErrors.concat(validate24.errors);
                                errors = vErrors.length;
                              }
                              var valid18 = _errs82 === errors;
                              if (!valid18) {
                                break;
                              }
                            }
                          } else {
                            validate150.errors = [{
                              instancePath: instancePath + "/priceAlternatives",
                              schemaPath: "#/properties/priceAlternatives/type",
                              keyword: "type",
                              params: {
                                type: "array"
                              },
                              message: "must be array"
                            }];
                            return false;
                          }
                        }
                        var valid0 = _errs80 === errors;
                      } else {
                        var valid0 = true;
                      }
                      if (valid0) {
                        if (data.geo_restriction !== void 0) {
                          let data29 = data.geo_restriction;
                          const _errs83 = errors;
                          const _errs84 = errors;
                          let valid19 = false;
                          const _errs85 = errors;
                          if (errors === _errs85) {
                            if (Array.isArray(data29)) {
                              var valid20 = true;
                              const len6 = data29.length;
                              for (let i6 = 0; i6 < len6; i6++) {
                                const _errs87 = errors;
                                if (typeof data29[i6] !== "string") {
                                  const err42 = {
                                    instancePath: instancePath + "/geo_restriction/" + i6,
                                    schemaPath: "#/properties/geo_restriction/anyOf/0/items/type",
                                    keyword: "type",
                                    params: {
                                      type: "string"
                                    },
                                    message: "must be string"
                                  };
                                  if (vErrors === null) {
                                    vErrors = [err42];
                                  } else {
                                    vErrors.push(err42);
                                  }
                                  errors++;
                                }
                                var valid20 = _errs87 === errors;
                                if (!valid20) {
                                  break;
                                }
                              }
                            } else {
                              const err43 = {
                                instancePath: instancePath + "/geo_restriction",
                                schemaPath: "#/properties/geo_restriction/anyOf/0/type",
                                keyword: "type",
                                params: {
                                  type: "array"
                                },
                                message: "must be array"
                              };
                              if (vErrors === null) {
                                vErrors = [err43];
                              } else {
                                vErrors.push(err43);
                              }
                              errors++;
                            }
                          }
                          var _valid6 = _errs85 === errors;
                          valid19 = valid19 || _valid6;
                          if (!valid19) {
                            const _errs89 = errors;
                            if (data29 !== null) {
                              const err44 = {
                                instancePath: instancePath + "/geo_restriction",
                                schemaPath: "#/properties/geo_restriction/anyOf/1/type",
                                keyword: "type",
                                params: {
                                  type: "null"
                                },
                                message: "must be null"
                              };
                              if (vErrors === null) {
                                vErrors = [err44];
                              } else {
                                vErrors.push(err44);
                              }
                              errors++;
                            }
                            var _valid6 = _errs89 === errors;
                            valid19 = valid19 || _valid6;
                          }
                          if (!valid19) {
                            const err45 = {
                              instancePath: instancePath + "/geo_restriction",
                              schemaPath: "#/properties/geo_restriction/anyOf",
                              keyword: "anyOf",
                              params: {},
                              message: "must match a schema in anyOf"
                            };
                            if (vErrors === null) {
                              vErrors = [err45];
                            } else {
                              vErrors.push(err45);
                            }
                            errors++;
                            validate150.errors = vErrors;
                            return false;
                          } else {
                            errors = _errs84;
                            if (vErrors !== null) {
                              if (_errs84) {
                                vErrors.length = _errs84;
                              } else {
                                vErrors = null;
                              }
                            }
                          }
                          var valid0 = _errs83 === errors;
                        } else {
                          var valid0 = true;
                        }
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
    } else {
      validate150.errors = [{
        instancePath,
        schemaPath: "#/type",
        keyword: "type",
        params: {
          type: "object"
        },
        message: "must be object"
      }];
      return false;
    }
  }
  validate150.errors = vErrors;
  return errors === 0;
}
const SubscriptionCancellation = validate152;
const schema162 = {
  "$id": "SubscriptionCancellation",
  "$schema": "http://json-schema.org/draft-07/schema#",
  "type": "object",
  "properties": {
    "initiated": {
      "type": "object",
      "format": "date-time"
    },
    "effective": {
      "type": "object",
      "format": "date-time"
    },
    "reason": {
      "type": "string"
    },
    "origin": {
      "type": "string",
      "enum": ["STRIPE", "APP"]
    },
    "canUncancel": {
      "type": "boolean"
    }
  },
  "required": ["initiated", "effective", "reason", "origin", "canUncancel"]
};
function validate152(data, {
  instancePath = "",
  parentData,
  parentDataProperty,
  rootData = data
} = {}) {
  let vErrors = null;
  let errors = 0;
  {
    if (data && typeof data == "object" && !Array.isArray(data)) {
      let missing0;
      if (data.initiated === void 0 && (missing0 = "initiated") || data.effective === void 0 && (missing0 = "effective") || data.reason === void 0 && (missing0 = "reason") || data.origin === void 0 && (missing0 = "origin") || data.canUncancel === void 0 && (missing0 = "canUncancel")) {
        validate152.errors = [{
          instancePath,
          schemaPath: "#/required",
          keyword: "required",
          params: {
            missingProperty: missing0
          },
          message: "must have required property '" + missing0 + "'"
        }];
        return false;
      } else {
        if (data.initiated !== void 0) {
          let data0 = data.initiated;
          const _errs1 = errors;
          if (!(data0 && typeof data0 == "object" && !Array.isArray(data0))) {
            validate152.errors = [{
              instancePath: instancePath + "/initiated",
              schemaPath: "#/properties/initiated/type",
              keyword: "type",
              params: {
                type: "object"
              },
              message: "must be object"
            }];
            return false;
          }
          {
            {
              if (typeof data0 === "string") {
                if (!formats0(data0)) {
                  validate152.errors = [{
                    instancePath: instancePath + "/initiated",
                    schemaPath: "#/properties/initiated/format",
                    keyword: "format",
                    params: {
                      format: "date-time"
                    },
                    message: 'must match format "date-time"'
                  }];
                  return false;
                }
              }
            }
          }
          var valid0 = _errs1 === errors;
        } else {
          var valid0 = true;
        }
        if (valid0) {
          if (data.effective !== void 0) {
            let data1 = data.effective;
            const _errs3 = errors;
            if (!(data1 && typeof data1 == "object" && !Array.isArray(data1))) {
              validate152.errors = [{
                instancePath: instancePath + "/effective",
                schemaPath: "#/properties/effective/type",
                keyword: "type",
                params: {
                  type: "object"
                },
                message: "must be object"
              }];
              return false;
            }
            {
              {
                if (typeof data1 === "string") {
                  if (!formats0(data1)) {
                    validate152.errors = [{
                      instancePath: instancePath + "/effective",
                      schemaPath: "#/properties/effective/format",
                      keyword: "format",
                      params: {
                        format: "date-time"
                      },
                      message: 'must match format "date-time"'
                    }];
                    return false;
                  }
                }
              }
            }
            var valid0 = _errs3 === errors;
          } else {
            var valid0 = true;
          }
          if (valid0) {
            if (data.reason !== void 0) {
              const _errs5 = errors;
              if (typeof data.reason !== "string") {
                validate152.errors = [{
                  instancePath: instancePath + "/reason",
                  schemaPath: "#/properties/reason/type",
                  keyword: "type",
                  params: {
                    type: "string"
                  },
                  message: "must be string"
                }];
                return false;
              }
              var valid0 = _errs5 === errors;
            } else {
              var valid0 = true;
            }
            if (valid0) {
              if (data.origin !== void 0) {
                let data3 = data.origin;
                const _errs7 = errors;
                if (typeof data3 !== "string") {
                  validate152.errors = [{
                    instancePath: instancePath + "/origin",
                    schemaPath: "#/properties/origin/type",
                    keyword: "type",
                    params: {
                      type: "string"
                    },
                    message: "must be string"
                  }];
                  return false;
                }
                if (!(data3 === "STRIPE" || data3 === "APP")) {
                  validate152.errors = [{
                    instancePath: instancePath + "/origin",
                    schemaPath: "#/properties/origin/enum",
                    keyword: "enum",
                    params: {
                      allowedValues: schema162.properties.origin.enum
                    },
                    message: "must be equal to one of the allowed values"
                  }];
                  return false;
                }
                var valid0 = _errs7 === errors;
              } else {
                var valid0 = true;
              }
              if (valid0) {
                if (data.canUncancel !== void 0) {
                  const _errs9 = errors;
                  if (typeof data.canUncancel !== "boolean") {
                    validate152.errors = [{
                      instancePath: instancePath + "/canUncancel",
                      schemaPath: "#/properties/canUncancel/type",
                      keyword: "type",
                      params: {
                        type: "boolean"
                      },
                      message: "must be boolean"
                    }];
                    return false;
                  }
                  var valid0 = _errs9 === errors;
                } else {
                  var valid0 = true;
                }
              }
            }
          }
        }
      }
    } else {
      validate152.errors = [{
        instancePath,
        schemaPath: "#/type",
        keyword: "type",
        params: {
          type: "object"
        },
        message: "must be object"
      }];
      return false;
    }
  }
  validate152.errors = vErrors;
  return errors === 0;
}
const SubscriptionStatus = validate153;
const schema163 = {
  "$id": "SubscriptionStatus",
  "$schema": "http://json-schema.org/draft-07/schema#",
  "type": "string",
  "enum": ["NEEDS_ACTION", "PAUSED", "PENDING", "TRIALING", "ACTIVE", "CANCELLING", "TERMINATED"]
};
function validate153(data, {
  instancePath = "",
  parentData,
  parentDataProperty,
  rootData = data
} = {}) {
  let vErrors = null;
  let errors = 0;
  if (typeof data !== "string") {
    validate153.errors = [{
      instancePath,
      schemaPath: "#/type",
      keyword: "type",
      params: {
        type: "string"
      },
      message: "must be string"
    }];
    return false;
  }
  if (!(data === "NEEDS_ACTION" || data === "PAUSED" || data === "PENDING" || data === "TRIALING" || data === "ACTIVE" || data === "CANCELLING" || data === "TERMINATED")) {
    validate153.errors = [{
      instancePath,
      schemaPath: "#/enum",
      keyword: "enum",
      params: {
        allowedValues: schema163.enum
      },
      message: "must be equal to one of the allowed values"
    }];
    return false;
  }
  validate153.errors = vErrors;
  return errors === 0;
}
const Subscription = validate154;
const schema164 = {
  "$id": "Subscription",
  "$schema": "http://json-schema.org/draft-07/schema#",
  "type": "object",
  "properties": {
    "status": {
      "$ref": "SubscriptionStatus"
    },
    "userId": {
      "type": "string"
    },
    "planId": {
      "type": "string"
    },
    "selectedConfig": {
      "type": "object",
      "properties": {
        "currency": {
          "type": "string"
        },
        "periodicity": {
          "$ref": "BillingPeriodicity"
        },
        "installments": {
          "type": ["boolean", "null"]
        }
      },
      "required": ["currency", "periodicity"]
    },
    "subscriptionId": {
      "type": "string"
    },
    "location": {
      "anyOf": [{
        "$ref": "UserLocation"
      }, {
        "type": "null"
      }]
    },
    "lastTimeUsed": {
      "anyOf": [{
        "type": "object",
        "format": "date-time"
      }, {
        "type": "null"
      }]
    },
    "coupon": {
      "type": ["string", "null"]
    },
    "cancellation": {
      "$ref": "SubscriptionCancellation"
    },
    "requiredUserAction": {
      "type": "object",
      "properties": {
        "code": {
          "type": "string"
        },
        "description": {
          "type": "string"
        },
        "referenceUrl": {
          "type": "string"
        }
      },
      "required": ["code"]
    },
    "pausedUntil": {
      "type": "object",
      "properties": {
        "date": {
          "type": "object",
          "format": "date-time"
        },
        "proratableTime": {
          "type": "number"
        }
      },
      "required": ["date", "proratableTime"]
    },
    "pauseDate": {
      "type": "object",
      "format": "date-time"
    },
    "nextPeriodicCheck": {
      "type": "object",
      "format": "date-time"
    },
    "lastReminderSentDate": {
      "type": "object",
      "format": "date-time"
    },
    "creationDate": {
      "type": "object",
      "format": "date-time"
    }
  },
  "required": ["status", "userId", "planId", "selectedConfig", "subscriptionId", "location", "lastTimeUsed", "coupon", "creationDate"]
};
function validate154(data, {
  instancePath = "",
  parentData,
  parentDataProperty,
  rootData = data
} = {}) {
  let vErrors = null;
  let errors = 0;
  if (errors === 0) {
    if (data && typeof data == "object" && !Array.isArray(data)) {
      let missing0;
      if (data.status === void 0 && (missing0 = "status") || data.userId === void 0 && (missing0 = "userId") || data.planId === void 0 && (missing0 = "planId") || data.selectedConfig === void 0 && (missing0 = "selectedConfig") || data.subscriptionId === void 0 && (missing0 = "subscriptionId") || data.location === void 0 && (missing0 = "location") || data.lastTimeUsed === void 0 && (missing0 = "lastTimeUsed") || data.coupon === void 0 && (missing0 = "coupon") || data.creationDate === void 0 && (missing0 = "creationDate")) {
        validate154.errors = [{
          instancePath,
          schemaPath: "#/required",
          keyword: "required",
          params: {
            missingProperty: missing0
          },
          message: "must have required property '" + missing0 + "'"
        }];
        return false;
      } else {
        if (data.status !== void 0) {
          let data0 = data.status;
          const _errs1 = errors;
          if (typeof data0 !== "string") {
            validate154.errors = [{
              instancePath: instancePath + "/status",
              schemaPath: "SubscriptionStatus/type",
              keyword: "type",
              params: {
                type: "string"
              },
              message: "must be string"
            }];
            return false;
          }
          if (!(data0 === "NEEDS_ACTION" || data0 === "PAUSED" || data0 === "PENDING" || data0 === "TRIALING" || data0 === "ACTIVE" || data0 === "CANCELLING" || data0 === "TERMINATED")) {
            validate154.errors = [{
              instancePath: instancePath + "/status",
              schemaPath: "SubscriptionStatus/enum",
              keyword: "enum",
              params: {
                allowedValues: schema163.enum
              },
              message: "must be equal to one of the allowed values"
            }];
            return false;
          }
          var valid0 = _errs1 === errors;
        } else {
          var valid0 = true;
        }
        if (valid0) {
          if (data.userId !== void 0) {
            const _errs4 = errors;
            if (typeof data.userId !== "string") {
              validate154.errors = [{
                instancePath: instancePath + "/userId",
                schemaPath: "#/properties/userId/type",
                keyword: "type",
                params: {
                  type: "string"
                },
                message: "must be string"
              }];
              return false;
            }
            var valid0 = _errs4 === errors;
          } else {
            var valid0 = true;
          }
          if (valid0) {
            if (data.planId !== void 0) {
              const _errs6 = errors;
              if (typeof data.planId !== "string") {
                validate154.errors = [{
                  instancePath: instancePath + "/planId",
                  schemaPath: "#/properties/planId/type",
                  keyword: "type",
                  params: {
                    type: "string"
                  },
                  message: "must be string"
                }];
                return false;
              }
              var valid0 = _errs6 === errors;
            } else {
              var valid0 = true;
            }
            if (valid0) {
              if (data.selectedConfig !== void 0) {
                let data3 = data.selectedConfig;
                const _errs8 = errors;
                if (errors === _errs8) {
                  if (data3 && typeof data3 == "object" && !Array.isArray(data3)) {
                    let missing1;
                    if (data3.currency === void 0 && (missing1 = "currency") || data3.periodicity === void 0 && (missing1 = "periodicity")) {
                      validate154.errors = [{
                        instancePath: instancePath + "/selectedConfig",
                        schemaPath: "#/properties/selectedConfig/required",
                        keyword: "required",
                        params: {
                          missingProperty: missing1
                        },
                        message: "must have required property '" + missing1 + "'"
                      }];
                      return false;
                    } else {
                      if (data3.currency !== void 0) {
                        const _errs10 = errors;
                        if (typeof data3.currency !== "string") {
                          validate154.errors = [{
                            instancePath: instancePath + "/selectedConfig/currency",
                            schemaPath: "#/properties/selectedConfig/properties/currency/type",
                            keyword: "type",
                            params: {
                              type: "string"
                            },
                            message: "must be string"
                          }];
                          return false;
                        }
                        var valid2 = _errs10 === errors;
                      } else {
                        var valid2 = true;
                      }
                      if (valid2) {
                        if (data3.periodicity !== void 0) {
                          let data5 = data3.periodicity;
                          const _errs12 = errors;
                          if (typeof data5 !== "string") {
                            validate154.errors = [{
                              instancePath: instancePath + "/selectedConfig/periodicity",
                              schemaPath: "BillingPeriodicity/type",
                              keyword: "type",
                              params: {
                                type: "string"
                              },
                              message: "must be string"
                            }];
                            return false;
                          }
                          if (!(data5 === "MONTHLY" || data5 === "YEARLY")) {
                            validate154.errors = [{
                              instancePath: instancePath + "/selectedConfig/periodicity",
                              schemaPath: "BillingPeriodicity/enum",
                              keyword: "enum",
                              params: {
                                allowedValues: schema21.enum
                              },
                              message: "must be equal to one of the allowed values"
                            }];
                            return false;
                          }
                          var valid2 = _errs12 === errors;
                        } else {
                          var valid2 = true;
                        }
                        if (valid2) {
                          if (data3.installments !== void 0) {
                            let data6 = data3.installments;
                            const _errs15 = errors;
                            if (typeof data6 !== "boolean" && data6 !== null) {
                              validate154.errors = [{
                                instancePath: instancePath + "/selectedConfig/installments",
                                schemaPath: "#/properties/selectedConfig/properties/installments/type",
                                keyword: "type",
                                params: {
                                  type: schema164.properties.selectedConfig.properties.installments.type
                                },
                                message: "must be boolean,null"
                              }];
                              return false;
                            }
                            var valid2 = _errs15 === errors;
                          } else {
                            var valid2 = true;
                          }
                        }
                      }
                    }
                  } else {
                    validate154.errors = [{
                      instancePath: instancePath + "/selectedConfig",
                      schemaPath: "#/properties/selectedConfig/type",
                      keyword: "type",
                      params: {
                        type: "object"
                      },
                      message: "must be object"
                    }];
                    return false;
                  }
                }
                var valid0 = _errs8 === errors;
              } else {
                var valid0 = true;
              }
              if (valid0) {
                if (data.subscriptionId !== void 0) {
                  const _errs17 = errors;
                  if (typeof data.subscriptionId !== "string") {
                    validate154.errors = [{
                      instancePath: instancePath + "/subscriptionId",
                      schemaPath: "#/properties/subscriptionId/type",
                      keyword: "type",
                      params: {
                        type: "string"
                      },
                      message: "must be string"
                    }];
                    return false;
                  }
                  var valid0 = _errs17 === errors;
                } else {
                  var valid0 = true;
                }
                if (valid0) {
                  if (data.location !== void 0) {
                    let data8 = data.location;
                    const _errs19 = errors;
                    const _errs20 = errors;
                    let valid4 = false;
                    const _errs21 = errors;
                    const _errs22 = errors;
                    if (errors === _errs22) {
                      if (data8 && typeof data8 == "object" && !Array.isArray(data8)) {
                        let missing2;
                        if (data8.IP === void 0 && (missing2 = "IP") || data8.latlng === void 0 && (missing2 = "latlng") || data8.city === void 0 && (missing2 = "city") || data8.country === void 0 && (missing2 = "country") || data8.region === void 0 && (missing2 = "region")) {
                          const err0 = {
                            instancePath: instancePath + "/location",
                            schemaPath: "UserLocation/required",
                            keyword: "required",
                            params: {
                              missingProperty: missing2
                            },
                            message: "must have required property '" + missing2 + "'"
                          };
                          if (vErrors === null) {
                            vErrors = [err0];
                          } else {
                            vErrors.push(err0);
                          }
                          errors++;
                        } else {
                          if (data8.IP !== void 0) {
                            let data9 = data8.IP;
                            const _errs24 = errors;
                            if (typeof data9 !== "string" && data9 !== null) {
                              const err1 = {
                                instancePath: instancePath + "/location/IP",
                                schemaPath: "UserLocation/properties/IP/type",
                                keyword: "type",
                                params: {
                                  type: schema47.properties.IP.type
                                },
                                message: "must be string,null"
                              };
                              if (vErrors === null) {
                                vErrors = [err1];
                              } else {
                                vErrors.push(err1);
                              }
                              errors++;
                            }
                            var valid6 = _errs24 === errors;
                          } else {
                            var valid6 = true;
                          }
                          if (valid6) {
                            if (data8.latlng !== void 0) {
                              let data10 = data8.latlng;
                              const _errs26 = errors;
                              if (typeof data10 !== "string" && data10 !== null) {
                                const err2 = {
                                  instancePath: instancePath + "/location/latlng",
                                  schemaPath: "UserLocation/properties/latlng/type",
                                  keyword: "type",
                                  params: {
                                    type: schema47.properties.latlng.type
                                  },
                                  message: "must be string,null"
                                };
                                if (vErrors === null) {
                                  vErrors = [err2];
                                } else {
                                  vErrors.push(err2);
                                }
                                errors++;
                              }
                              var valid6 = _errs26 === errors;
                            } else {
                              var valid6 = true;
                            }
                            if (valid6) {
                              if (data8.city !== void 0) {
                                let data11 = data8.city;
                                const _errs28 = errors;
                                if (typeof data11 !== "string" && data11 !== null) {
                                  const err3 = {
                                    instancePath: instancePath + "/location/city",
                                    schemaPath: "UserLocation/properties/city/type",
                                    keyword: "type",
                                    params: {
                                      type: schema47.properties.city.type
                                    },
                                    message: "must be string,null"
                                  };
                                  if (vErrors === null) {
                                    vErrors = [err3];
                                  } else {
                                    vErrors.push(err3);
                                  }
                                  errors++;
                                }
                                var valid6 = _errs28 === errors;
                              } else {
                                var valid6 = true;
                              }
                              if (valid6) {
                                if (data8.country !== void 0) {
                                  let data12 = data8.country;
                                  const _errs30 = errors;
                                  if (typeof data12 !== "string" && data12 !== null) {
                                    const err4 = {
                                      instancePath: instancePath + "/location/country",
                                      schemaPath: "UserLocation/properties/country/type",
                                      keyword: "type",
                                      params: {
                                        type: schema47.properties.country.type
                                      },
                                      message: "must be string,null"
                                    };
                                    if (vErrors === null) {
                                      vErrors = [err4];
                                    } else {
                                      vErrors.push(err4);
                                    }
                                    errors++;
                                  }
                                  var valid6 = _errs30 === errors;
                                } else {
                                  var valid6 = true;
                                }
                                if (valid6) {
                                  if (data8.region !== void 0) {
                                    let data13 = data8.region;
                                    const _errs32 = errors;
                                    if (typeof data13 !== "string" && data13 !== null) {
                                      const err5 = {
                                        instancePath: instancePath + "/location/region",
                                        schemaPath: "UserLocation/properties/region/type",
                                        keyword: "type",
                                        params: {
                                          type: schema47.properties.region.type
                                        },
                                        message: "must be string,null"
                                      };
                                      if (vErrors === null) {
                                        vErrors = [err5];
                                      } else {
                                        vErrors.push(err5);
                                      }
                                      errors++;
                                    }
                                    var valid6 = _errs32 === errors;
                                  } else {
                                    var valid6 = true;
                                  }
                                }
                              }
                            }
                          }
                        }
                      } else {
                        const err6 = {
                          instancePath: instancePath + "/location",
                          schemaPath: "UserLocation/type",
                          keyword: "type",
                          params: {
                            type: "object"
                          },
                          message: "must be object"
                        };
                        if (vErrors === null) {
                          vErrors = [err6];
                        } else {
                          vErrors.push(err6);
                        }
                        errors++;
                      }
                    }
                    var _valid0 = _errs21 === errors;
                    valid4 = valid4 || _valid0;
                    if (!valid4) {
                      const _errs34 = errors;
                      if (data8 !== null) {
                        const err7 = {
                          instancePath: instancePath + "/location",
                          schemaPath: "#/properties/location/anyOf/1/type",
                          keyword: "type",
                          params: {
                            type: "null"
                          },
                          message: "must be null"
                        };
                        if (vErrors === null) {
                          vErrors = [err7];
                        } else {
                          vErrors.push(err7);
                        }
                        errors++;
                      }
                      var _valid0 = _errs34 === errors;
                      valid4 = valid4 || _valid0;
                    }
                    if (!valid4) {
                      const err8 = {
                        instancePath: instancePath + "/location",
                        schemaPath: "#/properties/location/anyOf",
                        keyword: "anyOf",
                        params: {},
                        message: "must match a schema in anyOf"
                      };
                      if (vErrors === null) {
                        vErrors = [err8];
                      } else {
                        vErrors.push(err8);
                      }
                      errors++;
                      validate154.errors = vErrors;
                      return false;
                    } else {
                      errors = _errs20;
                      if (vErrors !== null) {
                        if (_errs20) {
                          vErrors.length = _errs20;
                        } else {
                          vErrors = null;
                        }
                      }
                    }
                    var valid0 = _errs19 === errors;
                  } else {
                    var valid0 = true;
                  }
                  if (valid0) {
                    if (data.lastTimeUsed !== void 0) {
                      let data14 = data.lastTimeUsed;
                      const _errs36 = errors;
                      const _errs37 = errors;
                      let valid7 = false;
                      const _errs38 = errors;
                      if (!(data14 && typeof data14 == "object" && !Array.isArray(data14))) {
                        const err9 = {
                          instancePath: instancePath + "/lastTimeUsed",
                          schemaPath: "#/properties/lastTimeUsed/anyOf/0/type",
                          keyword: "type",
                          params: {
                            type: "object"
                          },
                          message: "must be object"
                        };
                        if (vErrors === null) {
                          vErrors = [err9];
                        } else {
                          vErrors.push(err9);
                        }
                        errors++;
                      }
                      if (errors === _errs38) {
                        if (errors === _errs38) {
                          if (typeof data14 === "string") {
                            if (!formats0(data14)) {
                              const err10 = {
                                instancePath: instancePath + "/lastTimeUsed",
                                schemaPath: "#/properties/lastTimeUsed/anyOf/0/format",
                                keyword: "format",
                                params: {
                                  format: "date-time"
                                },
                                message: 'must match format "date-time"'
                              };
                              if (vErrors === null) {
                                vErrors = [err10];
                              } else {
                                vErrors.push(err10);
                              }
                              errors++;
                            }
                          }
                        }
                      }
                      var _valid1 = _errs38 === errors;
                      valid7 = valid7 || _valid1;
                      if (!valid7) {
                        const _errs40 = errors;
                        if (data14 !== null) {
                          const err11 = {
                            instancePath: instancePath + "/lastTimeUsed",
                            schemaPath: "#/properties/lastTimeUsed/anyOf/1/type",
                            keyword: "type",
                            params: {
                              type: "null"
                            },
                            message: "must be null"
                          };
                          if (vErrors === null) {
                            vErrors = [err11];
                          } else {
                            vErrors.push(err11);
                          }
                          errors++;
                        }
                        var _valid1 = _errs40 === errors;
                        valid7 = valid7 || _valid1;
                      }
                      if (!valid7) {
                        const err12 = {
                          instancePath: instancePath + "/lastTimeUsed",
                          schemaPath: "#/properties/lastTimeUsed/anyOf",
                          keyword: "anyOf",
                          params: {},
                          message: "must match a schema in anyOf"
                        };
                        if (vErrors === null) {
                          vErrors = [err12];
                        } else {
                          vErrors.push(err12);
                        }
                        errors++;
                        validate154.errors = vErrors;
                        return false;
                      } else {
                        errors = _errs37;
                        if (vErrors !== null) {
                          if (_errs37) {
                            vErrors.length = _errs37;
                          } else {
                            vErrors = null;
                          }
                        }
                      }
                      var valid0 = _errs36 === errors;
                    } else {
                      var valid0 = true;
                    }
                    if (valid0) {
                      if (data.coupon !== void 0) {
                        let data15 = data.coupon;
                        const _errs42 = errors;
                        if (typeof data15 !== "string" && data15 !== null) {
                          validate154.errors = [{
                            instancePath: instancePath + "/coupon",
                            schemaPath: "#/properties/coupon/type",
                            keyword: "type",
                            params: {
                              type: schema164.properties.coupon.type
                            },
                            message: "must be string,null"
                          }];
                          return false;
                        }
                        var valid0 = _errs42 === errors;
                      } else {
                        var valid0 = true;
                      }
                      if (valid0) {
                        if (data.cancellation !== void 0) {
                          let data16 = data.cancellation;
                          const _errs44 = errors;
                          const _errs45 = errors;
                          if (errors === _errs45) {
                            if (data16 && typeof data16 == "object" && !Array.isArray(data16)) {
                              let missing3;
                              if (data16.initiated === void 0 && (missing3 = "initiated") || data16.effective === void 0 && (missing3 = "effective") || data16.reason === void 0 && (missing3 = "reason") || data16.origin === void 0 && (missing3 = "origin") || data16.canUncancel === void 0 && (missing3 = "canUncancel")) {
                                validate154.errors = [{
                                  instancePath: instancePath + "/cancellation",
                                  schemaPath: "SubscriptionCancellation/required",
                                  keyword: "required",
                                  params: {
                                    missingProperty: missing3
                                  },
                                  message: "must have required property '" + missing3 + "'"
                                }];
                                return false;
                              } else {
                                if (data16.initiated !== void 0) {
                                  let data17 = data16.initiated;
                                  const _errs47 = errors;
                                  if (!(data17 && typeof data17 == "object" && !Array.isArray(data17))) {
                                    validate154.errors = [{
                                      instancePath: instancePath + "/cancellation/initiated",
                                      schemaPath: "SubscriptionCancellation/properties/initiated/type",
                                      keyword: "type",
                                      params: {
                                        type: "object"
                                      },
                                      message: "must be object"
                                    }];
                                    return false;
                                  }
                                  if (errors === _errs47) {
                                    if (errors === _errs47) {
                                      if (typeof data17 === "string") {
                                        if (!formats0(data17)) {
                                          validate154.errors = [{
                                            instancePath: instancePath + "/cancellation/initiated",
                                            schemaPath: "SubscriptionCancellation/properties/initiated/format",
                                            keyword: "format",
                                            params: {
                                              format: "date-time"
                                            },
                                            message: 'must match format "date-time"'
                                          }];
                                          return false;
                                        }
                                      }
                                    }
                                  }
                                  var valid9 = _errs47 === errors;
                                } else {
                                  var valid9 = true;
                                }
                                if (valid9) {
                                  if (data16.effective !== void 0) {
                                    let data18 = data16.effective;
                                    const _errs49 = errors;
                                    if (!(data18 && typeof data18 == "object" && !Array.isArray(data18))) {
                                      validate154.errors = [{
                                        instancePath: instancePath + "/cancellation/effective",
                                        schemaPath: "SubscriptionCancellation/properties/effective/type",
                                        keyword: "type",
                                        params: {
                                          type: "object"
                                        },
                                        message: "must be object"
                                      }];
                                      return false;
                                    }
                                    if (errors === _errs49) {
                                      if (errors === _errs49) {
                                        if (typeof data18 === "string") {
                                          if (!formats0(data18)) {
                                            validate154.errors = [{
                                              instancePath: instancePath + "/cancellation/effective",
                                              schemaPath: "SubscriptionCancellation/properties/effective/format",
                                              keyword: "format",
                                              params: {
                                                format: "date-time"
                                              },
                                              message: 'must match format "date-time"'
                                            }];
                                            return false;
                                          }
                                        }
                                      }
                                    }
                                    var valid9 = _errs49 === errors;
                                  } else {
                                    var valid9 = true;
                                  }
                                  if (valid9) {
                                    if (data16.reason !== void 0) {
                                      const _errs51 = errors;
                                      if (typeof data16.reason !== "string") {
                                        validate154.errors = [{
                                          instancePath: instancePath + "/cancellation/reason",
                                          schemaPath: "SubscriptionCancellation/properties/reason/type",
                                          keyword: "type",
                                          params: {
                                            type: "string"
                                          },
                                          message: "must be string"
                                        }];
                                        return false;
                                      }
                                      var valid9 = _errs51 === errors;
                                    } else {
                                      var valid9 = true;
                                    }
                                    if (valid9) {
                                      if (data16.origin !== void 0) {
                                        let data20 = data16.origin;
                                        const _errs53 = errors;
                                        if (typeof data20 !== "string") {
                                          validate154.errors = [{
                                            instancePath: instancePath + "/cancellation/origin",
                                            schemaPath: "SubscriptionCancellation/properties/origin/type",
                                            keyword: "type",
                                            params: {
                                              type: "string"
                                            },
                                            message: "must be string"
                                          }];
                                          return false;
                                        }
                                        if (!(data20 === "STRIPE" || data20 === "APP")) {
                                          validate154.errors = [{
                                            instancePath: instancePath + "/cancellation/origin",
                                            schemaPath: "SubscriptionCancellation/properties/origin/enum",
                                            keyword: "enum",
                                            params: {
                                              allowedValues: schema162.properties.origin.enum
                                            },
                                            message: "must be equal to one of the allowed values"
                                          }];
                                          return false;
                                        }
                                        var valid9 = _errs53 === errors;
                                      } else {
                                        var valid9 = true;
                                      }
                                      if (valid9) {
                                        if (data16.canUncancel !== void 0) {
                                          const _errs55 = errors;
                                          if (typeof data16.canUncancel !== "boolean") {
                                            validate154.errors = [{
                                              instancePath: instancePath + "/cancellation/canUncancel",
                                              schemaPath: "SubscriptionCancellation/properties/canUncancel/type",
                                              keyword: "type",
                                              params: {
                                                type: "boolean"
                                              },
                                              message: "must be boolean"
                                            }];
                                            return false;
                                          }
                                          var valid9 = _errs55 === errors;
                                        } else {
                                          var valid9 = true;
                                        }
                                      }
                                    }
                                  }
                                }
                              }
                            } else {
                              validate154.errors = [{
                                instancePath: instancePath + "/cancellation",
                                schemaPath: "SubscriptionCancellation/type",
                                keyword: "type",
                                params: {
                                  type: "object"
                                },
                                message: "must be object"
                              }];
                              return false;
                            }
                          }
                          var valid0 = _errs44 === errors;
                        } else {
                          var valid0 = true;
                        }
                        if (valid0) {
                          if (data.requiredUserAction !== void 0) {
                            let data22 = data.requiredUserAction;
                            const _errs57 = errors;
                            if (errors === _errs57) {
                              if (data22 && typeof data22 == "object" && !Array.isArray(data22)) {
                                let missing4;
                                if (data22.code === void 0 && (missing4 = "code")) {
                                  validate154.errors = [{
                                    instancePath: instancePath + "/requiredUserAction",
                                    schemaPath: "#/properties/requiredUserAction/required",
                                    keyword: "required",
                                    params: {
                                      missingProperty: missing4
                                    },
                                    message: "must have required property '" + missing4 + "'"
                                  }];
                                  return false;
                                } else {
                                  if (data22.code !== void 0) {
                                    const _errs59 = errors;
                                    if (typeof data22.code !== "string") {
                                      validate154.errors = [{
                                        instancePath: instancePath + "/requiredUserAction/code",
                                        schemaPath: "#/properties/requiredUserAction/properties/code/type",
                                        keyword: "type",
                                        params: {
                                          type: "string"
                                        },
                                        message: "must be string"
                                      }];
                                      return false;
                                    }
                                    var valid10 = _errs59 === errors;
                                  } else {
                                    var valid10 = true;
                                  }
                                  if (valid10) {
                                    if (data22.description !== void 0) {
                                      const _errs61 = errors;
                                      if (typeof data22.description !== "string") {
                                        validate154.errors = [{
                                          instancePath: instancePath + "/requiredUserAction/description",
                                          schemaPath: "#/properties/requiredUserAction/properties/description/type",
                                          keyword: "type",
                                          params: {
                                            type: "string"
                                          },
                                          message: "must be string"
                                        }];
                                        return false;
                                      }
                                      var valid10 = _errs61 === errors;
                                    } else {
                                      var valid10 = true;
                                    }
                                    if (valid10) {
                                      if (data22.referenceUrl !== void 0) {
                                        const _errs63 = errors;
                                        if (typeof data22.referenceUrl !== "string") {
                                          validate154.errors = [{
                                            instancePath: instancePath + "/requiredUserAction/referenceUrl",
                                            schemaPath: "#/properties/requiredUserAction/properties/referenceUrl/type",
                                            keyword: "type",
                                            params: {
                                              type: "string"
                                            },
                                            message: "must be string"
                                          }];
                                          return false;
                                        }
                                        var valid10 = _errs63 === errors;
                                      } else {
                                        var valid10 = true;
                                      }
                                    }
                                  }
                                }
                              } else {
                                validate154.errors = [{
                                  instancePath: instancePath + "/requiredUserAction",
                                  schemaPath: "#/properties/requiredUserAction/type",
                                  keyword: "type",
                                  params: {
                                    type: "object"
                                  },
                                  message: "must be object"
                                }];
                                return false;
                              }
                            }
                            var valid0 = _errs57 === errors;
                          } else {
                            var valid0 = true;
                          }
                          if (valid0) {
                            if (data.pausedUntil !== void 0) {
                              let data26 = data.pausedUntil;
                              const _errs65 = errors;
                              if (errors === _errs65) {
                                if (data26 && typeof data26 == "object" && !Array.isArray(data26)) {
                                  let missing5;
                                  if (data26.date === void 0 && (missing5 = "date") || data26.proratableTime === void 0 && (missing5 = "proratableTime")) {
                                    validate154.errors = [{
                                      instancePath: instancePath + "/pausedUntil",
                                      schemaPath: "#/properties/pausedUntil/required",
                                      keyword: "required",
                                      params: {
                                        missingProperty: missing5
                                      },
                                      message: "must have required property '" + missing5 + "'"
                                    }];
                                    return false;
                                  } else {
                                    if (data26.date !== void 0) {
                                      let data27 = data26.date;
                                      const _errs67 = errors;
                                      if (!(data27 && typeof data27 == "object" && !Array.isArray(data27))) {
                                        validate154.errors = [{
                                          instancePath: instancePath + "/pausedUntil/date",
                                          schemaPath: "#/properties/pausedUntil/properties/date/type",
                                          keyword: "type",
                                          params: {
                                            type: "object"
                                          },
                                          message: "must be object"
                                        }];
                                        return false;
                                      }
                                      if (errors === _errs67) {
                                        if (errors === _errs67) {
                                          if (typeof data27 === "string") {
                                            if (!formats0(data27)) {
                                              validate154.errors = [{
                                                instancePath: instancePath + "/pausedUntil/date",
                                                schemaPath: "#/properties/pausedUntil/properties/date/format",
                                                keyword: "format",
                                                params: {
                                                  format: "date-time"
                                                },
                                                message: 'must match format "date-time"'
                                              }];
                                              return false;
                                            }
                                          }
                                        }
                                      }
                                      var valid11 = _errs67 === errors;
                                    } else {
                                      var valid11 = true;
                                    }
                                    if (valid11) {
                                      if (data26.proratableTime !== void 0) {
                                        let data28 = data26.proratableTime;
                                        const _errs69 = errors;
                                        if (!(typeof data28 == "number" && isFinite(data28))) {
                                          validate154.errors = [{
                                            instancePath: instancePath + "/pausedUntil/proratableTime",
                                            schemaPath: "#/properties/pausedUntil/properties/proratableTime/type",
                                            keyword: "type",
                                            params: {
                                              type: "number"
                                            },
                                            message: "must be number"
                                          }];
                                          return false;
                                        }
                                        var valid11 = _errs69 === errors;
                                      } else {
                                        var valid11 = true;
                                      }
                                    }
                                  }
                                } else {
                                  validate154.errors = [{
                                    instancePath: instancePath + "/pausedUntil",
                                    schemaPath: "#/properties/pausedUntil/type",
                                    keyword: "type",
                                    params: {
                                      type: "object"
                                    },
                                    message: "must be object"
                                  }];
                                  return false;
                                }
                              }
                              var valid0 = _errs65 === errors;
                            } else {
                              var valid0 = true;
                            }
                            if (valid0) {
                              if (data.pauseDate !== void 0) {
                                let data29 = data.pauseDate;
                                const _errs71 = errors;
                                if (!(data29 && typeof data29 == "object" && !Array.isArray(data29))) {
                                  validate154.errors = [{
                                    instancePath: instancePath + "/pauseDate",
                                    schemaPath: "#/properties/pauseDate/type",
                                    keyword: "type",
                                    params: {
                                      type: "object"
                                    },
                                    message: "must be object"
                                  }];
                                  return false;
                                }
                                if (errors === _errs71) {
                                  if (errors === _errs71) {
                                    if (typeof data29 === "string") {
                                      if (!formats0(data29)) {
                                        validate154.errors = [{
                                          instancePath: instancePath + "/pauseDate",
                                          schemaPath: "#/properties/pauseDate/format",
                                          keyword: "format",
                                          params: {
                                            format: "date-time"
                                          },
                                          message: 'must match format "date-time"'
                                        }];
                                        return false;
                                      }
                                    }
                                  }
                                }
                                var valid0 = _errs71 === errors;
                              } else {
                                var valid0 = true;
                              }
                              if (valid0) {
                                if (data.nextPeriodicCheck !== void 0) {
                                  let data30 = data.nextPeriodicCheck;
                                  const _errs73 = errors;
                                  if (!(data30 && typeof data30 == "object" && !Array.isArray(data30))) {
                                    validate154.errors = [{
                                      instancePath: instancePath + "/nextPeriodicCheck",
                                      schemaPath: "#/properties/nextPeriodicCheck/type",
                                      keyword: "type",
                                      params: {
                                        type: "object"
                                      },
                                      message: "must be object"
                                    }];
                                    return false;
                                  }
                                  if (errors === _errs73) {
                                    if (errors === _errs73) {
                                      if (typeof data30 === "string") {
                                        if (!formats0(data30)) {
                                          validate154.errors = [{
                                            instancePath: instancePath + "/nextPeriodicCheck",
                                            schemaPath: "#/properties/nextPeriodicCheck/format",
                                            keyword: "format",
                                            params: {
                                              format: "date-time"
                                            },
                                            message: 'must match format "date-time"'
                                          }];
                                          return false;
                                        }
                                      }
                                    }
                                  }
                                  var valid0 = _errs73 === errors;
                                } else {
                                  var valid0 = true;
                                }
                                if (valid0) {
                                  if (data.lastReminderSentDate !== void 0) {
                                    let data31 = data.lastReminderSentDate;
                                    const _errs75 = errors;
                                    if (!(data31 && typeof data31 == "object" && !Array.isArray(data31))) {
                                      validate154.errors = [{
                                        instancePath: instancePath + "/lastReminderSentDate",
                                        schemaPath: "#/properties/lastReminderSentDate/type",
                                        keyword: "type",
                                        params: {
                                          type: "object"
                                        },
                                        message: "must be object"
                                      }];
                                      return false;
                                    }
                                    if (errors === _errs75) {
                                      if (errors === _errs75) {
                                        if (typeof data31 === "string") {
                                          if (!formats0(data31)) {
                                            validate154.errors = [{
                                              instancePath: instancePath + "/lastReminderSentDate",
                                              schemaPath: "#/properties/lastReminderSentDate/format",
                                              keyword: "format",
                                              params: {
                                                format: "date-time"
                                              },
                                              message: 'must match format "date-time"'
                                            }];
                                            return false;
                                          }
                                        }
                                      }
                                    }
                                    var valid0 = _errs75 === errors;
                                  } else {
                                    var valid0 = true;
                                  }
                                  if (valid0) {
                                    if (data.creationDate !== void 0) {
                                      let data32 = data.creationDate;
                                      const _errs77 = errors;
                                      if (!(data32 && typeof data32 == "object" && !Array.isArray(data32))) {
                                        validate154.errors = [{
                                          instancePath: instancePath + "/creationDate",
                                          schemaPath: "#/properties/creationDate/type",
                                          keyword: "type",
                                          params: {
                                            type: "object"
                                          },
                                          message: "must be object"
                                        }];
                                        return false;
                                      }
                                      if (errors === _errs77) {
                                        if (errors === _errs77) {
                                          if (typeof data32 === "string") {
                                            if (!formats0(data32)) {
                                              validate154.errors = [{
                                                instancePath: instancePath + "/creationDate",
                                                schemaPath: "#/properties/creationDate/format",
                                                keyword: "format",
                                                params: {
                                                  format: "date-time"
                                                },
                                                message: 'must match format "date-time"'
                                              }];
                                              return false;
                                            }
                                          }
                                        }
                                      }
                                      var valid0 = _errs77 === errors;
                                    } else {
                                      var valid0 = true;
                                    }
                                  }
                                }
                              }
                            }
                          }
                        }
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
    } else {
      validate154.errors = [{
        instancePath,
        schemaPath: "#/type",
        keyword: "type",
        params: {
          type: "object"
        },
        message: "must be object"
      }];
      return false;
    }
  }
  validate154.errors = vErrors;
  return errors === 0;
}
const GetAccessRequest = validate155;
function validate155(data, {
  instancePath = "",
  parentData,
  parentDataProperty,
  rootData = data
} = {}) {
  let vErrors = null;
  let errors = 0;
  {
    if (data && typeof data == "object" && !Array.isArray(data)) {
      let missing0;
      if (data.videoId === void 0 && (missing0 = "videoId") || data.channelId === void 0 && (missing0 = "channelId")) {
        validate155.errors = [{
          instancePath,
          schemaPath: "#/required",
          keyword: "required",
          params: {
            missingProperty: missing0
          },
          message: "must have required property '" + missing0 + "'"
        }];
        return false;
      } else {
        if (data.videoId !== void 0) {
          const _errs1 = errors;
          if (typeof data.videoId !== "string") {
            validate155.errors = [{
              instancePath: instancePath + "/videoId",
              schemaPath: "#/properties/videoId/type",
              keyword: "type",
              params: {
                type: "string"
              },
              message: "must be string"
            }];
            return false;
          }
          var valid0 = _errs1 === errors;
        } else {
          var valid0 = true;
        }
        if (valid0) {
          if (data.channelId !== void 0) {
            const _errs3 = errors;
            if (typeof data.channelId !== "string") {
              validate155.errors = [{
                instancePath: instancePath + "/channelId",
                schemaPath: "#/properties/channelId/type",
                keyword: "type",
                params: {
                  type: "string"
                },
                message: "must be string"
              }];
              return false;
            }
            var valid0 = _errs3 === errors;
          } else {
            var valid0 = true;
          }
        }
      }
    } else {
      validate155.errors = [{
        instancePath,
        schemaPath: "#/type",
        keyword: "type",
        params: {
          type: "object"
        },
        message: "must be object"
      }];
      return false;
    }
  }
  validate155.errors = vErrors;
  return errors === 0;
}
const GetAccessGrantType = validate156;
function validate156(data, {
  instancePath = "",
  parentData,
  parentDataProperty,
  rootData = data
} = {}) {
  let vErrors = null;
  let errors = 0;
  const _errs0 = errors;
  let valid0 = false;
  const _errs1 = errors;
  if (errors === _errs1) {
    if (data && typeof data == "object" && !Array.isArray(data)) {
      let missing0;
      if (data.type === void 0 && (missing0 = "type") || data.ticketEntries === void 0 && (missing0 = "ticketEntries")) {
        const err0 = {
          instancePath,
          schemaPath: "#/anyOf/0/required",
          keyword: "required",
          params: {
            missingProperty: missing0
          },
          message: "must have required property '" + missing0 + "'"
        };
        if (vErrors === null) {
          vErrors = [err0];
        } else {
          vErrors.push(err0);
        }
        errors++;
      } else {
        if (data.type !== void 0) {
          let data0 = data.type;
          const _errs3 = errors;
          if (typeof data0 !== "string") {
            const err1 = {
              instancePath: instancePath + "/type",
              schemaPath: "#/anyOf/0/properties/type/type",
              keyword: "type",
              params: {
                type: "string"
              },
              message: "must be string"
            };
            if (vErrors === null) {
              vErrors = [err1];
            } else {
              vErrors.push(err1);
            }
            errors++;
          }
          if ("TICKET" !== data0) {
            const err2 = {
              instancePath: instancePath + "/type",
              schemaPath: "#/anyOf/0/properties/type/const",
              keyword: "const",
              params: {
                allowedValue: "TICKET"
              },
              message: "must be equal to constant"
            };
            if (vErrors === null) {
              vErrors = [err2];
            } else {
              vErrors.push(err2);
            }
            errors++;
          }
          var valid1 = _errs3 === errors;
        } else {
          var valid1 = true;
        }
        if (valid1) {
          if (data.ticketEntries !== void 0) {
            let data1 = data.ticketEntries;
            const _errs5 = errors;
            if (errors === _errs5) {
              if (Array.isArray(data1)) {
                var valid2 = true;
                const len0 = data1.length;
                for (let i0 = 0; i0 < len0; i0++) {
                  let data2 = data1[i0];
                  const _errs7 = errors;
                  if (errors === _errs7) {
                    if (data2 && typeof data2 == "object" && !Array.isArray(data2)) {
                      let missing1;
                      if (data2.entry === void 0 && (missing1 = "entry") || data2.id === void 0 && (missing1 = "id")) {
                        const err3 = {
                          instancePath: instancePath + "/ticketEntries/" + i0,
                          schemaPath: "#/anyOf/0/properties/ticketEntries/items/required",
                          keyword: "required",
                          params: {
                            missingProperty: missing1
                          },
                          message: "must have required property '" + missing1 + "'"
                        };
                        if (vErrors === null) {
                          vErrors = [err3];
                        } else {
                          vErrors.push(err3);
                        }
                        errors++;
                      } else {
                        if (data2.entry !== void 0) {
                          const _errs9 = errors;
                          if (!validate36(data2.entry, {
                            instancePath: instancePath + "/ticketEntries/" + i0 + "/entry",
                            parentData: data2,
                            parentDataProperty: "entry",
                            rootData
                          })) {
                            vErrors = vErrors === null ? validate36.errors : vErrors.concat(validate36.errors);
                            errors = vErrors.length;
                          }
                          var valid3 = _errs9 === errors;
                        } else {
                          var valid3 = true;
                        }
                        if (valid3) {
                          if (data2.id !== void 0) {
                            const _errs10 = errors;
                            if (typeof data2.id !== "string") {
                              const err4 = {
                                instancePath: instancePath + "/ticketEntries/" + i0 + "/id",
                                schemaPath: "#/anyOf/0/properties/ticketEntries/items/properties/id/type",
                                keyword: "type",
                                params: {
                                  type: "string"
                                },
                                message: "must be string"
                              };
                              if (vErrors === null) {
                                vErrors = [err4];
                              } else {
                                vErrors.push(err4);
                              }
                              errors++;
                            }
                            var valid3 = _errs10 === errors;
                          } else {
                            var valid3 = true;
                          }
                        }
                      }
                    } else {
                      const err5 = {
                        instancePath: instancePath + "/ticketEntries/" + i0,
                        schemaPath: "#/anyOf/0/properties/ticketEntries/items/type",
                        keyword: "type",
                        params: {
                          type: "object"
                        },
                        message: "must be object"
                      };
                      if (vErrors === null) {
                        vErrors = [err5];
                      } else {
                        vErrors.push(err5);
                      }
                      errors++;
                    }
                  }
                  var valid2 = _errs7 === errors;
                  if (!valid2) {
                    break;
                  }
                }
              } else {
                const err6 = {
                  instancePath: instancePath + "/ticketEntries",
                  schemaPath: "#/anyOf/0/properties/ticketEntries/type",
                  keyword: "type",
                  params: {
                    type: "array"
                  },
                  message: "must be array"
                };
                if (vErrors === null) {
                  vErrors = [err6];
                } else {
                  vErrors.push(err6);
                }
                errors++;
              }
            }
            var valid1 = _errs5 === errors;
          } else {
            var valid1 = true;
          }
        }
      }
    } else {
      const err7 = {
        instancePath,
        schemaPath: "#/anyOf/0/type",
        keyword: "type",
        params: {
          type: "object"
        },
        message: "must be object"
      };
      if (vErrors === null) {
        vErrors = [err7];
      } else {
        vErrors.push(err7);
      }
      errors++;
    }
  }
  var _valid0 = _errs1 === errors;
  valid0 = valid0 || _valid0;
  if (!valid0) {
    const _errs12 = errors;
    if (errors === _errs12) {
      if (data && typeof data == "object" && !Array.isArray(data)) {
        let missing2;
        if (data.type === void 0 && (missing2 = "type") || data.subscriptionEntry === void 0 && (missing2 = "subscriptionEntry") || data.subscriptionEntryId === void 0 && (missing2 = "subscriptionEntryId") || data.planId === void 0 && (missing2 = "planId")) {
          const err8 = {
            instancePath,
            schemaPath: "#/anyOf/1/required",
            keyword: "required",
            params: {
              missingProperty: missing2
            },
            message: "must have required property '" + missing2 + "'"
          };
          if (vErrors === null) {
            vErrors = [err8];
          } else {
            vErrors.push(err8);
          }
          errors++;
        } else {
          if (data.type !== void 0) {
            let data5 = data.type;
            const _errs14 = errors;
            if (typeof data5 !== "string") {
              const err9 = {
                instancePath: instancePath + "/type",
                schemaPath: "#/anyOf/1/properties/type/type",
                keyword: "type",
                params: {
                  type: "string"
                },
                message: "must be string"
              };
              if (vErrors === null) {
                vErrors = [err9];
              } else {
                vErrors.push(err9);
              }
              errors++;
            }
            if ("SUBSCRIPTION" !== data5) {
              const err10 = {
                instancePath: instancePath + "/type",
                schemaPath: "#/anyOf/1/properties/type/const",
                keyword: "const",
                params: {
                  allowedValue: "SUBSCRIPTION"
                },
                message: "must be equal to constant"
              };
              if (vErrors === null) {
                vErrors = [err10];
              } else {
                vErrors.push(err10);
              }
              errors++;
            }
            var valid4 = _errs14 === errors;
          } else {
            var valid4 = true;
          }
          if (valid4) {
            if (data.subscriptionEntry !== void 0) {
              const _errs16 = errors;
              if (!validate154(data.subscriptionEntry, {
                instancePath: instancePath + "/subscriptionEntry",
                parentData: data,
                parentDataProperty: "subscriptionEntry",
                rootData
              })) {
                vErrors = vErrors === null ? validate154.errors : vErrors.concat(validate154.errors);
                errors = vErrors.length;
              }
              var valid4 = _errs16 === errors;
            } else {
              var valid4 = true;
            }
            if (valid4) {
              if (data.subscriptionEntryId !== void 0) {
                const _errs17 = errors;
                if (typeof data.subscriptionEntryId !== "string") {
                  const err11 = {
                    instancePath: instancePath + "/subscriptionEntryId",
                    schemaPath: "#/anyOf/1/properties/subscriptionEntryId/type",
                    keyword: "type",
                    params: {
                      type: "string"
                    },
                    message: "must be string"
                  };
                  if (vErrors === null) {
                    vErrors = [err11];
                  } else {
                    vErrors.push(err11);
                  }
                  errors++;
                }
                var valid4 = _errs17 === errors;
              } else {
                var valid4 = true;
              }
              if (valid4) {
                if (data.planId !== void 0) {
                  const _errs19 = errors;
                  if (typeof data.planId !== "string") {
                    const err12 = {
                      instancePath: instancePath + "/planId",
                      schemaPath: "#/anyOf/1/properties/planId/type",
                      keyword: "type",
                      params: {
                        type: "string"
                      },
                      message: "must be string"
                    };
                    if (vErrors === null) {
                      vErrors = [err12];
                    } else {
                      vErrors.push(err12);
                    }
                    errors++;
                  }
                  var valid4 = _errs19 === errors;
                } else {
                  var valid4 = true;
                }
              }
            }
          }
        }
      } else {
        const err13 = {
          instancePath,
          schemaPath: "#/anyOf/1/type",
          keyword: "type",
          params: {
            type: "object"
          },
          message: "must be object"
        };
        if (vErrors === null) {
          vErrors = [err13];
        } else {
          vErrors.push(err13);
        }
        errors++;
      }
    }
    var _valid0 = _errs12 === errors;
    valid0 = valid0 || _valid0;
    if (!valid0) {
      const _errs21 = errors;
      if (errors === _errs21) {
        if (data && typeof data == "object" && !Array.isArray(data)) {
          let missing3;
          if (data.type === void 0 && (missing3 = "type")) {
            const err14 = {
              instancePath,
              schemaPath: "#/anyOf/2/required",
              keyword: "required",
              params: {
                missingProperty: missing3
              },
              message: "must have required property '" + missing3 + "'"
            };
            if (vErrors === null) {
              vErrors = [err14];
            } else {
              vErrors.push(err14);
            }
            errors++;
          } else {
            if (data.type !== void 0) {
              let data9 = data.type;
              if (typeof data9 !== "string") {
                const err15 = {
                  instancePath: instancePath + "/type",
                  schemaPath: "#/anyOf/2/properties/type/type",
                  keyword: "type",
                  params: {
                    type: "string"
                  },
                  message: "must be string"
                };
                if (vErrors === null) {
                  vErrors = [err15];
                } else {
                  vErrors.push(err15);
                }
                errors++;
              }
              if ("FREE" !== data9) {
                const err16 = {
                  instancePath: instancePath + "/type",
                  schemaPath: "#/anyOf/2/properties/type/const",
                  keyword: "const",
                  params: {
                    allowedValue: "FREE"
                  },
                  message: "must be equal to constant"
                };
                if (vErrors === null) {
                  vErrors = [err16];
                } else {
                  vErrors.push(err16);
                }
                errors++;
              }
            }
          }
        } else {
          const err17 = {
            instancePath,
            schemaPath: "#/anyOf/2/type",
            keyword: "type",
            params: {
              type: "object"
            },
            message: "must be object"
          };
          if (vErrors === null) {
            vErrors = [err17];
          } else {
            vErrors.push(err17);
          }
          errors++;
        }
      }
      var _valid0 = _errs21 === errors;
      valid0 = valid0 || _valid0;
    }
  }
  if (!valid0) {
    const err18 = {
      instancePath,
      schemaPath: "#/anyOf",
      keyword: "anyOf",
      params: {},
      message: "must match a schema in anyOf"
    };
    if (vErrors === null) {
      vErrors = [err18];
    } else {
      vErrors.push(err18);
    }
    errors++;
    validate156.errors = vErrors;
    return false;
  } else {
    errors = _errs0;
    if (vErrors !== null) {
      if (_errs0) {
        vErrors.length = _errs0;
      } else {
        vErrors = null;
      }
    }
  }
  validate156.errors = vErrors;
  return errors === 0;
}
const GetAccessGrantedResponse = validate159;
function validate159(data, {
  instancePath = "",
  parentData,
  parentDataProperty,
  rootData = data
} = {}) {
  let vErrors = null;
  let errors = 0;
  if (errors === 0) {
    if (data && typeof data == "object" && !Array.isArray(data)) {
      let missing0;
      if (data.granted === void 0 && (missing0 = "granted") || data.accessType === void 0 && (missing0 = "accessType")) {
        validate159.errors = [{
          instancePath,
          schemaPath: "#/required",
          keyword: "required",
          params: {
            missingProperty: missing0
          },
          message: "must have required property '" + missing0 + "'"
        }];
        return false;
      } else {
        if (data.granted !== void 0) {
          let data0 = data.granted;
          const _errs1 = errors;
          if (typeof data0 !== "boolean") {
            validate159.errors = [{
              instancePath: instancePath + "/granted",
              schemaPath: "#/properties/granted/type",
              keyword: "type",
              params: {
                type: "boolean"
              },
              message: "must be boolean"
            }];
            return false;
          }
          if (true !== data0) {
            validate159.errors = [{
              instancePath: instancePath + "/granted",
              schemaPath: "#/properties/granted/const",
              keyword: "const",
              params: {
                allowedValue: true
              },
              message: "must be equal to constant"
            }];
            return false;
          }
          var valid0 = _errs1 === errors;
        } else {
          var valid0 = true;
        }
        if (valid0) {
          if (data.url !== void 0) {
            const _errs3 = errors;
            if (typeof data.url !== "string") {
              validate159.errors = [{
                instancePath: instancePath + "/url",
                schemaPath: "#/properties/url/type",
                keyword: "type",
                params: {
                  type: "string"
                },
                message: "must be string"
              }];
              return false;
            }
            var valid0 = _errs3 === errors;
          } else {
            var valid0 = true;
          }
          if (valid0) {
            if (data.accessType !== void 0) {
              const _errs5 = errors;
              if (!validate156(data.accessType, {
                instancePath: instancePath + "/accessType",
                parentData: data,
                parentDataProperty: "accessType",
                rootData
              })) {
                vErrors = vErrors === null ? validate156.errors : vErrors.concat(validate156.errors);
                errors = vErrors.length;
              }
              var valid0 = _errs5 === errors;
            } else {
              var valid0 = true;
            }
            if (valid0) {
              if (data.preparedPaymentMethods !== void 0) {
                const _errs6 = errors;
                if (!validate39(data.preparedPaymentMethods, {
                  instancePath: instancePath + "/preparedPaymentMethods",
                  parentData: data,
                  parentDataProperty: "preparedPaymentMethods",
                  rootData
                })) {
                  vErrors = vErrors === null ? validate39.errors : vErrors.concat(validate39.errors);
                  errors = vErrors.length;
                }
                var valid0 = _errs6 === errors;
              } else {
                var valid0 = true;
              }
              if (valid0) {
                if (data.availableOptions !== void 0) {
                  let data4 = data.availableOptions;
                  const _errs7 = errors;
                  if (errors === _errs7) {
                    if (data4 && typeof data4 == "object" && !Array.isArray(data4)) {
                      if (data4.plans !== void 0) {
                        let data5 = data4.plans;
                        const _errs9 = errors;
                        if (errors === _errs9) {
                          if (Array.isArray(data5)) {
                            var valid2 = true;
                            const len0 = data5.length;
                            for (let i0 = 0; i0 < len0; i0++) {
                              let data6 = data5[i0];
                              const _errs11 = errors;
                              if (errors === _errs11) {
                                if (data6 && typeof data6 == "object" && !Array.isArray(data6)) {
                                  let missing1;
                                  if (data6.plan === void 0 && (missing1 = "plan") || data6.id === void 0 && (missing1 = "id")) {
                                    validate159.errors = [{
                                      instancePath: instancePath + "/availableOptions/plans/" + i0,
                                      schemaPath: "#/properties/availableOptions/properties/plans/items/required",
                                      keyword: "required",
                                      params: {
                                        missingProperty: missing1
                                      },
                                      message: "must have required property '" + missing1 + "'"
                                    }];
                                    return false;
                                  } else {
                                    if (data6.plan !== void 0) {
                                      const _errs13 = errors;
                                      if (!validate150(data6.plan, {
                                        instancePath: instancePath + "/availableOptions/plans/" + i0 + "/plan",
                                        parentData: data6,
                                        parentDataProperty: "plan",
                                        rootData
                                      })) {
                                        vErrors = vErrors === null ? validate150.errors : vErrors.concat(validate150.errors);
                                        errors = vErrors.length;
                                      }
                                      var valid3 = _errs13 === errors;
                                    } else {
                                      var valid3 = true;
                                    }
                                    if (valid3) {
                                      if (data6.id !== void 0) {
                                        const _errs14 = errors;
                                        if (typeof data6.id !== "string") {
                                          validate159.errors = [{
                                            instancePath: instancePath + "/availableOptions/plans/" + i0 + "/id",
                                            schemaPath: "#/properties/availableOptions/properties/plans/items/properties/id/type",
                                            keyword: "type",
                                            params: {
                                              type: "string"
                                            },
                                            message: "must be string"
                                          }];
                                          return false;
                                        }
                                        var valid3 = _errs14 === errors;
                                      } else {
                                        var valid3 = true;
                                      }
                                    }
                                  }
                                } else {
                                  validate159.errors = [{
                                    instancePath: instancePath + "/availableOptions/plans/" + i0,
                                    schemaPath: "#/properties/availableOptions/properties/plans/items/type",
                                    keyword: "type",
                                    params: {
                                      type: "object"
                                    },
                                    message: "must be object"
                                  }];
                                  return false;
                                }
                              }
                              var valid2 = _errs11 === errors;
                              if (!valid2) {
                                break;
                              }
                            }
                          } else {
                            validate159.errors = [{
                              instancePath: instancePath + "/availableOptions/plans",
                              schemaPath: "#/properties/availableOptions/properties/plans/type",
                              keyword: "type",
                              params: {
                                type: "array"
                              },
                              message: "must be array"
                            }];
                            return false;
                          }
                        }
                        var valid1 = _errs9 === errors;
                      } else {
                        var valid1 = true;
                      }
                      if (valid1) {
                        if (data4.tickets !== void 0) {
                          let data9 = data4.tickets;
                          const _errs16 = errors;
                          if (errors === _errs16) {
                            if (Array.isArray(data9)) {
                              var valid4 = true;
                              const len1 = data9.length;
                              for (let i1 = 0; i1 < len1; i1++) {
                                const _errs18 = errors;
                                if (!validate140(data9[i1], {
                                  instancePath: instancePath + "/availableOptions/tickets/" + i1,
                                  parentData: data9,
                                  parentDataProperty: i1,
                                  rootData
                                })) {
                                  vErrors = vErrors === null ? validate140.errors : vErrors.concat(validate140.errors);
                                  errors = vErrors.length;
                                }
                                var valid4 = _errs18 === errors;
                                if (!valid4) {
                                  break;
                                }
                              }
                            } else {
                              validate159.errors = [{
                                instancePath: instancePath + "/availableOptions/tickets",
                                schemaPath: "#/properties/availableOptions/properties/tickets/type",
                                keyword: "type",
                                params: {
                                  type: "array"
                                },
                                message: "must be array"
                              }];
                              return false;
                            }
                          }
                          var valid1 = _errs16 === errors;
                        } else {
                          var valid1 = true;
                        }
                      }
                    } else {
                      validate159.errors = [{
                        instancePath: instancePath + "/availableOptions",
                        schemaPath: "#/properties/availableOptions/type",
                        keyword: "type",
                        params: {
                          type: "object"
                        },
                        message: "must be object"
                      }];
                      return false;
                    }
                  }
                  var valid0 = _errs7 === errors;
                } else {
                  var valid0 = true;
                }
              }
            }
          }
        }
      }
    } else {
      validate159.errors = [{
        instancePath,
        schemaPath: "#/type",
        keyword: "type",
        params: {
          type: "object"
        },
        message: "must be object"
      }];
      return false;
    }
  }
  validate159.errors = vErrors;
  return errors === 0;
}
const GetAccessDeniedResponseReason = validate164;
const schema172 = {
  "$id": "GetAccessDeniedResponseReason",
  "$schema": "http://json-schema.org/draft-07/schema#",
  "type": "string",
  "enum": ["NOT_REGISTERED", "CONTENT_GONE", "NO_ACCESS", "TICKET_AND_SUBSCRIPTION_INVALID", "TICKET_EXPIRED", "SUBSCRIPTION_INVALID", "GEO_RESTRICTION"]
};
function validate164(data, {
  instancePath = "",
  parentData,
  parentDataProperty,
  rootData = data
} = {}) {
  let vErrors = null;
  let errors = 0;
  if (typeof data !== "string") {
    validate164.errors = [{
      instancePath,
      schemaPath: "#/type",
      keyword: "type",
      params: {
        type: "string"
      },
      message: "must be string"
    }];
    return false;
  }
  if (!(data === "NOT_REGISTERED" || data === "CONTENT_GONE" || data === "NO_ACCESS" || data === "TICKET_AND_SUBSCRIPTION_INVALID" || data === "TICKET_EXPIRED" || data === "SUBSCRIPTION_INVALID" || data === "GEO_RESTRICTION")) {
    validate164.errors = [{
      instancePath,
      schemaPath: "#/enum",
      keyword: "enum",
      params: {
        allowedValues: schema172.enum
      },
      message: "must be equal to one of the allowed values"
    }];
    return false;
  }
  validate164.errors = vErrors;
  return errors === 0;
}
const GetAccessDeniedResponse = validate165;
function validate165(data, {
  instancePath = "",
  parentData,
  parentDataProperty,
  rootData = data
} = {}) {
  let vErrors = null;
  let errors = 0;
  if (errors === 0) {
    if (data && typeof data == "object" && !Array.isArray(data)) {
      let missing0;
      if (data.granted === void 0 && (missing0 = "granted") || data.reason === void 0 && (missing0 = "reason")) {
        validate165.errors = [{
          instancePath,
          schemaPath: "#/required",
          keyword: "required",
          params: {
            missingProperty: missing0
          },
          message: "must have required property '" + missing0 + "'"
        }];
        return false;
      } else {
        if (data.granted !== void 0) {
          let data0 = data.granted;
          const _errs1 = errors;
          if (typeof data0 !== "boolean") {
            validate165.errors = [{
              instancePath: instancePath + "/granted",
              schemaPath: "#/properties/granted/type",
              keyword: "type",
              params: {
                type: "boolean"
              },
              message: "must be boolean"
            }];
            return false;
          }
          if (false !== data0) {
            validate165.errors = [{
              instancePath: instancePath + "/granted",
              schemaPath: "#/properties/granted/const",
              keyword: "const",
              params: {
                allowedValue: false
              },
              message: "must be equal to constant"
            }];
            return false;
          }
          var valid0 = _errs1 === errors;
        } else {
          var valid0 = true;
        }
        if (valid0) {
          if (data.reason !== void 0) {
            let data1 = data.reason;
            const _errs3 = errors;
            if (typeof data1 !== "string") {
              validate165.errors = [{
                instancePath: instancePath + "/reason",
                schemaPath: "GetAccessDeniedResponseReason/type",
                keyword: "type",
                params: {
                  type: "string"
                },
                message: "must be string"
              }];
              return false;
            }
            if (!(data1 === "NOT_REGISTERED" || data1 === "CONTENT_GONE" || data1 === "NO_ACCESS" || data1 === "TICKET_AND_SUBSCRIPTION_INVALID" || data1 === "TICKET_EXPIRED" || data1 === "SUBSCRIPTION_INVALID" || data1 === "GEO_RESTRICTION")) {
              validate165.errors = [{
                instancePath: instancePath + "/reason",
                schemaPath: "GetAccessDeniedResponseReason/enum",
                keyword: "enum",
                params: {
                  allowedValues: schema172.enum
                },
                message: "must be equal to one of the allowed values"
              }];
              return false;
            }
            var valid0 = _errs3 === errors;
          } else {
            var valid0 = true;
          }
          if (valid0) {
            if (data.invalidSubscriptions !== void 0) {
              let data2 = data.invalidSubscriptions;
              const _errs6 = errors;
              if (errors === _errs6) {
                if (Array.isArray(data2)) {
                  var valid2 = true;
                  const len0 = data2.length;
                  for (let i0 = 0; i0 < len0; i0++) {
                    let data3 = data2[i0];
                    const _errs8 = errors;
                    if (errors === _errs8) {
                      if (data3 && typeof data3 == "object" && !Array.isArray(data3)) {
                        let missing1;
                        if (data3.id === void 0 && (missing1 = "id") || data3.status === void 0 && (missing1 = "status") || data3.planId === void 0 && (missing1 = "planId")) {
                          validate165.errors = [{
                            instancePath: instancePath + "/invalidSubscriptions/" + i0,
                            schemaPath: "#/properties/invalidSubscriptions/items/required",
                            keyword: "required",
                            params: {
                              missingProperty: missing1
                            },
                            message: "must have required property '" + missing1 + "'"
                          }];
                          return false;
                        } else {
                          if (data3.id !== void 0) {
                            const _errs10 = errors;
                            if (typeof data3.id !== "string") {
                              validate165.errors = [{
                                instancePath: instancePath + "/invalidSubscriptions/" + i0 + "/id",
                                schemaPath: "#/properties/invalidSubscriptions/items/properties/id/type",
                                keyword: "type",
                                params: {
                                  type: "string"
                                },
                                message: "must be string"
                              }];
                              return false;
                            }
                            var valid3 = _errs10 === errors;
                          } else {
                            var valid3 = true;
                          }
                          if (valid3) {
                            if (data3.status !== void 0) {
                              let data5 = data3.status;
                              const _errs12 = errors;
                              if (typeof data5 !== "string") {
                                validate165.errors = [{
                                  instancePath: instancePath + "/invalidSubscriptions/" + i0 + "/status",
                                  schemaPath: "SubscriptionStatus/type",
                                  keyword: "type",
                                  params: {
                                    type: "string"
                                  },
                                  message: "must be string"
                                }];
                                return false;
                              }
                              if (!(data5 === "NEEDS_ACTION" || data5 === "PAUSED" || data5 === "PENDING" || data5 === "TRIALING" || data5 === "ACTIVE" || data5 === "CANCELLING" || data5 === "TERMINATED")) {
                                validate165.errors = [{
                                  instancePath: instancePath + "/invalidSubscriptions/" + i0 + "/status",
                                  schemaPath: "SubscriptionStatus/enum",
                                  keyword: "enum",
                                  params: {
                                    allowedValues: schema163.enum
                                  },
                                  message: "must be equal to one of the allowed values"
                                }];
                                return false;
                              }
                              var valid3 = _errs12 === errors;
                            } else {
                              var valid3 = true;
                            }
                            if (valid3) {
                              if (data3.planId !== void 0) {
                                const _errs15 = errors;
                                if (typeof data3.planId !== "string") {
                                  validate165.errors = [{
                                    instancePath: instancePath + "/invalidSubscriptions/" + i0 + "/planId",
                                    schemaPath: "#/properties/invalidSubscriptions/items/properties/planId/type",
                                    keyword: "type",
                                    params: {
                                      type: "string"
                                    },
                                    message: "must be string"
                                  }];
                                  return false;
                                }
                                var valid3 = _errs15 === errors;
                              } else {
                                var valid3 = true;
                              }
                            }
                          }
                        }
                      } else {
                        validate165.errors = [{
                          instancePath: instancePath + "/invalidSubscriptions/" + i0,
                          schemaPath: "#/properties/invalidSubscriptions/items/type",
                          keyword: "type",
                          params: {
                            type: "object"
                          },
                          message: "must be object"
                        }];
                        return false;
                      }
                    }
                    var valid2 = _errs8 === errors;
                    if (!valid2) {
                      break;
                    }
                  }
                } else {
                  validate165.errors = [{
                    instancePath: instancePath + "/invalidSubscriptions",
                    schemaPath: "#/properties/invalidSubscriptions/type",
                    keyword: "type",
                    params: {
                      type: "array"
                    },
                    message: "must be array"
                  }];
                  return false;
                }
              }
              var valid0 = _errs6 === errors;
            } else {
              var valid0 = true;
            }
            if (valid0) {
              if (data.preparedPaymentMethods !== void 0) {
                const _errs17 = errors;
                if (!validate39(data.preparedPaymentMethods, {
                  instancePath: instancePath + "/preparedPaymentMethods",
                  parentData: data,
                  parentDataProperty: "preparedPaymentMethods",
                  rootData
                })) {
                  vErrors = vErrors === null ? validate39.errors : vErrors.concat(validate39.errors);
                  errors = vErrors.length;
                }
                var valid0 = _errs17 === errors;
              } else {
                var valid0 = true;
              }
              if (valid0) {
                if (data.availableOptions !== void 0) {
                  let data8 = data.availableOptions;
                  const _errs18 = errors;
                  if (errors === _errs18) {
                    if (data8 && typeof data8 == "object" && !Array.isArray(data8)) {
                      if (data8.plans !== void 0) {
                        let data9 = data8.plans;
                        const _errs20 = errors;
                        if (errors === _errs20) {
                          if (Array.isArray(data9)) {
                            var valid6 = true;
                            const len1 = data9.length;
                            for (let i1 = 0; i1 < len1; i1++) {
                              let data10 = data9[i1];
                              const _errs22 = errors;
                              if (errors === _errs22) {
                                if (data10 && typeof data10 == "object" && !Array.isArray(data10)) {
                                  let missing2;
                                  if (data10.plan === void 0 && (missing2 = "plan") || data10.id === void 0 && (missing2 = "id")) {
                                    validate165.errors = [{
                                      instancePath: instancePath + "/availableOptions/plans/" + i1,
                                      schemaPath: "#/properties/availableOptions/properties/plans/items/required",
                                      keyword: "required",
                                      params: {
                                        missingProperty: missing2
                                      },
                                      message: "must have required property '" + missing2 + "'"
                                    }];
                                    return false;
                                  } else {
                                    if (data10.plan !== void 0) {
                                      const _errs24 = errors;
                                      if (!validate150(data10.plan, {
                                        instancePath: instancePath + "/availableOptions/plans/" + i1 + "/plan",
                                        parentData: data10,
                                        parentDataProperty: "plan",
                                        rootData
                                      })) {
                                        vErrors = vErrors === null ? validate150.errors : vErrors.concat(validate150.errors);
                                        errors = vErrors.length;
                                      }
                                      var valid7 = _errs24 === errors;
                                    } else {
                                      var valid7 = true;
                                    }
                                    if (valid7) {
                                      if (data10.id !== void 0) {
                                        const _errs25 = errors;
                                        if (typeof data10.id !== "string") {
                                          validate165.errors = [{
                                            instancePath: instancePath + "/availableOptions/plans/" + i1 + "/id",
                                            schemaPath: "#/properties/availableOptions/properties/plans/items/properties/id/type",
                                            keyword: "type",
                                            params: {
                                              type: "string"
                                            },
                                            message: "must be string"
                                          }];
                                          return false;
                                        }
                                        var valid7 = _errs25 === errors;
                                      } else {
                                        var valid7 = true;
                                      }
                                    }
                                  }
                                } else {
                                  validate165.errors = [{
                                    instancePath: instancePath + "/availableOptions/plans/" + i1,
                                    schemaPath: "#/properties/availableOptions/properties/plans/items/type",
                                    keyword: "type",
                                    params: {
                                      type: "object"
                                    },
                                    message: "must be object"
                                  }];
                                  return false;
                                }
                              }
                              var valid6 = _errs22 === errors;
                              if (!valid6) {
                                break;
                              }
                            }
                          } else {
                            validate165.errors = [{
                              instancePath: instancePath + "/availableOptions/plans",
                              schemaPath: "#/properties/availableOptions/properties/plans/type",
                              keyword: "type",
                              params: {
                                type: "array"
                              },
                              message: "must be array"
                            }];
                            return false;
                          }
                        }
                        var valid5 = _errs20 === errors;
                      } else {
                        var valid5 = true;
                      }
                      if (valid5) {
                        if (data8.tickets !== void 0) {
                          let data13 = data8.tickets;
                          const _errs27 = errors;
                          if (errors === _errs27) {
                            if (Array.isArray(data13)) {
                              var valid8 = true;
                              const len2 = data13.length;
                              for (let i2 = 0; i2 < len2; i2++) {
                                const _errs29 = errors;
                                if (!validate140(data13[i2], {
                                  instancePath: instancePath + "/availableOptions/tickets/" + i2,
                                  parentData: data13,
                                  parentDataProperty: i2,
                                  rootData
                                })) {
                                  vErrors = vErrors === null ? validate140.errors : vErrors.concat(validate140.errors);
                                  errors = vErrors.length;
                                }
                                var valid8 = _errs29 === errors;
                                if (!valid8) {
                                  break;
                                }
                              }
                            } else {
                              validate165.errors = [{
                                instancePath: instancePath + "/availableOptions/tickets",
                                schemaPath: "#/properties/availableOptions/properties/tickets/type",
                                keyword: "type",
                                params: {
                                  type: "array"
                                },
                                message: "must be array"
                              }];
                              return false;
                            }
                          }
                          var valid5 = _errs27 === errors;
                        } else {
                          var valid5 = true;
                        }
                      }
                    } else {
                      validate165.errors = [{
                        instancePath: instancePath + "/availableOptions",
                        schemaPath: "#/properties/availableOptions/type",
                        keyword: "type",
                        params: {
                          type: "object"
                        },
                        message: "must be object"
                      }];
                      return false;
                    }
                  }
                  var valid0 = _errs18 === errors;
                } else {
                  var valid0 = true;
                }
              }
            }
          }
        }
      }
    } else {
      validate165.errors = [{
        instancePath,
        schemaPath: "#/type",
        keyword: "type",
        params: {
          type: "object"
        },
        message: "must be object"
      }];
      return false;
    }
  }
  validate165.errors = vErrors;
  return errors === 0;
}
const GetAccessResponse = validate169;
function validate169(data, {
  instancePath = "",
  parentData,
  parentDataProperty,
  rootData = data
} = {}) {
  let vErrors = null;
  let errors = 0;
  const _errs0 = errors;
  let valid0 = false;
  const _errs1 = errors;
  if (!validate165(data, {
    instancePath,
    parentData,
    parentDataProperty,
    rootData
  })) {
    vErrors = vErrors === null ? validate165.errors : vErrors.concat(validate165.errors);
    errors = vErrors.length;
  }
  var _valid0 = _errs1 === errors;
  valid0 = valid0 || _valid0;
  if (!valid0) {
    const _errs2 = errors;
    if (!validate159(data, {
      instancePath,
      parentData,
      parentDataProperty,
      rootData
    })) {
      vErrors = vErrors === null ? validate159.errors : vErrors.concat(validate159.errors);
      errors = vErrors.length;
    }
    var _valid0 = _errs2 === errors;
    valid0 = valid0 || _valid0;
  }
  if (!valid0) {
    const err0 = {
      instancePath,
      schemaPath: "#/anyOf",
      keyword: "anyOf",
      params: {},
      message: "must match a schema in anyOf"
    };
    if (vErrors === null) {
      vErrors = [err0];
    } else {
      vErrors.push(err0);
    }
    errors++;
    validate169.errors = vErrors;
    return false;
  } else {
    errors = _errs0;
    if (vErrors !== null) {
      if (_errs0) {
        vErrors.length = _errs0;
      } else {
        vErrors = null;
      }
    }
  }
  validate169.errors = vErrors;
  return errors === 0;
}
const Invite = validate172;
const schema177 = {
  "$id": "Invite",
  "$schema": "http://json-schema.org/draft-07/schema#",
  "type": "object",
  "properties": {
    "channelId": {
      "type": "string"
    },
    "expiracyDate": {
      "type": "object",
      "format": "date-time"
    },
    "intentType": {
      "type": "string",
      "enum": ["ADMIN", "MEMBER", "PRE_REGISTER", "STREAMER", "TRAINER"]
    },
    "inviteMessage": {
      "type": "string"
    },
    "status": {
      "type": "string",
      "enum": ["PENDING", "REJECTED", "ACCEPTED", "PROCESSING"]
    },
    "tokenHash": {
      "type": "string"
    }
  },
  "required": ["expiracyDate", "intentType", "status", "tokenHash"]
};
function validate172(data, {
  instancePath = "",
  parentData,
  parentDataProperty,
  rootData = data
} = {}) {
  let vErrors = null;
  let errors = 0;
  {
    if (data && typeof data == "object" && !Array.isArray(data)) {
      let missing0;
      if (data.expiracyDate === void 0 && (missing0 = "expiracyDate") || data.intentType === void 0 && (missing0 = "intentType") || data.status === void 0 && (missing0 = "status") || data.tokenHash === void 0 && (missing0 = "tokenHash")) {
        validate172.errors = [{
          instancePath,
          schemaPath: "#/required",
          keyword: "required",
          params: {
            missingProperty: missing0
          },
          message: "must have required property '" + missing0 + "'"
        }];
        return false;
      } else {
        if (data.channelId !== void 0) {
          const _errs1 = errors;
          if (typeof data.channelId !== "string") {
            validate172.errors = [{
              instancePath: instancePath + "/channelId",
              schemaPath: "#/properties/channelId/type",
              keyword: "type",
              params: {
                type: "string"
              },
              message: "must be string"
            }];
            return false;
          }
          var valid0 = _errs1 === errors;
        } else {
          var valid0 = true;
        }
        if (valid0) {
          if (data.expiracyDate !== void 0) {
            let data1 = data.expiracyDate;
            const _errs3 = errors;
            if (!(data1 && typeof data1 == "object" && !Array.isArray(data1))) {
              validate172.errors = [{
                instancePath: instancePath + "/expiracyDate",
                schemaPath: "#/properties/expiracyDate/type",
                keyword: "type",
                params: {
                  type: "object"
                },
                message: "must be object"
              }];
              return false;
            }
            {
              {
                if (typeof data1 === "string") {
                  if (!formats0(data1)) {
                    validate172.errors = [{
                      instancePath: instancePath + "/expiracyDate",
                      schemaPath: "#/properties/expiracyDate/format",
                      keyword: "format",
                      params: {
                        format: "date-time"
                      },
                      message: 'must match format "date-time"'
                    }];
                    return false;
                  }
                }
              }
            }
            var valid0 = _errs3 === errors;
          } else {
            var valid0 = true;
          }
          if (valid0) {
            if (data.intentType !== void 0) {
              let data2 = data.intentType;
              const _errs5 = errors;
              if (typeof data2 !== "string") {
                validate172.errors = [{
                  instancePath: instancePath + "/intentType",
                  schemaPath: "#/properties/intentType/type",
                  keyword: "type",
                  params: {
                    type: "string"
                  },
                  message: "must be string"
                }];
                return false;
              }
              if (!(data2 === "ADMIN" || data2 === "MEMBER" || data2 === "PRE_REGISTER" || data2 === "STREAMER" || data2 === "TRAINER")) {
                validate172.errors = [{
                  instancePath: instancePath + "/intentType",
                  schemaPath: "#/properties/intentType/enum",
                  keyword: "enum",
                  params: {
                    allowedValues: schema177.properties.intentType.enum
                  },
                  message: "must be equal to one of the allowed values"
                }];
                return false;
              }
              var valid0 = _errs5 === errors;
            } else {
              var valid0 = true;
            }
            if (valid0) {
              if (data.inviteMessage !== void 0) {
                const _errs7 = errors;
                if (typeof data.inviteMessage !== "string") {
                  validate172.errors = [{
                    instancePath: instancePath + "/inviteMessage",
                    schemaPath: "#/properties/inviteMessage/type",
                    keyword: "type",
                    params: {
                      type: "string"
                    },
                    message: "must be string"
                  }];
                  return false;
                }
                var valid0 = _errs7 === errors;
              } else {
                var valid0 = true;
              }
              if (valid0) {
                if (data.status !== void 0) {
                  let data4 = data.status;
                  const _errs9 = errors;
                  if (typeof data4 !== "string") {
                    validate172.errors = [{
                      instancePath: instancePath + "/status",
                      schemaPath: "#/properties/status/type",
                      keyword: "type",
                      params: {
                        type: "string"
                      },
                      message: "must be string"
                    }];
                    return false;
                  }
                  if (!(data4 === "PENDING" || data4 === "REJECTED" || data4 === "ACCEPTED" || data4 === "PROCESSING")) {
                    validate172.errors = [{
                      instancePath: instancePath + "/status",
                      schemaPath: "#/properties/status/enum",
                      keyword: "enum",
                      params: {
                        allowedValues: schema177.properties.status.enum
                      },
                      message: "must be equal to one of the allowed values"
                    }];
                    return false;
                  }
                  var valid0 = _errs9 === errors;
                } else {
                  var valid0 = true;
                }
                if (valid0) {
                  if (data.tokenHash !== void 0) {
                    const _errs11 = errors;
                    if (typeof data.tokenHash !== "string") {
                      validate172.errors = [{
                        instancePath: instancePath + "/tokenHash",
                        schemaPath: "#/properties/tokenHash/type",
                        keyword: "type",
                        params: {
                          type: "string"
                        },
                        message: "must be string"
                      }];
                      return false;
                    }
                    var valid0 = _errs11 === errors;
                  } else {
                    var valid0 = true;
                  }
                }
              }
            }
          }
        }
      }
    } else {
      validate172.errors = [{
        instancePath,
        schemaPath: "#/type",
        keyword: "type",
        params: {
          type: "object"
        },
        message: "must be object"
      }];
      return false;
    }
  }
  validate172.errors = vErrors;
  return errors === 0;
}
const SAML_PROVIDERS = validate173;
const schema178 = {
  "$id": "SAML_PROVIDERS",
  "$schema": "http://json-schema.org/draft-07/schema#",
  "type": "string",
  "enum": ["sport80"]
};
function validate173(data, {
  instancePath = "",
  parentData,
  parentDataProperty,
  rootData = data
} = {}) {
  let vErrors = null;
  let errors = 0;
  if (typeof data !== "string") {
    validate173.errors = [{
      instancePath,
      schemaPath: "#/type",
      keyword: "type",
      params: {
        type: "string"
      },
      message: "must be string"
    }];
    return false;
  }
  if (!(data === "sport80")) {
    validate173.errors = [{
      instancePath,
      schemaPath: "#/enum",
      keyword: "enum",
      params: {
        allowedValues: schema178.enum
      },
      message: "must be equal to one of the allowed values"
    }];
    return false;
  }
  validate173.errors = vErrors;
  return errors === 0;
}
const SAML_LINK_OPERATION = validate174;
const schema179 = {
  "$id": "SAML_LINK_OPERATION",
  "$schema": "http://json-schema.org/draft-07/schema#",
  "type": "string",
  "enum": ["LINK", "UNLINK", "RECHECK"]
};
function validate174(data, {
  instancePath = "",
  parentData,
  parentDataProperty,
  rootData = data
} = {}) {
  let vErrors = null;
  let errors = 0;
  if (typeof data !== "string") {
    validate174.errors = [{
      instancePath,
      schemaPath: "#/type",
      keyword: "type",
      params: {
        type: "string"
      },
      message: "must be string"
    }];
    return false;
  }
  if (!(data === "LINK" || data === "UNLINK" || data === "RECHECK")) {
    validate174.errors = [{
      instancePath,
      schemaPath: "#/enum",
      keyword: "enum",
      params: {
        allowedValues: schema179.enum
      },
      message: "must be equal to one of the allowed values"
    }];
    return false;
  }
  validate174.errors = vErrors;
  return errors === 0;
}
const ACCOUNT_LINKING_RESULT = validate175;
const schema180 = {
  "$id": "ACCOUNT_LINKING_RESULT",
  "$schema": "http://json-schema.org/draft-07/schema#",
  "type": "string",
  "enum": ["LINKED", "NO_LINKABLE_PLAN", "ACCOUNT_ALREADY_LINKED", "ACCOUNT_LINKED_TO_OTHER_USER"]
};
function validate175(data, {
  instancePath = "",
  parentData,
  parentDataProperty,
  rootData = data
} = {}) {
  let vErrors = null;
  let errors = 0;
  if (typeof data !== "string") {
    validate175.errors = [{
      instancePath,
      schemaPath: "#/type",
      keyword: "type",
      params: {
        type: "string"
      },
      message: "must be string"
    }];
    return false;
  }
  if (!(data === "LINKED" || data === "NO_LINKABLE_PLAN" || data === "ACCOUNT_ALREADY_LINKED" || data === "ACCOUNT_LINKED_TO_OTHER_USER")) {
    validate175.errors = [{
      instancePath,
      schemaPath: "#/enum",
      keyword: "enum",
      params: {
        allowedValues: schema180.enum
      },
      message: "must be equal to one of the allowed values"
    }];
    return false;
  }
  validate175.errors = vErrors;
  return errors === 0;
}
const ACCOUNT_UNLINKING_RESULT = validate176;
const schema181 = {
  "$id": "ACCOUNT_UNLINKING_RESULT",
  "$schema": "http://json-schema.org/draft-07/schema#",
  "type": "string",
  "enum": ["UNLINKED", "NOT_SAME_USER", "USER_NOT_LINKED"]
};
function validate176(data, {
  instancePath = "",
  parentData,
  parentDataProperty,
  rootData = data
} = {}) {
  let vErrors = null;
  let errors = 0;
  if (typeof data !== "string") {
    validate176.errors = [{
      instancePath,
      schemaPath: "#/type",
      keyword: "type",
      params: {
        type: "string"
      },
      message: "must be string"
    }];
    return false;
  }
  if (!(data === "UNLINKED" || data === "NOT_SAME_USER" || data === "USER_NOT_LINKED")) {
    validate176.errors = [{
      instancePath,
      schemaPath: "#/enum",
      keyword: "enum",
      params: {
        allowedValues: schema181.enum
      },
      message: "must be equal to one of the allowed values"
    }];
    return false;
  }
  validate176.errors = vErrors;
  return errors === 0;
}
const ACCOUNT_RELINK_RESULT = validate177;
const schema182 = {
  "$id": "ACCOUNT_RELINK_RESULT",
  "$schema": "http://json-schema.org/draft-07/schema#",
  "type": "string",
  "enum": ["RELINKED", "NOT_SAME_USER", "USER_NOT_LINKED", "RELINKED_DIFFERENT_PACKAGE", "UNLINKED"]
};
function validate177(data, {
  instancePath = "",
  parentData,
  parentDataProperty,
  rootData = data
} = {}) {
  let vErrors = null;
  let errors = 0;
  if (typeof data !== "string") {
    validate177.errors = [{
      instancePath,
      schemaPath: "#/type",
      keyword: "type",
      params: {
        type: "string"
      },
      message: "must be string"
    }];
    return false;
  }
  if (!(data === "RELINKED" || data === "NOT_SAME_USER" || data === "USER_NOT_LINKED" || data === "RELINKED_DIFFERENT_PACKAGE" || data === "UNLINKED")) {
    validate177.errors = [{
      instancePath,
      schemaPath: "#/enum",
      keyword: "enum",
      params: {
        allowedValues: schema182.enum
      },
      message: "must be equal to one of the allowed values"
    }];
    return false;
  }
  validate177.errors = vErrors;
  return errors === 0;
}
const LinkExternalAccountRequest = validate178;
function validate178(data, {
  instancePath = "",
  parentData,
  parentDataProperty,
  rootData = data
} = {}) {
  let vErrors = null;
  let errors = 0;
  {
    if (data && typeof data == "object" && !Array.isArray(data)) {
      let missing0;
      if (data.channelId === void 0 && (missing0 = "channelId") || data.providerType === void 0 && (missing0 = "providerType")) {
        validate178.errors = [{
          instancePath,
          schemaPath: "#/required",
          keyword: "required",
          params: {
            missingProperty: missing0
          },
          message: "must have required property '" + missing0 + "'"
        }];
        return false;
      } else {
        if (data.channelId !== void 0) {
          const _errs1 = errors;
          if (typeof data.channelId !== "string") {
            validate178.errors = [{
              instancePath: instancePath + "/channelId",
              schemaPath: "#/properties/channelId/type",
              keyword: "type",
              params: {
                type: "string"
              },
              message: "must be string"
            }];
            return false;
          }
          var valid0 = _errs1 === errors;
        } else {
          var valid0 = true;
        }
        if (valid0) {
          if (data.providerType !== void 0) {
            const _errs3 = errors;
            if (typeof data.providerType !== "string") {
              validate178.errors = [{
                instancePath: instancePath + "/providerType",
                schemaPath: "#/properties/providerType/type",
                keyword: "type",
                params: {
                  type: "string"
                },
                message: "must be string"
              }];
              return false;
            }
            var valid0 = _errs3 === errors;
          } else {
            var valid0 = true;
          }
        }
      }
    } else {
      validate178.errors = [{
        instancePath,
        schemaPath: "#/type",
        keyword: "type",
        params: {
          type: "object"
        },
        message: "must be object"
      }];
      return false;
    }
  }
  validate178.errors = vErrors;
  return errors === 0;
}
const LinkExternalSAMLAccountRequest = validate179;
function validate179(data, {
  instancePath = "",
  parentData,
  parentDataProperty,
  rootData = data
} = {}) {
  let vErrors = null;
  let errors = 0;
  {
    if (data && typeof data == "object" && !Array.isArray(data)) {
      let missing0;
      if (data.channelId === void 0 && (missing0 = "channelId") || data.providerType === void 0 && (missing0 = "providerType") || data.returnUrl === void 0 && (missing0 = "returnUrl") || data.providerId === void 0 && (missing0 = "providerId") || data.operation === void 0 && (missing0 = "operation")) {
        validate179.errors = [{
          instancePath,
          schemaPath: "#/required",
          keyword: "required",
          params: {
            missingProperty: missing0
          },
          message: "must have required property '" + missing0 + "'"
        }];
        return false;
      } else {
        if (data.channelId !== void 0) {
          const _errs1 = errors;
          if (typeof data.channelId !== "string") {
            validate179.errors = [{
              instancePath: instancePath + "/channelId",
              schemaPath: "#/properties/channelId/type",
              keyword: "type",
              params: {
                type: "string"
              },
              message: "must be string"
            }];
            return false;
          }
          var valid0 = _errs1 === errors;
        } else {
          var valid0 = true;
        }
        if (valid0) {
          if (data.providerType !== void 0) {
            let data1 = data.providerType;
            const _errs3 = errors;
            if (typeof data1 !== "string") {
              validate179.errors = [{
                instancePath: instancePath + "/providerType",
                schemaPath: "#/properties/providerType/type",
                keyword: "type",
                params: {
                  type: "string"
                },
                message: "must be string"
              }];
              return false;
            }
            if ("SAML" !== data1) {
              validate179.errors = [{
                instancePath: instancePath + "/providerType",
                schemaPath: "#/properties/providerType/const",
                keyword: "const",
                params: {
                  allowedValue: "SAML"
                },
                message: "must be equal to constant"
              }];
              return false;
            }
            var valid0 = _errs3 === errors;
          } else {
            var valid0 = true;
          }
          if (valid0) {
            if (data.returnUrl !== void 0) {
              const _errs5 = errors;
              if (typeof data.returnUrl !== "string") {
                validate179.errors = [{
                  instancePath: instancePath + "/returnUrl",
                  schemaPath: "#/properties/returnUrl/type",
                  keyword: "type",
                  params: {
                    type: "string"
                  },
                  message: "must be string"
                }];
                return false;
              }
              var valid0 = _errs5 === errors;
            } else {
              var valid0 = true;
            }
            if (valid0) {
              if (data.providerId !== void 0) {
                let data3 = data.providerId;
                const _errs7 = errors;
                if (typeof data3 !== "string") {
                  validate179.errors = [{
                    instancePath: instancePath + "/providerId",
                    schemaPath: "SAML_PROVIDERS/type",
                    keyword: "type",
                    params: {
                      type: "string"
                    },
                    message: "must be string"
                  }];
                  return false;
                }
                if (!(data3 === "sport80")) {
                  validate179.errors = [{
                    instancePath: instancePath + "/providerId",
                    schemaPath: "SAML_PROVIDERS/enum",
                    keyword: "enum",
                    params: {
                      allowedValues: schema178.enum
                    },
                    message: "must be equal to one of the allowed values"
                  }];
                  return false;
                }
                var valid0 = _errs7 === errors;
              } else {
                var valid0 = true;
              }
              if (valid0) {
                if (data.operation !== void 0) {
                  let data4 = data.operation;
                  const _errs10 = errors;
                  if (typeof data4 !== "string") {
                    validate179.errors = [{
                      instancePath: instancePath + "/operation",
                      schemaPath: "SAML_LINK_OPERATION/type",
                      keyword: "type",
                      params: {
                        type: "string"
                      },
                      message: "must be string"
                    }];
                    return false;
                  }
                  if (!(data4 === "LINK" || data4 === "UNLINK" || data4 === "RECHECK")) {
                    validate179.errors = [{
                      instancePath: instancePath + "/operation",
                      schemaPath: "SAML_LINK_OPERATION/enum",
                      keyword: "enum",
                      params: {
                        allowedValues: schema179.enum
                      },
                      message: "must be equal to one of the allowed values"
                    }];
                    return false;
                  }
                  var valid0 = _errs10 === errors;
                } else {
                  var valid0 = true;
                }
              }
            }
          }
        }
      }
    } else {
      validate179.errors = [{
        instancePath,
        schemaPath: "#/type",
        keyword: "type",
        params: {
          type: "object"
        },
        message: "must be object"
      }];
      return false;
    }
  }
  validate179.errors = vErrors;
  return errors === 0;
}
const LinkExternalAccountSuccessfulResponse = validate180;
function validate180(data, {
  instancePath = "",
  parentData,
  parentDataProperty,
  rootData = data
} = {}) {
  let vErrors = null;
  let errors = 0;
  {
    if (data && typeof data == "object" && !Array.isArray(data)) {
      let missing0;
      if (data.success === void 0 && (missing0 = "success") || data.redirection === void 0 && (missing0 = "redirection")) {
        validate180.errors = [{
          instancePath,
          schemaPath: "#/required",
          keyword: "required",
          params: {
            missingProperty: missing0
          },
          message: "must have required property '" + missing0 + "'"
        }];
        return false;
      } else {
        if (data.success !== void 0) {
          let data0 = data.success;
          const _errs1 = errors;
          if (typeof data0 !== "boolean") {
            validate180.errors = [{
              instancePath: instancePath + "/success",
              schemaPath: "#/properties/success/type",
              keyword: "type",
              params: {
                type: "boolean"
              },
              message: "must be boolean"
            }];
            return false;
          }
          if (true !== data0) {
            validate180.errors = [{
              instancePath: instancePath + "/success",
              schemaPath: "#/properties/success/const",
              keyword: "const",
              params: {
                allowedValue: true
              },
              message: "must be equal to constant"
            }];
            return false;
          }
          var valid0 = _errs1 === errors;
        } else {
          var valid0 = true;
        }
        if (valid0) {
          if (data.redirection !== void 0) {
            const _errs3 = errors;
            if (typeof data.redirection !== "string") {
              validate180.errors = [{
                instancePath: instancePath + "/redirection",
                schemaPath: "#/properties/redirection/type",
                keyword: "type",
                params: {
                  type: "string"
                },
                message: "must be string"
              }];
              return false;
            }
            var valid0 = _errs3 === errors;
          } else {
            var valid0 = true;
          }
        }
      }
    } else {
      validate180.errors = [{
        instancePath,
        schemaPath: "#/type",
        keyword: "type",
        params: {
          type: "object"
        },
        message: "must be object"
      }];
      return false;
    }
  }
  validate180.errors = vErrors;
  return errors === 0;
}
const LinkExternalAccountErrorResponse = validate181;
function validate181(data, {
  instancePath = "",
  parentData,
  parentDataProperty,
  rootData = data
} = {}) {
  let vErrors = null;
  let errors = 0;
  {
    if (data && typeof data == "object" && !Array.isArray(data)) {
      let missing0;
      if (data.success === void 0 && (missing0 = "success") || data.errorReason === void 0 && (missing0 = "errorReason")) {
        validate181.errors = [{
          instancePath,
          schemaPath: "#/required",
          keyword: "required",
          params: {
            missingProperty: missing0
          },
          message: "must have required property '" + missing0 + "'"
        }];
        return false;
      } else {
        if (data.success !== void 0) {
          let data0 = data.success;
          const _errs1 = errors;
          if (typeof data0 !== "boolean") {
            validate181.errors = [{
              instancePath: instancePath + "/success",
              schemaPath: "#/properties/success/type",
              keyword: "type",
              params: {
                type: "boolean"
              },
              message: "must be boolean"
            }];
            return false;
          }
          if (false !== data0) {
            validate181.errors = [{
              instancePath: instancePath + "/success",
              schemaPath: "#/properties/success/const",
              keyword: "const",
              params: {
                allowedValue: false
              },
              message: "must be equal to constant"
            }];
            return false;
          }
          var valid0 = _errs1 === errors;
        } else {
          var valid0 = true;
        }
        if (valid0) {
          if (data.errorReason !== void 0) {
            const _errs3 = errors;
            if (typeof data.errorReason !== "string") {
              validate181.errors = [{
                instancePath: instancePath + "/errorReason",
                schemaPath: "#/properties/errorReason/type",
                keyword: "type",
                params: {
                  type: "string"
                },
                message: "must be string"
              }];
              return false;
            }
            var valid0 = _errs3 === errors;
          } else {
            var valid0 = true;
          }
        }
      }
    } else {
      validate181.errors = [{
        instancePath,
        schemaPath: "#/type",
        keyword: "type",
        params: {
          type: "object"
        },
        message: "must be object"
      }];
      return false;
    }
  }
  validate181.errors = vErrors;
  return errors === 0;
}
const LinkExternalAccountResponse = validate182;
function validate182(data, {
  instancePath = "",
  parentData,
  parentDataProperty,
  rootData = data
} = {}) {
  let vErrors = null;
  let errors = 0;
  const _errs0 = errors;
  let valid0 = false;
  const _errs1 = errors;
  const _errs2 = errors;
  if (errors === _errs2) {
    if (data && typeof data == "object" && !Array.isArray(data)) {
      let missing0;
      if (data.success === void 0 && (missing0 = "success") || data.redirection === void 0 && (missing0 = "redirection")) {
        const err0 = {
          instancePath,
          schemaPath: "LinkExternalAccountSuccessfulResponse/required",
          keyword: "required",
          params: {
            missingProperty: missing0
          },
          message: "must have required property '" + missing0 + "'"
        };
        if (vErrors === null) {
          vErrors = [err0];
        } else {
          vErrors.push(err0);
        }
        errors++;
      } else {
        if (data.success !== void 0) {
          let data0 = data.success;
          const _errs4 = errors;
          if (typeof data0 !== "boolean") {
            const err1 = {
              instancePath: instancePath + "/success",
              schemaPath: "LinkExternalAccountSuccessfulResponse/properties/success/type",
              keyword: "type",
              params: {
                type: "boolean"
              },
              message: "must be boolean"
            };
            if (vErrors === null) {
              vErrors = [err1];
            } else {
              vErrors.push(err1);
            }
            errors++;
          }
          if (true !== data0) {
            const err2 = {
              instancePath: instancePath + "/success",
              schemaPath: "LinkExternalAccountSuccessfulResponse/properties/success/const",
              keyword: "const",
              params: {
                allowedValue: true
              },
              message: "must be equal to constant"
            };
            if (vErrors === null) {
              vErrors = [err2];
            } else {
              vErrors.push(err2);
            }
            errors++;
          }
          var valid2 = _errs4 === errors;
        } else {
          var valid2 = true;
        }
        if (valid2) {
          if (data.redirection !== void 0) {
            const _errs6 = errors;
            if (typeof data.redirection !== "string") {
              const err3 = {
                instancePath: instancePath + "/redirection",
                schemaPath: "LinkExternalAccountSuccessfulResponse/properties/redirection/type",
                keyword: "type",
                params: {
                  type: "string"
                },
                message: "must be string"
              };
              if (vErrors === null) {
                vErrors = [err3];
              } else {
                vErrors.push(err3);
              }
              errors++;
            }
            var valid2 = _errs6 === errors;
          } else {
            var valid2 = true;
          }
        }
      }
    } else {
      const err4 = {
        instancePath,
        schemaPath: "LinkExternalAccountSuccessfulResponse/type",
        keyword: "type",
        params: {
          type: "object"
        },
        message: "must be object"
      };
      if (vErrors === null) {
        vErrors = [err4];
      } else {
        vErrors.push(err4);
      }
      errors++;
    }
  }
  var _valid0 = _errs1 === errors;
  valid0 = valid0 || _valid0;
  if (!valid0) {
    const _errs8 = errors;
    const _errs9 = errors;
    if (errors === _errs9) {
      if (data && typeof data == "object" && !Array.isArray(data)) {
        let missing1;
        if (data.success === void 0 && (missing1 = "success") || data.errorReason === void 0 && (missing1 = "errorReason")) {
          const err5 = {
            instancePath,
            schemaPath: "LinkExternalAccountErrorResponse/required",
            keyword: "required",
            params: {
              missingProperty: missing1
            },
            message: "must have required property '" + missing1 + "'"
          };
          if (vErrors === null) {
            vErrors = [err5];
          } else {
            vErrors.push(err5);
          }
          errors++;
        } else {
          if (data.success !== void 0) {
            let data2 = data.success;
            const _errs11 = errors;
            if (typeof data2 !== "boolean") {
              const err6 = {
                instancePath: instancePath + "/success",
                schemaPath: "LinkExternalAccountErrorResponse/properties/success/type",
                keyword: "type",
                params: {
                  type: "boolean"
                },
                message: "must be boolean"
              };
              if (vErrors === null) {
                vErrors = [err6];
              } else {
                vErrors.push(err6);
              }
              errors++;
            }
            if (false !== data2) {
              const err7 = {
                instancePath: instancePath + "/success",
                schemaPath: "LinkExternalAccountErrorResponse/properties/success/const",
                keyword: "const",
                params: {
                  allowedValue: false
                },
                message: "must be equal to constant"
              };
              if (vErrors === null) {
                vErrors = [err7];
              } else {
                vErrors.push(err7);
              }
              errors++;
            }
            var valid4 = _errs11 === errors;
          } else {
            var valid4 = true;
          }
          if (valid4) {
            if (data.errorReason !== void 0) {
              const _errs13 = errors;
              if (typeof data.errorReason !== "string") {
                const err8 = {
                  instancePath: instancePath + "/errorReason",
                  schemaPath: "LinkExternalAccountErrorResponse/properties/errorReason/type",
                  keyword: "type",
                  params: {
                    type: "string"
                  },
                  message: "must be string"
                };
                if (vErrors === null) {
                  vErrors = [err8];
                } else {
                  vErrors.push(err8);
                }
                errors++;
              }
              var valid4 = _errs13 === errors;
            } else {
              var valid4 = true;
            }
          }
        }
      } else {
        const err9 = {
          instancePath,
          schemaPath: "LinkExternalAccountErrorResponse/type",
          keyword: "type",
          params: {
            type: "object"
          },
          message: "must be object"
        };
        if (vErrors === null) {
          vErrors = [err9];
        } else {
          vErrors.push(err9);
        }
        errors++;
      }
    }
    var _valid0 = _errs8 === errors;
    valid0 = valid0 || _valid0;
  }
  if (!valid0) {
    const err10 = {
      instancePath,
      schemaPath: "#/anyOf",
      keyword: "anyOf",
      params: {},
      message: "must match a schema in anyOf"
    };
    if (vErrors === null) {
      vErrors = [err10];
    } else {
      vErrors.push(err10);
    }
    errors++;
    validate182.errors = vErrors;
    return false;
  } else {
    errors = _errs0;
    if (vErrors !== null) {
      if (_errs0) {
        vErrors.length = _errs0;
      } else {
        vErrors = null;
      }
    }
  }
  validate182.errors = vErrors;
  return errors === 0;
}
const ManageSubscriptionRequest = validate183;
function validate183(data, {
  instancePath = "",
  parentData,
  parentDataProperty,
  rootData = data
} = {}) {
  let vErrors = null;
  let errors = 0;
  if (errors === 0) {
    if (data && typeof data == "object" && !Array.isArray(data)) {
      let missing0;
      if (data.channelId === void 0 && (missing0 = "channelId") || data.subscriptionId === void 0 && (missing0 = "subscriptionId") || data.command === void 0 && (missing0 = "command")) {
        validate183.errors = [{
          instancePath,
          schemaPath: "#/required",
          keyword: "required",
          params: {
            missingProperty: missing0
          },
          message: "must have required property '" + missing0 + "'"
        }];
        return false;
      } else {
        if (data.channelId !== void 0) {
          const _errs1 = errors;
          if (typeof data.channelId !== "string") {
            validate183.errors = [{
              instancePath: instancePath + "/channelId",
              schemaPath: "#/properties/channelId/type",
              keyword: "type",
              params: {
                type: "string"
              },
              message: "must be string"
            }];
            return false;
          }
          var valid0 = _errs1 === errors;
        } else {
          var valid0 = true;
        }
        if (valid0) {
          if (data.subscriptionId !== void 0) {
            const _errs3 = errors;
            if (typeof data.subscriptionId !== "string") {
              validate183.errors = [{
                instancePath: instancePath + "/subscriptionId",
                schemaPath: "#/properties/subscriptionId/type",
                keyword: "type",
                params: {
                  type: "string"
                },
                message: "must be string"
              }];
              return false;
            }
            var valid0 = _errs3 === errors;
          } else {
            var valid0 = true;
          }
          if (valid0) {
            if (data.command !== void 0) {
              let data2 = data.command;
              const _errs5 = errors;
              const _errs6 = errors;
              let valid1 = false;
              const _errs7 = errors;
              const _errs8 = errors;
              if (errors === _errs8) {
                if (data2 && typeof data2 == "object" && !Array.isArray(data2)) {
                  let missing1;
                  if (data2.type === void 0 && (missing1 = "type") || data2.reason === void 0 && (missing1 = "reason")) {
                    const err0 = {
                      instancePath: instancePath + "/command",
                      schemaPath: "CancelSubscriptionCommand/required",
                      keyword: "required",
                      params: {
                        missingProperty: missing1
                      },
                      message: "must have required property '" + missing1 + "'"
                    };
                    if (vErrors === null) {
                      vErrors = [err0];
                    } else {
                      vErrors.push(err0);
                    }
                    errors++;
                  } else {
                    if (data2.type !== void 0) {
                      let data3 = data2.type;
                      const _errs10 = errors;
                      if (typeof data3 !== "string") {
                        const err1 = {
                          instancePath: instancePath + "/command/type",
                          schemaPath: "CancelSubscriptionCommand/properties/type/type",
                          keyword: "type",
                          params: {
                            type: "string"
                          },
                          message: "must be string"
                        };
                        if (vErrors === null) {
                          vErrors = [err1];
                        } else {
                          vErrors.push(err1);
                        }
                        errors++;
                      }
                      if ("CANCEL" !== data3) {
                        const err2 = {
                          instancePath: instancePath + "/command/type",
                          schemaPath: "CancelSubscriptionCommand/properties/type/const",
                          keyword: "const",
                          params: {
                            allowedValue: "CANCEL"
                          },
                          message: "must be equal to constant"
                        };
                        if (vErrors === null) {
                          vErrors = [err2];
                        } else {
                          vErrors.push(err2);
                        }
                        errors++;
                      }
                      var valid3 = _errs10 === errors;
                    } else {
                      var valid3 = true;
                    }
                    if (valid3) {
                      if (data2.reason !== void 0) {
                        const _errs12 = errors;
                        if (typeof data2.reason !== "string") {
                          const err3 = {
                            instancePath: instancePath + "/command/reason",
                            schemaPath: "CancelSubscriptionCommand/properties/reason/type",
                            keyword: "type",
                            params: {
                              type: "string"
                            },
                            message: "must be string"
                          };
                          if (vErrors === null) {
                            vErrors = [err3];
                          } else {
                            vErrors.push(err3);
                          }
                          errors++;
                        }
                        var valid3 = _errs12 === errors;
                      } else {
                        var valid3 = true;
                      }
                    }
                  }
                } else {
                  const err4 = {
                    instancePath: instancePath + "/command",
                    schemaPath: "CancelSubscriptionCommand/type",
                    keyword: "type",
                    params: {
                      type: "object"
                    },
                    message: "must be object"
                  };
                  if (vErrors === null) {
                    vErrors = [err4];
                  } else {
                    vErrors.push(err4);
                  }
                  errors++;
                }
              }
              var _valid0 = _errs7 === errors;
              valid1 = valid1 || _valid0;
              if (!valid1) {
                const _errs14 = errors;
                const _errs15 = errors;
                if (errors === _errs15) {
                  if (data2 && typeof data2 == "object" && !Array.isArray(data2)) {
                    let missing2;
                    if (data2.type === void 0 && (missing2 = "type")) {
                      const err5 = {
                        instancePath: instancePath + "/command",
                        schemaPath: "UncancelSubscriptionCommand/required",
                        keyword: "required",
                        params: {
                          missingProperty: missing2
                        },
                        message: "must have required property '" + missing2 + "'"
                      };
                      if (vErrors === null) {
                        vErrors = [err5];
                      } else {
                        vErrors.push(err5);
                      }
                      errors++;
                    } else {
                      if (data2.type !== void 0) {
                        let data5 = data2.type;
                        if (typeof data5 !== "string") {
                          const err6 = {
                            instancePath: instancePath + "/command/type",
                            schemaPath: "UncancelSubscriptionCommand/properties/type/type",
                            keyword: "type",
                            params: {
                              type: "string"
                            },
                            message: "must be string"
                          };
                          if (vErrors === null) {
                            vErrors = [err6];
                          } else {
                            vErrors.push(err6);
                          }
                          errors++;
                        }
                        if ("UNCANCEL" !== data5) {
                          const err7 = {
                            instancePath: instancePath + "/command/type",
                            schemaPath: "UncancelSubscriptionCommand/properties/type/const",
                            keyword: "const",
                            params: {
                              allowedValue: "UNCANCEL"
                            },
                            message: "must be equal to constant"
                          };
                          if (vErrors === null) {
                            vErrors = [err7];
                          } else {
                            vErrors.push(err7);
                          }
                          errors++;
                        }
                      }
                    }
                  } else {
                    const err8 = {
                      instancePath: instancePath + "/command",
                      schemaPath: "UncancelSubscriptionCommand/type",
                      keyword: "type",
                      params: {
                        type: "object"
                      },
                      message: "must be object"
                    };
                    if (vErrors === null) {
                      vErrors = [err8];
                    } else {
                      vErrors.push(err8);
                    }
                    errors++;
                  }
                }
                var _valid0 = _errs14 === errors;
                valid1 = valid1 || _valid0;
                if (!valid1) {
                  const _errs19 = errors;
                  const _errs20 = errors;
                  if (errors === _errs20) {
                    if (data2 && typeof data2 == "object" && !Array.isArray(data2)) {
                      let missing3;
                      if (data2.type === void 0 && (missing3 = "type") || data2.newPaymentMethodId === void 0 && (missing3 = "newPaymentMethodId")) {
                        const err9 = {
                          instancePath: instancePath + "/command",
                          schemaPath: "UpdateSubscriptionPaymentCommand/required",
                          keyword: "required",
                          params: {
                            missingProperty: missing3
                          },
                          message: "must have required property '" + missing3 + "'"
                        };
                        if (vErrors === null) {
                          vErrors = [err9];
                        } else {
                          vErrors.push(err9);
                        }
                        errors++;
                      } else {
                        if (data2.type !== void 0) {
                          let data6 = data2.type;
                          const _errs22 = errors;
                          if (typeof data6 !== "string") {
                            const err10 = {
                              instancePath: instancePath + "/command/type",
                              schemaPath: "UpdateSubscriptionPaymentCommand/properties/type/type",
                              keyword: "type",
                              params: {
                                type: "string"
                              },
                              message: "must be string"
                            };
                            if (vErrors === null) {
                              vErrors = [err10];
                            } else {
                              vErrors.push(err10);
                            }
                            errors++;
                          }
                          if ("UPDATE_PAYMENT_METHOD" !== data6) {
                            const err11 = {
                              instancePath: instancePath + "/command/type",
                              schemaPath: "UpdateSubscriptionPaymentCommand/properties/type/const",
                              keyword: "const",
                              params: {
                                allowedValue: "UPDATE_PAYMENT_METHOD"
                              },
                              message: "must be equal to constant"
                            };
                            if (vErrors === null) {
                              vErrors = [err11];
                            } else {
                              vErrors.push(err11);
                            }
                            errors++;
                          }
                          var valid7 = _errs22 === errors;
                        } else {
                          var valid7 = true;
                        }
                        if (valid7) {
                          if (data2.newPaymentMethodId !== void 0) {
                            const _errs24 = errors;
                            if (typeof data2.newPaymentMethodId !== "string") {
                              const err12 = {
                                instancePath: instancePath + "/command/newPaymentMethodId",
                                schemaPath: "UpdateSubscriptionPaymentCommand/properties/newPaymentMethodId/type",
                                keyword: "type",
                                params: {
                                  type: "string"
                                },
                                message: "must be string"
                              };
                              if (vErrors === null) {
                                vErrors = [err12];
                              } else {
                                vErrors.push(err12);
                              }
                              errors++;
                            }
                            var valid7 = _errs24 === errors;
                          } else {
                            var valid7 = true;
                          }
                          if (valid7) {
                            if (data2.chargeImmediately !== void 0) {
                              const _errs26 = errors;
                              if (typeof data2.chargeImmediately !== "boolean") {
                                const err13 = {
                                  instancePath: instancePath + "/command/chargeImmediately",
                                  schemaPath: "UpdateSubscriptionPaymentCommand/properties/chargeImmediately/type",
                                  keyword: "type",
                                  params: {
                                    type: "boolean"
                                  },
                                  message: "must be boolean"
                                };
                                if (vErrors === null) {
                                  vErrors = [err13];
                                } else {
                                  vErrors.push(err13);
                                }
                                errors++;
                              }
                              var valid7 = _errs26 === errors;
                            } else {
                              var valid7 = true;
                            }
                          }
                        }
                      }
                    } else {
                      const err14 = {
                        instancePath: instancePath + "/command",
                        schemaPath: "UpdateSubscriptionPaymentCommand/type",
                        keyword: "type",
                        params: {
                          type: "object"
                        },
                        message: "must be object"
                      };
                      if (vErrors === null) {
                        vErrors = [err14];
                      } else {
                        vErrors.push(err14);
                      }
                      errors++;
                    }
                  }
                  var _valid0 = _errs19 === errors;
                  valid1 = valid1 || _valid0;
                  if (!valid1) {
                    const _errs28 = errors;
                    const _errs29 = errors;
                    if (errors === _errs29) {
                      if (data2 && typeof data2 == "object" && !Array.isArray(data2)) {
                        let missing4;
                        if (data2.type === void 0 && (missing4 = "type") || data2.duration === void 0 && (missing4 = "duration")) {
                          const err15 = {
                            instancePath: instancePath + "/command",
                            schemaPath: "PauseSubscriptionCommand/required",
                            keyword: "required",
                            params: {
                              missingProperty: missing4
                            },
                            message: "must have required property '" + missing4 + "'"
                          };
                          if (vErrors === null) {
                            vErrors = [err15];
                          } else {
                            vErrors.push(err15);
                          }
                          errors++;
                        } else {
                          if (data2.type !== void 0) {
                            let data9 = data2.type;
                            const _errs31 = errors;
                            if (typeof data9 !== "string") {
                              const err16 = {
                                instancePath: instancePath + "/command/type",
                                schemaPath: "PauseSubscriptionCommand/properties/type/type",
                                keyword: "type",
                                params: {
                                  type: "string"
                                },
                                message: "must be string"
                              };
                              if (vErrors === null) {
                                vErrors = [err16];
                              } else {
                                vErrors.push(err16);
                              }
                              errors++;
                            }
                            if ("PAUSE" !== data9) {
                              const err17 = {
                                instancePath: instancePath + "/command/type",
                                schemaPath: "PauseSubscriptionCommand/properties/type/const",
                                keyword: "const",
                                params: {
                                  allowedValue: "PAUSE"
                                },
                                message: "must be equal to constant"
                              };
                              if (vErrors === null) {
                                vErrors = [err17];
                              } else {
                                vErrors.push(err17);
                              }
                              errors++;
                            }
                            var valid9 = _errs31 === errors;
                          } else {
                            var valid9 = true;
                          }
                          if (valid9) {
                            if (data2.duration !== void 0) {
                              let data10 = data2.duration;
                              const _errs33 = errors;
                              const _errs34 = errors;
                              let valid10 = false;
                              const _errs35 = errors;
                              if (!(typeof data10 == "number" && isFinite(data10))) {
                                const err18 = {
                                  instancePath: instancePath + "/command/duration",
                                  schemaPath: "PauseSubscriptionCommand/properties/duration/anyOf/0/type",
                                  keyword: "type",
                                  params: {
                                    type: "number"
                                  },
                                  message: "must be number"
                                };
                                if (vErrors === null) {
                                  vErrors = [err18];
                                } else {
                                  vErrors.push(err18);
                                }
                                errors++;
                              }
                              var _valid1 = _errs35 === errors;
                              valid10 = valid10 || _valid1;
                              if (!valid10) {
                                const _errs37 = errors;
                                if (errors === _errs37) {
                                  if (data10 && typeof data10 == "object" && !Array.isArray(data10)) {
                                    let missing5;
                                    if (data10.date === void 0 && (missing5 = "date")) {
                                      const err19 = {
                                        instancePath: instancePath + "/command/duration",
                                        schemaPath: "PauseSubscriptionCommand/properties/duration/anyOf/1/required",
                                        keyword: "required",
                                        params: {
                                          missingProperty: missing5
                                        },
                                        message: "must have required property '" + missing5 + "'"
                                      };
                                      if (vErrors === null) {
                                        vErrors = [err19];
                                      } else {
                                        vErrors.push(err19);
                                      }
                                      errors++;
                                    } else {
                                      if (data10.date !== void 0) {
                                        let data11 = data10.date;
                                        if (!(typeof data11 == "number" && isFinite(data11))) {
                                          const err20 = {
                                            instancePath: instancePath + "/command/duration/date",
                                            schemaPath: "PauseSubscriptionCommand/properties/duration/anyOf/1/properties/date/type",
                                            keyword: "type",
                                            params: {
                                              type: "number"
                                            },
                                            message: "must be number"
                                          };
                                          if (vErrors === null) {
                                            vErrors = [err20];
                                          } else {
                                            vErrors.push(err20);
                                          }
                                          errors++;
                                        }
                                      }
                                    }
                                  } else {
                                    const err21 = {
                                      instancePath: instancePath + "/command/duration",
                                      schemaPath: "PauseSubscriptionCommand/properties/duration/anyOf/1/type",
                                      keyword: "type",
                                      params: {
                                        type: "object"
                                      },
                                      message: "must be object"
                                    };
                                    if (vErrors === null) {
                                      vErrors = [err21];
                                    } else {
                                      vErrors.push(err21);
                                    }
                                    errors++;
                                  }
                                }
                                var _valid1 = _errs37 === errors;
                                valid10 = valid10 || _valid1;
                              }
                              if (!valid10) {
                                const err22 = {
                                  instancePath: instancePath + "/command/duration",
                                  schemaPath: "PauseSubscriptionCommand/properties/duration/anyOf",
                                  keyword: "anyOf",
                                  params: {},
                                  message: "must match a schema in anyOf"
                                };
                                if (vErrors === null) {
                                  vErrors = [err22];
                                } else {
                                  vErrors.push(err22);
                                }
                                errors++;
                              } else {
                                errors = _errs34;
                                if (vErrors !== null) {
                                  if (_errs34) {
                                    vErrors.length = _errs34;
                                  } else {
                                    vErrors = null;
                                  }
                                }
                              }
                              var valid9 = _errs33 === errors;
                            } else {
                              var valid9 = true;
                            }
                          }
                        }
                      } else {
                        const err23 = {
                          instancePath: instancePath + "/command",
                          schemaPath: "PauseSubscriptionCommand/type",
                          keyword: "type",
                          params: {
                            type: "object"
                          },
                          message: "must be object"
                        };
                        if (vErrors === null) {
                          vErrors = [err23];
                        } else {
                          vErrors.push(err23);
                        }
                        errors++;
                      }
                    }
                    var _valid0 = _errs28 === errors;
                    valid1 = valid1 || _valid0;
                    if (!valid1) {
                      const _errs41 = errors;
                      const _errs42 = errors;
                      if (errors === _errs42) {
                        if (data2 && typeof data2 == "object" && !Array.isArray(data2)) {
                          let missing6;
                          if (data2.type === void 0 && (missing6 = "type")) {
                            const err24 = {
                              instancePath: instancePath + "/command",
                              schemaPath: "UnpauseSubscriptionCommand/required",
                              keyword: "required",
                              params: {
                                missingProperty: missing6
                              },
                              message: "must have required property '" + missing6 + "'"
                            };
                            if (vErrors === null) {
                              vErrors = [err24];
                            } else {
                              vErrors.push(err24);
                            }
                            errors++;
                          } else {
                            if (data2.type !== void 0) {
                              let data12 = data2.type;
                              if (typeof data12 !== "string") {
                                const err25 = {
                                  instancePath: instancePath + "/command/type",
                                  schemaPath: "UnpauseSubscriptionCommand/properties/type/type",
                                  keyword: "type",
                                  params: {
                                    type: "string"
                                  },
                                  message: "must be string"
                                };
                                if (vErrors === null) {
                                  vErrors = [err25];
                                } else {
                                  vErrors.push(err25);
                                }
                                errors++;
                              }
                              if ("UNPAUSE" !== data12) {
                                const err26 = {
                                  instancePath: instancePath + "/command/type",
                                  schemaPath: "UnpauseSubscriptionCommand/properties/type/const",
                                  keyword: "const",
                                  params: {
                                    allowedValue: "UNPAUSE"
                                  },
                                  message: "must be equal to constant"
                                };
                                if (vErrors === null) {
                                  vErrors = [err26];
                                } else {
                                  vErrors.push(err26);
                                }
                                errors++;
                              }
                            }
                          }
                        } else {
                          const err27 = {
                            instancePath: instancePath + "/command",
                            schemaPath: "UnpauseSubscriptionCommand/type",
                            keyword: "type",
                            params: {
                              type: "object"
                            },
                            message: "must be object"
                          };
                          if (vErrors === null) {
                            vErrors = [err27];
                          } else {
                            vErrors.push(err27);
                          }
                          errors++;
                        }
                      }
                      var _valid0 = _errs41 === errors;
                      valid1 = valid1 || _valid0;
                    }
                  }
                }
              }
              if (!valid1) {
                const err28 = {
                  instancePath: instancePath + "/command",
                  schemaPath: "#/properties/command/anyOf",
                  keyword: "anyOf",
                  params: {},
                  message: "must match a schema in anyOf"
                };
                if (vErrors === null) {
                  vErrors = [err28];
                } else {
                  vErrors.push(err28);
                }
                errors++;
                validate183.errors = vErrors;
                return false;
              } else {
                errors = _errs6;
                if (vErrors !== null) {
                  if (_errs6) {
                    vErrors.length = _errs6;
                  } else {
                    vErrors = null;
                  }
                }
              }
              var valid0 = _errs5 === errors;
            } else {
              var valid0 = true;
            }
          }
        }
      }
    } else {
      validate183.errors = [{
        instancePath,
        schemaPath: "#/type",
        keyword: "type",
        params: {
          type: "object"
        },
        message: "must be object"
      }];
      return false;
    }
  }
  validate183.errors = vErrors;
  return errors === 0;
}
const CancelSubscriptionCommand = validate184;
function validate184(data, {
  instancePath = "",
  parentData,
  parentDataProperty,
  rootData = data
} = {}) {
  let vErrors = null;
  let errors = 0;
  {
    if (data && typeof data == "object" && !Array.isArray(data)) {
      let missing0;
      if (data.type === void 0 && (missing0 = "type") || data.reason === void 0 && (missing0 = "reason")) {
        validate184.errors = [{
          instancePath,
          schemaPath: "#/required",
          keyword: "required",
          params: {
            missingProperty: missing0
          },
          message: "must have required property '" + missing0 + "'"
        }];
        return false;
      } else {
        if (data.type !== void 0) {
          let data0 = data.type;
          const _errs1 = errors;
          if (typeof data0 !== "string") {
            validate184.errors = [{
              instancePath: instancePath + "/type",
              schemaPath: "#/properties/type/type",
              keyword: "type",
              params: {
                type: "string"
              },
              message: "must be string"
            }];
            return false;
          }
          if ("CANCEL" !== data0) {
            validate184.errors = [{
              instancePath: instancePath + "/type",
              schemaPath: "#/properties/type/const",
              keyword: "const",
              params: {
                allowedValue: "CANCEL"
              },
              message: "must be equal to constant"
            }];
            return false;
          }
          var valid0 = _errs1 === errors;
        } else {
          var valid0 = true;
        }
        if (valid0) {
          if (data.reason !== void 0) {
            const _errs3 = errors;
            if (typeof data.reason !== "string") {
              validate184.errors = [{
                instancePath: instancePath + "/reason",
                schemaPath: "#/properties/reason/type",
                keyword: "type",
                params: {
                  type: "string"
                },
                message: "must be string"
              }];
              return false;
            }
            var valid0 = _errs3 === errors;
          } else {
            var valid0 = true;
          }
        }
      }
    } else {
      validate184.errors = [{
        instancePath,
        schemaPath: "#/type",
        keyword: "type",
        params: {
          type: "object"
        },
        message: "must be object"
      }];
      return false;
    }
  }
  validate184.errors = vErrors;
  return errors === 0;
}
const UncancelSubscriptionCommand = validate185;
function validate185(data, {
  instancePath = "",
  parentData,
  parentDataProperty,
  rootData = data
} = {}) {
  let vErrors = null;
  let errors = 0;
  {
    if (data && typeof data == "object" && !Array.isArray(data)) {
      let missing0;
      if (data.type === void 0 && (missing0 = "type")) {
        validate185.errors = [{
          instancePath,
          schemaPath: "#/required",
          keyword: "required",
          params: {
            missingProperty: missing0
          },
          message: "must have required property '" + missing0 + "'"
        }];
        return false;
      } else {
        if (data.type !== void 0) {
          let data0 = data.type;
          if (typeof data0 !== "string") {
            validate185.errors = [{
              instancePath: instancePath + "/type",
              schemaPath: "#/properties/type/type",
              keyword: "type",
              params: {
                type: "string"
              },
              message: "must be string"
            }];
            return false;
          }
          if ("UNCANCEL" !== data0) {
            validate185.errors = [{
              instancePath: instancePath + "/type",
              schemaPath: "#/properties/type/const",
              keyword: "const",
              params: {
                allowedValue: "UNCANCEL"
              },
              message: "must be equal to constant"
            }];
            return false;
          }
        }
      }
    } else {
      validate185.errors = [{
        instancePath,
        schemaPath: "#/type",
        keyword: "type",
        params: {
          type: "object"
        },
        message: "must be object"
      }];
      return false;
    }
  }
  validate185.errors = vErrors;
  return errors === 0;
}
const UpdateSubscriptionPaymentCommand = validate186;
function validate186(data, {
  instancePath = "",
  parentData,
  parentDataProperty,
  rootData = data
} = {}) {
  let vErrors = null;
  let errors = 0;
  {
    if (data && typeof data == "object" && !Array.isArray(data)) {
      let missing0;
      if (data.type === void 0 && (missing0 = "type") || data.newPaymentMethodId === void 0 && (missing0 = "newPaymentMethodId")) {
        validate186.errors = [{
          instancePath,
          schemaPath: "#/required",
          keyword: "required",
          params: {
            missingProperty: missing0
          },
          message: "must have required property '" + missing0 + "'"
        }];
        return false;
      } else {
        if (data.type !== void 0) {
          let data0 = data.type;
          const _errs1 = errors;
          if (typeof data0 !== "string") {
            validate186.errors = [{
              instancePath: instancePath + "/type",
              schemaPath: "#/properties/type/type",
              keyword: "type",
              params: {
                type: "string"
              },
              message: "must be string"
            }];
            return false;
          }
          if ("UPDATE_PAYMENT_METHOD" !== data0) {
            validate186.errors = [{
              instancePath: instancePath + "/type",
              schemaPath: "#/properties/type/const",
              keyword: "const",
              params: {
                allowedValue: "UPDATE_PAYMENT_METHOD"
              },
              message: "must be equal to constant"
            }];
            return false;
          }
          var valid0 = _errs1 === errors;
        } else {
          var valid0 = true;
        }
        if (valid0) {
          if (data.newPaymentMethodId !== void 0) {
            const _errs3 = errors;
            if (typeof data.newPaymentMethodId !== "string") {
              validate186.errors = [{
                instancePath: instancePath + "/newPaymentMethodId",
                schemaPath: "#/properties/newPaymentMethodId/type",
                keyword: "type",
                params: {
                  type: "string"
                },
                message: "must be string"
              }];
              return false;
            }
            var valid0 = _errs3 === errors;
          } else {
            var valid0 = true;
          }
          if (valid0) {
            if (data.chargeImmediately !== void 0) {
              const _errs5 = errors;
              if (typeof data.chargeImmediately !== "boolean") {
                validate186.errors = [{
                  instancePath: instancePath + "/chargeImmediately",
                  schemaPath: "#/properties/chargeImmediately/type",
                  keyword: "type",
                  params: {
                    type: "boolean"
                  },
                  message: "must be boolean"
                }];
                return false;
              }
              var valid0 = _errs5 === errors;
            } else {
              var valid0 = true;
            }
          }
        }
      }
    } else {
      validate186.errors = [{
        instancePath,
        schemaPath: "#/type",
        keyword: "type",
        params: {
          type: "object"
        },
        message: "must be object"
      }];
      return false;
    }
  }
  validate186.errors = vErrors;
  return errors === 0;
}
const PauseSubscriptionCommand = validate187;
function validate187(data, {
  instancePath = "",
  parentData,
  parentDataProperty,
  rootData = data
} = {}) {
  let vErrors = null;
  let errors = 0;
  if (errors === 0) {
    if (data && typeof data == "object" && !Array.isArray(data)) {
      let missing0;
      if (data.type === void 0 && (missing0 = "type") || data.duration === void 0 && (missing0 = "duration")) {
        validate187.errors = [{
          instancePath,
          schemaPath: "#/required",
          keyword: "required",
          params: {
            missingProperty: missing0
          },
          message: "must have required property '" + missing0 + "'"
        }];
        return false;
      } else {
        if (data.type !== void 0) {
          let data0 = data.type;
          const _errs1 = errors;
          if (typeof data0 !== "string") {
            validate187.errors = [{
              instancePath: instancePath + "/type",
              schemaPath: "#/properties/type/type",
              keyword: "type",
              params: {
                type: "string"
              },
              message: "must be string"
            }];
            return false;
          }
          if ("PAUSE" !== data0) {
            validate187.errors = [{
              instancePath: instancePath + "/type",
              schemaPath: "#/properties/type/const",
              keyword: "const",
              params: {
                allowedValue: "PAUSE"
              },
              message: "must be equal to constant"
            }];
            return false;
          }
          var valid0 = _errs1 === errors;
        } else {
          var valid0 = true;
        }
        if (valid0) {
          if (data.duration !== void 0) {
            let data1 = data.duration;
            const _errs3 = errors;
            const _errs4 = errors;
            let valid1 = false;
            const _errs5 = errors;
            if (!(typeof data1 == "number" && isFinite(data1))) {
              const err0 = {
                instancePath: instancePath + "/duration",
                schemaPath: "#/properties/duration/anyOf/0/type",
                keyword: "type",
                params: {
                  type: "number"
                },
                message: "must be number"
              };
              if (vErrors === null) {
                vErrors = [err0];
              } else {
                vErrors.push(err0);
              }
              errors++;
            }
            var _valid0 = _errs5 === errors;
            valid1 = valid1 || _valid0;
            if (!valid1) {
              const _errs7 = errors;
              if (errors === _errs7) {
                if (data1 && typeof data1 == "object" && !Array.isArray(data1)) {
                  let missing1;
                  if (data1.date === void 0 && (missing1 = "date")) {
                    const err1 = {
                      instancePath: instancePath + "/duration",
                      schemaPath: "#/properties/duration/anyOf/1/required",
                      keyword: "required",
                      params: {
                        missingProperty: missing1
                      },
                      message: "must have required property '" + missing1 + "'"
                    };
                    if (vErrors === null) {
                      vErrors = [err1];
                    } else {
                      vErrors.push(err1);
                    }
                    errors++;
                  } else {
                    if (data1.date !== void 0) {
                      let data2 = data1.date;
                      if (!(typeof data2 == "number" && isFinite(data2))) {
                        const err2 = {
                          instancePath: instancePath + "/duration/date",
                          schemaPath: "#/properties/duration/anyOf/1/properties/date/type",
                          keyword: "type",
                          params: {
                            type: "number"
                          },
                          message: "must be number"
                        };
                        if (vErrors === null) {
                          vErrors = [err2];
                        } else {
                          vErrors.push(err2);
                        }
                        errors++;
                      }
                    }
                  }
                } else {
                  const err3 = {
                    instancePath: instancePath + "/duration",
                    schemaPath: "#/properties/duration/anyOf/1/type",
                    keyword: "type",
                    params: {
                      type: "object"
                    },
                    message: "must be object"
                  };
                  if (vErrors === null) {
                    vErrors = [err3];
                  } else {
                    vErrors.push(err3);
                  }
                  errors++;
                }
              }
              var _valid0 = _errs7 === errors;
              valid1 = valid1 || _valid0;
            }
            if (!valid1) {
              const err4 = {
                instancePath: instancePath + "/duration",
                schemaPath: "#/properties/duration/anyOf",
                keyword: "anyOf",
                params: {},
                message: "must match a schema in anyOf"
              };
              if (vErrors === null) {
                vErrors = [err4];
              } else {
                vErrors.push(err4);
              }
              errors++;
              validate187.errors = vErrors;
              return false;
            } else {
              errors = _errs4;
              if (vErrors !== null) {
                if (_errs4) {
                  vErrors.length = _errs4;
                } else {
                  vErrors = null;
                }
              }
            }
            var valid0 = _errs3 === errors;
          } else {
            var valid0 = true;
          }
        }
      }
    } else {
      validate187.errors = [{
        instancePath,
        schemaPath: "#/type",
        keyword: "type",
        params: {
          type: "object"
        },
        message: "must be object"
      }];
      return false;
    }
  }
  validate187.errors = vErrors;
  return errors === 0;
}
const UnpauseSubscriptionCommand = validate188;
function validate188(data, {
  instancePath = "",
  parentData,
  parentDataProperty,
  rootData = data
} = {}) {
  let vErrors = null;
  let errors = 0;
  {
    if (data && typeof data == "object" && !Array.isArray(data)) {
      let missing0;
      if (data.type === void 0 && (missing0 = "type")) {
        validate188.errors = [{
          instancePath,
          schemaPath: "#/required",
          keyword: "required",
          params: {
            missingProperty: missing0
          },
          message: "must have required property '" + missing0 + "'"
        }];
        return false;
      } else {
        if (data.type !== void 0) {
          let data0 = data.type;
          if (typeof data0 !== "string") {
            validate188.errors = [{
              instancePath: instancePath + "/type",
              schemaPath: "#/properties/type/type",
              keyword: "type",
              params: {
                type: "string"
              },
              message: "must be string"
            }];
            return false;
          }
          if ("UNPAUSE" !== data0) {
            validate188.errors = [{
              instancePath: instancePath + "/type",
              schemaPath: "#/properties/type/const",
              keyword: "const",
              params: {
                allowedValue: "UNPAUSE"
              },
              message: "must be equal to constant"
            }];
            return false;
          }
        }
      }
    } else {
      validate188.errors = [{
        instancePath,
        schemaPath: "#/type",
        keyword: "type",
        params: {
          type: "object"
        },
        message: "must be object"
      }];
      return false;
    }
  }
  validate188.errors = vErrors;
  return errors === 0;
}
const ManageSubscriptionResponse = validate189;
function validate189(data, {
  instancePath = "",
  parentData,
  parentDataProperty,
  rootData = data
} = {}) {
  let vErrors = null;
  let errors = 0;
  const _errs0 = errors;
  let valid0 = false;
  const _errs1 = errors;
  if (errors === _errs1) {
    if (data && typeof data == "object" && !Array.isArray(data)) {
      let missing0;
      if (data.success === void 0 && (missing0 = "success")) {
        const err0 = {
          instancePath,
          schemaPath: "#/anyOf/0/required",
          keyword: "required",
          params: {
            missingProperty: missing0
          },
          message: "must have required property '" + missing0 + "'"
        };
        if (vErrors === null) {
          vErrors = [err0];
        } else {
          vErrors.push(err0);
        }
        errors++;
      } else {
        if (data.success !== void 0) {
          let data0 = data.success;
          if (typeof data0 !== "boolean") {
            const err1 = {
              instancePath: instancePath + "/success",
              schemaPath: "#/anyOf/0/properties/success/type",
              keyword: "type",
              params: {
                type: "boolean"
              },
              message: "must be boolean"
            };
            if (vErrors === null) {
              vErrors = [err1];
            } else {
              vErrors.push(err1);
            }
            errors++;
          }
          if (true !== data0) {
            const err2 = {
              instancePath: instancePath + "/success",
              schemaPath: "#/anyOf/0/properties/success/const",
              keyword: "const",
              params: {
                allowedValue: true
              },
              message: "must be equal to constant"
            };
            if (vErrors === null) {
              vErrors = [err2];
            } else {
              vErrors.push(err2);
            }
            errors++;
          }
        }
      }
    } else {
      const err3 = {
        instancePath,
        schemaPath: "#/anyOf/0/type",
        keyword: "type",
        params: {
          type: "object"
        },
        message: "must be object"
      };
      if (vErrors === null) {
        vErrors = [err3];
      } else {
        vErrors.push(err3);
      }
      errors++;
    }
  }
  var _valid0 = _errs1 === errors;
  valid0 = valid0 || _valid0;
  if (!valid0) {
    const _errs5 = errors;
    if (errors === _errs5) {
      if (data && typeof data == "object" && !Array.isArray(data)) {
        let missing1;
        if (data.effectiveDate === void 0 && (missing1 = "effectiveDate") || data.success === void 0 && (missing1 = "success")) {
          const err4 = {
            instancePath,
            schemaPath: "#/anyOf/1/required",
            keyword: "required",
            params: {
              missingProperty: missing1
            },
            message: "must have required property '" + missing1 + "'"
          };
          if (vErrors === null) {
            vErrors = [err4];
          } else {
            vErrors.push(err4);
          }
          errors++;
        } else {
          if (data.success !== void 0) {
            let data1 = data.success;
            const _errs7 = errors;
            if (typeof data1 !== "boolean") {
              const err5 = {
                instancePath: instancePath + "/success",
                schemaPath: "#/anyOf/1/properties/success/type",
                keyword: "type",
                params: {
                  type: "boolean"
                },
                message: "must be boolean"
              };
              if (vErrors === null) {
                vErrors = [err5];
              } else {
                vErrors.push(err5);
              }
              errors++;
            }
            if (true !== data1) {
              const err6 = {
                instancePath: instancePath + "/success",
                schemaPath: "#/anyOf/1/properties/success/const",
                keyword: "const",
                params: {
                  allowedValue: true
                },
                message: "must be equal to constant"
              };
              if (vErrors === null) {
                vErrors = [err6];
              } else {
                vErrors.push(err6);
              }
              errors++;
            }
            var valid2 = _errs7 === errors;
          } else {
            var valid2 = true;
          }
          if (valid2) {
            if (data.effectiveDate !== void 0) {
              let data2 = data.effectiveDate;
              const _errs9 = errors;
              if (errors === _errs9) {
                if (errors === _errs9) {
                  if (typeof data2 === "string") {
                    if (!formats0(data2)) {
                      const err7 = {
                        instancePath: instancePath + "/effectiveDate",
                        schemaPath: "#/anyOf/1/properties/effectiveDate/format",
                        keyword: "format",
                        params: {
                          format: "date-time"
                        },
                        message: 'must match format "date-time"'
                      };
                      if (vErrors === null) {
                        vErrors = [err7];
                      } else {
                        vErrors.push(err7);
                      }
                      errors++;
                    }
                  } else {
                    const err8 = {
                      instancePath: instancePath + "/effectiveDate",
                      schemaPath: "#/anyOf/1/properties/effectiveDate/type",
                      keyword: "type",
                      params: {
                        type: "string"
                      },
                      message: "must be string"
                    };
                    if (vErrors === null) {
                      vErrors = [err8];
                    } else {
                      vErrors.push(err8);
                    }
                    errors++;
                  }
                }
              }
              var valid2 = _errs9 === errors;
            } else {
              var valid2 = true;
            }
          }
        }
      } else {
        const err9 = {
          instancePath,
          schemaPath: "#/anyOf/1/type",
          keyword: "type",
          params: {
            type: "object"
          },
          message: "must be object"
        };
        if (vErrors === null) {
          vErrors = [err9];
        } else {
          vErrors.push(err9);
        }
        errors++;
      }
    }
    var _valid0 = _errs5 === errors;
    valid0 = valid0 || _valid0;
    if (!valid0) {
      const _errs11 = errors;
      if (errors === _errs11) {
        if (data && typeof data == "object" && !Array.isArray(data)) {
          let missing2;
          if (data.errorReason === void 0 && (missing2 = "errorReason") || data.success === void 0 && (missing2 = "success")) {
            const err10 = {
              instancePath,
              schemaPath: "#/anyOf/2/required",
              keyword: "required",
              params: {
                missingProperty: missing2
              },
              message: "must have required property '" + missing2 + "'"
            };
            if (vErrors === null) {
              vErrors = [err10];
            } else {
              vErrors.push(err10);
            }
            errors++;
          } else {
            if (data.errorReason !== void 0) {
              const _errs13 = errors;
              if (typeof data.errorReason !== "string") {
                const err11 = {
                  instancePath: instancePath + "/errorReason",
                  schemaPath: "#/anyOf/2/properties/errorReason/type",
                  keyword: "type",
                  params: {
                    type: "string"
                  },
                  message: "must be string"
                };
                if (vErrors === null) {
                  vErrors = [err11];
                } else {
                  vErrors.push(err11);
                }
                errors++;
              }
              var valid3 = _errs13 === errors;
            } else {
              var valid3 = true;
            }
            if (valid3) {
              if (data.success !== void 0) {
                let data4 = data.success;
                const _errs15 = errors;
                if (typeof data4 !== "boolean") {
                  const err12 = {
                    instancePath: instancePath + "/success",
                    schemaPath: "#/anyOf/2/properties/success/type",
                    keyword: "type",
                    params: {
                      type: "boolean"
                    },
                    message: "must be boolean"
                  };
                  if (vErrors === null) {
                    vErrors = [err12];
                  } else {
                    vErrors.push(err12);
                  }
                  errors++;
                }
                if (false !== data4) {
                  const err13 = {
                    instancePath: instancePath + "/success",
                    schemaPath: "#/anyOf/2/properties/success/const",
                    keyword: "const",
                    params: {
                      allowedValue: false
                    },
                    message: "must be equal to constant"
                  };
                  if (vErrors === null) {
                    vErrors = [err13];
                  } else {
                    vErrors.push(err13);
                  }
                  errors++;
                }
                var valid3 = _errs15 === errors;
              } else {
                var valid3 = true;
              }
            }
          }
        } else {
          const err14 = {
            instancePath,
            schemaPath: "#/anyOf/2/type",
            keyword: "type",
            params: {
              type: "object"
            },
            message: "must be object"
          };
          if (vErrors === null) {
            vErrors = [err14];
          } else {
            vErrors.push(err14);
          }
          errors++;
        }
      }
      var _valid0 = _errs11 === errors;
      valid0 = valid0 || _valid0;
    }
  }
  if (!valid0) {
    const err15 = {
      instancePath,
      schemaPath: "#/anyOf",
      keyword: "anyOf",
      params: {},
      message: "must match a schema in anyOf"
    };
    if (vErrors === null) {
      vErrors = [err15];
    } else {
      vErrors.push(err15);
    }
    errors++;
    validate189.errors = vErrors;
    return false;
  } else {
    errors = _errs0;
    if (vErrors !== null) {
      if (_errs0) {
        vErrors.length = _errs0;
      } else {
        vErrors = null;
      }
    }
  }
  validate189.errors = vErrors;
  return errors === 0;
}
const UpdateUserConsentRequest = validate190;
function validate190(data, {
  instancePath = "",
  parentData,
  parentDataProperty,
  rootData = data
} = {}) {
  let vErrors = null;
  let errors = 0;
  {
    if (data && typeof data == "object" && !Array.isArray(data)) {
      let missing0;
      if (data.responses === void 0 && (missing0 = "responses") || data.terms === void 0 && (missing0 = "terms") || data.channelId === void 0 && (missing0 = "channelId")) {
        validate190.errors = [{
          instancePath,
          schemaPath: "#/required",
          keyword: "required",
          params: {
            missingProperty: missing0
          },
          message: "must have required property '" + missing0 + "'"
        }];
        return false;
      } else {
        if (data.merge !== void 0) {
          const _errs1 = errors;
          if (typeof data.merge !== "boolean") {
            validate190.errors = [{
              instancePath: instancePath + "/merge",
              schemaPath: "#/properties/merge/type",
              keyword: "type",
              params: {
                type: "boolean"
              },
              message: "must be boolean"
            }];
            return false;
          }
          var valid0 = _errs1 === errors;
        } else {
          var valid0 = true;
        }
        if (valid0) {
          if (data.responses !== void 0) {
            let data1 = data.responses;
            const _errs3 = errors;
            {
              if (Array.isArray(data1)) {
                var valid1 = true;
                const len0 = data1.length;
                for (let i0 = 0; i0 < len0; i0++) {
                  let data2 = data1[i0];
                  const _errs5 = errors;
                  {
                    if (data2 && typeof data2 == "object" && !Array.isArray(data2)) {
                      let missing1;
                      if (data2.requestId === void 0 && (missing1 = "requestId") || data2.consented === void 0 && (missing1 = "consented") || data2.version === void 0 && (missing1 = "version")) {
                        validate190.errors = [{
                          instancePath: instancePath + "/responses/" + i0,
                          schemaPath: "#/properties/responses/items/required",
                          keyword: "required",
                          params: {
                            missingProperty: missing1
                          },
                          message: "must have required property '" + missing1 + "'"
                        }];
                        return false;
                      } else {
                        if (data2.requestId !== void 0) {
                          const _errs7 = errors;
                          if (typeof data2.requestId !== "string") {
                            validate190.errors = [{
                              instancePath: instancePath + "/responses/" + i0 + "/requestId",
                              schemaPath: "#/properties/responses/items/properties/requestId/type",
                              keyword: "type",
                              params: {
                                type: "string"
                              },
                              message: "must be string"
                            }];
                            return false;
                          }
                          var valid2 = _errs7 === errors;
                        } else {
                          var valid2 = true;
                        }
                        if (valid2) {
                          if (data2.consented !== void 0) {
                            const _errs9 = errors;
                            if (typeof data2.consented !== "boolean") {
                              validate190.errors = [{
                                instancePath: instancePath + "/responses/" + i0 + "/consented",
                                schemaPath: "#/properties/responses/items/properties/consented/type",
                                keyword: "type",
                                params: {
                                  type: "boolean"
                                },
                                message: "must be boolean"
                              }];
                              return false;
                            }
                            var valid2 = _errs9 === errors;
                          } else {
                            var valid2 = true;
                          }
                          if (valid2) {
                            if (data2.version !== void 0) {
                              let data5 = data2.version;
                              const _errs11 = errors;
                              if (!(typeof data5 == "number" && isFinite(data5))) {
                                validate190.errors = [{
                                  instancePath: instancePath + "/responses/" + i0 + "/version",
                                  schemaPath: "#/properties/responses/items/properties/version/type",
                                  keyword: "type",
                                  params: {
                                    type: "number"
                                  },
                                  message: "must be number"
                                }];
                                return false;
                              }
                              var valid2 = _errs11 === errors;
                            } else {
                              var valid2 = true;
                            }
                          }
                        }
                      }
                    } else {
                      validate190.errors = [{
                        instancePath: instancePath + "/responses/" + i0,
                        schemaPath: "#/properties/responses/items/type",
                        keyword: "type",
                        params: {
                          type: "object"
                        },
                        message: "must be object"
                      }];
                      return false;
                    }
                  }
                  var valid1 = _errs5 === errors;
                  if (!valid1) {
                    break;
                  }
                }
              } else {
                validate190.errors = [{
                  instancePath: instancePath + "/responses",
                  schemaPath: "#/properties/responses/type",
                  keyword: "type",
                  params: {
                    type: "array"
                  },
                  message: "must be array"
                }];
                return false;
              }
            }
            var valid0 = _errs3 === errors;
          } else {
            var valid0 = true;
          }
          if (valid0) {
            if (data.terms !== void 0) {
              let data6 = data.terms;
              const _errs13 = errors;
              {
                if (Array.isArray(data6)) {
                  var valid3 = true;
                  const len1 = data6.length;
                  for (let i1 = 0; i1 < len1; i1++) {
                    let data7 = data6[i1];
                    const _errs15 = errors;
                    {
                      if (data7 && typeof data7 == "object" && !Array.isArray(data7)) {
                        let missing2;
                        if (data7.termsId === void 0 && (missing2 = "termsId") || data7.version === void 0 && (missing2 = "version")) {
                          validate190.errors = [{
                            instancePath: instancePath + "/terms/" + i1,
                            schemaPath: "#/properties/terms/items/required",
                            keyword: "required",
                            params: {
                              missingProperty: missing2
                            },
                            message: "must have required property '" + missing2 + "'"
                          }];
                          return false;
                        } else {
                          if (data7.termsId !== void 0) {
                            const _errs17 = errors;
                            if (typeof data7.termsId !== "string") {
                              validate190.errors = [{
                                instancePath: instancePath + "/terms/" + i1 + "/termsId",
                                schemaPath: "#/properties/terms/items/properties/termsId/type",
                                keyword: "type",
                                params: {
                                  type: "string"
                                },
                                message: "must be string"
                              }];
                              return false;
                            }
                            var valid4 = _errs17 === errors;
                          } else {
                            var valid4 = true;
                          }
                          if (valid4) {
                            if (data7.version !== void 0) {
                              let data9 = data7.version;
                              const _errs19 = errors;
                              if (!(typeof data9 == "number" && isFinite(data9))) {
                                validate190.errors = [{
                                  instancePath: instancePath + "/terms/" + i1 + "/version",
                                  schemaPath: "#/properties/terms/items/properties/version/type",
                                  keyword: "type",
                                  params: {
                                    type: "number"
                                  },
                                  message: "must be number"
                                }];
                                return false;
                              }
                              var valid4 = _errs19 === errors;
                            } else {
                              var valid4 = true;
                            }
                          }
                        }
                      } else {
                        validate190.errors = [{
                          instancePath: instancePath + "/terms/" + i1,
                          schemaPath: "#/properties/terms/items/type",
                          keyword: "type",
                          params: {
                            type: "object"
                          },
                          message: "must be object"
                        }];
                        return false;
                      }
                    }
                    var valid3 = _errs15 === errors;
                    if (!valid3) {
                      break;
                    }
                  }
                } else {
                  validate190.errors = [{
                    instancePath: instancePath + "/terms",
                    schemaPath: "#/properties/terms/type",
                    keyword: "type",
                    params: {
                      type: "array"
                    },
                    message: "must be array"
                  }];
                  return false;
                }
              }
              var valid0 = _errs13 === errors;
            } else {
              var valid0 = true;
            }
            if (valid0) {
              if (data.channelId !== void 0) {
                const _errs21 = errors;
                if (typeof data.channelId !== "string") {
                  validate190.errors = [{
                    instancePath: instancePath + "/channelId",
                    schemaPath: "#/properties/channelId/type",
                    keyword: "type",
                    params: {
                      type: "string"
                    },
                    message: "must be string"
                  }];
                  return false;
                }
                var valid0 = _errs21 === errors;
              } else {
                var valid0 = true;
              }
            }
          }
        }
      }
    } else {
      validate190.errors = [{
        instancePath,
        schemaPath: "#/type",
        keyword: "type",
        params: {
          type: "object"
        },
        message: "must be object"
      }];
      return false;
    }
  }
  validate190.errors = vErrors;
  return errors === 0;
}
const UpdateUserConsentResponse = validate191;
function validate191(data, {
  instancePath = "",
  parentData,
  parentDataProperty,
  rootData = data
} = {}) {
  let vErrors = null;
  let errors = 0;
  const _errs0 = errors;
  let valid0 = false;
  const _errs1 = errors;
  if (errors === _errs1) {
    if (data && typeof data == "object" && !Array.isArray(data)) {
      let missing0;
      if (data.success === void 0 && (missing0 = "success")) {
        const err0 = {
          instancePath,
          schemaPath: "#/anyOf/0/required",
          keyword: "required",
          params: {
            missingProperty: missing0
          },
          message: "must have required property '" + missing0 + "'"
        };
        if (vErrors === null) {
          vErrors = [err0];
        } else {
          vErrors.push(err0);
        }
        errors++;
      } else {
        if (data.success !== void 0) {
          let data0 = data.success;
          if (typeof data0 !== "boolean") {
            const err1 = {
              instancePath: instancePath + "/success",
              schemaPath: "#/anyOf/0/properties/success/type",
              keyword: "type",
              params: {
                type: "boolean"
              },
              message: "must be boolean"
            };
            if (vErrors === null) {
              vErrors = [err1];
            } else {
              vErrors.push(err1);
            }
            errors++;
          }
          if (true !== data0) {
            const err2 = {
              instancePath: instancePath + "/success",
              schemaPath: "#/anyOf/0/properties/success/const",
              keyword: "const",
              params: {
                allowedValue: true
              },
              message: "must be equal to constant"
            };
            if (vErrors === null) {
              vErrors = [err2];
            } else {
              vErrors.push(err2);
            }
            errors++;
          }
        }
      }
    } else {
      const err3 = {
        instancePath,
        schemaPath: "#/anyOf/0/type",
        keyword: "type",
        params: {
          type: "object"
        },
        message: "must be object"
      };
      if (vErrors === null) {
        vErrors = [err3];
      } else {
        vErrors.push(err3);
      }
      errors++;
    }
  }
  var _valid0 = _errs1 === errors;
  valid0 = valid0 || _valid0;
  if (!valid0) {
    const _errs5 = errors;
    if (errors === _errs5) {
      if (data && typeof data == "object" && !Array.isArray(data)) {
        let missing1;
        if (data.success === void 0 && (missing1 = "success") || data.errorReason === void 0 && (missing1 = "errorReason")) {
          const err4 = {
            instancePath,
            schemaPath: "#/anyOf/1/required",
            keyword: "required",
            params: {
              missingProperty: missing1
            },
            message: "must have required property '" + missing1 + "'"
          };
          if (vErrors === null) {
            vErrors = [err4];
          } else {
            vErrors.push(err4);
          }
          errors++;
        } else {
          if (data.success !== void 0) {
            let data1 = data.success;
            const _errs7 = errors;
            if (typeof data1 !== "boolean") {
              const err5 = {
                instancePath: instancePath + "/success",
                schemaPath: "#/anyOf/1/properties/success/type",
                keyword: "type",
                params: {
                  type: "boolean"
                },
                message: "must be boolean"
              };
              if (vErrors === null) {
                vErrors = [err5];
              } else {
                vErrors.push(err5);
              }
              errors++;
            }
            if (false !== data1) {
              const err6 = {
                instancePath: instancePath + "/success",
                schemaPath: "#/anyOf/1/properties/success/const",
                keyword: "const",
                params: {
                  allowedValue: false
                },
                message: "must be equal to constant"
              };
              if (vErrors === null) {
                vErrors = [err6];
              } else {
                vErrors.push(err6);
              }
              errors++;
            }
            var valid2 = _errs7 === errors;
          } else {
            var valid2 = true;
          }
          if (valid2) {
            if (data.errorReason !== void 0) {
              const _errs9 = errors;
              if (typeof data.errorReason !== "string") {
                const err7 = {
                  instancePath: instancePath + "/errorReason",
                  schemaPath: "#/anyOf/1/properties/errorReason/type",
                  keyword: "type",
                  params: {
                    type: "string"
                  },
                  message: "must be string"
                };
                if (vErrors === null) {
                  vErrors = [err7];
                } else {
                  vErrors.push(err7);
                }
                errors++;
              }
              var valid2 = _errs9 === errors;
            } else {
              var valid2 = true;
            }
          }
        }
      } else {
        const err8 = {
          instancePath,
          schemaPath: "#/anyOf/1/type",
          keyword: "type",
          params: {
            type: "object"
          },
          message: "must be object"
        };
        if (vErrors === null) {
          vErrors = [err8];
        } else {
          vErrors.push(err8);
        }
        errors++;
      }
    }
    var _valid0 = _errs5 === errors;
    valid0 = valid0 || _valid0;
  }
  if (!valid0) {
    const err9 = {
      instancePath,
      schemaPath: "#/anyOf",
      keyword: "anyOf",
      params: {},
      message: "must match a schema in anyOf"
    };
    if (vErrors === null) {
      vErrors = [err9];
    } else {
      vErrors.push(err9);
    }
    errors++;
    validate191.errors = vErrors;
    return false;
  } else {
    errors = _errs0;
    if (vErrors !== null) {
      if (_errs0) {
        vErrors.length = _errs0;
      } else {
        vErrors = null;
      }
    }
  }
  validate191.errors = vErrors;
  return errors === 0;
}
const UserConsentEntryResponse = validate192;
function validate192(data, {
  instancePath = "",
  parentData,
  parentDataProperty,
  rootData = data
} = {}) {
  let vErrors = null;
  let errors = 0;
  {
    if (data && typeof data == "object" && !Array.isArray(data)) {
      let missing0;
      if (data.consentedVersion === void 0 && (missing0 = "consentedVersion") || data.consented === void 0 && (missing0 = "consented") || data.date === void 0 && (missing0 = "date")) {
        validate192.errors = [{
          instancePath,
          schemaPath: "#/required",
          keyword: "required",
          params: {
            missingProperty: missing0
          },
          message: "must have required property '" + missing0 + "'"
        }];
        return false;
      } else {
        if (data.consentedVersion !== void 0) {
          let data0 = data.consentedVersion;
          const _errs1 = errors;
          if (!(typeof data0 == "number" && isFinite(data0))) {
            validate192.errors = [{
              instancePath: instancePath + "/consentedVersion",
              schemaPath: "#/properties/consentedVersion/type",
              keyword: "type",
              params: {
                type: "number"
              },
              message: "must be number"
            }];
            return false;
          }
          var valid0 = _errs1 === errors;
        } else {
          var valid0 = true;
        }
        if (valid0) {
          if (data.consented !== void 0) {
            const _errs3 = errors;
            if (typeof data.consented !== "boolean") {
              validate192.errors = [{
                instancePath: instancePath + "/consented",
                schemaPath: "#/properties/consented/type",
                keyword: "type",
                params: {
                  type: "boolean"
                },
                message: "must be boolean"
              }];
              return false;
            }
            var valid0 = _errs3 === errors;
          } else {
            var valid0 = true;
          }
          if (valid0) {
            if (data.date !== void 0) {
              let data2 = data.date;
              const _errs5 = errors;
              if (!(data2 && typeof data2 == "object" && !Array.isArray(data2))) {
                validate192.errors = [{
                  instancePath: instancePath + "/date",
                  schemaPath: "#/properties/date/type",
                  keyword: "type",
                  params: {
                    type: "object"
                  },
                  message: "must be object"
                }];
                return false;
              }
              {
                {
                  if (typeof data2 === "string") {
                    if (!formats0(data2)) {
                      validate192.errors = [{
                        instancePath: instancePath + "/date",
                        schemaPath: "#/properties/date/format",
                        keyword: "format",
                        params: {
                          format: "date-time"
                        },
                        message: 'must match format "date-time"'
                      }];
                      return false;
                    }
                  }
                }
              }
              var valid0 = _errs5 === errors;
            } else {
              var valid0 = true;
            }
          }
        }
      }
    } else {
      validate192.errors = [{
        instancePath,
        schemaPath: "#/type",
        keyword: "type",
        params: {
          type: "object"
        },
        message: "must be object"
      }];
      return false;
    }
  }
  validate192.errors = vErrors;
  return errors === 0;
}
const UserConsentEntryTermsResponse = validate193;
function validate193(data, {
  instancePath = "",
  parentData,
  parentDataProperty,
  rootData = data
} = {}) {
  let vErrors = null;
  let errors = 0;
  {
    if (data && typeof data == "object" && !Array.isArray(data)) {
      let missing0;
      if (data.consentedVersion === void 0 && (missing0 = "consentedVersion") || data.date === void 0 && (missing0 = "date")) {
        validate193.errors = [{
          instancePath,
          schemaPath: "#/required",
          keyword: "required",
          params: {
            missingProperty: missing0
          },
          message: "must have required property '" + missing0 + "'"
        }];
        return false;
      } else {
        if (data.consentedVersion !== void 0) {
          let data0 = data.consentedVersion;
          const _errs1 = errors;
          if (!(typeof data0 == "number" && isFinite(data0))) {
            validate193.errors = [{
              instancePath: instancePath + "/consentedVersion",
              schemaPath: "#/properties/consentedVersion/type",
              keyword: "type",
              params: {
                type: "number"
              },
              message: "must be number"
            }];
            return false;
          }
          var valid0 = _errs1 === errors;
        } else {
          var valid0 = true;
        }
        if (valid0) {
          if (data.date !== void 0) {
            let data1 = data.date;
            const _errs3 = errors;
            if (!(data1 && typeof data1 == "object" && !Array.isArray(data1))) {
              validate193.errors = [{
                instancePath: instancePath + "/date",
                schemaPath: "#/properties/date/type",
                keyword: "type",
                params: {
                  type: "object"
                },
                message: "must be object"
              }];
              return false;
            }
            {
              {
                if (typeof data1 === "string") {
                  if (!formats0(data1)) {
                    validate193.errors = [{
                      instancePath: instancePath + "/date",
                      schemaPath: "#/properties/date/format",
                      keyword: "format",
                      params: {
                        format: "date-time"
                      },
                      message: 'must match format "date-time"'
                    }];
                    return false;
                  }
                }
              }
            }
            var valid0 = _errs3 === errors;
          } else {
            var valid0 = true;
          }
        }
      }
    } else {
      validate193.errors = [{
        instancePath,
        schemaPath: "#/type",
        keyword: "type",
        params: {
          type: "object"
        },
        message: "must be object"
      }];
      return false;
    }
  }
  validate193.errors = vErrors;
  return errors === 0;
}
const UserConsentEntry = validate194;
function validate194(data, {
  instancePath = "",
  parentData,
  parentDataProperty,
  rootData = data
} = {}) {
  let vErrors = null;
  let errors = 0;
  {
    if (data && typeof data == "object" && !Array.isArray(data)) {
      let missing0;
      if (data.userId === void 0 && (missing0 = "userId") || data.channelId === void 0 && (missing0 = "channelId") || data.updateDate === void 0 && (missing0 = "updateDate")) {
        validate194.errors = [{
          instancePath,
          schemaPath: "#/required",
          keyword: "required",
          params: {
            missingProperty: missing0
          },
          message: "must have required property '" + missing0 + "'"
        }];
        return false;
      } else {
        if (data.userId !== void 0) {
          const _errs1 = errors;
          if (typeof data.userId !== "string") {
            validate194.errors = [{
              instancePath: instancePath + "/userId",
              schemaPath: "#/properties/userId/type",
              keyword: "type",
              params: {
                type: "string"
              },
              message: "must be string"
            }];
            return false;
          }
          var valid0 = _errs1 === errors;
        } else {
          var valid0 = true;
        }
        if (valid0) {
          if (data.channelId !== void 0) {
            const _errs3 = errors;
            if (typeof data.channelId !== "string") {
              validate194.errors = [{
                instancePath: instancePath + "/channelId",
                schemaPath: "#/properties/channelId/type",
                keyword: "type",
                params: {
                  type: "string"
                },
                message: "must be string"
              }];
              return false;
            }
            var valid0 = _errs3 === errors;
          } else {
            var valid0 = true;
          }
          if (valid0) {
            if (data.consents !== void 0) {
              let data2 = data.consents;
              const _errs5 = errors;
              {
                if (data2 && typeof data2 == "object" && !Array.isArray(data2)) {
                  for (const key0 in data2) {
                    let data3 = data2[key0];
                    const _errs8 = errors;
                    {
                      if (data3 && typeof data3 == "object" && !Array.isArray(data3)) {
                        let missing1;
                        if (data3.consentedVersion === void 0 && (missing1 = "consentedVersion") || data3.consented === void 0 && (missing1 = "consented") || data3.date === void 0 && (missing1 = "date")) {
                          validate194.errors = [{
                            instancePath: instancePath + "/consents/" + key0.replace(/~/g, "~0").replace(/\//g, "~1"),
                            schemaPath: "UserConsentEntryResponse/required",
                            keyword: "required",
                            params: {
                              missingProperty: missing1
                            },
                            message: "must have required property '" + missing1 + "'"
                          }];
                          return false;
                        } else {
                          if (data3.consentedVersion !== void 0) {
                            let data4 = data3.consentedVersion;
                            const _errs11 = errors;
                            if (!(typeof data4 == "number" && isFinite(data4))) {
                              validate194.errors = [{
                                instancePath: instancePath + "/consents/" + key0.replace(/~/g, "~0").replace(/\//g, "~1") + "/consentedVersion",
                                schemaPath: "UserConsentEntryResponse/properties/consentedVersion/type",
                                keyword: "type",
                                params: {
                                  type: "number"
                                },
                                message: "must be number"
                              }];
                              return false;
                            }
                            var valid3 = _errs11 === errors;
                          } else {
                            var valid3 = true;
                          }
                          if (valid3) {
                            if (data3.consented !== void 0) {
                              const _errs13 = errors;
                              if (typeof data3.consented !== "boolean") {
                                validate194.errors = [{
                                  instancePath: instancePath + "/consents/" + key0.replace(/~/g, "~0").replace(/\//g, "~1") + "/consented",
                                  schemaPath: "UserConsentEntryResponse/properties/consented/type",
                                  keyword: "type",
                                  params: {
                                    type: "boolean"
                                  },
                                  message: "must be boolean"
                                }];
                                return false;
                              }
                              var valid3 = _errs13 === errors;
                            } else {
                              var valid3 = true;
                            }
                            if (valid3) {
                              if (data3.date !== void 0) {
                                let data6 = data3.date;
                                const _errs15 = errors;
                                if (!(data6 && typeof data6 == "object" && !Array.isArray(data6))) {
                                  validate194.errors = [{
                                    instancePath: instancePath + "/consents/" + key0.replace(/~/g, "~0").replace(/\//g, "~1") + "/date",
                                    schemaPath: "UserConsentEntryResponse/properties/date/type",
                                    keyword: "type",
                                    params: {
                                      type: "object"
                                    },
                                    message: "must be object"
                                  }];
                                  return false;
                                }
                                {
                                  {
                                    if (typeof data6 === "string") {
                                      if (!formats0(data6)) {
                                        validate194.errors = [{
                                          instancePath: instancePath + "/consents/" + key0.replace(/~/g, "~0").replace(/\//g, "~1") + "/date",
                                          schemaPath: "UserConsentEntryResponse/properties/date/format",
                                          keyword: "format",
                                          params: {
                                            format: "date-time"
                                          },
                                          message: 'must match format "date-time"'
                                        }];
                                        return false;
                                      }
                                    }
                                  }
                                }
                                var valid3 = _errs15 === errors;
                              } else {
                                var valid3 = true;
                              }
                            }
                          }
                        }
                      } else {
                        validate194.errors = [{
                          instancePath: instancePath + "/consents/" + key0.replace(/~/g, "~0").replace(/\//g, "~1"),
                          schemaPath: "UserConsentEntryResponse/type",
                          keyword: "type",
                          params: {
                            type: "object"
                          },
                          message: "must be object"
                        }];
                        return false;
                      }
                    }
                    var valid1 = _errs8 === errors;
                    if (!valid1) {
                      break;
                    }
                  }
                } else {
                  validate194.errors = [{
                    instancePath: instancePath + "/consents",
                    schemaPath: "#/properties/consents/type",
                    keyword: "type",
                    params: {
                      type: "object"
                    },
                    message: "must be object"
                  }];
                  return false;
                }
              }
              var valid0 = _errs5 === errors;
            } else {
              var valid0 = true;
            }
            if (valid0) {
              if (data.terms !== void 0) {
                let data7 = data.terms;
                const _errs17 = errors;
                {
                  if (data7 && typeof data7 == "object" && !Array.isArray(data7)) {
                    for (const key1 in data7) {
                      let data8 = data7[key1];
                      const _errs20 = errors;
                      {
                        if (data8 && typeof data8 == "object" && !Array.isArray(data8)) {
                          let missing2;
                          if (data8.consentedVersion === void 0 && (missing2 = "consentedVersion") || data8.date === void 0 && (missing2 = "date")) {
                            validate194.errors = [{
                              instancePath: instancePath + "/terms/" + key1.replace(/~/g, "~0").replace(/\//g, "~1"),
                              schemaPath: "UserConsentEntryTermsResponse/required",
                              keyword: "required",
                              params: {
                                missingProperty: missing2
                              },
                              message: "must have required property '" + missing2 + "'"
                            }];
                            return false;
                          } else {
                            if (data8.consentedVersion !== void 0) {
                              let data9 = data8.consentedVersion;
                              const _errs23 = errors;
                              if (!(typeof data9 == "number" && isFinite(data9))) {
                                validate194.errors = [{
                                  instancePath: instancePath + "/terms/" + key1.replace(/~/g, "~0").replace(/\//g, "~1") + "/consentedVersion",
                                  schemaPath: "UserConsentEntryTermsResponse/properties/consentedVersion/type",
                                  keyword: "type",
                                  params: {
                                    type: "number"
                                  },
                                  message: "must be number"
                                }];
                                return false;
                              }
                              var valid6 = _errs23 === errors;
                            } else {
                              var valid6 = true;
                            }
                            if (valid6) {
                              if (data8.date !== void 0) {
                                let data10 = data8.date;
                                const _errs25 = errors;
                                if (!(data10 && typeof data10 == "object" && !Array.isArray(data10))) {
                                  validate194.errors = [{
                                    instancePath: instancePath + "/terms/" + key1.replace(/~/g, "~0").replace(/\//g, "~1") + "/date",
                                    schemaPath: "UserConsentEntryTermsResponse/properties/date/type",
                                    keyword: "type",
                                    params: {
                                      type: "object"
                                    },
                                    message: "must be object"
                                  }];
                                  return false;
                                }
                                {
                                  {
                                    if (typeof data10 === "string") {
                                      if (!formats0(data10)) {
                                        validate194.errors = [{
                                          instancePath: instancePath + "/terms/" + key1.replace(/~/g, "~0").replace(/\//g, "~1") + "/date",
                                          schemaPath: "UserConsentEntryTermsResponse/properties/date/format",
                                          keyword: "format",
                                          params: {
                                            format: "date-time"
                                          },
                                          message: 'must match format "date-time"'
                                        }];
                                        return false;
                                      }
                                    }
                                  }
                                }
                                var valid6 = _errs25 === errors;
                              } else {
                                var valid6 = true;
                              }
                            }
                          }
                        } else {
                          validate194.errors = [{
                            instancePath: instancePath + "/terms/" + key1.replace(/~/g, "~0").replace(/\//g, "~1"),
                            schemaPath: "UserConsentEntryTermsResponse/type",
                            keyword: "type",
                            params: {
                              type: "object"
                            },
                            message: "must be object"
                          }];
                          return false;
                        }
                      }
                      var valid4 = _errs20 === errors;
                      if (!valid4) {
                        break;
                      }
                    }
                  } else {
                    validate194.errors = [{
                      instancePath: instancePath + "/terms",
                      schemaPath: "#/properties/terms/type",
                      keyword: "type",
                      params: {
                        type: "object"
                      },
                      message: "must be object"
                    }];
                    return false;
                  }
                }
                var valid0 = _errs17 === errors;
              } else {
                var valid0 = true;
              }
              if (valid0) {
                if (data.updateDate !== void 0) {
                  let data11 = data.updateDate;
                  const _errs27 = errors;
                  if (!(data11 && typeof data11 == "object" && !Array.isArray(data11))) {
                    validate194.errors = [{
                      instancePath: instancePath + "/updateDate",
                      schemaPath: "#/properties/updateDate/type",
                      keyword: "type",
                      params: {
                        type: "object"
                      },
                      message: "must be object"
                    }];
                    return false;
                  }
                  {
                    {
                      if (typeof data11 === "string") {
                        if (!formats0(data11)) {
                          validate194.errors = [{
                            instancePath: instancePath + "/updateDate",
                            schemaPath: "#/properties/updateDate/format",
                            keyword: "format",
                            params: {
                              format: "date-time"
                            },
                            message: 'must match format "date-time"'
                          }];
                          return false;
                        }
                      }
                    }
                  }
                  var valid0 = _errs27 === errors;
                } else {
                  var valid0 = true;
                }
              }
            }
          }
        }
      }
    } else {
      validate194.errors = [{
        instancePath,
        schemaPath: "#/type",
        keyword: "type",
        params: {
          type: "object"
        },
        message: "must be object"
      }];
      return false;
    }
  }
  validate194.errors = vErrors;
  return errors === 0;
}
const Sport80ExternalInfo = validate195;
function validate195(data, {
  instancePath = "",
  parentData,
  parentDataProperty,
  rootData = data
} = {}) {
  let vErrors = null;
  let errors = 0;
  {
    if (data && typeof data == "object" && !Array.isArray(data)) {
      let missing0;
      if (data.contactUuid === void 0 && (missing0 = "contactUuid") || data.lastCheck === void 0 && (missing0 = "lastCheck") || data.packageName === void 0 && (missing0 = "packageName") || data.email === void 0 && (missing0 = "email") || data.name === void 0 && (missing0 = "name")) {
        validate195.errors = [{
          instancePath,
          schemaPath: "#/required",
          keyword: "required",
          params: {
            missingProperty: missing0
          },
          message: "must have required property '" + missing0 + "'"
        }];
        return false;
      } else {
        if (data.contactUuid !== void 0) {
          const _errs1 = errors;
          if (typeof data.contactUuid !== "string") {
            validate195.errors = [{
              instancePath: instancePath + "/contactUuid",
              schemaPath: "#/properties/contactUuid/type",
              keyword: "type",
              params: {
                type: "string"
              },
              message: "must be string"
            }];
            return false;
          }
          var valid0 = _errs1 === errors;
        } else {
          var valid0 = true;
        }
        if (valid0) {
          if (data.lastCheck !== void 0) {
            let data1 = data.lastCheck;
            const _errs3 = errors;
            if (!(data1 && typeof data1 == "object" && !Array.isArray(data1))) {
              validate195.errors = [{
                instancePath: instancePath + "/lastCheck",
                schemaPath: "#/properties/lastCheck/type",
                keyword: "type",
                params: {
                  type: "object"
                },
                message: "must be object"
              }];
              return false;
            }
            {
              {
                if (typeof data1 === "string") {
                  if (!formats0(data1)) {
                    validate195.errors = [{
                      instancePath: instancePath + "/lastCheck",
                      schemaPath: "#/properties/lastCheck/format",
                      keyword: "format",
                      params: {
                        format: "date-time"
                      },
                      message: 'must match format "date-time"'
                    }];
                    return false;
                  }
                }
              }
            }
            var valid0 = _errs3 === errors;
          } else {
            var valid0 = true;
          }
          if (valid0) {
            if (data.packageName !== void 0) {
              const _errs5 = errors;
              if (typeof data.packageName !== "string") {
                validate195.errors = [{
                  instancePath: instancePath + "/packageName",
                  schemaPath: "#/properties/packageName/type",
                  keyword: "type",
                  params: {
                    type: "string"
                  },
                  message: "must be string"
                }];
                return false;
              }
              var valid0 = _errs5 === errors;
            } else {
              var valid0 = true;
            }
            if (valid0) {
              if (data.email !== void 0) {
                const _errs7 = errors;
                if (typeof data.email !== "string") {
                  validate195.errors = [{
                    instancePath: instancePath + "/email",
                    schemaPath: "#/properties/email/type",
                    keyword: "type",
                    params: {
                      type: "string"
                    },
                    message: "must be string"
                  }];
                  return false;
                }
                var valid0 = _errs7 === errors;
              } else {
                var valid0 = true;
              }
              if (valid0) {
                if (data.name !== void 0) {
                  const _errs9 = errors;
                  if (typeof data.name !== "string") {
                    validate195.errors = [{
                      instancePath: instancePath + "/name",
                      schemaPath: "#/properties/name/type",
                      keyword: "type",
                      params: {
                        type: "string"
                      },
                      message: "must be string"
                    }];
                    return false;
                  }
                  var valid0 = _errs9 === errors;
                } else {
                  var valid0 = true;
                }
              }
            }
          }
        }
      }
    } else {
      validate195.errors = [{
        instancePath,
        schemaPath: "#/type",
        keyword: "type",
        params: {
          type: "object"
        },
        message: "must be object"
      }];
      return false;
    }
  }
  validate195.errors = vErrors;
  return errors === 0;
}
const UserExternalIntegrationsData = validate196;
function validate196(data, {
  instancePath = "",
  parentData,
  parentDataProperty,
  rootData = data
} = {}) {
  let vErrors = null;
  let errors = 0;
  {
    if (data && typeof data == "object" && !Array.isArray(data)) {
      if (data.payment !== void 0) {
        let data0 = data.payment;
        {
          if (data0 && typeof data0 == "object" && !Array.isArray(data0)) {
            if (data0.stripe !== void 0) {
              let data1 = data0.stripe;
              const _errs3 = errors;
              {
                if (data1 && typeof data1 == "object" && !Array.isArray(data1)) {
                  for (const key0 in data1) {
                    let data2 = data1[key0];
                    const _errs6 = errors;
                    {
                      if (data2 && typeof data2 == "object" && !Array.isArray(data2)) {
                        let missing0;
                        if (data2.customerId === void 0 && (missing0 = "customerId")) {
                          validate196.errors = [{
                            instancePath: instancePath + "/payment/stripe/" + key0.replace(/~/g, "~0").replace(/\//g, "~1"),
                            schemaPath: "#/properties/payment/properties/stripe/additionalProperties/required",
                            keyword: "required",
                            params: {
                              missingProperty: missing0
                            },
                            message: "must have required property '" + missing0 + "'"
                          }];
                          return false;
                        } else {
                          if (data2.customerId !== void 0) {
                            const _errs8 = errors;
                            if (typeof data2.customerId !== "string") {
                              validate196.errors = [{
                                instancePath: instancePath + "/payment/stripe/" + key0.replace(/~/g, "~0").replace(/\//g, "~1") + "/customerId",
                                schemaPath: "#/properties/payment/properties/stripe/additionalProperties/properties/customerId/type",
                                keyword: "type",
                                params: {
                                  type: "string"
                                },
                                message: "must be string"
                              }];
                              return false;
                            }
                            var valid3 = _errs8 === errors;
                          } else {
                            var valid3 = true;
                          }
                          if (valid3) {
                            if (data2.savedPaymentMethods !== void 0) {
                              let data4 = data2.savedPaymentMethods;
                              const _errs10 = errors;
                              {
                                if (Array.isArray(data4)) {
                                  var valid4 = true;
                                  const len0 = data4.length;
                                  for (let i0 = 0; i0 < len0; i0++) {
                                    let data5 = data4[i0];
                                    const _errs12 = errors;
                                    {
                                      if (data5 && typeof data5 == "object" && !Array.isArray(data5)) {
                                        let missing1;
                                        if (data5.paymentMethodId === void 0 && (missing1 = "paymentMethodId") || data5.type === void 0 && (missing1 = "type") || data5.description === void 0 && (missing1 = "description")) {
                                          validate196.errors = [{
                                            instancePath: instancePath + "/payment/stripe/" + key0.replace(/~/g, "~0").replace(/\//g, "~1") + "/savedPaymentMethods/" + i0,
                                            schemaPath: "StripeSavedPaymentMethods/required",
                                            keyword: "required",
                                            params: {
                                              missingProperty: missing1
                                            },
                                            message: "must have required property '" + missing1 + "'"
                                          }];
                                          return false;
                                        } else {
                                          if (data5.paymentMethodId !== void 0) {
                                            const _errs15 = errors;
                                            if (typeof data5.paymentMethodId !== "string") {
                                              validate196.errors = [{
                                                instancePath: instancePath + "/payment/stripe/" + key0.replace(/~/g, "~0").replace(/\//g, "~1") + "/savedPaymentMethods/" + i0 + "/paymentMethodId",
                                                schemaPath: "StripeSavedPaymentMethods/properties/paymentMethodId/type",
                                                keyword: "type",
                                                params: {
                                                  type: "string"
                                                },
                                                message: "must be string"
                                              }];
                                              return false;
                                            }
                                            var valid6 = _errs15 === errors;
                                          } else {
                                            var valid6 = true;
                                          }
                                          if (valid6) {
                                            if (data5.type !== void 0) {
                                              const _errs17 = errors;
                                              if (typeof data5.type !== "string") {
                                                validate196.errors = [{
                                                  instancePath: instancePath + "/payment/stripe/" + key0.replace(/~/g, "~0").replace(/\//g, "~1") + "/savedPaymentMethods/" + i0 + "/type",
                                                  schemaPath: "StripeSavedPaymentMethods/properties/type/type",
                                                  keyword: "type",
                                                  params: {
                                                    type: "string"
                                                  },
                                                  message: "must be string"
                                                }];
                                                return false;
                                              }
                                              var valid6 = _errs17 === errors;
                                            } else {
                                              var valid6 = true;
                                            }
                                            if (valid6) {
                                              if (data5.description !== void 0) {
                                                const _errs19 = errors;
                                                if (typeof data5.description !== "string") {
                                                  validate196.errors = [{
                                                    instancePath: instancePath + "/payment/stripe/" + key0.replace(/~/g, "~0").replace(/\//g, "~1") + "/savedPaymentMethods/" + i0 + "/description",
                                                    schemaPath: "StripeSavedPaymentMethods/properties/description/type",
                                                    keyword: "type",
                                                    params: {
                                                      type: "string"
                                                    },
                                                    message: "must be string"
                                                  }];
                                                  return false;
                                                }
                                                var valid6 = _errs19 === errors;
                                              } else {
                                                var valid6 = true;
                                              }
                                            }
                                          }
                                        }
                                      } else {
                                        validate196.errors = [{
                                          instancePath: instancePath + "/payment/stripe/" + key0.replace(/~/g, "~0").replace(/\//g, "~1") + "/savedPaymentMethods/" + i0,
                                          schemaPath: "StripeSavedPaymentMethods/type",
                                          keyword: "type",
                                          params: {
                                            type: "object"
                                          },
                                          message: "must be object"
                                        }];
                                        return false;
                                      }
                                    }
                                    var valid4 = _errs12 === errors;
                                    if (!valid4) {
                                      break;
                                    }
                                  }
                                } else {
                                  validate196.errors = [{
                                    instancePath: instancePath + "/payment/stripe/" + key0.replace(/~/g, "~0").replace(/\//g, "~1") + "/savedPaymentMethods",
                                    schemaPath: "#/properties/payment/properties/stripe/additionalProperties/properties/savedPaymentMethods/type",
                                    keyword: "type",
                                    params: {
                                      type: "array"
                                    },
                                    message: "must be array"
                                  }];
                                  return false;
                                }
                              }
                              var valid3 = _errs10 === errors;
                            } else {
                              var valid3 = true;
                            }
                          }
                        }
                      } else {
                        validate196.errors = [{
                          instancePath: instancePath + "/payment/stripe/" + key0.replace(/~/g, "~0").replace(/\//g, "~1"),
                          schemaPath: "#/properties/payment/properties/stripe/additionalProperties/type",
                          keyword: "type",
                          params: {
                            type: "object"
                          },
                          message: "must be object"
                        }];
                        return false;
                      }
                    }
                    var valid2 = _errs6 === errors;
                    if (!valid2) {
                      break;
                    }
                  }
                } else {
                  validate196.errors = [{
                    instancePath: instancePath + "/payment/stripe",
                    schemaPath: "#/properties/payment/properties/stripe/type",
                    keyword: "type",
                    params: {
                      type: "object"
                    },
                    message: "must be object"
                  }];
                  return false;
                }
              }
              var valid1 = _errs3 === errors;
            } else {
              var valid1 = true;
            }
            if (valid1) {
              if (data0.sport80 !== void 0) {
                let data9 = data0.sport80;
                const _errs21 = errors;
                {
                  if (data9 && typeof data9 == "object" && !Array.isArray(data9)) {
                    for (const key1 in data9) {
                      let data10 = data9[key1];
                      const _errs24 = errors;
                      {
                        if (data10 && typeof data10 == "object" && !Array.isArray(data10)) {
                          let missing2;
                          if (data10.contactUuid === void 0 && (missing2 = "contactUuid") || data10.lastCheck === void 0 && (missing2 = "lastCheck") || data10.packageName === void 0 && (missing2 = "packageName") || data10.email === void 0 && (missing2 = "email") || data10.name === void 0 && (missing2 = "name")) {
                            validate196.errors = [{
                              instancePath: instancePath + "/payment/sport80/" + key1.replace(/~/g, "~0").replace(/\//g, "~1"),
                              schemaPath: "Sport80ExternalInfo/required",
                              keyword: "required",
                              params: {
                                missingProperty: missing2
                              },
                              message: "must have required property '" + missing2 + "'"
                            }];
                            return false;
                          } else {
                            if (data10.contactUuid !== void 0) {
                              const _errs27 = errors;
                              if (typeof data10.contactUuid !== "string") {
                                validate196.errors = [{
                                  instancePath: instancePath + "/payment/sport80/" + key1.replace(/~/g, "~0").replace(/\//g, "~1") + "/contactUuid",
                                  schemaPath: "Sport80ExternalInfo/properties/contactUuid/type",
                                  keyword: "type",
                                  params: {
                                    type: "string"
                                  },
                                  message: "must be string"
                                }];
                                return false;
                              }
                              var valid9 = _errs27 === errors;
                            } else {
                              var valid9 = true;
                            }
                            if (valid9) {
                              if (data10.lastCheck !== void 0) {
                                let data12 = data10.lastCheck;
                                const _errs29 = errors;
                                if (!(data12 && typeof data12 == "object" && !Array.isArray(data12))) {
                                  validate196.errors = [{
                                    instancePath: instancePath + "/payment/sport80/" + key1.replace(/~/g, "~0").replace(/\//g, "~1") + "/lastCheck",
                                    schemaPath: "Sport80ExternalInfo/properties/lastCheck/type",
                                    keyword: "type",
                                    params: {
                                      type: "object"
                                    },
                                    message: "must be object"
                                  }];
                                  return false;
                                }
                                {
                                  {
                                    if (typeof data12 === "string") {
                                      if (!formats0(data12)) {
                                        validate196.errors = [{
                                          instancePath: instancePath + "/payment/sport80/" + key1.replace(/~/g, "~0").replace(/\//g, "~1") + "/lastCheck",
                                          schemaPath: "Sport80ExternalInfo/properties/lastCheck/format",
                                          keyword: "format",
                                          params: {
                                            format: "date-time"
                                          },
                                          message: 'must match format "date-time"'
                                        }];
                                        return false;
                                      }
                                    }
                                  }
                                }
                                var valid9 = _errs29 === errors;
                              } else {
                                var valid9 = true;
                              }
                              if (valid9) {
                                if (data10.packageName !== void 0) {
                                  const _errs31 = errors;
                                  if (typeof data10.packageName !== "string") {
                                    validate196.errors = [{
                                      instancePath: instancePath + "/payment/sport80/" + key1.replace(/~/g, "~0").replace(/\//g, "~1") + "/packageName",
                                      schemaPath: "Sport80ExternalInfo/properties/packageName/type",
                                      keyword: "type",
                                      params: {
                                        type: "string"
                                      },
                                      message: "must be string"
                                    }];
                                    return false;
                                  }
                                  var valid9 = _errs31 === errors;
                                } else {
                                  var valid9 = true;
                                }
                                if (valid9) {
                                  if (data10.email !== void 0) {
                                    const _errs33 = errors;
                                    if (typeof data10.email !== "string") {
                                      validate196.errors = [{
                                        instancePath: instancePath + "/payment/sport80/" + key1.replace(/~/g, "~0").replace(/\//g, "~1") + "/email",
                                        schemaPath: "Sport80ExternalInfo/properties/email/type",
                                        keyword: "type",
                                        params: {
                                          type: "string"
                                        },
                                        message: "must be string"
                                      }];
                                      return false;
                                    }
                                    var valid9 = _errs33 === errors;
                                  } else {
                                    var valid9 = true;
                                  }
                                  if (valid9) {
                                    if (data10.name !== void 0) {
                                      const _errs35 = errors;
                                      if (typeof data10.name !== "string") {
                                        validate196.errors = [{
                                          instancePath: instancePath + "/payment/sport80/" + key1.replace(/~/g, "~0").replace(/\//g, "~1") + "/name",
                                          schemaPath: "Sport80ExternalInfo/properties/name/type",
                                          keyword: "type",
                                          params: {
                                            type: "string"
                                          },
                                          message: "must be string"
                                        }];
                                        return false;
                                      }
                                      var valid9 = _errs35 === errors;
                                    } else {
                                      var valid9 = true;
                                    }
                                  }
                                }
                              }
                            }
                          }
                        } else {
                          validate196.errors = [{
                            instancePath: instancePath + "/payment/sport80/" + key1.replace(/~/g, "~0").replace(/\//g, "~1"),
                            schemaPath: "Sport80ExternalInfo/type",
                            keyword: "type",
                            params: {
                              type: "object"
                            },
                            message: "must be object"
                          }];
                          return false;
                        }
                      }
                      var valid7 = _errs24 === errors;
                      if (!valid7) {
                        break;
                      }
                    }
                  } else {
                    validate196.errors = [{
                      instancePath: instancePath + "/payment/sport80",
                      schemaPath: "#/properties/payment/properties/sport80/type",
                      keyword: "type",
                      params: {
                        type: "object"
                      },
                      message: "must be object"
                    }];
                    return false;
                  }
                }
                var valid1 = _errs21 === errors;
              } else {
                var valid1 = true;
              }
            }
          } else {
            validate196.errors = [{
              instancePath: instancePath + "/payment",
              schemaPath: "#/properties/payment/type",
              keyword: "type",
              params: {
                type: "object"
              },
              message: "must be object"
            }];
            return false;
          }
        }
      }
    } else {
      validate196.errors = [{
        instancePath,
        schemaPath: "#/type",
        keyword: "type",
        params: {
          type: "object"
        },
        message: "must be object"
      }];
      return false;
    }
  }
  validate196.errors = vErrors;
  return errors === 0;
}
const ChannelSubscriptions = validate197;
const schema215 = {
  "$id": "ChannelSubscriptions",
  "$schema": "http://json-schema.org/draft-07/schema#",
  "type": "object",
  "additionalProperties": {
    "type": "object",
    "properties": {
      "channelId": {
        "type": "string"
      },
      "subscription": {
        "type": "string",
        "enum": ["ACTIVE", "PENDING", "TERMINATED"]
      },
      "tickets": {
        "type": "number"
      },
      "lastFeedbackProvided": {
        "type": "object",
        "format": "date-time"
      }
    },
    "required": ["channelId"]
  },
  "description": "Holds information about subscriptions to different channels"
};
function validate197(data, {
  instancePath = "",
  parentData,
  parentDataProperty,
  rootData = data
} = {}) {
  let vErrors = null;
  let errors = 0;
  {
    if (data && typeof data == "object" && !Array.isArray(data)) {
      for (const key0 in data) {
        let data0 = data[key0];
        const _errs2 = errors;
        {
          if (data0 && typeof data0 == "object" && !Array.isArray(data0)) {
            let missing0;
            if (data0.channelId === void 0 && (missing0 = "channelId")) {
              validate197.errors = [{
                instancePath: instancePath + "/" + key0.replace(/~/g, "~0").replace(/\//g, "~1"),
                schemaPath: "#/additionalProperties/required",
                keyword: "required",
                params: {
                  missingProperty: missing0
                },
                message: "must have required property '" + missing0 + "'"
              }];
              return false;
            } else {
              if (data0.channelId !== void 0) {
                const _errs4 = errors;
                if (typeof data0.channelId !== "string") {
                  validate197.errors = [{
                    instancePath: instancePath + "/" + key0.replace(/~/g, "~0").replace(/\//g, "~1") + "/channelId",
                    schemaPath: "#/additionalProperties/properties/channelId/type",
                    keyword: "type",
                    params: {
                      type: "string"
                    },
                    message: "must be string"
                  }];
                  return false;
                }
                var valid1 = _errs4 === errors;
              } else {
                var valid1 = true;
              }
              if (valid1) {
                if (data0.subscription !== void 0) {
                  let data2 = data0.subscription;
                  const _errs6 = errors;
                  if (typeof data2 !== "string") {
                    validate197.errors = [{
                      instancePath: instancePath + "/" + key0.replace(/~/g, "~0").replace(/\//g, "~1") + "/subscription",
                      schemaPath: "#/additionalProperties/properties/subscription/type",
                      keyword: "type",
                      params: {
                        type: "string"
                      },
                      message: "must be string"
                    }];
                    return false;
                  }
                  if (!(data2 === "ACTIVE" || data2 === "PENDING" || data2 === "TERMINATED")) {
                    validate197.errors = [{
                      instancePath: instancePath + "/" + key0.replace(/~/g, "~0").replace(/\//g, "~1") + "/subscription",
                      schemaPath: "#/additionalProperties/properties/subscription/enum",
                      keyword: "enum",
                      params: {
                        allowedValues: schema215.additionalProperties.properties.subscription.enum
                      },
                      message: "must be equal to one of the allowed values"
                    }];
                    return false;
                  }
                  var valid1 = _errs6 === errors;
                } else {
                  var valid1 = true;
                }
                if (valid1) {
                  if (data0.tickets !== void 0) {
                    let data3 = data0.tickets;
                    const _errs8 = errors;
                    if (!(typeof data3 == "number" && isFinite(data3))) {
                      validate197.errors = [{
                        instancePath: instancePath + "/" + key0.replace(/~/g, "~0").replace(/\//g, "~1") + "/tickets",
                        schemaPath: "#/additionalProperties/properties/tickets/type",
                        keyword: "type",
                        params: {
                          type: "number"
                        },
                        message: "must be number"
                      }];
                      return false;
                    }
                    var valid1 = _errs8 === errors;
                  } else {
                    var valid1 = true;
                  }
                  if (valid1) {
                    if (data0.lastFeedbackProvided !== void 0) {
                      let data4 = data0.lastFeedbackProvided;
                      const _errs10 = errors;
                      if (!(data4 && typeof data4 == "object" && !Array.isArray(data4))) {
                        validate197.errors = [{
                          instancePath: instancePath + "/" + key0.replace(/~/g, "~0").replace(/\//g, "~1") + "/lastFeedbackProvided",
                          schemaPath: "#/additionalProperties/properties/lastFeedbackProvided/type",
                          keyword: "type",
                          params: {
                            type: "object"
                          },
                          message: "must be object"
                        }];
                        return false;
                      }
                      {
                        {
                          if (typeof data4 === "string") {
                            if (!formats0(data4)) {
                              validate197.errors = [{
                                instancePath: instancePath + "/" + key0.replace(/~/g, "~0").replace(/\//g, "~1") + "/lastFeedbackProvided",
                                schemaPath: "#/additionalProperties/properties/lastFeedbackProvided/format",
                                keyword: "format",
                                params: {
                                  format: "date-time"
                                },
                                message: 'must match format "date-time"'
                              }];
                              return false;
                            }
                          }
                        }
                      }
                      var valid1 = _errs10 === errors;
                    } else {
                      var valid1 = true;
                    }
                  }
                }
              }
            }
          } else {
            validate197.errors = [{
              instancePath: instancePath + "/" + key0.replace(/~/g, "~0").replace(/\//g, "~1"),
              schemaPath: "#/additionalProperties/type",
              keyword: "type",
              params: {
                type: "object"
              },
              message: "must be object"
            }];
            return false;
          }
        }
        var valid0 = _errs2 === errors;
        if (!valid0) {
          break;
        }
      }
    } else {
      validate197.errors = [{
        instancePath,
        schemaPath: "#/type",
        keyword: "type",
        params: {
          type: "object"
        },
        message: "must be object"
      }];
      return false;
    }
  }
  validate197.errors = vErrors;
  return errors === 0;
}
const UserInfo = validate198;
const schema216 = {
  "$id": "UserInfo",
  "$schema": "http://json-schema.org/draft-07/schema#",
  "type": "object",
  "properties": {
    "email": {
      "type": "string"
    },
    "photoURL": {
      "type": ["string", "null"]
    },
    "displayName": {
      "type": ["string", "null"]
    },
    "stripeCustomerId": {
      "type": "string"
    },
    "externalIntegrationsData": {
      "$ref": "UserExternalIntegrationsData"
    },
    "subscriptions": {
      "$ref": "ChannelSubscriptions"
    },
    "fingerprint": {
      "type": ["string", "number"]
    },
    "onboardingStatus": {
      "$ref": "UserGuidedOnboardingStatus"
    }
  },
  "required": ["email"]
};
function validate198(data, {
  instancePath = "",
  parentData,
  parentDataProperty,
  rootData = data
} = {}) {
  let vErrors = null;
  let errors = 0;
  if (errors === 0) {
    if (data && typeof data == "object" && !Array.isArray(data)) {
      let missing0;
      if (data.email === void 0 && (missing0 = "email")) {
        validate198.errors = [{
          instancePath,
          schemaPath: "#/required",
          keyword: "required",
          params: {
            missingProperty: missing0
          },
          message: "must have required property '" + missing0 + "'"
        }];
        return false;
      } else {
        if (data.email !== void 0) {
          const _errs1 = errors;
          if (typeof data.email !== "string") {
            validate198.errors = [{
              instancePath: instancePath + "/email",
              schemaPath: "#/properties/email/type",
              keyword: "type",
              params: {
                type: "string"
              },
              message: "must be string"
            }];
            return false;
          }
          var valid0 = _errs1 === errors;
        } else {
          var valid0 = true;
        }
        if (valid0) {
          if (data.photoURL !== void 0) {
            let data1 = data.photoURL;
            const _errs3 = errors;
            if (typeof data1 !== "string" && data1 !== null) {
              validate198.errors = [{
                instancePath: instancePath + "/photoURL",
                schemaPath: "#/properties/photoURL/type",
                keyword: "type",
                params: {
                  type: schema216.properties.photoURL.type
                },
                message: "must be string,null"
              }];
              return false;
            }
            var valid0 = _errs3 === errors;
          } else {
            var valid0 = true;
          }
          if (valid0) {
            if (data.displayName !== void 0) {
              let data2 = data.displayName;
              const _errs5 = errors;
              if (typeof data2 !== "string" && data2 !== null) {
                validate198.errors = [{
                  instancePath: instancePath + "/displayName",
                  schemaPath: "#/properties/displayName/type",
                  keyword: "type",
                  params: {
                    type: schema216.properties.displayName.type
                  },
                  message: "must be string,null"
                }];
                return false;
              }
              var valid0 = _errs5 === errors;
            } else {
              var valid0 = true;
            }
            if (valid0) {
              if (data.stripeCustomerId !== void 0) {
                const _errs7 = errors;
                if (typeof data.stripeCustomerId !== "string") {
                  validate198.errors = [{
                    instancePath: instancePath + "/stripeCustomerId",
                    schemaPath: "#/properties/stripeCustomerId/type",
                    keyword: "type",
                    params: {
                      type: "string"
                    },
                    message: "must be string"
                  }];
                  return false;
                }
                var valid0 = _errs7 === errors;
              } else {
                var valid0 = true;
              }
              if (valid0) {
                if (data.externalIntegrationsData !== void 0) {
                  const _errs9 = errors;
                  if (!validate196(data.externalIntegrationsData, {
                    instancePath: instancePath + "/externalIntegrationsData",
                    parentData: data,
                    parentDataProperty: "externalIntegrationsData",
                    rootData
                  })) {
                    vErrors = vErrors === null ? validate196.errors : vErrors.concat(validate196.errors);
                    errors = vErrors.length;
                  }
                  var valid0 = _errs9 === errors;
                } else {
                  var valid0 = true;
                }
                if (valid0) {
                  if (data.subscriptions !== void 0) {
                    let data5 = data.subscriptions;
                    const _errs10 = errors;
                    const _errs11 = errors;
                    if (errors === _errs11) {
                      if (data5 && typeof data5 == "object" && !Array.isArray(data5)) {
                        for (const key0 in data5) {
                          let data6 = data5[key0];
                          const _errs14 = errors;
                          if (errors === _errs14) {
                            if (data6 && typeof data6 == "object" && !Array.isArray(data6)) {
                              let missing1;
                              if (data6.channelId === void 0 && (missing1 = "channelId")) {
                                validate198.errors = [{
                                  instancePath: instancePath + "/subscriptions/" + key0.replace(/~/g, "~0").replace(/\//g, "~1"),
                                  schemaPath: "ChannelSubscriptions/additionalProperties/required",
                                  keyword: "required",
                                  params: {
                                    missingProperty: missing1
                                  },
                                  message: "must have required property '" + missing1 + "'"
                                }];
                                return false;
                              } else {
                                if (data6.channelId !== void 0) {
                                  const _errs16 = errors;
                                  if (typeof data6.channelId !== "string") {
                                    validate198.errors = [{
                                      instancePath: instancePath + "/subscriptions/" + key0.replace(/~/g, "~0").replace(/\//g, "~1") + "/channelId",
                                      schemaPath: "ChannelSubscriptions/additionalProperties/properties/channelId/type",
                                      keyword: "type",
                                      params: {
                                        type: "string"
                                      },
                                      message: "must be string"
                                    }];
                                    return false;
                                  }
                                  var valid3 = _errs16 === errors;
                                } else {
                                  var valid3 = true;
                                }
                                if (valid3) {
                                  if (data6.subscription !== void 0) {
                                    let data8 = data6.subscription;
                                    const _errs18 = errors;
                                    if (typeof data8 !== "string") {
                                      validate198.errors = [{
                                        instancePath: instancePath + "/subscriptions/" + key0.replace(/~/g, "~0").replace(/\//g, "~1") + "/subscription",
                                        schemaPath: "ChannelSubscriptions/additionalProperties/properties/subscription/type",
                                        keyword: "type",
                                        params: {
                                          type: "string"
                                        },
                                        message: "must be string"
                                      }];
                                      return false;
                                    }
                                    if (!(data8 === "ACTIVE" || data8 === "PENDING" || data8 === "TERMINATED")) {
                                      validate198.errors = [{
                                        instancePath: instancePath + "/subscriptions/" + key0.replace(/~/g, "~0").replace(/\//g, "~1") + "/subscription",
                                        schemaPath: "ChannelSubscriptions/additionalProperties/properties/subscription/enum",
                                        keyword: "enum",
                                        params: {
                                          allowedValues: schema215.additionalProperties.properties.subscription.enum
                                        },
                                        message: "must be equal to one of the allowed values"
                                      }];
                                      return false;
                                    }
                                    var valid3 = _errs18 === errors;
                                  } else {
                                    var valid3 = true;
                                  }
                                  if (valid3) {
                                    if (data6.tickets !== void 0) {
                                      let data9 = data6.tickets;
                                      const _errs20 = errors;
                                      if (!(typeof data9 == "number" && isFinite(data9))) {
                                        validate198.errors = [{
                                          instancePath: instancePath + "/subscriptions/" + key0.replace(/~/g, "~0").replace(/\//g, "~1") + "/tickets",
                                          schemaPath: "ChannelSubscriptions/additionalProperties/properties/tickets/type",
                                          keyword: "type",
                                          params: {
                                            type: "number"
                                          },
                                          message: "must be number"
                                        }];
                                        return false;
                                      }
                                      var valid3 = _errs20 === errors;
                                    } else {
                                      var valid3 = true;
                                    }
                                    if (valid3) {
                                      if (data6.lastFeedbackProvided !== void 0) {
                                        let data10 = data6.lastFeedbackProvided;
                                        const _errs22 = errors;
                                        if (!(data10 && typeof data10 == "object" && !Array.isArray(data10))) {
                                          validate198.errors = [{
                                            instancePath: instancePath + "/subscriptions/" + key0.replace(/~/g, "~0").replace(/\//g, "~1") + "/lastFeedbackProvided",
                                            schemaPath: "ChannelSubscriptions/additionalProperties/properties/lastFeedbackProvided/type",
                                            keyword: "type",
                                            params: {
                                              type: "object"
                                            },
                                            message: "must be object"
                                          }];
                                          return false;
                                        }
                                        if (errors === _errs22) {
                                          if (errors === _errs22) {
                                            if (typeof data10 === "string") {
                                              if (!formats0(data10)) {
                                                validate198.errors = [{
                                                  instancePath: instancePath + "/subscriptions/" + key0.replace(/~/g, "~0").replace(/\//g, "~1") + "/lastFeedbackProvided",
                                                  schemaPath: "ChannelSubscriptions/additionalProperties/properties/lastFeedbackProvided/format",
                                                  keyword: "format",
                                                  params: {
                                                    format: "date-time"
                                                  },
                                                  message: 'must match format "date-time"'
                                                }];
                                                return false;
                                              }
                                            }
                                          }
                                        }
                                        var valid3 = _errs22 === errors;
                                      } else {
                                        var valid3 = true;
                                      }
                                    }
                                  }
                                }
                              }
                            } else {
                              validate198.errors = [{
                                instancePath: instancePath + "/subscriptions/" + key0.replace(/~/g, "~0").replace(/\//g, "~1"),
                                schemaPath: "ChannelSubscriptions/additionalProperties/type",
                                keyword: "type",
                                params: {
                                  type: "object"
                                },
                                message: "must be object"
                              }];
                              return false;
                            }
                          }
                          var valid2 = _errs14 === errors;
                          if (!valid2) {
                            break;
                          }
                        }
                      } else {
                        validate198.errors = [{
                          instancePath: instancePath + "/subscriptions",
                          schemaPath: "ChannelSubscriptions/type",
                          keyword: "type",
                          params: {
                            type: "object"
                          },
                          message: "must be object"
                        }];
                        return false;
                      }
                    }
                    var valid0 = _errs10 === errors;
                  } else {
                    var valid0 = true;
                  }
                  if (valid0) {
                    if (data.fingerprint !== void 0) {
                      let data11 = data.fingerprint;
                      const _errs24 = errors;
                      if (typeof data11 !== "string" && !(typeof data11 == "number" && isFinite(data11))) {
                        validate198.errors = [{
                          instancePath: instancePath + "/fingerprint",
                          schemaPath: "#/properties/fingerprint/type",
                          keyword: "type",
                          params: {
                            type: schema216.properties.fingerprint.type
                          },
                          message: "must be string,number"
                        }];
                        return false;
                      }
                      var valid0 = _errs24 === errors;
                    } else {
                      var valid0 = true;
                    }
                    if (valid0) {
                      if (data.onboardingStatus !== void 0) {
                        let data12 = data.onboardingStatus;
                        const _errs26 = errors;
                        const _errs27 = errors;
                        if (errors === _errs27) {
                          if (data12 && typeof data12 == "object" && !Array.isArray(data12)) {
                            if (data12.skipTutorial !== void 0) {
                              const _errs29 = errors;
                              if (typeof data12.skipTutorial !== "boolean") {
                                validate198.errors = [{
                                  instancePath: instancePath + "/onboardingStatus/skipTutorial",
                                  schemaPath: "UserGuidedOnboardingStatus/properties/skipTutorial/type",
                                  keyword: "type",
                                  params: {
                                    type: "boolean"
                                  },
                                  message: "must be boolean"
                                }];
                                return false;
                              }
                              var valid5 = _errs29 === errors;
                            } else {
                              var valid5 = true;
                            }
                            if (valid5) {
                              if (data12.completed !== void 0) {
                                let data14 = data12.completed;
                                const _errs31 = errors;
                                if (errors === _errs31) {
                                  if (Array.isArray(data14)) {
                                    var valid6 = true;
                                    const len0 = data14.length;
                                    for (let i0 = 0; i0 < len0; i0++) {
                                      const _errs33 = errors;
                                      if (typeof data14[i0] !== "string") {
                                        validate198.errors = [{
                                          instancePath: instancePath + "/onboardingStatus/completed/" + i0,
                                          schemaPath: "UserGuidedOnboardingStatus/properties/completed/items/type",
                                          keyword: "type",
                                          params: {
                                            type: "string"
                                          },
                                          message: "must be string"
                                        }];
                                        return false;
                                      }
                                      var valid6 = _errs33 === errors;
                                      if (!valid6) {
                                        break;
                                      }
                                    }
                                  } else {
                                    validate198.errors = [{
                                      instancePath: instancePath + "/onboardingStatus/completed",
                                      schemaPath: "UserGuidedOnboardingStatus/properties/completed/type",
                                      keyword: "type",
                                      params: {
                                        type: "array"
                                      },
                                      message: "must be array"
                                    }];
                                    return false;
                                  }
                                }
                                var valid5 = _errs31 === errors;
                              } else {
                                var valid5 = true;
                              }
                            }
                          } else {
                            validate198.errors = [{
                              instancePath: instancePath + "/onboardingStatus",
                              schemaPath: "UserGuidedOnboardingStatus/type",
                              keyword: "type",
                              params: {
                                type: "object"
                              },
                              message: "must be object"
                            }];
                            return false;
                          }
                        }
                        var valid0 = _errs26 === errors;
                      } else {
                        var valid0 = true;
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
    } else {
      validate198.errors = [{
        instancePath,
        schemaPath: "#/type",
        keyword: "type",
        params: {
          type: "object"
        },
        message: "must be object"
      }];
      return false;
    }
  }
  validate198.errors = vErrors;
  return errors === 0;
}
const UserGuidedOnboardingStatus = validate200;
function validate200(data, {
  instancePath = "",
  parentData,
  parentDataProperty,
  rootData = data
} = {}) {
  let vErrors = null;
  let errors = 0;
  {
    if (data && typeof data == "object" && !Array.isArray(data)) {
      if (data.skipTutorial !== void 0) {
        const _errs1 = errors;
        if (typeof data.skipTutorial !== "boolean") {
          validate200.errors = [{
            instancePath: instancePath + "/skipTutorial",
            schemaPath: "#/properties/skipTutorial/type",
            keyword: "type",
            params: {
              type: "boolean"
            },
            message: "must be boolean"
          }];
          return false;
        }
        var valid0 = _errs1 === errors;
      } else {
        var valid0 = true;
      }
      if (valid0) {
        if (data.completed !== void 0) {
          let data1 = data.completed;
          const _errs3 = errors;
          {
            if (Array.isArray(data1)) {
              var valid1 = true;
              const len0 = data1.length;
              for (let i0 = 0; i0 < len0; i0++) {
                const _errs5 = errors;
                if (typeof data1[i0] !== "string") {
                  validate200.errors = [{
                    instancePath: instancePath + "/completed/" + i0,
                    schemaPath: "#/properties/completed/items/type",
                    keyword: "type",
                    params: {
                      type: "string"
                    },
                    message: "must be string"
                  }];
                  return false;
                }
                var valid1 = _errs5 === errors;
                if (!valid1) {
                  break;
                }
              }
            } else {
              validate200.errors = [{
                instancePath: instancePath + "/completed",
                schemaPath: "#/properties/completed/type",
                keyword: "type",
                params: {
                  type: "array"
                },
                message: "must be array"
              }];
              return false;
            }
          }
          var valid0 = _errs3 === errors;
        } else {
          var valid0 = true;
        }
      }
    } else {
      validate200.errors = [{
        instancePath,
        schemaPath: "#/type",
        keyword: "type",
        params: {
          type: "object"
        },
        message: "must be object"
      }];
      return false;
    }
  }
  validate200.errors = vErrors;
  return errors === 0;
}
const Video = validate201;
const schema220 = {
  "$id": "Video",
  "$schema": "http://json-schema.org/draft-07/schema#",
  "type": "object",
  "properties": {
    "attr0": {
      "type": "string"
    },
    "attr1": {
      "type": "string"
    },
    "attr2": {
      "type": "string"
    },
    "attr3": {
      "type": "string"
    },
    "name": {
      "type": "string"
    },
    "description": {
      "type": "string"
    },
    "eventId": {
      "type": ["string", "null"]
    },
    "unlocked": {
      "type": "boolean"
    },
    "archived": {
      "type": "boolean"
    },
    "type": {
      "type": "string",
      "enum": ["SHORT", "UPLOAD", "STREAM"]
    },
    "streamState": {
      "type": ["string", "null"],
      "enum": ["SCHEDULED", "LIVE", "FINISHED", null]
    },
    "tags": {
      "type": "array",
      "items": {
        "type": "string"
      }
    },
    "startTime": {
      "anyOf": [{
        "type": "object",
        "format": "date-time"
      }, {
        "type": "null"
      }]
    },
    "endTime": {
      "anyOf": [{
        "type": "object",
        "format": "date-time"
      }, {
        "type": "null"
      }]
    },
    "uploadTime": {
      "type": "object",
      "format": "date-time"
    },
    "duration": {
      "type": ["number", "null"]
    },
    "posterImage": {
      "type": "string"
    },
    "videoLocation": {
      "type": "string"
    },
    "views": {
      "type": "number"
    },
    "popularity": {
      "type": "number"
    },
    "organizationId": {
      "type": ["string", "null"]
    },
    "channelId": {
      "type": "string"
    },
    "published": {
      "type": "boolean"
    },
    "restrictedTo": {
      "type": "array",
      "items": {
        "type": "string"
      }
    },
    "externalIds": {
      "type": "array",
      "items": {
        "type": "string"
      }
    }
  },
  "required": ["name", "description", "eventId", "unlocked", "archived", "type", "streamState", "tags", "startTime", "endTime", "uploadTime", "duration", "posterImage", "videoLocation", "views", "popularity", "organizationId", "channelId", "published"],
  "description": "A video models a media file along with metadata that a user consumes in the platform. Videos can be uploaded as short form content,or as long form events. They can also be livestreamed and then transformed to a VOD.\n*Popularity score*: The proposed implementation for the popularity score (that is simple and straightforward to implement) is an algorithm using an [exponential moving average](https://en.wikipedia.org/wiki/Moving_average#Exponential_moving_average) with time as a variable: > Let `p` be the current popularity score of a video. if an event (video view or similar) happens at time `t` then the current popularity score can be calculated as: `p = (a*p) + (1-a)*t` Where `a=2/(N+1)` and `N` the number of past events that will affect the new score. The popularity for new videos can be set to the creation timestamp of the video (which means new content will be boosted), or set to a reasonable point in the past (which means the video would need to bubble up). >"
};
function validate201(data, {
  instancePath = "",
  parentData,
  parentDataProperty,
  rootData = data
} = {}) {
  let vErrors = null;
  let errors = 0;
  if (errors === 0) {
    if (data && typeof data == "object" && !Array.isArray(data)) {
      let missing0;
      if (data.name === void 0 && (missing0 = "name") || data.description === void 0 && (missing0 = "description") || data.eventId === void 0 && (missing0 = "eventId") || data.unlocked === void 0 && (missing0 = "unlocked") || data.archived === void 0 && (missing0 = "archived") || data.type === void 0 && (missing0 = "type") || data.streamState === void 0 && (missing0 = "streamState") || data.tags === void 0 && (missing0 = "tags") || data.startTime === void 0 && (missing0 = "startTime") || data.endTime === void 0 && (missing0 = "endTime") || data.uploadTime === void 0 && (missing0 = "uploadTime") || data.duration === void 0 && (missing0 = "duration") || data.posterImage === void 0 && (missing0 = "posterImage") || data.videoLocation === void 0 && (missing0 = "videoLocation") || data.views === void 0 && (missing0 = "views") || data.popularity === void 0 && (missing0 = "popularity") || data.organizationId === void 0 && (missing0 = "organizationId") || data.channelId === void 0 && (missing0 = "channelId") || data.published === void 0 && (missing0 = "published")) {
        validate201.errors = [{
          instancePath,
          schemaPath: "#/required",
          keyword: "required",
          params: {
            missingProperty: missing0
          },
          message: "must have required property '" + missing0 + "'"
        }];
        return false;
      } else {
        if (data.attr0 !== void 0) {
          const _errs1 = errors;
          if (typeof data.attr0 !== "string") {
            validate201.errors = [{
              instancePath: instancePath + "/attr0",
              schemaPath: "#/properties/attr0/type",
              keyword: "type",
              params: {
                type: "string"
              },
              message: "must be string"
            }];
            return false;
          }
          var valid0 = _errs1 === errors;
        } else {
          var valid0 = true;
        }
        if (valid0) {
          if (data.attr1 !== void 0) {
            const _errs3 = errors;
            if (typeof data.attr1 !== "string") {
              validate201.errors = [{
                instancePath: instancePath + "/attr1",
                schemaPath: "#/properties/attr1/type",
                keyword: "type",
                params: {
                  type: "string"
                },
                message: "must be string"
              }];
              return false;
            }
            var valid0 = _errs3 === errors;
          } else {
            var valid0 = true;
          }
          if (valid0) {
            if (data.attr2 !== void 0) {
              const _errs5 = errors;
              if (typeof data.attr2 !== "string") {
                validate201.errors = [{
                  instancePath: instancePath + "/attr2",
                  schemaPath: "#/properties/attr2/type",
                  keyword: "type",
                  params: {
                    type: "string"
                  },
                  message: "must be string"
                }];
                return false;
              }
              var valid0 = _errs5 === errors;
            } else {
              var valid0 = true;
            }
            if (valid0) {
              if (data.attr3 !== void 0) {
                const _errs7 = errors;
                if (typeof data.attr3 !== "string") {
                  validate201.errors = [{
                    instancePath: instancePath + "/attr3",
                    schemaPath: "#/properties/attr3/type",
                    keyword: "type",
                    params: {
                      type: "string"
                    },
                    message: "must be string"
                  }];
                  return false;
                }
                var valid0 = _errs7 === errors;
              } else {
                var valid0 = true;
              }
              if (valid0) {
                if (data.name !== void 0) {
                  const _errs9 = errors;
                  if (typeof data.name !== "string") {
                    validate201.errors = [{
                      instancePath: instancePath + "/name",
                      schemaPath: "#/properties/name/type",
                      keyword: "type",
                      params: {
                        type: "string"
                      },
                      message: "must be string"
                    }];
                    return false;
                  }
                  var valid0 = _errs9 === errors;
                } else {
                  var valid0 = true;
                }
                if (valid0) {
                  if (data.description !== void 0) {
                    const _errs11 = errors;
                    if (typeof data.description !== "string") {
                      validate201.errors = [{
                        instancePath: instancePath + "/description",
                        schemaPath: "#/properties/description/type",
                        keyword: "type",
                        params: {
                          type: "string"
                        },
                        message: "must be string"
                      }];
                      return false;
                    }
                    var valid0 = _errs11 === errors;
                  } else {
                    var valid0 = true;
                  }
                  if (valid0) {
                    if (data.eventId !== void 0) {
                      let data6 = data.eventId;
                      const _errs13 = errors;
                      if (typeof data6 !== "string" && data6 !== null) {
                        validate201.errors = [{
                          instancePath: instancePath + "/eventId",
                          schemaPath: "#/properties/eventId/type",
                          keyword: "type",
                          params: {
                            type: schema220.properties.eventId.type
                          },
                          message: "must be string,null"
                        }];
                        return false;
                      }
                      var valid0 = _errs13 === errors;
                    } else {
                      var valid0 = true;
                    }
                    if (valid0) {
                      if (data.unlocked !== void 0) {
                        const _errs15 = errors;
                        if (typeof data.unlocked !== "boolean") {
                          validate201.errors = [{
                            instancePath: instancePath + "/unlocked",
                            schemaPath: "#/properties/unlocked/type",
                            keyword: "type",
                            params: {
                              type: "boolean"
                            },
                            message: "must be boolean"
                          }];
                          return false;
                        }
                        var valid0 = _errs15 === errors;
                      } else {
                        var valid0 = true;
                      }
                      if (valid0) {
                        if (data.archived !== void 0) {
                          const _errs17 = errors;
                          if (typeof data.archived !== "boolean") {
                            validate201.errors = [{
                              instancePath: instancePath + "/archived",
                              schemaPath: "#/properties/archived/type",
                              keyword: "type",
                              params: {
                                type: "boolean"
                              },
                              message: "must be boolean"
                            }];
                            return false;
                          }
                          var valid0 = _errs17 === errors;
                        } else {
                          var valid0 = true;
                        }
                        if (valid0) {
                          if (data.type !== void 0) {
                            let data9 = data.type;
                            const _errs19 = errors;
                            if (typeof data9 !== "string") {
                              validate201.errors = [{
                                instancePath: instancePath + "/type",
                                schemaPath: "#/properties/type/type",
                                keyword: "type",
                                params: {
                                  type: "string"
                                },
                                message: "must be string"
                              }];
                              return false;
                            }
                            if (!(data9 === "SHORT" || data9 === "UPLOAD" || data9 === "STREAM")) {
                              validate201.errors = [{
                                instancePath: instancePath + "/type",
                                schemaPath: "#/properties/type/enum",
                                keyword: "enum",
                                params: {
                                  allowedValues: schema220.properties.type.enum
                                },
                                message: "must be equal to one of the allowed values"
                              }];
                              return false;
                            }
                            var valid0 = _errs19 === errors;
                          } else {
                            var valid0 = true;
                          }
                          if (valid0) {
                            if (data.streamState !== void 0) {
                              let data10 = data.streamState;
                              const _errs21 = errors;
                              if (typeof data10 !== "string" && data10 !== null) {
                                validate201.errors = [{
                                  instancePath: instancePath + "/streamState",
                                  schemaPath: "#/properties/streamState/type",
                                  keyword: "type",
                                  params: {
                                    type: schema220.properties.streamState.type
                                  },
                                  message: "must be string,null"
                                }];
                                return false;
                              }
                              if (!(data10 === "SCHEDULED" || data10 === "LIVE" || data10 === "FINISHED" || data10 === null)) {
                                validate201.errors = [{
                                  instancePath: instancePath + "/streamState",
                                  schemaPath: "#/properties/streamState/enum",
                                  keyword: "enum",
                                  params: {
                                    allowedValues: schema220.properties.streamState.enum
                                  },
                                  message: "must be equal to one of the allowed values"
                                }];
                                return false;
                              }
                              var valid0 = _errs21 === errors;
                            } else {
                              var valid0 = true;
                            }
                            if (valid0) {
                              if (data.tags !== void 0) {
                                let data11 = data.tags;
                                const _errs23 = errors;
                                if (errors === _errs23) {
                                  if (Array.isArray(data11)) {
                                    var valid1 = true;
                                    const len0 = data11.length;
                                    for (let i0 = 0; i0 < len0; i0++) {
                                      const _errs25 = errors;
                                      if (typeof data11[i0] !== "string") {
                                        validate201.errors = [{
                                          instancePath: instancePath + "/tags/" + i0,
                                          schemaPath: "#/properties/tags/items/type",
                                          keyword: "type",
                                          params: {
                                            type: "string"
                                          },
                                          message: "must be string"
                                        }];
                                        return false;
                                      }
                                      var valid1 = _errs25 === errors;
                                      if (!valid1) {
                                        break;
                                      }
                                    }
                                  } else {
                                    validate201.errors = [{
                                      instancePath: instancePath + "/tags",
                                      schemaPath: "#/properties/tags/type",
                                      keyword: "type",
                                      params: {
                                        type: "array"
                                      },
                                      message: "must be array"
                                    }];
                                    return false;
                                  }
                                }
                                var valid0 = _errs23 === errors;
                              } else {
                                var valid0 = true;
                              }
                              if (valid0) {
                                if (data.startTime !== void 0) {
                                  let data13 = data.startTime;
                                  const _errs27 = errors;
                                  const _errs28 = errors;
                                  let valid2 = false;
                                  const _errs29 = errors;
                                  if (!(data13 && typeof data13 == "object" && !Array.isArray(data13))) {
                                    const err0 = {
                                      instancePath: instancePath + "/startTime",
                                      schemaPath: "#/properties/startTime/anyOf/0/type",
                                      keyword: "type",
                                      params: {
                                        type: "object"
                                      },
                                      message: "must be object"
                                    };
                                    if (vErrors === null) {
                                      vErrors = [err0];
                                    } else {
                                      vErrors.push(err0);
                                    }
                                    errors++;
                                  }
                                  if (errors === _errs29) {
                                    if (errors === _errs29) {
                                      if (typeof data13 === "string") {
                                        if (!formats0(data13)) {
                                          const err1 = {
                                            instancePath: instancePath + "/startTime",
                                            schemaPath: "#/properties/startTime/anyOf/0/format",
                                            keyword: "format",
                                            params: {
                                              format: "date-time"
                                            },
                                            message: 'must match format "date-time"'
                                          };
                                          if (vErrors === null) {
                                            vErrors = [err1];
                                          } else {
                                            vErrors.push(err1);
                                          }
                                          errors++;
                                        }
                                      }
                                    }
                                  }
                                  var _valid0 = _errs29 === errors;
                                  valid2 = valid2 || _valid0;
                                  if (!valid2) {
                                    const _errs31 = errors;
                                    if (data13 !== null) {
                                      const err2 = {
                                        instancePath: instancePath + "/startTime",
                                        schemaPath: "#/properties/startTime/anyOf/1/type",
                                        keyword: "type",
                                        params: {
                                          type: "null"
                                        },
                                        message: "must be null"
                                      };
                                      if (vErrors === null) {
                                        vErrors = [err2];
                                      } else {
                                        vErrors.push(err2);
                                      }
                                      errors++;
                                    }
                                    var _valid0 = _errs31 === errors;
                                    valid2 = valid2 || _valid0;
                                  }
                                  if (!valid2) {
                                    const err3 = {
                                      instancePath: instancePath + "/startTime",
                                      schemaPath: "#/properties/startTime/anyOf",
                                      keyword: "anyOf",
                                      params: {},
                                      message: "must match a schema in anyOf"
                                    };
                                    if (vErrors === null) {
                                      vErrors = [err3];
                                    } else {
                                      vErrors.push(err3);
                                    }
                                    errors++;
                                    validate201.errors = vErrors;
                                    return false;
                                  } else {
                                    errors = _errs28;
                                    if (vErrors !== null) {
                                      if (_errs28) {
                                        vErrors.length = _errs28;
                                      } else {
                                        vErrors = null;
                                      }
                                    }
                                  }
                                  var valid0 = _errs27 === errors;
                                } else {
                                  var valid0 = true;
                                }
                                if (valid0) {
                                  if (data.endTime !== void 0) {
                                    let data14 = data.endTime;
                                    const _errs33 = errors;
                                    const _errs34 = errors;
                                    let valid3 = false;
                                    const _errs35 = errors;
                                    if (!(data14 && typeof data14 == "object" && !Array.isArray(data14))) {
                                      const err4 = {
                                        instancePath: instancePath + "/endTime",
                                        schemaPath: "#/properties/endTime/anyOf/0/type",
                                        keyword: "type",
                                        params: {
                                          type: "object"
                                        },
                                        message: "must be object"
                                      };
                                      if (vErrors === null) {
                                        vErrors = [err4];
                                      } else {
                                        vErrors.push(err4);
                                      }
                                      errors++;
                                    }
                                    if (errors === _errs35) {
                                      if (errors === _errs35) {
                                        if (typeof data14 === "string") {
                                          if (!formats0(data14)) {
                                            const err5 = {
                                              instancePath: instancePath + "/endTime",
                                              schemaPath: "#/properties/endTime/anyOf/0/format",
                                              keyword: "format",
                                              params: {
                                                format: "date-time"
                                              },
                                              message: 'must match format "date-time"'
                                            };
                                            if (vErrors === null) {
                                              vErrors = [err5];
                                            } else {
                                              vErrors.push(err5);
                                            }
                                            errors++;
                                          }
                                        }
                                      }
                                    }
                                    var _valid1 = _errs35 === errors;
                                    valid3 = valid3 || _valid1;
                                    if (!valid3) {
                                      const _errs37 = errors;
                                      if (data14 !== null) {
                                        const err6 = {
                                          instancePath: instancePath + "/endTime",
                                          schemaPath: "#/properties/endTime/anyOf/1/type",
                                          keyword: "type",
                                          params: {
                                            type: "null"
                                          },
                                          message: "must be null"
                                        };
                                        if (vErrors === null) {
                                          vErrors = [err6];
                                        } else {
                                          vErrors.push(err6);
                                        }
                                        errors++;
                                      }
                                      var _valid1 = _errs37 === errors;
                                      valid3 = valid3 || _valid1;
                                    }
                                    if (!valid3) {
                                      const err7 = {
                                        instancePath: instancePath + "/endTime",
                                        schemaPath: "#/properties/endTime/anyOf",
                                        keyword: "anyOf",
                                        params: {},
                                        message: "must match a schema in anyOf"
                                      };
                                      if (vErrors === null) {
                                        vErrors = [err7];
                                      } else {
                                        vErrors.push(err7);
                                      }
                                      errors++;
                                      validate201.errors = vErrors;
                                      return false;
                                    } else {
                                      errors = _errs34;
                                      if (vErrors !== null) {
                                        if (_errs34) {
                                          vErrors.length = _errs34;
                                        } else {
                                          vErrors = null;
                                        }
                                      }
                                    }
                                    var valid0 = _errs33 === errors;
                                  } else {
                                    var valid0 = true;
                                  }
                                  if (valid0) {
                                    if (data.uploadTime !== void 0) {
                                      let data15 = data.uploadTime;
                                      const _errs39 = errors;
                                      if (!(data15 && typeof data15 == "object" && !Array.isArray(data15))) {
                                        validate201.errors = [{
                                          instancePath: instancePath + "/uploadTime",
                                          schemaPath: "#/properties/uploadTime/type",
                                          keyword: "type",
                                          params: {
                                            type: "object"
                                          },
                                          message: "must be object"
                                        }];
                                        return false;
                                      }
                                      if (errors === _errs39) {
                                        if (errors === _errs39) {
                                          if (typeof data15 === "string") {
                                            if (!formats0(data15)) {
                                              validate201.errors = [{
                                                instancePath: instancePath + "/uploadTime",
                                                schemaPath: "#/properties/uploadTime/format",
                                                keyword: "format",
                                                params: {
                                                  format: "date-time"
                                                },
                                                message: 'must match format "date-time"'
                                              }];
                                              return false;
                                            }
                                          }
                                        }
                                      }
                                      var valid0 = _errs39 === errors;
                                    } else {
                                      var valid0 = true;
                                    }
                                    if (valid0) {
                                      if (data.duration !== void 0) {
                                        let data16 = data.duration;
                                        const _errs41 = errors;
                                        if (!(typeof data16 == "number" && isFinite(data16)) && data16 !== null) {
                                          validate201.errors = [{
                                            instancePath: instancePath + "/duration",
                                            schemaPath: "#/properties/duration/type",
                                            keyword: "type",
                                            params: {
                                              type: schema220.properties.duration.type
                                            },
                                            message: "must be number,null"
                                          }];
                                          return false;
                                        }
                                        var valid0 = _errs41 === errors;
                                      } else {
                                        var valid0 = true;
                                      }
                                      if (valid0) {
                                        if (data.posterImage !== void 0) {
                                          const _errs43 = errors;
                                          if (typeof data.posterImage !== "string") {
                                            validate201.errors = [{
                                              instancePath: instancePath + "/posterImage",
                                              schemaPath: "#/properties/posterImage/type",
                                              keyword: "type",
                                              params: {
                                                type: "string"
                                              },
                                              message: "must be string"
                                            }];
                                            return false;
                                          }
                                          var valid0 = _errs43 === errors;
                                        } else {
                                          var valid0 = true;
                                        }
                                        if (valid0) {
                                          if (data.videoLocation !== void 0) {
                                            const _errs45 = errors;
                                            if (typeof data.videoLocation !== "string") {
                                              validate201.errors = [{
                                                instancePath: instancePath + "/videoLocation",
                                                schemaPath: "#/properties/videoLocation/type",
                                                keyword: "type",
                                                params: {
                                                  type: "string"
                                                },
                                                message: "must be string"
                                              }];
                                              return false;
                                            }
                                            var valid0 = _errs45 === errors;
                                          } else {
                                            var valid0 = true;
                                          }
                                          if (valid0) {
                                            if (data.views !== void 0) {
                                              let data19 = data.views;
                                              const _errs47 = errors;
                                              if (!(typeof data19 == "number" && isFinite(data19))) {
                                                validate201.errors = [{
                                                  instancePath: instancePath + "/views",
                                                  schemaPath: "#/properties/views/type",
                                                  keyword: "type",
                                                  params: {
                                                    type: "number"
                                                  },
                                                  message: "must be number"
                                                }];
                                                return false;
                                              }
                                              var valid0 = _errs47 === errors;
                                            } else {
                                              var valid0 = true;
                                            }
                                            if (valid0) {
                                              if (data.popularity !== void 0) {
                                                let data20 = data.popularity;
                                                const _errs49 = errors;
                                                if (!(typeof data20 == "number" && isFinite(data20))) {
                                                  validate201.errors = [{
                                                    instancePath: instancePath + "/popularity",
                                                    schemaPath: "#/properties/popularity/type",
                                                    keyword: "type",
                                                    params: {
                                                      type: "number"
                                                    },
                                                    message: "must be number"
                                                  }];
                                                  return false;
                                                }
                                                var valid0 = _errs49 === errors;
                                              } else {
                                                var valid0 = true;
                                              }
                                              if (valid0) {
                                                if (data.organizationId !== void 0) {
                                                  let data21 = data.organizationId;
                                                  const _errs51 = errors;
                                                  if (typeof data21 !== "string" && data21 !== null) {
                                                    validate201.errors = [{
                                                      instancePath: instancePath + "/organizationId",
                                                      schemaPath: "#/properties/organizationId/type",
                                                      keyword: "type",
                                                      params: {
                                                        type: schema220.properties.organizationId.type
                                                      },
                                                      message: "must be string,null"
                                                    }];
                                                    return false;
                                                  }
                                                  var valid0 = _errs51 === errors;
                                                } else {
                                                  var valid0 = true;
                                                }
                                                if (valid0) {
                                                  if (data.channelId !== void 0) {
                                                    const _errs53 = errors;
                                                    if (typeof data.channelId !== "string") {
                                                      validate201.errors = [{
                                                        instancePath: instancePath + "/channelId",
                                                        schemaPath: "#/properties/channelId/type",
                                                        keyword: "type",
                                                        params: {
                                                          type: "string"
                                                        },
                                                        message: "must be string"
                                                      }];
                                                      return false;
                                                    }
                                                    var valid0 = _errs53 === errors;
                                                  } else {
                                                    var valid0 = true;
                                                  }
                                                  if (valid0) {
                                                    if (data.published !== void 0) {
                                                      const _errs55 = errors;
                                                      if (typeof data.published !== "boolean") {
                                                        validate201.errors = [{
                                                          instancePath: instancePath + "/published",
                                                          schemaPath: "#/properties/published/type",
                                                          keyword: "type",
                                                          params: {
                                                            type: "boolean"
                                                          },
                                                          message: "must be boolean"
                                                        }];
                                                        return false;
                                                      }
                                                      var valid0 = _errs55 === errors;
                                                    } else {
                                                      var valid0 = true;
                                                    }
                                                    if (valid0) {
                                                      if (data.restrictedTo !== void 0) {
                                                        let data24 = data.restrictedTo;
                                                        const _errs57 = errors;
                                                        if (errors === _errs57) {
                                                          if (Array.isArray(data24)) {
                                                            var valid4 = true;
                                                            const len1 = data24.length;
                                                            for (let i1 = 0; i1 < len1; i1++) {
                                                              const _errs59 = errors;
                                                              if (typeof data24[i1] !== "string") {
                                                                validate201.errors = [{
                                                                  instancePath: instancePath + "/restrictedTo/" + i1,
                                                                  schemaPath: "#/properties/restrictedTo/items/type",
                                                                  keyword: "type",
                                                                  params: {
                                                                    type: "string"
                                                                  },
                                                                  message: "must be string"
                                                                }];
                                                                return false;
                                                              }
                                                              var valid4 = _errs59 === errors;
                                                              if (!valid4) {
                                                                break;
                                                              }
                                                            }
                                                          } else {
                                                            validate201.errors = [{
                                                              instancePath: instancePath + "/restrictedTo",
                                                              schemaPath: "#/properties/restrictedTo/type",
                                                              keyword: "type",
                                                              params: {
                                                                type: "array"
                                                              },
                                                              message: "must be array"
                                                            }];
                                                            return false;
                                                          }
                                                        }
                                                        var valid0 = _errs57 === errors;
                                                      } else {
                                                        var valid0 = true;
                                                      }
                                                      if (valid0) {
                                                        if (data.externalIds !== void 0) {
                                                          let data26 = data.externalIds;
                                                          const _errs61 = errors;
                                                          if (errors === _errs61) {
                                                            if (Array.isArray(data26)) {
                                                              var valid5 = true;
                                                              const len2 = data26.length;
                                                              for (let i2 = 0; i2 < len2; i2++) {
                                                                const _errs63 = errors;
                                                                if (typeof data26[i2] !== "string") {
                                                                  validate201.errors = [{
                                                                    instancePath: instancePath + "/externalIds/" + i2,
                                                                    schemaPath: "#/properties/externalIds/items/type",
                                                                    keyword: "type",
                                                                    params: {
                                                                      type: "string"
                                                                    },
                                                                    message: "must be string"
                                                                  }];
                                                                  return false;
                                                                }
                                                                var valid5 = _errs63 === errors;
                                                                if (!valid5) {
                                                                  break;
                                                                }
                                                              }
                                                            } else {
                                                              validate201.errors = [{
                                                                instancePath: instancePath + "/externalIds",
                                                                schemaPath: "#/properties/externalIds/type",
                                                                keyword: "type",
                                                                params: {
                                                                  type: "array"
                                                                },
                                                                message: "must be array"
                                                              }];
                                                              return false;
                                                            }
                                                          }
                                                          var valid0 = _errs61 === errors;
                                                        } else {
                                                          var valid0 = true;
                                                        }
                                                      }
                                                    }
                                                  }
                                                }
                                              }
                                            }
                                          }
                                        }
                                      }
                                    }
                                  }
                                }
                              }
                            }
                          }
                        }
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
    } else {
      validate201.errors = [{
        instancePath,
        schemaPath: "#/type",
        keyword: "type",
        params: {
          type: "object"
        },
        message: "must be object"
      }];
      return false;
    }
  }
  validate201.errors = vErrors;
  return errors === 0;
}
const VideoAccessLogEntry = validate202;
const schema221 = {
  "$id": "VideoAccessLogEntry",
  "$schema": "http://json-schema.org/draft-07/schema#",
  "type": "object",
  "properties": {
    "accessType": {
      "$ref": "GetAccessGrantType"
    },
    "userId": {
      "type": "string"
    },
    "videoId": {
      "type": "string"
    },
    "eventId": {
      "type": ["string", "null"]
    },
    "channelId": {
      "type": "string"
    },
    "location": {
      "anyOf": [{
        "$ref": "UserLocation"
      }, {
        "type": "null"
      }]
    },
    "ticketId": {
      "type": ["string", "null"]
    },
    "subscriptionId": {
      "type": ["string", "null"]
    },
    "timestamp": {
      "type": "object",
      "format": "date-time"
    },
    "videoUrl": {
      "type": "string"
    }
  },
  "required": ["accessType", "userId", "videoId", "eventId", "channelId", "location", "ticketId", "subscriptionId", "timestamp", "videoUrl"]
};
function validate202(data, {
  instancePath = "",
  parentData,
  parentDataProperty,
  rootData = data
} = {}) {
  let vErrors = null;
  let errors = 0;
  if (errors === 0) {
    if (data && typeof data == "object" && !Array.isArray(data)) {
      let missing0;
      if (data.accessType === void 0 && (missing0 = "accessType") || data.userId === void 0 && (missing0 = "userId") || data.videoId === void 0 && (missing0 = "videoId") || data.eventId === void 0 && (missing0 = "eventId") || data.channelId === void 0 && (missing0 = "channelId") || data.location === void 0 && (missing0 = "location") || data.ticketId === void 0 && (missing0 = "ticketId") || data.subscriptionId === void 0 && (missing0 = "subscriptionId") || data.timestamp === void 0 && (missing0 = "timestamp") || data.videoUrl === void 0 && (missing0 = "videoUrl")) {
        validate202.errors = [{
          instancePath,
          schemaPath: "#/required",
          keyword: "required",
          params: {
            missingProperty: missing0
          },
          message: "must have required property '" + missing0 + "'"
        }];
        return false;
      } else {
        if (data.accessType !== void 0) {
          const _errs1 = errors;
          if (!validate156(data.accessType, {
            instancePath: instancePath + "/accessType",
            parentData: data,
            parentDataProperty: "accessType",
            rootData
          })) {
            vErrors = vErrors === null ? validate156.errors : vErrors.concat(validate156.errors);
            errors = vErrors.length;
          }
          var valid0 = _errs1 === errors;
        } else {
          var valid0 = true;
        }
        if (valid0) {
          if (data.userId !== void 0) {
            const _errs2 = errors;
            if (typeof data.userId !== "string") {
              validate202.errors = [{
                instancePath: instancePath + "/userId",
                schemaPath: "#/properties/userId/type",
                keyword: "type",
                params: {
                  type: "string"
                },
                message: "must be string"
              }];
              return false;
            }
            var valid0 = _errs2 === errors;
          } else {
            var valid0 = true;
          }
          if (valid0) {
            if (data.videoId !== void 0) {
              const _errs4 = errors;
              if (typeof data.videoId !== "string") {
                validate202.errors = [{
                  instancePath: instancePath + "/videoId",
                  schemaPath: "#/properties/videoId/type",
                  keyword: "type",
                  params: {
                    type: "string"
                  },
                  message: "must be string"
                }];
                return false;
              }
              var valid0 = _errs4 === errors;
            } else {
              var valid0 = true;
            }
            if (valid0) {
              if (data.eventId !== void 0) {
                let data3 = data.eventId;
                const _errs6 = errors;
                if (typeof data3 !== "string" && data3 !== null) {
                  validate202.errors = [{
                    instancePath: instancePath + "/eventId",
                    schemaPath: "#/properties/eventId/type",
                    keyword: "type",
                    params: {
                      type: schema221.properties.eventId.type
                    },
                    message: "must be string,null"
                  }];
                  return false;
                }
                var valid0 = _errs6 === errors;
              } else {
                var valid0 = true;
              }
              if (valid0) {
                if (data.channelId !== void 0) {
                  const _errs8 = errors;
                  if (typeof data.channelId !== "string") {
                    validate202.errors = [{
                      instancePath: instancePath + "/channelId",
                      schemaPath: "#/properties/channelId/type",
                      keyword: "type",
                      params: {
                        type: "string"
                      },
                      message: "must be string"
                    }];
                    return false;
                  }
                  var valid0 = _errs8 === errors;
                } else {
                  var valid0 = true;
                }
                if (valid0) {
                  if (data.location !== void 0) {
                    let data5 = data.location;
                    const _errs10 = errors;
                    const _errs11 = errors;
                    let valid1 = false;
                    const _errs12 = errors;
                    const _errs13 = errors;
                    if (errors === _errs13) {
                      if (data5 && typeof data5 == "object" && !Array.isArray(data5)) {
                        let missing1;
                        if (data5.IP === void 0 && (missing1 = "IP") || data5.latlng === void 0 && (missing1 = "latlng") || data5.city === void 0 && (missing1 = "city") || data5.country === void 0 && (missing1 = "country") || data5.region === void 0 && (missing1 = "region")) {
                          const err0 = {
                            instancePath: instancePath + "/location",
                            schemaPath: "UserLocation/required",
                            keyword: "required",
                            params: {
                              missingProperty: missing1
                            },
                            message: "must have required property '" + missing1 + "'"
                          };
                          if (vErrors === null) {
                            vErrors = [err0];
                          } else {
                            vErrors.push(err0);
                          }
                          errors++;
                        } else {
                          if (data5.IP !== void 0) {
                            let data6 = data5.IP;
                            const _errs15 = errors;
                            if (typeof data6 !== "string" && data6 !== null) {
                              const err1 = {
                                instancePath: instancePath + "/location/IP",
                                schemaPath: "UserLocation/properties/IP/type",
                                keyword: "type",
                                params: {
                                  type: schema47.properties.IP.type
                                },
                                message: "must be string,null"
                              };
                              if (vErrors === null) {
                                vErrors = [err1];
                              } else {
                                vErrors.push(err1);
                              }
                              errors++;
                            }
                            var valid3 = _errs15 === errors;
                          } else {
                            var valid3 = true;
                          }
                          if (valid3) {
                            if (data5.latlng !== void 0) {
                              let data7 = data5.latlng;
                              const _errs17 = errors;
                              if (typeof data7 !== "string" && data7 !== null) {
                                const err2 = {
                                  instancePath: instancePath + "/location/latlng",
                                  schemaPath: "UserLocation/properties/latlng/type",
                                  keyword: "type",
                                  params: {
                                    type: schema47.properties.latlng.type
                                  },
                                  message: "must be string,null"
                                };
                                if (vErrors === null) {
                                  vErrors = [err2];
                                } else {
                                  vErrors.push(err2);
                                }
                                errors++;
                              }
                              var valid3 = _errs17 === errors;
                            } else {
                              var valid3 = true;
                            }
                            if (valid3) {
                              if (data5.city !== void 0) {
                                let data8 = data5.city;
                                const _errs19 = errors;
                                if (typeof data8 !== "string" && data8 !== null) {
                                  const err3 = {
                                    instancePath: instancePath + "/location/city",
                                    schemaPath: "UserLocation/properties/city/type",
                                    keyword: "type",
                                    params: {
                                      type: schema47.properties.city.type
                                    },
                                    message: "must be string,null"
                                  };
                                  if (vErrors === null) {
                                    vErrors = [err3];
                                  } else {
                                    vErrors.push(err3);
                                  }
                                  errors++;
                                }
                                var valid3 = _errs19 === errors;
                              } else {
                                var valid3 = true;
                              }
                              if (valid3) {
                                if (data5.country !== void 0) {
                                  let data9 = data5.country;
                                  const _errs21 = errors;
                                  if (typeof data9 !== "string" && data9 !== null) {
                                    const err4 = {
                                      instancePath: instancePath + "/location/country",
                                      schemaPath: "UserLocation/properties/country/type",
                                      keyword: "type",
                                      params: {
                                        type: schema47.properties.country.type
                                      },
                                      message: "must be string,null"
                                    };
                                    if (vErrors === null) {
                                      vErrors = [err4];
                                    } else {
                                      vErrors.push(err4);
                                    }
                                    errors++;
                                  }
                                  var valid3 = _errs21 === errors;
                                } else {
                                  var valid3 = true;
                                }
                                if (valid3) {
                                  if (data5.region !== void 0) {
                                    let data10 = data5.region;
                                    const _errs23 = errors;
                                    if (typeof data10 !== "string" && data10 !== null) {
                                      const err5 = {
                                        instancePath: instancePath + "/location/region",
                                        schemaPath: "UserLocation/properties/region/type",
                                        keyword: "type",
                                        params: {
                                          type: schema47.properties.region.type
                                        },
                                        message: "must be string,null"
                                      };
                                      if (vErrors === null) {
                                        vErrors = [err5];
                                      } else {
                                        vErrors.push(err5);
                                      }
                                      errors++;
                                    }
                                    var valid3 = _errs23 === errors;
                                  } else {
                                    var valid3 = true;
                                  }
                                }
                              }
                            }
                          }
                        }
                      } else {
                        const err6 = {
                          instancePath: instancePath + "/location",
                          schemaPath: "UserLocation/type",
                          keyword: "type",
                          params: {
                            type: "object"
                          },
                          message: "must be object"
                        };
                        if (vErrors === null) {
                          vErrors = [err6];
                        } else {
                          vErrors.push(err6);
                        }
                        errors++;
                      }
                    }
                    var _valid0 = _errs12 === errors;
                    valid1 = valid1 || _valid0;
                    if (!valid1) {
                      const _errs25 = errors;
                      if (data5 !== null) {
                        const err7 = {
                          instancePath: instancePath + "/location",
                          schemaPath: "#/properties/location/anyOf/1/type",
                          keyword: "type",
                          params: {
                            type: "null"
                          },
                          message: "must be null"
                        };
                        if (vErrors === null) {
                          vErrors = [err7];
                        } else {
                          vErrors.push(err7);
                        }
                        errors++;
                      }
                      var _valid0 = _errs25 === errors;
                      valid1 = valid1 || _valid0;
                    }
                    if (!valid1) {
                      const err8 = {
                        instancePath: instancePath + "/location",
                        schemaPath: "#/properties/location/anyOf",
                        keyword: "anyOf",
                        params: {},
                        message: "must match a schema in anyOf"
                      };
                      if (vErrors === null) {
                        vErrors = [err8];
                      } else {
                        vErrors.push(err8);
                      }
                      errors++;
                      validate202.errors = vErrors;
                      return false;
                    } else {
                      errors = _errs11;
                      if (vErrors !== null) {
                        if (_errs11) {
                          vErrors.length = _errs11;
                        } else {
                          vErrors = null;
                        }
                      }
                    }
                    var valid0 = _errs10 === errors;
                  } else {
                    var valid0 = true;
                  }
                  if (valid0) {
                    if (data.ticketId !== void 0) {
                      let data11 = data.ticketId;
                      const _errs27 = errors;
                      if (typeof data11 !== "string" && data11 !== null) {
                        validate202.errors = [{
                          instancePath: instancePath + "/ticketId",
                          schemaPath: "#/properties/ticketId/type",
                          keyword: "type",
                          params: {
                            type: schema221.properties.ticketId.type
                          },
                          message: "must be string,null"
                        }];
                        return false;
                      }
                      var valid0 = _errs27 === errors;
                    } else {
                      var valid0 = true;
                    }
                    if (valid0) {
                      if (data.subscriptionId !== void 0) {
                        let data12 = data.subscriptionId;
                        const _errs29 = errors;
                        if (typeof data12 !== "string" && data12 !== null) {
                          validate202.errors = [{
                            instancePath: instancePath + "/subscriptionId",
                            schemaPath: "#/properties/subscriptionId/type",
                            keyword: "type",
                            params: {
                              type: schema221.properties.subscriptionId.type
                            },
                            message: "must be string,null"
                          }];
                          return false;
                        }
                        var valid0 = _errs29 === errors;
                      } else {
                        var valid0 = true;
                      }
                      if (valid0) {
                        if (data.timestamp !== void 0) {
                          let data13 = data.timestamp;
                          const _errs31 = errors;
                          if (!(data13 && typeof data13 == "object" && !Array.isArray(data13))) {
                            validate202.errors = [{
                              instancePath: instancePath + "/timestamp",
                              schemaPath: "#/properties/timestamp/type",
                              keyword: "type",
                              params: {
                                type: "object"
                              },
                              message: "must be object"
                            }];
                            return false;
                          }
                          if (errors === _errs31) {
                            if (errors === _errs31) {
                              if (typeof data13 === "string") {
                                if (!formats0(data13)) {
                                  validate202.errors = [{
                                    instancePath: instancePath + "/timestamp",
                                    schemaPath: "#/properties/timestamp/format",
                                    keyword: "format",
                                    params: {
                                      format: "date-time"
                                    },
                                    message: 'must match format "date-time"'
                                  }];
                                  return false;
                                }
                              }
                            }
                          }
                          var valid0 = _errs31 === errors;
                        } else {
                          var valid0 = true;
                        }
                        if (valid0) {
                          if (data.videoUrl !== void 0) {
                            const _errs33 = errors;
                            if (typeof data.videoUrl !== "string") {
                              validate202.errors = [{
                                instancePath: instancePath + "/videoUrl",
                                schemaPath: "#/properties/videoUrl/type",
                                keyword: "type",
                                params: {
                                  type: "string"
                                },
                                message: "must be string"
                              }];
                              return false;
                            }
                            var valid0 = _errs33 === errors;
                          } else {
                            var valid0 = true;
                          }
                        }
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
    } else {
      validate202.errors = [{
        instancePath,
        schemaPath: "#/type",
        keyword: "type",
        params: {
          type: "object"
        },
        message: "must be object"
      }];
      return false;
    }
  }
  validate202.errors = vErrors;
  return errors === 0;
}
export { ACCOUNT_LINKING_RESULT, ACCOUNT_RELINK_RESULT, ACCOUNT_UNLINKING_RESULT, AbstractListModule, AbstractPageModule, AcceptUserInviteRequest, AcceptUserInviteResponse, AdCarouselModule, AdSpaceModule, ApplyCouponErrorResponse, ApplyCouponRequest, ApplyCouponResponse, ApplyCouponSuccessfulResponse, AttributeKey, AttributeSource, BillingPeriodConfiguration, BillingPeriodicity, Branding, ButtonPromotionalBlock, BuySubscriptionErrorResponse, BuySubscriptionRequest, BuySubscriptionResponse, BuySubscriptionSuccessfulResponse, BuyTicketErrorResponse, BuyTicketRequest, BuyTicketResponse, BuyTicketSuccessfulResponse, CancelSubscriptionCommand, CardPromotionalBlock, Channel, ChannelNavigation, ChannelPublicSettings, ChannelSubscriptions, ChannelTerms, ClassicHeaderModule, CreateSetupIntentRequest, CreateSetupIntentResponse, CreateSubscriptionErrorResponse, CreateSubscriptionRequest, CreateSubscriptionResponse, CreateSubscriptionSuccessfulResponse, CustomAttributes, DynamicNamedTagListSource, DynamicVideoListSource, Event, EventListModule, EventListSource, Feedback, FilteredVideoListModule, FiltersAttributeDefinition, GetAccessDeniedResponse, GetAccessDeniedResponseReason, GetAccessGrantType, GetAccessGrantedResponse, GetAccessRequest, GetAccessResponse, HeaderModule, Invite, InviteErrors, LinkExternalAccountErrorResponse, LinkExternalAccountRequest, LinkExternalAccountResponse, LinkExternalAccountSuccessfulResponse, LinkExternalSAMLAccountRequest, LinkNavigationResource, LiveAndUpcomingListModule, ManageSubscriptionRequest, ManageSubscriptionResponse, NamedTag, NamedTagListSource, NamedTagType, NamedTagsListModule, OptionsListLink, Page, PageModule, PageModuleList, PageTab, PauseBehaviour, PauseSubscriptionCommand, Plan, PlanInstallments, PlanPrice, PlanScope, PriceBlock, PromoButtonAction, PromotionalBlock, RootNavigationResource, SAML_LINK_OPERATION, SAML_PROVIDERS, SaveFeedbackErrorResponse, SaveFeedbackRequest, SaveFeedbackResponse, SaveFeedbackSuccessfulResponse, SingleOptionLink, SoldTicket, Sport80ExternalInfo, Sport80PlanProvider, StaticNamedTagListSource, StaticSlideSource, StaticVideoListSource, StripeCouponMetadata, StripePaymentOptionsForUser, StripePaymentSystemOpaque, StripeSavedPaymentMethods, StripeSubscriptionMetadata, StripeTicketMetaData, Subscription, SubscriptionCancellation, SubscriptionStatus, TabbedPageModules, TagsListModule, Testimonial, Ticket, TicketPrice, TicketScope, UncancelSubscriptionCommand, UnpauseSubscriptionCommand, UpdateSubscriptionPaymentCommand, UpdateUserConsentRequest, UpdateUserConsentResponse, UserConsentEntry, UserConsentEntryResponse, UserConsentEntryTermsResponse, UserConsentRequest, UserConsentSettings, UserExternalIntegrationsData, UserGuidedOnboardingStatus, UserInfo, UserLocation, Video, VideoAccessLogEntry, VideoAttribute, VideoAttributeValue, VideoAttributesMapping, VideoListModule, VideoListModuleBase, VideoListSource, VideoModule, ViewerRetentionSettings };
